(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode("._unmatchedHeader_qcj19_1{opacity:.55}")),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { isRunningLocalPartnerApi as rI, getPartnerDevApiHeaders as iI, WidgetContextProvider as aI, makeExecuteQuery as oI, makeUseLazyQuery as sI, makeUseQuery as lI, makeUseMutation as cI, IntegrationModal as dI, useWidgetSettingsMutations as ur, useWidgetSettingsQuery as mr, useRenderConditions as pr, PartnerSettingsWrapper as fr, handleWidgetSubmit as hr, MisconfigurationBanner as yr, validateApiHostName as Vl, mapLabels as rr, PartnerHookFormSecretText as Er, WidgetSettingsFormFooter as gr, useTracking as Cn, useWidgetContext as hn, hasDownstreamApiForbiddenError as zl, hasDownstreamApiAuthorizationError as Ul, DisplayErrors as En, settingsToFormValues as Ml, useCopyWithDelay as Jt, defaultDateFormat as jt, displayAttributeValue as Mi, OAuthSettings as gi, useData as jy, isDownstreamApiNotFoundError as uI, isDownstreamApiAuthorizationError as vw, isDownstreamApiPermissionError as mI, capitalizeFirstCharacter as kw, humanizeKey as pI, hasDownstreamApiTooManyRequestsError as fI, hasDownstreamApiPermissionError as bw, PartnerHookFormBasicAuth as hI, hasDownstreamApiNotFoundError as wa, getCountryNameFromCountryCode as yI, parseBoolean as gI, parseString as vI } from "lib-integrations-partner-support";
export * from "lib-integrations-partner-support";
import qe, { useMemo as Xn, useContext as Bl, createContext as wy, useState as me, useEffect as Qe, useRef as $r, useCallback as _t, useReducer as kI, useLayoutEffect as bI, isValidElement as _w, Fragment as _I, createElement as xI } from "react";
import { FlexBox as b, Switch as Ao, FieldLabel as xw, FieldWrapper as We, InputText as dr, InputSelectionList as mi, FormGrid as nt, FormField as Z, Text as $, Spinner as fn, Icon as ve, Tooltip as Xe, List as Ye, Badge as Mn, Button as ct, IconButton as ir, Tag as Jn, NavigationButton as Lt, Select as Tr, CollapseCard as _r, Box as st, Modal as wt, ModalHead as Ct, ModalBody as Ft, ModalFoot as Et, Textarea as qh, TagsInput as ql, Image as Ca, Banner as Cy, FieldSwitch as Sw, SelectionList as mt, Divider as Hl, FieldText as Wr, FieldTextarea as SI, CopyToClipboardButton as NI, getSelectionListContext as jI, Avatar as Fy, Timestamp as wI, Attachment as CI, EmptyState as Lo, Table as at, Checkbox as sv, TextWithHighlight as Nw, ErrorBoundaryContext as jw } from "@dixa/lib-shared-habla";
import dt from "classnames";
import { ApolloLink as Iy, Observable as ww, ApolloClient as FI, InMemoryCache as II, createHttpLink as EI, ApolloProvider as $I, useApolloClient as TI, ApolloConsumer as OI, NetworkStatus as tr, isApolloError as Cw, gql as Wl, ApolloError as Fw } from "@apollo/client";
import RI from "cross-fetch";
import { config as Vo } from "lib-shared-backend-config";
import Gn from "moment";
import "moment-timezone";
import { __rest as DI, __assign as kc } from "tslib";
function Ey(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var cs = { exports: {} }, za = {};
var lv;
function PI() {
  if (lv) return za;
  lv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return za.Fragment = r, za.jsx = s, za.jsxs = s, za;
}
var Ua = {};
var cv;
function AI() {
  return cv || (cv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c, w));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Ua.Fragment = i, Ua.jsx = zn, Ua.jsxs = Wn;
  })()), Ua;
}
var dv;
function LI() {
  return dv || (dv = 1, process.env.NODE_ENV === "production" ? cs.exports = PI() : cs.exports = AI()), cs.exports;
}
var Qn = LI();
function Iw(e, n) {
  return function() {
    return e.apply(n, arguments);
  };
}
const { toString: VI } = Object.prototype, { getPrototypeOf: ka } = Object, { iterator: Ko, toStringTag: Ew } = Symbol, dl = (({ hasOwnProperty: e }) => (n, r) => e.call(n, r))(Object.prototype), zo = (e, n) => {
  let r = e;
  const i = [];
  for (; r != null && r !== Object.prototype; ) {
    if (i.indexOf(r) !== -1)
      return !1;
    if (i.push(r), dl(r, n))
      return !0;
    r = ka(r);
  }
  return !1;
}, zI = (e, n) => e != null && zo(e, n) ? e[n] : void 0, $y = /* @__PURE__ */ ((e) => (n) => {
  const r = VI.call(n);
  return e[r] || (e[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Or = (e) => (e = e.toLowerCase(), (n) => $y(n) === e), Kl = (e) => (n) => typeof n === e, { isArray: Bi } = Array, ba = Kl("undefined");
function Fa(e) {
  return e !== null && !ba(e) && e.constructor !== null && !ba(e.constructor) && er(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const $w = Or("ArrayBuffer");
function UI(e) {
  let n;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? n = ArrayBuffer.isView(e) : n = e && e.buffer && $w(e.buffer), n;
}
const MI = Kl("string"), er = Kl("function"), Tw = Kl("number"), Ia = (e) => e !== null && typeof e == "object", BI = (e) => e === !0 || e === !1, Gs = (e) => {
  if (!Ia(e))
    return !1;
  const n = ka(e);
  return (n === null || n === Object.prototype || ka(n) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !zo(e, Ew) && !zo(e, Ko);
}, qI = (e) => {
  if (!Ia(e) || Fa(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, HI = Or("Date"), WI = Or("File"), KI = (e) => !!(e && typeof e.uri < "u"), GI = (e) => e && typeof e.getParts < "u", YI = Or("Blob"), JI = Or("FileList"), QI = (e) => Ia(e) && er(e.pipe);
function XI() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const uv = XI(), mv = typeof uv.FormData < "u" ? uv.FormData : void 0, ZI = (e) => {
  if (!e) return !1;
  if (mv && e instanceof mv) return !0;
  const n = ka(e);
  if (!n || n === Object.prototype || !er(e.append)) return !1;
  const r = $y(e);
  return r === "formdata" || // detect form-data instance
  r === "object" && er(e.toString) && e.toString() === "[object FormData]";
}, eE = Or("URLSearchParams"), [nE, tE, rE, iE] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(Or), aE = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Go(e, n, { allOwnKeys: r = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let i, a;
  if (typeof e != "object" && (e = [e]), Bi(e))
    for (i = 0, a = e.length; i < a; i++)
      n.call(null, e[i], i, e);
  else {
    if (Fa(e))
      return;
    const o = r ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let l;
    for (i = 0; i < s; i++)
      l = o[i], n.call(null, e[l], l, e);
  }
}
function Ow(e, n) {
  if (Fa(e))
    return null;
  n = n.toLowerCase();
  const r = Object.keys(e);
  let i = r.length, a;
  for (; i-- > 0; )
    if (a = r[i], n === a.toLowerCase())
      return a;
  return null;
}
const Ri = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Rw = (e) => !ba(e) && e !== Ri;
function Hh(...e) {
  const { caseless: n, skipUndefined: r } = Rw(this) && this || {}, i = {}, a = (o, s) => {
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    const l = n && typeof s == "string" && Ow(i, s) || s, d = dl(i, l) ? i[l] : void 0;
    Gs(d) && Gs(o) ? i[l] = Hh(d, o) : Gs(o) ? i[l] = Hh({}, o) : Bi(o) ? i[l] = o.slice() : (!r || !ba(o)) && (i[l] = o);
  };
  for (let o = 0, s = e.length; o < s; o++) {
    const l = e[o];
    if (!l || Fa(l) || (Go(l, a), typeof l != "object" || Bi(l)))
      continue;
    const d = Object.getOwnPropertySymbols(l);
    for (let m = 0; m < d.length; m++) {
      const u = d[m];
      gE.call(l, u) && a(l[u], u);
    }
  }
  return i;
}
const oE = (e, n, r, { allOwnKeys: i } = {}) => (Go(
  n,
  (a, o) => {
    r && er(a) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: Iw(a, r),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: a,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: i }
), e), sE = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), lE = (e, n, r, i) => {
  e.prototype = Object.create(n.prototype, i), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: n.prototype
  }), r && Object.assign(e.prototype, r);
}, cE = (e, n, r, i) => {
  let a, o, s;
  const l = {};
  if (n = n || {}, e == null) return n;
  do {
    for (a = Object.getOwnPropertyNames(e), o = a.length; o-- > 0; )
      s = a[o], (!i || i(s, e, n)) && !l[s] && (n[s] = e[s], l[s] = !0);
    e = r !== !1 && ka(e);
  } while (e && (!r || r(e, n)) && e !== Object.prototype);
  return n;
}, dE = (e, n, r) => {
  e = String(e), (r === void 0 || r > e.length) && (r = e.length), r -= n.length;
  const i = e.indexOf(n, r);
  return i !== -1 && i === r;
}, uE = (e) => {
  if (!e) return null;
  if (Bi(e)) return e;
  let n = e.length;
  if (!Tw(n)) return null;
  const r = new Array(n);
  for (; n-- > 0; )
    r[n] = e[n];
  return r;
}, mE = /* @__PURE__ */ ((e) => (n) => e && n instanceof e)(typeof Uint8Array < "u" && ka(Uint8Array)), pE = (e, n) => {
  const i = (e && e[Ko]).call(e);
  let a;
  for (; (a = i.next()) && !a.done; ) {
    const o = a.value;
    n.call(e, o[0], o[1]);
  }
}, fE = (e, n) => {
  let r;
  const i = [];
  for (; (r = e.exec(n)) !== null; )
    i.push(r);
  return i;
}, hE = Or("HTMLFormElement"), yE = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(r, i, a) {
  return i.toUpperCase() + a;
}), { propertyIsEnumerable: gE } = Object.prototype, vE = Or("RegExp"), Dw = (e, n) => {
  const r = Object.getOwnPropertyDescriptors(e), i = {};
  Go(r, (a, o) => {
    let s;
    (s = n(a, o, e)) !== !1 && (i[o] = s || a);
  }), Object.defineProperties(e, i);
}, kE = (e) => {
  Dw(e, (n, r) => {
    if (er(e) && ["arguments", "caller", "callee"].includes(r))
      return !1;
    const i = e[r];
    if (er(i)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, bE = (e, n) => {
  const r = {}, i = (a) => {
    a.forEach((o) => {
      r[o] = !0;
    });
  };
  return Bi(e) ? i(e) : i(String(e).split(n)), r;
}, _E = () => {
}, xE = (e, n) => e != null && Number.isFinite(e = +e) ? e : n;
function SE(e) {
  return !!(e && er(e.append) && e[Ew] === "FormData" && e[Ko]);
}
const NE = (e) => {
  const n = /* @__PURE__ */ new WeakSet(), r = (i) => {
    if (Ia(i)) {
      if (n.has(i))
        return;
      if (Fa(i))
        return i;
      if (!("toJSON" in i)) {
        n.add(i);
        const a = Bi(i) ? [] : {};
        return Go(i, (o, s) => {
          const l = r(o);
          !ba(l) && (a[s] = l);
        }), n.delete(i), a;
      }
    }
    return i;
  };
  return r(e);
}, jE = Or("AsyncFunction"), wE = (e) => e && (Ia(e) || er(e)) && er(e.then) && er(e.catch), Pw = ((e, n) => e ? setImmediate : n ? ((r, i) => (Ri.addEventListener(
  "message",
  ({ source: a, data: o }) => {
    a === Ri && o === r && i.length && i.shift()();
  },
  !1
), (a) => {
  i.push(a), Ri.postMessage(r, "*");
}))(`axios@${Math.random()}`, []) : (r) => setTimeout(r))(typeof setImmediate == "function", er(Ri.postMessage)), CE = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ri) : typeof process < "u" && process.nextTick || Pw, Aw = (e) => e != null && er(e[Ko]), FE = (e) => e != null && zo(e, Ko) && Aw(e), fe = {
  isArray: Bi,
  isArrayBuffer: $w,
  isBuffer: Fa,
  isFormData: ZI,
  isArrayBufferView: UI,
  isString: MI,
  isNumber: Tw,
  isBoolean: BI,
  isObject: Ia,
  isPlainObject: Gs,
  isEmptyObject: qI,
  isReadableStream: nE,
  isRequest: tE,
  isResponse: rE,
  isHeaders: iE,
  isUndefined: ba,
  isDate: HI,
  isFile: WI,
  isReactNativeBlob: KI,
  isReactNative: GI,
  isBlob: YI,
  isRegExp: vE,
  isFunction: er,
  isStream: QI,
  isURLSearchParams: eE,
  isTypedArray: mE,
  isFileList: JI,
  forEach: Go,
  merge: Hh,
  extend: oE,
  trim: aE,
  stripBOM: sE,
  inherits: lE,
  toFlatObject: cE,
  kindOf: $y,
  kindOfTest: Or,
  endsWith: dE,
  toArray: uE,
  forEachEntry: pE,
  matchAll: fE,
  isHTMLForm: hE,
  hasOwnProperty: dl,
  hasOwnProp: dl,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: zo,
  getSafeProp: zI,
  reduceDescriptors: Dw,
  freezeMethods: kE,
  toObjectSet: bE,
  toCamelCase: yE,
  noop: _E,
  toFiniteNumber: xE,
  findKey: Ow,
  global: Ri,
  isContextDefined: Rw,
  isSpecCompliantForm: SE,
  toJSONObject: NE,
  isAsyncFn: jE,
  isThenable: wE,
  setImmediate: Pw,
  asap: CE,
  isIterable: Aw,
  isSafeIterable: FE
}, IE = fe.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), EE = (e) => {
  const n = {};
  let r, i, a;
  return e && e.split(`
`).forEach(function(s) {
    a = s.indexOf(":"), r = s.substring(0, a).trim().toLowerCase(), i = s.substring(a + 1).trim(), !(!r || n[r] && IE[r]) && (r === "set-cookie" ? n[r] ? n[r].push(i) : n[r] = [i] : n[r] = n[r] ? n[r] + ", " + i : i);
  }), n;
};
function $E(e) {
  let n = 0, r = e.length;
  for (; n < r; ) {
    const i = e.charCodeAt(n);
    if (i !== 9 && i !== 32)
      break;
    n += 1;
  }
  for (; r > n; ) {
    const i = e.charCodeAt(r - 1);
    if (i !== 9 && i !== 32)
      break;
    r -= 1;
  }
  return n === 0 && r === e.length ? e : e.slice(n, r);
}
const TE = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), OE = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Ty(e, n) {
  return fe.isArray(e) ? e.map((r) => Ty(r, n)) : $E(String(e).replace(n, ""));
}
const RE = (e) => Ty(e, TE), DE = (e) => Ty(e, OE);
function Lw(e) {
  const n = /* @__PURE__ */ Object.create(null);
  return fe.forEach(e.toJSON(), (r, i) => {
    n[i] = DE(r);
  }), n;
}
const pv = /* @__PURE__ */ Symbol("internals");
function Ma(e) {
  return e && String(e).trim().toLowerCase();
}
function Ys(e) {
  return e === !1 || e == null ? e : fe.isArray(e) ? e.map(Ys) : RE(String(e));
}
function PE(e) {
  const n = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(e); )
    n[i[1]] = i[2];
  return n;
}
const AE = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function bc(e, n, r, i, a) {
  if (fe.isFunction(i))
    return i.call(this, n, r);
  if (a && (n = r), !!fe.isString(n)) {
    if (fe.isString(i))
      return n.indexOf(i) !== -1;
    if (fe.isRegExp(i))
      return i.test(n);
  }
}
function LE(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, r, i) => r.toUpperCase() + i);
}
function VE(e, n) {
  const r = fe.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(e, i + r, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(a, o, s) {
        return this[i].call(this, n, a, o, s);
      },
      configurable: !0
    });
  });
}
let Ut = class {
  constructor(n) {
    n && this.set(n);
  }
  set(n, r, i) {
    const a = this;
    function o(l, d, m) {
      const u = Ma(d);
      if (!u)
        return;
      const f = fe.findKey(a, u);
      (!f || a[f] === void 0 || m === !0 || m === void 0 && a[f] !== !1) && (a[f || d] = Ys(l));
    }
    const s = (l, d) => fe.forEach(l, (m, u) => o(m, u, d));
    if (fe.isPlainObject(n) || n instanceof this.constructor)
      s(n, r);
    else if (fe.isString(n) && (n = n.trim()) && !AE(n))
      s(EE(n), r);
    else if (fe.isObject(n) && fe.isSafeIterable(n)) {
      let l = /* @__PURE__ */ Object.create(null), d, m;
      for (const u of n) {
        if (!fe.isArray(u))
          throw new TypeError("Object iterator must return a key-value pair");
        m = u[0], fe.hasOwnProp(l, m) ? (d = l[m], l[m] = fe.isArray(d) ? [...d, u[1]] : [d, u[1]]) : l[m] = u[1];
      }
      s(l, r);
    } else
      n != null && o(r, n, i);
    return this;
  }
  get(n, r) {
    if (n = Ma(n), n) {
      const i = fe.findKey(this, n);
      if (i) {
        const a = this[i];
        if (!r)
          return a;
        if (r === !0)
          return PE(a);
        if (fe.isFunction(r))
          return r.call(this, a, i);
        if (fe.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, r) {
    if (n = Ma(n), n) {
      const i = fe.findKey(this, n);
      return !!(i && this[i] !== void 0 && (!r || bc(this, this[i], i, r)));
    }
    return !1;
  }
  delete(n, r) {
    const i = this;
    let a = !1;
    function o(s) {
      if (s = Ma(s), s) {
        const l = fe.findKey(i, s);
        l && (!r || bc(i, i[l], l, r)) && (delete i[l], a = !0);
      }
    }
    return fe.isArray(n) ? n.forEach(o) : o(n), a;
  }
  clear(n) {
    const r = Object.keys(this);
    let i = r.length, a = !1;
    for (; i--; ) {
      const o = r[i];
      (!n || bc(this, this[o], o, n, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(n) {
    const r = this, i = {};
    return fe.forEach(this, (a, o) => {
      const s = fe.findKey(i, o);
      if (s) {
        r[s] = Ys(a), delete r[o];
        return;
      }
      const l = n ? LE(o) : String(o).trim();
      l !== o && delete r[o], r[l] = Ys(a), i[l] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const r = /* @__PURE__ */ Object.create(null);
    return fe.forEach(this, (i, a) => {
      i != null && i !== !1 && (r[a] = n && fe.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, r]) => n + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...r) {
    const i = new this(n);
    return r.forEach((a) => i.set(a)), i;
  }
  static accessor(n) {
    const i = (this[pv] = this[pv] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(s) {
      const l = Ma(s);
      i[l] || (VE(a, s), i[l] = !0);
    }
    return fe.isArray(n) ? n.forEach(o) : o(n), this;
  }
};
Ut.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
fe.reduceDescriptors(Ut.prototype, ({ value: e }, n) => {
  let r = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => e,
    set(i) {
      this[r] = i;
    }
  };
});
fe.freezeMethods(Ut);
const zE = "[REDACTED ****]";
function UE(e) {
  if (fe.hasOwnProp(e, "toJSON"))
    return !0;
  let n = Object.getPrototypeOf(e);
  for (; n && n !== Object.prototype; ) {
    if (fe.hasOwnProp(n, "toJSON"))
      return !0;
    n = Object.getPrototypeOf(n);
  }
  return !1;
}
function ME(e, n) {
  const r = new Set(n.map((o) => String(o).toLowerCase())), i = [], a = (o) => {
    if (o === null || typeof o != "object" || fe.isBuffer(o)) return o;
    if (i.indexOf(o) !== -1) return;
    o instanceof Ut && (o = o.toJSON()), i.push(o);
    let s;
    if (fe.isArray(o))
      s = [], o.forEach((l, d) => {
        const m = a(l);
        fe.isUndefined(m) || (s[d] = m);
      });
    else {
      if (!fe.isPlainObject(o) && UE(o))
        return i.pop(), o;
      s = /* @__PURE__ */ Object.create(null);
      for (const [l, d] of Object.entries(o)) {
        const m = r.has(l.toLowerCase()) ? zE : a(d);
        fe.isUndefined(m) || (s[l] = m);
      }
    }
    return i.pop(), s;
  };
  return a(e);
}
let on = class Vw extends Error {
  static from(n, r, i, a, o, s) {
    const l = new Vw(n.message, r || n.code, i, a, o);
    return l.cause = n, l.name = n.name, n.status != null && l.status == null && (l.status = n.status), s && Object.assign(l, s), l;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(n, r, i, a, o) {
    super(n), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: n,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, r && (this.code = r), i && (this.config = i), a && (this.request = a), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const n = this.config, r = n && fe.hasOwnProp(n, "redact") ? n.redact : void 0, i = fe.isArray(r) && r.length > 0 ? ME(n, r) : fe.toJSONObject(n);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: i,
      code: this.code,
      status: this.status
    };
  }
};
on.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
on.ERR_BAD_OPTION = "ERR_BAD_OPTION";
on.ECONNABORTED = "ECONNABORTED";
on.ETIMEDOUT = "ETIMEDOUT";
on.ECONNREFUSED = "ECONNREFUSED";
on.ERR_NETWORK = "ERR_NETWORK";
on.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
on.ERR_DEPRECATED = "ERR_DEPRECATED";
on.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
on.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
on.ERR_CANCELED = "ERR_CANCELED";
on.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
on.ERR_INVALID_URL = "ERR_INVALID_URL";
on.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const BE = null, zw = 100;
function Wh(e) {
  return fe.isPlainObject(e) || fe.isArray(e);
}
function Uw(e) {
  return fe.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function _c(e, n, r) {
  return e ? e.concat(n).map(function(a, o) {
    return a = Uw(a), !r && o ? "[" + a + "]" : a;
  }).join(r ? "." : "") : n;
}
function qE(e) {
  return fe.isArray(e) && !e.some(Wh);
}
const HE = fe.toFlatObject(fe, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Gl(e, n, r) {
  if (!fe.isObject(e))
    throw new TypeError("target must be an object");
  n = n || new FormData(), r = fe.toFlatObject(
    r,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(g, D) {
      return !fe.isUndefined(D[g]);
    }
  );
  const i = r.metaTokens, a = r.visitor || C, o = r.dots, s = r.indexes, l = r.Blob || typeof Blob < "u" && Blob, d = r.maxDepth === void 0 ? zw : r.maxDepth, m = l && fe.isSpecCompliantForm(n), u = [];
  if (!fe.isFunction(a))
    throw new TypeError("visitor must be a function");
  function f(_) {
    if (_ === null) return "";
    if (fe.isDate(_))
      return _.toISOString();
    if (fe.isBoolean(_))
      return _.toString();
    if (!m && fe.isBlob(_))
      throw new on("Blob is not supported. Use a Buffer instead.");
    return fe.isArrayBuffer(_) || fe.isTypedArray(_) ? m && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function h(_) {
    if (_ > d)
      throw new on(
        "Object is too deeply nested (" + _ + " levels). Max depth: " + d,
        on.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function k(_, g) {
    if (d === 1 / 0)
      return JSON.stringify(_);
    const D = [];
    return JSON.stringify(_, function(I, F) {
      if (!fe.isObject(F))
        return F;
      for (; D.length && D[D.length - 1] !== this; )
        D.pop();
      return D.push(F), h(g + D.length - 1), F;
    });
  }
  function C(_, g, D) {
    let O = _;
    if (fe.isReactNative(n) && fe.isReactNativeBlob(_))
      return n.append(_c(D, g, o), f(_)), !1;
    if (_ && !D && typeof _ == "object") {
      if (fe.endsWith(g, "{}"))
        g = i ? g : g.slice(0, -2), _ = k(_, 1);
      else if (fe.isArray(_) && qE(_) || (fe.isFileList(_) || fe.endsWith(g, "[]")) && (O = fe.toArray(_)))
        return g = Uw(g), O.forEach(function(F, L) {
          !(fe.isUndefined(F) || F === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? _c([g], L, o) : s === null ? g : g + "[]",
            f(F)
          );
        }), !1;
    }
    return Wh(_) ? !0 : (n.append(_c(D, g, o), f(_)), !1);
  }
  const N = Object.assign(HE, {
    defaultVisitor: C,
    convertValue: f,
    isVisitable: Wh
  });
  function j(_, g, D = 0) {
    if (!fe.isUndefined(_)) {
      if (h(D), u.indexOf(_) !== -1)
        throw new Error("Circular reference detected in " + g.join("."));
      u.push(_), fe.forEach(_, function(I, F) {
        (!(fe.isUndefined(I) || I === null) && a.call(n, I, fe.isString(F) ? F.trim() : F, g, N)) === !0 && j(I, g ? g.concat(F) : [F], D + 1);
      }), u.pop();
    }
  }
  if (!fe.isObject(e))
    throw new TypeError("data must be an object");
  return j(e), n;
}
function fv(e) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(i) {
    return n[i];
  });
}
function Oy(e, n) {
  this._pairs = [], e && Gl(e, this, n);
}
const Mw = Oy.prototype;
Mw.append = function(n, r) {
  this._pairs.push([n, r]);
};
Mw.toString = function(n) {
  const r = n ? function(i) {
    return n.call(this, i, fv);
  } : fv;
  return this._pairs.map(function(a) {
    return r(a[0]) + "=" + r(a[1]);
  }, "").join("&");
};
function WE(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Bw(e, n, r) {
  if (!n)
    return e;
  const i = fe.isFunction(r) ? {
    serialize: r
  } : r, a = fe.getSafeProp(i, "encode") || WE, o = fe.getSafeProp(i, "serialize");
  let s;
  if (o ? s = o(n, i) : s = fe.isURLSearchParams(n) ? n.toString() : new Oy(n, i).toString(a), s) {
    const l = e.indexOf("#");
    l !== -1 && (e = e.slice(0, l)), e += (e.indexOf("?") === -1 ? "?" : "&") + s;
  }
  return e;
}
class hv {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, r, i) {
    return this.handlers.push({
      fulfilled: n,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    fe.forEach(this.handlers, function(i) {
      i !== null && n(i);
    });
  }
}
const Ry = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, KE = typeof URLSearchParams < "u" ? URLSearchParams : Oy, GE = typeof FormData < "u" ? FormData : null, YE = typeof Blob < "u" ? Blob : null, JE = {
  isBrowser: !0,
  classes: {
    URLSearchParams: KE,
    FormData: GE,
    Blob: YE
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Dy = typeof window < "u" && typeof document < "u", Kh = typeof navigator == "object" && navigator || void 0, QE = Dy && (!Kh || ["ReactNative", "NativeScript", "NS"].indexOf(Kh.product) < 0), XE = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ZE = Dy && window.location.href || "http://localhost", e$ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Dy,
  hasStandardBrowserEnv: QE,
  hasStandardBrowserWebWorkerEnv: XE,
  navigator: Kh,
  origin: ZE
}, Symbol.toStringTag, { value: "Module" })), Pt = {
  ...e$,
  ...JE
};
function n$(e, n) {
  return Gl(e, new Pt.classes.URLSearchParams(), {
    visitor: function(r, i, a, o) {
      return Pt.isNode && fe.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...n
  });
}
const yv = zw;
function qw(e) {
  if (e > yv)
    throw new on(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + yv,
      on.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function t$(e) {
  const n = [], r = /\w+|\[(\w*)]/g;
  let i;
  for (; (i = r.exec(e)) !== null; )
    qw(n.length), n.push(i[0] === "[]" ? "" : i[1] || i[0]);
  return n;
}
function r$(e) {
  const n = {}, r = Object.keys(e);
  let i;
  const a = r.length;
  let o;
  for (i = 0; i < a; i++)
    o = r[i], n[o] = e[o];
  return n;
}
function Hw(e) {
  function n(r, i, a, o) {
    qw(o);
    let s = r[o++];
    if (s === "__proto__") return !0;
    const l = Number.isFinite(+s), d = o >= r.length;
    return s = !s && fe.isArray(a) ? a.length : s, d ? (fe.hasOwnProp(a, s) ? a[s] = fe.isArray(a[s]) ? a[s].concat(i) : [a[s], i] : a[s] = i, !l) : ((!fe.hasOwnProp(a, s) || !fe.isObject(a[s])) && (a[s] = []), n(r, i, a[s], o) && fe.isArray(a[s]) && (a[s] = r$(a[s])), !l);
  }
  if (fe.isFormData(e) && fe.isFunction(e.entries)) {
    const r = {};
    return fe.forEachEntry(e, (i, a) => {
      n(t$(i), a, r, 0);
    }), r;
  }
  return null;
}
const Xi = (e, n) => e != null && fe.hasOwnProp(e, n) ? e[n] : void 0;
function i$(e, n, r) {
  if (fe.isString(e))
    try {
      return (n || JSON.parse)(e), fe.trim(e);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(e);
}
const Yo = {
  transitional: Ry,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(n, r) {
      const i = r.getContentType() || "", a = i.indexOf("application/json") > -1, o = fe.isObject(n);
      if (o && fe.isHTMLForm(n) && (n = new FormData(n)), fe.isFormData(n))
        return a ? JSON.stringify(Hw(n)) : n;
      if (fe.isArrayBuffer(n) || fe.isBuffer(n) || fe.isStream(n) || fe.isFile(n) || fe.isBlob(n) || fe.isReadableStream(n))
        return n;
      if (fe.isArrayBufferView(n))
        return n.buffer;
      if (fe.isURLSearchParams(n))
        return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
      let l;
      if (o) {
        const d = Xi(this, "formSerializer");
        if (i.indexOf("application/x-www-form-urlencoded") > -1)
          return n$(n, d).toString();
        if ((l = fe.isFileList(n)) || i.indexOf("multipart/form-data") > -1) {
          const m = Xi(this, "env"), u = m && m.FormData;
          return Gl(
            l ? { "files[]": n } : n,
            u && new u(),
            d
          );
        }
      }
      return o || a ? (r.setContentType("application/json", !1), i$(n)) : n;
    }
  ],
  transformResponse: [
    function(n) {
      const r = Xi(this, "transitional") || Yo.transitional, i = r && r.forcedJSONParsing, a = Xi(this, "responseType"), o = a === "json";
      if (fe.isResponse(n) || fe.isReadableStream(n))
        return n;
      if (n && fe.isString(n) && (i && !a || o)) {
        const l = !(r && r.silentJSONParsing) && o;
        try {
          return JSON.parse(n, Xi(this, "parseReviver"));
        } catch (d) {
          if (l)
            throw d.name === "SyntaxError" ? on.from(d, on.ERR_BAD_RESPONSE, this, null, Xi(this, "response")) : d;
        }
      }
      return n;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Pt.classes.FormData,
    Blob: Pt.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
fe.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  Yo.headers[e] = {};
});
function xc(e, n) {
  const r = this || Yo, i = n || r, a = Ut.from(i.headers);
  let o = i.data;
  return fe.forEach(e, function(l) {
    o = l.call(r, o, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), o;
}
function Ww(e) {
  return !!(e && e.__CANCEL__);
}
let Jo = class extends on {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(n, r, i) {
    super(n ?? "canceled", on.ERR_CANCELED, r, i), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function Kw(e, n, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? e(r) : n(new on(
    "Request failed with status code " + r.status,
    r.status >= 400 && r.status < 500 ? on.ERR_BAD_REQUEST : on.ERR_BAD_RESPONSE,
    r.config,
    r.request,
    r
  ));
}
function a$(e) {
  const n = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return n && n[1] || "";
}
function o$(e, n) {
  e = e || 10;
  const r = new Array(e), i = new Array(e);
  let a = 0, o = 0, s;
  return n = n !== void 0 ? n : 1e3, function(d) {
    const m = Date.now(), u = i[o];
    s || (s = m), r[a] = d, i[a] = m;
    let f = o, h = 0;
    for (; f !== a; )
      h += r[f++], f = f % e;
    if (a = (a + 1) % e, a === o && (o = (o + 1) % e), m - s < n)
      return;
    const k = u && m - u;
    return k ? Math.round(h * 1e3 / k) : void 0;
  };
}
function s$(e, n) {
  let r = 0, i = 1e3 / n, a, o;
  const s = (m, u = Date.now()) => {
    r = u, a = null, o && (clearTimeout(o), o = null), e(...m);
  };
  return [(...m) => {
    const u = Date.now(), f = u - r;
    f >= i ? s(m, u) : (a = m, o || (o = setTimeout(() => {
      o = null, s(a);
    }, i - f)));
  }, () => a && s(a)];
}
const ul = (e, n, r = 3) => {
  let i = 0;
  const a = o$(50, 250);
  return s$((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const s = o.loaded, l = o.lengthComputable ? o.total : void 0, d = l != null ? Math.min(s, l) : s, m = Math.max(0, d - i), u = a(m);
    i = Math.max(i, d);
    const f = {
      loaded: d,
      total: l,
      progress: l ? d / l : void 0,
      bytes: m,
      rate: u || void 0,
      estimated: u && l ? (l - d) / u : void 0,
      event: o,
      lengthComputable: l != null,
      [n ? "download" : "upload"]: !0
    };
    e(f);
  }, r);
}, gv = (e, n) => {
  const r = e != null;
  return [
    (i) => n[0]({
      lengthComputable: r,
      total: e,
      loaded: i
    }),
    n[1]
  ];
}, vv = (e) => (...n) => fe.asap(() => e(...n)), l$ = Pt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, n) => (r) => (r = new URL(r, Pt.origin), e.protocol === r.protocol && e.host === r.host && (n || e.port === r.port)))(
  new URL(Pt.origin),
  Pt.navigator && /(msie|trident)/i.test(Pt.navigator.userAgent)
) : () => !0, c$ = Pt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, n, r, i, a, o, s) {
      if (typeof document > "u") return;
      const l = [`${e}=${encodeURIComponent(n)}`];
      fe.isNumber(r) && l.push(`expires=${new Date(r).toUTCString()}`), fe.isString(i) && l.push(`path=${i}`), fe.isString(a) && l.push(`domain=${a}`), o === !0 && l.push("secure"), fe.isString(s) && l.push(`SameSite=${s}`), document.cookie = l.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const n = document.cookie.split(";");
      for (let r = 0; r < n.length; r++) {
        const i = n[r].replace(/^\s+/, ""), a = i.indexOf("=");
        if (a !== -1 && i.slice(0, a) === e)
          return decodeURIComponent(i.slice(a + 1));
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function d$(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function u$(e, n) {
  return n ? e.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : e;
}
const m$ = /^https?:(?!\/\/)/i, p$ = /[\t\n\r]/g;
function f$(e) {
  let n = 0;
  for (; n < e.length && e.charCodeAt(n) <= 32; )
    n++;
  return e.slice(n);
}
function h$(e) {
  return f$(e).replace(p$, "");
}
function kv(e, n) {
  if (typeof e == "string" && m$.test(h$(e)))
    throw new on(
      'Invalid URL: missing "//" after protocol',
      on.ERR_INVALID_URL,
      n
    );
}
function Gw(e, n, r, i) {
  kv(n, i);
  let a = !d$(n);
  return e && (a || r === !1) ? (kv(e, i), u$(e, n)) : n;
}
const bv = (e) => e instanceof Ut ? { ...e } : e;
function qi(e, n) {
  n = n || {};
  const r = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(r, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function i(u, f, h, k) {
    return fe.isPlainObject(u) && fe.isPlainObject(f) ? fe.merge.call({ caseless: k }, u, f) : fe.isPlainObject(f) ? fe.merge({}, f) : fe.isArray(f) ? f.slice() : f;
  }
  function a(u, f, h, k) {
    if (fe.isUndefined(f)) {
      if (!fe.isUndefined(u))
        return i(void 0, u, h, k);
    } else return i(u, f, h, k);
  }
  function o(u, f) {
    if (!fe.isUndefined(f))
      return i(void 0, f);
  }
  function s(u, f) {
    if (fe.isUndefined(f)) {
      if (!fe.isUndefined(u))
        return i(void 0, u);
    } else return i(void 0, f);
  }
  function l(u) {
    const f = fe.hasOwnProp(n, "transitional") ? n.transitional : void 0;
    if (!fe.isUndefined(f))
      if (fe.isPlainObject(f)) {
        if (fe.hasOwnProp(f, u))
          return f[u];
      } else
        return;
    const h = fe.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (fe.isPlainObject(h) && fe.hasOwnProp(h, u))
      return h[u];
  }
  function d(u, f, h) {
    if (fe.hasOwnProp(n, h))
      return i(u, f);
    if (fe.hasOwnProp(e, h))
      return i(void 0, u);
  }
  const m = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    withXSRFToken: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    allowedSocketPaths: s,
    responseEncoding: s,
    validateStatus: d,
    headers: (u, f, h) => a(bv(u), bv(f), h, !0)
  };
  return fe.forEach(Object.keys({ ...e, ...n }), function(f) {
    if (f === "__proto__" || f === "constructor" || f === "prototype") return;
    const h = fe.hasOwnProp(m, f) ? m[f] : a, k = fe.hasOwnProp(e, f) ? e[f] : void 0, C = fe.hasOwnProp(n, f) ? n[f] : void 0, N = h(k, C, f);
    fe.isUndefined(N) && h !== d || (r[f] = N);
  }), fe.hasOwnProp(n, "validateStatus") && fe.isUndefined(n.validateStatus) && l("validateStatusUndefinedResolves") === !1 && (fe.hasOwnProp(e, "validateStatus") ? r.validateStatus = i(void 0, e.validateStatus) : delete r.validateStatus), r;
}
const y$ = ["content-type", "content-length"];
function g$(e, n, r) {
  if (r !== "content-only") {
    e.set(n);
    return;
  }
  Object.entries(n).forEach(([i, a]) => {
    y$.includes(i.toLowerCase()) && e.set(i, a);
  });
}
const v$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
);
function Yw(e) {
  const n = qi({}, e), r = (h) => fe.hasOwnProp(n, h) ? n[h] : void 0, i = r("data");
  let a = r("withXSRFToken");
  const o = r("xsrfHeaderName"), s = r("xsrfCookieName");
  let l = r("headers");
  const d = r("auth"), m = r("baseURL"), u = r("allowAbsoluteUrls"), f = r("url");
  if (n.headers = l = Ut.from(l), n.url = Bw(
    Gw(m, f, u, n),
    r("params"),
    r("paramsSerializer")
  ), d) {
    const h = fe.getSafeProp(d, "username") || "", k = fe.getSafeProp(d, "password") || "";
    l.set(
      "Authorization",
      "Basic " + btoa(h + ":" + (k ? v$(k) : ""))
    );
  }
  if (fe.isFormData(i) && (Pt.hasStandardBrowserEnv || Pt.hasStandardBrowserWebWorkerEnv || fe.isReactNative(i) ? l.setContentType(void 0) : fe.isFunction(i.getHeaders) && g$(l, i.getHeaders(), r("formDataHeaderPolicy"))), Pt.hasStandardBrowserEnv && (fe.isFunction(a) && (a = a(n)), a === !0 || a == null && l$(n.url))) {
    const k = o && s && c$.read(s);
    k && l.set(o, k);
  }
  return n;
}
const k$ = typeof XMLHttpRequest < "u", b$ = k$ && function(e) {
  return new Promise(function(r, i) {
    const a = Yw(e);
    let o = a.data;
    const s = Ut.from(a.headers).normalize();
    let { responseType: l, onUploadProgress: d, onDownloadProgress: m } = a, u, f, h, k, C;
    function N() {
      k && k(), C && C(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let j = new XMLHttpRequest();
    j.open(a.method.toUpperCase(), a.url, !0), j.timeout = a.timeout;
    function _() {
      if (!j)
        return;
      const D = Ut.from(
        "getAllResponseHeaders" in j && j.getAllResponseHeaders()
      ), I = {
        data: !l || l === "text" || l === "json" ? j.responseText : j.response,
        status: j.status,
        statusText: j.statusText,
        headers: D,
        config: e,
        request: j
      };
      Kw(
        function(L) {
          r(L), N();
        },
        function(L) {
          i(L), N();
        },
        I
      ), j = null;
    }
    "onloadend" in j ? j.onloadend = _ : j.onreadystatechange = function() {
      !j || j.readyState !== 4 || j.status === 0 && !(j.responseURL && j.responseURL.startsWith("file:")) || setTimeout(_);
    }, j.onabort = function() {
      j && (i(new on("Request aborted", on.ECONNABORTED, e, j)), N(), j = null);
    }, j.onerror = function(O) {
      const I = O && O.message ? O.message : "Network Error", F = new on(I, on.ERR_NETWORK, e, j);
      F.event = O || null, i(F), N(), j = null;
    }, j.ontimeout = function() {
      let O = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const I = a.transitional || Ry;
      a.timeoutErrorMessage && (O = a.timeoutErrorMessage), i(
        new on(
          O,
          I.clarifyTimeoutError ? on.ETIMEDOUT : on.ECONNABORTED,
          e,
          j
        )
      ), N(), j = null;
    }, o === void 0 && s.setContentType(null), "setRequestHeader" in j && fe.forEach(Lw(s), function(O, I) {
      j.setRequestHeader(I, O);
    }), fe.isUndefined(a.withCredentials) || (j.withCredentials = !!a.withCredentials), l && l !== "json" && (j.responseType = a.responseType), m && ([h, C] = ul(m, !0), j.addEventListener("progress", h)), d && j.upload && ([f, k] = ul(d), j.upload.addEventListener("progress", f), j.upload.addEventListener("loadend", k)), (a.cancelToken || a.signal) && (u = (D) => {
      j && (i(!D || D.type ? new Jo(null, e, j) : D), j.abort(), N(), j = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const g = a$(a.url);
    if (g && !Pt.protocols.includes(g)) {
      i(
        new on(
          "Unsupported protocol " + g + ":",
          on.ERR_BAD_REQUEST,
          e
        )
      );
      return;
    }
    j.send(o || null);
  });
}, _$ = (e, n) => {
  if (e = e ? e.filter(Boolean) : [], !n && !e.length)
    return;
  const r = new AbortController();
  let i = !1;
  const a = function(d) {
    if (!i) {
      i = !0, s();
      const m = d instanceof Error ? d : this.reason;
      r.abort(
        m instanceof on ? m : new Jo(m instanceof Error ? m.message : m)
      );
    }
  };
  let o = n && setTimeout(() => {
    o = null, a(new on(`timeout of ${n}ms exceeded`, on.ETIMEDOUT));
  }, n);
  const s = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((d) => {
      d.unsubscribe ? d.unsubscribe(a) : d.removeEventListener("abort", a);
    }), e = null);
  };
  e.forEach((d) => d.addEventListener("abort", a));
  const { signal: l } = r;
  return l.unsubscribe = () => fe.asap(s), l;
}, x$ = function* (e, n) {
  let r = e.byteLength;
  if (r < n) {
    yield e;
    return;
  }
  let i = 0, a;
  for (; i < r; )
    a = i + n, yield e.slice(i, a), i = a;
}, S$ = async function* (e, n) {
  for await (const r of N$(e))
    yield* x$(r, n);
}, N$ = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const n = e.getReader();
  try {
    for (; ; ) {
      const { done: r, value: i } = await n.read();
      if (r)
        break;
      yield i;
    }
  } finally {
    await n.cancel();
  }
}, _v = (e, n, r, i) => {
  const a = S$(e, n);
  let o = 0, s, l = (d) => {
    s || (s = !0, i && i(d));
  };
  return new ReadableStream(
    {
      async pull(d) {
        try {
          const { done: m, value: u } = await a.next();
          if (m) {
            l(), d.close();
            return;
          }
          let f = u.byteLength;
          if (r) {
            let h = o += f;
            r(h);
          }
          d.enqueue(new Uint8Array(u));
        } catch (m) {
          throw l(m), m;
        }
      },
      cancel(d) {
        return l(d), a.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, ml = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, j$ = (e, n, r) => n + 2 < r && ml(e.charCodeAt(n + 1)) && ml(e.charCodeAt(n + 2));
function w$(e) {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const n = e.indexOf(",");
  if (n < 0) return 0;
  const r = e.slice(5, n), i = e.slice(n + 1);
  if (/;base64/i.test(r)) {
    let s = i.length;
    const l = i.length;
    for (let k = 0; k < l; k++)
      if (i.charCodeAt(k) === 37 && k + 2 < l) {
        const C = i.charCodeAt(k + 1), N = i.charCodeAt(k + 2);
        ml(C) && ml(N) && (s -= 2, k += 2);
      }
    let d = 0, m = l - 1;
    const u = (k) => k >= 2 && i.charCodeAt(k - 2) === 37 && // '%'
    i.charCodeAt(k - 1) === 51 && // '3'
    (i.charCodeAt(k) === 68 || i.charCodeAt(k) === 100);
    m >= 0 && (i.charCodeAt(m) === 61 ? (d++, m--) : u(m) && (d++, m -= 3)), d === 1 && m >= 0 && (i.charCodeAt(m) === 61 || u(m)) && d++;
    const h = Math.floor(s / 4) * 3 - (d || 0);
    return h > 0 ? h : 0;
  }
  let o = 0;
  for (let s = 0, l = i.length; s < l; s++) {
    const d = i.charCodeAt(s);
    if (d === 37 && j$(i, s, l))
      o += 1, s += 2;
    else if (d < 128)
      o += 1;
    else if (d < 2048)
      o += 2;
    else if (d >= 55296 && d <= 56319 && s + 1 < l) {
      const m = i.charCodeAt(s + 1);
      m >= 56320 && m <= 57343 ? (o += 4, s++) : o += 3;
    } else
      o += 3;
  }
  return o;
}
const Py = "1.18.0", xv = 64 * 1024, { isFunction: ds } = fe, C$ = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (n, r) => String.fromCharCode(parseInt(r, 16))
), Sv = (e) => {
  if (!fe.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, Nv = (e, ...n) => {
  try {
    return !!e(...n);
  } catch {
    return !1;
  }
}, F$ = (e) => {
  const n = e.indexOf("://");
  let r = e;
  return n !== -1 && (r = r.slice(n + 3)), r.includes("@") || r.includes(":");
}, I$ = (e) => {
  const n = fe.global !== void 0 && fe.global !== null ? fe.global : globalThis, { ReadableStream: r, TextEncoder: i } = n;
  e = fe.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: n.Request,
      Response: n.Response
    },
    e
  );
  const { fetch: a, Request: o, Response: s } = e, l = a ? ds(a) : typeof fetch == "function", d = ds(o), m = ds(s);
  if (!l)
    return !1;
  const u = l && ds(r), f = l && (typeof i == "function" ? /* @__PURE__ */ ((_) => (g) => _.encode(g))(new i()) : async (_) => new Uint8Array(await new o(_).arrayBuffer())), h = d && u && Nv(() => {
    let _ = !1;
    const g = new o(Pt.origin, {
      body: new r(),
      method: "POST",
      get duplex() {
        return _ = !0, "half";
      }
    }), D = g.headers.has("Content-Type");
    return g.body != null && g.body.cancel(), _ && !D;
  }), k = m && u && Nv(() => fe.isReadableStream(new s("").body)), C = {
    stream: k && ((_) => _.body)
  };
  l && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((_) => {
    !C[_] && (C[_] = (g, D) => {
      let O = g && g[_];
      if (O)
        return O.call(g);
      throw new on(
        `Response type '${_}' is not supported`,
        on.ERR_NOT_SUPPORT,
        D
      );
    });
  });
  const N = async (_) => {
    if (_ == null)
      return 0;
    if (fe.isBlob(_))
      return _.size;
    if (fe.isSpecCompliantForm(_))
      return (await new o(Pt.origin, {
        method: "POST",
        body: _
      }).arrayBuffer()).byteLength;
    if (fe.isArrayBufferView(_) || fe.isArrayBuffer(_))
      return _.byteLength;
    if (fe.isURLSearchParams(_) && (_ = _ + ""), fe.isString(_))
      return (await f(_)).byteLength;
  }, j = async (_, g) => {
    const D = fe.toFiniteNumber(_.getContentLength());
    return D ?? N(g);
  };
  return async (_) => {
    let {
      url: g,
      method: D,
      data: O,
      signal: I,
      cancelToken: F,
      timeout: L,
      onDownloadProgress: K,
      onUploadProgress: J,
      responseType: te,
      headers: W,
      withCredentials: Y = "same-origin",
      fetchOptions: P,
      maxContentLength: B,
      maxBodyLength: re
    } = Yw(_);
    const je = fe.isNumber(B) && B > -1, ue = fe.isNumber(re) && re > -1, se = (Ie) => fe.hasOwnProp(_, Ie) ? _[Ie] : void 0;
    let he = a || fetch;
    te = te ? (te + "").toLowerCase() : "text";
    let V = _$(
      [I, F && F.toAbortSignal()],
      L
    ), ke = null;
    const De = V && V.unsubscribe && (() => {
      V.unsubscribe();
    });
    let q, Ge = null;
    const sn = () => new on(
      "Request body larger than maxBodyLength limit",
      on.ERR_BAD_REQUEST,
      _,
      ke
    );
    try {
      let Ie;
      const Ue = se("auth");
      if (Ue) {
        const le = fe.getSafeProp(Ue, "username") || "", xe = fe.getSafeProp(Ue, "password") || "";
        Ie = {
          username: le,
          password: xe
        };
      }
      if (F$(g)) {
        const le = new URL(g, Pt.origin);
        if (!Ie && (le.username || le.password)) {
          const xe = Sv(le.username), Ve = Sv(le.password);
          Ie = {
            username: xe,
            password: Ve
          };
        }
        (le.username || le.password) && (le.username = "", le.password = "", g = le.href);
      }
      if (Ie && (W.delete("authorization"), W.set(
        "Authorization",
        "Basic " + btoa(C$((Ie.username || "") + ":" + (Ie.password || "")))
      )), je && typeof g == "string" && g.startsWith("data:") && w$(g) > B)
        throw new on(
          "maxContentLength size of " + B + " exceeded",
          on.ERR_BAD_RESPONSE,
          _,
          ke
        );
      if (ue && D !== "get" && D !== "head") {
        const le = await N(O);
        if (typeof le == "number" && isFinite(le) && (q = le, le > re))
          throw sn();
      }
      const Re = ue && (fe.isReadableStream(O) || fe.isStream(O)), Be = (le, xe, Ve) => _v(
        le,
        xv,
        (Pe) => {
          if (ue && Pe > re)
            throw Ge = sn();
          xe && xe(Pe);
        },
        Ve
      );
      if (h && D !== "get" && D !== "head" && (J || Re)) {
        if (q = q ?? await j(W, O), q !== 0 || Re) {
          let le = new o(g, {
            method: "POST",
            body: O,
            duplex: "half"
          }), xe;
          if (fe.isFormData(O) && (xe = le.headers.get("content-type")) && W.setContentType(xe), le.body) {
            const [Ve, Pe] = J && gv(
              q,
              ul(vv(J))
            ) || [];
            O = Be(le.body, Ve, Pe);
          }
        }
      } else if (Re && !d && u && D !== "get" && D !== "head")
        O = Be(O);
      else if (Re && d && !h && D !== "get" && D !== "head")
        throw new on(
          "Stream request bodies are not supported by the current fetch implementation",
          on.ERR_NOT_SUPPORT,
          _,
          ke
        );
      fe.isString(Y) || (Y = Y ? "include" : "omit");
      const Ae = d && "credentials" in o.prototype;
      if (fe.isFormData(O)) {
        const le = W.getContentType();
        le && /^multipart\/form-data/i.test(le) && !/boundary=/i.test(le) && W.delete("content-type");
      }
      W.set("User-Agent", "axios/" + Py, !1);
      const Je = {
        ...P,
        signal: V,
        method: D.toUpperCase(),
        headers: Lw(W.normalize()),
        body: O,
        duplex: "half",
        credentials: Ae ? Y : void 0
      };
      ke = d && new o(g, Je);
      let $e = await (d ? he(ke, P) : he(g, Je));
      const Me = Ut.from($e.headers);
      if (je) {
        const le = fe.toFiniteNumber(Me.getContentLength());
        if (le != null && le > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            ke
          );
      }
      const en = k && (te === "stream" || te === "response");
      if (k && $e.body && (K || je || en && De)) {
        const le = {};
        ["status", "statusText", "headers"].forEach((E) => {
          le[E] = $e[E];
        });
        const xe = fe.toFiniteNumber(Me.getContentLength()), [Ve, Pe] = K && gv(
          xe,
          ul(vv(K), !0)
        ) || [];
        let vn = 0;
        const Q = (E) => {
          if (je && (vn = E, vn > B))
            throw new on(
              "maxContentLength size of " + B + " exceeded",
              on.ERR_BAD_RESPONSE,
              _,
              ke
            );
          Ve && Ve(E);
        };
        $e = new s(
          _v($e.body, xv, Q, () => {
            Pe && Pe(), De && De();
          }),
          le
        );
      }
      te = te || "text";
      let oe = await C[fe.findKey(C, te) || "text"](
        $e,
        _
      );
      if (je && !k && !en) {
        let le;
        if (oe != null && (typeof oe.byteLength == "number" ? le = oe.byteLength : typeof oe.size == "number" ? le = oe.size : typeof oe == "string" && (le = typeof i == "function" ? new i().encode(oe).byteLength : oe.length)), typeof le == "number" && le > B)
          throw new on(
            "maxContentLength size of " + B + " exceeded",
            on.ERR_BAD_RESPONSE,
            _,
            ke
          );
      }
      return !en && De && De(), await new Promise((le, xe) => {
        Kw(le, xe, {
          data: oe,
          headers: Ut.from($e.headers),
          status: $e.status,
          statusText: $e.statusText,
          config: _,
          request: ke
        });
      });
    } catch (Ie) {
      if (De && De(), V && V.aborted && V.reason instanceof on) {
        const Ue = V.reason;
        throw Ue.config = _, ke && (Ue.request = ke), Ie !== Ue && (Ue.cause = Ie), Ue;
      }
      throw Ge ? (ke && !Ge.request && (Ge.request = ke), Ge) : Ie instanceof on ? (ke && !Ie.request && (Ie.request = ke), Ie) : Ie && Ie.name === "TypeError" && /Load failed|fetch/i.test(Ie.message) ? Object.assign(
        new on(
          "Network Error",
          on.ERR_NETWORK,
          _,
          ke,
          Ie && Ie.response
        ),
        {
          cause: Ie.cause || Ie
        }
      ) : on.from(Ie, Ie && Ie.code, _, ke, Ie && Ie.response);
    }
  };
}, E$ = /* @__PURE__ */ new Map(), Jw = (e) => {
  let n = e && e.env || {};
  const { fetch: r, Request: i, Response: a } = n, o = [i, a, r];
  let s = o.length, l = s, d, m, u = E$;
  for (; l--; )
    d = o[l], m = u.get(d), m === void 0 && u.set(d, m = l ? /* @__PURE__ */ new Map() : I$(n)), u = m;
  return m;
};
Jw();
const Ay = {
  http: BE,
  xhr: b$,
  fetch: {
    get: Jw
  }
};
fe.forEach(Ay, (e, n) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: n });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: n });
  }
});
const jv = (e) => `- ${e}`, $$ = (e) => fe.isFunction(e) || e === null || e === !1;
function T$(e, n) {
  e = fe.isArray(e) ? e : [e];
  const { length: r } = e;
  let i, a;
  const o = {};
  for (let s = 0; s < r; s++) {
    i = e[s];
    let l;
    if (a = i, !$$(i) && (a = Ay[(l = String(i)).toLowerCase()], a === void 0))
      throw new on(`Unknown adapter '${l}'`);
    if (a && (fe.isFunction(a) || (a = a.get(n))))
      break;
    o[l || "#" + s] = a;
  }
  if (!a) {
    const s = Object.entries(o).map(
      ([d, m]) => `adapter ${d} ` + (m === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let l = r ? s.length > 1 ? `since :
` + s.map(jv).join(`
`) : " " + jv(s[0]) : "as no adapter specified";
    throw new on(
      "There is no suitable adapter to dispatch the request " + l,
      "ERR_NOT_SUPPORT"
    );
  }
  return a;
}
const Qw = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: T$,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: Ay
};
function Sc(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Jo(null, e);
}
function wv(e) {
  return Sc(e), e.headers = Ut.from(e.headers), e.data = xc.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Qw.getAdapter(e.adapter || Yo.adapter, e)(e).then(
    function(i) {
      Sc(e), e.response = i;
      try {
        i.data = xc.call(e, e.transformResponse, i);
      } finally {
        delete e.response;
      }
      return i.headers = Ut.from(i.headers), i;
    },
    function(i) {
      if (!Ww(i) && (Sc(e), i && i.response)) {
        e.response = i.response;
        try {
          i.response.data = xc.call(
            e,
            e.transformResponse,
            i.response
          );
        } finally {
          delete e.response;
        }
        i.response.headers = Ut.from(i.response.headers);
      }
      return Promise.reject(i);
    }
  );
}
const Yl = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, n) => {
  Yl[e] = function(i) {
    return typeof i === e || "a" + (n < 1 ? "n " : " ") + e;
  };
});
const Cv = {};
Yl.transitional = function(n, r, i) {
  function a(o, s) {
    return "[Axios v" + Py + "] Transitional option '" + o + "'" + s + (i ? ". " + i : "");
  }
  return (o, s, l) => {
    if (n === !1)
      throw new on(
        a(s, " has been removed" + (r ? " in " + r : "")),
        on.ERR_DEPRECATED
      );
    return r && !Cv[s] && (Cv[s] = !0, console.warn(
      a(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), n ? n(o, s, l) : !0;
  };
};
Yl.spelling = function(n) {
  return (r, i) => (console.warn(`${i} is likely a misspelling of ${n}`), !0);
};
function O$(e, n, r) {
  if (typeof e != "object")
    throw new on("options must be an object", on.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(e);
  let a = i.length;
  for (; a-- > 0; ) {
    const o = i[a], s = Object.prototype.hasOwnProperty.call(n, o) ? n[o] : void 0;
    if (s) {
      const l = e[o], d = l === void 0 || s(l, o, e);
      if (d !== !0)
        throw new on(
          "option " + o + " must be " + d,
          on.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (r !== !0)
      throw new on("Unknown option " + o, on.ERR_BAD_OPTION);
  }
}
const Js = {
  assertOptions: O$,
  validators: Yl
}, zt = Js.validators;
let Ai = class {
  constructor(n) {
    this.defaults = n || {}, this.interceptors = {
      request: new hv(),
      response: new hv()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(n, r) {
    try {
      return await this._request(n, r);
    } catch (i) {
      if (i instanceof Error) {
        let a = {};
        Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
        const o = (() => {
          if (!a.stack)
            return "";
          const s = a.stack.indexOf(`
`);
          return s === -1 ? "" : a.stack.slice(s + 1);
        })();
        try {
          if (!i.stack)
            i.stack = o;
          else if (o) {
            const s = o.indexOf(`
`), l = s === -1 ? -1 : o.indexOf(`
`, s + 1), d = l === -1 ? "" : o.slice(l + 1);
            String(i.stack).endsWith(d) || (i.stack += `
` + o);
          }
        } catch {
        }
      }
      throw i;
    }
  }
  _request(n, r) {
    typeof n == "string" ? (r = r || {}, r.url = n) : r = n || {}, r = qi(this.defaults, r);
    const { transitional: i, paramsSerializer: a, headers: o } = r;
    i !== void 0 && Js.assertOptions(
      i,
      {
        silentJSONParsing: zt.transitional(zt.boolean),
        forcedJSONParsing: zt.transitional(zt.boolean),
        clarifyTimeoutError: zt.transitional(zt.boolean),
        legacyInterceptorReqResOrdering: zt.transitional(zt.boolean),
        advertiseZstdAcceptEncoding: zt.transitional(zt.boolean),
        validateStatusUndefinedResolves: zt.transitional(zt.boolean)
      },
      !1
    ), a != null && (fe.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : Js.assertOptions(
      a,
      {
        encode: zt.function,
        serialize: zt.function
      },
      !0
    )), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), Js.assertOptions(
      r,
      {
        baseUrl: zt.spelling("baseURL"),
        withXsrfToken: zt.spelling("withXSRFToken")
      },
      !0
    ), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let s = o && fe.merge(o.common, o[r.method]);
    o && fe.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (C) => {
      delete o[C];
    }), r.headers = Ut.concat(s, o);
    const l = [];
    let d = !0;
    this.interceptors.request.forEach(function(N) {
      if (typeof N.runWhen == "function" && N.runWhen(r) === !1)
        return;
      d = d && N.synchronous;
      const j = r.transitional || Ry;
      j && j.legacyInterceptorReqResOrdering ? l.unshift(N.fulfilled, N.rejected) : l.push(N.fulfilled, N.rejected);
    });
    const m = [];
    this.interceptors.response.forEach(function(N) {
      m.push(N.fulfilled, N.rejected);
    });
    let u, f = 0, h;
    if (!d) {
      const C = [wv.bind(this), void 0];
      for (C.unshift(...l), C.push(...m), h = C.length, u = Promise.resolve(r); f < h; )
        u = u.then(C[f++], C[f++]);
      return u;
    }
    h = l.length;
    let k = r;
    for (; f < h; ) {
      const C = l[f++], N = l[f++];
      try {
        k = C(k);
      } catch (j) {
        N.call(this, j);
        break;
      }
    }
    try {
      u = wv.call(this, k);
    } catch (C) {
      return Promise.reject(C);
    }
    for (f = 0, h = m.length; f < h; )
      u = u.then(m[f++], m[f++]);
    return u;
  }
  getUri(n) {
    n = qi(this.defaults, n);
    const r = Gw(n.baseURL, n.url, n.allowAbsoluteUrls, n);
    return Bw(r, n.params, n.paramsSerializer);
  }
};
fe.forEach(["delete", "get", "head", "options"], function(n) {
  Ai.prototype[n] = function(r, i) {
    return this.request(
      qi(i || {}, {
        method: n,
        url: r,
        data: i && fe.hasOwnProp(i, "data") ? i.data : void 0
      })
    );
  };
});
fe.forEach(["post", "put", "patch", "query"], function(n) {
  function r(i) {
    return function(o, s, l) {
      return this.request(
        qi(l || {}, {
          method: n,
          headers: i ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: s
        })
      );
    };
  }
  Ai.prototype[n] = r(), n !== "query" && (Ai.prototype[n + "Form"] = r(!0));
});
let R$ = class Xw {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(o) {
      r = o;
    });
    const i = this;
    this.promise.then((a) => {
      if (!i._listeners) return;
      let o = i._listeners.length;
      for (; o-- > 0; )
        i._listeners[o](a);
      i._listeners = null;
    }), this.promise.then = (a) => {
      let o;
      const s = new Promise((l) => {
        i.subscribe(l), o = l;
      }).then(a);
      return s.cancel = function() {
        i.unsubscribe(o);
      }, s;
    }, n(function(o, s, l) {
      i.reason || (i.reason = new Jo(o, s, l), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(n);
    r !== -1 && this._listeners.splice(r, 1);
  }
  toAbortSignal() {
    const n = new AbortController(), r = (i) => {
      n.abort(i);
    };
    return this.subscribe(r), n.signal.unsubscribe = () => this.unsubscribe(r), n.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new Xw(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
};
function D$(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function P$(e) {
  return fe.isObject(e) && e.isAxiosError === !0;
}
const Gh = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(Gh).forEach(([e, n]) => {
  Gh[n] = e;
});
function Zw(e) {
  const n = new Ai(e), r = Iw(Ai.prototype.request, n);
  return fe.extend(r, Ai.prototype, n, { allOwnKeys: !0 }), fe.extend(r, n, null, { allOwnKeys: !0 }), r.create = function(a) {
    return Zw(qi(e, a));
  }, r;
}
const vt = Zw(Yo);
vt.Axios = Ai;
vt.CanceledError = Jo;
vt.CancelToken = R$;
vt.isCancel = Ww;
vt.VERSION = Py;
vt.toFormData = Gl;
vt.AxiosError = on;
vt.Cancel = vt.CanceledError;
vt.all = function(n) {
  return Promise.all(n);
};
vt.spread = D$;
vt.isAxiosError = P$;
vt.mergeConfig = qi;
vt.AxiosHeaders = Ut;
vt.formToJSON = (e) => Hw(fe.isHTMLForm(e) ? new FormData(e) : e);
vt.getAdapter = Qw.getAdapter;
vt.HttpStatusCode = Gh;
vt.default = vt;
const {
  Axios: S8,
  AxiosError: N8,
  CanceledError: j8,
  isCancel: w8,
  CancelToken: C8,
  VERSION: F8,
  all: I8,
  Cancel: E8,
  isAxiosError: A$,
  spread: $8,
  toFormData: T8,
  AxiosHeaders: O8,
  HttpStatusCode: R8,
  formToJSON: D8,
  getAdapter: P8,
  mergeConfig: A8,
  create: L8
} = vt;
class L$ {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    return window.electron ? !!window.electron : !!process?.versions?.electron || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  async getVersion() {
    return window.electron ? (await window.electron.getVersion()).split("-")[0] : "0.0.0";
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  async isStandaloneBuild() {
    return window.electron?.isStandaloneBuild ? await window.electron.isStandaloneBuild() : null;
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  async isMsiBuild() {
    return window.electron?.isMsiBuild ? await window.electron.isMsiBuild() : null;
  }
}
const Fv = new L$();
function V$(e, n) {
  return Iv(e), Iv(n), e.localeCompare(n, void 0, {
    numeric: !0
  });
}
function Iv(e) {
  if (e.split(".").length !== 3)
    throw Error(`The version '${e}' must be in the format 'x.x.x'.`);
}
const z$ = Object.prototype.toString;
function U$(e, n) {
  return z$.call(e) === `[object ${n}]`;
}
function M$(e) {
  return U$(e, "Object");
}
function B$(e) {
  return !!(e && e.then && typeof e.then == "function");
}
const Fo = "8.36.0", ai = globalThis;
function Ly(e, n, r) {
  const i = r || ai, a = i.__SENTRY__ = i.__SENTRY__ || {}, o = a[Fo] = a[Fo] || {};
  return o[e] || (o[e] = n());
}
const eC = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, q$ = "Sentry Logger ", Ev = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], $v = {};
function nC(e) {
  if (!("console" in ai))
    return e();
  const n = ai.console, r = {}, i = Object.keys($v);
  i.forEach((a) => {
    const o = $v[a];
    r[a] = n[a], n[a] = o;
  });
  try {
    return e();
  } finally {
    i.forEach((a) => {
      n[a] = r[a];
    });
  }
}
function H$() {
  let e = !1;
  const n = {
    enable: () => {
      e = !0;
    },
    disable: () => {
      e = !1;
    },
    isEnabled: () => e
  };
  return eC ? Ev.forEach((r) => {
    n[r] = (...i) => {
      e && nC(() => {
        ai.console[r](`${q$}[${r}]:`, ...i);
      });
    };
  }) : Ev.forEach((r) => {
    n[r] = () => {
    };
  }), n;
}
const Qs = Ly("logger", H$);
function W$(e, n, r) {
  try {
    Object.defineProperty(e, n, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: r,
      writable: !0,
      configurable: !0
    });
  } catch {
    eC && Qs.log(`Failed to add non-enumerable property "${n}" to object`, e);
  }
}
const tC = 1e3;
function Vy() {
  return Date.now() / tC;
}
function K$() {
  const { performance: e } = ai;
  if (!e || !e.now)
    return Vy;
  const n = Date.now() - e.now(), r = e.timeOrigin == null ? n : e.timeOrigin;
  return () => (r + e.now()) / tC;
}
const G$ = K$();
(() => {
  const { performance: e } = ai;
  if (!e || !e.now)
    return;
  const n = 3600 * 1e3, r = e.now(), i = Date.now(), a = e.timeOrigin ? Math.abs(e.timeOrigin + r - i) : n, o = a < n, s = e.timing && e.timing.navigationStart, d = typeof s == "number" ? Math.abs(s + r - i) : n, m = d < n;
  return o || m ? a <= d ? e.timeOrigin : s : i;
})();
function pa() {
  const e = ai, n = e.crypto || e.msCrypto;
  let r = () => Math.random() * 16;
  try {
    if (n && n.randomUUID)
      return n.randomUUID().replace(/-/g, "");
    n && n.getRandomValues && (r = () => {
      const i = new Uint8Array(1);
      return n.getRandomValues(i), i[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (i) => (
      // eslint-disable-next-line no-bitwise
      (i ^ (r() & 15) >> i / 4).toString(16)
    )
  );
}
function Tv() {
  return {
    traceId: pa(),
    spanId: pa().substring(16)
  };
}
function zy() {
  return Uy(ai), ai;
}
function Uy(e) {
  const n = e.__SENTRY__ = e.__SENTRY__ || {};
  return n.version = n.version || Fo, n[Fo] = n[Fo] || {};
}
function Y$(e, n = {}) {
  if (n.user && (!e.ipAddress && n.user.ip_address && (e.ipAddress = n.user.ip_address), !e.did && !n.did && (e.did = n.user.id || n.user.email || n.user.username)), e.timestamp = n.timestamp || G$(), n.abnormal_mechanism && (e.abnormal_mechanism = n.abnormal_mechanism), n.ignoreDuration && (e.ignoreDuration = n.ignoreDuration), n.sid && (e.sid = n.sid.length === 32 ? n.sid : pa()), n.init !== void 0 && (e.init = n.init), !e.did && n.did && (e.did = `${n.did}`), typeof n.started == "number" && (e.started = n.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof n.duration == "number")
    e.duration = n.duration;
  else {
    const r = e.timestamp - e.started;
    e.duration = r >= 0 ? r : 0;
  }
  n.release && (e.release = n.release), n.environment && (e.environment = n.environment), !e.ipAddress && n.ipAddress && (e.ipAddress = n.ipAddress), !e.userAgent && n.userAgent && (e.userAgent = n.userAgent), typeof n.errors == "number" && (e.errors = n.errors), n.status && (e.status = n.status);
}
const Yh = "_sentrySpan";
function Ov(e, n) {
  n ? W$(e, Yh, n) : delete e[Yh];
}
function Rv(e) {
  return e[Yh];
}
const J$ = 100;
class My {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = Tv();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const n = new My();
    return n._breadcrumbs = [...this._breadcrumbs], n._tags = { ...this._tags }, n._extra = { ...this._extra }, n._contexts = { ...this._contexts }, n._user = this._user, n._level = this._level, n._session = this._session, n._transactionName = this._transactionName, n._fingerprint = this._fingerprint, n._eventProcessors = [...this._eventProcessors], n._requestSession = this._requestSession, n._attachments = [...this._attachments], n._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, n._propagationContext = { ...this._propagationContext }, n._client = this._client, n._lastEventId = this._lastEventId, Ov(n, Rv(this)), n;
  }
  /**
   * @inheritDoc
   */
  setClient(n) {
    this._client = n;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(n) {
    this._lastEventId = n;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(n) {
    this._scopeListeners.push(n);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(n) {
    return this._eventProcessors.push(n), this;
  }
  /**
   * @inheritDoc
   */
  setUser(n) {
    return this._user = n || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && Y$(this._session, { user: n }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(n) {
    return this._requestSession = n, this;
  }
  /**
   * @inheritDoc
   */
  setTags(n) {
    return this._tags = {
      ...this._tags,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(n, r) {
    return this._tags = { ...this._tags, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(n) {
    return this._extra = {
      ...this._extra,
      ...n
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(n, r) {
    return this._extra = { ...this._extra, [n]: r }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(n) {
    return this._fingerprint = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(n) {
    return this._level = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(n) {
    return this._transactionName = n, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(n, r) {
    return r === null ? delete this._contexts[n] : this._contexts[n] = r, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(n) {
    return n ? this._session = n : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(n) {
    if (!n)
      return this;
    const r = typeof n == "function" ? n(this) : n, [i, a] = r instanceof _a ? [r.getScopeData(), r.getRequestSession()] : M$(r) ? [n, n.requestSession] : [], { tags: o, extra: s, user: l, contexts: d, level: m, fingerprint: u = [], propagationContext: f } = i || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...s }, this._contexts = { ...this._contexts, ...d }, l && Object.keys(l).length && (this._user = l), m && (this._level = m), u.length && (this._fingerprint = u), f && (this._propagationContext = f), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ov(this, void 0), this._attachments = [], this._propagationContext = Tv(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(n, r) {
    const i = typeof r == "number" ? r : J$;
    if (i <= 0)
      return this;
    const a = {
      timestamp: Vy(),
      ...n
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > i ? o.slice(-i) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(n) {
    return this._attachments.push(n), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Rv(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(n) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...n }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(n) {
    return this._propagationContext = n, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(n, r) {
    const i = r && r.event_id ? r.event_id : pa();
    if (!this._client)
      return Qs.warn("No client configured on scope - will not capture exception!"), i;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      n,
      {
        originalException: n,
        syntheticException: a,
        ...r,
        event_id: i
      },
      this
    ), i;
  }
  /**
   * @inheritDoc
   */
  captureMessage(n, r, i) {
    const a = i && i.event_id ? i.event_id : pa();
    if (!this._client)
      return Qs.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(n);
    return this._client.captureMessage(
      n,
      r,
      {
        originalException: n,
        syntheticException: o,
        ...i,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(n, r) {
    const i = r && r.event_id ? r.event_id : pa();
    return this._client ? (this._client.captureEvent(n, { ...r, event_id: i }, this), i) : (Qs.warn("No client configured on scope - will not capture event!"), i);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((n) => {
      n(this);
    }), this._notifyingListeners = !1);
  }
}
const _a = My;
function Q$() {
  return Ly("defaultCurrentScope", () => new _a());
}
function X$() {
  return Ly("defaultIsolationScope", () => new _a());
}
class Z$ {
  constructor(n, r) {
    let i;
    n ? i = n : i = new _a();
    let a;
    r ? a = r : a = new _a(), this._stack = [{ scope: i }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(n) {
    const r = this._pushScope();
    let i;
    try {
      i = n(r);
    } catch (a) {
      throw this._popScope(), a;
    }
    return B$(i) ? i.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), i);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const n = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: n
    }), n;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function xa() {
  const e = zy(), n = Uy(e);
  return n.stack = n.stack || new Z$(Q$(), X$());
}
function eT(e) {
  return xa().withScope(e);
}
function nT(e, n) {
  const r = xa();
  return r.withScope(() => (r.getStackTop().scope = e, n(e)));
}
function Dv(e) {
  return xa().withScope(() => e(xa().getIsolationScope()));
}
function tT() {
  return {
    withIsolationScope: Dv,
    withScope: eT,
    withSetScope: nT,
    withSetIsolationScope: (e, n) => Dv(n),
    getCurrentScope: () => xa().getScope(),
    getIsolationScope: () => xa().getIsolationScope()
  };
}
function rC(e) {
  const n = Uy(e);
  return n.acs ? n.acs : tT();
}
function By() {
  const e = zy();
  return rC(e).getCurrentScope();
}
function iC() {
  const e = zy();
  return rC(e).getIsolationScope();
}
function rT() {
  return By().getClient();
}
function iT(e) {
  if (e)
    return aT(e) ? { captureContext: e } : sT(e) ? {
      captureContext: e
    } : e;
}
function aT(e) {
  return e instanceof _a || typeof e == "function";
}
const oT = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function sT(e) {
  return Object.keys(e).some((n) => oT.includes(n));
}
function Pv(e, n) {
  return By().captureException(e, iT(n));
}
function lT(e, n) {
  const r = typeof n == "string" ? n : void 0, i = typeof n != "string" ? { captureContext: n } : void 0;
  return By().captureMessage(e, r, i);
}
function cT(e, n) {
  iC().setContext(e, n);
}
const dT = 100;
function $i(e, n) {
  const r = rT(), i = iC();
  if (!r) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = dT } = r.getOptions();
  if (o <= 0) return;
  const l = { timestamp: Vy(), ...e }, d = a ? nC(() => a(l, n)) : l;
  d !== null && (r.emit && r.emit("beforeAddBreadcrumb", d, n), i.addBreadcrumb(d, o));
}
var Uo;
(function(e) {
  e.Unknown = "unknown", e.Core = "core", e.Routing = "routing-and-presence", e.Insights = "insights", e.Ecosystem = "ecosystem", e.Partners = "partners", e.Channels = "channels", e.Messaging = "messaging", e.Platform = "platform", e.AI = "ai", e.Conversations = "conversations", e.Automation = "automation";
})(Uo || (Uo = {}));
function fa(e) {
  const n = e.split(".")[1];
  if (!n)
    throw Error("Invalid token");
  const r = n.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(r, "base64").toString());
  } catch (i) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${i}`);
  }
}
const uT = Vo.backendDomain ? {
  "backend-domain": Vo.backendDomain
} : void 0;
function Xs() {
  const e = new URLSearchParams({
    noToken: "true",
    ...uT
  }).toString();
  document.location.href = `${Vo.url.logIn}?${e}`;
}
const Nc = "authData", jc = 30, mT = 600, wc = 5;
class pT {
  authData = null;
  /** The (server) time when the access token expires, in seconds. */
  accessTokenExpiresAt = 0;
  /**
   * The difference between client- and server-time, in seconds. Negative if
   * client is ahead of server, positive if server is ahead of client
   */
  clientServerTimeDiff = 0;
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const n = Date.now() / 1e3;
    return this.clientServerTimeDiff >= wc || this.clientServerTimeDiff <= -wc ? Math.ceil(n + this.clientServerTimeDiff) : Math.ceil(n);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(n) {
    this.authData = n;
    const i = Math.ceil(Date.now() / 1e3) + mT, a = fa(n.access_token).exp;
    if (this.clientServerTimeDiff = a - i, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > wc) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(Nc, JSON.stringify(n));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const n = localStorage.getItem(Nc), r = n ? JSON.parse(n) : null;
    return this.validateAuthDataComplete(r) && (this.authData = r), r;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(Nc);
  }
  getAccessToken() {
    return this.authData?.access_token || null;
  }
  getRefreshToken() {
    return this.authData?.refresh_token || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(n) {
    return n ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((i) => typeof n[i] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const r = this.accessTokenExpiresAt - jc;
    return this.estimatedServerTime() >= r;
  }
  isRefreshTokenExpired(n) {
    if (!n)
      return !0;
    const r = fa(n), i = r.exp - jc;
    return !r || this.estimatedServerTime() >= i;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - jc - this.estimatedServerTime()) * 1e3;
  }
}
const $t = new pT();
async function fT(e) {
  const n = window.location.origin.replace(/^https?:\/\//, ""), r = ["localhost:8080", "uptrends-monitor"];
  if (!(!e.response || r.some((i) => n.includes(i)))) {
    try {
      const i = e.response.config.headers.Authorization ?? "", a = i ? i.toString()?.split("Basic ")[1] : "", o = a ? atob(a).split("token:")[1] : "", s = o ? fa(o).exp : "None", l = await Jl.getAuthData({ localStorageOnly: !0 }), d = Math.floor(Date.now() / 1e3), m = l?.access_token, u = l?.refresh_token, f = m ? fa(m).exp : "None", h = u ? fa(u).exp : "None", k = typeof s == "number" ? d - s : "Unknown", C = typeof f == "number" ? d - f : "Unknown", N = typeof h == "number" ? d - h : "Unknown", j = e.response.headers["x-dixa-rid"];
      cT("Expires", {
        currentTimestamp: d,
        accessTokenFromHeader: s,
        accessTokenFromHeaderDiff: k,
        accessTokenFromLocalStorage: f,
        accessTokenFromLocalStorageDiff: C,
        refreshTokenFromLocalStorage: h,
        refreshTokenFromLocalStorageDiff: N,
        xDixaRid: j,
        navigatorOnline: navigator.onLine
      });
    } catch (i) {
      console.error("Error adding Sentry error context", i);
    }
    lT("401 unauthorized interceptor", {
      level: "debug",
      tags: {
        team: Uo.Platform,
        domain: n
      }
    });
  }
}
const Cc = /* @__PURE__ */ new Map(), hT = 3;
function yT(e) {
  e.interceptors.response.use((n) => (Cc.delete(n.config.url), n), (n) => {
    if (n.response) {
      const { status: r } = n.response;
      switch (r) {
        case Jh.Unauthorized:
          if (!Jl.isRefreshTokenExpired() && n.config) {
            $i({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const i = Cc.get(n.config.url) ?? 0;
            if (console.log(`Retrying request (${i + 1}): ${n.config.url}`), i <= hT)
              return Cc.set(n.config.url, i + 1), e(n.config);
          }
          fT(n), console.error("401 unauthorized interceptor"), Xs();
          break;
      }
    }
    return Promise.reject(n);
  });
}
const aC = vt.create();
yT(aC);
const Xr = console.log;
async function Av(e) {
  return new Promise((n) => setTimeout(n, e * 1e3));
}
class gT extends Error {
  constructor(n, r) {
    super(n, r);
  }
}
function vT(e = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, e)), 30);
}
const kT = 5;
class bT {
  authDataPromise = null;
  retryCount = 0;
  async init(n) {
    const r = await this.refresh(n);
    if (r)
      $t.setAuthData(r);
    else {
      const i = $t.isRefreshTokenExpired(n) ? "expired" : "unknown";
      throw new gT("Failed to init refresh token", {
        cause: i
      });
    }
  }
  getDebugInfo() {
    const n = $t.getAccessToken();
    if (!n)
      return {};
    const r = fa(n), { exp: i } = r;
    return {
      expire: i ? new Date(i * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  async getAuthData({ localStorageOnly: n = !1 } = {}) {
    if (n)
      return $t.getAuthData();
    if (this.authDataPromise)
      return await this.authDataPromise;
    const r = $t.getAuthData();
    return r ? $t.isAccessTokenExpired() ? ($i({
      category: "refreshToken",
      // Cannot include "token" in the message, as it will be redacted
      message: "expired or about to expire",
      level: "debug",
      data: this.getDebugInfo()
    }), this.authDataPromise = this.refresh(r.refresh_token).then((i) => (i && $t.setAuthData(i), this.authDataPromise = null, i)), await this.authDataPromise) : r : null;
  }
  removeAuthData() {
    return $t.removeAuthData();
  }
  validateAuthDataComplete(n) {
    return $t.validateAuthDataComplete(n);
  }
  isAccessTokenExpired() {
    return $t.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const n = $t.getAuthData();
    return n ? $t.isRefreshTokenExpired(n.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  async isSupported() {
    if (!Fv.isElectron())
      return !0;
    const n = await Fv.getVersion();
    return V$(n, "3.7.0") === 1;
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  async refresh(n, r = kT) {
    try {
      return await aC.post(`${Vo.url.rest}/v2/login/refresh`, {
        refreshToken: n
      }).then((i) => (this.retryCount = 0, i.data.data));
    } catch (i) {
      return await this.handleRefreshError(i, n, r);
    }
  }
  async waitUntilOnline() {
    const n = navigator.onLine === !1;
    for (n && (Xr("AUTH", "Network connection offline - waiting..."), $i({
      category: "refreshToken",
      message: "Network connection offline - waiting...",
      level: "debug"
    })); navigator.onLine === !1; )
      await Av(5);
    n && (Xr("AUTH", "Network connection restored"), $i({
      category: "refreshToken",
      message: "Network connection restored",
      level: "debug"
    }));
  }
  async retryRefresh(n, r) {
    await this.waitUntilOnline(), this.retryCount++;
    const i = vT(this.retryCount);
    return Xr("AUTH", `Retrying in ${i} seconds`), await Av(i), await this.refresh(n, r);
  }
  async handleRefreshError(n, r, i) {
    if ($t.isRefreshTokenExpired(r))
      return Xr("AUTH", "Refresh token expired"), $i({
        category: "refreshToken",
        message: "Refresh token expired",
        level: "debug"
      }), $t.removeAuthData(), Xs(), null;
    if (A$(n)) {
      if (n.message === "timeout exceeded")
        return Xr("AUTH", "Timeout exceeded"), $i({
          category: "refreshToken",
          message: "Timeout exceeded",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.message === "Network Error")
        return Xr("AUTH", "Network error"), $i({
          category: "refreshToken",
          message: "Network error",
          level: "debug"
        }), await this.retryRefresh(r, i);
      if (n.response?.status === 401)
        return Xr("AUTH", "Refresh token invalid (401)"), $t.removeAuthData(), Xs(), null;
      Pv(n, {
        level: "error",
        tags: {
          team: Uo.Platform,
          errorSource: "authManager.refresh"
        }
      });
    }
    return i <= 0 ? (Xr("AUTH", "Retries exhausted, logging out"), Pv(n, {
      level: "error",
      tags: {
        team: Uo.Platform,
        errorSource: "authManager.refresh"
      }
    }), $t.removeAuthData(), Xs(), null) : (Xr("AUTH", `Retrying ${i} more times`), await this.retryRefresh(r, i - 1));
  }
  accessTokenExpiresInMs() {
    return $t.accessTokenExpiresInMs();
  }
}
const Jl = new bT();
var Jh;
(function(e) {
  e[e.BadRequest = 400] = "BadRequest", e[e.Unauthorized = 401] = "Unauthorized", e[e.Forbidden = 403] = "Forbidden", e[e.NotFound = 404] = "NotFound", e[e.Conflict = 409] = "Conflict", e[e.InternalServerError = 500] = "InternalServerError", e[e.BadGateway = 502] = "BadGateway", e[e.ServiceUnavailable = 503] = "ServiceUnavailable";
})(Jh || (Jh = {}));
const _T = new Iy((e, n) => new ww((r) => {
  Jl.getAuthData().then((i) => {
    const a = i?.access_token, o = e.getContext().headers;
    return e.setContext({
      ...o,
      headers: {
        Authorization: a ? `Bearer ${a}` : ""
      }
    }), n(e).subscribe(r);
  }).catch((i) => r.error(i));
})), xT = new Iy(
  (e, n) => new ww((r) => {
    const i = e.getContext(), { headers: a, widgetId: o, widgetType: s, operationName: l } = i;
    Jl.getAuthData().then((d) => (e.setContext({
      ...i,
      headers: {
        ...a,
        ...o && { "x-integration-widget-id": o },
        ...s && { "x-integration-widget-type": s },
        ...l && {
          "x-integration-widget-operation": l
        },
        ...rI(Vo.url.partnerIntegrations) && d?.access_token && iI(d.access_token)
      }
    }), n(e).subscribe(r))).catch((d) => r.error(d));
  })
), ST = new AbortController(), oC = (e) => new FI({
  queryDeduplication: !1,
  cache: new II(),
  link: Iy.from([
    _T,
    xT,
    EI({
      uri: `${e}/graphql`,
      fetch: RI,
      fetchOptions: {
        mode: "cors",
        // The `AbortSignal` object instance is used to communicate with a
        // fetch request and abort it if desired via an `AbortController`.
        // This prevents abandoned abort errors spiral up to Sentry.
        signal: ST.signal
      }
    })
  ]),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "all"
    }
  }
}), NT = ({
  configuration: e,
  children: n
}) => {
  const r = Xn(
    () => oC(e.baseUrl),
    [e.baseUrl]
  );
  return /* @__PURE__ */ Qn.jsx($I, { client: r, children: n });
};
function jT() {
  try {
    return TI(), !0;
  } catch {
    return !1;
  }
}
const wT = ({
  configuration: e,
  children: n
}) => jT() ? n : /* @__PURE__ */ Qn.jsx(NT, { configuration: e, children: n }), CT = ({
  integrationId: e,
  type: n,
  showNotification: r,
  showModal: i,
  children: a
}) => /* @__PURE__ */ Qn.jsx(OI, { children: (o) => /* @__PURE__ */ Qn.jsx(
  aI,
  {
    value: {
      useMutation: cI(e, n),
      useQuery: lI(e, n),
      useLazyQuery: sI(e, n),
      executeQuery: oI(e, n, o),
      showNotification: r,
      showModal: i ?? (() => null)
    },
    children: a
  }
) }), sC = ({
  integrationId: e,
  type: n,
  configuration: r,
  showNotification: i,
  showModal: a,
  children: o
}) => {
  const s = !!e && !!n;
  return /* @__PURE__ */ Qn.jsx(wT, { configuration: r, children: s ? /* @__PURE__ */ Qn.jsx(
    CT,
    {
      integrationId: e,
      type: n,
      showNotification: i,
      showModal: a,
      children: o
    }
  ) : o });
}, lC = wy(
  () => {
  }
), FT = () => Bl(lC), IT = ({
  children: e
}) => {
  const [n, r] = me(!1), i = {
    headline: "",
    text: "",
    onConfirm: () => r(!1),
    confirmLabel: "Confirm",
    confirmVariant: "primary"
  }, [a, o] = me(i), s = (d) => {
    r(!0), o(d);
  }, l = () => {
    r(!1), o(i);
  };
  return /* @__PURE__ */ Qn.jsxs(lC.Provider, { value: s, children: [
    e,
    /* @__PURE__ */ Qn.jsx(
      dI,
      {
        isOpen: n,
        setIsOpen: r,
        headline: a.headline,
        text: a.text,
        confirmLabel: a.confirmLabel,
        confirmVariant: a.confirmVariant,
        cancelLabel: a.cancelLabel,
        cancelVariant: a.cancelVariant,
        onConfirm: a.onConfirm ? () => {
          try {
            a.onConfirm && a.onConfirm();
          } finally {
            l();
          }
        } : void 0,
        onCancel: a.onCancel ? () => {
          try {
            a.onCancel && a.onCancel();
          } finally {
            l();
          }
        } : void 0,
        children: a.children
      }
    )
  ] });
}, ET = "_unmatchedHeader_qcj19_1", $T = {
  unmatchedHeader: ET
};
var Qo = (e) => e.type === "checkbox", Di = (e) => e instanceof Date, Gt = (e) => e == null;
const cC = (e) => typeof e == "object";
var yt = (e) => !Gt(e) && !Array.isArray(e) && cC(e) && !Di(e), dC = (e) => yt(e) && e.target ? Qo(e.target) ? e.target.checked : e.target.value : e, TT = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, uC = (e, n) => e.has(TT(n)), OT = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return yt(n) && n.hasOwnProperty("isPrototypeOf");
}, qy = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Rt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(qy && (e instanceof Blob || i)) && (r || yt(e)))
    if (n = r ? [] : {}, !r && !OT(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Rt(e[a]));
  else
    return e;
  return n;
}
var Ql = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ft = (e) => e === void 0, nn = (e, n, r) => {
  if (!n || !yt(e))
    return r;
  const i = Ql(n.split(/[,[\].]+?/)).reduce((a, o) => Gt(a) ? a : a[o], e);
  return ft(i) || i === e ? ft(e[n]) ? r : e[n] : i;
}, sr = (e) => typeof e == "boolean", Hy = (e) => /^\w*$/.test(e), mC = (e) => Ql(e.replace(/["|']|\]/g, "").split(/\.|\[/)), rt = (e, n, r) => {
  let i = -1;
  const a = Hy(n) ? [n] : mC(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = yt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const pl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, jr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Zr = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, pC = qe.createContext(null), Rr = () => qe.useContext(pC), Wy = (e) => {
  const { children: n, ...r } = e;
  return qe.createElement(pC.Provider, { value: r }, n);
};
var fC = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== jr.all && (n._proxyFormState[s] = !i || jr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function RT(e) {
  const n = Rr(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => fC(s, r, d.current, !1), [s, r]);
}
var Br = (e) => typeof e == "string", hC = (e, n, r, i, a) => Br(e) ? (i && n.watch.add(e), nn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), nn(r, o))) : (i && (n.watchAll = !0), r);
function yi(e) {
  const n = Rr(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(hC(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Ky(e) {
  const n = Rr(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = uC(a._names.array, r), l = yi({
    control: a,
    name: r,
    defaultValue: nn(a._formValues, r, nn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = RT({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...sr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!nn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!nn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!nn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!nn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => nn(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((j) => u.current.onChange({
    target: {
      value: dC(j),
      name: r
    },
    type: pl.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: nn(a._formValues, r),
      name: r
    },
    type: pl.BLUR
  }), [r, a._formValues]), C = qe.useCallback((j) => {
    const _ = nn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = qe.useMemo(() => ({
    name: r,
    value: l,
    ...sr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: C
  }), [r, i, d.disabled, h, k, C, l]);
  return qe.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...sr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (g, D) => {
      const O = nn(a._fields, g);
      O && O._f && (O._f.mount = D);
    };
    if (_(r, !0), j) {
      const g = Rt(nn(a._options.defaultValues, r));
      rt(a._defaultValues, r, g), ft(nn(a._formValues, r)) && rt(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
const bt = (e) => e.render(Ky(e));
var DT = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Io = (e) => Array.isArray(e) ? e : [e], Lv = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (a) => {
      for (const o of e)
        o.next && o.next(a);
    },
    subscribe: (a) => (e.push(a), {
      unsubscribe: () => {
        e = e.filter((o) => o !== a);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, Qh = (e) => Gt(e) || !cC(e);
function pi(e, n) {
  if (Qh(e) || Qh(n))
    return e === n;
  if (Di(e) && Di(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Di(o) && Di(s) || yt(o) && yt(s) || Array.isArray(o) && Array.isArray(s) ? !pi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Wt = (e) => yt(e) && !Object.keys(e).length, Gy = (e) => e.type === "file", wr = (e) => typeof e == "function", fl = (e) => {
  if (!qy)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, yC = (e) => e.type === "select-multiple", Yy = (e) => e.type === "radio", PT = (e) => Yy(e) || Qo(e), Fc = (e) => fl(e) && e.isConnected;
function AT(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ft(e) ? i++ : e[n[i++]];
  return e;
}
function LT(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ft(e[n]))
      return !1;
  return !0;
}
function St(e, n) {
  const r = Array.isArray(n) ? n : Hy(n) ? [n] : mC(n), i = r.length === 1 ? e : AT(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (yt(i) && Wt(i) || Array.isArray(i) && LT(i)) && St(e, r.slice(0, -1)), e;
}
var gC = (e) => {
  for (const n in e)
    if (wr(e[n]))
      return !0;
  return !1;
};
function hl(e, n = {}) {
  const r = Array.isArray(e);
  if (yt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || yt(e[i]) && !gC(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, hl(e[i], n[i])) : Gt(e[i]) || (n[i] = !0);
  return n;
}
function vC(e, n, r) {
  const i = Array.isArray(e);
  if (yt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || yt(e[a]) && !gC(e[a]) ? ft(n) || Qh(r[a]) ? r[a] = Array.isArray(e[a]) ? hl(e[a], []) : { ...hl(e[a]) } : vC(e[a], Gt(n) ? {} : n[a], r[a]) : r[a] = !pi(e[a], n[a]);
  return r;
}
var Ba = (e, n) => vC(e, n, hl(n));
const Vv = {
  value: !1,
  isValid: !1
}, zv = { value: !0, isValid: !0 };
var kC = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ft(e[0].attributes.value) ? ft(e[0].value) || e[0].value === "" ? zv : { value: e[0].value, isValid: !0 } : zv
    ) : Vv;
  }
  return Vv;
}, bC = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ft(e) ? e : n ? e === "" ? NaN : e && +e : r && Br(e) ? new Date(e) : i ? i(e) : e;
const Uv = {
  isValid: !1,
  value: null
};
var _C = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, Uv) : Uv;
function Mv(e) {
  const n = e.ref;
  return Gy(n) ? n.files : Yy(n) ? _C(e.refs).value : yC(n) ? [...n.selectedOptions].map(({ value: r }) => r) : Qo(n) ? kC(e.refs).value : bC(ft(n.value) ? e.ref.value : n.value, e);
}
var VT = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = nn(n, o);
    s && rt(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, yl = (e) => e instanceof RegExp, qa = (e) => ft(e) ? e : yl(e) ? e.source : yt(e) ? yl(e.value) ? e.value.source : e.value : e, Bv = (e) => ({
  isOnSubmit: !e || e === jr.onSubmit,
  isOnBlur: e === jr.onBlur,
  isOnChange: e === jr.onChange,
  isOnAll: e === jr.all,
  isOnTouch: e === jr.onTouched
});
const qv = "AsyncFunction";
var zT = (e) => !!e && !!e.validate && !!(wr(e.validate) && e.validate.constructor.name === qv || yt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === qv)), UT = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), Hv = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Eo = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = nn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i)
          return !0;
        if (s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Eo(l, n))
          break;
      } else if (yt(l) && Eo(l, n))
        break;
    }
  }
};
function Wv(e, n, r) {
  const i = nn(e, r);
  if (i || Hy(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = nn(n, o), l = nn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var MT = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Wt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || jr.all));
}, BT = (e, n, r) => !e || !n || e === n || Io(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), qT = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, HT = (e, n) => !Ql(nn(e, n)).length && St(e, n), WT = (e, n, r) => {
  const i = Io(nn(e, r));
  return rt(i, "root", n[r]), rt(e, r, i), e;
}, Zs = (e) => Br(e);
function Kv(e, n, r = "validate") {
  if (Zs(e) || Array.isArray(e) && e.every(Zs) || sr(e) && !e)
    return {
      type: r,
      message: Zs(e) ? e : "",
      ref: n
    };
}
var Zi = (e) => yt(e) && !yl(e) ? e : {
  value: e,
  message: ""
}, Gv = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: C, name: N, valueAsNumber: j, mount: _ } = e._f, g = nn(r, N);
  if (!_ || n.has(N))
    return {};
  const D = l ? l[0] : s, O = (Y) => {
    a && D.reportValidity && (D.setCustomValidity(sr(Y) ? "" : Y || ""), D.reportValidity());
  }, I = {}, F = Yy(s), L = Qo(s), K = F || L, J = (j || Gy(s)) && ft(s.value) && ft(g) || fl(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = DT.bind(null, N, i, I), W = (Y, P, B, re = Zr.maxLength, je = Zr.minLength) => {
    const ue = Y ? P : B;
    I[N] = {
      type: Y ? re : je,
      message: ue,
      ref: s,
      ...te(Y ? re : je, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!K && (J || Gt(g)) || sr(g) && !g || L && !kC(l).isValid || F && !_C(l).isValid)) {
    const { value: Y, message: P } = Zs(d) ? { value: !!d, message: d } : Zi(d);
    if (Y && (I[N] = {
      type: Zr.required,
      message: P,
      ref: D,
      ...te(Zr.required, P)
    }, !i))
      return O(P), I;
  }
  if (!J && (!Gt(f) || !Gt(h))) {
    let Y, P;
    const B = Zi(h), re = Zi(f);
    if (!Gt(g) && !isNaN(g)) {
      const je = s.valueAsNumber || g && +g;
      Gt(B.value) || (Y = je > B.value), Gt(re.value) || (P = je < re.value);
    } else {
      const je = s.valueAsDate || new Date(g), ue = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), se = s.type == "time", he = s.type == "week";
      Br(B.value) && g && (Y = se ? ue(g) > ue(B.value) : he ? g > B.value : je > new Date(B.value)), Br(re.value) && g && (P = se ? ue(g) < ue(re.value) : he ? g < re.value : je < new Date(re.value));
    }
    if ((Y || P) && (W(!!Y, B.message, re.message, Zr.max, Zr.min), !i))
      return O(I[N].message), I;
  }
  if ((m || u) && !J && (Br(g) || o && Array.isArray(g))) {
    const Y = Zi(m), P = Zi(u), B = !Gt(Y.value) && g.length > +Y.value, re = !Gt(P.value) && g.length < +P.value;
    if ((B || re) && (W(B, Y.message, P.message), !i))
      return O(I[N].message), I;
  }
  if (k && !J && Br(g)) {
    const { value: Y, message: P } = Zi(k);
    if (yl(Y) && !g.match(Y) && (I[N] = {
      type: Zr.pattern,
      message: P,
      ref: s,
      ...te(Zr.pattern, P)
    }, !i))
      return O(P), I;
  }
  if (C) {
    if (wr(C)) {
      const Y = await C(g, r), P = Kv(Y, D);
      if (P && (I[N] = {
        ...P,
        ...te(Zr.validate, P.message)
      }, !i))
        return O(P.message), I;
    } else if (yt(C)) {
      let Y = {};
      for (const P in C) {
        if (!Wt(Y) && !i)
          break;
        const B = Kv(await C[P](g, r), D, P);
        B && (Y = {
          ...B,
          ...te(P, B.message)
        }, O(B.message), i && (I[N] = Y));
      }
      if (!Wt(Y) && (I[N] = {
        ref: D,
        ...Y
      }, !i))
        return I;
    }
  }
  return O(!0), I;
};
const KT = {
  mode: jr.onSubmit,
  reValidateMode: jr.onChange,
  shouldFocusError: !0
};
function GT(e = {}) {
  let n = {
    ...KT,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: wr(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = yt(n.defaultValues) || yt(n.values) ? Rt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Rt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: Lv(),
    state: Lv()
  }, k = Bv(n.mode), C = Bv(n.reValidateMode), N = n.criteriaMode === jr.all, j = (E) => (z) => {
    clearTimeout(m), m = setTimeout(E, z);
  }, _ = async (E) => {
    if (!n.disabled && (u.isValid || f.isValid || E)) {
      const z = n.resolver ? Wt((await J()).errors) : await W(i, !0);
      z !== r.isValid && h.state.next({
        isValid: z
      });
    }
  }, g = (E, z) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((E || Array.from(l.mount)).forEach((ie) => {
      ie && (z ? rt(r.validatingFields, ie, z) : St(r.validatingFields, ie));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Wt(r.validatingFields)
    }));
  }, D = (E, z = [], ie, ce, U = !0, G = !0) => {
    if (ce && ie && !n.disabled) {
      if (s.action = !0, G && Array.isArray(nn(i, E))) {
        const ye = ie(nn(i, E), ce.argA, ce.argB);
        U && rt(i, E, ye);
      }
      if (G && Array.isArray(nn(r.errors, E))) {
        const ye = ie(nn(r.errors, E), ce.argA, ce.argB);
        U && rt(r.errors, E, ye), HT(r.errors, E);
      }
      if ((u.touchedFields || f.touchedFields) && G && Array.isArray(nn(r.touchedFields, E))) {
        const ye = ie(nn(r.touchedFields, E), ce.argA, ce.argB);
        U && rt(r.touchedFields, E, ye);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = Ba(a, o)), h.state.next({
        name: E,
        isDirty: P(E, z),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      rt(o, E, z);
  }, O = (E, z) => {
    rt(r.errors, E, z), h.state.next({
      errors: r.errors
    });
  }, I = (E) => {
    r.errors = E, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (E, z, ie, ce) => {
    const U = nn(i, E);
    if (U) {
      const G = nn(o, E, ft(ie) ? nn(a, E) : ie);
      ft(G) || ce && ce.defaultChecked || z ? rt(o, E, z ? G : Mv(U._f)) : je(E, G), s.mount && _();
    }
  }, L = (E, z, ie, ce, U) => {
    let G = !1, ye = !1;
    const Ne = {
      name: E
    };
    if (!n.disabled) {
      if (!ie || ce) {
        (u.isDirty || f.isDirty) && (ye = r.isDirty, r.isDirty = Ne.isDirty = P(), G = ye !== Ne.isDirty);
        const Oe = pi(nn(a, E), z);
        ye = !!nn(r.dirtyFields, E), Oe ? St(r.dirtyFields, E) : rt(r.dirtyFields, E, !0), Ne.dirtyFields = r.dirtyFields, G = G || (u.dirtyFields || f.dirtyFields) && ye !== !Oe;
      }
      if (ie) {
        const Oe = nn(r.touchedFields, E);
        Oe || (rt(r.touchedFields, E, ie), Ne.touchedFields = r.touchedFields, G = G || (u.touchedFields || f.touchedFields) && Oe !== ie);
      }
      G && U && h.state.next(Ne);
    }
    return G ? Ne : {};
  }, K = (E, z, ie, ce) => {
    const U = nn(r.errors, E), G = (u.isValid || f.isValid) && sr(z) && r.isValid !== z;
    if (n.delayError && ie ? (d = j(() => O(E, ie)), d(n.delayError)) : (clearTimeout(m), d = null, ie ? rt(r.errors, E, ie) : St(r.errors, E)), (ie ? !pi(U, ie) : U) || !Wt(ce) || G) {
      const ye = {
        ...ce,
        ...G && sr(z) ? { isValid: z } : {},
        errors: r.errors,
        name: E
      };
      r = {
        ...r,
        ...ye
      }, h.state.next(ye);
    }
  }, J = async (E) => {
    g(E, !0);
    const z = await n.resolver(o, n.context, VT(E || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(E), z;
  }, te = async (E) => {
    const { errors: z } = await J(E);
    if (E)
      for (const ie of E) {
        const ce = nn(z, ie);
        ce ? rt(r.errors, ie, ce) : St(r.errors, ie);
      }
    else
      r.errors = z;
    return z;
  }, W = async (E, z, ie = {
    valid: !0
  }) => {
    for (const ce in E) {
      const U = E[ce];
      if (U) {
        const { _f: G, ...ye } = U;
        if (G) {
          const Ne = l.array.has(G.name), Oe = U._f && zT(U._f);
          Oe && u.validatingFields && g([ce], !0);
          const rn = await Gv(U, l.disabled, o, N, n.shouldUseNativeValidation && !z, Ne);
          if (Oe && u.validatingFields && g([ce]), rn[G.name] && (ie.valid = !1, z))
            break;
          !z && (nn(rn, G.name) ? Ne ? WT(r.errors, rn, G.name) : rt(r.errors, G.name, rn[G.name]) : St(r.errors, G.name));
        }
        !Wt(ye) && await W(ye, z, ie);
      }
    }
    return ie.valid;
  }, Y = () => {
    for (const E of l.unMount) {
      const z = nn(i, E);
      z && (z._f.refs ? z._f.refs.every((ie) => !Fc(ie)) : !Fc(z._f.ref)) && Be(E);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (E, z) => !n.disabled && (E && z && rt(o, E, z), !pi(De(), a)), B = (E, z, ie) => hC(E, l, {
    ...s.mount ? o : ft(z) ? a : Br(E) ? { [E]: z } : z
  }, ie, z), re = (E) => Ql(nn(s.mount ? o : a, E, n.shouldUnregister ? nn(a, E, []) : [])), je = (E, z, ie = {}) => {
    const ce = nn(i, E);
    let U = z;
    if (ce) {
      const G = ce._f;
      G && (!G.disabled && rt(o, E, bC(z, G)), U = fl(G.ref) && Gt(z) ? "" : z, yC(G.ref) ? [...G.ref.options].forEach((ye) => ye.selected = U.includes(ye.value)) : G.refs ? Qo(G.ref) ? G.refs.length > 1 ? G.refs.forEach((ye) => (!ye.defaultChecked || !ye.disabled) && (ye.checked = Array.isArray(U) ? !!U.find((Ne) => Ne === ye.value) : U === ye.value)) : G.refs[0] && (G.refs[0].checked = !!U) : G.refs.forEach((ye) => ye.checked = ye.value === U) : Gy(G.ref) ? G.ref.value = "" : (G.ref.value = U, G.ref.type || h.state.next({
        name: E,
        values: Rt(o)
      })));
    }
    (ie.shouldDirty || ie.shouldTouch) && L(E, U, ie.shouldTouch, ie.shouldDirty, !0), ie.shouldValidate && ke(E);
  }, ue = (E, z, ie) => {
    for (const ce in z) {
      const U = z[ce], G = `${E}.${ce}`, ye = nn(i, G);
      (l.array.has(E) || yt(U) || ye && !ye._f) && !Di(U) ? ue(G, U, ie) : je(G, U, ie);
    }
  }, se = (E, z, ie = {}) => {
    const ce = nn(i, E), U = l.array.has(E), G = Rt(z);
    rt(o, E, G), U ? (h.array.next({
      name: E,
      values: Rt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && ie.shouldDirty && h.state.next({
      name: E,
      dirtyFields: Ba(a, o),
      isDirty: P(E, G)
    })) : ce && !ce._f && !Gt(G) ? ue(E, G, ie) : je(E, G, ie), Hv(E, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? E : void 0,
      values: Rt(o)
    });
  }, he = async (E) => {
    s.mount = !0;
    const z = E.target;
    let ie = z.name, ce = !0;
    const U = nn(i, ie), G = (ye) => {
      ce = Number.isNaN(ye) || Di(ye) && isNaN(ye.getTime()) || pi(ye, nn(o, ie, ye));
    };
    if (U) {
      let ye, Ne;
      const Oe = z.type ? Mv(U._f) : dC(E), rn = E.type === pl.BLUR || E.type === pl.FOCUS_OUT, kn = !UT(U._f) && !n.resolver && !nn(r.errors, ie) && !U._f.deps || qT(rn, nn(r.touchedFields, ie), r.isSubmitted, C, k), an = Hv(ie, l, rn);
      rt(o, ie, Oe), rn ? (U._f.onBlur && U._f.onBlur(E), d && d(0)) : U._f.onChange && U._f.onChange(E);
      const pn = L(ie, Oe, rn), $n = !Wt(pn) || an;
      if (!rn && h.state.next({
        name: ie,
        type: E.type,
        values: Rt(o)
      }), kn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? rn && _() : rn || _()), $n && h.state.next({ name: ie, ...an ? {} : pn });
      if (!rn && an && h.state.next({ ...r }), n.resolver) {
        const { errors: _n } = await J([ie]);
        if (G(Oe), ce) {
          const Fn = Wv(r.errors, i, ie), Ze = Wv(_n, i, Fn.name || ie);
          ye = Ze.error, ie = Ze.name, Ne = Wt(_n);
        }
      } else
        g([ie], !0), ye = (await Gv(U, l.disabled, o, N, n.shouldUseNativeValidation))[ie], g([ie]), G(Oe), ce && (ye ? Ne = !1 : (u.isValid || f.isValid) && (Ne = await W(i, !0)));
      ce && (U._f.deps && ke(U._f.deps), K(ie, Ne, ye, pn));
    }
  }, V = (E, z) => {
    if (nn(r.errors, z) && E.focus)
      return E.focus(), 1;
  }, ke = async (E, z = {}) => {
    let ie, ce;
    const U = Io(E);
    if (n.resolver) {
      const G = await te(ft(E) ? E : U);
      ie = Wt(G), ce = E ? !U.some((ye) => nn(G, ye)) : ie;
    } else E ? (ce = (await Promise.all(U.map(async (G) => {
      const ye = nn(i, G);
      return await W(ye && ye._f ? { [G]: ye } : ye);
    }))).every(Boolean), !(!ce && !r.isValid) && _()) : ce = ie = await W(i);
    return h.state.next({
      ...!Br(E) || (u.isValid || f.isValid) && ie !== r.isValid ? {} : { name: E },
      ...n.resolver || !E ? { isValid: ie } : {},
      errors: r.errors
    }), z.shouldFocus && !ce && Eo(i, V, E ? U : l.mount), ce;
  }, De = (E) => {
    const z = {
      ...s.mount ? o : a
    };
    return ft(E) ? z : Br(E) ? nn(z, E) : E.map((ie) => nn(z, ie));
  }, q = (E, z) => ({
    invalid: !!nn((z || r).errors, E),
    isDirty: !!nn((z || r).dirtyFields, E),
    error: nn((z || r).errors, E),
    isValidating: !!nn(r.validatingFields, E),
    isTouched: !!nn((z || r).touchedFields, E)
  }), Ge = (E) => {
    E && Io(E).forEach((z) => St(r.errors, z)), h.state.next({
      errors: E ? r.errors : {}
    });
  }, sn = (E, z, ie) => {
    const ce = (nn(i, E, { _f: {} })._f || {}).ref, U = nn(r.errors, E) || {}, { ref: G, message: ye, type: Ne, ...Oe } = U;
    rt(r.errors, E, {
      ...Oe,
      ...z,
      ref: ce
    }), h.state.next({
      name: E,
      errors: r.errors,
      isValid: !1
    }), ie && ie.shouldFocus && ce && ce.focus && ce.focus();
  }, Ie = (E, z) => wr(E) ? h.state.subscribe({
    next: (ie) => E(B(void 0, z), ie)
  }) : B(E, z, !0), Ue = (E) => h.state.subscribe({
    next: (z) => {
      BT(E.name, z.name, E.exact) && MT(z, E.formState || u, Pe, E.reRenderRoot) && E.callback({
        values: { ...o },
        ...r,
        ...z
      });
    }
  }).unsubscribe, Re = (E) => (s.mount = !0, f = {
    ...f,
    ...E.formState
  }, Ue({
    ...E,
    formState: f
  })), Be = (E, z = {}) => {
    for (const ie of E ? Io(E) : l.mount)
      l.mount.delete(ie), l.array.delete(ie), z.keepValue || (St(i, ie), St(o, ie)), !z.keepError && St(r.errors, ie), !z.keepDirty && St(r.dirtyFields, ie), !z.keepTouched && St(r.touchedFields, ie), !z.keepIsValidating && St(r.validatingFields, ie), !n.shouldUnregister && !z.keepDefaultValue && St(a, ie);
    h.state.next({
      values: Rt(o)
    }), h.state.next({
      ...r,
      ...z.keepDirty ? { isDirty: P() } : {}
    }), !z.keepIsValid && _();
  }, Ae = ({ disabled: E, name: z }) => {
    (sr(E) && s.mount || E || l.disabled.has(z)) && (E ? l.disabled.add(z) : l.disabled.delete(z));
  }, Je = (E, z = {}) => {
    let ie = nn(i, E);
    const ce = sr(z.disabled) || sr(n.disabled);
    return rt(i, E, {
      ...ie || {},
      _f: {
        ...ie && ie._f ? ie._f : { ref: { name: E } },
        name: E,
        mount: !0,
        ...z
      }
    }), l.mount.add(E), ie ? Ae({
      disabled: sr(z.disabled) ? z.disabled : n.disabled,
      name: E
    }) : F(E, !0, z.value), {
      ...ce ? { disabled: z.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!z.required,
        min: qa(z.min),
        max: qa(z.max),
        minLength: qa(z.minLength),
        maxLength: qa(z.maxLength),
        pattern: qa(z.pattern)
      } : {},
      name: E,
      onChange: he,
      onBlur: he,
      ref: (U) => {
        if (U) {
          Je(E, z), ie = nn(i, E);
          const G = ft(U.value) && U.querySelectorAll && U.querySelectorAll("input,select,textarea")[0] || U, ye = PT(G), Ne = ie._f.refs || [];
          if (ye ? Ne.find((Oe) => Oe === G) : G === ie._f.ref)
            return;
          rt(i, E, {
            _f: {
              ...ie._f,
              ...ye ? {
                refs: [
                  ...Ne.filter(Fc),
                  G,
                  ...Array.isArray(nn(a, E)) ? [{}] : []
                ],
                ref: { type: G.type, name: E }
              } : { ref: G }
            }
          }), F(E, !1, void 0, G);
        } else
          ie = nn(i, E, {}), ie._f && (ie._f.mount = !1), (n.shouldUnregister || z.shouldUnregister) && !(uC(l.array, E) && s.action) && l.unMount.add(E);
      }
    };
  }, $e = () => n.shouldFocusError && Eo(i, V, l.mount), Me = (E) => {
    sr(E) && (h.state.next({ disabled: E }), Eo(i, (z, ie) => {
      const ce = nn(i, ie);
      ce && (z.disabled = ce._f.disabled || E, Array.isArray(ce._f.refs) && ce._f.refs.forEach((U) => {
        U.disabled = ce._f.disabled || E;
      }));
    }, 0, !1));
  }, en = (E, z) => async (ie) => {
    let ce;
    ie && (ie.preventDefault && ie.preventDefault(), ie.persist && ie.persist());
    let U = Rt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: G, values: ye } = await J();
      r.errors = G, U = ye;
    } else
      await W(i);
    if (l.disabled.size)
      for (const G of l.disabled)
        rt(U, G, void 0);
    if (St(r.errors, "root"), Wt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await E(U, ie);
      } catch (G) {
        ce = G;
      }
    } else
      z && await z({ ...r.errors }, ie), $e(), setTimeout($e);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Wt(r.errors) && !ce,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ce)
      throw ce;
  }, oe = (E, z = {}) => {
    nn(i, E) && (ft(z.defaultValue) ? se(E, Rt(nn(a, E))) : (se(E, z.defaultValue), rt(a, E, Rt(z.defaultValue))), z.keepTouched || St(r.touchedFields, E), z.keepDirty || (St(r.dirtyFields, E), r.isDirty = z.defaultValue ? P(E, Rt(nn(a, E))) : P()), z.keepError || (St(r.errors, E), u.isValid && _()), h.state.next({ ...r }));
  }, le = (E, z = {}) => {
    const ie = E ? Rt(E) : a, ce = Rt(ie), U = Wt(E), G = U ? a : ce;
    if (z.keepDefaultValues || (a = ie), !z.keepValues) {
      if (z.keepDirtyValues) {
        const ye = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(Ba(a, o))
        ]);
        for (const Ne of Array.from(ye))
          nn(r.dirtyFields, Ne) ? rt(G, Ne, nn(o, Ne)) : se(Ne, nn(G, Ne));
      } else {
        if (qy && ft(E))
          for (const ye of l.mount) {
            const Ne = nn(i, ye);
            if (Ne && Ne._f) {
              const Oe = Array.isArray(Ne._f.refs) ? Ne._f.refs[0] : Ne._f.ref;
              if (fl(Oe)) {
                const rn = Oe.closest("form");
                if (rn) {
                  rn.reset();
                  break;
                }
              }
            }
          }
        for (const ye of l.mount)
          se(ye, nn(G, ye));
      }
      o = Rt(G), h.array.next({
        values: { ...G }
      }), h.state.next({
        values: { ...G }
      });
    }
    l = {
      mount: z.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!z.keepIsValid || !!z.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: z.keepSubmitCount ? r.submitCount : 0,
      isDirty: U ? !1 : z.keepDirty ? r.isDirty : !!(z.keepDefaultValues && !pi(E, a)),
      isSubmitted: z.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: U ? {} : z.keepDirtyValues ? z.keepDefaultValues && o ? Ba(a, o) : r.dirtyFields : z.keepDefaultValues && E ? Ba(a, E) : z.keepDirty ? r.dirtyFields : {},
      touchedFields: z.keepTouched ? r.touchedFields : {},
      errors: z.keepErrors ? r.errors : {},
      isSubmitSuccessful: z.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (E, z) => le(wr(E) ? E(o) : E, z), Ve = (E, z = {}) => {
    const ie = nn(i, E), ce = ie && ie._f;
    if (ce) {
      const U = ce.refs ? ce.refs[0] : ce.ref;
      U.focus && (U.focus(), z.shouldSelect && wr(U.select) && U.select());
    }
  }, Pe = (E) => {
    r = {
      ...r,
      ...E
    };
  }, Q = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: q,
      handleSubmit: en,
      setError: sn,
      _subscribe: Ue,
      _runSchema: J,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: D,
      _setDisabledField: Ae,
      _setErrors: I,
      _getFieldArray: re,
      _reset: le,
      _resetDefaultValues: () => wr(n.defaultValues) && n.defaultValues().then((E) => {
        xe(E, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(E) {
        s = E;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(E) {
        l = E;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(E) {
        n = {
          ...n,
          ...E
        };
      }
    },
    subscribe: Re,
    trigger: ke,
    register: Je,
    handleSubmit: en,
    watch: Ie,
    setValue: se,
    getValues: De,
    reset: xe,
    resetField: oe,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Ve,
    getFieldState: q
  };
  return {
    ...Q,
    formControl: Q
  };
}
function ut(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: wr(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: wr(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : GT(e),
    formState: i
  }, e.formControl && e.defaultValues && !wr(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !pi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Wt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = fC(i, o), n.current;
}
var us = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xC(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Ic = { exports: {} }, Ha = {}, Yv;
function YT() {
  if (Yv) return Ha;
  Yv = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ha.Fragment = r, Ha.jsx = s, Ha.jsxs = s, Ha;
}
var ms = {}, Jv;
function JT() {
  return Jv || (Jv = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    ms.Fragment = i, ms.jsx = zn, ms.jsxs = Wn;
  })()), ms;
}
var Qv;
function QT() {
  return Qv || (Qv = 1, process.env.NODE_ENV === "production" ? Ic.exports = YT() : Ic.exports = JT()), Ic.exports;
}
var Li = QT();
function XT(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Ec, Xv;
function vi() {
  if (Xv) return Ec;
  Xv = 1;
  var e = Array.isArray;
  return Ec = e, Ec;
}
var $c, Zv;
function SC() {
  if (Zv) return $c;
  Zv = 1;
  var e = typeof us == "object" && us && us.Object === Object && us;
  return $c = e, $c;
}
var Tc, ek;
function Gr() {
  if (ek) return Tc;
  ek = 1;
  var e = SC(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Tc = r, Tc;
}
var Oc, nk;
function Xo() {
  if (nk) return Oc;
  nk = 1;
  var e = Gr(), n = e.Symbol;
  return Oc = n, Oc;
}
var Rc, tk;
function ZT() {
  if (tk) return Rc;
  tk = 1;
  var e = Xo(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return Rc = o, Rc;
}
var Dc, rk;
function eO() {
  if (rk) return Dc;
  rk = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return Dc = r, Dc;
}
var Pc, ik;
function Ea() {
  if (ik) return Pc;
  ik = 1;
  var e = Xo(), n = ZT(), r = eO(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return Pc = s, Pc;
}
var Ac, ak;
function Hi() {
  if (ak) return Ac;
  ak = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return Ac = e, Ac;
}
var Lc, ok;
function Jy() {
  if (ok) return Lc;
  ok = 1;
  var e = Ea(), n = Hi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return Lc = i, Lc;
}
var Vc, sk;
function nO() {
  if (sk) return Vc;
  sk = 1;
  var e = vi(), n = Jy(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return Vc = a, Vc;
}
var zc, lk;
function $a() {
  if (lk) return zc;
  lk = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return zc = e, zc;
}
var Uc, ck;
function NC() {
  if (ck) return Uc;
  ck = 1;
  var e = Ea(), n = $a(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return Uc = s, Uc;
}
var Mc, dk;
function tO() {
  if (dk) return Mc;
  dk = 1;
  var e = Gr(), n = e["__core-js_shared__"];
  return Mc = n, Mc;
}
var Bc, uk;
function rO() {
  if (uk) return Bc;
  uk = 1;
  var e = tO(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return Bc = r, Bc;
}
var qc, mk;
function jC() {
  if (mk) return qc;
  mk = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return qc = r, qc;
}
var Hc, pk;
function iO() {
  if (pk) return Hc;
  pk = 1;
  var e = NC(), n = rO(), r = $a(), i = jC(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return Hc = f, Hc;
}
var Wc, fk;
function aO() {
  if (fk) return Wc;
  fk = 1;
  function e(n, r) {
    return n?.[r];
  }
  return Wc = e, Wc;
}
var Kc, hk;
function Wi() {
  if (hk) return Kc;
  hk = 1;
  var e = iO(), n = aO();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return Kc = r, Kc;
}
var Gc, yk;
function Xl() {
  if (yk) return Gc;
  yk = 1;
  var e = Wi(), n = e(Object, "create");
  return Gc = n, Gc;
}
var Yc, gk;
function oO() {
  if (gk) return Yc;
  gk = 1;
  var e = Xl();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Yc = n, Yc;
}
var Jc, vk;
function sO() {
  if (vk) return Jc;
  vk = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return Jc = e, Jc;
}
var Qc, kk;
function lO() {
  if (kk) return Qc;
  kk = 1;
  var e = Xl(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return Qc = a, Qc;
}
var Xc, bk;
function cO() {
  if (bk) return Xc;
  bk = 1;
  var e = Xl(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return Xc = i, Xc;
}
var Zc, _k;
function dO() {
  if (_k) return Zc;
  _k = 1;
  var e = Xl(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return Zc = r, Zc;
}
var ed, xk;
function uO() {
  if (xk) return ed;
  xk = 1;
  var e = oO(), n = sO(), r = lO(), i = cO(), a = dO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ed = o, ed;
}
var nd, Sk;
function mO() {
  if (Sk) return nd;
  Sk = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return nd = e, nd;
}
var td, Nk;
function wC() {
  if (Nk) return td;
  Nk = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return td = e, td;
}
var rd, jk;
function Zl() {
  if (jk) return rd;
  jk = 1;
  var e = wC();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return rd = n, rd;
}
var id, wk;
function pO() {
  if (wk) return id;
  wk = 1;
  var e = Zl(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return id = i, id;
}
var ad, Ck;
function fO() {
  if (Ck) return ad;
  Ck = 1;
  var e = Zl();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return ad = n, ad;
}
var od, Fk;
function hO() {
  if (Fk) return od;
  Fk = 1;
  var e = Zl();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return od = n, od;
}
var sd, Ik;
function yO() {
  if (Ik) return sd;
  Ik = 1;
  var e = Zl();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return sd = n, sd;
}
var ld, Ek;
function ec() {
  if (Ek) return ld;
  Ek = 1;
  var e = mO(), n = pO(), r = fO(), i = hO(), a = yO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, ld = o, ld;
}
var cd, $k;
function Qy() {
  if ($k) return cd;
  $k = 1;
  var e = Wi(), n = Gr(), r = e(n, "Map");
  return cd = r, cd;
}
var dd, Tk;
function gO() {
  if (Tk) return dd;
  Tk = 1;
  var e = uO(), n = ec(), r = Qy();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return dd = i, dd;
}
var ud, Ok;
function vO() {
  if (Ok) return ud;
  Ok = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return ud = e, ud;
}
var md, Rk;
function nc() {
  if (Rk) return md;
  Rk = 1;
  var e = vO();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return md = n, md;
}
var pd, Dk;
function kO() {
  if (Dk) return pd;
  Dk = 1;
  var e = nc();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return pd = n, pd;
}
var fd, Pk;
function bO() {
  if (Pk) return fd;
  Pk = 1;
  var e = nc();
  function n(r) {
    return e(this, r).get(r);
  }
  return fd = n, fd;
}
var hd, Ak;
function _O() {
  if (Ak) return hd;
  Ak = 1;
  var e = nc();
  function n(r) {
    return e(this, r).has(r);
  }
  return hd = n, hd;
}
var yd, Lk;
function xO() {
  if (Lk) return yd;
  Lk = 1;
  var e = nc();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return yd = n, yd;
}
var gd, Vk;
function CC() {
  if (Vk) return gd;
  Vk = 1;
  var e = gO(), n = kO(), r = bO(), i = _O(), a = xO();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, gd = o, gd;
}
var vd, zk;
function SO() {
  if (zk) return vd;
  zk = 1;
  var e = CC(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, vd = r, vd;
}
var kd, Uk;
function NO() {
  if (Uk) return kd;
  Uk = 1;
  var e = SO(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return kd = r, kd;
}
var bd, Mk;
function jO() {
  if (Mk) return bd;
  Mk = 1;
  var e = NO(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return bd = i, bd;
}
var _d, Bk;
function FC() {
  if (Bk) return _d;
  Bk = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return _d = e, _d;
}
var xd, qk;
function wO() {
  if (qk) return xd;
  qk = 1;
  var e = Xo(), n = FC(), r = vi(), i = Jy(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return xd = s, xd;
}
var Sd, Hk;
function CO() {
  if (Hk) return Sd;
  Hk = 1;
  var e = wO();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return Sd = n, Sd;
}
var Nd, Wk;
function Ta() {
  if (Wk) return Nd;
  Wk = 1;
  var e = vi(), n = nO(), r = jO(), i = CO();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Nd = a, Nd;
}
var jd, Kk;
function tc() {
  if (Kk) return jd;
  Kk = 1;
  var e = Jy();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return jd = n, jd;
}
var wd, Gk;
function IC() {
  if (Gk) return wd;
  Gk = 1;
  var e = Ta(), n = tc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return wd = r, wd;
}
var Cd, Yk;
function EC() {
  if (Yk) return Cd;
  Yk = 1;
  var e = Wi(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Cd = n, Cd;
}
var Fd, Jk;
function $C() {
  if (Jk) return Fd;
  Jk = 1;
  var e = EC();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Fd = n, Fd;
}
var Id, Qk;
function Xy() {
  if (Qk) return Id;
  Qk = 1;
  var e = $C(), n = wC(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Id = a, Id;
}
var Ed, Xk;
function Zy() {
  if (Xk) return Ed;
  Xk = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Ed = r, Ed;
}
var $d, Zk;
function FO() {
  if (Zk) return $d;
  Zk = 1;
  var e = Xy(), n = Ta(), r = Zy(), i = $a(), a = tc();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var C = a(l[u]), N = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var j = k[C];
        N = m ? m(j, C, k) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(k, C, N), k = k[C];
    }
    return s;
  }
  return $d = o, $d;
}
var Td, eb;
function IO() {
  if (eb) return Td;
  eb = 1;
  var e = IC(), n = FO(), r = Ta();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Td = i, Td;
}
var Od, nb;
function EO() {
  if (nb) return Od;
  nb = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return Od = e, Od;
}
var Rd, tb;
function $O() {
  if (tb) return Rd;
  tb = 1;
  var e = Ea(), n = Hi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Rd = i, Rd;
}
var Dd, rb;
function eg() {
  if (rb) return Dd;
  rb = 1;
  var e = $O(), n = Hi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return Dd = o, Dd;
}
var Pd, ib;
function ng() {
  if (ib) return Pd;
  ib = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return Pd = n, Pd;
}
var Ad, ab;
function TO() {
  if (ab) return Ad;
  ab = 1;
  var e = Ta(), n = eg(), r = vi(), i = Zy(), a = ng(), o = tc();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return Ad = s, Ad;
}
var Ld, ob;
function OO() {
  if (ob) return Ld;
  ob = 1;
  var e = EO(), n = TO();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return Ld = r, Ld;
}
var Vd, sb;
function RO() {
  if (sb) return Vd;
  sb = 1;
  var e = IO(), n = OO();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return Vd = r, Vd;
}
var zd, lb;
function tg() {
  if (lb) return zd;
  lb = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return zd = e, zd;
}
var Ud, cb;
function DO() {
  if (cb) return Ud;
  cb = 1;
  var e = Xo(), n = eg(), r = vi(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return Ud = a, Ud;
}
var Md, db;
function PO() {
  if (db) return Md;
  db = 1;
  var e = tg(), n = DO();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return Md = r, Md;
}
var Bd, ub;
function AO() {
  if (ub) return Bd;
  ub = 1;
  var e = PO();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return Bd = n, Bd;
}
var qd, mb;
function LO() {
  if (mb) return qd;
  mb = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return qd = e, qd;
}
var Hd, pb;
function VO() {
  if (pb) return Hd;
  pb = 1;
  var e = LO(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return Hd = r, Hd;
}
var Wd, fb;
function zO() {
  if (fb) return Wd;
  fb = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return Wd = e, Wd;
}
var Kd, hb;
function TC() {
  if (hb) return Kd;
  hb = 1;
  function e(n) {
    return n;
  }
  return Kd = e, Kd;
}
var Gd, yb;
function UO() {
  if (yb) return Gd;
  yb = 1;
  var e = zO(), n = EC(), r = TC(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return Gd = i, Gd;
}
var Yd, gb;
function MO() {
  if (gb) return Yd;
  gb = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return Yd = i, Yd;
}
var Jd, vb;
function BO() {
  if (vb) return Jd;
  vb = 1;
  var e = UO(), n = MO(), r = n(e);
  return Jd = r, Jd;
}
var Qd, kb;
function OC() {
  if (kb) return Qd;
  kb = 1;
  var e = AO(), n = VO(), r = BO();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return Qd = i, Qd;
}
var Xd, bb;
function qO() {
  if (bb) return Xd;
  bb = 1;
  var e = RO(), n = OC(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return Xd = r, Xd;
}
var HO = qO();
const RC = /* @__PURE__ */ xC(HO), WO = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function DC(e) {
  const n = RC(e, WO);
  return {
    controller: Ky(n),
    controllerProps: n
  };
}
const KO = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function PC(e) {
  const { controller: n, controllerProps: r } = DC(e), i = {
    ...RC(e, KO),
    required: XT(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var Zd, _b;
function GO() {
  if (_b) return Zd;
  _b = 1;
  var e = ec();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return Zd = n, Zd;
}
var eu, xb;
function YO() {
  if (xb) return eu;
  xb = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return eu = e, eu;
}
var nu, Sb;
function JO() {
  if (Sb) return nu;
  Sb = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return nu = e, nu;
}
var tu, Nb;
function QO() {
  if (Nb) return tu;
  Nb = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return tu = e, tu;
}
var ru, jb;
function XO() {
  if (jb) return ru;
  jb = 1;
  var e = ec(), n = Qy(), r = CC(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return ru = a, ru;
}
var iu, wb;
function ZO() {
  if (wb) return iu;
  wb = 1;
  var e = ec(), n = GO(), r = YO(), i = JO(), a = QO(), o = XO();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, iu = s, iu;
}
var au, Cb;
function eR() {
  if (Cb) return au;
  Cb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return au = e, au;
}
var ou, Fb;
function Zo() {
  if (Fb) return ou;
  Fb = 1;
  var e = Xy(), n = $C();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return ou = r, ou;
}
var su, Ib;
function nR() {
  if (Ib) return su;
  Ib = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return su = e, su;
}
var el = { exports: {} }, lu, Eb;
function tR() {
  if (Eb) return lu;
  Eb = 1;
  function e() {
    return !1;
  }
  return lu = e, lu;
}
el.exports;
var $b;
function AC() {
  return $b || ($b = 1, (function(e, n) {
    var r = Gr(), i = tR(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(el, el.exports)), el.exports;
}
var cu, Tb;
function rR() {
  if (Tb) return cu;
  Tb = 1;
  var e = Ea(), n = ng(), r = Hi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", C = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", D = "[object Float64Array]", O = "[object Int8Array]", I = "[object Int16Array]", F = "[object Int32Array]", L = "[object Uint8Array]", K = "[object Uint8ClampedArray]", J = "[object Uint16Array]", te = "[object Uint32Array]", W = {};
  W[g] = W[D] = W[O] = W[I] = W[F] = W[L] = W[K] = W[J] = W[te] = !0, W[i] = W[a] = W[j] = W[o] = W[_] = W[s] = W[l] = W[d] = W[m] = W[u] = W[f] = W[h] = W[k] = W[C] = W[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!W[e(P)];
  }
  return cu = Y, cu;
}
var du, Ob;
function rg() {
  if (Ob) return du;
  Ob = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return du = e, du;
}
var nl = { exports: {} };
nl.exports;
var Rb;
function ig() {
  return Rb || (Rb = 1, (function(e, n) {
    var r = SC(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(nl, nl.exports)), nl.exports;
}
var uu, Db;
function iR() {
  if (Db) return uu;
  Db = 1;
  var e = rR(), n = rg(), r = ig(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return uu = a, uu;
}
var mu, Pb;
function LC() {
  if (Pb) return mu;
  Pb = 1;
  var e = nR(), n = eg(), r = vi(), i = AC(), a = Zy(), o = iR(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), C = !f && !h && !k && o(m), N = f || h || k || C, j = N ? e(m.length, String) : [], _ = j.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return mu = d, mu;
}
var pu, Ab;
function ag() {
  if (Ab) return pu;
  Ab = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return pu = n, pu;
}
var fu, Lb;
function VC() {
  if (Lb) return fu;
  Lb = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return fu = e, fu;
}
var hu, Vb;
function aR() {
  if (Vb) return hu;
  Vb = 1;
  var e = VC(), n = e(Object.keys, Object);
  return hu = n, hu;
}
var yu, zb;
function oR() {
  if (zb) return yu;
  zb = 1;
  var e = ag(), n = aR(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return yu = a, yu;
}
var gu, Ub;
function zC() {
  if (Ub) return gu;
  Ub = 1;
  var e = NC(), n = ng();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return gu = r, gu;
}
var vu, Mb;
function og() {
  if (Mb) return vu;
  Mb = 1;
  var e = LC(), n = oR(), r = zC();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return vu = i, vu;
}
var ku, Bb;
function sR() {
  if (Bb) return ku;
  Bb = 1;
  var e = Zo(), n = og();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return ku = r, ku;
}
var bu, qb;
function lR() {
  if (qb) return bu;
  qb = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return bu = e, bu;
}
var _u, Hb;
function cR() {
  if (Hb) return _u;
  Hb = 1;
  var e = $a(), n = ag(), r = lR(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return _u = o, _u;
}
var xu, Wb;
function sg() {
  if (Wb) return xu;
  Wb = 1;
  var e = LC(), n = cR(), r = zC();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return xu = i, xu;
}
var Su, Kb;
function dR() {
  if (Kb) return Su;
  Kb = 1;
  var e = Zo(), n = sg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Su = r, Su;
}
var tl = { exports: {} };
tl.exports;
var Gb;
function uR() {
  return Gb || (Gb = 1, (function(e, n) {
    var r = Gr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(tl, tl.exports)), tl.exports;
}
var Nu, Yb;
function mR() {
  if (Yb) return Nu;
  Yb = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Nu = e, Nu;
}
var ju, Jb;
function pR() {
  if (Jb) return ju;
  Jb = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return ju = e, ju;
}
var wu, Qb;
function UC() {
  if (Qb) return wu;
  Qb = 1;
  function e() {
    return [];
  }
  return wu = e, wu;
}
var Cu, Xb;
function lg() {
  if (Xb) return Cu;
  Xb = 1;
  var e = pR(), n = UC(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Cu = o, Cu;
}
var Fu, Zb;
function fR() {
  if (Zb) return Fu;
  Zb = 1;
  var e = Zo(), n = lg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Fu = r, Fu;
}
var Iu, e_;
function cg() {
  if (e_) return Iu;
  e_ = 1;
  var e = VC(), n = e(Object.getPrototypeOf, Object);
  return Iu = n, Iu;
}
var Eu, n_;
function MC() {
  if (n_) return Eu;
  n_ = 1;
  var e = tg(), n = cg(), r = lg(), i = UC(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Eu = o, Eu;
}
var $u, t_;
function hR() {
  if (t_) return $u;
  t_ = 1;
  var e = Zo(), n = MC();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return $u = r, $u;
}
var Tu, r_;
function BC() {
  if (r_) return Tu;
  r_ = 1;
  var e = tg(), n = vi();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return Tu = r, Tu;
}
var Ou, i_;
function yR() {
  if (i_) return Ou;
  i_ = 1;
  var e = BC(), n = lg(), r = og();
  function i(a) {
    return e(a, r, n);
  }
  return Ou = i, Ou;
}
var Ru, a_;
function qC() {
  if (a_) return Ru;
  a_ = 1;
  var e = BC(), n = MC(), r = sg();
  function i(a) {
    return e(a, r, n);
  }
  return Ru = i, Ru;
}
var Du, o_;
function gR() {
  if (o_) return Du;
  o_ = 1;
  var e = Wi(), n = Gr(), r = e(n, "DataView");
  return Du = r, Du;
}
var Pu, s_;
function vR() {
  if (s_) return Pu;
  s_ = 1;
  var e = Wi(), n = Gr(), r = e(n, "Promise");
  return Pu = r, Pu;
}
var Au, l_;
function kR() {
  if (l_) return Au;
  l_ = 1;
  var e = Wi(), n = Gr(), r = e(n, "Set");
  return Au = r, Au;
}
var Lu, c_;
function bR() {
  if (c_) return Lu;
  c_ = 1;
  var e = Wi(), n = Gr(), r = e(n, "WeakMap");
  return Lu = r, Lu;
}
var Vu, d_;
function dg() {
  if (d_) return Vu;
  d_ = 1;
  var e = gR(), n = Qy(), r = vR(), i = kR(), a = bR(), o = Ea(), s = jC(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), C = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(D) {
    var O = o(D), I = O == d ? D.constructor : void 0, F = I ? s(I) : "";
    if (F)
      switch (F) {
        case k:
          return h;
        case C:
          return l;
        case N:
          return m;
        case j:
          return u;
        case _:
          return f;
      }
    return O;
  }), Vu = g, Vu;
}
var zu, u_;
function _R() {
  if (u_) return zu;
  u_ = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return zu = r, zu;
}
var Uu, m_;
function xR() {
  if (m_) return Uu;
  m_ = 1;
  var e = Gr(), n = e.Uint8Array;
  return Uu = n, Uu;
}
var Mu, p_;
function ug() {
  if (p_) return Mu;
  p_ = 1;
  var e = xR();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return Mu = n, Mu;
}
var Bu, f_;
function SR() {
  if (f_) return Bu;
  f_ = 1;
  var e = ug();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return Bu = n, Bu;
}
var qu, h_;
function NR() {
  if (h_) return qu;
  h_ = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return qu = n, qu;
}
var Hu, y_;
function jR() {
  if (y_) return Hu;
  y_ = 1;
  var e = Xo(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return Hu = i, Hu;
}
var Wu, g_;
function wR() {
  if (g_) return Wu;
  g_ = 1;
  var e = ug();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return Wu = n, Wu;
}
var Ku, v_;
function CR() {
  if (v_) return Ku;
  v_ = 1;
  var e = ug(), n = SR(), r = NR(), i = jR(), a = wR(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", C = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", D = "[object Int32Array]", O = "[object Uint8Array]", I = "[object Uint8ClampedArray]", F = "[object Uint16Array]", L = "[object Uint32Array]";
  function K(J, te, W) {
    var Y = J.constructor;
    switch (te) {
      case k:
        return e(J);
      case o:
      case s:
        return new Y(+J);
      case C:
        return n(J, W);
      case N:
      case j:
      case _:
      case g:
      case D:
      case O:
      case I:
      case F:
      case L:
        return a(J, W);
      case l:
        return new Y();
      case d:
      case f:
        return new Y(J);
      case m:
        return r(J);
      case u:
        return new Y();
      case h:
        return i(J);
    }
  }
  return Ku = K, Ku;
}
var Gu, k_;
function FR() {
  if (k_) return Gu;
  k_ = 1;
  var e = $a(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return Gu = r, Gu;
}
var Yu, b_;
function IR() {
  if (b_) return Yu;
  b_ = 1;
  var e = FR(), n = cg(), r = ag();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return Yu = i, Yu;
}
var Ju, __;
function ER() {
  if (__) return Ju;
  __ = 1;
  var e = dg(), n = Hi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Ju = i, Ju;
}
var Qu, x_;
function $R() {
  if (x_) return Qu;
  x_ = 1;
  var e = ER(), n = rg(), r = ig(), i = r && r.isMap, a = i ? n(i) : e;
  return Qu = a, Qu;
}
var Xu, S_;
function TR() {
  if (S_) return Xu;
  S_ = 1;
  var e = dg(), n = Hi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return Xu = i, Xu;
}
var Zu, N_;
function OR() {
  if (N_) return Zu;
  N_ = 1;
  var e = TR(), n = rg(), r = ig(), i = r && r.isSet, a = i ? n(i) : e;
  return Zu = a, Zu;
}
var em, j_;
function RR() {
  if (j_) return em;
  j_ = 1;
  var e = ZO(), n = eR(), r = Xy(), i = sR(), a = dR(), o = uR(), s = mR(), l = fR(), d = hR(), m = yR(), u = qC(), f = dg(), h = _R(), k = CR(), C = IR(), N = vi(), j = AC(), _ = $R(), g = $a(), D = OR(), O = og(), I = sg(), F = 1, L = 2, K = 4, J = "[object Arguments]", te = "[object Array]", W = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", re = "[object GeneratorFunction]", je = "[object Map]", ue = "[object Number]", se = "[object Object]", he = "[object RegExp]", V = "[object Set]", ke = "[object String]", De = "[object Symbol]", q = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", $e = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", oe = {};
  oe[J] = oe[te] = oe[Ge] = oe[sn] = oe[W] = oe[Y] = oe[Ie] = oe[Ue] = oe[Re] = oe[Be] = oe[Ae] = oe[je] = oe[ue] = oe[se] = oe[he] = oe[V] = oe[ke] = oe[De] = oe[Je] = oe[$e] = oe[Me] = oe[en] = !0, oe[P] = oe[B] = oe[q] = !1;
  function le(xe, Ve, Pe, vn, Q, E) {
    var z, ie = Ve & F, ce = Ve & L, U = Ve & K;
    if (Pe && (z = Q ? Pe(xe, vn, Q, E) : Pe(xe)), z !== void 0)
      return z;
    if (!g(xe))
      return xe;
    var G = N(xe);
    if (G) {
      if (z = h(xe), !ie)
        return s(xe, z);
    } else {
      var ye = f(xe), Ne = ye == B || ye == re;
      if (j(xe))
        return o(xe, ie);
      if (ye == se || ye == J || Ne && !Q) {
        if (z = ce || Ne ? {} : C(xe), !ie)
          return ce ? d(xe, a(z, xe)) : l(xe, i(z, xe));
      } else {
        if (!oe[ye])
          return Q ? xe : {};
        z = k(xe, ye, ie);
      }
    }
    E || (E = new e());
    var Oe = E.get(xe);
    if (Oe)
      return Oe;
    E.set(xe, z), D(xe) ? xe.forEach(function(an) {
      z.add(le(an, Ve, Pe, an, xe, E));
    }) : _(xe) && xe.forEach(function(an, pn) {
      z.set(pn, le(an, Ve, Pe, pn, xe, E));
    });
    var rn = U ? ce ? u : m : ce ? I : O, kn = G ? void 0 : rn(xe);
    return n(kn || xe, function(an, pn) {
      kn && (pn = an, an = xe[pn]), r(z, pn, le(an, Ve, Pe, pn, xe, E));
    }), z;
  }
  return em = le, em;
}
var nm, w_;
function DR() {
  if (w_) return nm;
  w_ = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return nm = e, nm;
}
var tm, C_;
function PR() {
  if (C_) return tm;
  C_ = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return tm = e, tm;
}
var rm, F_;
function AR() {
  if (F_) return rm;
  F_ = 1;
  var e = IC(), n = PR();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return rm = r, rm;
}
var im, I_;
function LR() {
  if (I_) return im;
  I_ = 1;
  var e = Ta(), n = DR(), r = AR(), i = tc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return im = s, im;
}
var am, E_;
function VR() {
  if (E_) return am;
  E_ = 1;
  var e = Ea(), n = cg(), r = Hi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return am = m, am;
}
var om, $_;
function zR() {
  if ($_) return om;
  $_ = 1;
  var e = VR();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return om = n, om;
}
var sm, T_;
function UR() {
  if (T_) return sm;
  T_ = 1;
  var e = FC(), n = RR(), r = LR(), i = Ta(), a = Zo(), o = zR(), s = OC(), l = qC(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var C = {};
    if (h == null)
      return C;
    var N = !1;
    k = e(k, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), C), N && (C = n(C, d | m | u, o));
    for (var j = k.length; j--; )
      r(C, k[j]);
    return C;
  });
  return sm = f, sm;
}
UR();
const xr = ({
  children: e,
  ...n
}) => {
  const { controller: r, controllerProps: i, fieldWrapperProps: a } = PC(n), {
    name: o,
    onBlur: s,
    onChange: l,
    ...d
  } = r.field;
  return /* @__PURE__ */ Li.jsx(We, { ...a, children: /* @__PURE__ */ Li.jsx(
    mi,
    {
      ...n.componentProps,
      ...d,
      multiple: !1,
      value: d.value ? [d.value] : [],
      onBlur: (m) => {
        n.componentProps?.onBlur?.(m), s();
      },
      onChange: (m) => {
        n.componentProps?.onChange?.(m), l(m.selectedValues[0] ?? null);
      },
      id: i.name,
      "aria-disabled": a.disabled,
      disabled: a.disabled,
      "aria-required": a.required,
      required: a.required,
      status: We.getStatus(a.meta),
      children: e
    }
  ) });
};
var MR = TC();
const BR = /* @__PURE__ */ xC(MR), bn = ({
  transformValue: e = BR,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = DC(a);
  return /* @__PURE__ */ Li.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Li.jsx(
      Ao,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Li.jsx(xw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, Pn = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = PC(e);
  return /* @__PURE__ */ Li.jsx(We, { ...i, children: /* @__PURE__ */ Li.jsx(
    dr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: We.getStatus(i.meta)
    }
  ) });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_10dvk_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_10dvk_59{padding:0;max-height:250px;overflow-y:auto;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_10dvk_69{background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_10dvk_69:last-child:not(:only-child){border-bottom:none}._collapsible_10dvk_78{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._collapsible_10dvk_78:hover,._collapsibleIsOpen_10dvk_86{border-color:var(--dixa-color-neutral-400)}._collapsibleHeader_10dvk_89{cursor:pointer}._collapsibleIconTrue_10dvk_92{color:var(--dixa-color-green-500)}._collapsibleIconFalse_10dvk_95{color:var(--dixa-color-red-500)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var lm = { exports: {} }, Wa = {}, O_;
function qR() {
  if (O_) return Wa;
  O_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Wa.Fragment = r, Wa.jsx = s, Wa.jsxs = s, Wa;
}
var ps = {}, R_;
function HR() {
  return R_ || (R_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    ps.Fragment = i, ps.jsx = zn, ps.jsxs = Wn;
  })()), ps;
}
var D_;
function WR() {
  return D_ || (D_ = 1, process.env.NODE_ENV === "production" ? lm.exports = qR() : lm.exports = HR()), lm.exports;
}
var ee = WR();
const KR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "exportUserDetails" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_exportUserDetails_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_ExportedUserDetails" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "users" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "braze_id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "dob" } }, { kind: "Field", name: { kind: "Name", value: "home_city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "language" } }, { kind: "Field", name: { kind: "Name", value: "time_zone" } }, { kind: "Field", name: { kind: "Name", value: "total_revenue" } }, { kind: "Field", name: { kind: "Name", value: "push_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "email_subscribe" } }, { kind: "Field", name: { kind: "Name", value: "custom_attributes" } }, { kind: "Field", name: { kind: "Name", value: "apps" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "platform" } }, { kind: "Field", name: { kind: "Name", value: "version" } }, { kind: "Field", name: { kind: "Name", value: "sessions" } }, { kind: "Field", name: { kind: "Name", value: "first_used" } }, { kind: "Field", name: { kind: "Name", value: "last_used" } }] } }, { kind: "Field", name: { kind: "Name", value: "devices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "model" } }, { kind: "Field", name: { kind: "Name", value: "os" } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "idfv" } }, { kind: "Field", name: { kind: "Name", value: "idfa" } }, { kind: "Field", name: { kind: "Name", value: "google_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "roku_ad_id" } }, { kind: "Field", name: { kind: "Name", value: "ad_tracking_enabled" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_events" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }, { kind: "Field", name: { kind: "Name", value: "purchases" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first" } }, { kind: "Field", name: { kind: "Name", value: "last" } }, { kind: "Field", name: { kind: "Name", value: "count" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Braze_BasicResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] } }] }, GR = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Braze_updateEmailSubscriptionStatus_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Braze" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateEmailSubscriptionStatus" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] }, YR = {
  "\n  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {\n    Braze {\n      exportUserDetails(input: $input) {\n        ... on Braze_exportUserDetails_response {\n          ... on Braze_ExportedUserDetails {\n            message\n            users {\n              external_id\n              braze_id\n              created_at\n              email\n              first_name\n              last_name\n              dob\n              home_city\n              country\n              phone\n              language\n              time_zone\n              total_revenue\n              push_subscribe\n              email_subscribe\n              custom_attributes\n              apps {\n                name\n                platform\n                version\n                sessions\n                first_used\n                last_used\n              }\n              devices {\n                model\n                os\n                carrier\n                idfv\n                idfa\n                google_ad_id\n                roku_ad_id\n                ad_tracking_enabled\n              }\n              custom_events {\n                name\n                first\n                last\n                count\n              }\n              purchases {\n                name\n                first\n                last\n                count\n              }\n            }\n          }\n\n          ... on Braze_BasicResponse {\n            message\n          }\n        }\n      }\n    }\n  }\n": KR,
  "\n  mutation updateEmailSubscriptionStatus(\n    $input: Braze_updateEmailSubscriptionStatus_request_Input!\n  ) {\n    Braze {\n      updateEmailSubscriptionStatus(input: $input) {\n        message\n      }\n    }\n  }\n": GR
};
function HC(e) {
  return YR[e] ?? {};
}
const JR = HC(
  /* GraphQL */
  `
  mutation getCustomerDetails($input: Braze_exportUserDetails_request_Input!) {
    Braze {
      exportUserDetails(input: $input) {
        ... on Braze_exportUserDetails_response {
          ... on Braze_ExportedUserDetails {
            message
            users {
              external_id
              braze_id
              created_at
              email
              first_name
              last_name
              dob
              home_city
              country
              phone
              language
              time_zone
              total_revenue
              push_subscribe
              email_subscribe
              custom_attributes
              apps {
                name
                platform
                version
                sessions
                first_used
                last_used
              }
              devices {
                model
                os
                carrier
                idfv
                idfa
                google_ad_id
                roku_ad_id
                ad_tracking_enabled
              }
              custom_events {
                name
                first
                last
                count
              }
              purchases {
                name
                first
                last
                count
              }
            }
          }

          ... on Braze_BasicResponse {
            message
          }
        }
      }
    }
  }
`
), QR = HC(
  /* GraphQL */
  `
  mutation updateEmailSubscriptionStatus(
    $input: Braze_updateEmailSubscriptionStatus_request_Input!
  ) {
    Braze {
      updateEmailSubscriptionStatus(input: $input) {
        message
      }
    }
  }
`
), XR = "_copyIcon_10dvk_54", ZR = "_list_10dvk_59", eD = "_listItem_10dvk_69", nD = "_collapsible_10dvk_78", tD = "_collapsibleIsOpen_10dvk_86", rD = "_collapsibleHeader_10dvk_89", iD = "_collapsibleIconTrue_10dvk_92", aD = "_collapsibleIconFalse_10dvk_95", Un = {
  copyIcon: XR,
  list: ZR,
  listItem: eD,
  collapsible: nD,
  collapsibleIsOpen: tD,
  collapsibleHeader: rD,
  collapsibleIconTrue: iD,
  collapsibleIconFalse: aD
}, oD = ({
  app: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    name: a,
    platform: o,
    version: s,
    sessions: l,
    first_used: d,
    last_used: m
  } = e;
  return /* @__PURE__ */ ee.jsxs(
    b,
    {
      className: dt(Un.collapsible, {
        [Un.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Un.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "1", children: a }),
              /* @__PURE__ */ ee.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ee.jsxs(Ye, { className: Un.list, children: [
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Platform" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Version" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Sessions" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "First used" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: Gn(d).format(jt) })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Last used" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: Gn(m).format(jt) })
          ] }) })
        ] })
      ]
    }
  );
}, sD = ({ apps: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Apps" }),
      n && /* @__PURE__ */ ee.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no apps associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ee.jsx(oD, { app: r, openByDefault: i === 0 }, i))
  ] });
}, lD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_attributes: n } = e, r = !!n && Object.keys(n).length > 0;
  return /* @__PURE__ */ ee.jsx(ee.Fragment, { children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Custom attributes" }),
    !r && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom attributes available" }),
    r && /* @__PURE__ */ ee.jsx(Ye, { className: Un.list, children: Object.entries(
      n
    ).map(([i, a], o) => (typeof a == "boolean" || typeof a == "string" || typeof a == "number") && /* @__PURE__ */ ee.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: i }),
          Mi(a)
        ] })
      },
      o
    )) })
  ] }) });
}, cD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { custom_events: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ee.jsx(ee.Fragment, { children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Custom events" }),
    !i && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom events available" }),
    i && /* @__PURE__ */ ee.jsx(Ye, { className: Un.list, children: r.map((a, o) => /* @__PURE__ */ ee.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ee.jsx(
            Xe,
            {
              content: /* @__PURE__ */ ee.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ee.jsx(b, { children: `First ${Gn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ ee.jsx(b, { children: `Last ${Gn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, gl = ({
  state: e,
  noTooltip: n = !1,
  isPush: r = !1
}) => {
  if (!e) return null;
  const i = e === "subscribed", a = e === "unsubscribed", o = () => i ? "exclamation" : a ? "close-circle-filled" : "check-circle-filled", s = () => i ? "neutral.500" : a ? "red.500" : "green.500", l = () => {
    const d = r ? "push notifications" : "emails";
    return i ? `Default case "subscribed": The user has neither unsubscribed nor explicitly opted-in to receive ${d}. This is the default subscription state when a user profile is created.` : a ? `Unsubscribed: The user has explicitly unsubscribed from receiving ${d}.` : `Opted in: The user has explicitly confirmed they want to receive ${d}.`;
  };
  return /* @__PURE__ */ ee.jsx(Xe, { content: n ? null : l(), children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(ve, { size: 14, name: o(), color: s() }) }) });
}, dD = "_wrapper_1xucg_1", uD = "_externalLink_1xucg_7", cm = {
  wrapper: dD,
  externalLink: uD
}, mD = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt(), { isCopied: o, copy: s } = Jt(), { isCopied: l, copy: d } = Jt(), { isCopied: m, copy: u } = Jt();
  if (!e)
    return null;
  const {
    external_id: f,
    braze_id: h,
    first_name: k,
    last_name: C,
    home_city: N,
    country: j,
    email: _,
    phone: g,
    dob: D,
    created_at: O,
    email_subscribe: I,
    push_subscribe: F
  } = e, L = 14, K = `${k || ""} ${C || ""}`.trim() || "A customer has no name", J = `${N ? `${N} /` : ""} ${j || ""}`.trim(), te = D ? Gn(D).isSame(Date.now(), "day") : !1;
  return /* @__PURE__ */ ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ee.jsxs(b, { className: cm.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: cm.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-2", children: K }),
          te && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    O && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: Gn(O).format(jt) })
    ] }),
    J && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "map-pin" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: J })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy location", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        ve,
        {
          size: L,
          name: o ? "done" : "copy",
          onClick: () => s(J),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    _ && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "mail" }),
        /* @__PURE__ */ ee.jsx("span", { className: cm.externalLink, children: _ })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        ve,
        {
          size: L,
          name: n ? "done" : "copy",
          onClick: () => r(_),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    g && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "phone" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: g })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        ve,
        {
          size: L,
          name: i ? "done" : "copy",
          onClick: () => a(g),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    h && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "user" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Braze ID" }),
        /* @__PURE__ */ ee.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          h,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy Braze ID", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        ve,
        {
          size: L,
          name: l ? "done" : "copy",
          onClick: () => d(h),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    f && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "tag" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "External ID" }),
        /* @__PURE__ */ ee.jsxs($.Paragraph, { variant: "5", subdued: !0, color: "tertiary", children: [
          "(",
          f,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ ee.jsx(Xe, { content: "Copy External ID", children: /* @__PURE__ */ ee.jsx(b, { alignItems: "center", children: /* @__PURE__ */ ee.jsx(
        ve,
        {
          size: L,
          name: m ? "done" : "copy",
          onClick: () => u(f),
          className: Un.copyIcon
        }
      ) }) })
    ] }),
    I && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "sync" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ee.jsx(gl, { state: I })
    ] }),
    F && /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: L, name: "bell" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Push notification subscription state" })
      ] }),
      /* @__PURE__ */ ee.jsx(gl, { isPush: !0, state: F })
    ] })
  ] }) });
}, pD = ({
  device: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const a = 14, {
    model: o,
    os: s,
    carrier: l,
    ad_tracking_enabled: d,
    idfa: m,
    idfv: u,
    google_ad_id: f,
    roku_ad_id: h
  } = e;
  return /* @__PURE__ */ ee.jsxs(
    b,
    {
      className: dt(Un.collapsible, {
        [Un.collapsibleIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ ee.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Un.collapsibleHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "1", children: o }),
              /* @__PURE__ */ ee.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ ee.jsxs(Ye, { className: Un.list, children: [
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "OS" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: s })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Carrier" }),
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: l })
          ] }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", justifyContent: "space-between", width: "100%", children: [
            /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Ad tracking enabled" }),
            /* @__PURE__ */ ee.jsx(
              ve,
              {
                size: a,
                className: dt({
                  [Un.collapsibleIconTrue]: d,
                  [Un.collapsibleIconFalse]: !d
                }),
                name: d ? "check-circle-filled" : "close-circle-filled"
              }
            )
          ] }) }),
          /* @__PURE__ */ ee.jsx(Xe, { content: "The Apple Identifier for Vendor (iOS)", children: /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Braze device identifier" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: u })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Xe, { content: "For iOS", children: /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Identifier for Advertising" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: m })
              ]
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Roku Advertising id" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(
            b,
            {
              gap: "200",
              justifyContent: "space-between",
              width: "100%",
              flexWrap: "wrap",
              children: [
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "3", children: "Google Play Advertising id" }),
                /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", color: "secondary", children: f })
              ]
            }
          ) })
        ] })
      ]
    }
  );
}, fD = ({ devices: e }) => {
  const n = e && e?.length > 0;
  return /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 0", children: [
    /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Devices" }),
      n && /* @__PURE__ */ ee.jsx(Mn, { size: "small", variant: "success", children: e.length })
    ] }),
    !n && /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        variant: "4",
        margin: "200 0 300 0",
        color: "secondary",
        align: "center",
        children: "There are no devices associated with this customer"
      }
    ),
    e?.map((r, i) => /* @__PURE__ */ ee.jsx(pD, { device: r, openByDefault: i === 0 }, i))
  ] });
}, Ka = {
  optIn: {
    label: "Opt in",
    icon: "check-circle-filled",
    color: "var(--dixa-color-green-500)",
    tooltipContent: "Opt in to receive emails",
    parameter: "opted_in"
  },
  unsubscribe: {
    label: "Unsubscribe",
    icon: "close-circle-filled",
    color: "var(--dixa-color-red-500)",
    tooltipContent: "Unsubscribe from emails",
    parameter: "unsubscribed"
  }
}, fs = ({
  email: e,
  updateTo: n,
  refetchCustomerDetails: r
}) => {
  const { track: i } = Cn(), { useMutation: a } = hn(), [o, s] = me(!1), [l] = a(
    QR,
    {
      onCompleted: (m) => {
        m?.Braze?.updateEmailSubscriptionStatus?.message === "success" && i(n === "optIn" ? "braze:email:subscription:opt-in:succeeded" : "braze:email:subscription:unsubscribe:succeeded");
      }
    }
  ), d = async () => {
    s(!0), await l({
      variables: {
        input: {
          email: e,
          // eslint-disable-next-line camelcase
          subscription_state: Ka[n].parameter
        }
      }
    }), setTimeout(async () => {
      await r().finally(() => s(!1));
    }, 500);
  };
  return /* @__PURE__ */ ee.jsx(Xe, { content: Ka[n].tooltipContent, children: /* @__PURE__ */ ee.jsx(
    ct,
    {
      variant: "secondary",
      color: Ka[n].color,
      isLoading: o,
      onClick: () => d(),
      "data-testid": "braze-subscription-button",
      children: /* @__PURE__ */ ee.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(
          gl,
          {
            noTooltip: !0,
            state: Ka[n].parameter
          }
        ),
        Ka[n].label
      ] })
    }
  ) });
}, hD = ({
  customerDetails: e,
  showCustomerDetails: n,
  refetchCustomerDetails: r
}) => {
  if (!e)
    return null;
  const { email: i, email_subscribe: a } = e;
  if (!i)
    return null;
  const o = a === "subscribed", s = a === "unsubscribed", l = a === "opted_in";
  return /* @__PURE__ */ ee.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Update Email subscription state" }),
    !n && /* @__PURE__ */ ee.jsx(Ye, { className: Un.list, children: /* @__PURE__ */ ee.jsx(Ye.Text, { variant: "dense", className: Un.listItem, children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ ee.jsx(ve, { size: 14, name: "sync" }),
        /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: "Email subscription state" })
      ] }),
      /* @__PURE__ */ ee.jsx(gl, { state: a })
    ] }) }) }),
    /* @__PURE__ */ ee.jsxs(b, { gap: "200", alignItems: "center", children: [
      o && /* @__PURE__ */ ee.jsxs(ee.Fragment, { children: [
        /* @__PURE__ */ ee.jsx(
          fs,
          {
            email: i,
            updateTo: "optIn",
            refetchCustomerDetails: r
          }
        ),
        /* @__PURE__ */ ee.jsx(
          fs,
          {
            email: i,
            updateTo: "unsubscribe",
            refetchCustomerDetails: r
          }
        )
      ] }),
      s && /* @__PURE__ */ ee.jsx(
        fs,
        {
          email: i,
          updateTo: "optIn",
          refetchCustomerDetails: r
        }
      ),
      l && /* @__PURE__ */ ee.jsx(
        fs,
        {
          email: i,
          updateTo: "unsubscribe",
          refetchCustomerDetails: r
        }
      )
    ] })
  ] }) });
}, yD = ({
  customerDetails: e
}) => {
  if (!e)
    return null;
  const { purchases: n } = e, r = n?.sort(
    (a, o) => o?.count - a?.count
  ), i = r && r.length > 0;
  return /* @__PURE__ */ ee.jsx(ee.Fragment, { children: /* @__PURE__ */ ee.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ee.jsx($.Heading, { variant: "heading-3", children: "Purchases" }),
    !i && /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No purchases available" }),
    i && /* @__PURE__ */ ee.jsx(Ye, { className: Un.list, children: r.map((a, o) => /* @__PURE__ */ ee.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: Un.listItem,
        children: /* @__PURE__ */ ee.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ ee.jsx(
            Xe,
            {
              content: /* @__PURE__ */ ee.jsxs(b, { flexDirection: "column", children: [
                /* @__PURE__ */ ee.jsx(b, { children: `First ${Gn(a?.first).format(
                  jt
                )}` }),
                /* @__PURE__ */ ee.jsx(b, { children: `Last ${Gn(a?.last).format(
                  jt
                )}` })
              ] }),
              children: /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "4", children: a?.name })
            }
          ),
          /* @__PURE__ */ ee.jsx($.Paragraph, { variant: "5", children: a?.count })
        ] })
      },
      o
    )) })
  ] }) });
}, gD = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Cn(), { useMutation: i } = hn(), [a, o] = me(), [s, l] = me(!1), [d, m] = me(!1), u = e?.customer?.email, f = e?.customer?.phone_number, h = n.displayCustomerDetails ?? !1, k = n.updateEmailSubscriptionState ?? !1, C = n.displayCustomAttributes ?? !1, N = n.displayCustomEvents ?? !1, j = n.displayPuchases ?? !1, _ = n.displayDevices ?? !1, g = n.displayApps ?? !1, D = !h && !k && !C && !N && !j, [O, { error: I }] = i(
    JR,
    {
      onError: () => {
      },
      onCompleted: (L) => {
        const K = L?.Braze?.exportUserDetails?.users?.[0];
        K ? (o(K), l(!1), r("braze:profile:received")) : (o(void 0), l(!0));
      }
    }
  ), F = async () => {
    u || f ? await O({
      variables: {
        input: {
          // Use the email if exists. Otherwise use the phone number. We decided
          // to not search for both together, because we receive a customer
          // entity for each input parameter and we only want one.
          /* eslint-disable camelcase */
          ...u ? { email_address: u } : { phone: f },
          fields_to_export: [
            "external_id",
            "braze_id",
            "created_at",
            "email",
            "first_name",
            "last_name",
            "dob",
            "home_city",
            "country",
            "phone",
            "language",
            "time_zone",
            "total_revenue",
            "push_subscribe",
            "email_subscribe",
            "custom_attributes",
            "custom_events",
            "purchases",
            "apps",
            "devices"
          ]
          /* eslint-enable camelcase */
        }
      }
    }) : l(!0);
  };
  if (Qe(() => {
    async function L() {
      m(!0), await F();
    }
    L().finally(() => m(!1));
  }, [u, f]), I) {
    const L = I.graphQLErrors;
    return zl({ errors: L }) ? /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API key used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: L }) ? /* @__PURE__ */ ee.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Braze. Please contact your administrator."
      }
    ) : /* @__PURE__ */ ee.jsx(En, { error: I });
  }
  return d ? /* @__PURE__ */ ee.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ ee.jsx(fn, {}) }) : D ? /* @__PURE__ */ ee.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : s ? /* @__PURE__ */ ee.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-customer-found",
      children: "No customer found with this email or phone number."
    }
  ) : /* @__PURE__ */ ee.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ ee.jsx(mD, { customerDetails: a }),
        k && !!a && /* @__PURE__ */ ee.jsx(
          hD,
          {
            customerDetails: a,
            showCustomerDetails: h,
            refetchCustomerDetails: async () => await F()
          }
        ),
        C && !!a && /* @__PURE__ */ ee.jsx(lD, { customerDetails: a }),
        N && !!a && /* @__PURE__ */ ee.jsx(cD, { customerDetails: a }),
        j && !!a && /* @__PURE__ */ ee.jsx(yD, { customerDetails: a }),
        _ && !!a && /* @__PURE__ */ ee.jsx(fD, { devices: a?.devices }),
        g && !!a && /* @__PURE__ */ ee.jsx(sD, { apps: a?.apps })
      ]
    }
  );
}, Mo = [
  {
    key: "apiHostName",
    label: "API endpoint",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "brazeApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    label: "Display customer details",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "updateEmailSubscriptionState",
    label: "Display the button to change the email subscription state",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomAttributes",
    label: "Display a list of custom attributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCustomEvents",
    label: "Display a list of custom events",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    // Yeah, there is a typo 😅 We need to stick with it now, since customers
    // might have used it in the past..
    key: "displayPuchases",
    label: "Display a list of purchases",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDevices",
    label: "Display customer devices",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayApps",
    label: "Display customer apps",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ei = rr(Mo), vD = {
  enabled: !1,
  name: "",
  brazeApiKey: "",
  ...Ml([], Mo)
}, kD = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: vD
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "BRAZE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Mo,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => hr(K, {
    fieldDefinitions: Mo,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ ee.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ ee.jsx(yr, { cause: h }),
        /* @__PURE__ */ ee.jsxs(nt, { children: [
          /* @__PURE__ */ ee.jsx(Z, { children: /* @__PURE__ */ ee.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(
            Pn,
            {
              name: "apiHostName",
              label: ei.apiHostName,
              control: s.control,
              rules: {
                required: "API endpoint is required",
                validate: (K) => Vl(K) || !0
              },
              componentProps: {
                placeholder: "REST API endpoint for your region, e.g. rest.iad-01.braze.com",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(
            Er,
            {
              name: "brazeApiKey",
              label: ei.brazeApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.displayCustomerDetails, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.updateEmailSubscriptionState, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "updateEmailSubscriptionState",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.displayCustomAttributes, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "displayCustomAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.displayCustomEvents, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "displayCustomEvents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.displayPuchases, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "displayPuchases",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.displayDevices, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "displayDevices",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3, children: /* @__PURE__ */ ee.jsx(We, { label: ei.displayApps, children: /* @__PURE__ */ ee.jsx(
            bn,
            {
              name: "displayApps",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ ee.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ ee.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ ee.jsx(
          gr,
          {
            integrationType: "BRAZE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
function bD() {
  var e = $r(!1), n = _t(function() {
    return e.current;
  }, []);
  return Qe(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), n;
}
var _D = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = _t(function(o) {
    i(function(s) {
      return Object.assign({}, s, o instanceof Function ? o(s) : o);
    });
  }, []);
  return [r, a];
}, xD = function(e, n) {
  return typeof n == "boolean" ? n : !e;
}, P_ = function(e) {
  return kI(xD, e);
}, dm, A_;
function SD() {
  return A_ || (A_ = 1, dm = function() {
    var e = document.getSelection();
    if (!e.rangeCount)
      return function() {
      };
    for (var n = document.activeElement, r = [], i = 0; i < e.rangeCount; i++)
      r.push(e.getRangeAt(i));
    switch (n.tagName.toUpperCase()) {
      // .toUpperCase handles XHTML
      case "INPUT":
      case "TEXTAREA":
        n.blur();
        break;
      default:
        n = null;
        break;
    }
    return e.removeAllRanges(), function() {
      e.type === "Caret" && e.removeAllRanges(), e.rangeCount || r.forEach(function(a) {
        e.addRange(a);
      }), n && n.focus();
    };
  }), dm;
}
var um, L_;
function ND() {
  if (L_) return um;
  L_ = 1;
  var e = SD(), n = {
    "text/plain": "Text",
    "text/html": "Url",
    default: "Text"
  }, r = "Copy to clipboard: #{key}, Enter";
  function i(o) {
    var s = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
    return o.replace(/#{\s*key\s*}/g, s);
  }
  function a(o, s) {
    var l, d, m, u, f, h, k = !1;
    s || (s = {}), l = s.debug || !1;
    try {
      m = e(), u = document.createRange(), f = document.getSelection(), h = document.createElement("span"), h.textContent = o, h.ariaHidden = "true", h.style.all = "unset", h.style.position = "fixed", h.style.top = 0, h.style.clip = "rect(0, 0, 0, 0)", h.style.whiteSpace = "pre", h.style.webkitUserSelect = "text", h.style.MozUserSelect = "text", h.style.msUserSelect = "text", h.style.userSelect = "text", h.addEventListener("copy", function(N) {
        if (N.stopPropagation(), s.format)
          if (N.preventDefault(), typeof N.clipboardData > "u") {
            l && console.warn("unable to use e.clipboardData"), l && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
            var j = n[s.format] || n.default;
            window.clipboardData.setData(j, o);
          } else
            N.clipboardData.clearData(), N.clipboardData.setData(s.format, o);
        s.onCopy && (N.preventDefault(), s.onCopy(N.clipboardData));
      }), document.body.appendChild(h), u.selectNodeContents(h), f.addRange(u);
      var C = document.execCommand("copy");
      if (!C)
        throw new Error("copy command was unsuccessful");
      k = !0;
    } catch (N) {
      l && console.error("unable to copy using execCommand: ", N), l && console.warn("trying IE specific stuff");
      try {
        window.clipboardData.setData(s.format || "text", o), s.onCopy && s.onCopy(window.clipboardData), k = !0;
      } catch (j) {
        l && console.error("unable to copy using clipboardData: ", j), l && console.error("falling back to prompt"), d = i("message" in s ? s.message : r), window.prompt(d, o);
      }
    } finally {
      f && (typeof f.removeRange == "function" ? f.removeRange(u) : f.removeAllRanges()), h && document.body.removeChild(h), m();
    }
    return k;
  }
  return um = a, um;
}
var jD = ND();
const wD = /* @__PURE__ */ Ey(jD);
var WC = function() {
  var e = bD(), n = _D({
    value: void 0,
    error: void 0,
    noUserInteraction: !0
  }), r = n[0], i = n[1], a = _t(function(o) {
    if (e()) {
      var s, l;
      try {
        if (typeof o != "string" && typeof o != "number") {
          var d = new Error("Cannot copy typeof " + typeof o + " to clipboard, must be a string");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        } else if (o === "") {
          var d = new Error("Cannot copy empty string to clipboard.");
          process.env.NODE_ENV === "development" && console.error(d), i({
            value: o,
            error: d,
            noUserInteraction: !0
          });
          return;
        }
        l = o.toString(), s = wD(l), i({
          value: l,
          error: void 0,
          noUserInteraction: s
        });
      } catch (m) {
        i({
          value: l,
          error: m,
          noUserInteraction: s
        });
      }
    }
  }, []);
  return [r, a];
};
function CD(e, n) {
  n === void 0 && (n = 0);
  var r = $r(!1), i = $r(), a = $r(e), o = _t(function() {
    return r.current;
  }, []), s = _t(function() {
    r.current = !1, i.current && clearTimeout(i.current), i.current = setTimeout(function() {
      r.current = !0, a.current();
    }, n);
  }, [n]), l = _t(function() {
    r.current = null, i.current && clearTimeout(i.current);
  }, []);
  return Qe(function() {
    a.current = e;
  }, [e]), Qe(function() {
    return s(), l;
  }, [n]), [o, l, s];
}
function ki(e, n, r) {
  n === void 0 && (n = 0), r === void 0 && (r = []);
  var i = CD(e, n), a = i[0], o = i[1], s = i[2];
  return Qe(s, r), [a, o];
}
var FD = function(e) {
  Qe(e, []);
}, ID = function(e, n) {
  var r = $r(function() {
  });
  Qe(function() {
    r.current = e;
  }), Qe(function() {
    if (n !== null) {
      var i = setInterval(function() {
        return r.current();
      }, n || 0);
      return function() {
        return clearInterval(i);
      };
    }
  }, [n]);
}, ED = function(e) {
  e === void 0 && (e = {});
  var n = me(e), r = n[0], i = n[1], a = Xn(function() {
    return {
      set: function(s, l) {
        i(function(d) {
          var m;
          return kc(kc({}, d), (m = {}, m[s] = l, m));
        });
      },
      setAll: function(s) {
        i(s);
      },
      remove: function(s) {
        i(function(l) {
          var d = l, m = s;
          d[m];
          var u = DI(d, [typeof m == "symbol" ? m : m + ""]);
          return u;
        });
      },
      reset: function() {
        return i(e);
      }
    };
  }, [i]), o = kc({ get: _t(function(s) {
    return r[s];
  }, [r]) }, a);
  return [r, o];
}, $D = function(e) {
  var n = $r(e);
  n.current = e, FD(function() {
    return function() {
      return n.current();
    };
  });
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._contentWrapper_1vx3c_1{margin-bottom:var(--dixa-size-spacer-300)}._contentWrapperHeadline_1vx3c_4{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary);margin-bottom:var(--dixa-size-spacer-100)}._contentWrapperBody_1vx3c_11{max-height:75vh;overflow-y:auto}._contentWrapperAssigneeIcon_1vx3c_15{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle}._contentWrapperStatusTag_1vx3c_20{margin-right:var(--dixa-size-spacer-200)}._collapse_1bdjy_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_1bdjy_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_1bdjy_10>div>div>p{white-space:unset!important}._collapseHeader_1bdjy_10>div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child{width:100%}._collapseHeader_1bdjy_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_1bdjy_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderKey_1bdjy_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-700)}._collapseHeaderKeyIcon_1bdjy_36{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._collapseHeaderKeyLink_1bdjy_41{text-decoration:none}._collapseHeaderIcon_1bdjy_44{padding-top:.35em;margin-left:var(--dixa-size-spacer-100);vertical-align:text-bottom}._collapseHeaderTitle_1bdjy_49{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_1bdjy_57{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentButtonSpacer_1bdjy_60{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_1bdjy_63{color:var(--dixa-typography-color-link)}._result_1uaom_1{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1uaom_1:hover,._result_1uaom_1:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1uaom_21{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultItemIcon_1uaom_29{margin-top:-2px;margin-right:var(--dixa-size-spacer-100);vertical-align:middle}._resultDescription_1uaom_34{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1uaom_46{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1uaom_55{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipName_1uaom_61{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1uaom_66{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipTag_1uaom_71{width:fit-content;max-width:15em}._itemButton_3sxfy_1{border:none;padding:0}._result_3sxfy_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_3sxfy_6:hover,._result_3sxfy_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_3sxfy_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_3sxfy_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-normal)}._resultCheckIcon_3sxfy_38{height:var(--dixa-size-spacer-400)}._resultAssigneeIcon_3sxfy_41{border-radius:50%;width:var(--dixa-size-spacer-300);vertical-align:middle;margin-right:var(--dixa-size-spacer-200)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_19v8w_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_19v8w_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300);text-align:center}._inputField_19v8w_15{text-align:center}._buttonLink_19v8w_19{color:var(--dixa-typography-color-link)}._noItemsFound_19v8w_23{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._createIssueButton_19v8w_28{min-height:38px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var mm = { exports: {} }, Ga = {}, V_;
function TD() {
  if (V_) return Ga;
  V_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ga.Fragment = r, Ga.jsx = s, Ga.jsxs = s, Ga;
}
var hs = {}, z_;
function OD() {
  return z_ || (z_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    hs.Fragment = i, hs.jsx = zn, hs.jsxs = Wn;
  })()), hs;
}
var U_;
function RD() {
  return U_ || (U_ = 1, process.env.NODE_ENV === "production" ? mm.exports = TD() : mm.exports = OD()), mm.exports;
}
var _e = RD();
const DD = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "IssueFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "issueState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, PD = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "PullRequestFields" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", alias: { kind: "Name", value: "prState" }, name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] }, AD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubOrganizationMembersByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "organization" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "login" }, value: { kind: "Variable", name: { kind: "Name", value: "organizationQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "members" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "usersQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "login" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] } }] }, LD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createGithubIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "GitHub_CreateIssueInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, VD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getGithubRepositoriesByName" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "REPOSITORY" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repositoryCount" } }, { kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Repository" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, zD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "issues" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxIssueResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_Issue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "pullRequests" }, name: { kind: "Name", value: "search" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "prQuery" } } }, { kind: "Argument", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "ISSUE" } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "maxPRResults" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCount" } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "GitHub_PullRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] } }] }, UD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "issueNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, MD = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPullRequest" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "owner" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "prNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "GitHub" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "repository" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "owner" }, value: { kind: "Variable", name: { kind: "Name", value: "owner" } } }, { kind: "Argument", name: { kind: "Name", value: "name" }, value: { kind: "Variable", name: { kind: "Name", value: "repositoryName" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pullRequest" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "number" }, value: { kind: "Variable", name: { kind: "Name", value: "prNumber" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "bodyText" } }, { kind: "Field", name: { kind: "Name", value: "author" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "login" } }] } }, { kind: "Field", name: { kind: "Name", value: "state" } }, { kind: "Field", name: { kind: "Name", value: "assignees" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "repository" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "owner" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "login" } }] } }] } }] } }] } }] } }] } }] }, BD = {
  "\n  query getGithubOrganizationMembersByName(\n    $organizationQuery: String!\n    $usersQuery: String!\n    $maxResults: Int!\n  ) {\n    GitHub {\n      organization(login: $organizationQuery) {\n        teams(first: $maxResults) {\n          edges {\n            node {\n              id\n              name\n              members(first: $maxResults, query: $usersQuery) {\n                edges {\n                  node {\n                    id\n                    name\n                    login\n                    avatarUrl\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": AD,
  "\n  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {\n    GitHub {\n      createIssue(input: $input) {\n        issue {\n          id\n          number\n          repository {\n            name\n          }\n        }\n      }\n    }\n  }\n": LD,
  "\n  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {\n    GitHub {\n      search(query: $query, type: REPOSITORY, first: $maxResults) {\n        repositoryCount\n        edges {\n          node {\n            ... on GitHub_Repository {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": VD,
  "\n  fragment IssueFields on GitHub_Issue {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    issueState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": DD,
  "\n  fragment PullRequestFields on GitHub_PullRequest {\n    id\n    number\n    title\n    body\n    bodyText\n    author {\n      avatarUrl\n      login\n    }\n    prState: state\n    assignees(first: 10) {\n      nodes {\n        avatarUrl\n        name\n      }\n    }\n    labels(first: 10) {\n      nodes {\n        color\n        name\n      }\n    }\n    repository {\n      name\n      owner {\n        login\n      }\n    }\n  }\n": PD,
  "\n  query searchItems(\n    $issueQuery: String!\n    $prQuery: String!\n    $maxIssueResults: Int\n    $maxPRResults: Int\n  ) {\n    GitHub {\n      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {\n        issueCount\n        nodes {\n          ... on GitHub_Issue {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {\n        issueCount\n        nodes {\n          ... on GitHub_PullRequest {\n            id\n            number\n            title\n            body\n            bodyText\n            author {\n              avatarUrl\n              login\n            }\n            state\n            assignees(first: 10) {\n              nodes {\n                avatarUrl\n                name\n              }\n            }\n            labels(first: 10) {\n              nodes {\n                color\n                name\n              }\n            }\n            repository {\n              name\n              owner {\n                login\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zD,
  "\n  query getIssue(\n    $owner: String!\n    $repositoryName: String!\n    $issueNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        issue(number: $issueNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": UD,
  "\n  query getPullRequest(\n    $owner: String!\n    $repositoryName: String!\n    $prNumber: Int!\n  ) {\n    GitHub {\n      repository(owner: $owner, name: $repositoryName) {\n        pullRequest(number: $prNumber) {\n          id\n          number\n          title\n          body\n          bodyText\n          author {\n            avatarUrl\n            login\n          }\n          state\n          assignees(first: 10) {\n            nodes {\n              avatarUrl\n              name\n            }\n          }\n          labels(first: 10) {\n            nodes {\n              color\n              name\n            }\n          }\n          repository {\n            name\n            owner {\n              login\n            }\n          }\n        }\n      }\n    }\n  }\n": MD
};
function Oa(e) {
  return BD[e] ?? {};
}
const qD = Oa(
  /* GraphQL */
  `
  query searchItems(
    $issueQuery: String!
    $prQuery: String!
    $maxIssueResults: Int
    $maxPRResults: Int
  ) {
    GitHub {
      issues: search(query: $issueQuery, type: ISSUE, first: $maxIssueResults) {
        issueCount
        nodes {
          ... on GitHub_Issue {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
      pullRequests: search(query: $prQuery, type: ISSUE, first: $maxPRResults) {
        issueCount
        nodes {
          ... on GitHub_PullRequest {
            id
            number
            title
            body
            bodyText
            author {
              avatarUrl
              login
            }
            state
            assignees(first: 10) {
              nodes {
                avatarUrl
                name
              }
            }
            labels(first: 10) {
              nodes {
                color
                name
              }
            }
            repository {
              name
              owner {
                login
              }
            }
          }
        }
      }
    }
  }
`
), HD = Oa(
  /* GraphQL */
  `
  query getIssue(
    $owner: String!
    $repositoryName: String!
    $issueNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        issue(number: $issueNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), WD = Oa(
  /* GraphQL */
  `
  query getPullRequest(
    $owner: String!
    $repositoryName: String!
    $prNumber: Int!
  ) {
    GitHub {
      repository(owner: $owner, name: $repositoryName) {
        pullRequest(number: $prNumber) {
          id
          number
          title
          body
          bodyText
          author {
            avatarUrl
            login
          }
          state
          assignees(first: 10) {
            nodes {
              avatarUrl
              name
            }
          }
          labels(first: 10) {
            nodes {
              color
              name
            }
          }
          repository {
            name
            owner {
              login
            }
          }
        }
      }
    }
  }
`
), M_ = ({
  owner: e,
  repository: n,
  number: r
}) => `https://github.com/${e}/${n}/issues/${r}`, kr = ({
  owner: e,
  repository: n,
  number: r
}) => `${e}/${n} #${r}`, KD = ({
  number: e,
  repository: n
}) => ({
  number: e,
  repository: n.name,
  owner: n.owner.login
}), B_ = (e) => {
  switch (e) {
    case "ISSUE":
      return "issue";
    case "PR":
      return "pull request";
    default:
      return e;
  }
}, Xh = (e, n, r) => e === "ISSUE" ? {
  OPEN: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      height: "16",
      width: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M8 9.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" }),
        /* @__PURE__ */ _e.jsx("path", { d: "M8 0a8 8 0 100 16A8 8 0 008 0zM1.5 8a6.5 6.5 0 1113 0 6.5 6.5 0 01-13 0z" })
      ]
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsxs(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: [
        /* @__PURE__ */ _e.jsx("path", { d: "M11.28 6.78a.75.75 0 00-1.06-1.06L7.25 8.69 5.78 7.22a.75.75 0 00-1.06 1.06l2 2a.75.75 0 001.06 0l3.5-3.5z" }),
        /* @__PURE__ */ _e.jsx(
          "path",
          {
            fillRule: "evenodd",
            d: "M16 8A8 8 0 110 8a8 8 0 0116 0zm-1.5 0a6.5 6.5 0 11-13 0 6.5 6.5 0 0113 0z"
          }
        )
      ]
    }
  )
}[n] : {
  OPEN: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#3fb950",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M7.177 3.073L9.573.677A.25.25 0 0110 .854v4.792a.25.25 0 01-.427.177L7.177 3.427a.25.25 0 010-.354zM3.75 2.5a.75.75 0 100 1.5.75.75 0 000-1.5zm-2.25.75a2.25 2.25 0 113 2.122v5.256a2.251 2.251 0 11-1.5 0V5.372A2.25 2.25 0 011.5 3.25zM11 2.5h-1V4h1a1 1 0 011 1v5.628a2.251 2.251 0 101.5 0V5A2.5 2.5 0 0011 2.5zm1 10.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.75 12a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  ),
  MERGED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#a371f7",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M5 3.254V3.25v.005a.75.75 0 110-.005v.004zm.45 1.9a2.25 2.25 0 10-1.95.218v5.256a2.25 2.25 0 101.5 0V7.123A5.735 5.735 0 009.25 9h1.378a2.251 2.251 0 100-1.5H9.25a4.25 4.25 0 01-3.8-2.346zM12.75 9a.75.75 0 100-1.5.75.75 0 000 1.5zm-8.5 4.5a.75.75 0 100-1.5.75.75 0 000 1.5z" })
    }
  ),
  CLOSED: /* @__PURE__ */ _e.jsx(
    "svg",
    {
      className: r,
      fill: "#f85149",
      width: "16",
      height: "16",
      "aria-hidden": "true",
      children: /* @__PURE__ */ _e.jsx("path", { d: "M10.72 1.227a.75.75 0 011.06 0l.97.97.97-.97a.75.75 0 111.06 1.061l-.97.97.97.97a.75.75 0 01-1.06 1.06l-.97-.97-.97.97a.75.75 0 11-1.06-1.06l.97-.97-.97-.97a.75.75 0 010-1.06zM12.75 6.5a.75.75 0 00-.75.75v3.378a2.251 2.251 0 101.5 0V7.25a.75.75 0 00-.75-.75zm0 5.5a.75.75 0 100 1.5.75.75 0 000-1.5zM2.5 3.25a.75.75 0 111.5 0 .75.75 0 01-1.5 0zM3.25 1a2.25 2.25 0 00-.75 4.372v5.256a2.251 2.251 0 101.5 0V5.372A2.25 2.25 0 003.25 1zm0 11a.75.75 0 100 1.5.75.75 0 000-1.5z" })
    }
  )
}[n];
function GD({
  conversationId: e,
  githubOrganization: n
}) {
  const r = {
    github: { issues: [], pullRequests: [] }
  }, [i, a] = me(
    []
  ), [o, s] = me([]), [l, d] = me([]), [m, u] = me([]), [f, h] = me(), { showNotification: k, showModal: C, executeQuery: N } = hn(), { track: j } = Cn(), {
    loading: _,
    data: g,
    error: D,
    store: O
  } = jy(e ?? null), I = g?.github?.issues || [], F = g?.github?.pullRequests || [], [L, K] = me(!1), [J, te] = me();
  Qe(
    () => h(D || J || void 0),
    [D, J]
  ), Qe(
    () => {
      !_ && (I?.length || F?.length) ? (a(I), s(F), Y(I, F)) : (a([]), s([]), d([]), u([]));
    },
    // Only trigger when data is loaded, not when the loading status changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g]
  );
  const W = async (he, V) => {
    await O(he).then(() => {
      k({
        icon: "check-circle-filled",
        severity: "success",
        title: V.success.title,
        text: V.success.text
      });
    }).catch((ke) => {
      k({
        title: V.error.title,
        text: `${V.error.text} ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, Y = (he, V) => {
    if (!he?.length && !V?.length) {
      d([]), u([]);
      return;
    }
    const ke = (he || []).map(
      (Ge) => N(HD, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        issueNumber: Ge.number
      })
    ), De = (V || []).map(
      (Ge) => N(WD, {
        owner: Ge.owner,
        repositoryName: Ge.repository,
        prNumber: Ge.number
      })
    ), q = [...ke, ...De];
    K(!0), Promise.all(q).then((Ge) => {
      const sn = [], Ie = [];
      Ge.forEach((Ue) => {
        const Re = Ue?.data?.GitHub;
        if (!Re) {
          d([]), u([]);
          return;
        }
        Object.keys(Re).forEach((Be) => {
          if (Be.startsWith("repository")) {
            const Ae = Re[Be];
            Object.keys(Ae).forEach((Je) => {
              const $e = Ae[Je], Me = {
                number: $e?.number,
                owner: $e?.repository?.owner?.login,
                repository: $e?.repository?.name
              };
              Je.startsWith("issue") && sn.push({
                ...$e,
                type: "ISSUE",
                key: Me
              }), Je.startsWith("pullRequest") && Ie.push({
                ...$e,
                type: "PR",
                key: Me
              });
            });
          }
        });
      }), d(sn), u(Ie);
    }).catch(te).finally(() => {
      K(!1);
    });
  }, P = ({ key: he, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = g && (I.length || F.length) ? g : r, De = V === "ISSUE" ? "issues" : "pullRequests";
    ke.github[De] = Array.from(
      new Set(ke.github[De]).add(he)
    ), W(ke, {
      success: {
        title: "GitHub issue linked",
        text: `You linked the GitHub issue ${kr(
          he
        )} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${kr(he)} failed. Please try again.`
      }
    });
  }, B = async ({ key: he, type: V }) => {
    j("github:link:issue:clicked", {
      githubOrganization: n
    });
    const ke = g && (I.length || F.length) ? g : r, De = V === "ISSUE" ? "issues" : "pullRequests";
    ke.github[De] = Array.from(
      new Set(ke.github[De]).add(he)
    ), await O(ke).catch((q) => {
      k({
        title: "Linking failed",
        text: `Linking ${he} failed. Please try again. ${q.message && " (" + q.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, re = ({ key: he, type: V }) => {
    j("github:unlink:issue:clicked", {
      githubOrganization: n
    });
    const ke = V === "ISSUE" ? "issue" : "pull request";
    C({
      headline: `Unlink ${ke} ${kr(he)}?`,
      text: `You are about to unlink the ${ke} ${kr(
        he
      )}. Do you want to proceed?`,
      confirmLabel: `Unlink GitHub ${ke}`,
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        const De = V === "ISSUE" ? "issues" : "pullRequests";
        if (!g)
          return;
        const q = {
          ...g,
          github: {
            ...g?.github,
            [De]: g?.github?.[De].filter(
              (Ge) => Ge.number !== he.number || Ge.owner !== he.owner || Ge.repository !== he.repository
            )
          }
        };
        j("github:unlink:issue:confirmed", {
          githubOrganization: n
        }), W(q, {
          success: {
            title: `GitHub ${ke} unlinked`,
            text: `You unlinked the GitHub ${ke} ${kr(
              he
            )}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${kr(he)} failed.`
          }
        });
      },
      onCancel: () => {
        j("github:unlink:issue:canceled", {
          githubOrganization: n
        });
      }
    });
  }, je = () => {
    j("github:unlink:all:clicked", {
      githubOrganization: n
    }), C({
      headline: "Unlink all GitHub issues/pull requests?",
      text: "You are about to unlink the all GitHub issues/pull requests from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues/pull requests",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        j("github:unlink:all:confirmed", {
          githubOrganization: n
        }), W(r, {
          success: {
            title: "Unlinking successful",
            text: "All GitHub issues/pull requests were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues/pull requests failed."
          }
        });
      },
      onCancel: () => {
        j("github:unlink:all:canceled", {
          githubOrganization: n
        });
      }
    });
  }, ue = I.filter(
    (he) => !i?.includes(he)
  ) || [], se = F.filter(
    (he) => !o?.includes(he)
  ) || [];
  return {
    linkGithubItem: P,
    linkGithubItemQuietly: B,
    unlinkGithubItem: re,
    loadGithubItems: Y,
    removeDanglingGithubItemLinks: () => {
      const he = {
        ...g,
        github: {
          ...g?.github,
          issues: I.filter(
            (V) => !ue.includes(V)
          ) || [],
          pullRequests: F.filter(
            (V) => !se.includes(V)
          ) || []
        }
      };
      O(he);
    },
    unlinkAllGithubItems: je,
    isLoadingGithubItemLinks: _,
    danglingIssueLinks: ue,
    danglingPullRequestLinks: se,
    isLoadingGithubItems: L,
    issues: l,
    pullRequests: m,
    error: f
  };
}
const YD = "_contentWrapper_1vx3c_1", JD = "_contentWrapperHeadline_1vx3c_4", QD = "_contentWrapperBody_1vx3c_11", XD = "_contentWrapperAssigneeIcon_1vx3c_15", ZD = "_contentWrapperStatusTag_1vx3c_20", ni = {
  contentWrapper: YD,
  contentWrapperHeadline: JD,
  contentWrapperBody: QD,
  contentWrapperAssigneeIcon: XD,
  contentWrapperStatusTag: ZD
}, KC = ({
  description: e,
  assignees: n,
  labels: r
}) => /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
  e && /* @__PURE__ */ _e.jsxs(st, { className: ni.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(st, { className: ni.contentWrapperHeadline, children: "Description" }),
    /* @__PURE__ */ _e.jsx(st, { className: ni.contentWrapperBody, children: e })
  ] }),
  n?.nodes && n.nodes.length > 0 && /* @__PURE__ */ _e.jsxs(st, { className: ni.contentWrapper, children: [
    /* @__PURE__ */ _e.jsx(st, { className: ni.contentWrapperHeadline, children: "Assignees" }),
    /* @__PURE__ */ _e.jsx(st, { className: ni.contentWrapperBody, children: n.nodes.map(
      (i) => i && /* @__PURE__ */ _e.jsxs(st, { margin: "100 0", children: [
        /* @__PURE__ */ _e.jsx(
          "img",
          {
            className: ni.contentWrapperAssigneeIcon,
            src: i.avatarUrl,
            alt: i.name || ""
          }
        ),
        " ",
        i.name
      ] }, i.name)
    ) })
  ] }),
  r?.nodes && r?.nodes.length > 0 && /* @__PURE__ */ _e.jsx(st, { className: ni.contentWrapper, children: r.nodes.map(
    (i) => i && /* @__PURE__ */ _e.jsx(
      Jn,
      {
        className: ni.contentWrapperStatusTag,
        children: i.name
      },
      i.name
    )
  ) })
] }), eP = "_collapse_1bdjy_1", nP = "_collapseHeader_1bdjy_10", tP = "_collapseHeaderKey_1bdjy_31", rP = "_collapseHeaderKeyIcon_1bdjy_36", iP = "_collapseHeaderKeyLink_1bdjy_41", aP = "_collapseHeaderIcon_1bdjy_44", oP = "_collapseHeaderTitle_1bdjy_49", sP = "_collapseContent_1bdjy_57", lP = "_collapseContentButtonSpacer_1bdjy_60", cP = "_collapseContentButtonLink_1bdjy_63", Dr = {
  collapse: eP,
  collapseHeader: nP,
  collapseHeaderKey: tP,
  collapseHeaderKeyIcon: rP,
  collapseHeaderKeyLink: iP,
  collapseHeaderIcon: aP,
  collapseHeaderTitle: oP,
  collapseContent: sP,
  collapseContentButtonSpacer: lP,
  collapseContentButtonLink: cP
}, dP = ({
  items: e,
  unlinkGithubItem: n,
  githubOrganization: r
}) => {
  const i = e.reduce(
    (d, m) => ({ ...d, [m.id]: !1 }),
    {}
  ), [a, o] = me(i), { track: s } = Cn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ _e.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const {
      id: m,
      number: u,
      key: f,
      title: h,
      bodyText: k,
      repository: C,
      type: N,
      state: j,
      assignees: _,
      labels: g
    } = d, D = a[m];
    return /* @__PURE__ */ _e.jsxs(
      _r,
      {
        onToggle: () => l(m, !a[m]),
        isOpen: D,
        className: Dr.collapse,
        children: [
          /* @__PURE__ */ _e.jsx(_r.Header, { className: Dr.collapseHeader, children: /* @__PURE__ */ _e.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ _e.jsx(st, { children: /* @__PURE__ */ _e.jsxs(st, { as: "span", className: Dr.collapseHeaderKey, children: [
                  Xh(
                    N,
                    j,
                    Dr.collapseHeaderKeyIcon
                  ),
                  /* @__PURE__ */ _e.jsxs(
                    "a",
                    {
                      href: M_(f),
                      className: Dr.collapseHeaderKeyLink,
                      target: "_blank",
                      rel: "noreferrer",
                      onClick: (O) => {
                        O.stopPropagation();
                      },
                      children: [
                        kr(f),
                        /* @__PURE__ */ _e.jsx(
                          ve,
                          {
                            className: Dr.collapseHeaderIcon,
                            name: "external-link",
                            size: 16
                          }
                        )
                      ]
                    }
                  )
                ] }) }),
                /* @__PURE__ */ _e.jsx(st, { className: Dr.collapseHeaderTitle, children: h })
              ]
            }
          ) }),
          /* @__PURE__ */ _e.jsx(_r.Content, { className: Dr.collapseContent, children: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", margin: "0 0 200 0", children: [
            /* @__PURE__ */ _e.jsx(
              KC,
              {
                description: k,
                assignees: _,
                labels: g
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              ct,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Dr.collapseContentButtonSpacer,
                onClick: () => n({
                  key: {
                    number: u,
                    owner: C?.owner.login,
                    repository: d.repository.name
                  },
                  type: N
                }),
                children: [
                  "Unlink ",
                  B_(N)
                ]
              }
            ),
            /* @__PURE__ */ _e.jsxs(
              Lt,
              {
                slotEnd: /* @__PURE__ */ _e.jsx(ve, { name: "external-link" }),
                variant: "tertiary",
                className: Dr.collapseContentButtonLink,
                navigate: () => {
                  s("github:view:link:clicked", {
                    githubOrganization: r
                  }), window.open(M_(f), "_blank")?.focus();
                },
                children: [
                  "View ",
                  B_(N),
                  " in GitHub"
                ]
              }
            )
          ] }) })
        ]
      },
      m
    );
  }) : /* @__PURE__ */ _e.jsx(_e.Fragment, {}) });
}, uP = "_result_1uaom_1", mP = "_resultName_1uaom_21", pP = "_resultItemIcon_1uaom_29", fP = "_resultDescription_1uaom_34", hP = "_resultLinkIcon_1uaom_46", yP = "_tooltip_1uaom_55", gP = "_tooltipName_1uaom_61", vP = "_tooltipTag_1uaom_71", ti = {
  result: uP,
  resultName: mP,
  resultItemIcon: pP,
  resultDescription: fP,
  resultLinkIcon: hP,
  tooltip: yP,
  tooltipName: gP,
  tooltipTag: vP
}, kP = ({
  item: e,
  onSelect: n
}) => {
  const { key: r, title: i, type: a, state: o, labels: s, bodyText: l, assignees: d } = e, [m, u] = me(!1);
  return /* @__PURE__ */ _e.jsx(
    Xe,
    {
      className: ti.tooltip,
      content: /* @__PURE__ */ _e.jsxs(b, { flexDirection: "column", justifyContent: "center", width: "100%", children: [
        /* @__PURE__ */ _e.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "center",
            margin: "0 0 300 0",
            children: [
              /* @__PURE__ */ _e.jsxs(st, { as: "span", className: ti.tooltipName, children: [
                Xh(a, o, ti.resultItemIcon),
                i
              ] }),
              /* @__PURE__ */ _e.jsx(Jn, { className: ti.tooltipTag, children: o })
            ]
          }
        ),
        /* @__PURE__ */ _e.jsx(
          KC,
          {
            description: l,
            assignees: d,
            labels: s
          }
        )
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ _e.jsxs(
        "button",
        {
          className: ti.result,
          type: "button",
          onClick: () => {
            n(e);
          },
          onMouseEnter: () => u(!0),
          onMouseLeave: () => u(!1),
          children: [
            /* @__PURE__ */ _e.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                width: "100%",
                style: {
                  width: m ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ _e.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ _e.jsxs(st, { as: "span", className: ti.resultName, children: [
                    Xh(a, o, ti.resultItemIcon),
                    kr(r)
                  ] }) }),
                  /* @__PURE__ */ _e.jsx(st, { className: ti.resultDescription, children: i })
                ]
              }
            ),
            m && /* @__PURE__ */ _e.jsx(
              ve,
              {
                className: ti.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, bP = ({
  className: e,
  searched: n,
  githubOrganization: r
}) => /* @__PURE__ */ _e.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ _e.jsx(ve, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `https://github.com/search?q=is:issue+org:${r}+${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching items on GitHub"
  }
), vl = "[a-zA-z0-9_.-]+", GC = "[0-9]+", _P = new RegExp(
  `(${vl})/(${vl})/(?:issues|pull)/(${GC})`,
  "i"
), q_ = new RegExp(`^${_P.source}$`), H_ = new RegExp(
  `https://github.com/(${vl})/(${vl})/(?:issues|pull)/(${GC})`,
  "i"
), xP = ({
  onSelectItem: e,
  githubOrganization: n,
  linkedIssues: r,
  linkedPullRequests: i
}) => {
  const a = Xn(() => r?.map((F) => F.id) || [], [r]), o = Xn(() => i?.map((F) => F.id) || [], [i]), [s, l] = me([]), { useLazyQuery: d } = hn(), [m, u] = me(), [f, { loading: h, error: k, data: C, networkStatus: N }] = d(qD, {
    notifyOnNetworkStatusChange: !0
  });
  ki(
    () => {
      !h && m && N === tr.ready ? f({
        variables: {
          issueQuery: `${m} type:issue`,
          prQuery: `${m} type:pr`,
          maxIssueResults: 12,
          maxPRResults: 12
        }
      }) : l([]);
    },
    500,
    [m]
  ), Qe(() => {
    let F = C?.GitHub?.issues?.nodes || [], L = C?.GitHub?.pullRequests.nodes || [];
    a.length > 0 && (F = F.filter((K) => !a.includes(K.id))), o.length > 0 && (L = L.filter(
      (K) => !o.includes(K.id)
    )), l([
      ...F.map((K) => ({
        ...K,
        type: "ISSUE",
        key: {
          number: K.number,
          owner: K.repository.owner.login,
          repository: K.repository.name
        }
      })),
      ...L.map((K) => ({
        ...K,
        type: "PR",
        key: {
          number: K.number,
          owner: K.repository.owner.login,
          repository: K.repository.name
        }
      }))
    ]);
  }, [C, a, o]);
  function j(F) {
    const L = F?.trim();
    if (q_.test(L)) {
      const [K, J, te, W] = L.match(q_) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(W)
      };
    }
    if (H_.test(L)) {
      const [K, J, te, W] = L.match(H_) || [];
      return J !== n ? void 0 : {
        owner: n,
        repository: te,
        number: parseInt(W)
      };
    }
  }
  const _ = (F) => {
    e({
      key: KD(F),
      type: F.type
    }), u(void 0);
  }, g = (F) => {
    const L = j(F);
    u(
      L ? `org:${L.owner} repo:${L.repository} ${L.number}` : `org:${n} ${F}`
    );
  }, D = () => {
    u(void 0);
  }, O = ({ className: F, searched: L }) => /* @__PURE__ */ _e.jsx(
    bP,
    {
      className: F,
      searched: L,
      githubOrganization: n
    }
  ), I = ({ item: F, onSelect: L }) => /* @__PURE__ */ _e.jsx(kP, { item: F, onSelect: L });
  return !h && k ? /* @__PURE__ */ _e.jsx(En, { error: k }) : /* @__PURE__ */ _e.jsx(
    Tr,
    {
      items: s?.map((F) => ({ name: F.title, ...F })),
      loading: h,
      onSearch: g,
      onSelect: _,
      onClear: D,
      emptyMessage: m ? h ? "" : "No GitHub items found" : "Enter GitHub item key, link or search terms",
      suggestionComponent: O,
      itemComponent: I,
      placeholder: "Search GitHub items",
      searchable: !0,
      clearable: !0
    }
  );
}, SP = "_itemButton_3sxfy_1", NP = "_result_3sxfy_6", jP = "_resultName_3sxfy_30", wP = "_resultCheckIcon_3sxfy_38", CP = "_resultAssigneeIcon_3sxfy_41", Ya = {
  itemButton: SP,
  result: NP,
  resultName: jP,
  resultCheckIcon: wP,
  resultAssigneeIcon: CP
}, YC = ({
  item: e,
  checked: n = !1,
  onSelectItem: r
}) => /* @__PURE__ */ _e.jsx(
  b,
  {
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    "data-testid": "github-select-item-component",
    children: /* @__PURE__ */ _e.jsx(
      "button",
      {
        onClick: () => {
          r(e);
        },
        className: Ya.itemButton,
        children: /* @__PURE__ */ _e.jsxs(b, { className: Ya.result, flexDirection: "row", width: "100%", children: [
          e.iconUrl && /* @__PURE__ */ _e.jsx(st, { margin: "100 0", children: /* @__PURE__ */ _e.jsx(
            "img",
            {
              className: Ya.resultAssigneeIcon,
              src: e.iconUrl,
              alt: e.name
            }
          ) }, e.name),
          /* @__PURE__ */ _e.jsx(st, { className: Ya.resultName, children: e.name }),
          n && /* @__PURE__ */ _e.jsx(st, { className: Ya.resultCheckIcon, children: /* @__PURE__ */ _e.jsx(ve, { name: "done" }) })
        ] })
      }
    )
  }
), FP = Oa(
  /* GraphQL */
  `
  query getGithubOrganizationMembersByName(
    $organizationQuery: String!
    $usersQuery: String!
    $maxResults: Int!
  ) {
    GitHub {
      organization(login: $organizationQuery) {
        teams(first: $maxResults) {
          edges {
            node {
              id
              name
              members(first: $maxResults, query: $usersQuery) {
                edges {
                  node {
                    id
                    name
                    login
                    avatarUrl
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
), IP = ({
  githubOrganization: e,
  selectedItems: n,
  onChange: r,
  multiple: i = !1
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = me([]), [l, d] = me(""), m = 2, [u, { loading: f, error: h, data: k, networkStatus: C }] = a(
    FP,
    {
      notifyOnNetworkStatusChange: !0
    }
  );
  return ki(
    () => {
      !f && l && l.length >= m && C === tr.ready ? u({
        variables: {
          usersQuery: l,
          organizationQuery: e,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const N = k?.GitHub?.organization?.teams || { edges: [] }, j = [];
    N?.edges?.forEach((_) => {
      const g = _?.node?.members?.edges;
      (g?.length || 0) > 0 && g?.forEach((D) => {
        const O = D?.node;
        O && (O?.id && j.find((I) => I.id === O.id) || j.push(O));
      });
    }), s(
      j.sort((_, g) => {
        const D = _.name?.toLowerCase() || _.login?.toLowerCase(), O = g.name?.toLowerCase() || g.login?.toLowerCase();
        return D.localeCompare(O, void 0, {
          sensitivity: "base"
        });
      })
    );
  }, [k]), !f && h ? /* @__PURE__ */ _e.jsx(En, { error: h }) : /* @__PURE__ */ _e.jsx(
    Tr,
    {
      clearable: !0,
      searchable: !0,
      multiple: i,
      items: o?.map(({ id: N, name: j, login: _, avatarUrl: g }) => ({
        id: N,
        name: j || _,
        iconUrl: g
      })) || [],
      loading: f,
      onSearch: (N) => d(N),
      onChange: (N, j) => {
        const _ = N.id;
        i ? (j && !n.find(
          (g) => g.id === _
        ) && n.push(N), j || (n = n.filter(
          (g) => g.id !== _
        ))) : n = j ? [N] : [], r(n);
      },
      onClear: () => d(""),
      selectedItems: n,
      emptyMessage: l ? f ? "" : "No user found" : "Search users",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ _e.jsx(
        YC,
        {
          item: N,
          checked: _,
          onSelectItem: j
        }
      ),
      placeholder: "Search GitHub users"
    }
  );
}, EP = ({
  field: e,
  value: n,
  onChange: r,
  githubOrganization: i
}) => {
  const { multiple: a, type: o } = e;
  switch (o) {
    case "any":
      return /* @__PURE__ */ _e.jsx(dr, { onChange: r, value: n });
    case "array":
      return e?.allowedValues ? /* @__PURE__ */ _e.jsx(
        Tr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues.map(({ id: s, name: l, value: d }) => ({
            id: s,
            name: l || d
          }))
        }
      ) : /* @__PURE__ */ _e.jsx(
        ql,
        {
          onChange: r,
          selectedTags: Array.isArray(n) ? n : []
        }
      );
    case "number":
      return /* @__PURE__ */ _e.jsx(dr, { type: "number", onChange: r, value: n });
    case "option":
      return /* @__PURE__ */ _e.jsx(
        Tr,
        {
          onSelect: r,
          selectedItems: Array.isArray(n) ? n : [],
          items: e?.allowedValues?.map(
            ({ id: s, name: l, value: d }) => ({
              id: s,
              name: l || d
            })
          ) || []
        }
      );
    case "string":
      return /* @__PURE__ */ _e.jsx(dr, { onChange: r, value: n || "" });
    case "textarea":
      return /* @__PURE__ */ _e.jsx(qh, { onChange: r, value: n || "" });
    case "user":
      return /* @__PURE__ */ _e.jsx(
        IP,
        {
          githubOrganization: i,
          onChange: r,
          selectedItems: Array.isArray(n) ? n : [],
          multiple: a
        }
      );
    default:
      return /* @__PURE__ */ _e.jsx(_e.Fragment, { children: "Your organizations GitHub configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field." });
  }
}, $P = ({
  issueTypeFields: e,
  control: n,
  githubOrganization: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ _e.jsx(_e.Fragment, { children: e.filter(({ key: o }) => o !== "repository").map((o) => /* @__PURE__ */ _e.jsx(
  bt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ _e.jsx(
      We,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: EP({
          field: o,
          value: l,
          onChange: s,
          githubOrganization: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), TP = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => {
  const o = `${n}/${e.repository.name}/issues/${e.number}`;
  return /* @__PURE__ */ _e.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "400",
      "data-testid": "github-create-issue-success-message",
      children: [
        /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
          "You can visit your new issue by following",
          " ",
          /* @__PURE__ */ _e.jsxs($.ExternalLink, { href: o, target: "_blank", children: [
            "this link ",
            /* @__PURE__ */ _e.jsx(ve, { name: "external-link" })
          ] }),
          " ",
          "or copy it from the field below."
        ] }),
        /* @__PURE__ */ _e.jsx(We, { label: "GitHub issue link", children: /* @__PURE__ */ _e.jsx(
          dr,
          {
            readOnly: !0,
            value: o,
            suffix: {
              type: "button",
              button: {
                icon: r ? "done" : "copy",
                onClick: () => {
                  i(!0), a(o);
                }
              }
            }
          }
        ) })
      ]
    }
  );
}, OP = "_modalBody_1hk1o_1", RP = "_modalBodyFormFields_1hk1o_4", pm = {
  modalBody: OP,
  modalBodyFormFields: RP
}, DP = Oa(
  /* GraphQL */
  `
  query getGithubRepositoriesByName($query: String!, $maxResults: Int!) {
    GitHub {
      search(query: $query, type: REPOSITORY, first: $maxResults) {
        repositoryCount
        edges {
          node {
            ... on GitHub_Repository {
              id
              name
            }
          }
        }
      }
    }
  }
`
), PP = Oa(
  /* GraphQL */
  `
  mutation createGithubIssue($input: GitHub_CreateIssueInput!) {
    GitHub {
      createIssue(input: $input) {
        issue {
          id
          number
          repository {
            name
          }
        }
      }
    }
  }
`
), AP = [
  {
    key: "title",
    name: "Title",
    type: "string",
    required: !0
  },
  {
    key: "assignees",
    name: "Assignees",
    type: "user",
    required: !1,
    multiple: !0
  },
  {
    key: "body",
    name: "Description",
    type: "textarea",
    required: !1
  }
], LP = ({
  isOpen: e,
  onClose: n,
  linkGithubIssueQuietly: r,
  conversationContext: i,
  githubOrganization: a
}) => {
  const { showNotification: o, useLazyQuery: s, useMutation: l } = hn(), { track: d } = Cn(), {
    control: m,
    handleSubmit: u,
    formState: { errors: f },
    reset: h,
    getValues: k
  } = ut(), [C, N] = me(""), [j, _] = me([]), [g, D] = me(), [O, I] = me(!1), [F, L] = me(!1), [K, J] = WC(), [
    te,
    {
      loading: W,
      error: Y,
      networkStatus: P
    }
  ] = s(DP, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (De) => {
      _(
        De.GitHub.search?.edges?.map((q) => q?.node)
      );
    },
    onError: () => {
      o({
        title: "Could not get repository list",
        text: "We could not fetch the list of your repositories. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), _([]);
    }
  });
  ki(
    () => {
      !W && C && P === tr.ready ? te({
        variables: {
          query: C,
          maxResults: 10
        }
      }) : _([]);
    },
    500,
    [C]
  );
  const [B, { error: re }] = l(
    PP,
    {
      onError: (De) => {
        I(!1), o({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), console.warn("Error in createMutation", De);
      },
      onCompleted: (De) => {
        I(!1);
        const q = De.GitHub.createIssue?.issue;
        D(q), o({
          title: "Success",
          text: `GitHub issue '${q.number}' created`,
          icon: "check-circle-filled",
          severity: "success"
        }), r({
          owner: a,
          repository: q.repository.name,
          number: q.number
        });
      }
    }
  ), je = (De) => {
    N(`org:${a} ${De}`);
  }, ue = (De, q) => {
    q(De), N("");
  }, se = () => {
    N("");
  }, he = (De) => {
    d("github:create:issue:confirmed", {
      githubOrganization: a
    }), I(!0), B({
      variables: {
        input: {
          repositoryId: De.repository.id,
          title: De.title,
          body: De.body,
          assigneeIds: De.assignees?.length > 0 ? De.assignees.map((q) => q.id) : void 0
        }
      }
    });
  };
  Qe(() => {
    const De = F ? window.setTimeout(() => L(!1), 2e3) : void 0;
    return () => window.clearTimeout(De);
  }, [F]);
  const V = () => {
    N(""), _([]), D(void 0), I(!1), L(!1);
  }, ke = () => {
    d("github:create:issue:canceled", {
      githubOrganization: a
    }), V(), h(), n();
  };
  return /* @__PURE__ */ _e.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "github-create-issue-modal",
      onClose: ke,
      children: [
        /* @__PURE__ */ _e.jsx(
          Ct,
          {
            title: g ? "Issue creation successful" : "Create new GitHub issue",
            onClose: ke
          }
        ),
        /* @__PURE__ */ _e.jsxs(Ft, { className: pm.modalBody, children: [
          !W && Y && /* @__PURE__ */ _e.jsx(En, { error: Y }),
          !O && re && /* @__PURE__ */ _e.jsx(En, { error: re }),
          g ? /* @__PURE__ */ _e.jsx(
            TP,
            {
              createdIssue: g,
              issueBaseLink: `https://github.com/${a}`,
              issueLinkCopied: F,
              setIssueLinkCopied: L,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ _e.jsx(
            "form",
            {
              "data-testid": "github-create-issue-form",
              onSubmit: u(he),
              children: /* @__PURE__ */ _e.jsxs(nt, { children: [
                /* @__PURE__ */ _e.jsx(Z, { children: /* @__PURE__ */ _e.jsx(We, { label: "Repository", required: !0, children: /* @__PURE__ */ _e.jsx(
                  bt,
                  {
                    control: m,
                    name: "repository",
                    rules: { required: "Please select a repository" },
                    render: ({ field: { onChange: De, value: q } }) => /* @__PURE__ */ _e.jsx(
                      Tr,
                      {
                        className: pm.modalBodyRepository,
                        searchable: !0,
                        clearable: !0,
                        loading: W,
                        onSearch: je,
                        onSelect: (Ge) => ue(Ge, De),
                        onClear: se,
                        selectedItems: [q],
                        placeholder: "Search GitHub repositories",
                        emptyMessage: Y ? "No repositories found" : "No repositories available",
                        items: j || [],
                        itemComponent: ({ item: Ge, onSelect: sn, checked: Ie }) => /* @__PURE__ */ _e.jsx(
                          YC,
                          {
                            item: Ge,
                            checked: Ie,
                            onSelectItem: sn
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ _e.jsx(Z, { className: pm.modalBodyFormFields, children: /* @__PURE__ */ _e.jsx(
                  $P,
                  {
                    control: m,
                    errors: f,
                    getValues: k,
                    githubOrganization: a,
                    conversationContext: i,
                    issueTypeFields: AP
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ _e.jsx(
          Et,
          {
            confirmOnClick: g ? ke : u(he),
            confirmProps: {
              isLoading: O,
              loadingIndicator: /* @__PURE__ */ _e.jsx(fn, { size: 16 })
            },
            confirmName: g ? "Close" : "Save",
            cancelOnClick: g ? void 0 : ke
          }
        )
      ]
    }
  );
}, VP = "_wrapper_19v8w_1", zP = "_inputWrapper_19v8w_6", UP = "_buttonLink_19v8w_19", MP = "_noItemsFound_19v8w_23", BP = "_createIssueButton_19v8w_28", ea = {
  wrapper: VP,
  inputWrapper: zP,
  buttonLink: UP,
  noItemsFound: MP,
  createIssueButton: BP
}, qP = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1), { track: a } = Cn(), o = n?.githubOrganization, s = !!n?.enableRemoveAllLinks, {
    linkGithubItem: l,
    linkGithubItemQuietly: d,
    unlinkGithubItem: m,
    loadGithubItems: u,
    removeDanglingGithubItemLinks: f,
    unlinkAllGithubItems: h,
    isLoadingGithubItemLinks: k,
    danglingIssueLinks: C,
    danglingPullRequestLinks: N,
    isLoadingGithubItems: j,
    issues: _,
    pullRequests: g,
    error: D
  } = GD({
    conversationId: e?.conversationId || null,
    githubOrganization: o
  }), O = (J) => d({ key: J, type: "ISSUE" }), I = !(!!_?.length).valueOf() && !(!!g?.length).valueOf() && !(!!C?.length).valueOf() && !(!!N?.length).valueOf(), F = !k && !j && !!C?.length && !!N?.length && !!n?.showDanglingLinks, L = n?.enableCreateIssue, K = !!_?.length || !!g?.length;
  return !j && D ? /* @__PURE__ */ _e.jsx(En, { error: D, retry: () => u() }) : /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
    /* @__PURE__ */ _e.jsxs(b, { className: ea.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ _e.jsxs(b, { className: ea.inputWrapper, flexDirection: "column", children: [
        L && /* @__PURE__ */ _e.jsxs(_e.Fragment, { children: [
          /* @__PURE__ */ _e.jsx(
            ct,
            {
              variant: "primary",
              onClick: () => {
                a("github:create:issue:clicked", {
                  githubOrganization: n?.githubOrganization
                }), i(!0);
              },
              className: ea.createIssueButton,
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ _e.jsx("div", { className: ea.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ _e.jsx(
          xP,
          {
            onSelectItem: l,
            githubOrganization: o,
            linkedIssues: _,
            linkedPullRequests: g
          }
        )
      ] }),
      j ? /* @__PURE__ */ _e.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ _e.jsx(fn, { "data-testid": "github-widget-item-spinner" }) }) : K ? /* @__PURE__ */ _e.jsx(
        dP,
        {
          items: [..._, ...g],
          unlinkGithubItem: m,
          githubOrganization: o
        }
      ) : /* @__PURE__ */ _e.jsx($.Paragraph, { align: "center", className: ea.noItemsFound, children: "No linked items found." }),
      F && /* @__PURE__ */ _e.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ _e.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues and/or pull requests" }),
            /* @__PURE__ */ _e.jsxs(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: [
              C.map((J) => /* @__PURE__ */ _e.jsx(
                Jn,
                {
                  onDelete: () => m({
                    key: J,
                    type: "ISSUE"
                  }),
                  children: kr(J)
                },
                kr(J)
              )),
              N.map((J) => /* @__PURE__ */ _e.jsx(
                Jn,
                {
                  onDelete: () => m({ key: J, type: "PR" }),
                  children: kr(J)
                },
                kr(J)
              ))
            ] }),
            /* @__PURE__ */ _e.jsx(
              ct,
              {
                variant: "secondary",
                onClick: () => f(),
                icon: "link-slash",
                children: "Remove all"
              }
            )
          ]
        }
      ),
      s && K && /* @__PURE__ */ _e.jsx(
        ct,
        {
          variant: "secondary",
          disabled: I,
          onClick: h,
          children: "Remove all links"
        }
      ),
      /* @__PURE__ */ _e.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ _e.jsx(ve, { name: "external-link" }),
          variant: "tertiary",
          className: ea.buttonLink,
          navigate: () => {
            window.open(`https://github.com/${o}`, "_blank")?.focus();
          },
          children: "Open GitHub"
        }
      )
    ] }),
    /* @__PURE__ */ _e.jsx(
      LP,
      {
        isOpen: r,
        onClose: () => i(!1),
        linkGithubIssueQuietly: O,
        conversationContext: e,
        githubOrganization: o
      }
    )
  ] });
}, kl = [
  {
    key: "githubOrganization",
    label: "GitHub organization or user",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to GitHub items",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], ys = rr(kl), Si = "GITHUB", HP = {
  enabled: !1,
  name: "",
  githubOrganization: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0
}, WP = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: HP
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = ur({
    integrationId: e,
    integrationType: Si,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: kl,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => hr(J, {
    fieldDefinitions: kl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ _e.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ _e.jsx(yr, { cause: k }),
        /* @__PURE__ */ _e.jsxs(nt, { children: [
          /* @__PURE__ */ _e.jsx(Z, { children: /* @__PURE__ */ _e.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(
            Pn,
            {
              name: "githubOrganization",
              label: ys.githubOrganization,
              control: l.control,
              rules: { required: "GitHub organization or user is required" },
              componentProps: {
                placeholder: "Insert your GitHub organization or user name, e.g. dixahq",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(We, { label: ys.enableRemoveAllLinks, children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(We, { label: ys.showDanglingLinks, children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3, children: /* @__PURE__ */ _e.jsx(We, { label: ys.enableCreateIssue, children: /* @__PURE__ */ _e.jsx(
            bn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ _e.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ _e.jsx(
            gi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Si,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ _e.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ _e.jsx(
          gr,
          {
            integrationType: Si,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ _e.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ _e.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ _e.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ _e.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Si,
                  " integration, all links between Dixa and ",
                  Si,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Si,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ _e.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Si,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_16pij_1{padding:0}._listItem_16pij_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_16pij_4:last-child{border-bottom:none}._listItemEdit_16pij_11{cursor:pointer}._clickableIcon_16pij_15{cursor:pointer;color:var(--dixa-typography-color-secondary)}._boxWrapper_89s7l_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._boxWrapper_89s7l_1:hover{border-color:var(--dixa-color-neutral-300)}._trackButton_89s7l_10{color:var(--dixa-typography-color-link)}._order_135ze_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_135ze_1:hover,._orderIsOpen_135ze_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_135ze_12{cursor:pointer}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var fm = { exports: {} }, Ja = {}, W_;
function KP() {
  if (W_) return Ja;
  W_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Ja.Fragment = r, Ja.jsx = s, Ja.jsxs = s, Ja;
}
var gs = {}, K_;
function GP() {
  return K_ || (K_ = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    gs.Fragment = i, gs.jsx = zn, gs.jsxs = Wn;
  })()), gs;
}
var G_;
function YP() {
  return G_ || (G_ = 1, process.env.NODE_ENV === "production" ? fm.exports = KP() : fm.exports = GP()), fm.exports;
}
var we = YP(), wo = /* @__PURE__ */ ((e) => (e.Outbound = "OUTBOUND", e.Return = "RETURN", e.UnknownDirectionType = "UNKNOWN_DIRECTION_TYPE", e.Unspecified = "UNSPECIFIED", e))(wo || {}), Ti = /* @__PURE__ */ ((e) => (e.Delivery = "DELIVERY", e.Instore = "INSTORE", e.Inwarehouse = "INWAREHOUSE", e.Mailbox = "MAILBOX", e.Pickup = "PICKUP", e.Unknown = "UNKNOWN", e))(Ti || {}), Xt = /* @__PURE__ */ ((e) => (e.StepAwaitingSupplier = "STEP_AWAITING_SUPPLIER", e.StepConfirmedByMerchant = "STEP_CONFIRMED_BY_MERCHANT", e.StepDeliveredToConsumer = "STEP_DELIVERED_TO_CONSUMER", e.StepDeliveredToMerchant = "STEP_DELIVERED_TO_MERCHANT", e.StepDeliveredToPickupPoint = "STEP_DELIVERED_TO_PICKUP_POINT", e.StepLinehaulToCarrier = "STEP_LINEHAUL_TO_CARRIER", e.StepOnRoute = "STEP_ON_ROUTE", e.StepPreparedByMerchant = "STEP_PREPARED_BY_MERCHANT", e.StepReturnRequested = "STEP_RETURN_REQUESTED", e.StepSentBack = "STEP_SENT_BACK", e.StepSubmittedToCarrier = "STEP_SUBMITTED_TO_CARRIER", e.StepTerminated = "STEP_TERMINATED", e.StepUnknown = "STEP_UNKNOWN", e))(Xt || {});
const JP = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "locale" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Ingrid" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "DeliveryTracking_GetTrackingOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "locale" }, value: { kind: "Variable", name: { kind: "Name", value: "locale" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_GetTrackingOrdersResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "analytics_id" } }, { kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "preselected_parcel_index" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "site_name" } }, { kind: "Field", name: { kind: "Name", value: "tos_id" } }, { kind: "Field", name: { kind: "Name", value: "tracking_links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "cart" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_quantity" } }, { kind: "Field", name: { kind: "Name", value: "cancelled_total_price" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "variant" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "color" } }, { kind: "Field", name: { kind: "Name", value: "size" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "prices" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shipping_components" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "total" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "items_discount" } }, { kind: "Field", name: { kind: "Name", value: "items_price" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "shipping_discount" } }, { kind: "Field", name: { kind: "Name", value: "shipping_price" } }, { kind: "Field", name: { kind: "Name", value: "tax" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "parcels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alerts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "awaiting_supplier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "delivery_attempt_failed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed" } }, { kind: "Field", name: { kind: "Name", value: "delivery_delayed_from_carrier" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time_updated" } }, { kind: "Field", name: { kind: "Name", value: "linehaul" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "earliest" } }, { kind: "Field", name: { kind: "Name", value: "latest" } }] } }, { kind: "Field", name: { kind: "Name", value: "estimated_time_range" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "out_for_delivery" } }, { kind: "Field", name: { kind: "Name", value: "submission_delayed" } }] } }, { kind: "Field", name: { kind: "Name", value: "carrier" } }, { kind: "Field", name: { kind: "Name", value: "carrier_fallback_enabled" } }, { kind: "Field", name: { kind: "Name", value: "carrier_link" } }, { kind: "Field", name: { kind: "Name", value: "carrier_logo_pattern" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_id" } }, { kind: "Field", name: { kind: "Name", value: "carrier_product_ref" } }, { kind: "Field", name: { kind: "Name", value: "delivery_type" } }, { kind: "Field", name: { kind: "Name", value: "direction_type" } }, { kind: "Field", name: { kind: "Name", value: "display_carrier_name" } }, { kind: "Field", name: { kind: "Name", value: "estimated_delivery_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "exceptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "status" } }] } }, { kind: "Field", name: { kind: "Name", value: "index" } }, { kind: "Field", name: { kind: "Name", value: "line_items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "discount" } }, { kind: "Field", name: { kind: "Name", value: "image" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "price" } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }] } }, { kind: "Field", name: { kind: "Name", value: "location" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address_lines" } }, { kind: "Field", name: { kind: "Name", value: "apartment_number" } }, { kind: "Field", name: { kind: "Name", value: "attn" } }, { kind: "Field", name: { kind: "Name", value: "building_name" } }, { kind: "Field", name: { kind: "Name", value: "care_of" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "coordinates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lat" } }, { kind: "Field", name: { kind: "Name", value: "lng" } }] } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "door_code" } }, { kind: "Field", name: { kind: "Name", value: "floor_number" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "po_box_id" } }, { kind: "Field", name: { kind: "Name", value: "postal_code" } }, { kind: "Field", name: { kind: "Name", value: "region" } }, { kind: "Field", name: { kind: "Name", value: "street" } }, { kind: "Field", name: { kind: "Name", value: "street_number" } }, { kind: "Field", name: { kind: "Name", value: "subregion" } }] } }, { kind: "Field", name: { kind: "Name", value: "location_external_id" } }, { kind: "Field", name: { kind: "Name", value: "location_type" } }, { kind: "Field", name: { kind: "Name", value: "operational_hours" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "free_text" } }, { kind: "Field", name: { kind: "Name", value: "fri" } }, { kind: "Field", name: { kind: "Name", value: "mon" } }, { kind: "Field", name: { kind: "Name", value: "sat" } }, { kind: "Field", name: { kind: "Name", value: "sun" } }, { kind: "Field", name: { kind: "Name", value: "thu" } }, { kind: "Field", name: { kind: "Name", value: "tue" } }, { kind: "Field", name: { kind: "Name", value: "wed" } }] } }, { kind: "Field", name: { kind: "Name", value: "pickup_instructions" } }] } }, { kind: "Field", name: { kind: "Name", value: "progress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "estimated_time" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "end" } }, { kind: "Field", name: { kind: "Name", value: "start" } }] } }, { kind: "Field", name: { kind: "Name", value: "step" } }, { kind: "Field", name: { kind: "Name", value: "time" } }] } }, { kind: "Field", name: { kind: "Name", value: "requested_shipping_method" } }, { kind: "Field", name: { kind: "Name", value: "sender_name" } }, { kind: "Field", name: { kind: "Name", value: "tracking_link" } }, { kind: "Field", name: { kind: "Name", value: "tracking_number" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Ingrid_Error" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "details" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, QP = {
  "\n  query getOrders($email: String!, $locale: String!) {\n    Ingrid {\n      DeliveryTracking_GetTrackingOrders(\n        email: $email\n        locale: $locale\n      ) {\n        ... on Ingrid_GetTrackingOrdersResponse {\n          orders {\n            analytics_id\n            external_id\n            preselected_parcel_index\n            sender_name\n            site_name\n            tos_id\n            tracking_links {\n              links {\n                type\n                url\n              }\n            }\n            items {\n              discount\n              image\n              name\n              price\n              quantity\n              sku\n              total_price\n            }\n            cart {\n              currency\n              items {\n                attributes\n                cancelled_quantity\n                cancelled_total_price\n                discount\n                image\n                name\n                price\n                quantity\n                sku\n                total_price\n                variant {\n                  color\n                  size\n                }\n              }\n              prices {\n                shipping_components {\n                  discount\n                  name\n                  price\n                }\n                total {\n                  discount\n                  items_discount\n                  items_price\n                  price\n                  shipping_discount\n                  shipping_price\n                  tax\n                }\n              }\n            }\n            parcels {\n              alerts {\n                created_at\n                type\n                awaiting_supplier {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                delivery_attempt_failed\n                delivery_delayed\n                delivery_delayed_from_carrier\n                estimated_delivery_time_updated\n                linehaul {\n                  estimated_time {\n                    earliest\n                    latest\n                  }\n                  estimated_time_range {\n                    end\n                    start\n                  }\n                }\n                out_for_delivery\n                submission_delayed\n              }\n              carrier\n              carrier_fallback_enabled\n              carrier_link\n              carrier_logo_pattern\n              carrier_product_id\n              carrier_product_ref\n              delivery_type\n              direction_type\n              display_carrier_name\n              estimated_delivery_time {\n                end\n                start\n              }\n              exceptions {\n                created_at\n                status\n              }\n              index\n              line_items {\n                currency\n                discount\n                image\n                name\n                price\n                properties\n                quantity\n                sku\n                total_price\n              }\n              location {\n                address {\n                  address_lines\n                  apartment_number\n                  attn\n                  building_name\n                  care_of\n                  city\n                  coordinates {\n                    lat\n                    lng\n                  }\n                  country\n                  door_code\n                  floor_number\n                  name\n                  po_box_id\n                  postal_code\n                  region\n                  street\n                  street_number\n                  subregion\n                }\n                location_external_id\n                location_type\n                operational_hours {\n                  free_text\n                  fri\n                  mon\n                  sat\n                  sun\n                  thu\n                  tue\n                  wed\n                }\n                pickup_instructions\n              }\n              progress {\n                estimated_time {\n                  end\n                  start\n                }\n                step\n                time\n              }\n              requested_shipping_method\n              sender_name\n              tracking_link\n              tracking_number\n            }\n          }\n        }\n\n        ... on Ingrid_Error {\n          code\n          details\n          message\n        }\n      }\n    }\n  }\n": JP
};
function XP(e) {
  return QP[e] ?? {};
}
const ZP = XP(
  /* GraphQL */
  `
  query getOrders($email: String!, $locale: String!) {
    Ingrid {
      DeliveryTracking_GetTrackingOrders(
        email: $email
        locale: $locale
      ) {
        ... on Ingrid_GetTrackingOrdersResponse {
          orders {
            analytics_id
            external_id
            preselected_parcel_index
            sender_name
            site_name
            tos_id
            tracking_links {
              links {
                type
                url
              }
            }
            items {
              discount
              image
              name
              price
              quantity
              sku
              total_price
            }
            cart {
              currency
              items {
                attributes
                cancelled_quantity
                cancelled_total_price
                discount
                image
                name
                price
                quantity
                sku
                total_price
                variant {
                  color
                  size
                }
              }
              prices {
                shipping_components {
                  discount
                  name
                  price
                }
                total {
                  discount
                  items_discount
                  items_price
                  price
                  shipping_discount
                  shipping_price
                  tax
                }
              }
            }
            parcels {
              alerts {
                created_at
                type
                awaiting_supplier {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                delivery_attempt_failed
                delivery_delayed
                delivery_delayed_from_carrier
                estimated_delivery_time_updated
                linehaul {
                  estimated_time {
                    earliest
                    latest
                  }
                  estimated_time_range {
                    end
                    start
                  }
                }
                out_for_delivery
                submission_delayed
              }
              carrier
              carrier_fallback_enabled
              carrier_link
              carrier_logo_pattern
              carrier_product_id
              carrier_product_ref
              delivery_type
              direction_type
              display_carrier_name
              estimated_delivery_time {
                end
                start
              }
              exceptions {
                created_at
                status
              }
              index
              line_items {
                currency
                discount
                image
                name
                price
                properties
                quantity
                sku
                total_price
              }
              location {
                address {
                  address_lines
                  apartment_number
                  attn
                  building_name
                  care_of
                  city
                  coordinates {
                    lat
                    lng
                  }
                  country
                  door_code
                  floor_number
                  name
                  po_box_id
                  postal_code
                  region
                  street
                  street_number
                  subregion
                }
                location_external_id
                location_type
                operational_hours {
                  free_text
                  fri
                  mon
                  sat
                  sun
                  thu
                  tue
                  wed
                }
                pickup_instructions
              }
              progress {
                estimated_time {
                  end
                  start
                }
                step
                time
              }
              requested_shipping_method
              sender_name
              tracking_link
              tracking_number
            }
          }
        }

        ... on Ingrid_Error {
          code
          details
          message
        }
      }
    }
  }
`
), Y_ = (e) => {
  if (!e) return "";
  try {
    return new Intl.DateTimeFormat(void 0, {
      dateStyle: "medium",
      timeStyle: "short"
    }).format(new Date(e));
  } catch {
    return e;
  }
}, JC = (e, n) => {
  try {
    return new Intl.NumberFormat(void 0, {
      style: "currency",
      currency: n
    }).format(e);
  } catch {
    return e.toString();
  }
}, eA = "_listItem_16pij_4", nA = "_clickableIcon_16pij_15", Bo = {
  listItem: eA,
  clickableIcon: nA
}, QC = ({
  items: e,
  title: n,
  currency: r,
  openByDefault: i = !1
}) => {
  const [a, o] = me(i);
  return !e || e.length === 0 ? null : /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ we.jsx(ve, { size: 14, name: "list-ul", color: "blue.900" }),
      /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsxs(
        b,
        {
          gap: "100",
          flexDirection: "row",
          onClick: () => o(!a),
          className: Bo.clickableIcon,
          alignItems: "center",
          children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: n }),
            /* @__PURE__ */ we.jsx(
              ve,
              {
                size: 14,
                name: a ? "angle-down" : "angle-right"
              }
            )
          ]
        }
      ) })
    ] }),
    a && /* @__PURE__ */ we.jsx(Ye, { children: e.map((l, d) => {
      if (!l) return null;
      const { name: m, quantity: u, price: f, image: h, sku: k } = l, C = l.currency ?? r;
      return /* @__PURE__ */ we.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ we.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ we.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ we.jsxs(b, { flexDirection: "column", gap: "050", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: m }),
            f != null && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: JC(f / 100, C) })
          ] }),
          contentRight: h && /* @__PURE__ */ we.jsx(Ca, { src: h, alt: m ?? "Product image" }),
          className: Bo.listItem
        },
        `item-${d}-${k}`
      );
    }) })
  ] }) });
}, tA = "_boxWrapper_89s7l_1", rA = "_trackButton_89s7l_10", J_ = {
  boxWrapper: tA,
  trackButton: rA
}, iA = {
  [Xt.StepUnknown]: "Unknown",
  [Xt.StepConfirmedByMerchant]: "Confirmed by merchant",
  [Xt.StepPreparedByMerchant]: "Prepared by merchant",
  [Xt.StepSubmittedToCarrier]: "Submitted to carrier",
  [Xt.StepLinehaulToCarrier]: "Linehaul to carrier",
  [Xt.StepOnRoute]: "On route",
  [Xt.StepDeliveredToPickupPoint]: "At pickup point",
  [Xt.StepDeliveredToConsumer]: "Delivered to customer",
  [Xt.StepDeliveredToMerchant]: "Returned to merchant",
  [Xt.StepReturnRequested]: "Return requested",
  [Xt.StepSentBack]: "Sent back",
  [Xt.StepTerminated]: "Terminated",
  [Xt.StepAwaitingSupplier]: "Awaiting supplier"
}, aA = {
  [Ti.Delivery]: "Home delivery",
  [Ti.Pickup]: "Pickup point",
  [Ti.Instore]: "In-store pickup",
  [Ti.Mailbox]: "Mailbox",
  [Ti.Inwarehouse]: "Warehouse",
  [Ti.Unknown]: "Unknown"
}, oA = {
  [wo.Outbound]: "From merchant to customer",
  [wo.Return]: "Return from customer to merchant",
  [wo.Unspecified]: "Unspecified",
  [wo.UnknownDirectionType]: "Unknown"
}, sA = (e) => e ? iA[e] ?? e : "", lA = (e) => e ? aA[e] ?? e : "", cA = (e) => e ? oA[e] ?? e : "", dA = (e) => {
  if (!e) return null;
  const n = [e.street, e.street_number].filter(Boolean).join(" ");
  return [
    e.name,
    n,
    e.postal_code,
    e.city,
    e.country
  ].filter(Boolean).join(`
`);
}, uA = ({
  parcel: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const {
    carrier: i,
    progress: a,
    tracking_number: o,
    line_items: s,
    carrier_product_ref: l,
    carrier_link: d,
    display_carrier_name: m,
    delivery_type: u,
    direction_type: f,
    estimated_delivery_time: h
  } = e, k = m || l || i, C = a?.filter((O) => O?.time !== ""), N = sA(C?.[0]?.step), j = lA(u), _ = cA(f), g = dA(e.location?.address), D = 14;
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      padding: "250",
      className: J_.boxWrapper,
      children: [
        /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-4", children: k }),
        /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(
              ve,
              {
                size: D,
                name: "magnifying-glass-chart",
                color: "blue.900"
              }
            ),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Carrier tracking ID" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                !o && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                o && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: o })
              ] })
            ] })
          ] }),
          o && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
            ve,
            {
              size: D,
              name: n ? "done" : "copy",
              className: Bo.clickableIcon,
              onClick: () => r(o)
            }
          ) }) })
        ] }),
        N && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "chart-donut", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Status" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: N })
          ] })
        ] }),
        _ && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "arrow-right", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Direction" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: _ })
          ] })
        ] }),
        h && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "calendar", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Estimated delivery" }),
            /* @__PURE__ */ we.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
              Y_(h.start),
              " ",
              h.end && " until"
            ] }),
            h.end && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: Y_(h.end) })
          ] })
        ] }),
        u && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "info", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Delivery type" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: j })
          ] })
        ] }),
        g && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
          /* @__PURE__ */ we.jsx(ve, { size: D, name: "map-pin", color: "blue.900" }),
          /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Pickup location" }),
            /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: g })
          ] })
        ] }),
        /* @__PURE__ */ we.jsx(QC, { title: "Parcel items", items: s }),
        d && /* @__PURE__ */ we.jsxs(
          Lt,
          {
            variant: "secondary",
            className: J_.trackButton,
            navigate: () => window.open(d, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ we.jsx(ve, { name: "external-link" }),
            children: [
              "Track on ",
              k ?? "carrier",
              " website"
            ]
          }
        )
      ]
    }
  );
}, mA = "_order_135ze_1", pA = "_orderIsOpen_135ze_9", fA = "_orderHeader_135ze_12", hm = {
  order: mA,
  orderIsOpen: pA,
  orderHeader: fA
}, Q_ = "No order number found", hA = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { isCopied: a, copy: o } = Jt(), { isCopied: s, copy: l } = Jt();
  if (!e)
    return null;
  const { cart: d, parcels: m, sender_name: u, tos_id: f } = e, h = e.external_id?.trim(), k = d?.currency || "", C = d?.prices?.total?.price ?? 0, N = JC(C / 100, k), j = 14, _ = u && u.trim() !== "" ? u : "unknown sender";
  return /* @__PURE__ */ we.jsxs(
    b,
    {
      className: dt(hm.order, {
        [hm.orderIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ we.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: hm.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsxs($.Paragraph, { variant: "4", children: [
                  "From ",
                  _
                ] }),
                h ? /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: /* @__PURE__ */ we.jsxs("span", { children: [
                  "#",
                  h
                ] }) }) : /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Q_ })
              ] }),
              /* @__PURE__ */ we.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(ve, { size: j, name: "tag", color: "blue.900" }),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                /* @__PURE__ */ we.jsx(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: h ? /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: h }) : /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: Q_ }) })
              ] })
            ] }),
            h && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ we.jsx(
              ve,
              {
                size: j,
                name: s ? "done" : "copy",
                className: Bo.clickableIcon,
                onClick: () => l(h)
              }
            ) }) })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
              /* @__PURE__ */ we.jsx(
                ve,
                {
                  size: j,
                  name: "magnifying-glass-chart",
                  color: "blue.900"
                }
              ),
              /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Ingrid tracking ID" }),
                /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
                  !f && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tracking ID here yet" }),
                  f && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: f })
                ] })
              ] })
            ] }),
            f && /* @__PURE__ */ we.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ we.jsx(Xe, { content: "Copy tracking ID", children: /* @__PURE__ */ we.jsx(
              ve,
              {
                size: j,
                name: a ? "done" : "copy",
                className: Bo.clickableIcon,
                onClick: () => o(f)
              }
            ) }) })
          ] }),
          u && /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(ve, { size: 14, name: "user", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Sender" }),
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: u })
            ] })
          ] }),
          /* @__PURE__ */ we.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ we.jsx(ve, { size: 14, name: "chart-bar", color: "blue.900" }),
            /* @__PURE__ */ we.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", children: N })
            ] })
          ] }),
          /* @__PURE__ */ we.jsx(
            QC,
            {
              openByDefault: !0,
              title: "Order items",
              items: d?.items?.map((g) => g),
              currency: d?.currency
            }
          ),
          m && /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", margin: "0 0 100 0", children: [
            /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
              /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-4", children: "Parcels" }),
              m.length > 0 && /* @__PURE__ */ we.jsx(Mn, { variant: "success", size: "small", children: m.length })
            ] }),
            m.length === 0 && /* @__PURE__ */ we.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No parcels here" }),
            m.map((g, D) => /* @__PURE__ */ we.jsx(
              uA,
              {
                parcel: g
              },
              `parcel-${D}-${g?.tracking_number}`
            ))
          ] })
        ] })
      ]
    }
  );
}, yA = (e) => {
  const n = [], r = /* @__PURE__ */ new Map();
  for (const i of e) {
    if (!i?.external_id) {
      n.push(i);
      continue;
    }
    const a = r.get(i.external_id);
    if (a)
      a.parcels = [
        ...a.parcels ?? [],
        ...i.parcels ?? []
      ];
    else {
      const o = { ...i };
      r.set(i.external_id, o), n.push(o);
    }
  }
  return n;
}, X_ = (e) => {
  let n = 1 / 0;
  for (const r of e?.parcels ?? [])
    for (const i of r?.progress ?? []) {
      if (!i?.time)
        continue;
      const a = new Date(i.time).getTime();
      !Number.isNaN(a) && a < n && (n = a);
    }
  return n === 1 / 0 ? -1 / 0 : n;
}, gA = (e) => [...e].sort(
  (n, r) => X_(r) - X_(n)
), vA = ({
  customerEmail: e
}) => {
  const { useQuery: n } = hn(), [r, i] = me([]), a = !e, { data: o, loading: s, error: l } = n(ZP, {
    skip: a,
    variables: {
      email: e,
      locale: "en-GB"
    }
  }), d = !s && r.length > 0, m = l ? uI({
    error: l.graphQLErrors?.[0]
  }) : !1, u = l ? vw({
    error: l.graphQLErrors?.[0]
  }) : !1;
  return Qe(() => {
    const f = o?.Ingrid?.DeliveryTracking_GetTrackingOrders;
    f?.orders && i(
      gA(
        yA(f.orders)
      )
    );
  }, [o?.Ingrid?.DeliveryTracking_GetTrackingOrders]), s ? /* @__PURE__ */ we.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ we.jsx(fn, {}) }) : m || !d && !l ? /* @__PURE__ */ we.jsx($.Paragraph, { color: "tertiary", align: "center", children: "No orders to track" }) : u ? /* @__PURE__ */ we.jsx($.Paragraph, { color: "tertiary", align: "center", children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator." }) : l ? /* @__PURE__ */ we.jsx(En, { error: l }) : /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ we.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ we.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      /* @__PURE__ */ we.jsx(Mn, { variant: "success", size: "small", children: r.length })
    ] }),
    /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ we.jsx(b, { gap: "200", flexDirection: "column", children: r.map((f, h) => /* @__PURE__ */ we.jsx(
      hA,
      {
        order: f,
        openByDefault: h === 0
      },
      `${h}-${f?.tos_id}`
    )) }) })
  ] });
}, kA = ({ conversationContext: e }) => {
  const n = e?.customer?.email;
  return /* @__PURE__ */ we.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: /* @__PURE__ */ we.jsx(vA, { customerEmail: n })
    }
  );
}, bl = [
  {
    key: "ingridUseStagingEnvironment",
    label: "Use Ingrid staging environment",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "ingridSiteId",
    label: "Site ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "ingridApiToken",
    label: "API token",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], ym = rr(bl), bA = {
  enabled: !1,
  name: "",
  ingridSiteId: "",
  ingridApiToken: "",
  ingridUseStagingEnvironment: !1
}, _A = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: bA
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "INGRID",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: bl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => hr(K, {
    fieldDefinitions: bl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ we.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ we.jsx(yr, { cause: h }),
        /* @__PURE__ */ we.jsxs(nt, { children: [
          /* @__PURE__ */ we.jsx(Z, { children: /* @__PURE__ */ we.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ we.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(We, { label: ym.ingridUseStagingEnvironment, children: /* @__PURE__ */ we.jsx(
            bn,
            {
              name: "ingridUseStagingEnvironment",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Pn,
            {
              name: "ingridSiteId",
              label: ym.ingridSiteId,
              control: s.control,
              rules: { required: "Site ID is required" },
              componentProps: {
                placeholder: "Site ID from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          /* @__PURE__ */ we.jsx(Z, { span: 3, children: /* @__PURE__ */ we.jsx(
            Er,
            {
              name: "ingridApiToken",
              label: ym.ingridApiToken,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "API token from Ingrid",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ we.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ we.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ we.jsx(
          gr,
          {
            integrationType: "INGRID",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._jiraCode_h30p6_1{padding:2px 4px;font-size:100%;font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-primary);border-radius:4px}._jiraCodeInline_h30p6_8{background-color:var(--dixa-color-neutral-200)}._collapse_m2gjh_1{border:1px solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:0}._collapseHeader_m2gjh_10>div{padding:var(--dixa-size-spacer-300) 0!important}._collapseHeader_m2gjh_10>div>div>p{white-space:unset!important}._collapseHeader_m2gjh_10>div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child{width:100%}._collapseHeader_m2gjh_10>div:first-child div:first-child p{width:calc(100% - 20px)}._collapseHeader_m2gjh_10{background-color:transparent!important;padding:0 var(--dixa-size-spacer-300) 0 0;letter-spacing:-.08px;color:var(--dixa-color-neutral-500)}._collapseHeaderLink_m2gjh_31{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-link);text-decoration:none}._collapseHeaderLink_m2gjh_31:hover{text-decoration:underline}._collapseHeaderStatus_m2gjh_40{font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-color-neutral-500);float:right}._collapseHeaderIcon_m2gjh_46{padding-top:.35em;transform:scale(1.4);margin-left:var(--dixa-size-spacer-100)}._collapseHeaderTitle_m2gjh_51{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-300);line-height:var(--dixa-typography-line-height-300);letter-spacing:-.16px;color:var(--dixa-typography-color-primary);width:100%}._collapseContent_m2gjh_59{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-300)!important}._collapseContentHeadline_m2gjh_62{font-weight:var(--dixa-typography-weight-semibold);font-size:var(--dixa-typography-size-100);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-tertiary)}._collapseContentButtonSpacer_m2gjh_68{margin-top:var(--dixa-size-spacer-250)}._collapseContentButtonLink_m2gjh_71{color:var(--dixa-typography-color-link)}._collapseContentStatusTag_m2gjh_74{max-width:10em}._collapseContentDescription_m2gjh_77{max-height:75vh;overflow-y:auto}._result_1wiub_54{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:12px;line-height:32px;height:48px;width:100%;cursor:pointer}._result_1wiub_54:hover,._result_1wiub_54:focus{background-color:var(--dixa-color-neutral-100)}._resultName_1wiub_74{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultNameIcon_1wiub_82{height:var(--dixa-typography-line-height-200);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._resultDescription_1wiub_87{width:100%;text-align:left;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);color:var(--dixa-typography-color-secondary);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-top:-.5em;margin-bottom:.5em}._resultLinkIcon_1wiub_99{position:absolute;right:5px;background-color:var(--dixa-color-neutral-000);border:1px solid var(--dixa-color-neutral-300);border-radius:5px;color:var(--dixa-color-neutral-500)}._tooltip_1wiub_108{width:500px;max-height:60vh;overflow:hidden;text-overflow:ellipsis}._tooltipContent_1wiub_114{display:flex;flex-direction:column;width:100%;max-height:60vh;max-height:60dvh}._tooltipName_1wiub_121{text-align:left;white-space:nowrap;font-weight:var(--dixa-typography-weight-semibold)}._tooltipNameIcon_1wiub_126{height:var(--dixa-typography-line-height-300);padding-right:var(--dixa-size-spacer-100);margin-top:-2px}._tooltipDescription_1wiub_131{padding-top:.5em;width:100%;text-align:left;color:var(--dixa-typography-color-secondary);flex-grow:1;overflow-y:auto}._tooltipSummary_1wiub_139{padding-top:.5em;font-weight:var(--dixa-typography-weight-semibold)}._tooltipTag_1wiub_143{width:fit-content;max-width:15em}._itemButton_1hl53_1{border:none;padding:0}._result_1hl53_6{padding:0 var(--dixa-size-spacer-200);margin:0;outline:0;border:0;color:var(--dixa-typography-color-primary);background-color:var(--dixa-color-neutral-000);box-sizing:border-box;display:flex;align-items:center;position:relative;font-size:var(--dixa-typography-size-200);line-height:32px;height:48px;width:100%;cursor:pointer}._result_1hl53_6:hover,._result_1hl53_6:focus{background-color:var(--dixa-color-neutral-100)}._resultIcon_1hl53_26{height:var(--dixa-size-spacer-400);padding-right:var(--dixa-size-spacer-250)}._resultName_1hl53_30{width:100%;text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:var(--dixa-typography-weight-semibold)}._resultCheckIcon_1hl53_38{height:var(--dixa-size-spacer-400)}._modalBody_1hk1o_1{width:600px}._modalBodyFormFields_1hk1o_4{display:grid;gap:var(--dixa-size-spacer-300) var(--dixa-size-spacer-400)}._wrapper_1bylq_1{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_1bylq_6{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_1bylq_14{text-align:center}._inputSeparator_1bylq_18{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_1bylq_23{color:var(--dixa-typography-color-link)}._noIssuesFound_1bylq_27{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var gm = { exports: {} }, Qa = {}, Z_;
function xA() {
  if (Z_) return Qa;
  Z_ = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return Qa.Fragment = r, Qa.jsx = s, Qa.jsxs = s, Qa;
}
var vs = {}, ex;
function SA() {
  return ex || (ex = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    vs.Fragment = i, vs.jsx = zn, vs.jsxs = Wn;
  })()), vs;
}
var nx;
function NA() {
  return nx || (nx = 1, process.env.NODE_ENV === "production" ? gm.exports = xA() : gm.exports = SA()), gm.exports;
}
var pe = NA();
const mg = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => mg(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, jA = "_jiraCode_h30p6_1", wA = "_jiraCodeInline_h30p6_8", vm = {
  jiraCode: jA,
  jiraCodeInline: wA
}, XC = {
  default: (e, n) => n().every((r) => typeof r == "string") ? n().join(" ") : /* @__PURE__ */ pe.jsx(pe.Fragment, { children: n() }),
  nodes: {
    doc: (e, n) => /* @__PURE__ */ pe.jsx("div", { children: n() }),
    paragraph: (e, n) => /* @__PURE__ */ pe.jsx("p", { children: n() }),
    text: (e) => e.text || "",
    hardBreak: () => /* @__PURE__ */ pe.jsx("br", {}),
    bulletList: (e, n) => /* @__PURE__ */ pe.jsx("ul", { children: n() }),
    orderedList: (e, n) => /* @__PURE__ */ pe.jsx("ol", { children: n() }),
    listItem: (e, n) => /* @__PURE__ */ pe.jsx("li", { children: n() }),
    codeBlock: (e, n) => /* @__PURE__ */ pe.jsx("pre", { children: /* @__PURE__ */ pe.jsx("code", { className: vm.jiraCode, children: n() }) }),
    heading: (e, n) => {
      switch (e.attrs?.level) {
        // Not using headlines above level 3
        case 1:
          return /* @__PURE__ */ pe.jsx("h3", { children: n() });
        case 2:
          return /* @__PURE__ */ pe.jsx("h4", { children: n() });
        case 3:
          return /* @__PURE__ */ pe.jsx("h5", { children: n() });
        case 4:
          return /* @__PURE__ */ pe.jsx("h6", { children: n() });
        case 5:
          return /* @__PURE__ */ pe.jsx("b", { children: n() });
        case 6:
          return /* @__PURE__ */ pe.jsx("b", { children: n() });
        default:
          return /* @__PURE__ */ pe.jsx("h4", { children: n() });
      }
    }
  },
  marks: {
    text: {
      em: (e, n) => /* @__PURE__ */ pe.jsx("em", { children: n() }),
      strong: (e, n) => /* @__PURE__ */ pe.jsx("b", { children: n() }),
      underline: (e, n) => /* @__PURE__ */ pe.jsx("u", { children: n() }),
      link: (e, n) => /* @__PURE__ */ pe.jsx("a", { href: e.attrs?.href || "", target: "_blank", rel: "noreferrer", children: n() }),
      code: (e, n) => /* @__PURE__ */ pe.jsx("code", { className: dt(vm.jiraCode, vm.jiraCodeInline), children: n() })
      // Removing color support for now.
      // textColor: (mark, next) => (
      // 	<span style={{ color: mark.attrs?.['color'] }}>{next()}</span>
      // ),
    }
  }
}, _l = ({
  iconUrl: e,
  className: n,
  width: r
}) => {
  const [i, a] = me(!1);
  return !e || i ? /* @__PURE__ */ pe.jsx(ve, { size: r, name: "question", className: n }) : /* @__PURE__ */ pe.jsx(
    "img",
    {
      src: e,
      width: r,
      className: n,
      onError: ({ currentTarget: o }) => {
        o.onerror = null, a(!0);
      }
    }
  );
}, CA = "_collapse_m2gjh_1", FA = "_collapseHeader_m2gjh_10", IA = "_collapseHeaderLink_m2gjh_31", EA = "_collapseHeaderStatus_m2gjh_40", $A = "_collapseHeaderTitle_m2gjh_51", TA = "_collapseContent_m2gjh_59", OA = "_collapseContentHeadline_m2gjh_62", RA = "_collapseContentButtonSpacer_m2gjh_68", DA = "_collapseContentButtonLink_m2gjh_71", PA = "_collapseContentStatusTag_m2gjh_74", AA = "_collapseContentDescription_m2gjh_77", Nr = {
  collapse: CA,
  collapseHeader: FA,
  collapseHeaderLink: IA,
  collapseHeaderStatus: EA,
  collapseHeaderTitle: $A,
  collapseContent: TA,
  collapseContentHeadline: OA,
  collapseContentButtonSpacer: RA,
  collapseContentButtonLink: DA,
  collapseContentStatusTag: PA,
  collapseContentDescription: AA
}, ZC = ({
  jiraInstanceUrl: e,
  avatarId: n,
  iconUrl: r
}) => n ? `${e}/rest/api/3/universal_avatar/view/type/issuetype/avatar/${n}?size=medium` : r, LA = ({
  issues: e,
  jiraInstanceUrl: n,
  unlinkIssue: r
}) => {
  const i = e.reduce(
    (d, m) => m?.id ? { ...d, [m.id]: !1 } : d,
    {}
  ), [a, o] = me(i), { track: s } = Cn(), l = (d, m) => {
    o({ ...a, [d]: m });
  };
  return /* @__PURE__ */ pe.jsx(b, { flexDirection: "column", gap: "250", children: e?.length ? e.map((d) => {
    const { summary: m, description: u, status: f, issuetype: h } = d?.fields || {}, k = ZC({
      avatarId: h?.avatarId,
      iconUrl: h?.iconUrl,
      jiraInstanceUrl: n
    }), C = !!(d?.id && a[d.id]);
    return /* @__PURE__ */ pe.jsxs(
      _r,
      {
        onToggle: () => d?.id && l(d.id, !a[d.id]),
        isOpen: C,
        className: Nr.collapse,
        children: [
          /* @__PURE__ */ pe.jsx(_r.Header, { className: Nr.collapseHeader, children: /* @__PURE__ */ pe.jsxs(
            b,
            {
              flexDirection: "column",
              gap: "200",
              justifyContent: "space-between",
              children: [
                /* @__PURE__ */ pe.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                  /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "200", children: [
                    /* @__PURE__ */ pe.jsx(_l, { width: 16, iconUrl: k }),
                    /* @__PURE__ */ pe.jsx(
                      "a",
                      {
                        className: Nr.collapseHeaderLink,
                        href: `${n}/browse/${d?.key}`,
                        target: "_blank",
                        rel: "noreferrer",
                        onClick: (N) => {
                          N.stopPropagation(), d?.key && s("jira:view:issue:clicked", {
                            jiraIssueKey: d.key,
                            jiraInstanceUrl: n
                          });
                        },
                        children: /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "200", children: [
                          d?.key,
                          /* @__PURE__ */ pe.jsx(ve, { name: "external-link", size: 16 })
                        ] })
                      },
                      d?.key
                    )
                  ] }),
                  /* @__PURE__ */ pe.jsx("span", { className: Nr.collapseHeaderStatus, children: f?.name && /* @__PURE__ */ pe.jsx(Jn, { className: Nr.collapseContentStatusTag, children: f.name }) })
                ] }),
                /* @__PURE__ */ pe.jsx("div", { className: Nr.collapseHeaderTitle, children: m })
              ]
            }
          ) }),
          /* @__PURE__ */ pe.jsx(_r.Content, { className: Nr.collapseContent, children: /* @__PURE__ */ pe.jsxs(b, { flexDirection: "column", gap: "250", margin: "0 0 200 0", children: [
            /* @__PURE__ */ pe.jsx("div", { className: Nr.collapseContentHeadline, children: "Description" }),
            /* @__PURE__ */ pe.jsx(st, { className: Nr.collapseContentDescription, children: u ? mg(u, XC) : "" }),
            /* @__PURE__ */ pe.jsx(
              ct,
              {
                icon: "link-slash",
                variant: "secondary",
                className: Nr.collapseContentButtonSpacer,
                onClick: () => d?.key && r(d.key),
                children: "Unlink issue from Jira"
              }
            ),
            /* @__PURE__ */ pe.jsx(
              Lt,
              {
                slotEnd: /* @__PURE__ */ pe.jsx(ve, { name: "external-link" }),
                variant: "tertiary",
                className: Nr.collapseContentButtonLink,
                navigate: () => {
                  d?.key && (s("jira:view:issue:clicked", {
                    jiraIssueKey: d.key,
                    jiraInstanceUrl: n
                  }), window.open(
                    `${n}/browse/${d.key}`,
                    "_blank"
                  )?.focus());
                },
                children: "View issue in Jira"
              }
            )
          ] }) })
        ]
      },
      d?.id
    );
  }) : /* @__PURE__ */ pe.jsx(pe.Fragment, {}) });
}, VA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "title" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "url" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createOrUpdateRemoteIssueLink" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "application" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "name" }, value: { kind: "StringValue", value: "Dixa Conversations", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "StringValue", value: "com.dixa.conversations", block: !1 } }] } }, { kind: "ObjectField", name: { kind: "Name", value: "relationship" }, value: { kind: "StringValue", value: "dixa-backlink", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "object" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "title" } } }, { kind: "ObjectField", name: { kind: "Name", value: "url" }, value: { kind: "Variable", name: { kind: "Name", value: "url" } } }, { kind: "ObjectField", name: { kind: "Name", value: "icon" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "url16x16" }, value: { kind: "StringValue", value: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2", block: !1 } }, { kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "StringValue", value: "Dixa", block: !1 } }] } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }] } }] } }] } }] }, zA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removeBacklink" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueKey" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "globalId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "deleteRemoteIssueLinkByGlobalId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "issueIdOrKey" }, value: { kind: "Variable", name: { kind: "Name", value: "issueKey" } } }, { kind: "Argument", name: { kind: "Name", value: "globalId" }, value: { kind: "Variable", name: { kind: "Name", value: "globalId" } } }] }] } }] } }] }, UA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Jira_IssueUpdateDetails_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "createIssue" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_CreatedIssue" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Jira_ErrorCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorMessages" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "errors" } }] } }] } }] } }] } }] }, MA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAllProjects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, BA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCreateIssueMeta" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectKey" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCreateIssueMeta" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "projectKeys" }, value: { kind: "ListValue", values: [{ kind: "Variable", name: { kind: "Name", value: "projectKey" } }] } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "StringValue", value: "projects.issuetypes.fields", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "issuetypes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "iconUrl" } }, { kind: "Field", name: { kind: "Name", value: "entityId" } }, { kind: "Field", name: { kind: "Name", value: "hierarchyLevel" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "scope" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "additionalProperties" } }] } }, { kind: "Field", name: { kind: "Name", value: "expand" } }, { kind: "Field", name: { kind: "Name", value: "subtask" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "required" } }, { kind: "Field", name: { kind: "Name", value: "hasDefaultValue" } }, { kind: "Field", name: { kind: "Name", value: "schema" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "system" } }, { kind: "Field", name: { kind: "Name", value: "items" } }, { kind: "Field", name: { kind: "Name", value: "custom" } }, { kind: "Field", name: { kind: "Name", value: "customId" } }] } }, { kind: "Field", name: { kind: "Name", value: "allowedValues" } }, { kind: "Field", name: { kind: "Name", value: "defaultValue" } }, { kind: "Field", name: { kind: "Name", value: "operations" } }, { kind: "Field", name: { kind: "Name", value: "autoCompleteUrl" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, qA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "jql" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "maxResults" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchAndReconsileIssuesUsingJql" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "jql" }, value: { kind: "Variable", name: { kind: "Name", value: "jql" } } }, { kind: "Argument", name: { kind: "Name", value: "maxResults" }, value: { kind: "Variable", name: { kind: "Name", value: "maxResults" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "ListValue", values: [{ kind: "StringValue", value: "summary", block: !1 }, { kind: "StringValue", value: "description", block: !1 }, { kind: "StringValue", value: "status", block: !1 }, { kind: "StringValue", value: "updated", block: !1 }, { kind: "StringValue", value: "issuetype", block: !1 }, { kind: "StringValue", value: "project", block: !1 }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "fields" } }] } }] } }] } }] } }] }, HA = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "findUsers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Jira" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findUsers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountId" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "self" } }, { kind: "Field", name: { kind: "Name", value: "active" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrls" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "_24x24" } }] } }] } }] } }] } }] }, WA = {
  '\n  mutation createBacklink(\n    $issueKey: String!\n    $title: String!\n    $url: String!\n    $globalId: String!\n  ) {\n    Jira {\n      createOrUpdateRemoteIssueLink(\n        issueIdOrKey: $issueKey\n        input: {\n          globalId: $globalId\n          application: {\n            name: "Dixa Conversations"\n            type: "com.dixa.conversations"\n          }\n          relationship: "dixa-backlink"\n          object: {\n            title: $title\n            url: $url\n            icon: {\n              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"\n              title: "Dixa"\n            }\n          }\n        }\n      ) {\n        __typename\n      }\n    }\n  }\n': VA,
  "\n  mutation removeBacklink($issueKey: String!, $globalId: String!) {\n    Jira {\n      deleteRemoteIssueLinkByGlobalId(\n        issueIdOrKey: $issueKey\n        globalId: $globalId\n      )\n    }\n  }\n": zA,
  "\n  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {\n    Jira {\n      createIssue(input: $input) {\n        ... on Jira_CreatedIssue {\n          id\n          key\n        }\n        ... on Jira_ErrorCollection {\n          errorMessages\n          status\n          errors\n        }\n      }\n    }\n  }\n": UA,
  "\n  query jira {\n    Jira {\n      getAllProjects {\n        id\n        key\n        name\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": MA,
  '\n  query getCreateIssueMeta($projectKey: String) {\n    Jira {\n      getCreateIssueMeta(\n        projectKeys: [$projectKey]\n        expand: "projects.issuetypes.fields"\n      ) {\n        projects {\n          id\n          key\n          name\n          issuetypes {\n            id\n            name\n            iconUrl\n            entityId\n            hierarchyLevel\n            subtask\n            scope {\n              type\n              project {\n                id\n                key\n                name\n              }\n              additionalProperties\n            }\n            expand\n            subtask\n            description\n            fields {\n              additionalProperties {\n                key\n                value {\n                  key\n                  name\n                  required\n                  hasDefaultValue\n                  schema {\n                    type\n                    system\n                    items\n                    custom\n                    customId\n                  }\n                  allowedValues\n                  defaultValue\n                  operations\n                  autoCompleteUrl\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n': BA,
  '\n  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {\n    Jira {\n      searchAndReconsileIssuesUsingJql(\n        jql: $jql\n        maxResults: $maxResults\n        fields: [\n          "summary"\n          "description"\n          "status"\n          "updated"\n          "issuetype"\n          "project"\n        ]\n      ) {\n        issues {\n          id\n          key\n          fields\n        }\n      }\n    }\n  }\n': qA,
  "\n  query findUsers($query: String) {\n    Jira {\n      findUsers(query: $query) {\n        accountId\n        displayName\n        self\n        active\n        avatarUrls {\n          _24x24\n        }\n      }\n    }\n  }\n": HA
};
function Ki(e) {
  return WA[e] ?? {};
}
const e1 = Ki(
  /* GraphQL */
  `
  query searchAndReconsileIssuesUsingJql($jql: String!, $maxResults: Int) {
    Jira {
      searchAndReconsileIssuesUsingJql(
        jql: $jql
        maxResults: $maxResults
        fields: [
          "summary"
          "description"
          "status"
          "updated"
          "issuetype"
          "project"
        ]
      ) {
        issues {
          id
          key
          fields
        }
      }
    }
  }
`
), KA = Ki(
  /* GraphQL */
  `
  mutation createBacklink(
    $issueKey: String!
    $title: String!
    $url: String!
    $globalId: String!
  ) {
    Jira {
      createOrUpdateRemoteIssueLink(
        issueIdOrKey: $issueKey
        input: {
          globalId: $globalId
          application: {
            name: "Dixa Conversations"
            type: "com.dixa.conversations"
          }
          relationship: "dixa-backlink"
          object: {
            title: $title
            url: $url
            icon: {
              url16x16: "https://www.dixa.com/app/themes/dixa/app/frontend/src/images/favicons/favicon-32x32.png?v=2"
              title: "Dixa"
            }
          }
        }
      ) {
        __typename
      }
    }
  }
`
), GA = Ki(
  /* GraphQL */
  `
  mutation removeBacklink($issueKey: String!, $globalId: String!) {
    Jira {
      deleteRemoteIssueLinkByGlobalId(
        issueIdOrKey: $issueKey
        globalId: $globalId
      )
    }
  }
`
), YA = Ki(
  /* GraphQL */
  `
  query jira {
    Jira {
      getAllProjects {
        id
        key
        name
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), JA = Ki(
  /* GraphQL */
  `
  query getCreateIssueMeta($projectKey: String) {
    Jira {
      getCreateIssueMeta(
        projectKeys: [$projectKey]
        expand: "projects.issuetypes.fields"
      ) {
        projects {
          id
          key
          name
          issuetypes {
            id
            name
            iconUrl
            entityId
            hierarchyLevel
            subtask
            scope {
              type
              project {
                id
                key
                name
              }
              additionalProperties
            }
            expand
            subtask
            description
            fields {
              additionalProperties {
                key
                value {
                  key
                  name
                  required
                  hasDefaultValue
                  schema {
                    type
                    system
                    items
                    custom
                    customId
                  }
                  allowedValues
                  defaultValue
                  operations
                  autoCompleteUrl
                }
              }
            }
          }
        }
      }
    }
  }
`
), QA = Ki(
  /* GraphQL */
  `
  mutation createIssue($input: Jira_IssueUpdateDetails_Input) {
    Jira {
      createIssue(input: $input) {
        ... on Jira_CreatedIssue {
          id
          key
        }
        ... on Jira_ErrorCollection {
          errorMessages
          status
          errors
        }
      }
    }
  }
`
), XA = Ki(
  /* GraphQL */
  `
  query findUsers($query: String) {
    Jira {
      findUsers(query: $query) {
        accountId
        displayName
        self
        active
        avatarUrls {
          _24x24
        }
      }
    }
  }
`
), pg = new RegExp("[a-zA-Z0-9_]{2,}-[0-9]+"), ZA = new RegExp(`^${pg.source}$`), e2 = new RegExp(`/${pg.source}$`), tx = new RegExp(
  `.+?[&?]selectedIssue=(${pg.source})[&?]?.*`
);
function n1(e, n) {
  const r = { jira: { issues: [] } }, [i, a] = me([]), [o, s] = me([]), [l, d] = me(), { track: m } = Cn(), { showNotification: u, showModal: f, useLazyQuery: h, useMutation: k } = hn(), {
    loading: C,
    data: N,
    error: j,
    store: _
  } = jy(e ?? null), [
    g,
    { loading: D, error: O, data: I }
  ] = h(e1, {
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    const se = I?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    se?.length && (s(se), a(se.map((he) => he?.key).filter(Boolean)));
  }, [I]), Qe(
    () => d(j || O || void 0),
    [j, O]
  ), Qe(
    () => {
      C || Y();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [N?.jira?.issues, C]
  );
  const F = async (se, he) => {
    await _(se).then(() => {
      u({
        icon: "check-circle-filled",
        severity: "success",
        title: he.success.title,
        text: he.success.text
      });
    }).catch((V) => {
      u({
        title: he.error.title,
        text: `${he.error.text} ${V.message && " (" + V.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, [L] = k(KA, {
    onError: (se) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to create a link back from the issue to the conversation. Please create it manually in Jira.
				${se.message && " (" + se.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), K = (se, he) => {
    const V = window.location.href, ke = he ? V.replace(
      e?.toString() ?? "",
      he?.toString()
    ) : V, De = he ? `# ${he}` : `# ${e}`;
    L({
      variables: {
        issueKey: se,
        title: De,
        url: ke,
        globalId: `system=${ke}`
      }
    });
  }, [J] = k(GA, {
    onError: (se) => {
      u({
        title: "Something went wrong",
        text: `It looks like something went wrong when trying to remove a link back from the issue to the conversation. Please remove it manually from Jira.
					${se.message && " (" + se.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  }), te = (se) => {
    const he = window.location.href;
    J({
      variables: {
        issueKey: se,
        globalId: `system=${he}`
      }
    });
  }, W = (se) => ({
    jiraInstanceUrl: n,
    jiraIssueKey: se
  }), Y = () => {
    N && N.jira?.issues?.length > 0 ? g({
      variables: {
        jql: `key in (${N?.jira?.issues.join(",")})`,
        maxResults: 15
      }
    }) : s([]);
  }, P = async (se, he) => {
    m("jira:issue:link:clicked", W(se));
    const V = N?.jira?.issues ? N : r;
    V.jira.issues = Array.from(
      new Set(V.jira.issues).add(se)
    ), await _(V, he?.toString()).then(() => K(se, he)).catch((ke) => {
      u({
        title: "Linking failed",
        text: `Linking ${se} failed. Please try again. ${ke.message && " (" + ke.message + ")"}`,
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    });
  }, B = (se) => {
    m("jira:issue:link:clicked", W(se));
    const he = N?.jira?.issues ? N : r;
    he.jira.issues = Array.from(
      new Set(he.jira.issues).add(se)
    ), F(he, {
      success: {
        title: "Jira issue linked",
        text: `You linked the Jira issue ${se} to this conversation.`
      },
      error: {
        title: "Linking failed",
        text: `Linking ${se} failed. Please try again.`
      }
    }).then(() => K(se));
  }, re = (se) => {
    m("jira:issue:unlink:clicked", W(se)), f({
      headline: `Unlink issue ${se}?`,
      text: `You are about to unlink the issue ${se}. Do you want to proceed?`,
      confirmLabel: "Unlink Jira issue",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink:confirmed", W(se));
        const he = {
          ...N,
          jira: {
            ...N?.jira,
            issues: N?.jira?.issues.filter((V) => V !== se) || []
          }
        };
        F(he, {
          success: {
            title: "Jira issue unlinked",
            text: `You unlinked the Jira issue ${se}`
          },
          error: {
            title: "Unlinking failed",
            text: `Unlinking ${se} failed.`
          }
        }).then(() => te(se));
      },
      onCancel: () => m("jira:issue:unlink:cancelled", W(se))
    });
  }, je = () => {
    m("jira:issue:unlink-all:clicked", { jiraInstanceUrl: n }), f({
      headline: "Unlink all Jira issues?",
      text: "You are about to unlink the all Jira issues from the conversation. Do you want to proceed?",
      confirmLabel: "Unlink ALL issues",
      confirmVariant: "danger",
      cancelLabel: "Cancel",
      onConfirm: () => {
        m("jira:issue:unlink-all:confirmed", { jiraInstanceUrl: n }), o?.forEach((se) => se?.key && te(se.key)), F(r, {
          success: {
            title: "Unlinking successful",
            text: "All Jira issues were unlinked"
          },
          error: {
            title: "Unlinking failed",
            text: "Unlinking all issues failed."
          }
        });
      },
      onCancel: () => m("jira:issue:unlink-all:cancelled", { jiraInstanceUrl: n })
    });
  }, ue = N?.jira?.issues?.filter(
    (se) => !i?.includes(se)
  ) || [];
  return {
    linkIssue: B,
    linkIssueQuietly: P,
    unlinkIssue: re,
    loadIssues: Y,
    removeDanglingIssueLinks: () => {
      m("jira:issue:unlink-all-dangling:clicked", {
        jiraInstanceUrl: n
      });
      const se = {
        ...N,
        jira: {
          ...N?.jira,
          issues: N?.jira?.issues.filter(
            (he) => !ue.includes(he)
          ) || []
        }
      };
      _(se);
    },
    unlinkAllIssues: je,
    maybeExtractIssueKey: (se) => {
      const he = se.replace(/\s/g, "");
      if (ZA.test(he))
        return he;
      if (tx.test(se))
        return se.match(tx)?.[1];
      if (se.startsWith(n) && e2.test(se))
        return se.substring(se.lastIndexOf("/") + 1);
    },
    isLoadingIssueLinks: C,
    danglingIssueLinks: ue,
    isLoadingIssues: D,
    issues: o,
    error: l
  };
}
function n2(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copyToClipboard: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const t2 = "_result_1wiub_54", r2 = "_resultName_1wiub_74", i2 = "_resultNameIcon_1wiub_82", a2 = "_resultDescription_1wiub_87", o2 = "_resultLinkIcon_1wiub_99", s2 = "_tooltip_1wiub_108", l2 = "_tooltipContent_1wiub_114", c2 = "_tooltipName_1wiub_121", d2 = "_tooltipNameIcon_1wiub_126", u2 = "_tooltipDescription_1wiub_131", m2 = "_tooltipSummary_1wiub_139", p2 = "_tooltipTag_1wiub_143", vr = {
  result: t2,
  resultName: r2,
  resultNameIcon: i2,
  resultDescription: a2,
  resultLinkIcon: o2,
  tooltip: s2,
  tooltipContent: l2,
  tooltipName: c2,
  tooltipNameIcon: d2,
  tooltipDescription: u2,
  tooltipSummary: m2,
  tooltipTag: p2
}, f2 = ({
  item: e,
  jiraInstanceUrl: n,
  onSelect: r,
  disableTooltip: i = !1,
  ...a
}) => {
  const { issuetype: o, name: s, status: l, text: d, description: m } = e, [u, f] = me(!1), h = ZC({
    avatarId: o?.avatarId,
    iconUrl: o?.iconUrl,
    jiraInstanceUrl: n
  });
  return /* @__PURE__ */ pe.jsx(
    Xe,
    {
      disabled: i,
      className: vr.tooltip,
      content: /* @__PURE__ */ pe.jsxs("div", { className: vr.tooltipContent, children: [
        /* @__PURE__ */ pe.jsxs(
          b,
          {
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            children: [
              /* @__PURE__ */ pe.jsxs("span", { className: vr.tooltipName, children: [
                /* @__PURE__ */ pe.jsx(
                  _l,
                  {
                    width: 16,
                    iconUrl: h,
                    className: vr.tooltipNameIcon
                  }
                ),
                " ",
                s
              ] }),
              /* @__PURE__ */ pe.jsx(Jn, { className: vr.tooltipTag, children: l.name })
            ]
          }
        ),
        m && /* @__PURE__ */ pe.jsx("div", { className: vr.tooltipSummary, children: m }),
        d && /* @__PURE__ */ pe.jsx("div", { className: vr.tooltipDescription, children: d })
      ] }),
      side: "left",
      light: !0,
      children: /* @__PURE__ */ pe.jsxs(
        "button",
        {
          ...a,
          className: vr.result,
          type: "button",
          onClick: () => {
            r(e);
          },
          onMouseEnter: () => f(!0),
          onMouseLeave: () => f(!1),
          children: [
            /* @__PURE__ */ pe.jsxs(
              b,
              {
                flexDirection: "column",
                justifyContent: "center",
                style: {
                  width: u ? "calc(100% - 32px)" : "100%"
                },
                children: [
                  /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", children: /* @__PURE__ */ pe.jsxs("span", { className: vr.resultName, children: [
                    /* @__PURE__ */ pe.jsx(
                      _l,
                      {
                        width: 16,
                        iconUrl: h,
                        className: vr.resultNameIcon
                      }
                    ),
                    " ",
                    s
                  ] }) }),
                  m && /* @__PURE__ */ pe.jsx("div", { className: vr.resultDescription, children: m })
                ]
              }
            ),
            u && /* @__PURE__ */ pe.jsx(
              ve,
              {
                className: vr.resultLinkIcon,
                name: "plus",
                size: 32
              }
            )
          ]
        }
      )
    }
  );
}, h2 = ({
  className: e,
  searched: n,
  jiraInstanceUrl: r
}) => /* @__PURE__ */ pe.jsx(
  Lt,
  {
    slotEnd: /* @__PURE__ */ pe.jsx(ve, { name: "external-link" }),
    variant: "tertiary",
    style: { width: "100%" },
    className: e,
    navigate: () => {
      window.open(
        `${r}/secure/QuickSearch.jspa?searchString=${n}`,
        "_blank"
      )?.focus();
    },
    children: "View matching issues in Jira"
  }
), y2 = ({
  onSelectIssue: e,
  jiraInstanceUrl: n,
  filterByProjectKey: r,
  disableTooltip: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = me([]), [l, d] = me(""), [m, { loading: u, error: f, data: h, networkStatus: k }] = a(e1, {
    notifyOnNetworkStatusChange: !0
  }), { maybeExtractIssueKey: C } = n1(null, n);
  ki(
    () => {
      !u && l && k === tr.ready ? m({
        variables: {
          jql: l,
          maxResults: 25
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    const O = h?.Jira?.searchAndReconsileIssuesUsingJql?.issues || [];
    s(
      O.map((I) => ({
        id: I?.key ?? "",
        name: I?.key ?? "",
        description: I?.fields.summary,
        status: I?.fields.status,
        issuetype: I?.fields.issuetype,
        text: I?.fields.description ? mg(I?.fields.description, XC) : /* @__PURE__ */ pe.jsx(pe.Fragment, {})
      }))
    );
  }, [h]);
  const N = (O) => {
    e(O.id), d("");
  }, j = (O) => {
    const I = O.trim(), F = C(I);
    if (F) {
      const L = F.replaceAll("[-_|]", "\\\\$0");
      d(`key = '${L}'`);
    } else I !== "" && d(
      `text ~ '${I}'${r ? " and project = " + r : ""}`
    );
  }, _ = () => {
    d("");
  }, g = (O) => /* @__PURE__ */ pe.jsx(h2, { ...O, jiraInstanceUrl: n }), D = (O) => /* @__PURE__ */ pe.jsx(
    f2,
    {
      ...O,
      jiraInstanceUrl: n,
      disableTooltip: i
    }
  );
  return !u && f ? /* @__PURE__ */ pe.jsx(En, { error: f }) : /* @__PURE__ */ pe.jsx(
    Tr,
    {
      items: o,
      loading: u,
      onSearch: j,
      onSelect: N,
      onClear: _,
      emptyMessage: l ? u ? "" : "No Jira Issues found" : "Enter Jira issue key, link or search terms",
      suggestionComponent: g,
      itemComponent: D,
      placeholder: "Search and link existing issue",
      searchable: !0,
      clearable: !0
    }
  );
}, g2 = ({
  field: e,
  value: n,
  onChange: r
}) => {
  const [i, a] = me(n ? [n] : []), o = (s, l) => {
    a(
      l ? [...i, s] : i.filter(({ id: d }) => d !== s.id)
    );
  };
  return Qe(() => {
    r(i);
  }, [i]), /* @__PURE__ */ pe.jsx(
    Tr,
    {
      multiple: !0,
      onChange: o,
      selectedItems: i,
      items: e?.allowedValues?.map(
        ({ id: s, name: l, value: d }) => ({
          id: s,
          name: l || d
        })
      )
    }
  );
}, v2 = "_itemButton_1hl53_1", k2 = "_result_1hl53_6", b2 = "_resultIcon_1hl53_26", _2 = "_resultName_1hl53_30", x2 = "_resultCheckIcon_1hl53_38", Xa = {
  itemButton: v2,
  result: k2,
  resultIcon: b2,
  resultName: _2,
  resultCheckIcon: x2
}, Zh = ({
  item: e,
  checked: n = !1,
  onSelectItem: r,
  jiraInstanceUrl: i
}) => {
  const a = (s) => {
    const l = s.indexOf("/rest/api/");
    return l >= 0 ? `${i}${s?.substring(l)}` : s;
  };
  let o = e?.iconUrl || e?.avatarUrls?._24x24 || null;
  return o && (o = o?.startsWith("https://api.atlassian.com/ex/") ? a(o) : o), /* @__PURE__ */ pe.jsx(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      width: "100%",
      "data-testid": "jira-select-item-component",
      children: /* @__PURE__ */ pe.jsx(
        "button",
        {
          onClick: () => {
            r(e);
          },
          className: Xa.itemButton,
          children: /* @__PURE__ */ pe.jsxs(b, { className: Xa.result, flexDirection: "row", width: "100%", children: [
            /* @__PURE__ */ pe.jsx(
              _l,
              {
                width: 36,
                iconUrl: o || "",
                className: Xa.resultIcon
              }
            ),
            /* @__PURE__ */ pe.jsx(st, { className: Xa.resultName, children: e.name }),
            n && /* @__PURE__ */ pe.jsx(st, { className: Xa.resultCheckIcon, children: /* @__PURE__ */ pe.jsx(ve, { name: "done" }) })
          ] })
        }
      )
    }
  );
}, S2 = ({
  selectedItems: e,
  agentEmail: n,
  onSelect: r,
  jiraInstanceUrl: i
}) => {
  const { useLazyQuery: a } = hn(), [o, s] = me([]), [l, d] = me(), m = 2, [u, { loading: f, error: h, data: k, networkStatus: C }] = a(XA, {
    notifyOnNetworkStatusChange: !0
  });
  return ki(
    () => {
      !f && l && l.length >= m && C === tr.ready ? u({
        variables: {
          query: l,
          maxResults: 10
        }
      }) : s([]);
    },
    500,
    [l]
  ), Qe(() => {
    n && u({
      variables: {
        query: n,
        maxResults: 1
      }
    }).then((N) => {
      if (N?.data?.Jira.findUsers?.length === 1) {
        const j = N?.data?.Jira?.findUsers[0];
        r(j.accountId), s([
          {
            id: j.accountId,
            name: j.displayName
          }
        ]);
      }
    });
  }, []), Qe(() => {
    const N = k?.Jira?.findUsers || [];
    s(
      N.filter(({ active: j }) => j).map(({ accountId: j, displayName: _, avatarUrls: g, active: D }) => ({
        id: j,
        name: _,
        avatarUrls: g,
        active: D
      }))
    );
  }, [k]), !f && h ? /* @__PURE__ */ pe.jsx(En, { error: h }) : /* @__PURE__ */ pe.jsx(
    Tr,
    {
      clearable: !0,
      searchable: !0,
      items: o,
      loading: f,
      onSearch: (N) => d(N),
      onSelect: r,
      onClear: () => d(void 0),
      selectedItems: e,
      emptyMessage: l ? f ? "" : "No user found" : "Enter keyword to search for user",
      itemComponent: ({ item: N, onSelect: j, checked: _ }) => /* @__PURE__ */ pe.jsx(
        Zh,
        {
          item: N,
          checked: _,
          onSelectItem: j,
          jiraInstanceUrl: i
        }
      ),
      placeholder: "Search Jira users"
    }
  );
}, rx = ({
  field: e
}) => {
  const [n, r] = me(!1), [i, a] = WC();
  return Qe(() => {
    const o = n ? window.setTimeout(() => r(!1), 2e3) : void 0;
    return () => window.clearTimeout(o);
  }, [n]), /* @__PURE__ */ pe.jsxs(b, { alignItems: "center", gap: "400", justifyContent: "space-between", children: [
    /* @__PURE__ */ pe.jsx(b, { children: /* @__PURE__ */ pe.jsx(ve, { size: 24, name: "exclamation-triangle-filled", color: "red.500" }) }),
    /* @__PURE__ */ pe.jsx($.Paragraph, { children: "Your organizations Jira configuration is currently not fully supported by Dixa. Please reach out so we can have a look at this field. Please, attach a copy of the field details when contacting us. You can use the copy button to do so." }),
    /* @__PURE__ */ pe.jsx(Xe, { content: n ? "Copied" : "Copy field details", children: /* @__PURE__ */ pe.jsx(
      ir,
      {
        variant: "secondary",
        icon: n ? "done" : "copy",
        onClick: () => {
          a(JSON.stringify(e, null, 2)), r(!0);
        }
      }
    ) })
  ] });
}, N2 = ({
  field: e,
  onChange: n,
  value: r,
  conversationContext: i,
  jiraInstanceUrl: a
}) => {
  const { type: o, system: s } = e.schema;
  if (["array", "option", "priority"].includes(o) && (!e?.allowedValues || e.allowedValues.length === 0))
    return /* @__PURE__ */ pe.jsx(rx, { field: e });
  switch (o) {
    case "issuelink":
    case "environment":
    case "any":
      return /* @__PURE__ */ pe.jsx(dr, { onChange: n, value: r });
    case "string":
      return s === "description" ? /* @__PURE__ */ pe.jsx(qh, { onChange: n, value: r }) : /* @__PURE__ */ pe.jsx(dr, { onChange: n, value: r });
    case "textarea":
      return /* @__PURE__ */ pe.jsx(qh, { onChange: n, value: r });
    case "number":
      return /* @__PURE__ */ pe.jsx(dr, { type: "number", onChange: n, value: r });
    case "user":
      return /* @__PURE__ */ pe.jsx(
        S2,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          agentEmail: e.key === "reporter" && i?.agent?.email || void 0,
          jiraInstanceUrl: a
        }
      );
    case "option":
    case "priority":
      return /* @__PURE__ */ pe.jsx(
        Tr,
        {
          onSelect: n,
          selectedItems: r ? [r] : [],
          items: e?.allowedValues?.map(
            ({ id: l, name: d, value: m }) => ({
              id: l,
              name: d || m
            })
          ) || []
        }
      );
    case "array":
      return /* @__PURE__ */ pe.jsx(g2, { field: e, value: r, onChange: n });
    default:
      return /* @__PURE__ */ pe.jsx(rx, { field: e });
  }
}, j2 = ["description", "reporter", "summary"], w2 = ({
  issueTypeFields: e,
  control: n,
  jiraInstanceUrl: r,
  conversationContext: i,
  errors: a
}) => /* @__PURE__ */ pe.jsx(pe.Fragment, { children: e.filter(({ key: o }) => o !== "project" && o !== "issuetype").filter(
  ({ key: o, required: s }) => s || j2.includes(o)
).map((o) => /* @__PURE__ */ pe.jsx(
  bt,
  {
    control: n,
    render: ({ field: { onChange: s, value: l } }) => /* @__PURE__ */ pe.jsx(
      We,
      {
        meta: {
          error: a && o.key in a ? a[o.key].message : null
        },
        label: o.name,
        required: o.required,
        children: N2({
          field: o,
          onChange: s,
          value: l,
          conversationContext: i,
          jiraInstanceUrl: r
        })
      },
      o.key
    ),
    name: o.key,
    rules: {
      required: o.required ? "This field is required" : !1
    }
  },
  o.key
)) }), C2 = ({
  createdIssue: e,
  issueBaseLink: n,
  issueLinkCopied: r,
  setIssueLinkCopied: i,
  copyToClipboard: a
}) => /* @__PURE__ */ pe.jsxs(
  b,
  {
    flexDirection: "column",
    gap: "400",
    "data-testid": "jira-create-issue-success-message",
    children: [
      /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
        "You can visit your new issue by following",
        " ",
        /* @__PURE__ */ pe.jsxs(
          $.ExternalLink,
          {
            href: `${n}/${e.key}`,
            target: "_blank",
            children: [
              "this link ",
              /* @__PURE__ */ pe.jsx(ve, { name: "external-link" })
            ]
          }
        ),
        " ",
        "or copy it from the field below."
      ] }),
      /* @__PURE__ */ pe.jsx(We, { label: "Jira issue link", children: /* @__PURE__ */ pe.jsx(
        dr,
        {
          readOnly: !0,
          value: `${n}/${e.key}`,
          suffix: {
            type: "button",
            button: {
              icon: r ? "done" : "copy",
              onClick: () => {
                i(!0), a(`${n}/${e.key}`);
              }
            }
          }
        }
      ) })
    ]
  }
), F2 = "_modalBody_1hk1o_1", I2 = "_modalBodyFormFields_1hk1o_4", ix = {
  modalBody: F2,
  modalBodyFormFields: I2
}, E2 = (e) => ({
  version: 1,
  type: "doc",
  content: e?.trim()?.split(`
`).filter((n) => n !== "").map((n) => ({
    type: "paragraph",
    content: [
      {
        type: "text",
        text: n
      }
    ]
  }))
}), $2 = (e) => e?.custom?.split(":")?.[1] || null, T2 = (e, n) => {
  if (e.startsWith("customfield_")) {
    const r = n.find((i) => i.key === e)?.schema;
    if (r)
      return r;
  }
  return null;
}, O2 = (e, n) => {
  const r = ["environment", "textarea", "description"];
  return {
    fields: {
      ...Object.entries(e).reduce((i, [a, o]) => {
        if (!o || o === "")
          return delete e[a], i;
        const s = T2(a, n), l = $2(s) ?? a;
        return r.includes(l) ? i[a] = E2(o) : s?.type === "number" ? i[a] = parseInt(o) : i[a] = o, i;
      }, {}),
      summary: e.summary,
      project: { id: e.project.id },
      issuetype: { id: e.issuetype.id },
      ...e?.parent && { parent: { key: e.parent } },
      ...e?.reporter && {
        reporter: { id: e.reporter?.id ?? e.reporter }
      },
      ...e?.assignee && {
        assignee: { id: e.assignee?.id ?? e.assignee }
      }
    }
  };
}, R2 = ({
  isOpen: e,
  onClose: n,
  linkIssueQuietly: r,
  conversationContext: i,
  jiraInstanceUrl: a,
  hasSortIssueTypeByLabelEnabled: o
}) => {
  const s = { project: void 0, issuetype: void 0 }, [l, d] = me([]), [m, u] = me(), [f, h] = me(0), [k, C] = me([]), [N, j] = me([]), [_, g] = me(!1), [D, O] = me(!1), [I, F] = me({}), { track: L } = Cn(), { isCopied: K, copyToClipboard: J } = n2(), te = Xn(() => i?.conversationId, [e]), { useMutation: W, useLazyQuery: Y, showNotification: P } = hn(), {
    control: B,
    handleSubmit: re,
    formState: { errors: je },
    reset: ue,
    setValue: se,
    getValues: he
  } = ut({
    defaultValues: s
  }), V = N.length > 0, ke = `${a}/browse`, De = Object.keys(I).length > 0, [q, { loading: Ge, error: sn }] = Y(YA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      d(le.Jira.getAllProjects);
    },
    onError: (le) => {
      P({
        title: "Could not get project list",
        text: "We could not fetch the list of your projects. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error response when fetching projects", le), d([]);
    }
  }), [
    Ie,
    { loading: Ue, error: Re }
  ] = Y(JA, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (le) => {
      h(0);
      const xe = le?.Jira?.getCreateIssueMeta?.projects[0];
      if (xe) {
        const Ve = xe?.issuetypes.filter(
          ({ subtask: Pe }) => !Pe
        );
        C(Ve || []), se(
          "issuetype",
          Ve.length > 0 ? Ve[0] : void 0
        );
      } else
        P({
          title: "Could not get issue-type list",
          text: "It seems that there are no issue-types for this project or you might not have the necessary access rights to view them.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), C([]), j([]);
    },
    onError: (le) => {
      P({
        title: "Could not get issue list",
        text: "We could not fetch the list of issue-types for this project. Please try again later.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), console.warn("Error in getCreateIssueMeta", le), C([]), j([]), h(0);
    }
  }), [Be, { error: Ae }] = W(
    QA,
    {
      onError: () => {
        g(!1), P({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), L("jira:issue:create:failed", { jiraInstanceUrl: a });
      },
      onCompleted: (le) => {
        if (g(!1), le?.Jira && "key" in le.Jira.createIssue)
          u(le?.Jira?.createIssue), P({
            title: "Success",
            text: `Jira issue '${le.Jira.createIssue.key}' created`,
            icon: "check-circle-filled",
            severity: "success"
          }), L("jira:issue:create:succeeded", {
            jiraInstanceUrl: a,
            jiraIssueKey: le.Jira.createIssue.key
          }), te && r(
            le.Jira.createIssue.key,
            te
          );
        else if ("errorMessages" in le.Jira.createIssue || "errors" in le.Jira.createIssue) {
          const xe = le?.Jira?.createIssue?.errors;
          console.warn("There was a problem creating a Jira issue.", xe), P({
            title: "Creation was not successful",
            text: "Something went wrong. Please get in contact with Dixa.",
            icon: "exclamation-triangle-filled",
            severity: "warning"
          });
        }
      }
    }
  ), Je = (le) => {
    g(!0), F({}), Be({
      variables: {
        input: O2(le, N)
      }
    });
  };
  Qe(() => {
    if (e)
      try {
        q();
      } catch (le) {
        console.warn("Error when fetching initial projects", le);
      }
  }, [e]), Qe(() => {
    const le = D ? window.setTimeout(() => O(!1), 2e3) : void 0;
    return () => window.clearTimeout(le);
  }, [D]), Qe(() => {
    if (k?.length > 0) {
      se("issuetype", k[f]);
      const le = k[f]?.fields?.additionalProperties;
      if (le?.length > 0) {
        const xe = le.map(
          ({ value: Q }) => Q
        ), Ve = (o ? xe.sort(({ name: Q }, { name: E }) => Q.localeCompare(E)) : xe).sort(
          ({ required: Q }, { required: E }) => Number(E) - Number(Q)
        ), { project: Pe, issuetype: vn } = he();
        ue({ project: Pe, issuetype: vn }), j(Ve);
      }
    } else
      j([]), se("issuetype", void 0);
  }, [k, se, f]), Qe(() => {
    if (Ae && Cw(Ae)) {
      if (Ae?.graphQLErrors?.length > 0) {
        const { graphQLErrors: le } = Ae, xe = le[0].extensions?.integration?.responseBody;
        try {
          const Ve = JSON.parse(xe);
          if (Ve?.errors) {
            const Pe = Object.keys(Ve.errors).reduce(
              (vn, Q) => ({
                ...vn,
                [Q]: {
                  type: "required",
                  message: Ve.errors[Q],
                  ref: {
                    name: Q
                  }
                }
              }),
              {}
            );
            F(Pe);
          }
        } catch {
        }
      }
    } else
      F({});
  }, [Ae]);
  const $e = () => {
    d([]), j([]), C([]), u(void 0), h(0), g(!1), F({});
  }, Me = () => {
    $e(), ue(s), n();
  }, en = (le) => {
    le && Ie({
      variables: {
        projectKey: le
      }
    });
  }, oe = (le) => {
    const xe = k.map((Ve) => Ve.id).indexOf(le);
    h(xe ?? 0);
  };
  return /* @__PURE__ */ pe.jsxs(
    wt,
    {
      isOpen: e,
      "data-testid": "jira-create-issue-modal",
      onClose: Me,
      children: [
        /* @__PURE__ */ pe.jsx(
          Ct,
          {
            title: m ? "Issue creation successful" : "Create new Jira issue",
            onClose: Me
          }
        ),
        /* @__PURE__ */ pe.jsxs(Ft, { className: ix.modalBody, children: [
          !Ge && sn && /* @__PURE__ */ pe.jsx(En, { error: sn, retry: q }),
          !Ue && Re && /* @__PURE__ */ pe.jsx(
            En,
            {
              error: Re,
              retry: Ie
            }
          ),
          !_ && De && /* @__PURE__ */ pe.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ pe.jsx(
            Cy,
            {
              variant: "warning",
              description: /* @__PURE__ */ pe.jsxs(
                b,
                {
                  gap: "300",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  children: [
                    /* @__PURE__ */ pe.jsx($.Paragraph, { variant: "4", children: "The form contains input validation errors. Please correct them and try again to save. If your inputs seem fine, please contact our support team and provide the form schema to debug further." }),
                    /* @__PURE__ */ pe.jsx(
                      ct,
                      {
                        icon: K ? "done" : "copy",
                        variant: "secondary",
                        onClick: () => J(JSON.stringify(N, null, 2)),
                        children: "Copy form schema"
                      }
                    )
                  ]
                }
              )
            }
          ) }),
          m ? /* @__PURE__ */ pe.jsx(
            C2,
            {
              createdIssue: m,
              issueBaseLink: ke,
              issueLinkCopied: D,
              setIssueLinkCopied: O,
              copyToClipboard: J
            }
          ) : /* @__PURE__ */ pe.jsx(
            "form",
            {
              "data-testid": "jira-create-issue-form",
              onSubmit: re(Je),
              children: /* @__PURE__ */ pe.jsxs(nt, { children: [
                /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: "Project", required: !0, children: /* @__PURE__ */ pe.jsx(
                  bt,
                  {
                    control: B,
                    name: "project",
                    rules: { required: "Please select a project" },
                    render: ({ field: { onChange: le, value: xe } }) => /* @__PURE__ */ pe.jsx(
                      Tr,
                      {
                        searchable: !0,
                        loading: Ge,
                        onSelect: (Ve) => {
                          en(Ve.key), le(Ve);
                        },
                        selectedItems: [xe],
                        placeholder: "Select Jira project",
                        emptyMessage: sn ? "No projects found" : "No projects available",
                        items: l || [],
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: vn }) => /* @__PURE__ */ pe.jsx(
                          Zh,
                          {
                            item: Ve,
                            checked: vn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: "Issue type", required: !0, children: /* @__PURE__ */ pe.jsx(
                  bt,
                  {
                    control: B,
                    name: "issuetype",
                    rules: { required: "Please select an issue type" },
                    render: ({ field: { onChange: le, value: xe } }) => /* @__PURE__ */ pe.jsx(
                      Tr,
                      {
                        disabled: k.length === 0,
                        loading: Ue,
                        onSelect: (Ve) => {
                          oe(Ve.id), le(Ve);
                        },
                        selectedItems: [xe],
                        placeholder: k.length > 0 ? "Select Jira issue type" : "",
                        emptyMessage: Re ? "No issues found" : "No issues available",
                        items: k,
                        itemComponent: ({ item: Ve, onSelect: Pe, checked: vn }) => /* @__PURE__ */ pe.jsx(
                          Zh,
                          {
                            item: Ve,
                            checked: vn,
                            onSelectItem: Pe,
                            jiraInstanceUrl: a
                          }
                        )
                      }
                    )
                  }
                ) }) }),
                V && // Wrapping all dynamic input fields inside one `FormField`
                // which can handle the overflow scrolling in case we get many
                // input fields in the form
                /* @__PURE__ */ pe.jsx(Z, { className: ix.modalBodyFormFields, children: /* @__PURE__ */ pe.jsx(
                  w2,
                  {
                    control: B,
                    errors: { ...je, ...I },
                    getValues: he,
                    conversationContext: i,
                    jiraInstanceUrl: a,
                    issueTypeFields: N
                  }
                ) })
              ] })
            }
          )
        ] }),
        /* @__PURE__ */ pe.jsx(
          Et,
          {
            confirmOnClick: m ? Me : re(Je),
            confirmProps: {
              disabled: !V,
              isLoading: _,
              loadingIndicator: /* @__PURE__ */ pe.jsx(fn, { size: 16 })
            },
            confirmName: m ? "Close" : "Save",
            cancelOnClick: m ? void 0 : Me
          }
        )
      ]
    }
  );
}, D2 = (e) => {
  if (!e) return "";
  const n = "https://", r = (e.startsWith(n) ? e.slice(n.length) : e).split("/")[0];
  return `${n}${r}`;
}, P2 = (e) => {
  if (!e?.trim())
    return "Please add a value";
  const n = "https://";
  if (e.startsWith(" ") || e.endsWith(" "))
    return "Please remove any empty spaces before or after the URL";
  const r = e.startsWith(n);
  if (r) {
    const i = e.slice(n.length).split("/");
    if (i.length > 1) {
      const a = r ? n.length + i[0].length : i[0].length;
      return i.length === 2 && i[1] === "" ? "Please remove the trailing slash `/`" : `Please remove the trailing path \`${e.slice(a)}\``;
    }
  } else
    return e.includes("://") ? `The protocol \`${e.substring(
      0,
      e.indexOf("://") + 3
    )}\` is not supported` : `Please add \`${n}\` as protocol`;
}, A2 = "_wrapper_1bylq_1", L2 = "_inputWrapper_1bylq_6", V2 = "_inputSeparator_1bylq_18", z2 = "_buttonLink_1bylq_23", U2 = "_noIssuesFound_1bylq_27", Za = {
  wrapper: A2,
  inputWrapper: L2,
  inputSeparator: V2,
  buttonLink: z2,
  noIssuesFound: U2
}, M2 = ({
  conversationContext: e,
  settings: n
}) => {
  const { track: r } = Cn(), i = D2(n?.jiraSiteUrl), [a, o] = me(!1), s = !!e?.conversationId, {
    linkIssue: l,
    linkIssueQuietly: d,
    unlinkIssue: m,
    unlinkAllIssues: u,
    loadIssues: f,
    removeDanglingIssueLinks: h,
    danglingIssueLinks: k,
    isLoadingIssueLinks: C,
    isLoadingIssues: N,
    issues: j,
    error: _
  } = n1(
    s ? e.conversationId : null,
    i
  ), g = !!n?.enableCreateIssue, D = !!n?.enableSortIssueTypeByLabel, O = !!(j?.length || k?.length), I = !!n?.enableRemoveAllLinks && O, F = !C && !N && k?.length > 0 && !!n?.showDanglingLinks;
  return !N && _ ? /* @__PURE__ */ pe.jsx(En, { error: _, retry: () => f() }) : /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
    /* @__PURE__ */ pe.jsxs(b, { className: Za.wrapper, flexDirection: "column", children: [
      /* @__PURE__ */ pe.jsxs(b, { className: Za.inputWrapper, flexDirection: "column", children: [
        g && /* @__PURE__ */ pe.jsxs(pe.Fragment, { children: [
          /* @__PURE__ */ pe.jsx(
            ct,
            {
              variant: "primary",
              onClick: () => o(!0),
              style: {
                minHeight: "38px"
              },
              children: "Create new issue"
            }
          ),
          /* @__PURE__ */ pe.jsx("div", { className: Za.inputSeparator, children: "or" })
        ] }),
        /* @__PURE__ */ pe.jsx(
          y2,
          {
            onSelectIssue: l,
            jiraInstanceUrl: i
          }
        )
      ] }),
      N ? /* @__PURE__ */ pe.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ pe.jsx(fn, { "data-testid": "jira-widget-issue-spinner" }) }) : j?.length ? /* @__PURE__ */ pe.jsx(
        LA,
        {
          issues: j,
          jiraInstanceUrl: i,
          unlinkIssue: m
        }
      ) : /* @__PURE__ */ pe.jsx($.Paragraph, { align: "center", className: Za.noIssuesFound, children: "No linked issues found" }),
      I && j?.length > 0 && /* @__PURE__ */ pe.jsx(
        ct,
        {
          variant: "secondary",
          disabled: !j?.length && !k?.length,
          onClick: u,
          children: "Unlink all issues"
        }
      ),
      F && /* @__PURE__ */ pe.jsxs(
        b,
        {
          background: "neutral.100",
          padding: "300",
          borderRadius: "100",
          flexDirection: "column",
          gap: "200",
          children: [
            /* @__PURE__ */ pe.jsx($.Heading, { variant: "heading-3", children: "Unresolved linked issues" }),
            /* @__PURE__ */ pe.jsx(b, { flexDirection: "row", flexWrap: "wrap", gap: "100", children: k.map((L) => /* @__PURE__ */ pe.jsx(Jn, { onDelete: () => m(L), children: L }, L)) }),
            /* @__PURE__ */ pe.jsx(
              ct,
              {
                variant: "secondary",
                onClick: () => h(),
                icon: "link-slash",
                children: "Remove all unresolved issues"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ pe.jsx(
        Lt,
        {
          slotEnd: /* @__PURE__ */ pe.jsx(ve, { name: "external-link" }),
          variant: "tertiary",
          className: Za.buttonLink,
          navigate: () => {
            r("jira:view:jira:clicked", { jiraInstanceUrl: i }), window.open(i, "_blank")?.focus();
          },
          children: "Open Jira"
        }
      )
    ] }),
    a && /* @__PURE__ */ pe.jsx(
      R2,
      {
        isOpen: a,
        onClose: () => o(!1),
        linkIssueQuietly: d,
        conversationContext: e,
        jiraInstanceUrl: i,
        hasSortIssueTypeByLabelEnabled: D
      }
    )
  ] });
}, xl = [
  {
    key: "jiraSiteUrl",
    label: "Jira site URL",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "enableRemoveAllLinks",
    label: 'Enable the "Remove all links" button',
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showDanglingLinks",
    label: "Show unresolved links to Jira issues",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableSortIssueTypeByLabel",
    label: "Enable to sort the issue types by label",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  }
], B2 = (e) => {
  const n = P2(e);
  return typeof n == "string" ? n : !0;
}, eo = rr(xl), Ni = "JIRA", q2 = {
  enabled: !1,
  name: "",
  jiraSiteUrl: "",
  enableRemoveAllLinks: !1,
  showDanglingLinks: !1,
  enableCreateIssue: !0,
  enableSortIssueTypeByLabel: !1
}, H2 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: q2
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = ur({
    integrationId: e,
    integrationType: Ni,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: xl,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => hr(J, {
    fieldDefinitions: xl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ pe.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ pe.jsx(yr, { cause: k }),
        /* @__PURE__ */ pe.jsxs(nt, { children: [
          /* @__PURE__ */ pe.jsx(Z, { children: /* @__PURE__ */ pe.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(
            Pn,
            {
              name: "jiraSiteUrl",
              label: eo.jiraSiteUrl,
              control: l.control,
              rules: {
                validate: (J) => B2(J)
              },
              componentProps: {
                placeholder: 'Insert your Jira site URL, e.g. "https://your-site.atlassian.net/"',
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: eo.enableRemoveAllLinks, children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enableRemoveAllLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: eo.showDanglingLinks, children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "showDanglingLinks",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: eo.enableCreateIssue, children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3, children: /* @__PURE__ */ pe.jsx(We, { label: eo.enableSortIssueTypeByLabel, children: /* @__PURE__ */ pe.jsx(
            bn,
            {
              name: "enableSortIssueTypeByLabel",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ pe.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ pe.jsx(
            gi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Ni,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ pe.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ pe.jsx(
          gr,
          {
            integrationType: Ni,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ pe.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ pe.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ pe.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ pe.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  Ni,
                  " integration, all links between Dixa and ",
                  Ni,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
                  "All data in ",
                  Ni,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ pe.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  Ni,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._notificationText_1polx_1{color:var(--dixa-color-neutral-500)}._message_zrl8q_54{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}._message_zrl8q_54:hover,._messageIsOpen_zrl8q_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_zrl8q_65{cursor:pointer}._messageUnattended_zrl8q_68{text-decoration:line-through}._messageLabel_zrl8q_71{color:var(--dixa-typography-color-secondary)}._messageText_zrl8q_74{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_zrl8q_74::-webkit-scrollbar{width:7px;height:7px}._messageText_zrl8q_74::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_zrl8q_74::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_zrl8q_74::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._list_ld0hf_1{padding:0}._listItem_ld0hf_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_ld0hf_4:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._subscriptionError_1qhhx_1{color:var(--dixa-typography-color-error);font-size:var(--dixa-typography-size-200)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var km = { exports: {} }, no = {}, ax;
function W2() {
  if (ax) return no;
  ax = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return no.Fragment = r, no.jsx = s, no.jsxs = s, no;
}
var ks = {}, ox;
function K2() {
  return ox || (ox = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    ks.Fragment = i, ks.jsx = zn, ks.jsxs = Wn;
  })()), ks;
}
var sx;
function G2() {
  return sx || (sx = 1, process.env.NODE_ENV === "production" ? km.exports = W2() : km.exports = K2()), km.exports;
}
var ge = G2();
function Y2({
  query: e,
  options: n,
  delayMs: r
}) {
  const { useLazyQuery: i } = hn(), [a, o] = me([]), [s] = i(e, n), [l, d] = me(
    []
  );
  return Qe(() => () => {
    l.forEach((m) => window.clearTimeout(m));
  }, []), [async (m) => {
    const u = [];
    for (const [f, h] of m.entries()) {
      f !== 0 && await new Promise((C) => {
        const N = setTimeout(C, r);
        d([...l, N]);
      });
      const k = await s({
        variables: h
      });
      u.push(k);
    }
    o(u);
  }, a];
}
var t1 = /* @__PURE__ */ ((e) => (e.List = "list", e))(t1 || {}), ey = /* @__PURE__ */ ((e) => (e.Profile = "profile", e))(ey || {}), ny = /* @__PURE__ */ ((e) => (e.Subscribed = "SUBSCRIBED", e))(ny || {}), ty = /* @__PURE__ */ ((e) => (e.Unsubscribed = "UNSUBSCRIBED", e))(ty || {});
const J2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, Q2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, X2 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }] }, Z2 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListListResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "created" } }, { kind: "Field", name: { kind: "Name", value: "updated" } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "links" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "self" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, eL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "subscribeProfileToChannel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "relationships" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_subscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_create_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }, { kind: "ObjectField", name: { kind: "Name", value: "relationships" }, value: { kind: "Variable", name: { kind: "Name", value: "relationships" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, nL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "unsubscribeProfileByContact" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "attributes" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "bulk_unsubscribe_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "data" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "type" }, value: { kind: "EnumValue", value: "profile_subscription_bulk_delete_job" } }, { kind: "ObjectField", name: { kind: "Name", value: "attributes" }, value: { kind: "Variable", name: { kind: "Name", value: "attributes" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, tL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getEvents" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "pageSize" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_PositiveInt" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "receivedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "openedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "openedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "clickedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "clickedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "bouncedEmail" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "bouncedEmailEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "receivedSms" }, name: { kind: "Name", value: "get_events" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "receivedSmsEventsFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "sort" }, value: { kind: "EnumValue", value: "_datetime" } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "pageSize" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "GetEventResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "GetEventResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetEventResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "timestamp" } }, { kind: "Field", name: { kind: "Name", value: "event_properties" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, rL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFlowMessage" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "messageId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_flow_message" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "messageId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "definition" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_FlowEmail" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "preview_text" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, iL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getMetrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_metrics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetMetricResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, aL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileByFilter" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", alias: { kind: "Name", value: "profileByEmail" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "emailFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasEmail" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }, { kind: "Field", alias: { kind: "Name", value: "profileByPhoneNumber" }, name: { kind: "Name", value: "get_profiles" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "Variable", name: { kind: "Name", value: "phoneNumberFilter" } } }, { kind: "Argument", name: { kind: "Name", value: "page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_" }, value: { kind: "IntValue", value: "1" } }], directives: [{ kind: "Directive", name: { kind: "Name", value: "include" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "if" }, value: { kind: "Variable", name: { kind: "Name", value: "hasPhoneNumber" } } }] }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCollectionCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, oL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getProfileById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "properties" }, { kind: "EnumValue", value: "predictive_analytics" }] } }, { kind: "Argument", name: { kind: "Name", value: "additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "subscriptions" }, { kind: "EnumValue", value: "predictive_analytics" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetProfileResponseCompoundDocument" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "sms" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "marketing" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "consent" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" } }, { kind: "Field", name: { kind: "Name", value: "predictive_analytics" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "average_order_value" } }, { kind: "Field", name: { kind: "Name", value: "churn_probability" } }, { kind: "Field", name: { kind: "Name", value: "predicted_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_clv" } }, { kind: "Field", name: { kind: "Name", value: "total_clv" } }, { kind: "Field", name: { kind: "Name", value: "historic_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "predicted_number_of_orders" } }, { kind: "Field", name: { kind: "Name", value: "average_days_between_orders" } }, { kind: "Field", name: { kind: "Name", value: "expected_date_of_next_order" } }, { kind: "Field", name: { kind: "Name", value: "ranked_channel_affinity" } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, sL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getListsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_lists_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetListResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, lL = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getSegmentsByProfileId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "profileId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Klaviyo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "get_segments_for_profile" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "profileId" } } }, { kind: "Argument", name: { kind: "Name", value: "fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_" }, value: { kind: "ListValue", values: [{ kind: "EnumValue", value: "name" }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_GetSegmentResponseCollection" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ClientErrorResponseFragment" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "ServerErrorResponseFragment" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ClientErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ClientError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerErrorResponseFragment" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Klaviyo_ServerError_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "detail" } }, { kind: "Field", name: { kind: "Name", value: "source" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pointer" } }, { kind: "Field", name: { kind: "Name", value: "parameter" } }] } }] } }] } }] }, cL = {
  "\n  query getLists {\n    Klaviyo {\n      get_lists {\n        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {\n          data {\n            type\n            id\n            attributes {\n              name\n              created\n              updated\n            }\n            links {\n              self\n            }\n          }\n          links {\n            self\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": Z2,
  "\n  fragment ClientErrorResponseFragment on Klaviyo_ClientError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": J2,
  "\n  fragment ServerErrorResponseFragment on Klaviyo_ServerError_response {\n    errors {\n      id\n      code\n      title\n      detail\n      source {\n        pointer\n        parameter\n      }\n    }\n  }\n": Q2,
  "\n  mutation subscribeProfileToChannel(\n    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!\n    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!\n  ) {\n    Klaviyo {\n      bulk_subscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_create_job\n            attributes: $attributes\n            relationships: $relationships\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": eL,
  "\n  mutation unsubscribeProfileByContact(\n    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!\n  ) {\n    Klaviyo {\n      bulk_unsubscribe_profiles(\n        input: {\n          data: {\n            type: profile_subscription_bulk_delete_job\n            attributes: $attributes\n          }\n        }\n      ) {\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": nL,
  "\n  fragment GetEventResponseFragment on Klaviyo_GetEventResponseCollectionCompoundDocument {\n    data {\n      id\n      type\n      attributes {\n        timestamp\n        event_properties\n      }\n    }\n  }\n": X2,
  "\n  query getEvents(\n    $receivedEmailEventsFilter: String!\n    $openedEmailEventsFilter: String!\n    $clickedEmailEventsFilter: String!\n    $bouncedEmailEventsFilter: String!\n    $receivedSmsEventsFilter: String!\n    $pageSize: Klaviyo_PositiveInt!\n  ) {\n    Klaviyo {\n      receivedEmail: get_events(\n        filter: $receivedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      openedEmail: get_events(\n        filter: $openedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      clickedEmail: get_events(\n        filter: $clickedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      bouncedEmail: get_events(\n        filter: $bouncedEmailEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      receivedSms: get_events(\n        filter: $receivedSmsEventsFilter\n        sort: _datetime\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize\n      ) {\n        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {\n          ...GetEventResponseFragment\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": tL,
  "\n  query getFlowMessage($messageId: String!) {\n    Klaviyo {\n      get_flow_message(id: $messageId) {\n        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {\n          data {\n            id\n            type\n            attributes {\n              definition {\n                ... on Klaviyo_FlowEmail {\n                  preview_text\n                }\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": rL,
  "\n  query getMetrics {\n    Klaviyo {\n      get_metrics {\n        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": iL,
  "\n  query getProfileByFilter(\n    $emailFilter: String\n    $phoneNumberFilter: String\n    $hasEmail: Boolean!\n    $hasPhoneNumber: Boolean!\n  ) {\n    Klaviyo {\n      profileByEmail: get_profiles(\n        filter: $emailFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasEmail) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n      profileByPhoneNumber: get_profiles(\n        filter: $phoneNumberFilter\n        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1\n      ) @include(if: $hasPhoneNumber) {\n        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {\n          data {\n            id\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": aL,
  "\n  query getProfileById($profileId: String!) {\n    Klaviyo {\n      get_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          properties\n          predictive_analytics\n        ]\n        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [\n          subscriptions\n          predictive_analytics\n        ]\n      ) {\n        ... on Klaviyo_GetProfileResponseCompoundDocument {\n          data {\n            attributes {\n              subscriptions {\n                email {\n                  marketing {\n                    consent\n                  }\n                }\n                sms {\n                  marketing {\n                    consent\n                  }\n                }\n              }\n              properties\n              predictive_analytics {\n                average_order_value\n                churn_probability\n                predicted_clv\n                historic_clv\n                total_clv\n                historic_number_of_orders\n                predicted_number_of_orders\n                average_days_between_orders\n                expected_date_of_next_order\n                ranked_channel_affinity\n              }\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": oL,
  "\n  query getListsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_lists_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetListResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": sL,
  "\n  query getSegmentsByProfileId($profileId: String!) {\n    Klaviyo {\n      get_segments_for_profile(\n        id: $profileId\n        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]\n      ) {\n        ... on Klaviyo_GetSegmentResponseCollection {\n          data {\n            id\n            attributes {\n              name\n            }\n          }\n        }\n        ... on Klaviyo_ClientError_response {\n          ...ClientErrorResponseFragment\n        }\n        ... on Klaviyo_ServerError_response {\n          ...ServerErrorResponseFragment\n        }\n      }\n    }\n  }\n": lL
};
function Yr(e) {
  return cL[e] ?? {};
}
const dL = Yr(
  /* GraphQL */
  `
  query getEvents(
    $receivedEmailEventsFilter: String!
    $openedEmailEventsFilter: String!
    $clickedEmailEventsFilter: String!
    $bouncedEmailEventsFilter: String!
    $receivedSmsEventsFilter: String!
    $pageSize: Klaviyo_PositiveInt!
  ) {
    Klaviyo {
      receivedEmail: get_events(
        filter: $receivedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      openedEmail: get_events(
        filter: $openedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      clickedEmail: get_events(
        filter: $clickedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      bouncedEmail: get_events(
        filter: $bouncedEmailEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      receivedSms: get_events(
        filter: $receivedSmsEventsFilter
        sort: _datetime
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: $pageSize
      ) {
        ... on Klaviyo_GetEventResponseCollectionCompoundDocument {
          ...GetEventResponseFragment
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), uL = Yr(
  /* GraphQL */
  `
  query getFlowMessage($messageId: String!) {
    Klaviyo {
      get_flow_message(id: $messageId) {
        ... on Klaviyo_GetFlowMessageEncodedResponseCompoundDocument {
          data {
            id
            type
            attributes {
              definition {
                ... on Klaviyo_FlowEmail {
                  preview_text
                }
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), mL = Yr(
  /* GraphQL */
  `
  query getMetrics {
    Klaviyo {
      get_metrics {
        ... on Klaviyo_GetMetricResponseCollectionCompoundDocument {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), pL = Yr(
  /* GraphQL */
  `
  query getProfileByFilter(
    $emailFilter: String
    $phoneNumberFilter: String
    $hasEmail: Boolean!
    $hasPhoneNumber: Boolean!
  ) {
    Klaviyo {
      profileByEmail: get_profiles(
        filter: $emailFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasEmail) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
      profileByPhoneNumber: get_profiles(
        filter: $phoneNumberFilter
        page_LEFT_SQUARE_BRACE_size_RIGHT_SQUARE_BRACE_: 1
      ) @include(if: $hasPhoneNumber) {
        ... on Klaviyo_GetProfileResponseCollectionCompoundDocument {
          data {
            id
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), fL = Yr(
  /* GraphQL */
  `
  query getProfileById($profileId: String!) {
    Klaviyo {
      get_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          properties
          predictive_analytics
        ]
        additional_fields_LEFT_SQUARE_BRACE_profile_RIGHT_SQUARE_BRACE_: [
          subscriptions
          predictive_analytics
        ]
      ) {
        ... on Klaviyo_GetProfileResponseCompoundDocument {
          data {
            attributes {
              subscriptions {
                email {
                  marketing {
                    consent
                  }
                }
                sms {
                  marketing {
                    consent
                  }
                }
              }
              properties
              predictive_analytics {
                average_order_value
                churn_probability
                predicted_clv
                historic_clv
                total_clv
                historic_number_of_orders
                predicted_number_of_orders
                average_days_between_orders
                expected_date_of_next_order
                ranked_channel_affinity
              }
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), hL = Yr(
  /* GraphQL */
  `
  query getListsByProfileId($profileId: String!) {
    Klaviyo {
      get_lists_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_list_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetListResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), yL = Yr(
  /* GraphQL */
  `
  query getSegmentsByProfileId($profileId: String!) {
    Klaviyo {
      get_segments_for_profile(
        id: $profileId
        fields_LEFT_SQUARE_BRACE_segment_RIGHT_SQUARE_BRACE_: [name]
      ) {
        ... on Klaviyo_GetSegmentResponseCollection {
          data {
            id
            attributes {
              name
            }
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), gL = Yr(
  /* GraphQL */
  `
  mutation subscribeProfileToChannel(
    $attributes: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_attributes_Input!
    $relationships: Klaviyo_mutationInput_bulk_subscribe_profiles_input_data_relationships_Input!
  ) {
    Klaviyo {
      bulk_subscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_create_job
            attributes: $attributes
            relationships: $relationships
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), vL = Yr(
  /* GraphQL */
  `
  mutation unsubscribeProfileByContact(
    $attributes: Klaviyo_mutationInput_bulk_unsubscribe_profiles_input_data_attributes_Input!
  ) {
    Klaviyo {
      bulk_unsubscribe_profiles(
        input: {
          data: {
            type: profile_subscription_bulk_delete_job
            attributes: $attributes
          }
        }
      ) {
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
);
function ry(e) {
  return e?.attributes?.event_properties?.$flow !== void 0;
}
function lx(e) {
  return ry(e) && e?.attributes?.event_properties?.$message;
}
function kL(e) {
  return e?.attributes?.event_properties?.["Bounce Type"] !== void 0;
}
function cx(e) {
  const n = e?.attributes?.timestamp;
  if (n)
    return n;
}
function bL(e) {
  return e.Klaviyo?.get_metrics?.__typename === "Klaviyo_GetMetricResponseCollectionCompoundDocument" && e.Klaviyo.get_metrics.data || [];
}
function _L(e) {
  return (e?.Klaviyo?.receivedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function xL(e) {
  return (e?.Klaviyo?.receivedSms?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.receivedSms.data || [])?.map((n) => ({
    ...n,
    eventType: "SMS"
  }));
}
function SL(e) {
  return (e?.Klaviyo?.openedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.openedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function NL(e) {
  return (e?.Klaviyo?.clickedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.clickedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function jL(e) {
  return (e?.Klaviyo?.bouncedEmail?.__typename === "Klaviyo_GetEventResponseCollectionCompoundDocument" && e.Klaviyo.bouncedEmail.data || [])?.map((n) => ({
    ...n,
    eventType: "EMAIL"
  }));
}
function dx(e) {
  return e?.Klaviyo?.get_flow_message?.__typename === "Klaviyo_GetFlowMessageEncodedResponseCompoundDocument" && e.Klaviyo.get_flow_message.data || void 0;
}
function wL(e) {
  return e?.attributes?.definition?.__typename === "Klaviyo_FlowEmail" && e.attributes.definition.preview_text || void 0;
}
function CL(e) {
  try {
    return JSON.parse(JSON.stringify(e));
  } catch {
    return console.error(`Could not make a copy of ${JSON.stringify(e)}`), {};
  }
}
const FL = (e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
function IL(e) {
  return e?.data?.attributes?.subscriptions?.email?.marketing?.consent === "SUBSCRIBED";
}
function EL(e) {
  return e?.data?.attributes?.subscriptions?.sms?.marketing?.consent === "SUBSCRIBED";
}
function $L({
  profileId: e,
  noOfMessagesToShow: n
}) {
  const { useLazyQuery: r, useQuery: i } = hn(), { track: a } = Cn(), [o, s] = me(null), [l, d] = me(
    null
  ), [m, u] = me(null), [f, h] = me(null), [k, C] = me(
    null
  ), [N, j] = me([]), {
    data: _,
    error: g,
    loading: D,
    networkStatus: O
  } = i(mL, {
    /*
    	Since metrics should rarely be changed, query once when the client initializes
    	and then read from the cache for the subsequent queries.
    */
    fetchPolicy: "network-only",
    // Used for first execution
    nextFetchPolicy: "cache-first",
    // Used for subsequent executions
    notifyOnNetworkStatusChange: !0
  }), [
    I,
    {
      data: F,
      error: L,
      loading: K,
      networkStatus: J
    }
  ] = r(dL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    if (_ && !D && O === tr.ready) {
      const te = bL(_);
      s(
        te.find((W) => W?.attributes?.name === "Received Email")?.id || null
      ), d(
        te.find((W) => W?.attributes?.name === "Opened Email")?.id || null
      ), u(
        te.find((W) => W?.attributes?.name === "Clicked Email")?.id || null
      ), h(
        te.find((W) => W?.attributes?.name === "Bounced Email")?.id || null
      ), C(
        te.find((W) => W?.attributes?.name === "Received SMS")?.id || null
      );
    } else
      s(null), d(null), u(null), h(null), C(null);
  }, [_]), Qe(() => {
    o && l && m && f && k && !K && J === tr.ready ? I({
      variables: {
        receivedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${o}")`,
        openedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${l}")`,
        clickedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${m}")`,
        bouncedEmailEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${f}")`,
        receivedSmsEventsFilter: `equals(profile_id,"${e}"),equals(metric_id,"${k}")`,
        pageSize: n
      }
    }) : j([]);
  }, [
    o,
    l,
    m,
    f,
    k
  ]), Qe(() => {
    if (!K && F) {
      const te = _L(F), W = SL(
        F
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      ), Y = NL(
        F
      ).map(
        (ue) => ue?.attributes?.event_properties.$message
      );
      te.forEach((ue) => {
        const se = ue.attributes?.event_properties.$message;
        ue.opened = W.includes(se), ue.clicked = Y.includes(se);
      });
      const P = xL(F), B = jL(F), re = [
        ...te,
        ...B,
        ...P
      ].sort((ue, se) => {
        const he = cx(ue), V = cx(se);
        return he == null && V == null ? 0 : he == null ? 1 : V == null ? -1 : V - he;
      }).slice(0, n);
      j(re);
      const je = re.map((ue) => ue.id);
      a("klaviyo:messages:received", {
        emailsReceived: te.filter(
          (ue) => je.includes(ue.id)
        ).length,
        emailsBounced: B.filter(
          (ue) => je.includes(ue.id)
        ).length,
        smsReceived: P.filter(
          (ue) => je.includes(ue.id)
        ).length,
        total: je.length
      });
    } else
      j([]);
  }, [K, F]), Xn(
    () => ({
      receivedMessages: N,
      isLoading: D || K,
      error: g || L
    }),
    [
      N,
      D,
      K,
      g,
      L
    ]
  );
}
function TL({ profileId: e }) {
  const { useQuery: n } = hn(), [r, i] = me(), [a, o] = me(), {
    data: s,
    error: l,
    loading: d,
    refetch: m
  } = n(fL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    variables: {
      profileId: e
    }
  });
  Qe(() => {
    l && o(l);
  }, [l]), Qe(() => {
    !d && s && i(s.Klaviyo.get_profile);
  }, [d, s]);
  const u = async () => {
    const f = await m();
    f.error ? o(f.error) : f.data && i(
      f.data.Klaviyo.get_profile
    );
  };
  return Xn(
    () => ({
      profile: r,
      refetchProfile: u,
      isLoading: d,
      error: a
    }),
    // No need to add `refetchProfile` as a dependency here
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, d, a]
  );
}
function OL({
  email: e,
  phoneNumber: n
}) {
  const { track: r } = Cn(), { useLazyQuery: i } = hn(), [a, o] = me(), [s, l] = me(), [
    d,
    { data: m, error: u, loading: f }
  ] = i(pL, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    if (!f && m) {
      const k = m.Klaviyo?.profileByEmail?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByEmail || void 0, C = m.Klaviyo?.profileByPhoneNumber?.__typename === "Klaviyo_GetProfileResponseCollectionCompoundDocument" && m.Klaviyo.profileByPhoneNumber || void 0;
      h(k, C);
    }
  }, [f, m]);
  const h = (k, C) => {
    const N = k?.data?.length === 1 && k.data[0]?.id || void 0, j = C?.data?.length === 1 && C.data[0]?.id || void 0, _ = N || j, g = !N || !j || N === j;
    if (_ && g) {
      o(N || j), r("klaviyo:profile:received", { hasProfile: !0 });
      return;
    }
    o(void 0), r("klaviyo:profile:received", { hasProfile: !1 }), g || l(
      new Error(
        `Two different profiles were retrieved from Klaviyo for the email ${e} (profile ID ${N}) and phone number ${n} (profile ID ${j}).`
      )
    );
  };
  return Xn(
    () => ({
      profileId: a,
      getProfileId: d,
      isLoading: f,
      error: u || s
    }),
    [a, d, f, u, s]
  );
}
const ux = 800, RL = {
  min: 800,
  // 0.8 seconds
  max: 1200
  // 1.2 seconds
}, DL = 3, PL = 1.5, AL = ({
  query: e,
  delay: n,
  delayRange: r,
  maxCount: i = DL,
  useDelayRange: a = !1
}) => {
  const o = (L) => Math.floor(Math.random() * (L.max - L.min) + L.min), [s, l] = me(0), [d, m] = me(n || ux), [u, f] = me(r || RL), [h, k] = me(!1), [C, N] = me(!1), j = a || !!r, _ = j ? o(u) : n || ux, [g, D] = me(_);
  ID(
    async () => {
      const L = s + 1, K = PL ** L;
      l(L), D(
        (j ? o(u) : d) * K
      ), await e().then(() => {
        N(!0), F();
      });
    },
    h ? g : null
  ), $D(() => F());
  const O = _t(() => {
    l(0), D(_);
  }, [_]), I = _t(
    (L = {}) => {
      const { delay: K, delayRange: J } = L;
      N(!1), O(), J && (f(J), D(o(J))), K && (m(K), D(K)), k(!0);
    },
    [O]
  ), F = _t(() => {
    k(!1), O();
  }, [O]);
  return Qe(() => {
    s >= i && F();
  }, [s, i, F]), Xn(
    () => ({ isRunning: h, isSuccessful: C, start: I, stop: F }),
    [h, C, I, F]
  );
}, LL = (e) => {
  const n = e.graphQLErrors[0]?.extensions.integration?.responseHeaders?.["retry-after"];
  return n ? parseInt(n, 10) : void 0;
}, VL = (e) => ({
  min: e * 1e3,
  max: e * 1e3 + 500
});
function zL({
  profileId: e,
  query: n
}) {
  const { useQuery: r } = hn(), [i, a] = me(), [o, s] = me(), {
    data: l,
    error: d,
    loading: m,
    refetch: u,
    networkStatus: f
  } = r(
    n === "lists" ? hL : yL,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0,
      variables: {
        profileId: e
      }
    }
  ), {
    isRunning: h,
    start: k,
    stop: C
  } = AL({
    query: u,
    useDelayRange: !0
  }), N = m || h;
  return Qe(() => {
    if (d)
      if (fI({
        errors: d.graphQLErrors
      })) {
        if (!h) {
          const j = LL(d);
          k({
            ...j && {
              delayRange: VL(j)
            }
          });
        }
      } else
        s(d);
  }, [d]), Qe(() => {
    if (!m && l?.Klaviyo) {
      let j = {}, _ = {};
      n === "lists" && (j = l?.Klaviyo?.get_lists_for_profile), n === "segments" && (_ = l?.Klaviyo?.get_segments_for_profile), (j?.data || _?.data) && (C(), a(
        (n === "lists" ? j?.data : _?.data)?.map((g) => ({
          ...g,
          type: n === "lists" ? "list" : "segment"
        }))
      ));
    }
  }, [m, l]), Xn(
    () => ({
      listsOrSegments: i,
      refetchListOrSegments: k,
      isLoading: N,
      error: o,
      networkStatus: f
    }),
    [i, N, o, f, k]
  );
}
const UL = "_notificationText_1polx_1", fg = {
  notificationText: UL
}, rc = ({ error: e }) => {
  const { track: n } = Cn();
  let r = e;
  if (Cw(e)) {
    const i = e.graphQLErrors, a = i.length === 1 && vw({ error: i[0] }), o = i.length === 1 && mI({ error: i[0] });
    if (a)
      n("klaviyo:profile:failed", { reason: "Invalid access token" }), r = new Error(
        "It was not possible to retrieve data from Klaviyo due to an access issue. Please contact your administrator."
      );
    else if (o)
      n("klaviyo:profile:failed", { reason: "Insufficient permissions" }), r = new Error(
        "You don't have enough permissions to see Klaviyo profile data for this conversation. This is typically due to a misconfiguration of the Klaviyo integration."
      );
    else
      return n("klaviyo:profile:failed", { reason: "Unexpected error" }), /* @__PURE__ */ ge.jsx(En, { error: e });
  }
  return /* @__PURE__ */ ge.jsx(b, { margin: "0 0 300", children: /* @__PURE__ */ ge.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ ge.jsx(ve, { color: "red.500", size: 20, name: "exclamation-triangle-filled" }),
      titleSecondary: r.message,
      title: "Unable to show Klaviyo profile data",
      variant: "dense"
    }
  ) });
}, ML = "_message_zrl8q_54", BL = "_messageIsOpen_zrl8q_62", qL = "_messageHeader_zrl8q_65", HL = "_messageLabel_zrl8q_71", WL = "_messageText_zrl8q_74", ha = {
  message: ML,
  messageIsOpen: BL,
  messageHeader: qL,
  messageLabel: HL,
  messageText: WL
}, KL = ({ event: e, isLoadingPreview: n }) => {
  const r = e?.attributes?.event_properties, i = e.flowMessage && wL(e.flowMessage);
  return /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
      /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", className: ha.messageLabel, children: "Campaign name" }),
      /* @__PURE__ */ ge.jsx($.Paragraph, { children: r["Campaign Name"] })
    ] }),
    n ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "100", children: /* @__PURE__ */ ge.jsx(fn, { size: 22 }) }) : i && i.length > 0 && /* @__PURE__ */ ge.jsxs(
      b,
      {
        flexDirection: "column",
        justifyContent: "space-between",
        gap: "100",
        children: [
          /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(
            $.Paragraph,
            {
              variant: "4",
              className: ha.messageLabel,
              children: "Preview text"
            }
          ) }),
          /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", className: ha.messageText, children: i })
        ]
      }
    )
  ] });
}, GL = ({ event: e }) => {
  const n = e?.attributes?.event_properties;
  return /* @__PURE__ */ ge.jsx(ge.Fragment, { children: /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", justifyContent: "space-between", gap: "100", children: [
    /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-4", children: "Message" }) }),
    /* @__PURE__ */ ge.jsx(b, { children: n?.extra?.["Message Body"] })
  ] }) });
}, YL = ({
  event: e,
  isLoadingPreview: n,
  openByDefault: r
}) => {
  const [i, a] = me(r), { attributes: o, eventType: s } = e, l = o?.datetime, d = o?.timestamp, m = "DD MMM YYYY @ HH:mm", u = Xn(
    () => () => l ? Gn(l).format(m) : d ? Gn.unix(d).format(m) : null,
    [d, l]
  )(), f = s === "EMAIL", h = s === "SMS", k = f && e.opened, C = f && e.clicked, N = f && o?.event_properties.Subject, j = h && o?.event_properties["Message Name"], _ = f ? "mail" : "sms";
  return /* @__PURE__ */ ge.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      className: dt(ha.message, {
        [ha.messageIsOpen]: i
      }),
      children: [
        /* @__PURE__ */ ge.jsxs(
          b,
          {
            alignItems: "center",
            justifyContent: "space-between",
            className: ha.messageHeader,
            onClick: () => a(!i),
            children: [
              /* @__PURE__ */ ge.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ ge.jsxs(b, { gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ge.jsx(ve, { size: 16, name: _ }),
                  " ",
                  FL(s),
                  u && /* @__PURE__ */ ge.jsx(Mn, { size: "small", variant: "info", children: u })
                ] }),
                N && N,
                j && j
              ] }),
              /* @__PURE__ */ ge.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: i ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        i && /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "300", children: [
          /* @__PURE__ */ ge.jsx(Hl, {}),
          kL(e) && /* @__PURE__ */ ge.jsx(b, { children: /* @__PURE__ */ ge.jsx(Mn, { size: "medium", variant: "error", children: "Bounced" }) }),
          f && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
            /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
              /* @__PURE__ */ ge.jsx(Jn, { children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ge.jsx(
                  ve,
                  {
                    size: 16,
                    color: k ? "green.400" : "red.400",
                    name: k ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Opened"
              ] }) }),
              /* @__PURE__ */ ge.jsx(Jn, { children: /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "200", children: [
                /* @__PURE__ */ ge.jsx(
                  ve,
                  {
                    size: 16,
                    color: C ? "green.400" : "red.400",
                    name: C ? "check-circle-filled" : "close-circle-filled"
                  }
                ),
                " ",
                "Clicked"
              ] }) })
            ] }),
            /* @__PURE__ */ ge.jsx(KL, { event: e, isLoadingPreview: n })
          ] }),
          h && /* @__PURE__ */ ge.jsx(GL, { event: e })
        ] })
      ]
    }
  );
}, JL = {
  /*
  	Compiler needs this casting so as not to complain that the string literal 'no-cache'
  	is actually of type "FetchPolicy", which type is defined as one of many string values,
  	including 'no-cache'.
  */
  fetchPolicy: "no-cache",
  notifyOnNetworkStatusChange: !0
}, QL = ({
  profileId: e,
  noOfMessagesToShow: n
}) => {
  const [r, i] = me(!1), {
    receivedMessages: a,
    isLoading: o,
    error: s
  } = $L({
    profileId: e,
    noOfMessagesToShow: n
  }), [l, d] = Y2({
    query: uL,
    options: JL,
    delayMs: 1e3
  }), [m, u] = me([]);
  Qe(() => {
    if (a.length > 0) {
      u(a);
      const h = a.filter((k) => ry(k)).map((k) => lx(k));
      h.length > 0 && (i(!0), l(
        h.map((k) => ({
          messageId: k
        }))
      ).finally(() => i(!1)));
    }
  }, [a]), Qe(() => {
    d.length > 0 && u(
      a?.map((h) => {
        if (h.eventType === "EMAIL" && ry(h) && !h.flowMessage) {
          const k = lx(h), C = d.find((j) => (j.data && dx(j.data))?.id === k), N = C?.data && dx(C.data);
          if (N)
            return {
              ...CL(h),
              flowMessage: N
            };
        }
        return h;
      })
    );
  }, [d]);
  const f = [];
  return s && f.push(s), d.length > 0 && f.push(
    ...d.map((h) => h.error).filter((h) => h)
  ), f && f.length > 0 ? /* @__PURE__ */ ge.jsx(ge.Fragment, { children: f.map((h, k) => h.graphQLErrors ? /* @__PURE__ */ ge.jsx(
    En,
    {
      error: h
    },
    `lastMessagesError${k}`
  ) : /* @__PURE__ */ ge.jsx(
    rc,
    {
      error: h
    },
    `lastMessagesError${k}`
  )) }) : /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Messages" }),
    o ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) : /* @__PURE__ */ ge.jsx(ge.Fragment, { children: m?.length > 0 ? /* @__PURE__ */ ge.jsx(b, { gap: "200", flexDirection: "column", children: m.map((h, k) => /* @__PURE__ */ ge.jsx(
      YL,
      {
        event: h,
        isLoadingPreview: r,
        openByDefault: k === 0
      },
      h.id
    )) }) : /* @__PURE__ */ ge.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200",
        className: fg.notificationText,
        children: "No messages found for the profile"
      }
    ) })
  ] });
}, XL = "_list_ld0hf_1", ZL = "_listItem_ld0hf_4", ii = {
  list: XL,
  listItem: ZL
}, eV = ({
  profile: e
}) => {
  const n = e?.data?.attributes?.properties, r = Object.entries(
    n ?? {}
  ).filter(([a, o]) => a !== "__typename" && o != null), i = r.length > 0;
  return /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Custom properties" }),
    !i && /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No custom properties available" }),
    i && /* @__PURE__ */ ge.jsx(Ye, { className: ii.list, children: r.map(([a, o]) => typeof o == "boolean" || typeof o == "string" || typeof o == "number" || Array.isArray(o) && o.every((s) => typeof s == "string") ? /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "flex-start",
        gap: "200",
        children: [
          /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", children: pI(a) }),
          /* @__PURE__ */ ge.jsx(
            b,
            {
              style: { flex: 1, minWidth: 0 },
              justifyContent: "flex-end",
              children: Mi(o)
            }
          )
        ]
      }
    ) }, a) : null) })
  ] });
}, mx = ({
  profileId: e,
  type: n
}) => {
  const [r, i] = me(!1), {
    listsOrSegments: a,
    error: o,
    isLoading: s,
    networkStatus: l,
    refetchListOrSegments: d
  } = zL({ profileId: e, query: n });
  Qe(() => {
    l === 4 && i(!0);
  }, [l]);
  const m = () => {
    a || d();
  }, u = a || [];
  return o ? /* @__PURE__ */ ge.jsx(rc, { error: o }) : s ? /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ge.jsx(fn, { size: 14 }) }, "loading") : u.length > 0 ? /* @__PURE__ */ ge.jsx(ge.Fragment, { children: u.map(
    ({ attributes: f, type: h }, k) => /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ge.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", children: f?.name }),
      !!h && /* @__PURE__ */ ge.jsx(Jn, { children: kw(h) })
    ] }) }, k)
  ) }) : r && !a ? /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ge.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ ge.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ ge.jsx(ve, { name: "exclamation-triangle-filled", color: "red" }),
      /* @__PURE__ */ ge.jsxs($.Paragraph, { variant: "4", color: "red.500", children: [
        n === "lists" ? "Lists" : "Segments",
        " could not be loaded"
      ] })
    ] }),
    /* @__PURE__ */ ge.jsx(Xe, { content: "Refresh lists and segments", children: /* @__PURE__ */ ge.jsx(ct, { icon: "sync", variant: "secondary", onClick: () => m(), children: "Retry" }) })
  ] }) }, "refetch") : /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ge.jsx(b, { justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", subdued: !0, children: /* @__PURE__ */ ge.jsx("i", { children: `No ${n === "lists" ? "lists" : "segments"} available` }) }) }) }, "refetch");
}, nV = 0.7, tV = 0.3, rV = (e) => e >= nV ? { variant: "error", label: "High risk" } : e >= tV ? { variant: "warning", label: "Medium risk" } : { variant: "success", label: "Low risk" }, iV = (e) => /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: e.toFixed(2) }), aV = (e) => {
  const n = rV(e);
  return /* @__PURE__ */ ge.jsxs(b, { alignItems: "center", gap: "100", children: [
    /* @__PURE__ */ ge.jsx(Mn, { size: "small", variant: n.variant, children: n.label }),
    /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: `${(e * 100).toFixed(1)}%` })
  ] });
}, oV = (e) => {
  const n = e?.data?.attributes?.predictive_analytics ?? null;
  if (!n)
    return [];
  const r = [
    ["Average order value", n.average_order_value],
    ["Historic lifetime value", n.historic_clv],
    ["Predicted lifetime value", n.predicted_clv],
    ["Total lifetime value", n.total_clv]
  ], i = [
    ["Historic orders", n.historic_number_of_orders],
    ["Predicted orders", n.predicted_number_of_orders],
    [
      "Average days between orders",
      n.average_days_between_orders
    ],
    ["Expected next order", n.expected_date_of_next_order]
  ], a = n.churn_probability, o = n.ranked_channel_affinity?.filter(Boolean) ?? null;
  return [
    ...r.flatMap(
      ([s, l]) => l ? [{ label: s, content: iV(l) }] : []
    ),
    ...i.flatMap(
      ([s, l]) => l ? [{ label: s, content: Mi(l) }] : []
    ),
    ...a ? [
      {
        label: "Churn probability",
        content: aV(a)
      }
    ] : [],
    ...o?.length ? [
      {
        label: "Channel affinity",
        content: Mi(o)
      }
    ] : []
  ];
}, sV = ({
  profile: e
}) => {
  const n = oV(e);
  return /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Predictive analytics" }),
    n.length === 0 && /* @__PURE__ */ ge.jsx($.Paragraph, { variant: "4", color: "secondary", align: "center", children: "No predictive analytics available" }),
    n.length > 0 && /* @__PURE__ */ ge.jsx(Ye, { className: ii.list, children: n.map(({ label: r, content: i }) => /* @__PURE__ */ ge.jsx(Ye.Text, { variant: "dense", className: ii.listItem, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        gap: "200",
        children: [
          /* @__PURE__ */ ge.jsx($.Paragraph, { as: "span", variant: "4", children: r }),
          i
        ]
      }
    ) }, r)) })
  ] });
}, lV = "_tagHover_kzbzk_1", cV = "_channelUnsubscribed_kzbzk_6", px = {
  tagHover: lV,
  channelUnsubscribed: cV
}, fx = ({
  isSubscribed: e,
  isLoading: n,
  channelName: r,
  channelIcon: i,
  hasReSubscriptionFeature: a,
  handleAction: o
}) => {
  const s = e ? "Unsubscribe" : "Subscribe", l = !e && !a;
  return /* @__PURE__ */ ge.jsx(
    Xe,
    {
      content: l ? "You have to select a resubscription list in the settings." : s,
      children: /* @__PURE__ */ ge.jsx(
        Jn,
        {
          className: px.tagHover,
          color: e ? "green.500" : "neutral.200",
          children: /* @__PURE__ */ ge.jsxs(
            b,
            {
              "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
              gap: "200",
              alignItems: "center",
              className: dt({
                [px.channelUnsubscribed]: !e || l
              }),
              onClick: () => {
                l || o();
              },
              children: [
                n ? /* @__PURE__ */ ge.jsx(fn, { size: 16 }) : /* @__PURE__ */ ge.jsx(ve, { size: 16, name: i }),
                r
              ]
            }
          )
        }
      )
    }
  );
}, dV = "_subscriptionError_1qhhx_1", uV = {
  subscriptionError: dV
}, mV = ({
  subscriptionListId: e,
  profile: n,
  email: r,
  phoneNumber: i,
  profileId: a,
  refetchProfile: o
}) => {
  const [s, l] = me(!1), [d, m] = me(!1), [u, f] = me(), { track: h } = Cn(), [k, C] = ED({
    channel: null,
    request: null
  }), N = IL(n), j = EL(n), _ = !!e, { useMutation: g } = hn(), [D] = g(
    gL
  ), [O] = g(
    vL
  ), I = (K) => {
    h("klaviyo:profile:subscribe:clicked", { channel: K }), C.setAll({
      channel: K,
      request: "subscribed"
    }), ((J) => D({
      variables: {
        attributes: {
          // eslint-disable-next-line camelcase
          custom_source: "Dixa integration",
          profiles: {
            data: [
              {
                type: ey.Profile,
                id: a,
                attributes: {
                  email: r,
                  // eslint-disable-next-line camelcase
                  ...i ? { phone_number: i } : {},
                  subscriptions: {
                    ...J === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ny.Subscribed
                        }
                      }
                    },
                    ...J === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ny.Subscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        },
        relationships: {
          list: {
            data: {
              type: t1.List,
              id: e
            }
          }
        }
      }
    }))(K).then(
      (J) => L({
        channel: K,
        mutationResponse: J,
        isSubscriptionRequest: !0
      })
    ).catch(
      (J) => L({
        channel: K,
        mutationErrorResponse: J,
        isSubscriptionRequest: !0
      })
    );
  }, F = (K) => {
    h("klaviyo:profile:unsubscribe:clicked", { channel: K }), C.setAll({
      channel: K,
      request: "unsubscribed"
    }), O({
      variables: {
        attributes: {
          profiles: {
            data: [
              {
                type: ey.Profile,
                attributes: {
                  ...K === "EMAIL" ? { email: r } : {},
                  // eslint-disable-next-line camelcase
                  ...K === "SMS" ? { phone_number: i } : {},
                  subscriptions: {
                    ...K === "EMAIL" && {
                      email: {
                        marketing: {
                          consent: ty.Unsubscribed
                        }
                      }
                    },
                    ...K === "SMS" && {
                      sms: {
                        marketing: {
                          consent: ty.Unsubscribed
                        }
                      }
                    }
                  }
                }
              }
            ]
          }
        }
      }
    }).then(
      (J) => L({
        channel: K,
        mutationResponse: J,
        isSubscriptionRequest: !1
      })
    ).catch(
      (J) => L({
        channel: K,
        mutationErrorResponse: J,
        isSubscriptionRequest: !1
      })
    );
  }, L = async ({
    channel: K,
    mutationResponse: J,
    mutationErrorResponse: te,
    isSubscriptionRequest: W
  }) => {
    const Y = te?.networkError, P = Y ? Y?.statusCode : NaN, B = J?.errors, re = !!B && bw({
      errors: B
    });
    P === 202 ? (h(
      W ? "klaviyo:profile:subscribe:succeeded" : "klaviyo:profile:unsubscribe:succeeded",
      { channel: K }
    ), await o()) : re ? (h(
      W ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: K,
        reason: "Insufficient permissions"
      }
    ), f(
      `Request failed with a permission error. Could not ${W ? "opt-in" : "opt-out"}.`
    )) : (h(
      W ? "klaviyo:profile:subscribe:failed" : "klaviyo:profile:unsubscribe:failed",
      {
        channel: K,
        reason: Y?.message || "Unexpected error"
      }
    ), f(
      `Request failed. Could not ${W ? "opt-in" : "opt-out"}.`
    )), m(!1), l(!1);
  };
  return Qe(() => {
    if (k.request === "subscribed") {
      const K = `This subscription might be a double opt-in. The customer needs to check if they received a confirmation ${k.channel === "EMAIL" ? "email" : "sms"} to give consent.`;
      k.channel === "EMAIL" && !s && n?.data?.attributes?.subscriptions?.email?.marketing?.consent !== "SUBSCRIBED" && (f(K), C.reset()), k.channel === "SMS" && !d && n?.data?.attributes?.subscriptions?.sms?.marketing?.consent !== "SUBSCRIBED" && (f(K), C.reset());
    }
  }, [
    n?.data?.attributes?.subscriptions?.email?.marketing?.consent,
    n?.data?.attributes?.subscriptions?.sms?.marketing?.consent,
    s,
    d
  ]), /* @__PURE__ */ ge.jsx(
    b,
    {
      "data-testid": "subscription-channels",
      gap: "200",
      flexDirection: "column",
      children: /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Subscription channels" }),
        /* @__PURE__ */ ge.jsxs(b, { gap: "100", flexDirection: "row", children: [
          /* @__PURE__ */ ge.jsx(
            fx,
            {
              "data-testid": "subscription-channels-email-button",
              isLoading: s,
              isSubscribed: N,
              channelName: "Email",
              channelIcon: "mail",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                l(!0), f(void 0), N ? F("EMAIL") : I("EMAIL");
              }
            }
          ),
          /* @__PURE__ */ ge.jsx(
            fx,
            {
              "data-testid": "subscription-channels-sms-button",
              isLoading: d,
              isSubscribed: j,
              channelName: "Sms",
              channelIcon: "sms",
              hasReSubscriptionFeature: _,
              handleAction: () => {
                m(!0), f(void 0), j ? F("SMS") : I("SMS");
              }
            }
          )
        ] }),
        u && /* @__PURE__ */ ge.jsx(b, { className: uV.subscriptionError, children: u })
      ] })
    }
  );
}, pV = ({
  profileId: e,
  email: n,
  phoneNumber: r,
  showProfileLists: i,
  showProfileSegments: a,
  showSubscriptions: o,
  showCustomProperties: s,
  showPredictiveAnalytics: l,
  noOfMessagesToShow: d,
  subscriptionListId: m
}) => {
  const {
    profile: u,
    error: f,
    isLoading: h,
    refetchProfile: k
  } = TL({ profileId: e });
  return f ? /* @__PURE__ */ ge.jsx(rc, { error: f }) : h ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) : !u && !h ? /* @__PURE__ */ ge.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200",
      className: fg.notificationText,
      children: "No Klaviyo profile data found"
    }
  ) : /* @__PURE__ */ ge.jsxs(b, { flexDirection: "column", gap: "300", margin: "200 0 300", children: [
    (i || a) && /* @__PURE__ */ ge.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ ge.jsx($.Heading, { variant: "heading-3", children: "Lists & Segments" }),
      /* @__PURE__ */ ge.jsxs(Ye, { className: ii.list, children: [
        i && /* @__PURE__ */ ge.jsx(mx, { profileId: e, type: "lists" }),
        a && /* @__PURE__ */ ge.jsx(
          mx,
          {
            profileId: e,
            type: "segments"
          }
        )
      ] })
    ] }),
    u && e && o && /* @__PURE__ */ ge.jsx(
      mV,
      {
        profile: u,
        profileId: e,
        subscriptionListId: m,
        refetchProfile: k,
        email: n,
        phoneNumber: r
      }
    ),
    u && l && /* @__PURE__ */ ge.jsx(sV, { profile: u }),
    u && s && /* @__PURE__ */ ge.jsx(eV, { profile: u }),
    /* @__PURE__ */ ge.jsx(
      QL,
      {
        profileId: e,
        noOfMessagesToShow: d
      }
    )
  ] });
}, fV = ({
  conversationContext: e,
  settings: n
}) => {
  const r = e.customer?.email || void 0, i = e.customer?.phone_number || void 0, a = n?.showProfileLists, o = n?.showProfileSegments, s = n?.showSubscriptions, l = n?.showCustomProperties, d = n?.showPredictiveAnalytics, m = Number(n?.noOfMessagesToShow), u = n?.subscriptionListId, {
    profileId: f,
    getProfileId: h,
    isLoading: k,
    error: C
  } = OL({ email: r, phoneNumber: i });
  return bI(() => {
    (r || i) && h({
      variables: {
        emailFilter: r ? `equals(email,"${r}")` : void 0,
        phoneNumberFilter: i ? `equals(phone_number,"${i}")` : void 0,
        hasEmail: !!r,
        hasPhoneNumber: !!i
      }
    });
  }, [r, i]), !r && !i ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: "The customer does not have an email nor a phone number" }) : k ? /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) : C ? /* @__PURE__ */ ge.jsx(rc, { error: C }) : f ? /* @__PURE__ */ ge.jsx(
    pV,
    {
      profileId: f,
      email: r,
      phoneNumber: i,
      showProfileLists: a,
      showProfileSegments: o,
      showSubscriptions: s,
      showCustomProperties: l,
      showPredictiveAnalytics: d,
      noOfMessagesToShow: m,
      subscriptionListId: u
    }
  ) : /* @__PURE__ */ ge.jsx(
    b,
    {
      justifyContent: "center",
      margin: "0 0 300 0",
      className: fg.notificationText,
      children: "No profile ID found"
    }
  );
}, Sa = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showProfileLists",
    label: "Show Klaviyo lists for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showProfileSegments",
    label: "Show Klaviyo segments for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showSubscriptions",
    label: "Show subscription channels for Klaviyo messages",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "showCustomProperties",
    label: "Show custom properties for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPredictiveAnalytics",
    label: "Show predictive analytics for a profile",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  // Populated by the subscribe-list selector; empty means the feature is off.
  {
    key: "subscriptionListId",
    label: "Re-/subscription list",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "noOfMessagesToShow",
    label: "Choose how many messages to show",
    type: "string",
    secret: !1,
    defaultValue: "5"
  }
], hV = [
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: gi
  }
], yV = [
  {
    key: "klaviyoApiKey",
    label: "API key",
    placeholder: "API key from Klaviyo",
    required: !0,
    secret: !0,
    type: "input"
  }
], gV = rr(Sa), hx = [
  { value: "3", label: "The three latest messages" },
  { value: "4", label: "The four latest messages" },
  { value: "5", label: "The five latest messages" }
], vV = ({
  control: e,
  name: n
}) => /* @__PURE__ */ ge.jsx(
  xr,
  {
    name: n,
    control: e,
    label: gV.noOfMessagesToShow,
    rules: { required: "Please choose how many messages to show" },
    componentProps: {
      placeholder: "Select an option",
      equalityFn: (r, i) => r === i,
      getItemTitleByValue: (r) => {
        const i = hx.find(
          (a) => a.value === r
        )?.label;
        return i ? /* @__PURE__ */ ge.jsx($.Paragraph, { children: i }) : null;
      }
    },
    children: hx.map((r) => /* @__PURE__ */ ge.jsx(mt.Item, { value: r.value, children: r.label }, r.value))
  }
), kV = "_settingsWrapper_eleyu_1", bV = {
  settingsWrapper: kV
}, _V = Yr(
  /* GraphQL */
  `
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
          data {
            type
            id
            attributes {
              name
              created
              updated
            }
            links {
              self
            }
          }
          links {
            self
          }
        }
        ... on Klaviyo_ClientError_response {
          ...ClientErrorResponseFragment
        }
        ... on Klaviyo_ServerError_response {
          ...ServerErrorResponseFragment
        }
      }
    }
  }
`
), yx = [], xV = ({
  value: e,
  onChange: n
}) => {
  const { useQuery: r } = hn(), [i, a] = me(yx), [o, s] = me(!!e), {
    data: l,
    error: d,
    loading: m
  } = r(_V, {
    skip: !o,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return Qe(() => {
    e && s(!0);
  }, [e]), Qe(() => {
    const u = l?.Klaviyo?.get_lists;
    if (o && u && !m && !d) {
      const f = u?.data?.map(
        (h) => ({
          value: h?.id,
          label: h?.attributes?.name
        })
      ) || yx;
      a(f);
    }
  }, [o, l, m, d]), /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
    /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsxs(
      b,
      {
        gap: "300",
        flexDirection: "column",
        className: bV.settingsWrapper,
        children: [
          /* @__PURE__ */ ge.jsx(We, { label: "Activate re-/subscription list selection", children: /* @__PURE__ */ ge.jsx(
            Sw,
            {
              input: {
                name: "subscriptionListId-switch",
                value: "switchValueFromComponent",
                checked: o,
                onChange: () => {
                  const u = !o;
                  u || n(""), s(u);
                }
              }
            }
          ) }),
          o && d && !m && /* @__PURE__ */ ge.jsx(We, { children: /* @__PURE__ */ ge.jsx(En, { error: d }) }),
          o && !d && m && /* @__PURE__ */ ge.jsx(We, { children: /* @__PURE__ */ ge.jsx(b, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ ge.jsx(fn, {}) }) }),
          o && !d && !m && i && /* @__PURE__ */ ge.jsx(We, { label: "Available lists to subscribe to", children: /* @__PURE__ */ ge.jsx(
            mi,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (u) => n(u?.selectedValues?.[0]?.value ?? ""),
              getItemTitleByValue: (u) => u ? /* @__PURE__ */ ge.jsx($.Paragraph, { children: u.label }) : null,
              value: e ? [
                {
                  label: (i || []).find(
                    (u) => u.value === e
                  )?.label,
                  value: e
                }
              ] : [],
              equalityFn: (u, f) => u.value === f.value,
              children: i.map((u) => /* @__PURE__ */ ge.jsx(mt.Item, { value: u, children: u.label }, u.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ ge.jsx(Z, { span: 3 })
  ] });
}, na = rr(Sa), bm = "KLAVIYO", SV = {
  enabled: !1,
  name: "",
  ...Ml(
    [],
    Sa
  )
}, NV = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: SV
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = ur({
    integrationId: e,
    integrationType: bm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: Sa,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = s || !!D?.additionalProperties?.isUsingOAuth, K = (te) => hr(te, {
    fieldDefinitions: Sa,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), J = l.watch("name");
  return /* @__PURE__ */ ge.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: K,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ ge.jsx(yr, { cause: k }),
        /* @__PURE__ */ ge.jsxs(nt, { children: [
          /* @__PURE__ */ ge.jsx(Z, { children: /* @__PURE__ */ ge.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          !L && /* @__PURE__ */ ge.jsxs(ge.Fragment, { children: [
            /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
              Er,
              {
                name: "klaviyoApiKey",
                label: na.klaviyoApiKey,
                control: l.control,
                isCreationMode: s,
                rules: { required: "API key is required" },
                componentProps: {
                  placeholder: "API key from Klaviyo",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ ge.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: na.showProfileLists, children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showProfileLists",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: na.showProfileSegments, children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showProfileSegments",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: na.showSubscriptions, children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showSubscriptions",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: na.showCustomProperties, children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showCustomProperties",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(We, { label: na.showPredictiveAnalytics, children: /* @__PURE__ */ ge.jsx(
            bn,
            {
              name: "showPredictiveAnalytics",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          !s && /* @__PURE__ */ ge.jsx(
            bt,
            {
              name: "subscriptionListId",
              control: l.control,
              render: ({ field: te }) => /* @__PURE__ */ ge.jsx(
                xV,
                {
                  value: te.value,
                  onChange: te.onChange
                }
              )
            }
          ),
          /* @__PURE__ */ ge.jsx(Z, { span: 3, children: /* @__PURE__ */ ge.jsx(
            vV,
            {
              name: "noOfMessagesToShow",
              control: l.control
            }
          ) }),
          /* @__PURE__ */ ge.jsx(Z, { span: 3 }),
          L && !s && e && /* @__PURE__ */ ge.jsx(
            gi,
            {
              configuration: n,
              integrationId: e,
              integrationType: bm,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ ge.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ ge.jsx(
          gr,
          {
            integrationType: bm,
            integrationId: e,
            widgetName: J,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
function jV(e, n) {
  const r = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (r.padRight ? " " : "") + "," + (r.padLeft === !1 ? "" : " ")
  ).trim();
}
const wV = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, CV = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, FV = {};
function gx(e, n) {
  return (FV.jsx ? CV : wV).test(e);
}
const IV = /[ \t\n\f\r]/g;
function EV(e) {
  return typeof e == "object" ? e.type === "text" ? vx(e.value) : !1 : vx(e);
}
function vx(e) {
  return e.replace(IV, "") === "";
}
class es {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(n, r, i) {
    this.property = n, this.normal = r, i && (this.space = i);
  }
}
es.prototype.property = {};
es.prototype.normal = {};
es.prototype.space = null;
function r1(e, n) {
  const r = {}, i = {};
  let a = -1;
  for (; ++a < e.length; )
    Object.assign(r, e[a].property), Object.assign(i, e[a].normal);
  return new es(r, i, n);
}
function iy(e) {
  return e.toLowerCase();
}
class Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(n, r) {
    this.property = n, this.attribute = r;
  }
}
Sr.prototype.space = null;
Sr.prototype.boolean = !1;
Sr.prototype.booleanish = !1;
Sr.prototype.overloadedBoolean = !1;
Sr.prototype.number = !1;
Sr.prototype.commaSeparated = !1;
Sr.prototype.spaceSeparated = !1;
Sr.prototype.commaOrSpaceSeparated = !1;
Sr.prototype.mustUseProperty = !1;
Sr.prototype.defined = !1;
let $V = 0;
const Tn = Gi(), kt = Gi(), i1 = Gi(), Ke = Gi(), ot = Gi(), ya = Gi(), or = Gi();
function Gi() {
  return 2 ** ++$V;
}
const ay = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Tn,
  booleanish: kt,
  commaOrSpaceSeparated: or,
  commaSeparated: ya,
  number: Ke,
  overloadedBoolean: i1,
  spaceSeparated: ot
}, Symbol.toStringTag, { value: "Module" })), _m = Object.keys(ay);
class hg extends Sr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(n, r, i, a) {
    let o = -1;
    if (super(n, r), kx(this, "space", a), typeof i == "number")
      for (; ++o < _m.length; ) {
        const s = _m[o];
        kx(this, _m[o], (i & ay[s]) === ay[s]);
      }
  }
}
hg.prototype.defined = !0;
function kx(e, n, r) {
  r && (e[n] = r);
}
const TV = {}.hasOwnProperty;
function Ra(e) {
  const n = {}, r = {};
  let i;
  for (i in e.properties)
    if (TV.call(e.properties, i)) {
      const a = e.properties[i], o = new hg(
        i,
        e.transform(e.attributes || {}, i),
        a,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(i) && (o.mustUseProperty = !0), n[i] = o, r[iy(i)] = i, r[iy(o.attribute)] = i;
    }
  return new es(n, r, e.space);
}
const a1 = Ra({
  space: "xlink",
  transform(e, n) {
    return "xlink:" + n.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), o1 = Ra({
  space: "xml",
  transform(e, n) {
    return "xml:" + n.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function s1(e, n) {
  return n in e ? e[n] : n;
}
function l1(e, n) {
  return s1(e, n.toLowerCase());
}
const c1 = Ra({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: l1,
  properties: { xmlns: null, xmlnsXLink: null }
}), d1 = Ra({
  transform(e, n) {
    return n === "role" ? n : "aria-" + n.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: kt,
    ariaAutoComplete: null,
    ariaBusy: kt,
    ariaChecked: kt,
    ariaColCount: Ke,
    ariaColIndex: Ke,
    ariaColSpan: Ke,
    ariaControls: ot,
    ariaCurrent: null,
    ariaDescribedBy: ot,
    ariaDetails: null,
    ariaDisabled: kt,
    ariaDropEffect: ot,
    ariaErrorMessage: null,
    ariaExpanded: kt,
    ariaFlowTo: ot,
    ariaGrabbed: kt,
    ariaHasPopup: null,
    ariaHidden: kt,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: ot,
    ariaLevel: Ke,
    ariaLive: null,
    ariaModal: kt,
    ariaMultiLine: kt,
    ariaMultiSelectable: kt,
    ariaOrientation: null,
    ariaOwns: ot,
    ariaPlaceholder: null,
    ariaPosInSet: Ke,
    ariaPressed: kt,
    ariaReadOnly: kt,
    ariaRelevant: null,
    ariaRequired: kt,
    ariaRoleDescription: ot,
    ariaRowCount: Ke,
    ariaRowIndex: Ke,
    ariaRowSpan: Ke,
    ariaSelected: kt,
    ariaSetSize: Ke,
    ariaSort: null,
    ariaValueMax: Ke,
    ariaValueMin: Ke,
    ariaValueNow: Ke,
    ariaValueText: null,
    role: null
  }
}), OV = Ra({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: l1,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: ya,
    acceptCharset: ot,
    accessKey: ot,
    action: null,
    allow: null,
    allowFullScreen: Tn,
    allowPaymentRequest: Tn,
    allowUserMedia: Tn,
    alt: null,
    as: null,
    async: Tn,
    autoCapitalize: null,
    autoComplete: ot,
    autoFocus: Tn,
    autoPlay: Tn,
    blocking: ot,
    capture: null,
    charSet: null,
    checked: Tn,
    cite: null,
    className: ot,
    cols: Ke,
    colSpan: null,
    content: null,
    contentEditable: kt,
    controls: Tn,
    controlsList: ot,
    coords: Ke | ya,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Tn,
    defer: Tn,
    dir: null,
    dirName: null,
    disabled: Tn,
    download: i1,
    draggable: kt,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Tn,
    formTarget: null,
    headers: ot,
    height: Ke,
    hidden: Tn,
    high: Ke,
    href: null,
    hrefLang: null,
    htmlFor: ot,
    httpEquiv: ot,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Tn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Tn,
    itemId: null,
    itemProp: ot,
    itemRef: ot,
    itemScope: Tn,
    itemType: ot,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Tn,
    low: Ke,
    manifest: null,
    max: null,
    maxLength: Ke,
    media: null,
    method: null,
    min: null,
    minLength: Ke,
    multiple: Tn,
    muted: Tn,
    name: null,
    nonce: null,
    noModule: Tn,
    noValidate: Tn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Tn,
    optimum: Ke,
    pattern: null,
    ping: ot,
    placeholder: null,
    playsInline: Tn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Tn,
    referrerPolicy: null,
    rel: ot,
    required: Tn,
    reversed: Tn,
    rows: Ke,
    rowSpan: Ke,
    sandbox: ot,
    scope: null,
    scoped: Tn,
    seamless: Tn,
    selected: Tn,
    shadowRootClonable: Tn,
    shadowRootDelegatesFocus: Tn,
    shadowRootMode: null,
    shape: null,
    size: Ke,
    sizes: null,
    slot: null,
    span: Ke,
    spellCheck: kt,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Ke,
    step: null,
    style: null,
    tabIndex: Ke,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Tn,
    useMap: null,
    value: kt,
    width: Ke,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: ot,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Ke,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Ke,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Tn,
    // Lists. Use CSS to reduce space between items instead
    declare: Tn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Ke,
    // `<img>` and `<object>`
    leftMargin: Ke,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Ke,
    // `<body>`
    marginWidth: Ke,
    // `<body>`
    noResize: Tn,
    // `<frame>`
    noHref: Tn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Tn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Tn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Ke,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: kt,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Ke,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Ke,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Tn,
    disableRemotePlayback: Tn,
    prefix: null,
    property: null,
    results: Ke,
    security: null,
    unselectable: null
  }
}), RV = Ra({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: s1,
  properties: {
    about: or,
    accentHeight: Ke,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Ke,
    amplitude: Ke,
    arabicForm: null,
    ascent: Ke,
    attributeName: null,
    attributeType: null,
    azimuth: Ke,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Ke,
    by: null,
    calcMode: null,
    capHeight: Ke,
    className: ot,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Ke,
    diffuseConstant: Ke,
    direction: null,
    display: null,
    dur: null,
    divisor: Ke,
    dominantBaseline: null,
    download: Tn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Ke,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Ke,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Ke,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: ya,
    g2: ya,
    glyphName: ya,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Ke,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Ke,
    horizOriginX: Ke,
    horizOriginY: Ke,
    id: null,
    ideographic: Ke,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Ke,
    k: Ke,
    k1: Ke,
    k2: Ke,
    k3: Ke,
    k4: Ke,
    kernelMatrix: or,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Ke,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Ke,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Ke,
    overlineThickness: Ke,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Ke,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: ot,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Ke,
    pointsAtY: Ke,
    pointsAtZ: Ke,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: or,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: or,
    rev: or,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: or,
    requiredFeatures: or,
    requiredFonts: or,
    requiredFormats: or,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Ke,
    specularExponent: Ke,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Ke,
    strikethroughThickness: Ke,
    string: null,
    stroke: null,
    strokeDashArray: or,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Ke,
    strokeOpacity: Ke,
    strokeWidth: null,
    style: null,
    surfaceScale: Ke,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: or,
    tabIndex: Ke,
    tableValues: null,
    target: null,
    targetX: Ke,
    targetY: Ke,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: or,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Ke,
    underlineThickness: Ke,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Ke,
    values: null,
    vAlphabetic: Ke,
    vMathematical: Ke,
    vectorEffect: null,
    vHanging: Ke,
    vIdeographic: Ke,
    version: null,
    vertAdvY: Ke,
    vertOriginX: Ke,
    vertOriginY: Ke,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Ke,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), DV = /^data[-\w.:]+$/i, bx = /-[a-z]/g, PV = /[A-Z]/g;
function AV(e, n) {
  const r = iy(n);
  let i = n, a = Sr;
  if (r in e.normal)
    return e.property[e.normal[r]];
  if (r.length > 4 && r.slice(0, 4) === "data" && DV.test(n)) {
    if (n.charAt(4) === "-") {
      const o = n.slice(5).replace(bx, VV);
      i = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = n.slice(4);
      if (!bx.test(o)) {
        let s = o.replace(PV, LV);
        s.charAt(0) !== "-" && (s = "-" + s), n = "data" + s;
      }
    }
    a = hg;
  }
  return new a(i, n);
}
function LV(e) {
  return "-" + e.toLowerCase();
}
function VV(e) {
  return e.charAt(1).toUpperCase();
}
const zV = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, UV = r1([o1, a1, c1, d1, OV], "html"), yg = r1([o1, a1, c1, d1, RV], "svg");
function MV(e) {
  return e.join(" ").trim();
}
var ta = {}, xm, _x;
function BV() {
  if (_x) return xm;
  _x = 1;
  var e = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, n = /\n/g, r = /^\s*/, i = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, a = /^:\s*/, o = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, s = /^[;\s]*/, l = /^\s+|\s+$/g, d = `
`, m = "/", u = "*", f = "", h = "comment", k = "declaration";
  xm = function(N, j) {
    if (typeof N != "string")
      throw new TypeError("First argument must be a string");
    if (!N) return [];
    j = j || {};
    var _ = 1, g = 1;
    function D(P) {
      var B = P.match(n);
      B && (_ += B.length);
      var re = P.lastIndexOf(d);
      g = ~re ? P.length - re : g + P.length;
    }
    function O() {
      var P = { line: _, column: g };
      return function(B) {
        return B.position = new I(P), K(), B;
      };
    }
    function I(P) {
      this.start = P, this.end = { line: _, column: g }, this.source = j.source;
    }
    I.prototype.content = N;
    function F(P) {
      var B = new Error(
        j.source + ":" + _ + ":" + g + ": " + P
      );
      if (B.reason = P, B.filename = j.source, B.line = _, B.column = g, B.source = N, !j.silent) throw B;
    }
    function L(P) {
      var B = P.exec(N);
      if (B) {
        var re = B[0];
        return D(re), N = N.slice(re.length), B;
      }
    }
    function K() {
      L(r);
    }
    function J(P) {
      var B;
      for (P = P || []; B = te(); )
        B !== !1 && P.push(B);
      return P;
    }
    function te() {
      var P = O();
      if (!(m != N.charAt(0) || u != N.charAt(1))) {
        for (var B = 2; f != N.charAt(B) && (u != N.charAt(B) || m != N.charAt(B + 1)); )
          ++B;
        if (B += 2, f === N.charAt(B - 1))
          return F("End of comment missing");
        var re = N.slice(2, B - 2);
        return g += 2, D(re), N = N.slice(B), g += 2, P({
          type: h,
          comment: re
        });
      }
    }
    function W() {
      var P = O(), B = L(i);
      if (B) {
        if (te(), !L(a)) return F("property missing ':'");
        var re = L(o), je = P({
          type: k,
          property: C(B[0].replace(e, f)),
          value: re ? C(re[0].replace(e, f)) : f
        });
        return L(s), je;
      }
    }
    function Y() {
      var P = [];
      J(P);
      for (var B; B = W(); )
        B !== !1 && (P.push(B), J(P));
      return P;
    }
    return K(), Y();
  };
  function C(N) {
    return N ? N.replace(l, f) : f;
  }
  return xm;
}
var xx;
function qV() {
  if (xx) return ta;
  xx = 1;
  var e = ta && ta.__importDefault || function(i) {
    return i && i.__esModule ? i : { default: i };
  };
  Object.defineProperty(ta, "__esModule", { value: !0 }), ta.default = r;
  var n = e(BV());
  function r(i, a) {
    var o = null;
    if (!i || typeof i != "string")
      return o;
    var s = (0, n.default)(i), l = typeof a == "function";
    return s.forEach(function(d) {
      if (d.type === "declaration") {
        var m = d.property, u = d.value;
        l ? a(m, u, d) : u && (o = o || {}, o[m] = u);
      }
    }), o;
  }
  return ta;
}
var HV = qV();
const Sx = /* @__PURE__ */ Ey(HV), WV = Sx.default || Sx, u1 = m1("end"), gg = m1("start");
function m1(e) {
  return n;
  function n(r) {
    const i = r && r.position && r.position[e] || {};
    if (typeof i.line == "number" && i.line > 0 && typeof i.column == "number" && i.column > 0)
      return {
        line: i.line,
        column: i.column,
        offset: typeof i.offset == "number" && i.offset > -1 ? i.offset : void 0
      };
  }
}
function KV(e) {
  const n = gg(e), r = u1(e);
  if (n && r)
    return { start: n, end: r };
}
function $o(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Nx(e.position) : "start" in e || "end" in e ? Nx(e) : "line" in e || "column" in e ? oy(e) : "";
}
function oy(e) {
  return jx(e && e.line) + ":" + jx(e && e.column);
}
function Nx(e) {
  return oy(e && e.start) + "-" + oy(e && e.end);
}
function jx(e) {
  return e && typeof e == "number" ? e : 1;
}
class Bt extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(n, r, i) {
    super(), typeof r == "string" && (i = r, r = void 0);
    let a = "", o = {}, s = !1;
    if (r && ("line" in r && "column" in r ? o = { place: r } : "start" in r && "end" in r ? o = { place: r } : "type" in r ? o = {
      ancestors: [r],
      place: r.position
    } : o = { ...r }), typeof n == "string" ? a = n : !o.cause && n && (s = !0, a = n.message, o.cause = n), !o.ruleId && !o.source && typeof i == "string") {
      const d = i.indexOf(":");
      d === -1 ? o.ruleId = i : (o.source = i.slice(0, d), o.ruleId = i.slice(d + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const d = o.ancestors[o.ancestors.length - 1];
      d && (o.place = d.position);
    }
    const l = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = l ? l.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = l ? l.line : void 0, this.name = $o(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Bt.prototype.file = "";
Bt.prototype.name = "";
Bt.prototype.reason = "";
Bt.prototype.message = "";
Bt.prototype.stack = "";
Bt.prototype.column = void 0;
Bt.prototype.line = void 0;
Bt.prototype.ancestors = void 0;
Bt.prototype.cause = void 0;
Bt.prototype.fatal = void 0;
Bt.prototype.place = void 0;
Bt.prototype.ruleId = void 0;
Bt.prototype.source = void 0;
const vg = {}.hasOwnProperty, GV = /* @__PURE__ */ new Map(), YV = /[A-Z]/g, JV = /-([a-z])/g, QV = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), XV = /* @__PURE__ */ new Set(["td", "th"]), p1 = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function ZV(e, n) {
  if (!n || n.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const r = n.filePath || void 0;
  let i;
  if (n.development) {
    if (typeof n.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    i = s3(r, n.jsxDEV);
  } else {
    if (typeof n.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof n.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    i = o3(r, n.jsx, n.jsxs);
  }
  const a = {
    Fragment: n.Fragment,
    ancestors: [],
    components: n.components || {},
    create: i,
    elementAttributeNameCase: n.elementAttributeNameCase || "react",
    evaluater: n.createEvaluater ? n.createEvaluater() : void 0,
    filePath: r,
    ignoreInvalidStyle: n.ignoreInvalidStyle || !1,
    passKeys: n.passKeys !== !1,
    passNode: n.passNode || !1,
    schema: n.space === "svg" ? yg : UV,
    stylePropertyNameCase: n.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: n.tableCellAlignToStyle !== !1
  }, o = f1(a, e, void 0);
  return o && typeof o != "string" ? o : a.create(
    e,
    a.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function f1(e, n, r) {
  if (n.type === "element")
    return e3(e, n, r);
  if (n.type === "mdxFlowExpression" || n.type === "mdxTextExpression")
    return n3(e, n);
  if (n.type === "mdxJsxFlowElement" || n.type === "mdxJsxTextElement")
    return r3(e, n, r);
  if (n.type === "mdxjsEsm")
    return t3(e, n);
  if (n.type === "root")
    return i3(e, n, r);
  if (n.type === "text")
    return a3(e, n);
}
function e3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.tagName.toLowerCase() === "svg" && i.space === "html" && (a = yg, e.schema = a), e.ancestors.push(n);
  const o = y1(e, n.tagName, !1), s = l3(e, n);
  let l = bg(e, n);
  return QV.has(n.tagName) && (l = l.filter(function(d) {
    return typeof d == "string" ? !EV(d) : !0;
  })), h1(e, s, o, n), kg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function n3(e, n) {
  if (n.data && n.data.estree && e.evaluater) {
    const i = n.data.estree.body[0];
    return i.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(i.expression);
  }
  qo(e, n.position);
}
function t3(e, n) {
  if (n.data && n.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(n.data.estree)
    );
  qo(e, n.position);
}
function r3(e, n, r) {
  const i = e.schema;
  let a = i;
  n.name === "svg" && i.space === "html" && (a = yg, e.schema = a), e.ancestors.push(n);
  const o = n.name === null ? e.Fragment : y1(e, n.name, !0), s = c3(e, n), l = bg(e, n);
  return h1(e, s, o, n), kg(s, l), e.ancestors.pop(), e.schema = i, e.create(n, o, s, r);
}
function i3(e, n, r) {
  const i = {};
  return kg(i, bg(e, n)), e.create(n, e.Fragment, i, r);
}
function a3(e, n) {
  return n.value;
}
function h1(e, n, r, i) {
  typeof r != "string" && r !== e.Fragment && e.passNode && (n.node = i);
}
function kg(e, n) {
  if (n.length > 0) {
    const r = n.length > 1 ? n : n[0];
    r && (e.children = r);
  }
}
function o3(e, n, r) {
  return i;
  function i(a, o, s, l) {
    const m = Array.isArray(s.children) ? r : n;
    return l ? m(o, s, l) : m(o, s);
  }
}
function s3(e, n) {
  return r;
  function r(i, a, o, s) {
    const l = Array.isArray(o.children), d = gg(i);
    return n(
      a,
      o,
      s,
      l,
      {
        columnNumber: d ? d.column - 1 : void 0,
        fileName: e,
        lineNumber: d ? d.line : void 0
      },
      void 0
    );
  }
}
function l3(e, n) {
  const r = {};
  let i, a;
  for (a in n.properties)
    if (a !== "children" && vg.call(n.properties, a)) {
      const o = d3(e, a, n.properties[a]);
      if (o) {
        const [s, l] = o;
        e.tableCellAlignToStyle && s === "align" && typeof l == "string" && XV.has(n.tagName) ? i = l : r[s] = l;
      }
    }
  if (i) {
    const o = (
      /** @type {Style} */
      r.style || (r.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = i;
  }
  return r;
}
function c3(e, n) {
  const r = {};
  for (const i of n.attributes)
    if (i.type === "mdxJsxExpressionAttribute")
      if (i.data && i.data.estree && e.evaluater) {
        const o = i.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const l = s.properties[0];
        l.type, Object.assign(
          r,
          e.evaluater.evaluateExpression(l.argument)
        );
      } else
        qo(e, n.position);
    else {
      const a = i.name;
      let o;
      if (i.value && typeof i.value == "object")
        if (i.value.data && i.value.data.estree && e.evaluater) {
          const l = i.value.data.estree.body[0];
          l.type, o = e.evaluater.evaluateExpression(l.expression);
        } else
          qo(e, n.position);
      else
        o = i.value === null ? !0 : i.value;
      r[a] = /** @type {Props[keyof Props]} */
      o;
    }
  return r;
}
function bg(e, n) {
  const r = [];
  let i = -1;
  const a = e.passKeys ? /* @__PURE__ */ new Map() : GV;
  for (; ++i < n.children.length; ) {
    const o = n.children[i];
    let s;
    if (e.passKeys) {
      const d = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (d) {
        const m = a.get(d) || 0;
        s = d + "-" + m, a.set(d, m + 1);
      }
    }
    const l = f1(e, o, s);
    l !== void 0 && r.push(l);
  }
  return r;
}
function d3(e, n, r) {
  const i = AV(e.schema, n);
  if (!(r == null || typeof r == "number" && Number.isNaN(r))) {
    if (Array.isArray(r) && (r = i.commaSeparated ? jV(r) : MV(r)), i.property === "style") {
      let a = typeof r == "object" ? r : u3(e, String(r));
      return e.stylePropertyNameCase === "css" && (a = m3(a)), ["style", a];
    }
    return [
      e.elementAttributeNameCase === "react" && i.space ? zV[i.property] || i.property : i.attribute,
      r
    ];
  }
}
function u3(e, n) {
  const r = {};
  try {
    WV(n, i);
  } catch (a) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        a
      ), s = new Bt("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = p1 + "#cannot-parse-style-attribute", s;
    }
  }
  return r;
  function i(a, o) {
    let s = a;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(JV, f3)), r[s] = o;
  }
}
function y1(e, n, r) {
  let i;
  if (!r)
    i = { type: "Literal", value: n };
  else if (n.includes(".")) {
    const a = n.split(".");
    let o = -1, s;
    for (; ++o < a.length; ) {
      const l = gx(a[o]) ? { type: "Identifier", name: a[o] } : { type: "Literal", value: a[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: l,
        computed: !!(o && l.type === "Literal"),
        optional: !1
      } : l;
    }
    i = s;
  } else
    i = gx(n) && !/^[a-z]/.test(n) ? { type: "Identifier", name: n } : { type: "Literal", value: n };
  if (i.type === "Literal") {
    const a = (
      /** @type {keyof JSX.IntrinsicElements} */
      i.value
    );
    return vg.call(e.components, a) ? e.components[a] : a;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(i);
  qo(e);
}
function qo(e, n) {
  const r = new Bt(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: n,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw r.file = e.filePath || void 0, r.url = p1 + "#cannot-handle-mdx-estrees-without-createevaluater", r;
}
function m3(e) {
  const n = {};
  let r;
  for (r in e)
    vg.call(e, r) && (n[p3(r)] = e[r]);
  return n;
}
function p3(e) {
  let n = e.replace(YV, h3);
  return n.slice(0, 3) === "ms-" && (n = "-" + n), n;
}
function f3(e, n) {
  return n.toUpperCase();
}
function h3(e) {
  return "-" + e.toLowerCase();
}
const Sm = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, y3 = {};
function g3(e, n) {
  const r = y3, i = typeof r.includeImageAlt == "boolean" ? r.includeImageAlt : !0, a = typeof r.includeHtml == "boolean" ? r.includeHtml : !0;
  return g1(e, i, a);
}
function g1(e, n, r) {
  if (v3(e)) {
    if ("value" in e)
      return e.type === "html" && !r ? "" : e.value;
    if (n && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return wx(e.children, n, r);
  }
  return Array.isArray(e) ? wx(e, n, r) : "";
}
function wx(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; )
    i[a] = g1(e[a], n, r);
  return i.join("");
}
function v3(e) {
  return !!(e && typeof e == "object");
}
const Cx = document.createElement("i");
function _g(e) {
  const n = "&" + e + ";";
  Cx.innerHTML = n;
  const r = Cx.textContent;
  return r.charCodeAt(r.length - 1) === 59 && e !== "semi" || r === n ? !1 : r;
}
function Kr(e, n, r, i) {
  const a = e.length;
  let o = 0, s;
  if (n < 0 ? n = -n > a ? 0 : a + n : n = n > a ? a : n, r = r > 0 ? r : 0, i.length < 1e4)
    s = Array.from(i), s.unshift(n, r), e.splice(...s);
  else
    for (r && e.splice(n, r); o < i.length; )
      s = i.slice(o, o + 1e4), s.unshift(n, 0), e.splice(...s), o += 1e4, n += 1e4;
}
function br(e, n) {
  return e.length > 0 ? (Kr(e, e.length, 0, n), e) : n;
}
const Fx = {}.hasOwnProperty;
function k3(e) {
  const n = {};
  let r = -1;
  for (; ++r < e.length; )
    b3(n, e[r]);
  return n;
}
function b3(e, n) {
  let r;
  for (r in n) {
    const a = (Fx.call(e, r) ? e[r] : void 0) || (e[r] = {}), o = n[r];
    let s;
    if (o)
      for (s in o) {
        Fx.call(a, s) || (a[s] = []);
        const l = o[s];
        _3(
          // @ts-expect-error Looks like a list.
          a[s],
          Array.isArray(l) ? l : l ? [l] : []
        );
      }
  }
}
function _3(e, n) {
  let r = -1;
  const i = [];
  for (; ++r < n.length; )
    (n[r].add === "after" ? e : i).push(n[r]);
  Kr(e, 0, 0, i);
}
function v1(e, n) {
  const r = Number.parseInt(e, n);
  return (
    // C0 except for HT, LF, FF, CR, space.
    r < 9 || r === 11 || r > 13 && r < 32 || // Control character (DEL) of C0, and C1 controls.
    r > 126 && r < 160 || // Lone high surrogates and low surrogates.
    r > 55295 && r < 57344 || // Noncharacters.
    r > 64975 && r < 65008 || /* eslint-disable no-bitwise */
    (r & 65535) === 65535 || (r & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    r > 1114111 ? "�" : String.fromCodePoint(r)
  );
}
function ga(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Ur = bi(/[A-Za-z]/), cr = bi(/[\dA-Za-z]/), x3 = bi(/[#-'*+\--9=?A-Z^-~]/);
function sy(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const ly = bi(/\d/), S3 = bi(/[\dA-Fa-f]/), N3 = bi(/[!-/:-@[-`{-~]/);
function In(e) {
  return e !== null && e < -2;
}
function nr(e) {
  return e !== null && (e < 0 || e === 32);
}
function Yn(e) {
  return e === -2 || e === -1 || e === 32;
}
const j3 = bi(new RegExp("\\p{P}|\\p{S}", "u")), w3 = bi(/\s/);
function bi(e) {
  return n;
  function n(r) {
    return r !== null && r > -1 && e.test(String.fromCharCode(r));
  }
}
function Da(e) {
  const n = [];
  let r = -1, i = 0, a = 0;
  for (; ++r < e.length; ) {
    const o = e.charCodeAt(r);
    let s = "";
    if (o === 37 && cr(e.charCodeAt(r + 1)) && cr(e.charCodeAt(r + 2)))
      a = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const l = e.charCodeAt(r + 1);
      o < 56320 && l > 56319 && l < 57344 ? (s = String.fromCharCode(o, l), a = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (n.push(e.slice(i, r), encodeURIComponent(s)), i = r + a + 1, s = ""), a && (r += a, a = 0);
  }
  return n.join("") + e.slice(i);
}
function lt(e, n, r, i) {
  const a = i ? i - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(d) {
    return Yn(d) ? (e.enter(r), l(d)) : n(d);
  }
  function l(d) {
    return Yn(d) && o++ < a ? (e.consume(d), l) : (e.exit(r), n(d));
  }
}
const C3 = {
  tokenize: F3
};
function F3(e) {
  const n = e.attempt(this.parser.constructs.contentInitial, i, a);
  let r;
  return n;
  function i(l) {
    if (l === null) {
      e.consume(l);
      return;
    }
    return e.enter("lineEnding"), e.consume(l), e.exit("lineEnding"), lt(e, n, "linePrefix");
  }
  function a(l) {
    return e.enter("paragraph"), o(l);
  }
  function o(l) {
    const d = e.enter("chunkText", {
      contentType: "text",
      previous: r
    });
    return r && (r.next = d), r = d, s(l);
  }
  function s(l) {
    if (l === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(l);
      return;
    }
    return In(l) ? (e.consume(l), e.exit("chunkText"), o) : (e.consume(l), s);
  }
}
const I3 = {
  tokenize: E3
}, Ix = {
  tokenize: $3
};
function E3(e) {
  const n = this, r = [];
  let i = 0, a, o, s;
  return l;
  function l(D) {
    if (i < r.length) {
      const O = r[i];
      return n.containerState = O[1], e.attempt(O[0].continuation, d, m)(D);
    }
    return m(D);
  }
  function d(D) {
    if (i++, n.containerState._closeFlow) {
      n.containerState._closeFlow = void 0, a && g();
      const O = n.events.length;
      let I = O, F;
      for (; I--; )
        if (n.events[I][0] === "exit" && n.events[I][1].type === "chunkFlow") {
          F = n.events[I][1].end;
          break;
        }
      _(i);
      let L = O;
      for (; L < n.events.length; )
        n.events[L][1].end = {
          ...F
        }, L++;
      return Kr(n.events, I + 1, 0, n.events.slice(O)), n.events.length = L, m(D);
    }
    return l(D);
  }
  function m(D) {
    if (i === r.length) {
      if (!a)
        return h(D);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return C(D);
      n.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return n.containerState = {}, e.check(Ix, u, f)(D);
  }
  function u(D) {
    return a && g(), _(i), h(D);
  }
  function f(D) {
    return n.parser.lazy[n.now().line] = i !== r.length, s = n.now().offset, C(D);
  }
  function h(D) {
    return n.containerState = {}, e.attempt(Ix, k, C)(D);
  }
  function k(D) {
    return i++, r.push([n.currentConstruct, n.containerState]), h(D);
  }
  function C(D) {
    if (D === null) {
      a && g(), _(0), e.consume(D);
      return;
    }
    return a = a || n.parser.flow(n.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: o
    }), N(D);
  }
  function N(D) {
    if (D === null) {
      j(e.exit("chunkFlow"), !0), _(0), e.consume(D);
      return;
    }
    return In(D) ? (e.consume(D), j(e.exit("chunkFlow")), i = 0, n.interrupt = void 0, l) : (e.consume(D), N);
  }
  function j(D, O) {
    const I = n.sliceStream(D);
    if (O && I.push(null), D.previous = o, o && (o.next = D), o = D, a.defineSkip(D.start), a.write(I), n.parser.lazy[D.start.line]) {
      let F = a.events.length;
      for (; F--; )
        if (
          // The token starts before the line ending…
          a.events[F][1].start.offset < s && // …and either is not ended yet…
          (!a.events[F][1].end || // …or ends after it.
          a.events[F][1].end.offset > s)
        )
          return;
      const L = n.events.length;
      let K = L, J, te;
      for (; K--; )
        if (n.events[K][0] === "exit" && n.events[K][1].type === "chunkFlow") {
          if (J) {
            te = n.events[K][1].end;
            break;
          }
          J = !0;
        }
      for (_(i), F = L; F < n.events.length; )
        n.events[F][1].end = {
          ...te
        }, F++;
      Kr(n.events, K + 1, 0, n.events.slice(L)), n.events.length = F;
    }
  }
  function _(D) {
    let O = r.length;
    for (; O-- > D; ) {
      const I = r[O];
      n.containerState = I[1], I[0].exit.call(n, e);
    }
    r.length = D;
  }
  function g() {
    a.write([null]), o = void 0, a = void 0, n.containerState._closeFlow = void 0;
  }
}
function $3(e, n, r) {
  return lt(e, e.attempt(this.parser.constructs.document, n, r), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function Ex(e) {
  if (e === null || nr(e) || w3(e))
    return 1;
  if (j3(e))
    return 2;
}
function xg(e, n, r) {
  const i = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const o = e[a].resolveAll;
    o && !i.includes(o) && (n = o(n, r), i.push(o));
  }
  return n;
}
const cy = {
  name: "attention",
  resolveAll: T3,
  tokenize: O3
};
function T3(e, n) {
  let r = -1, i, a, o, s, l, d, m, u;
  for (; ++r < e.length; )
    if (e[r][0] === "enter" && e[r][1].type === "attentionSequence" && e[r][1]._close) {
      for (i = r; i--; )
        if (e[i][0] === "exit" && e[i][1].type === "attentionSequence" && e[i][1]._open && // If the markers are the same:
        n.sliceSerialize(e[i][1]).charCodeAt(0) === n.sliceSerialize(e[r][1]).charCodeAt(0)) {
          if ((e[i][1]._close || e[r][1]._open) && (e[r][1].end.offset - e[r][1].start.offset) % 3 && !((e[i][1].end.offset - e[i][1].start.offset + e[r][1].end.offset - e[r][1].start.offset) % 3))
            continue;
          d = e[i][1].end.offset - e[i][1].start.offset > 1 && e[r][1].end.offset - e[r][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[i][1].end
          }, h = {
            ...e[r][1].start
          };
          $x(f, -d), $x(h, d), s = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[i][1].end
            }
          }, l = {
            type: d > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[r][1].start
            },
            end: h
          }, o = {
            type: d > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[i][1].end
            },
            end: {
              ...e[r][1].start
            }
          }, a = {
            type: d > 1 ? "strong" : "emphasis",
            start: {
              ...s.start
            },
            end: {
              ...l.end
            }
          }, e[i][1].end = {
            ...s.start
          }, e[r][1].start = {
            ...l.end
          }, m = [], e[i][1].end.offset - e[i][1].start.offset && (m = br(m, [["enter", e[i][1], n], ["exit", e[i][1], n]])), m = br(m, [["enter", a, n], ["enter", s, n], ["exit", s, n], ["enter", o, n]]), m = br(m, xg(n.parser.constructs.insideSpan.null, e.slice(i + 1, r), n)), m = br(m, [["exit", o, n], ["enter", l, n], ["exit", l, n], ["exit", a, n]]), e[r][1].end.offset - e[r][1].start.offset ? (u = 2, m = br(m, [["enter", e[r][1], n], ["exit", e[r][1], n]])) : u = 0, Kr(e, i - 1, r - i + 3, m), r = i + m.length - u - 2;
          break;
        }
    }
  for (r = -1; ++r < e.length; )
    e[r][1].type === "attentionSequence" && (e[r][1].type = "data");
  return e;
}
function O3(e, n) {
  const r = this.parser.constructs.attentionMarkers.null, i = this.previous, a = Ex(i);
  let o;
  return s;
  function s(d) {
    return o = d, e.enter("attentionSequence"), l(d);
  }
  function l(d) {
    if (d === o)
      return e.consume(d), l;
    const m = e.exit("attentionSequence"), u = Ex(d), f = !u || u === 2 && a || r.includes(d), h = !a || a === 2 && u || r.includes(i);
    return m._open = !!(o === 42 ? f : f && (a || !h)), m._close = !!(o === 42 ? h : h && (u || !f)), n(d);
  }
}
function $x(e, n) {
  e.column += n, e.offset += n, e._bufferIndex += n;
}
const R3 = {
  name: "autolink",
  tokenize: D3
};
function D3(e, n, r) {
  let i = 0;
  return a;
  function a(k) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(k) {
    return Ur(k) ? (e.consume(k), s) : k === 64 ? r(k) : m(k);
  }
  function s(k) {
    return k === 43 || k === 45 || k === 46 || cr(k) ? (i = 1, l(k)) : m(k);
  }
  function l(k) {
    return k === 58 ? (e.consume(k), i = 0, d) : (k === 43 || k === 45 || k === 46 || cr(k)) && i++ < 32 ? (e.consume(k), l) : (i = 0, m(k));
  }
  function d(k) {
    return k === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : k === null || k === 32 || k === 60 || sy(k) ? r(k) : (e.consume(k), d);
  }
  function m(k) {
    return k === 64 ? (e.consume(k), u) : x3(k) ? (e.consume(k), m) : r(k);
  }
  function u(k) {
    return cr(k) ? f(k) : r(k);
  }
  function f(k) {
    return k === 46 ? (e.consume(k), i = 0, u) : k === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(k), e.exit("autolinkMarker"), e.exit("autolink"), n) : h(k);
  }
  function h(k) {
    if ((k === 45 || cr(k)) && i++ < 63) {
      const C = k === 45 ? h : f;
      return e.consume(k), C;
    }
    return r(k);
  }
}
const ic = {
  partial: !0,
  tokenize: P3
};
function P3(e, n, r) {
  return i;
  function i(o) {
    return Yn(o) ? lt(e, a, "linePrefix")(o) : a(o);
  }
  function a(o) {
    return o === null || In(o) ? n(o) : r(o);
  }
}
const k1 = {
  continuation: {
    tokenize: L3
  },
  exit: V3,
  name: "blockQuote",
  tokenize: A3
};
function A3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    if (s === 62) {
      const l = i.containerState;
      return l.open || (e.enter("blockQuote", {
        _container: !0
      }), l.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return r(s);
  }
  function o(s) {
    return Yn(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), n) : (e.exit("blockQuotePrefix"), n(s));
  }
}
function L3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return Yn(s) ? lt(e, o, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(k1, n, r)(s);
  }
}
function V3(e) {
  e.exit("blockQuote");
}
const b1 = {
  name: "characterEscape",
  tokenize: z3
};
function z3(e, n, r) {
  return i;
  function i(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), a;
  }
  function a(o) {
    return N3(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), n) : r(o);
  }
}
const _1 = {
  name: "characterReference",
  tokenize: U3
};
function U3(e, n, r) {
  const i = this;
  let a = 0, o, s;
  return l;
  function l(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), d;
  }
  function d(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), m) : (e.enter("characterReferenceValue"), o = 31, s = cr, u(f));
  }
  function m(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = S3, u) : (e.enter("characterReferenceValue"), o = 7, s = ly, u(f));
  }
  function u(f) {
    if (f === 59 && a) {
      const h = e.exit("characterReferenceValue");
      return s === cr && !_g(i.sliceSerialize(h)) ? r(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), n);
    }
    return s(f) && a++ < o ? (e.consume(f), u) : r(f);
  }
}
const Tx = {
  partial: !0,
  tokenize: B3
}, Ox = {
  concrete: !0,
  name: "codeFenced",
  tokenize: M3
};
function M3(e, n, r) {
  const i = this, a = {
    partial: !0,
    tokenize: I
  };
  let o = 0, s = 0, l;
  return d;
  function d(F) {
    return m(F);
  }
  function m(F) {
    const L = i.events[i.events.length - 1];
    return o = L && L[1].type === "linePrefix" ? L[2].sliceSerialize(L[1], !0).length : 0, l = F, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), u(F);
  }
  function u(F) {
    return F === l ? (s++, e.consume(F), u) : s < 3 ? r(F) : (e.exit("codeFencedFenceSequence"), Yn(F) ? lt(e, f, "whitespace")(F) : f(F));
  }
  function f(F) {
    return F === null || In(F) ? (e.exit("codeFencedFence"), i.interrupt ? n(F) : e.check(Tx, N, O)(F)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(F));
  }
  function h(F) {
    return F === null || In(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(F)) : Yn(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), lt(e, k, "whitespace")(F)) : F === 96 && F === l ? r(F) : (e.consume(F), h);
  }
  function k(F) {
    return F === null || In(F) ? f(F) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), C(F));
  }
  function C(F) {
    return F === null || In(F) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(F)) : F === 96 && F === l ? r(F) : (e.consume(F), C);
  }
  function N(F) {
    return e.attempt(a, O, j)(F);
  }
  function j(F) {
    return e.enter("lineEnding"), e.consume(F), e.exit("lineEnding"), _;
  }
  function _(F) {
    return o > 0 && Yn(F) ? lt(e, g, "linePrefix", o + 1)(F) : g(F);
  }
  function g(F) {
    return F === null || In(F) ? e.check(Tx, N, O)(F) : (e.enter("codeFlowValue"), D(F));
  }
  function D(F) {
    return F === null || In(F) ? (e.exit("codeFlowValue"), g(F)) : (e.consume(F), D);
  }
  function O(F) {
    return e.exit("codeFenced"), n(F);
  }
  function I(F, L, K) {
    let J = 0;
    return te;
    function te(re) {
      return F.enter("lineEnding"), F.consume(re), F.exit("lineEnding"), W;
    }
    function W(re) {
      return F.enter("codeFencedFence"), Yn(re) ? lt(F, Y, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(re) : Y(re);
    }
    function Y(re) {
      return re === l ? (F.enter("codeFencedFenceSequence"), P(re)) : K(re);
    }
    function P(re) {
      return re === l ? (J++, F.consume(re), P) : J >= s ? (F.exit("codeFencedFenceSequence"), Yn(re) ? lt(F, B, "whitespace")(re) : B(re)) : K(re);
    }
    function B(re) {
      return re === null || In(re) ? (F.exit("codeFencedFence"), L(re)) : K(re);
    }
  }
}
function B3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return s === null ? r(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
const Nm = {
  name: "codeIndented",
  tokenize: H3
}, q3 = {
  partial: !0,
  tokenize: W3
};
function H3(e, n, r) {
  const i = this;
  return a;
  function a(m) {
    return e.enter("codeIndented"), lt(e, o, "linePrefix", 5)(m);
  }
  function o(m) {
    const u = i.events[i.events.length - 1];
    return u && u[1].type === "linePrefix" && u[2].sliceSerialize(u[1], !0).length >= 4 ? s(m) : r(m);
  }
  function s(m) {
    return m === null ? d(m) : In(m) ? e.attempt(q3, s, d)(m) : (e.enter("codeFlowValue"), l(m));
  }
  function l(m) {
    return m === null || In(m) ? (e.exit("codeFlowValue"), s(m)) : (e.consume(m), l);
  }
  function d(m) {
    return e.exit("codeIndented"), n(m);
  }
}
function W3(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return i.parser.lazy[i.now().line] ? r(s) : In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), a) : lt(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const l = i.events[i.events.length - 1];
    return l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : In(s) ? a(s) : r(s);
  }
}
const K3 = {
  name: "codeText",
  previous: Y3,
  resolve: G3,
  tokenize: J3
};
function G3(e) {
  let n = e.length - 4, r = 3, i, a;
  if ((e[r][1].type === "lineEnding" || e[r][1].type === "space") && (e[n][1].type === "lineEnding" || e[n][1].type === "space")) {
    for (i = r; ++i < n; )
      if (e[i][1].type === "codeTextData") {
        e[r][1].type = "codeTextPadding", e[n][1].type = "codeTextPadding", r += 2, n -= 2;
        break;
      }
  }
  for (i = r - 1, n++; ++i <= n; )
    a === void 0 ? i !== n && e[i][1].type !== "lineEnding" && (a = i) : (i === n || e[i][1].type === "lineEnding") && (e[a][1].type = "codeTextData", i !== a + 2 && (e[a][1].end = e[i - 1][1].end, e.splice(a + 2, i - a - 2), n -= i - a - 2, i = a + 2), a = void 0);
  return e;
}
function Y3(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function J3(e, n, r) {
  let i = 0, a, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), l(f);
  }
  function l(f) {
    return f === 96 ? (e.consume(f), i++, l) : (e.exit("codeTextSequence"), d(f));
  }
  function d(f) {
    return f === null ? r(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), d) : f === 96 ? (o = e.enter("codeTextSequence"), a = 0, u(f)) : In(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), d) : (e.enter("codeTextData"), m(f));
  }
  function m(f) {
    return f === null || f === 32 || f === 96 || In(f) ? (e.exit("codeTextData"), d(f)) : (e.consume(f), m);
  }
  function u(f) {
    return f === 96 ? (e.consume(f), a++, u) : a === i ? (e.exit("codeTextSequence"), e.exit("codeText"), n(f)) : (o.type = "codeTextData", m(f));
  }
}
class Q3 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(n) {
    this.left = n ? [...n] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(n) {
    if (n < 0 || n >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + n + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return n < this.left.length ? this.left[n] : this.right[this.right.length - n + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(n, r) {
    const i = r ?? Number.POSITIVE_INFINITY;
    return i < this.left.length ? this.left.slice(n, i) : n > this.left.length ? this.right.slice(this.right.length - i + this.left.length, this.right.length - n + this.left.length).reverse() : this.left.slice(n).concat(this.right.slice(this.right.length - i + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(n, r, i) {
    const a = r || 0;
    this.setCursor(Math.trunc(n));
    const o = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return i && to(this.left, i), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(n) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(n);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(n) {
    this.setCursor(Number.POSITIVE_INFINITY), to(this.left, n);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(n) {
    this.setCursor(0), this.right.push(n);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(n) {
    this.setCursor(0), to(this.right, n.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n) {
    if (!(n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0))
      if (n < this.left.length) {
        const r = this.left.splice(n, Number.POSITIVE_INFINITY);
        to(this.right, r.reverse());
      } else {
        const r = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
        to(this.left, r.reverse());
      }
  }
}
function to(e, n) {
  let r = 0;
  if (n.length < 1e4)
    e.push(...n);
  else
    for (; r < n.length; )
      e.push(...n.slice(r, r + 1e4)), r += 1e4;
}
function x1(e) {
  const n = {};
  let r = -1, i, a, o, s, l, d, m;
  const u = new Q3(e);
  for (; ++r < u.length; ) {
    for (; r in n; )
      r = n[r];
    if (i = u.get(r), r && i[1].type === "chunkFlow" && u.get(r - 1)[1].type === "listItemPrefix" && (d = i[1]._tokenizer.events, o = 0, o < d.length && d[o][1].type === "lineEndingBlank" && (o += 2), o < d.length && d[o][1].type === "content"))
      for (; ++o < d.length && d[o][1].type !== "content"; )
        d[o][1].type === "chunkText" && (d[o][1]._isInFirstContentOfListItem = !0, o++);
    if (i[0] === "enter")
      i[1].contentType && (Object.assign(n, X3(u, r)), r = n[r], m = !0);
    else if (i[1]._container) {
      for (o = r, a = void 0; o-- && (s = u.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (a && (u.get(a)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", a = o);
      a && (i[1].end = {
        ...u.get(a)[1].start
      }, l = u.slice(a, r), l.unshift(i), u.splice(a, r - a + 1, l));
    }
  }
  return Kr(e, 0, Number.POSITIVE_INFINITY, u.slice(0)), !m;
}
function X3(e, n) {
  const r = e.get(n)[1], i = e.get(n)[2];
  let a = n - 1;
  const o = [], s = r._tokenizer || i.parser[r.contentType](r.start), l = s.events, d = [], m = {};
  let u, f, h = -1, k = r, C = 0, N = 0;
  const j = [N];
  for (; k; ) {
    for (; e.get(++a)[1] !== k; )
      ;
    o.push(a), k._tokenizer || (u = i.sliceStream(k), k.next || u.push(null), f && s.defineSkip(k.start), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(u), k._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = k, k = k.next;
  }
  for (k = r; ++h < l.length; )
    // Find a void token that includes a break.
    l[h][0] === "exit" && l[h - 1][0] === "enter" && l[h][1].type === l[h - 1][1].type && l[h][1].start.line !== l[h][1].end.line && (N = h + 1, j.push(N), k._tokenizer = void 0, k.previous = void 0, k = k.next);
  for (s.events = [], k ? (k._tokenizer = void 0, k.previous = void 0) : j.pop(), h = j.length; h--; ) {
    const _ = l.slice(j[h], j[h + 1]), g = o.pop();
    d.push([g, g + _.length - 1]), e.splice(g, 2, _);
  }
  for (d.reverse(), h = -1; ++h < d.length; )
    m[C + d[h][0]] = C + d[h][1], C += d[h][1] - d[h][0] - 1;
  return m;
}
const Z3 = {
  resolve: nz,
  tokenize: tz
}, ez = {
  partial: !0,
  tokenize: rz
};
function nz(e) {
  return x1(e), e;
}
function tz(e, n) {
  let r;
  return i;
  function i(l) {
    return e.enter("content"), r = e.enter("chunkContent", {
      contentType: "content"
    }), a(l);
  }
  function a(l) {
    return l === null ? o(l) : In(l) ? e.check(ez, s, o)(l) : (e.consume(l), a);
  }
  function o(l) {
    return e.exit("chunkContent"), e.exit("content"), n(l);
  }
  function s(l) {
    return e.consume(l), e.exit("chunkContent"), r.next = e.enter("chunkContent", {
      contentType: "content",
      previous: r
    }), r = r.next, a;
  }
}
function rz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), lt(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || In(s))
      return r(s);
    const l = i.events[i.events.length - 1];
    return !i.parser.constructs.disable.null.includes("codeIndented") && l && l[1].type === "linePrefix" && l[2].sliceSerialize(l[1], !0).length >= 4 ? n(s) : e.interrupt(i.parser.constructs.flow, r, n)(s);
  }
}
function S1(e, n, r, i, a, o, s, l, d) {
  const m = d || Number.POSITIVE_INFINITY;
  let u = 0;
  return f;
  function f(_) {
    return _ === 60 ? (e.enter(i), e.enter(a), e.enter(o), e.consume(_), e.exit(o), h) : _ === null || _ === 32 || _ === 41 || sy(_) ? r(_) : (e.enter(i), e.enter(s), e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), N(_));
  }
  function h(_) {
    return _ === 62 ? (e.enter(o), e.consume(_), e.exit(o), e.exit(a), e.exit(i), n) : (e.enter(l), e.enter("chunkString", {
      contentType: "string"
    }), k(_));
  }
  function k(_) {
    return _ === 62 ? (e.exit("chunkString"), e.exit(l), h(_)) : _ === null || _ === 60 || In(_) ? r(_) : (e.consume(_), _ === 92 ? C : k);
  }
  function C(_) {
    return _ === 60 || _ === 62 || _ === 92 ? (e.consume(_), k) : k(_);
  }
  function N(_) {
    return !u && (_ === null || _ === 41 || nr(_)) ? (e.exit("chunkString"), e.exit(l), e.exit(s), e.exit(i), n(_)) : u < m && _ === 40 ? (e.consume(_), u++, N) : _ === 41 ? (e.consume(_), u--, N) : _ === null || _ === 32 || _ === 40 || sy(_) ? r(_) : (e.consume(_), _ === 92 ? j : N);
  }
  function j(_) {
    return _ === 40 || _ === 41 || _ === 92 ? (e.consume(_), N) : N(_);
  }
}
function N1(e, n, r, i, a, o) {
  const s = this;
  let l = 0, d;
  return m;
  function m(k) {
    return e.enter(i), e.enter(a), e.consume(k), e.exit(a), e.enter(o), u;
  }
  function u(k) {
    return l > 999 || k === null || k === 91 || k === 93 && !d || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    k === 94 && !l && "_hiddenFootnoteSupport" in s.parser.constructs ? r(k) : k === 93 ? (e.exit(o), e.enter(a), e.consume(k), e.exit(a), e.exit(i), n) : In(k) ? (e.enter("lineEnding"), e.consume(k), e.exit("lineEnding"), u) : (e.enter("chunkString", {
      contentType: "string"
    }), f(k));
  }
  function f(k) {
    return k === null || k === 91 || k === 93 || In(k) || l++ > 999 ? (e.exit("chunkString"), u(k)) : (e.consume(k), d || (d = !Yn(k)), k === 92 ? h : f);
  }
  function h(k) {
    return k === 91 || k === 92 || k === 93 ? (e.consume(k), l++, f) : f(k);
  }
}
function j1(e, n, r, i, a, o) {
  let s;
  return l;
  function l(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(i), e.enter(a), e.consume(h), e.exit(a), s = h === 40 ? 41 : h, d) : r(h);
  }
  function d(h) {
    return h === s ? (e.enter(a), e.consume(h), e.exit(a), e.exit(i), n) : (e.enter(o), m(h));
  }
  function m(h) {
    return h === s ? (e.exit(o), d(s)) : h === null ? r(h) : In(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), lt(e, m, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), u(h));
  }
  function u(h) {
    return h === s || h === null || In(h) ? (e.exit("chunkString"), m(h)) : (e.consume(h), h === 92 ? f : u);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), u) : u(h);
  }
}
function To(e, n) {
  let r;
  return i;
  function i(a) {
    return In(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), r = !0, i) : Yn(a) ? lt(e, i, r ? "linePrefix" : "lineSuffix")(a) : n(a);
  }
}
const iz = {
  name: "definition",
  tokenize: oz
}, az = {
  partial: !0,
  tokenize: sz
};
function oz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(k) {
    return e.enter("definition"), s(k);
  }
  function s(k) {
    return N1.call(
      i,
      e,
      l,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(k);
  }
  function l(k) {
    return a = ga(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1)), k === 58 ? (e.enter("definitionMarker"), e.consume(k), e.exit("definitionMarker"), d) : r(k);
  }
  function d(k) {
    return nr(k) ? To(e, m)(k) : m(k);
  }
  function m(k) {
    return S1(
      e,
      u,
      // Note: we don’t need to reset the way `markdown-rs` does.
      r,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(k);
  }
  function u(k) {
    return e.attempt(az, f, f)(k);
  }
  function f(k) {
    return Yn(k) ? lt(e, h, "whitespace")(k) : h(k);
  }
  function h(k) {
    return k === null || In(k) ? (e.exit("definition"), i.parser.defined.push(a), n(k)) : r(k);
  }
}
function sz(e, n, r) {
  return i;
  function i(l) {
    return nr(l) ? To(e, a)(l) : r(l);
  }
  function a(l) {
    return j1(e, o, r, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(l);
  }
  function o(l) {
    return Yn(l) ? lt(e, s, "whitespace")(l) : s(l);
  }
  function s(l) {
    return l === null || In(l) ? n(l) : r(l);
  }
}
const lz = {
  name: "hardBreakEscape",
  tokenize: cz
};
function cz(e, n, r) {
  return i;
  function i(o) {
    return e.enter("hardBreakEscape"), e.consume(o), a;
  }
  function a(o) {
    return In(o) ? (e.exit("hardBreakEscape"), n(o)) : r(o);
  }
}
const dz = {
  name: "headingAtx",
  resolve: uz,
  tokenize: mz
};
function uz(e, n) {
  let r = e.length - 2, i = 3, a, o;
  return e[i][1].type === "whitespace" && (i += 2), r - 2 > i && e[r][1].type === "whitespace" && (r -= 2), e[r][1].type === "atxHeadingSequence" && (i === r - 1 || r - 4 > i && e[r - 2][1].type === "whitespace") && (r -= i + 1 === r ? 2 : 4), r > i && (a = {
    type: "atxHeadingText",
    start: e[i][1].start,
    end: e[r][1].end
  }, o = {
    type: "chunkText",
    start: e[i][1].start,
    end: e[r][1].end,
    contentType: "text"
  }, Kr(e, i, r - i + 1, [["enter", a, n], ["enter", o, n], ["exit", o, n], ["exit", a, n]])), e;
}
function mz(e, n, r) {
  let i = 0;
  return a;
  function a(u) {
    return e.enter("atxHeading"), o(u);
  }
  function o(u) {
    return e.enter("atxHeadingSequence"), s(u);
  }
  function s(u) {
    return u === 35 && i++ < 6 ? (e.consume(u), s) : u === null || nr(u) ? (e.exit("atxHeadingSequence"), l(u)) : r(u);
  }
  function l(u) {
    return u === 35 ? (e.enter("atxHeadingSequence"), d(u)) : u === null || In(u) ? (e.exit("atxHeading"), n(u)) : Yn(u) ? lt(e, l, "whitespace")(u) : (e.enter("atxHeadingText"), m(u));
  }
  function d(u) {
    return u === 35 ? (e.consume(u), d) : (e.exit("atxHeadingSequence"), l(u));
  }
  function m(u) {
    return u === null || u === 35 || nr(u) ? (e.exit("atxHeadingText"), l(u)) : (e.consume(u), m);
  }
}
const pz = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Rx = ["pre", "script", "style", "textarea"], fz = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: gz,
  tokenize: vz
}, hz = {
  partial: !0,
  tokenize: bz
}, yz = {
  partial: !0,
  tokenize: kz
};
function gz(e) {
  let n = e.length;
  for (; n-- && !(e[n][0] === "enter" && e[n][1].type === "htmlFlow"); )
    ;
  return n > 1 && e[n - 2][1].type === "linePrefix" && (e[n][1].start = e[n - 2][1].start, e[n + 1][1].start = e[n - 2][1].start, e.splice(n - 2, 2)), e;
}
function vz(e, n, r) {
  const i = this;
  let a, o, s, l, d;
  return m;
  function m(q) {
    return u(q);
  }
  function u(q) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(q), f;
  }
  function f(q) {
    return q === 33 ? (e.consume(q), h) : q === 47 ? (e.consume(q), o = !0, N) : q === 63 ? (e.consume(q), a = 3, i.interrupt ? n : V) : Ur(q) ? (e.consume(q), s = String.fromCharCode(q), j) : r(q);
  }
  function h(q) {
    return q === 45 ? (e.consume(q), a = 2, k) : q === 91 ? (e.consume(q), a = 5, l = 0, C) : Ur(q) ? (e.consume(q), a = 4, i.interrupt ? n : V) : r(q);
  }
  function k(q) {
    return q === 45 ? (e.consume(q), i.interrupt ? n : V) : r(q);
  }
  function C(q) {
    const Ge = "CDATA[";
    return q === Ge.charCodeAt(l++) ? (e.consume(q), l === Ge.length ? i.interrupt ? n : Y : C) : r(q);
  }
  function N(q) {
    return Ur(q) ? (e.consume(q), s = String.fromCharCode(q), j) : r(q);
  }
  function j(q) {
    if (q === null || q === 47 || q === 62 || nr(q)) {
      const Ge = q === 47, sn = s.toLowerCase();
      return !Ge && !o && Rx.includes(sn) ? (a = 1, i.interrupt ? n(q) : Y(q)) : pz.includes(s.toLowerCase()) ? (a = 6, Ge ? (e.consume(q), _) : i.interrupt ? n(q) : Y(q)) : (a = 7, i.interrupt && !i.parser.lazy[i.now().line] ? r(q) : o ? g(q) : D(q));
    }
    return q === 45 || cr(q) ? (e.consume(q), s += String.fromCharCode(q), j) : r(q);
  }
  function _(q) {
    return q === 62 ? (e.consume(q), i.interrupt ? n : Y) : r(q);
  }
  function g(q) {
    return Yn(q) ? (e.consume(q), g) : te(q);
  }
  function D(q) {
    return q === 47 ? (e.consume(q), te) : q === 58 || q === 95 || Ur(q) ? (e.consume(q), O) : Yn(q) ? (e.consume(q), D) : te(q);
  }
  function O(q) {
    return q === 45 || q === 46 || q === 58 || q === 95 || cr(q) ? (e.consume(q), O) : I(q);
  }
  function I(q) {
    return q === 61 ? (e.consume(q), F) : Yn(q) ? (e.consume(q), I) : D(q);
  }
  function F(q) {
    return q === null || q === 60 || q === 61 || q === 62 || q === 96 ? r(q) : q === 34 || q === 39 ? (e.consume(q), d = q, L) : Yn(q) ? (e.consume(q), F) : K(q);
  }
  function L(q) {
    return q === d ? (e.consume(q), d = null, J) : q === null || In(q) ? r(q) : (e.consume(q), L);
  }
  function K(q) {
    return q === null || q === 34 || q === 39 || q === 47 || q === 60 || q === 61 || q === 62 || q === 96 || nr(q) ? I(q) : (e.consume(q), K);
  }
  function J(q) {
    return q === 47 || q === 62 || Yn(q) ? D(q) : r(q);
  }
  function te(q) {
    return q === 62 ? (e.consume(q), W) : r(q);
  }
  function W(q) {
    return q === null || In(q) ? Y(q) : Yn(q) ? (e.consume(q), W) : r(q);
  }
  function Y(q) {
    return q === 45 && a === 2 ? (e.consume(q), je) : q === 60 && a === 1 ? (e.consume(q), ue) : q === 62 && a === 4 ? (e.consume(q), ke) : q === 63 && a === 3 ? (e.consume(q), V) : q === 93 && a === 5 ? (e.consume(q), he) : In(q) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(hz, De, P)(q)) : q === null || In(q) ? (e.exit("htmlFlowData"), P(q)) : (e.consume(q), Y);
  }
  function P(q) {
    return e.check(yz, B, De)(q);
  }
  function B(q) {
    return e.enter("lineEnding"), e.consume(q), e.exit("lineEnding"), re;
  }
  function re(q) {
    return q === null || In(q) ? P(q) : (e.enter("htmlFlowData"), Y(q));
  }
  function je(q) {
    return q === 45 ? (e.consume(q), V) : Y(q);
  }
  function ue(q) {
    return q === 47 ? (e.consume(q), s = "", se) : Y(q);
  }
  function se(q) {
    if (q === 62) {
      const Ge = s.toLowerCase();
      return Rx.includes(Ge) ? (e.consume(q), ke) : Y(q);
    }
    return Ur(q) && s.length < 8 ? (e.consume(q), s += String.fromCharCode(q), se) : Y(q);
  }
  function he(q) {
    return q === 93 ? (e.consume(q), V) : Y(q);
  }
  function V(q) {
    return q === 62 ? (e.consume(q), ke) : q === 45 && a === 2 ? (e.consume(q), V) : Y(q);
  }
  function ke(q) {
    return q === null || In(q) ? (e.exit("htmlFlowData"), De(q)) : (e.consume(q), ke);
  }
  function De(q) {
    return e.exit("htmlFlow"), n(q);
  }
}
function kz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return In(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : r(s);
  }
  function o(s) {
    return i.parser.lazy[i.now().line] ? r(s) : n(s);
  }
}
function bz(e, n, r) {
  return i;
  function i(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(ic, n, r);
  }
}
const _z = {
  name: "htmlText",
  tokenize: xz
};
function xz(e, n, r) {
  const i = this;
  let a, o, s;
  return l;
  function l(V) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(V), d;
  }
  function d(V) {
    return V === 33 ? (e.consume(V), m) : V === 47 ? (e.consume(V), I) : V === 63 ? (e.consume(V), D) : Ur(V) ? (e.consume(V), K) : r(V);
  }
  function m(V) {
    return V === 45 ? (e.consume(V), u) : V === 91 ? (e.consume(V), o = 0, C) : Ur(V) ? (e.consume(V), g) : r(V);
  }
  function u(V) {
    return V === 45 ? (e.consume(V), k) : r(V);
  }
  function f(V) {
    return V === null ? r(V) : V === 45 ? (e.consume(V), h) : In(V) ? (s = f, ue(V)) : (e.consume(V), f);
  }
  function h(V) {
    return V === 45 ? (e.consume(V), k) : f(V);
  }
  function k(V) {
    return V === 62 ? je(V) : V === 45 ? h(V) : f(V);
  }
  function C(V) {
    const ke = "CDATA[";
    return V === ke.charCodeAt(o++) ? (e.consume(V), o === ke.length ? N : C) : r(V);
  }
  function N(V) {
    return V === null ? r(V) : V === 93 ? (e.consume(V), j) : In(V) ? (s = N, ue(V)) : (e.consume(V), N);
  }
  function j(V) {
    return V === 93 ? (e.consume(V), _) : N(V);
  }
  function _(V) {
    return V === 62 ? je(V) : V === 93 ? (e.consume(V), _) : N(V);
  }
  function g(V) {
    return V === null || V === 62 ? je(V) : In(V) ? (s = g, ue(V)) : (e.consume(V), g);
  }
  function D(V) {
    return V === null ? r(V) : V === 63 ? (e.consume(V), O) : In(V) ? (s = D, ue(V)) : (e.consume(V), D);
  }
  function O(V) {
    return V === 62 ? je(V) : D(V);
  }
  function I(V) {
    return Ur(V) ? (e.consume(V), F) : r(V);
  }
  function F(V) {
    return V === 45 || cr(V) ? (e.consume(V), F) : L(V);
  }
  function L(V) {
    return In(V) ? (s = L, ue(V)) : Yn(V) ? (e.consume(V), L) : je(V);
  }
  function K(V) {
    return V === 45 || cr(V) ? (e.consume(V), K) : V === 47 || V === 62 || nr(V) ? J(V) : r(V);
  }
  function J(V) {
    return V === 47 ? (e.consume(V), je) : V === 58 || V === 95 || Ur(V) ? (e.consume(V), te) : In(V) ? (s = J, ue(V)) : Yn(V) ? (e.consume(V), J) : je(V);
  }
  function te(V) {
    return V === 45 || V === 46 || V === 58 || V === 95 || cr(V) ? (e.consume(V), te) : W(V);
  }
  function W(V) {
    return V === 61 ? (e.consume(V), Y) : In(V) ? (s = W, ue(V)) : Yn(V) ? (e.consume(V), W) : J(V);
  }
  function Y(V) {
    return V === null || V === 60 || V === 61 || V === 62 || V === 96 ? r(V) : V === 34 || V === 39 ? (e.consume(V), a = V, P) : In(V) ? (s = Y, ue(V)) : Yn(V) ? (e.consume(V), Y) : (e.consume(V), B);
  }
  function P(V) {
    return V === a ? (e.consume(V), a = void 0, re) : V === null ? r(V) : In(V) ? (s = P, ue(V)) : (e.consume(V), P);
  }
  function B(V) {
    return V === null || V === 34 || V === 39 || V === 60 || V === 61 || V === 96 ? r(V) : V === 47 || V === 62 || nr(V) ? J(V) : (e.consume(V), B);
  }
  function re(V) {
    return V === 47 || V === 62 || nr(V) ? J(V) : r(V);
  }
  function je(V) {
    return V === 62 ? (e.consume(V), e.exit("htmlTextData"), e.exit("htmlText"), n) : r(V);
  }
  function ue(V) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(V), e.exit("lineEnding"), se;
  }
  function se(V) {
    return Yn(V) ? lt(e, he, "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(V) : he(V);
  }
  function he(V) {
    return e.enter("htmlTextData"), s(V);
  }
}
const Sg = {
  name: "labelEnd",
  resolveAll: wz,
  resolveTo: Cz,
  tokenize: Fz
}, Sz = {
  tokenize: Iz
}, Nz = {
  tokenize: Ez
}, jz = {
  tokenize: $z
};
function wz(e) {
  let n = -1;
  const r = [];
  for (; ++n < e.length; ) {
    const i = e[n][1];
    if (r.push(e[n]), i.type === "labelImage" || i.type === "labelLink" || i.type === "labelEnd") {
      const a = i.type === "labelImage" ? 4 : 2;
      i.type = "data", n += a;
    }
  }
  return e.length !== r.length && Kr(e, 0, e.length, r), e;
}
function Cz(e, n) {
  let r = e.length, i = 0, a, o, s, l;
  for (; r--; )
    if (a = e[r][1], o) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[r][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (s) {
      if (e[r][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (o = r, a.type !== "labelLink")) {
        i = 2;
        break;
      }
    } else a.type === "labelEnd" && (s = r);
  const d = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, m = {
    type: "label",
    start: {
      ...e[o][1].start
    },
    end: {
      ...e[s][1].end
    }
  }, u = {
    type: "labelText",
    start: {
      ...e[o + i + 2][1].end
    },
    end: {
      ...e[s - 2][1].start
    }
  };
  return l = [["enter", d, n], ["enter", m, n]], l = br(l, e.slice(o + 1, o + i + 3)), l = br(l, [["enter", u, n]]), l = br(l, xg(n.parser.constructs.insideSpan.null, e.slice(o + i + 4, s - 3), n)), l = br(l, [["exit", u, n], e[s - 2], e[s - 1], ["exit", m, n]]), l = br(l, e.slice(s + 1)), l = br(l, [["exit", d, n]]), Kr(e, o, e.length, l), e;
}
function Fz(e, n, r) {
  const i = this;
  let a = i.events.length, o, s;
  for (; a--; )
    if ((i.events[a][1].type === "labelImage" || i.events[a][1].type === "labelLink") && !i.events[a][1]._balanced) {
      o = i.events[a][1];
      break;
    }
  return l;
  function l(h) {
    return o ? o._inactive ? f(h) : (s = i.parser.defined.includes(ga(i.sliceSerialize({
      start: o.end,
      end: i.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), d) : r(h);
  }
  function d(h) {
    return h === 40 ? e.attempt(Sz, u, s ? u : f)(h) : h === 91 ? e.attempt(Nz, u, s ? m : f)(h) : s ? u(h) : f(h);
  }
  function m(h) {
    return e.attempt(jz, u, f)(h);
  }
  function u(h) {
    return n(h);
  }
  function f(h) {
    return o._balanced = !0, r(h);
  }
}
function Iz(e, n, r) {
  return i;
  function i(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return nr(f) ? To(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? u(f) : S1(e, s, l, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return nr(f) ? To(e, d)(f) : u(f);
  }
  function l(f) {
    return r(f);
  }
  function d(f) {
    return f === 34 || f === 39 || f === 40 ? j1(e, m, r, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : u(f);
  }
  function m(f) {
    return nr(f) ? To(e, u)(f) : u(f);
  }
  function u(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), n) : r(f);
  }
}
function Ez(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return N1.call(i, e, o, s, "reference", "referenceMarker", "referenceString")(l);
  }
  function o(l) {
    return i.parser.defined.includes(ga(i.sliceSerialize(i.events[i.events.length - 1][1]).slice(1, -1))) ? n(l) : r(l);
  }
  function s(l) {
    return r(l);
  }
}
function $z(e, n, r) {
  return i;
  function i(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), a;
  }
  function a(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), n) : r(o);
  }
}
const Tz = {
  name: "labelStartImage",
  resolveAll: Sg.resolveAll,
  tokenize: Oz
};
function Oz(e, n, r) {
  const i = this;
  return a;
  function a(l) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(l), e.exit("labelImageMarker"), o;
  }
  function o(l) {
    return l === 91 ? (e.enter("labelMarker"), e.consume(l), e.exit("labelMarker"), e.exit("labelImage"), s) : r(l);
  }
  function s(l) {
    return l === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(l) : n(l);
  }
}
const Rz = {
  name: "labelStartLink",
  resolveAll: Sg.resolveAll,
  tokenize: Dz
};
function Dz(e, n, r) {
  const i = this;
  return a;
  function a(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in i.parser.constructs ? r(s) : n(s);
  }
}
const jm = {
  name: "lineEnding",
  tokenize: Pz
};
function Pz(e, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), lt(e, n, "linePrefix");
  }
}
const rl = {
  name: "thematicBreak",
  tokenize: Az
};
function Az(e, n, r) {
  let i = 0, a;
  return o;
  function o(m) {
    return e.enter("thematicBreak"), s(m);
  }
  function s(m) {
    return a = m, l(m);
  }
  function l(m) {
    return m === a ? (e.enter("thematicBreakSequence"), d(m)) : i >= 3 && (m === null || In(m)) ? (e.exit("thematicBreak"), n(m)) : r(m);
  }
  function d(m) {
    return m === a ? (e.consume(m), i++, d) : (e.exit("thematicBreakSequence"), Yn(m) ? lt(e, l, "whitespace")(m) : l(m));
  }
}
const Zt = {
  continuation: {
    tokenize: Uz
  },
  exit: Bz,
  name: "list",
  tokenize: zz
}, Lz = {
  partial: !0,
  tokenize: qz
}, Vz = {
  partial: !0,
  tokenize: Mz
};
function zz(e, n, r) {
  const i = this, a = i.events[i.events.length - 1];
  let o = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, s = 0;
  return l;
  function l(k) {
    const C = i.containerState.type || (k === 42 || k === 43 || k === 45 ? "listUnordered" : "listOrdered");
    if (C === "listUnordered" ? !i.containerState.marker || k === i.containerState.marker : ly(k)) {
      if (i.containerState.type || (i.containerState.type = C, e.enter(C, {
        _container: !0
      })), C === "listUnordered")
        return e.enter("listItemPrefix"), k === 42 || k === 45 ? e.check(rl, r, m)(k) : m(k);
      if (!i.interrupt || k === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), d(k);
    }
    return r(k);
  }
  function d(k) {
    return ly(k) && ++s < 10 ? (e.consume(k), d) : (!i.interrupt || s < 2) && (i.containerState.marker ? k === i.containerState.marker : k === 41 || k === 46) ? (e.exit("listItemValue"), m(k)) : r(k);
  }
  function m(k) {
    return e.enter("listItemMarker"), e.consume(k), e.exit("listItemMarker"), i.containerState.marker = i.containerState.marker || k, e.check(
      ic,
      // Can’t be empty when interrupting.
      i.interrupt ? r : u,
      e.attempt(Lz, h, f)
    );
  }
  function u(k) {
    return i.containerState.initialBlankLine = !0, o++, h(k);
  }
  function f(k) {
    return Yn(k) ? (e.enter("listItemPrefixWhitespace"), e.consume(k), e.exit("listItemPrefixWhitespace"), h) : r(k);
  }
  function h(k) {
    return i.containerState.size = o + i.sliceSerialize(e.exit("listItemPrefix"), !0).length, n(k);
  }
}
function Uz(e, n, r) {
  const i = this;
  return i.containerState._closeFlow = void 0, e.check(ic, a, o);
  function a(l) {
    return i.containerState.furtherBlankLines = i.containerState.furtherBlankLines || i.containerState.initialBlankLine, lt(e, n, "listItemIndent", i.containerState.size + 1)(l);
  }
  function o(l) {
    return i.containerState.furtherBlankLines || !Yn(l) ? (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, s(l)) : (i.containerState.furtherBlankLines = void 0, i.containerState.initialBlankLine = void 0, e.attempt(Vz, n, s)(l));
  }
  function s(l) {
    return i.containerState._closeFlow = !0, i.interrupt = void 0, lt(e, e.attempt(Zt, n, r), "linePrefix", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(l);
  }
}
function Mz(e, n, r) {
  const i = this;
  return lt(e, a, "listItemIndent", i.containerState.size + 1);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === i.containerState.size ? n(o) : r(o);
  }
}
function Bz(e) {
  e.exit(this.containerState.type);
}
function qz(e, n, r) {
  const i = this;
  return lt(e, a, "listItemPrefixWhitespace", i.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(o) {
    const s = i.events[i.events.length - 1];
    return !Yn(o) && s && s[1].type === "listItemPrefixWhitespace" ? n(o) : r(o);
  }
}
const Dx = {
  name: "setextUnderline",
  resolveTo: Hz,
  tokenize: Wz
};
function Hz(e, n) {
  let r = e.length, i, a, o;
  for (; r--; )
    if (e[r][0] === "enter") {
      if (e[r][1].type === "content") {
        i = r;
        break;
      }
      e[r][1].type === "paragraph" && (a = r);
    } else
      e[r][1].type === "content" && e.splice(r, 1), !o && e[r][1].type === "definition" && (o = r);
  const s = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", o ? (e.splice(a, 0, ["enter", s, n]), e.splice(o + 1, 0, ["exit", e[i][1], n]), e[i][1].end = {
    ...e[o][1].end
  }) : e[i][1] = s, e.push(["exit", s, n]), e;
}
function Wz(e, n, r) {
  const i = this;
  let a;
  return o;
  function o(m) {
    let u = i.events.length, f;
    for (; u--; )
      if (i.events[u][1].type !== "lineEnding" && i.events[u][1].type !== "linePrefix" && i.events[u][1].type !== "content") {
        f = i.events[u][1].type === "paragraph";
        break;
      }
    return !i.parser.lazy[i.now().line] && (i.interrupt || f) ? (e.enter("setextHeadingLine"), a = m, s(m)) : r(m);
  }
  function s(m) {
    return e.enter("setextHeadingLineSequence"), l(m);
  }
  function l(m) {
    return m === a ? (e.consume(m), l) : (e.exit("setextHeadingLineSequence"), Yn(m) ? lt(e, d, "lineSuffix")(m) : d(m));
  }
  function d(m) {
    return m === null || In(m) ? (e.exit("setextHeadingLine"), n(m)) : r(m);
  }
}
const Kz = {
  tokenize: Gz
};
function Gz(e) {
  const n = this, r = e.attempt(
    // Try to parse a blank line.
    ic,
    i,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, lt(e, e.attempt(this.parser.constructs.flow, a, e.attempt(Z3, a)), "linePrefix"))
  );
  return r;
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), n.currentConstruct = void 0, r;
  }
  function a(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), n.currentConstruct = void 0, r;
  }
}
const Yz = {
  resolveAll: C1()
}, Jz = w1("string"), Qz = w1("text");
function w1(e) {
  return {
    resolveAll: C1(e === "text" ? Xz : void 0),
    tokenize: n
  };
  function n(r) {
    const i = this, a = this.parser.constructs[e], o = r.attempt(a, s, l);
    return s;
    function s(u) {
      return m(u) ? o(u) : l(u);
    }
    function l(u) {
      if (u === null) {
        r.consume(u);
        return;
      }
      return r.enter("data"), r.consume(u), d;
    }
    function d(u) {
      return m(u) ? (r.exit("data"), o(u)) : (r.consume(u), d);
    }
    function m(u) {
      if (u === null)
        return !0;
      const f = a[u];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const k = f[h];
          if (!k.previous || k.previous.call(i, i.previous))
            return !0;
        }
      return !1;
    }
  }
}
function C1(e) {
  return n;
  function n(r, i) {
    let a = -1, o;
    for (; ++a <= r.length; )
      o === void 0 ? r[a] && r[a][1].type === "data" && (o = a, a++) : (!r[a] || r[a][1].type !== "data") && (a !== o + 2 && (r[o][1].end = r[a - 1][1].end, r.splice(o + 2, a - o - 2), a = o + 2), o = void 0);
    return e ? e(r, i) : r;
  }
}
function Xz(e, n) {
  let r = 0;
  for (; ++r <= e.length; )
    if ((r === e.length || e[r][1].type === "lineEnding") && e[r - 1][1].type === "data") {
      const i = e[r - 1][1], a = n.sliceStream(i);
      let o = a.length, s = -1, l = 0, d;
      for (; o--; ) {
        const m = a[o];
        if (typeof m == "string") {
          for (s = m.length; m.charCodeAt(s - 1) === 32; )
            l++, s--;
          if (s) break;
          s = -1;
        } else if (m === -2)
          d = !0, l++;
        else if (m !== -1) {
          o++;
          break;
        }
      }
      if (l) {
        const m = {
          type: r === e.length || d || l < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: o ? s : i.start._bufferIndex + s,
            _index: i.start._index + o,
            line: i.end.line,
            column: i.end.column - l,
            offset: i.end.offset - l
          },
          end: {
            ...i.end
          }
        };
        i.end = {
          ...m.start
        }, i.start.offset === i.end.offset ? Object.assign(i, m) : (e.splice(r, 0, ["enter", m, n], ["exit", m, n]), r += 2);
      }
      r++;
    }
  return e;
}
const Zz = {
  42: Zt,
  43: Zt,
  45: Zt,
  48: Zt,
  49: Zt,
  50: Zt,
  51: Zt,
  52: Zt,
  53: Zt,
  54: Zt,
  55: Zt,
  56: Zt,
  57: Zt,
  62: k1
}, eU = {
  91: iz
}, nU = {
  [-2]: Nm,
  [-1]: Nm,
  32: Nm
}, tU = {
  35: dz,
  42: rl,
  45: [Dx, rl],
  60: fz,
  61: Dx,
  95: rl,
  96: Ox,
  126: Ox
}, rU = {
  38: _1,
  92: b1
}, iU = {
  [-5]: jm,
  [-4]: jm,
  [-3]: jm,
  33: Tz,
  38: _1,
  42: cy,
  60: [R3, _z],
  91: Rz,
  92: [lz, b1],
  93: Sg,
  95: cy,
  96: K3
}, aU = {
  null: [cy, Yz]
}, oU = {
  null: [42, 95]
}, sU = {
  null: []
}, lU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: oU,
  contentInitial: eU,
  disable: sU,
  document: Zz,
  flow: tU,
  flowInitial: nU,
  insideSpan: aU,
  string: rU,
  text: iU
}, Symbol.toStringTag, { value: "Module" }));
function cU(e, n, r) {
  let i = {
    _bufferIndex: -1,
    _index: 0,
    line: r && r.line || 1,
    column: r && r.column || 1,
    offset: r && r.offset || 0
  };
  const a = {}, o = [];
  let s = [], l = [];
  const d = {
    attempt: L(I),
    check: L(F),
    consume: g,
    enter: D,
    exit: O,
    interrupt: L(F, {
      interrupt: !0
    })
  }, m = {
    code: null,
    containerState: {},
    defineSkip: N,
    events: [],
    now: C,
    parser: e,
    previous: null,
    sliceSerialize: h,
    sliceStream: k,
    write: f
  };
  let u = n.tokenize.call(m, d);
  return n.resolveAll && o.push(n), m;
  function f(W) {
    return s = br(s, W), j(), s[s.length - 1] !== null ? [] : (K(n, 0), m.events = xg(o, m.events, m), m.events);
  }
  function h(W, Y) {
    return uU(k(W), Y);
  }
  function k(W) {
    return dU(s, W);
  }
  function C() {
    const {
      _bufferIndex: W,
      _index: Y,
      line: P,
      column: B,
      offset: re
    } = i;
    return {
      _bufferIndex: W,
      _index: Y,
      line: P,
      column: B,
      offset: re
    };
  }
  function N(W) {
    a[W.line] = W.column, te();
  }
  function j() {
    let W;
    for (; i._index < s.length; ) {
      const Y = s[i._index];
      if (typeof Y == "string")
        for (W = i._index, i._bufferIndex < 0 && (i._bufferIndex = 0); i._index === W && i._bufferIndex < Y.length; )
          _(Y.charCodeAt(i._bufferIndex));
      else
        _(Y);
    }
  }
  function _(W) {
    u = u(W);
  }
  function g(W) {
    In(W) ? (i.line++, i.column = 1, i.offset += W === -3 ? 2 : 1, te()) : W !== -1 && (i.column++, i.offset++), i._bufferIndex < 0 ? i._index++ : (i._bufferIndex++, i._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    s[i._index].length && (i._bufferIndex = -1, i._index++)), m.previous = W;
  }
  function D(W, Y) {
    const P = Y || {};
    return P.type = W, P.start = C(), m.events.push(["enter", P, m]), l.push(P), P;
  }
  function O(W) {
    const Y = l.pop();
    return Y.end = C(), m.events.push(["exit", Y, m]), Y;
  }
  function I(W, Y) {
    K(W, Y.from);
  }
  function F(W, Y) {
    Y.restore();
  }
  function L(W, Y) {
    return P;
    function P(B, re, je) {
      let ue, se, he, V;
      return Array.isArray(B) ? (
        /* c8 ignore next 1 */
        De(B)
      ) : "tokenize" in B ? (
        // Looks like a construct.
        De([
          /** @type {Construct} */
          B
        ])
      ) : ke(B);
      function ke(Ie) {
        return Ue;
        function Ue(Re) {
          const Be = Re !== null && Ie[Re], Ae = Re !== null && Ie.null, Je = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(Be) ? Be : Be ? [Be] : [],
            ...Array.isArray(Ae) ? Ae : Ae ? [Ae] : []
          ];
          return De(Je)(Re);
        }
      }
      function De(Ie) {
        return ue = Ie, se = 0, Ie.length === 0 ? je : q(Ie[se]);
      }
      function q(Ie) {
        return Ue;
        function Ue(Re) {
          return V = J(), he = Ie, Ie.partial || (m.currentConstruct = Ie), Ie.name && m.parser.constructs.disable.null.includes(Ie.name) ? sn() : Ie.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            Y ? Object.assign(Object.create(m), Y) : m,
            d,
            Ge,
            sn
          )(Re);
        }
      }
      function Ge(Ie) {
        return W(he, V), re;
      }
      function sn(Ie) {
        return V.restore(), ++se < ue.length ? q(ue[se]) : je;
      }
    }
  }
  function K(W, Y) {
    W.resolveAll && !o.includes(W) && o.push(W), W.resolve && Kr(m.events, Y, m.events.length - Y, W.resolve(m.events.slice(Y), m)), W.resolveTo && (m.events = W.resolveTo(m.events, m));
  }
  function J() {
    const W = C(), Y = m.previous, P = m.currentConstruct, B = m.events.length, re = Array.from(l);
    return {
      from: B,
      restore: je
    };
    function je() {
      i = W, m.previous = Y, m.currentConstruct = P, m.events.length = B, l = re, te();
    }
  }
  function te() {
    i.line in a && i.column < 2 && (i.column = a[i.line], i.offset += a[i.line] - 1);
  }
}
function dU(e, n) {
  const r = n.start._index, i = n.start._bufferIndex, a = n.end._index, o = n.end._bufferIndex;
  let s;
  if (r === a)
    s = [e[r].slice(i, o)];
  else {
    if (s = e.slice(r, a), i > -1) {
      const l = s[0];
      typeof l == "string" ? s[0] = l.slice(i) : s.shift();
    }
    o > 0 && s.push(e[a].slice(0, o));
  }
  return s;
}
function uU(e, n) {
  let r = -1;
  const i = [];
  let a;
  for (; ++r < e.length; ) {
    const o = e[r];
    let s;
    if (typeof o == "string")
      s = o;
    else switch (o) {
      case -5: {
        s = "\r";
        break;
      }
      case -4: {
        s = `
`;
        break;
      }
      case -3: {
        s = `\r
`;
        break;
      }
      case -2: {
        s = n ? " " : "	";
        break;
      }
      case -1: {
        if (!n && a) continue;
        s = " ";
        break;
      }
      default:
        s = String.fromCharCode(o);
    }
    a = o === -2, i.push(s);
  }
  return i.join("");
}
function mU(e) {
  const i = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      k3([lU, ...(e || {}).extensions || []])
    ),
    content: a(C3),
    defined: [],
    document: a(I3),
    flow: a(Kz),
    lazy: {},
    string: a(Jz),
    text: a(Qz)
  };
  return i;
  function a(o) {
    return s;
    function s(l) {
      return cU(i, o, l);
    }
  }
}
function pU(e) {
  for (; !x1(e); )
    ;
  return e;
}
const Px = /[\0\t\n\r]/g;
function fU() {
  let e = 1, n = "", r = !0, i;
  return a;
  function a(o, s, l) {
    const d = [];
    let m, u, f, h, k;
    for (o = n + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, n = "", r && (o.charCodeAt(0) === 65279 && f++, r = void 0); f < o.length; ) {
      if (Px.lastIndex = f, m = Px.exec(o), h = m && m.index !== void 0 ? m.index : o.length, k = o.charCodeAt(h), !m) {
        n = o.slice(f);
        break;
      }
      if (k === 10 && f === h && i)
        d.push(-3), i = void 0;
      else
        switch (i && (d.push(-5), i = void 0), f < h && (d.push(o.slice(f, h)), e += h - f), k) {
          case 0: {
            d.push(65533), e++;
            break;
          }
          case 9: {
            for (u = Math.ceil(e / 4) * 4, d.push(-2); e++ < u; ) d.push(-1);
            break;
          }
          case 10: {
            d.push(-4), e = 1;
            break;
          }
          default:
            i = !0, e = 1;
        }
      f = h + 1;
    }
    return l && (i && d.push(-5), n && d.push(n), d.push(null)), d;
  }
}
const hU = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function yU(e) {
  return e.replace(hU, gU);
}
function gU(e, n, r) {
  if (n)
    return n;
  if (r.charCodeAt(0) === 35) {
    const a = r.charCodeAt(1), o = a === 120 || a === 88;
    return v1(r.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return _g(r) || e;
}
const F1 = {}.hasOwnProperty;
function vU(e, n, r) {
  return typeof n != "string" && (r = n, n = void 0), kU(r)(pU(mU(r).document().write(fU()(e, n, !0))));
}
function kU(e) {
  const n = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Pe),
      autolinkProtocol: J,
      autolinkEmail: J,
      atxHeading: o(oe),
      blockQuote: o(Ae),
      characterEscape: J,
      characterReference: J,
      codeFenced: o(Je),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(Je, s),
      codeText: o($e, s),
      codeTextData: J,
      data: J,
      codeFlowValue: J,
      definition: o(Me),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(en),
      hardBreakEscape: o(le),
      hardBreakTrailing: o(le),
      htmlFlow: o(xe, s),
      htmlFlowData: J,
      htmlText: o(xe, s),
      htmlTextData: J,
      image: o(Ve),
      label: s,
      link: o(Pe),
      listItem: o(Q),
      listItemValue: h,
      listOrdered: o(vn, f),
      listUnordered: o(vn),
      paragraph: o(E),
      reference: q,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(oe),
      strong: o(z),
      thematicBreak: o(ce)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: I,
      autolink: d(),
      autolinkEmail: Be,
      autolinkProtocol: Re,
      blockQuote: d(),
      characterEscapeValue: te,
      characterReferenceMarkerHexadecimal: sn,
      characterReferenceMarkerNumeric: sn,
      characterReferenceValue: Ie,
      characterReference: Ue,
      codeFenced: d(j),
      codeFencedFence: N,
      codeFencedFenceInfo: k,
      codeFencedFenceMeta: C,
      codeFlowValue: te,
      codeIndented: d(_),
      codeText: d(re),
      codeTextData: te,
      data: te,
      definition: d(),
      definitionDestinationString: O,
      definitionLabelString: g,
      definitionTitleString: D,
      emphasis: d(),
      hardBreakEscape: d(Y),
      hardBreakTrailing: d(Y),
      htmlFlow: d(P),
      htmlFlowData: te,
      htmlText: d(B),
      htmlTextData: te,
      image: d(ue),
      label: he,
      labelText: se,
      lineEnding: W,
      link: d(je),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: Ge,
      resourceDestinationString: V,
      resourceTitleString: ke,
      resource: De,
      setextHeading: d(K),
      setextHeadingLineSequence: L,
      setextHeadingText: F,
      strong: d(),
      thematicBreak: d()
    }
  };
  I1(n, (e || {}).mdastExtensions || []);
  const r = {};
  return i;
  function i(U) {
    let G = {
      type: "root",
      children: []
    };
    const ye = {
      stack: [G],
      tokenStack: [],
      config: n,
      enter: l,
      exit: m,
      buffer: s,
      resume: u,
      data: r
    }, Ne = [];
    let Oe = -1;
    for (; ++Oe < U.length; )
      if (U[Oe][1].type === "listOrdered" || U[Oe][1].type === "listUnordered")
        if (U[Oe][0] === "enter")
          Ne.push(Oe);
        else {
          const rn = Ne.pop();
          Oe = a(U, rn, Oe);
        }
    for (Oe = -1; ++Oe < U.length; ) {
      const rn = n[U[Oe][0]];
      F1.call(rn, U[Oe][1].type) && rn[U[Oe][1].type].call(Object.assign({
        sliceSerialize: U[Oe][2].sliceSerialize
      }, ye), U[Oe][1]);
    }
    if (ye.tokenStack.length > 0) {
      const rn = ye.tokenStack[ye.tokenStack.length - 1];
      (rn[1] || Ax).call(ye, void 0, rn[0]);
    }
    for (G.position = {
      start: ci(U.length > 0 ? U[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: ci(U.length > 0 ? U[U.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, Oe = -1; ++Oe < n.transforms.length; )
      G = n.transforms[Oe](G) || G;
    return G;
  }
  function a(U, G, ye) {
    let Ne = G - 1, Oe = -1, rn = !1, kn, an, pn, $n;
    for (; ++Ne <= ye; ) {
      const _n = U[Ne];
      switch (_n[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          _n[0] === "enter" ? Oe++ : Oe--, $n = void 0;
          break;
        }
        case "lineEndingBlank": {
          _n[0] === "enter" && (kn && !$n && !Oe && !pn && (pn = Ne), $n = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          $n = void 0;
      }
      if (!Oe && _n[0] === "enter" && _n[1].type === "listItemPrefix" || Oe === -1 && _n[0] === "exit" && (_n[1].type === "listUnordered" || _n[1].type === "listOrdered")) {
        if (kn) {
          let Fn = Ne;
          for (an = void 0; Fn--; ) {
            const Ze = U[Fn];
            if (Ze[1].type === "lineEnding" || Ze[1].type === "lineEndingBlank") {
              if (Ze[0] === "exit") continue;
              an && (U[an][1].type = "lineEndingBlank", rn = !0), Ze[1].type = "lineEnding", an = Fn;
            } else if (!(Ze[1].type === "linePrefix" || Ze[1].type === "blockQuotePrefix" || Ze[1].type === "blockQuotePrefixWhitespace" || Ze[1].type === "blockQuoteMarker" || Ze[1].type === "listItemIndent")) break;
          }
          pn && (!an || pn < an) && (kn._spread = !0), kn.end = Object.assign({}, an ? U[an][1].start : _n[1].end), U.splice(an || Ne, 0, ["exit", kn, _n[2]]), Ne++, ye++;
        }
        if (_n[1].type === "listItemPrefix") {
          const Fn = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, _n[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          kn = Fn, U.splice(Ne, 0, ["enter", Fn, _n[2]]), Ne++, ye++, pn = void 0, $n = !0;
        }
      }
    }
    return U[G][1]._spread = rn, ye;
  }
  function o(U, G) {
    return ye;
    function ye(Ne) {
      l.call(this, U(Ne), Ne), G && G.call(this, Ne);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function l(U, G, ye) {
    this.stack[this.stack.length - 1].children.push(U), this.stack.push(U), this.tokenStack.push([G, ye || void 0]), U.position = {
      start: ci(G.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function d(U) {
    return G;
    function G(ye) {
      U && U.call(this, ye), m.call(this, ye);
    }
  }
  function m(U, G) {
    const ye = this.stack.pop(), Ne = this.tokenStack.pop();
    if (Ne)
      Ne[0].type !== U.type && (G ? G.call(this, U, Ne[0]) : (Ne[1] || Ax).call(this, U, Ne[0]));
    else throw new Error("Cannot close `" + U.type + "` (" + $o({
      start: U.start,
      end: U.end
    }) + "): it’s not open");
    ye.position.end = ci(U.end);
  }
  function u() {
    return g3(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(U) {
    if (this.data.expectingFirstListItemValue) {
      const G = this.stack[this.stack.length - 2];
      G.start = Number.parseInt(this.sliceSerialize(U), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function k() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.lang = U;
  }
  function C() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.meta = U;
  }
  function N() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function j() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function _() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U.replace(/(\r?\n|\r)$/g, "");
  }
  function g(U) {
    const G = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = G, ye.identifier = ga(this.sliceSerialize(U)).toLowerCase();
  }
  function D() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = U;
  }
  function O() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = U;
  }
  function I(U) {
    const G = this.stack[this.stack.length - 1];
    if (!G.depth) {
      const ye = this.sliceSerialize(U).length;
      G.depth = ye;
    }
  }
  function F() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function L(U) {
    const G = this.stack[this.stack.length - 1];
    G.depth = this.sliceSerialize(U).codePointAt(0) === 61 ? 1 : 2;
  }
  function K() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function J(U) {
    const ye = this.stack[this.stack.length - 1].children;
    let Ne = ye[ye.length - 1];
    (!Ne || Ne.type !== "text") && (Ne = ie(), Ne.position = {
      start: ci(U.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, ye.push(Ne)), this.stack.push(Ne);
  }
  function te(U) {
    const G = this.stack.pop();
    G.value += this.sliceSerialize(U), G.position.end = ci(U.end);
  }
  function W(U) {
    const G = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const ye = G.children[G.children.length - 1];
      ye.position.end = ci(U.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && n.canContainEols.includes(G.type) && (J.call(this, U), te.call(this, U));
  }
  function Y() {
    this.data.atHardBreak = !0;
  }
  function P() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function B() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function re() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.value = U;
  }
  function je() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = G, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function ue() {
    const U = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const G = this.data.referenceType || "shortcut";
      U.type += "Reference", U.referenceType = G, delete U.url, delete U.title;
    } else
      delete U.identifier, delete U.label;
    this.data.referenceType = void 0;
  }
  function se(U) {
    const G = this.sliceSerialize(U), ye = this.stack[this.stack.length - 2];
    ye.label = yU(G), ye.identifier = ga(G).toLowerCase();
  }
  function he() {
    const U = this.stack[this.stack.length - 1], G = this.resume(), ye = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, ye.type === "link") {
      const Ne = U.children;
      ye.children = Ne;
    } else
      ye.alt = G;
  }
  function V() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.url = U;
  }
  function ke() {
    const U = this.resume(), G = this.stack[this.stack.length - 1];
    G.title = U;
  }
  function De() {
    this.data.inReference = void 0;
  }
  function q() {
    this.data.referenceType = "collapsed";
  }
  function Ge(U) {
    const G = this.resume(), ye = this.stack[this.stack.length - 1];
    ye.label = G, ye.identifier = ga(this.sliceSerialize(U)).toLowerCase(), this.data.referenceType = "full";
  }
  function sn(U) {
    this.data.characterReferenceType = U.type;
  }
  function Ie(U) {
    const G = this.sliceSerialize(U), ye = this.data.characterReferenceType;
    let Ne;
    ye ? (Ne = v1(G, ye === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Ne = _g(G);
    const Oe = this.stack[this.stack.length - 1];
    Oe.value += Ne;
  }
  function Ue(U) {
    const G = this.stack.pop();
    G.position.end = ci(U.end);
  }
  function Re(U) {
    te.call(this, U);
    const G = this.stack[this.stack.length - 1];
    G.url = this.sliceSerialize(U);
  }
  function Be(U) {
    te.call(this, U);
    const G = this.stack[this.stack.length - 1];
    G.url = "mailto:" + this.sliceSerialize(U);
  }
  function Ae() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function Je() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function $e() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Me() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function en() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function oe() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function le() {
    return {
      type: "break"
    };
  }
  function xe() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ve() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Pe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function vn(U) {
    return {
      type: "list",
      ordered: U.type === "listOrdered",
      start: null,
      spread: U._spread,
      children: []
    };
  }
  function Q(U) {
    return {
      type: "listItem",
      spread: U._spread,
      checked: null,
      children: []
    };
  }
  function E() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function z() {
    return {
      type: "strong",
      children: []
    };
  }
  function ie() {
    return {
      type: "text",
      value: ""
    };
  }
  function ce() {
    return {
      type: "thematicBreak"
    };
  }
}
function ci(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function I1(e, n) {
  let r = -1;
  for (; ++r < n.length; ) {
    const i = n[r];
    Array.isArray(i) ? I1(e, i) : bU(e, i);
  }
}
function bU(e, n) {
  let r;
  for (r in n)
    if (F1.call(n, r))
      switch (r) {
        case "canContainEols": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "transforms": {
          const i = n[r];
          i && e[r].push(...i);
          break;
        }
        case "enter":
        case "exit": {
          const i = n[r];
          i && Object.assign(e[r], i);
          break;
        }
      }
}
function Ax(e, n) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + $o({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + n.type + "`, " + $o({
    start: n.start,
    end: n.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + n.type + "`, " + $o({
    start: n.start,
    end: n.end
  }) + ") is still open");
}
function _U(e) {
  const n = this;
  n.parser = r;
  function r(i) {
    return vU(i, {
      ...n.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: n.data("micromarkExtensions") || [],
      mdastExtensions: n.data("fromMarkdownExtensions") || []
    });
  }
}
function xU(e, n) {
  const r = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(n), !0)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function SU(e, n) {
  const r = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(n, r), [e.applyData(n, r), { type: "text", value: `
` }];
}
function NU(e, n) {
  const r = n.value ? n.value + `
` : "", i = {}, a = n.lang ? n.lang.split(/\s+/) : [];
  a.length > 0 && (i.className = ["language-" + a[0]]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: r }]
  };
  return n.meta && (o.data = { meta: n.meta }), e.patch(n, o), o = e.applyData(n, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(n, o), o;
}
function jU(e, n) {
  const r = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function wU(e, n) {
  const r = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function CU(e, n) {
  const r = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", i = String(n.identifier).toUpperCase(), a = Da(i.toLowerCase()), o = e.footnoteOrder.indexOf(i);
  let s, l = e.footnoteCounts.get(i);
  l === void 0 ? (l = 0, e.footnoteOrder.push(i), s = e.footnoteOrder.length) : s = o + 1, l += 1, e.footnoteCounts.set(i, l);
  const d = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + r + "fn-" + a,
      id: r + "fnref-" + a + (l > 1 ? "-" + l : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(n, d);
  const m = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [d]
  };
  return e.patch(n, m), e.applyData(n, m);
}
function FU(e, n) {
  const r = {
    type: "element",
    tagName: "h" + n.depth,
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function IU(e, n) {
  if (e.options.allowDangerousHtml) {
    const r = { type: "raw", value: n.value };
    return e.patch(n, r), e.applyData(n, r);
  }
}
function E1(e, n) {
  const r = n.referenceType;
  let i = "]";
  if (r === "collapsed" ? i += "[]" : r === "full" && (i += "[" + (n.label || n.identifier) + "]"), n.type === "imageReference")
    return [{ type: "text", value: "![" + n.alt + i }];
  const a = e.all(n), o = a[0];
  o && o.type === "text" ? o.value = "[" + o.value : a.unshift({ type: "text", value: "[" });
  const s = a[a.length - 1];
  return s && s.type === "text" ? s.value += i : a.push({ type: "text", value: i }), a;
}
function EU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return E1(e, n);
  const a = { src: Da(i.url || ""), alt: n.alt };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = { type: "element", tagName: "img", properties: a, children: [] };
  return e.patch(n, o), e.applyData(n, o);
}
function $U(e, n) {
  const r = { src: Da(n.url) };
  n.alt !== null && n.alt !== void 0 && (r.alt = n.alt), n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(n, i), e.applyData(n, i);
}
function TU(e, n) {
  const r = { type: "text", value: n.value.replace(/\r?\n|\r/g, " ") };
  e.patch(n, r);
  const i = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [r]
  };
  return e.patch(n, i), e.applyData(n, i);
}
function OU(e, n) {
  const r = String(n.identifier).toUpperCase(), i = e.definitionById.get(r);
  if (!i)
    return E1(e, n);
  const a = { href: Da(i.url || "") };
  i.title !== null && i.title !== void 0 && (a.title = i.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: a,
    children: e.all(n)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function RU(e, n) {
  const r = { href: Da(n.url) };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function DU(e, n, r) {
  const i = e.all(n), a = r ? PU(r) : $1(n), o = {}, s = [];
  if (typeof n.checked == "boolean") {
    const u = i[0];
    let f;
    u && u.type === "element" && u.tagName === "p" ? f = u : (f = { type: "element", tagName: "p", properties: {}, children: [] }, i.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: n.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let l = -1;
  for (; ++l < i.length; ) {
    const u = i[l];
    (a || l !== 0 || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` }), u.type === "element" && u.tagName === "p" && !a ? s.push(...u.children) : s.push(u);
  }
  const d = i[i.length - 1];
  d && (a || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` });
  const m = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(n, m), e.applyData(n, m);
}
function PU(e) {
  let n = !1;
  if (e.type === "list") {
    n = e.spread || !1;
    const r = e.children;
    let i = -1;
    for (; !n && ++i < r.length; )
      n = $1(r[i]);
  }
  return n;
}
function $1(e) {
  const n = e.spread;
  return n ?? e.children.length > 1;
}
function AU(e, n) {
  const r = {}, i = e.all(n);
  let a = -1;
  for (typeof n.start == "number" && n.start !== 1 && (r.start = n.start); ++a < i.length; ) {
    const s = i[a];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      r.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: n.ordered ? "ol" : "ul",
    properties: r,
    children: e.wrap(i, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function LU(e, n) {
  const r = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function VU(e, n) {
  const r = { type: "root", children: e.wrap(e.all(n)) };
  return e.patch(n, r), e.applyData(n, r);
}
function zU(e, n) {
  const r = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
function UU(e, n) {
  const r = e.all(n), i = r.shift(), a = [];
  if (i) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([i], !0)
    };
    e.patch(n.children[0], s), a.push(s);
  }
  if (r.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(r, !0)
    }, l = gg(n.children[1]), d = u1(n.children[n.children.length - 1]);
    l && d && (s.position = { start: l, end: d }), a.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(a, !0)
  };
  return e.patch(n, o), e.applyData(n, o);
}
function MU(e, n, r) {
  const i = r ? r.children : void 0, o = (i ? i.indexOf(n) : 1) === 0 ? "th" : "td", s = r && r.type === "table" ? r.align : void 0, l = s ? s.length : n.children.length;
  let d = -1;
  const m = [];
  for (; ++d < l; ) {
    const f = n.children[d], h = {}, k = s ? s[d] : void 0;
    k && (h.align = k);
    let C = { type: "element", tagName: o, properties: h, children: [] };
    f && (C.children = e.all(f), e.patch(f, C), C = e.applyData(f, C)), m.push(C);
  }
  const u = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(m, !0)
  };
  return e.patch(n, u), e.applyData(n, u);
}
function BU(e, n) {
  const r = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, r), e.applyData(n, r);
}
const Lx = 9, Vx = 32;
function qU(e) {
  const n = String(e), r = /\r?\n|\r/g;
  let i = r.exec(n), a = 0;
  const o = [];
  for (; i; )
    o.push(
      zx(n.slice(a, i.index), a > 0, !0),
      i[0]
    ), a = i.index + i[0].length, i = r.exec(n);
  return o.push(zx(n.slice(a), a > 0, !1)), o.join("");
}
function zx(e, n, r) {
  let i = 0, a = e.length;
  if (n) {
    let o = e.codePointAt(i);
    for (; o === Lx || o === Vx; )
      i++, o = e.codePointAt(i);
  }
  if (r) {
    let o = e.codePointAt(a - 1);
    for (; o === Lx || o === Vx; )
      a--, o = e.codePointAt(a - 1);
  }
  return a > i ? e.slice(i, a) : "";
}
function HU(e, n) {
  const r = { type: "text", value: qU(String(n.value)) };
  return e.patch(n, r), e.applyData(n, r);
}
function WU(e, n) {
  const r = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(n, r), e.applyData(n, r);
}
const KU = {
  blockquote: xU,
  break: SU,
  code: NU,
  delete: jU,
  emphasis: wU,
  footnoteReference: CU,
  heading: FU,
  html: IU,
  imageReference: EU,
  image: $U,
  inlineCode: TU,
  linkReference: OU,
  link: RU,
  listItem: DU,
  list: AU,
  paragraph: LU,
  // @ts-expect-error: root is different, but hard to type.
  root: VU,
  strong: zU,
  table: UU,
  tableCell: BU,
  tableRow: MU,
  text: HU,
  thematicBreak: WU,
  toml: bs,
  yaml: bs,
  definition: bs,
  footnoteDefinition: bs
};
function bs() {
}
const T1 = -1, ac = 0, Sl = 1, Nl = 2, Ng = 3, jg = 4, wg = 5, Cg = 6, O1 = 7, R1 = 8, Ux = typeof self == "object" ? self : globalThis, GU = (e, n) => {
  const r = (a, o) => (e.set(o, a), a), i = (a) => {
    if (e.has(a))
      return e.get(a);
    const [o, s] = n[a];
    switch (o) {
      case ac:
      case T1:
        return r(s, a);
      case Sl: {
        const l = r([], a);
        for (const d of s)
          l.push(i(d));
        return l;
      }
      case Nl: {
        const l = r({}, a);
        for (const [d, m] of s)
          l[i(d)] = i(m);
        return l;
      }
      case Ng:
        return r(new Date(s), a);
      case jg: {
        const { source: l, flags: d } = s;
        return r(new RegExp(l, d), a);
      }
      case wg: {
        const l = r(/* @__PURE__ */ new Map(), a);
        for (const [d, m] of s)
          l.set(i(d), i(m));
        return l;
      }
      case Cg: {
        const l = r(/* @__PURE__ */ new Set(), a);
        for (const d of s)
          l.add(i(d));
        return l;
      }
      case O1: {
        const { name: l, message: d } = s;
        return r(new Ux[l](d), a);
      }
      case R1:
        return r(BigInt(s), a);
      case "BigInt":
        return r(Object(BigInt(s)), a);
    }
    return r(new Ux[o](s), a);
  };
  return i;
}, Mx = (e) => GU(/* @__PURE__ */ new Map(), e)(0), ra = "", { toString: YU } = {}, { keys: JU } = Object, ro = (e) => {
  const n = typeof e;
  if (n !== "object" || !e)
    return [ac, n];
  const r = YU.call(e).slice(8, -1);
  switch (r) {
    case "Array":
      return [Sl, ra];
    case "Object":
      return [Nl, ra];
    case "Date":
      return [Ng, ra];
    case "RegExp":
      return [jg, ra];
    case "Map":
      return [wg, ra];
    case "Set":
      return [Cg, ra];
  }
  return r.includes("Array") ? [Sl, r] : r.includes("Error") ? [O1, r] : [Nl, r];
}, _s = ([e, n]) => e === ac && (n === "function" || n === "symbol"), QU = (e, n, r, i) => {
  const a = (s, l) => {
    const d = i.push(s) - 1;
    return r.set(l, d), d;
  }, o = (s) => {
    if (r.has(s))
      return r.get(s);
    let [l, d] = ro(s);
    switch (l) {
      case ac: {
        let u = s;
        switch (d) {
          case "bigint":
            l = R1, u = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + d);
            u = null;
            break;
          case "undefined":
            return a([T1], s);
        }
        return a([l, u], s);
      }
      case Sl: {
        if (d)
          return a([d, [...s]], s);
        const u = [], f = a([l, u], s);
        for (const h of s)
          u.push(o(h));
        return f;
      }
      case Nl: {
        if (d)
          switch (d) {
            case "BigInt":
              return a([d, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return a([d, s.valueOf()], s);
          }
        if (n && "toJSON" in s)
          return o(s.toJSON());
        const u = [], f = a([l, u], s);
        for (const h of JU(s))
          (e || !_s(ro(s[h]))) && u.push([o(h), o(s[h])]);
        return f;
      }
      case Ng:
        return a([l, s.toISOString()], s);
      case jg: {
        const { source: u, flags: f } = s;
        return a([l, { source: u, flags: f }], s);
      }
      case wg: {
        const u = [], f = a([l, u], s);
        for (const [h, k] of s)
          (e || !(_s(ro(h)) || _s(ro(k)))) && u.push([o(h), o(k)]);
        return f;
      }
      case Cg: {
        const u = [], f = a([l, u], s);
        for (const h of s)
          (e || !_s(ro(h))) && u.push(o(h));
        return f;
      }
    }
    const { message: m } = s;
    return a([l, { name: d, message: m }], s);
  };
  return o;
}, Bx = (e, { json: n, lossy: r } = {}) => {
  const i = [];
  return QU(!(n || r), !!n, /* @__PURE__ */ new Map(), i)(e), i;
}, jl = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, n) => n && ("json" in n || "lossy" in n) ? Mx(Bx(e, n)) : structuredClone(e)
) : (e, n) => Mx(Bx(e, n));
function XU(e, n) {
  const r = [{ type: "text", value: "↩" }];
  return n > 1 && r.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(n) }]
  }), r;
}
function ZU(e, n) {
  return "Back to reference " + (e + 1) + (n > 1 ? "-" + n : "");
}
function eM(e) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = e.options.footnoteBackContent || XU, i = e.options.footnoteBackLabel || ZU, a = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, l = [];
  let d = -1;
  for (; ++d < e.footnoteOrder.length; ) {
    const m = e.footnoteById.get(
      e.footnoteOrder[d]
    );
    if (!m)
      continue;
    const u = e.all(m), f = String(m.identifier).toUpperCase(), h = Da(f.toLowerCase());
    let k = 0;
    const C = [], N = e.footnoteCounts.get(f);
    for (; N !== void 0 && ++k <= N; ) {
      C.length > 0 && C.push({ type: "text", value: " " });
      let g = typeof r == "string" ? r : r(d, k);
      typeof g == "string" && (g = { type: "text", value: g }), C.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + n + "fnref-" + h + (k > 1 ? "-" + k : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof i == "string" ? i : i(d, k),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(g) ? g : [g]
      });
    }
    const j = u[u.length - 1];
    if (j && j.type === "element" && j.tagName === "p") {
      const g = j.children[j.children.length - 1];
      g && g.type === "text" ? g.value += " " : j.children.push({ type: "text", value: " " }), j.children.push(...C);
    } else
      u.push(...C);
    const _ = {
      type: "element",
      tagName: "li",
      properties: { id: n + "fn-" + h },
      children: e.wrap(u, !0)
    };
    e.patch(m, _), l.push(_);
  }
  if (l.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...jl(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: a }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(l, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const D1 = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(e) {
    if (e == null)
      return iM;
    if (typeof e == "function")
      return oc(e);
    if (typeof e == "object")
      return Array.isArray(e) ? nM(e) : tM(e);
    if (typeof e == "string")
      return rM(e);
    throw new Error("Expected function, string, or object as test");
  })
);
function nM(e) {
  const n = [];
  let r = -1;
  for (; ++r < e.length; )
    n[r] = D1(e[r]);
  return oc(i);
  function i(...a) {
    let o = -1;
    for (; ++o < n.length; )
      if (n[o].apply(this, a)) return !0;
    return !1;
  }
}
function tM(e) {
  const n = (
    /** @type {Record<string, unknown>} */
    e
  );
  return oc(r);
  function r(i) {
    const a = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      i
    );
    let o;
    for (o in e)
      if (a[o] !== n[o]) return !1;
    return !0;
  }
}
function rM(e) {
  return oc(n);
  function n(r) {
    return r && r.type === e;
  }
}
function oc(e) {
  return n;
  function n(r, i, a) {
    return !!(aM(r) && e.call(
      this,
      r,
      typeof i == "number" ? i : void 0,
      a || void 0
    ));
  }
}
function iM() {
  return !0;
}
function aM(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const P1 = [], oM = !0, qx = !1, sM = "skip";
function lM(e, n, r, i) {
  let a;
  typeof n == "function" && typeof r != "function" ? (i = r, r = n) : a = n;
  const o = D1(a), s = i ? -1 : 1;
  l(e, void 0, [])();
  function l(d, m, u) {
    const f = (
      /** @type {Record<string, unknown>} */
      d && typeof d == "object" ? d : {}
    );
    if (typeof f.type == "string") {
      const k = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (d.type + (k ? "<" + k + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let k = P1, C, N, j;
      if ((!n || o(d, m, u[u.length - 1] || void 0)) && (k = cM(r(d, u)), k[0] === qx))
        return k;
      if ("children" in d && d.children) {
        const _ = (
          /** @type {UnistParent} */
          d
        );
        if (_.children && k[0] !== sM)
          for (N = (i ? _.children.length : -1) + s, j = u.concat(_); N > -1 && N < _.children.length; ) {
            const g = _.children[N];
            if (C = l(g, N, j)(), C[0] === qx)
              return C;
            N = typeof C[1] == "number" ? C[1] : N + s;
          }
      }
      return k;
    }
  }
}
function cM(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [oM, e] : e == null ? P1 : [e];
}
function A1(e, n, r, i) {
  let a, o, s;
  typeof n == "function" && typeof r != "function" ? (o = void 0, s = n, a = r) : (o = n, s = r, a = i), lM(e, o, l, a);
  function l(d, m) {
    const u = m[m.length - 1], f = u ? u.children.indexOf(d) : void 0;
    return s(d, f, u);
  }
}
const dy = {}.hasOwnProperty, dM = {};
function uM(e, n) {
  const r = n || dM, i = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...KU, ...r.handlers }, l = {
    all: m,
    applyData: pM,
    definitionById: i,
    footnoteById: a,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: d,
    options: r,
    patch: mM,
    wrap: hM
  };
  return A1(e, function(u) {
    if (u.type === "definition" || u.type === "footnoteDefinition") {
      const f = u.type === "definition" ? i : a, h = String(u.identifier).toUpperCase();
      f.has(h) || f.set(h, u);
    }
  }), l;
  function d(u, f) {
    const h = u.type, k = l.handlers[h];
    if (dy.call(l.handlers, h) && k)
      return k(l, u, f);
    if (l.options.passThrough && l.options.passThrough.includes(h)) {
      if ("children" in u) {
        const { children: N, ...j } = u, _ = jl(j);
        return _.children = l.all(u), _;
      }
      return jl(u);
    }
    return (l.options.unknownHandler || fM)(l, u, f);
  }
  function m(u) {
    const f = [];
    if ("children" in u) {
      const h = u.children;
      let k = -1;
      for (; ++k < h.length; ) {
        const C = l.one(h[k], u);
        if (C) {
          if (k && h[k - 1].type === "break" && (!Array.isArray(C) && C.type === "text" && (C.value = Hx(C.value)), !Array.isArray(C) && C.type === "element")) {
            const N = C.children[0];
            N && N.type === "text" && (N.value = Hx(N.value));
          }
          Array.isArray(C) ? f.push(...C) : f.push(C);
        }
      }
    }
    return f;
  }
}
function mM(e, n) {
  e.position && (n.position = KV(e));
}
function pM(e, n) {
  let r = n;
  if (e && e.data) {
    const i = e.data.hName, a = e.data.hChildren, o = e.data.hProperties;
    if (typeof i == "string")
      if (r.type === "element")
        r.tagName = i;
      else {
        const s = "children" in r ? r.children : [r];
        r = { type: "element", tagName: i, properties: {}, children: s };
      }
    r.type === "element" && o && Object.assign(r.properties, jl(o)), "children" in r && r.children && a !== null && a !== void 0 && (r.children = a);
  }
  return r;
}
function fM(e, n) {
  const r = n.data || {}, i = "value" in n && !(dy.call(r, "hProperties") || dy.call(r, "hChildren")) ? { type: "text", value: n.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(n)
  };
  return e.patch(n, i), e.applyData(n, i);
}
function hM(e, n) {
  const r = [];
  let i = -1;
  for (n && r.push({ type: "text", value: `
` }); ++i < e.length; )
    i && r.push({ type: "text", value: `
` }), r.push(e[i]);
  return n && e.length > 0 && r.push({ type: "text", value: `
` }), r;
}
function Hx(e) {
  let n = 0, r = e.charCodeAt(n);
  for (; r === 9 || r === 32; )
    n++, r = e.charCodeAt(n);
  return e.slice(n);
}
function Wx(e, n) {
  const r = uM(e, n), i = r.one(e, void 0), a = eM(r), o = Array.isArray(i) ? { type: "root", children: i } : i || { type: "root", children: [] };
  return a && o.children.push({ type: "text", value: `
` }, a), o;
}
function yM(e, n) {
  return e && "run" in e ? async function(r, i) {
    const a = (
      /** @type {HastRoot} */
      Wx(r, { file: i, ...n })
    );
    await e.run(a, i);
  } : function(r, i) {
    return (
      /** @type {HastRoot} */
      Wx(r, { file: i, ...e || n })
    );
  };
}
function Kx(e) {
  if (e)
    throw e;
}
var wm, Gx;
function gM() {
  if (Gx) return wm;
  Gx = 1;
  var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, a = function(m) {
    return typeof Array.isArray == "function" ? Array.isArray(m) : n.call(m) === "[object Array]";
  }, o = function(m) {
    if (!m || n.call(m) !== "[object Object]")
      return !1;
    var u = e.call(m, "constructor"), f = m.constructor && m.constructor.prototype && e.call(m.constructor.prototype, "isPrototypeOf");
    if (m.constructor && !u && !f)
      return !1;
    var h;
    for (h in m)
      ;
    return typeof h > "u" || e.call(m, h);
  }, s = function(m, u) {
    r && u.name === "__proto__" ? r(m, u.name, {
      enumerable: !0,
      configurable: !0,
      value: u.newValue,
      writable: !0
    }) : m[u.name] = u.newValue;
  }, l = function(m, u) {
    if (u === "__proto__")
      if (e.call(m, u)) {
        if (i)
          return i(m, u).value;
      } else return;
    return m[u];
  };
  return wm = function d() {
    var m, u, f, h, k, C, N = arguments[0], j = 1, _ = arguments.length, g = !1;
    for (typeof N == "boolean" && (g = N, N = arguments[1] || {}, j = 2), (N == null || typeof N != "object" && typeof N != "function") && (N = {}); j < _; ++j)
      if (m = arguments[j], m != null)
        for (u in m)
          f = l(N, u), h = l(m, u), N !== h && (g && h && (o(h) || (k = a(h))) ? (k ? (k = !1, C = f && a(f) ? f : []) : C = f && o(f) ? f : {}, s(N, { name: u, newValue: d(g, C, h) })) : typeof h < "u" && s(N, { name: u, newValue: h }));
    return N;
  }, wm;
}
var vM = gM();
const Cm = /* @__PURE__ */ Ey(vM);
function uy(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const n = Object.getPrototypeOf(e);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function kM() {
  const e = [], n = { run: r, use: i };
  return n;
  function r(...a) {
    let o = -1;
    const s = a.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    l(null, ...a);
    function l(d, ...m) {
      const u = e[++o];
      let f = -1;
      if (d) {
        s(d);
        return;
      }
      for (; ++f < a.length; )
        (m[f] === null || m[f] === void 0) && (m[f] = a[f]);
      a = m, u ? bM(u, l)(...m) : s(null, ...m);
    }
  }
  function i(a) {
    if (typeof a != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + a
      );
    return e.push(a), n;
  }
}
function bM(e, n) {
  let r;
  return i;
  function i(...s) {
    const l = e.length > s.length;
    let d;
    l && s.push(a);
    try {
      d = e.apply(this, s);
    } catch (m) {
      const u = (
        /** @type {Error} */
        m
      );
      if (l && r)
        throw u;
      return a(u);
    }
    l || (d instanceof Promise ? d.then(o, a) : d instanceof Error ? a(d) : o(d));
  }
  function a(s, ...l) {
    r || (r = !0, n(s, ...l));
  }
  function o(s) {
    a(null, s);
  }
}
const Vr = { basename: _M, dirname: xM, extname: SM, join: NM, sep: "/" };
function _M(e, n) {
  if (n !== void 0 && typeof n != "string")
    throw new TypeError('"ext" argument must be a string');
  ns(e);
  let r = 0, i = -1, a = e.length, o;
  if (n === void 0 || n.length === 0 || n.length > e.length) {
    for (; a--; )
      if (e.codePointAt(a) === 47) {
        if (o) {
          r = a + 1;
          break;
        }
      } else i < 0 && (o = !0, i = a + 1);
    return i < 0 ? "" : e.slice(r, i);
  }
  if (n === e)
    return "";
  let s = -1, l = n.length - 1;
  for (; a--; )
    if (e.codePointAt(a) === 47) {
      if (o) {
        r = a + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = a + 1), l > -1 && (e.codePointAt(a) === n.codePointAt(l--) ? l < 0 && (i = a) : (l = -1, i = s));
  return r === i ? i = s : i < 0 && (i = e.length), e.slice(r, i);
}
function xM(e) {
  if (ns(e), e.length === 0)
    return ".";
  let n = -1, r = e.length, i;
  for (; --r; )
    if (e.codePointAt(r) === 47) {
      if (i) {
        n = r;
        break;
      }
    } else i || (i = !0);
  return n < 0 ? e.codePointAt(0) === 47 ? "/" : "." : n === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, n);
}
function SM(e) {
  ns(e);
  let n = e.length, r = -1, i = 0, a = -1, o = 0, s;
  for (; n--; ) {
    const l = e.codePointAt(n);
    if (l === 47) {
      if (s) {
        i = n + 1;
        break;
      }
      continue;
    }
    r < 0 && (s = !0, r = n + 1), l === 46 ? a < 0 ? a = n : o !== 1 && (o = 1) : a > -1 && (o = -1);
  }
  return a < 0 || r < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && a === r - 1 && a === i + 1 ? "" : e.slice(a, r);
}
function NM(...e) {
  let n = -1, r;
  for (; ++n < e.length; )
    ns(e[n]), e[n] && (r = r === void 0 ? e[n] : r + "/" + e[n]);
  return r === void 0 ? "." : jM(r);
}
function jM(e) {
  ns(e);
  const n = e.codePointAt(0) === 47;
  let r = wM(e, !n);
  return r.length === 0 && !n && (r = "."), r.length > 0 && e.codePointAt(e.length - 1) === 47 && (r += "/"), n ? "/" + r : r;
}
function wM(e, n) {
  let r = "", i = 0, a = -1, o = 0, s = -1, l, d;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      l = e.codePointAt(s);
    else {
      if (l === 47)
        break;
      l = 47;
    }
    if (l === 47) {
      if (!(a === s - 1 || o === 1)) if (a !== s - 1 && o === 2) {
        if (r.length < 2 || i !== 2 || r.codePointAt(r.length - 1) !== 46 || r.codePointAt(r.length - 2) !== 46) {
          if (r.length > 2) {
            if (d = r.lastIndexOf("/"), d !== r.length - 1) {
              d < 0 ? (r = "", i = 0) : (r = r.slice(0, d), i = r.length - 1 - r.lastIndexOf("/")), a = s, o = 0;
              continue;
            }
          } else if (r.length > 0) {
            r = "", i = 0, a = s, o = 0;
            continue;
          }
        }
        n && (r = r.length > 0 ? r + "/.." : "..", i = 2);
      } else
        r.length > 0 ? r += "/" + e.slice(a + 1, s) : r = e.slice(a + 1, s), i = s - a - 1;
      a = s, o = 0;
    } else l === 46 && o > -1 ? o++ : o = -1;
  }
  return r;
}
function ns(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const CM = { cwd: FM };
function FM() {
  return "/";
}
function my(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function IM(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!my(e)) {
    const n = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw n.code = "ERR_INVALID_ARG_TYPE", n;
  }
  if (e.protocol !== "file:") {
    const n = new TypeError("The URL must be of scheme file");
    throw n.code = "ERR_INVALID_URL_SCHEME", n;
  }
  return EM(e);
}
function EM(e) {
  if (e.hostname !== "") {
    const i = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw i.code = "ERR_INVALID_FILE_URL_HOST", i;
  }
  const n = e.pathname;
  let r = -1;
  for (; ++r < n.length; )
    if (n.codePointAt(r) === 37 && n.codePointAt(r + 1) === 50) {
      const i = n.codePointAt(r + 2);
      if (i === 70 || i === 102) {
        const a = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw a.code = "ERR_INVALID_FILE_URL_PATH", a;
      }
    }
  return decodeURIComponent(n);
}
const Fm = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class L1 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(n) {
    let r;
    n ? my(n) ? r = { path: n } : typeof n == "string" || $M(n) ? r = { value: n } : r = n : r = {}, this.cwd = "cwd" in r ? "" : CM.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let i = -1;
    for (; ++i < Fm.length; ) {
      const o = Fm[i];
      o in r && r[o] !== void 0 && r[o] !== null && (this[o] = o === "history" ? [...r[o]] : r[o]);
    }
    let a;
    for (a in r)
      Fm.includes(a) || (this[a] = r[a]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Vr.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(n) {
    Em(n, "basename"), Im(n, "basename"), this.path = Vr.join(this.dirname || "", n);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Vr.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(n) {
    Yx(this.basename, "dirname"), this.path = Vr.join(n || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Vr.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(n) {
    if (Im(n, "extname"), Yx(this.dirname, "extname"), n) {
      if (n.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (n.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Vr.join(this.dirname, this.stem + (n || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(n) {
    my(n) && (n = IM(n)), Em(n, "path"), this.path !== n && this.history.push(n);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Vr.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(n) {
    Em(n, "stem"), Im(n, "stem"), this.path = Vr.join(this.dirname || "", n + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(n, r, i) {
    const a = this.message(n, r, i);
    throw a.fatal = !0, a;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(n, r, i) {
    const a = this.message(n, r, i);
    return a.fatal = void 0, a;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(n, r, i) {
    const a = new Bt(
      // @ts-expect-error: the overloads are fine.
      n,
      r,
      i
    );
    return this.path && (a.name = this.path + ":" + a.name, a.file = this.path), a.fatal = !1, this.messages.push(a), a;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(n) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(n || void 0).decode(this.value);
  }
}
function Im(e, n) {
  if (e && e.includes(Vr.sep))
    throw new Error(
      "`" + n + "` cannot be a path: did not expect `" + Vr.sep + "`"
    );
}
function Em(e, n) {
  if (!e)
    throw new Error("`" + n + "` cannot be empty");
}
function Yx(e, n) {
  if (!e)
    throw new Error("Setting `" + n + "` requires `path` to be set too");
}
function $M(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const TM = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(e) {
    const i = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), a = i[e], o = function() {
      return a.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, i), o;
  })
), OM = {}.hasOwnProperty;
class Fg extends TM {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = kM();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const n = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Fg()
    );
    let r = -1;
    for (; ++r < this.attachers.length; ) {
      const i = this.attachers[r];
      n.use(...i);
    }
    return n.data(Cm(!0, {}, this.namespace)), n;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(n, r) {
    return typeof n == "string" ? arguments.length === 2 ? (Om("data", this.frozen), this.namespace[n] = r, this) : OM.call(this.namespace, n) && this.namespace[n] || void 0 : n ? (Om("data", this.frozen), this.namespace = n, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const n = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [r, ...i] = this.attachers[this.freezeIndex];
      if (i[0] === !1)
        continue;
      i[0] === !0 && (i[0] = void 0);
      const a = r.call(n, ...i);
      typeof a == "function" && this.transformers.use(a);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(n) {
    this.freeze();
    const r = xs(n), i = this.parser || this.Parser;
    return $m("parse", i), i(String(r), r);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(n, r) {
    const i = this;
    return this.freeze(), $m("process", this.parser || this.Parser), Tm("process", this.compiler || this.Compiler), r ? a(void 0, r) : new Promise(a);
    function a(o, s) {
      const l = xs(n), d = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        i.parse(l)
      );
      i.run(d, l, function(u, f, h) {
        if (u || !f || !h)
          return m(u);
        const k = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), C = i.stringify(k, h);
        PM(C) ? h.value = C : h.result = C, m(
          u,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function m(u, f) {
        u || !f ? s(u) : o ? o(f) : r(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(n) {
    let r = !1, i;
    return this.freeze(), $m("processSync", this.parser || this.Parser), Tm("processSync", this.compiler || this.Compiler), this.process(n, a), Qx("processSync", "process", r), i;
    function a(o, s) {
      r = !0, Kx(o), i = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(n, r, i) {
    Jx(n), this.freeze();
    const a = this.transformers;
    return !i && typeof r == "function" && (i = r, r = void 0), i ? o(void 0, i) : new Promise(o);
    function o(s, l) {
      const d = xs(r);
      a.run(n, d, m);
      function m(u, f, h) {
        const k = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || n
        );
        u ? l(u) : s ? s(k) : i(void 0, k, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(n, r) {
    let i = !1, a;
    return this.run(n, r, o), Qx("runSync", "run", i), a;
    function o(s, l) {
      Kx(s), a = l, i = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(n, r) {
    this.freeze();
    const i = xs(r), a = this.compiler || this.Compiler;
    return Tm("stringify", a), Jx(n), a(n, i);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(n, ...r) {
    const i = this.attachers, a = this.namespace;
    if (Om("use", this.frozen), n != null) if (typeof n == "function")
      d(n, r);
    else if (typeof n == "object")
      Array.isArray(n) ? l(n) : s(n);
    else
      throw new TypeError("Expected usable value, not `" + n + "`");
    return this;
    function o(m) {
      if (typeof m == "function")
        d(m, []);
      else if (typeof m == "object")
        if (Array.isArray(m)) {
          const [u, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            m
          );
          d(u, f);
        } else
          s(m);
      else
        throw new TypeError("Expected usable value, not `" + m + "`");
    }
    function s(m) {
      if (!("plugins" in m) && !("settings" in m))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      l(m.plugins), m.settings && (a.settings = Cm(!0, a.settings, m.settings));
    }
    function l(m) {
      let u = -1;
      if (m != null) if (Array.isArray(m))
        for (; ++u < m.length; ) {
          const f = m[u];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + m + "`");
    }
    function d(m, u) {
      let f = -1, h = -1;
      for (; ++f < i.length; )
        if (i[f][0] === m) {
          h = f;
          break;
        }
      if (h === -1)
        i.push([m, ...u]);
      else if (u.length > 0) {
        let [k, ...C] = u;
        const N = i[h][1];
        uy(N) && uy(k) && (k = Cm(!0, N, k)), i[h] = [m, k, ...C];
      }
    }
  }
}
const RM = new Fg().freeze();
function $m(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function Tm(e, n) {
  if (typeof n != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function Om(e, n) {
  if (n)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function Jx(e) {
  if (!uy(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function Qx(e, n, r) {
  if (!r)
    throw new Error(
      "`" + e + "` finished async. Use `" + n + "` instead"
    );
}
function xs(e) {
  return DM(e) ? e : new L1(e);
}
function DM(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function PM(e) {
  return typeof e == "string" || AM(e);
}
function AM(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const LM = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Xx = [], Zx = { allowDangerousHtml: !0 }, VM = /^(https?|ircs?|mailto|xmpp)$/i, zM = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function UM(e) {
  const n = e.allowedElements, r = e.allowElement, i = e.children || "", a = e.className, o = e.components, s = e.disallowedElements, l = e.rehypePlugins || Xx, d = e.remarkPlugins || Xx, m = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...Zx } : Zx, u = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || MM, k = RM().use(_U).use(d).use(yM, m).use(l), C = new L1();
  typeof i == "string" && (C.value = i);
  for (const g of zM)
    Object.hasOwn(e, g.from) && ("" + g.from + (g.to ? "use `" + g.to + "` instead" : "remove it") + LM + g.id, void 0);
  const N = k.parse(C);
  let j = k.runSync(N, C);
  return a && (j = {
    type: "element",
    tagName: "div",
    properties: { className: a },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      j.type === "root" ? j.children : [j]
    )
  }), A1(j, _), ZV(j, {
    Fragment: Qn.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: Qn.jsx,
    jsxs: Qn.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function _(g, D, O) {
    if (g.type === "raw" && O && typeof D == "number")
      return u ? O.children.splice(D, 1) : O.children[D] = { type: "text", value: g.value }, D;
    if (g.type === "element") {
      let I;
      for (I in Sm)
        if (Object.hasOwn(Sm, I) && Object.hasOwn(g.properties, I)) {
          const F = g.properties[I], L = Sm[I];
          (L === null || L.includes(g.tagName)) && (g.properties[I] = h(String(F || ""), I, g));
        }
    }
    if (g.type === "element") {
      let I = n ? !n.includes(g.tagName) : s ? s.includes(g.tagName) : !1;
      if (!I && r && typeof D == "number" && (I = !r(g, D, O)), I && O && typeof D == "number")
        return f && g.children ? O.children.splice(D, 1, ...g.children) : O.children.splice(D, 1), D;
    }
  }
}
function MM(e) {
  const n = e.indexOf(":"), r = e.indexOf("?"), i = e.indexOf("#"), a = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    n < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    a > -1 && n > a || r > -1 && n > r || i > -1 && n > i || // It is a protocol, it should be allowed.
    VM.test(e.slice(0, n)) ? e : ""
  );
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('._issueAvatar_kc0sw_1{margin:var(--dixa-size-spacer-100) 0}._issueAvatar_kc0sw_1 h2{font-weight:var(--dixa-typography-weight-normal);align-items:center;display:flex}._issueField_kc0sw_9{font-weight:var(--dixa-typography-weight-normal)}._issueDescription_kc0sw_12{font-weight:var(--dixa-typography-weight-normal);color:var(--dixa-color-neutral-800);padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._issueDescription_kc0sw_12 p{margin:unset}._wrapper_e0qj3_1{width:400px;padding:0 0 var(--dixa-size-spacer-200) 0;max-height:400px;overflow:hidden;position:relative}._wrapper_e0qj3_1 ._description_e0qj3_8{color:var(--dixa-color-neutral-600)}._wrapper_e0qj3_1:after{width:100%;height:var(--dixa-size-spacer-400);content:"";position:absolute;bottom:0;left:0;background:linear-gradient(0deg,#fff,#ffffffbc 19%,#ffffff8a 34%,#ffffff61 47%,#ffffff47 56.5%,#ffffff31 65%,#ffffff20 73%,#ffffff13 80.2%,#ffffff0b 86.1%,#ffffff05 91%,#ffffff02 95.2%,#ffffff01 98.2%,#fff0)}._resultTitle_e0qj3_21{text-align:left;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;color:var(--dixa-color-neutral-600)}._resultTooltipTitle_e0qj3_28{margin-bottom:var(--dixa-size-spacer-200)}._resultLinkIcon_e0qj3_31{position:absolute;right:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-000);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);color:var(--dixa-color-neutral-500)}._loader_13xpk_1{width:100%;display:flex;padding:var(--dixa-size-spacer-200);justify-content:center}._dropdown_13xpk_8{max-height:300px;overflow-y:scroll}._loadMore_13xpk_13{cursor:pointer}._loadMore_13xpk_13:hover{background-color:var(--dixa-color-neutral-100)}._loadMore_13xpk_13:hover p{color:var(--dixa-color-purple-600)}._loadMore_13xpk_13 p{color:var(--dixa-color-purple-500)}._collapse_su0f9_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200);padding:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8{padding:var(--dixa-size-spacer-250);width:100%;box-sizing:border-box;background-color:transparent;gap:var(--dixa-size-spacer-100)}._collapseHeader_su0f9_8>div:first-of-type{padding:0!important;padding-right:var(--dixa-size-spacer-300);width:100%}._collapseHeader_su0f9_8>div>div:first-of-type{padding:0!important;width:100%}._collapseHeader_su0f9_8 p>div:first-of-type{justify-content:space-between}._collapseHeader_su0f9_8>div>div>p{white-space:unset!important;margin:0}._collapseContent_su0f9_31{padding:0 var(--dixa-size-spacer-250) var(--dixa-size-spacer-250) var(--dixa-size-spacer-250)}._url_su0f9_35{align-items:center;display:flex;flex-direction:row;gap:var(--dixa-size-spacer-100);color:var(--dixa-color-purple-500);font-weight:var(--dixa-typography-weight-semibold);cursor:pointer;font-size:var(--dixa-typography-size-200);line-height:var(--dixa-typography-line-height-200)}._empty_su0f9_47 p{color:var(--dixa-color-neutral-400)}._externalLink_su0f9_51{color:var(--dixa-typography-color-link)}._emptyState_su0f9_55{font-weight:var(--dixa-typography-weight-normal)}._modalBody_iv3ua_1{width:600px}._error_iv3ua_5{border:var(--dixa-size-border-100) solid var(--dixa-typography-color-error)}._emptyState_iv3ua_9{padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200) var(--dixa-size-spacer-200)}._emptyState_iv3ua_9 p{color:var(--dixa-color-neutral-400)}._dropdown_iv3ua_16{max-height:300px;overflow-y:scroll}._modalWrapper_4kh9u_1{min-width:600px;position:relative}._copyButton_4kh9u_6{height:var(--dixa-size-spacer-500);width:var(--dixa-size-spacer-500)}._copyButton_4kh9u_6 button{background-color:var(--dixa-color-neutral-100);border-radius:0 var(--dixa-size-border-radius-100) var(--dixa-size-border-radius-100) 0}._copyWrapper_4kh9u_15{box-sizing:border-box}._copyWrapper_4kh9u_15:focus-within{border-radius:var(--dixa-size-border-radius-100);outline:solid var(--dixa-size-border-100) var(--dixa-color-purple-500);box-shadow:0 0 0 3px var(--dixa-color-purple-300)}._copyField_4kh9u_24{cursor:pointer;min-width:62ch;height:var(--dixa-size-spacer-500);border-radius:var(--dixa-size-border-radius-100) 0 0 var(--dixa-size-border-radius-100);border:none}._copyField_4kh9u_24:hover{border:none}._copyField_4kh9u_24:focus-within{box-shadow:none;border:none;outline:none}._copyField_4kh9u_24 input{color:var(--dixa-color-neutral-800);background-color:var(--dixa-color-neutral-100);cursor:pointer;border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-right:none}._externalLink_4kh9u_47{display:flex;align-items:center}._externalLinkIcon_4kh9u_52{align-self:center}._textWrapper_4kh9u_56{display:flex;gap:var(--dixa-size-spacer-100)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Rm = { exports: {} }, io = {}, eS;
function BM() {
  if (eS) return io;
  eS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return io.Fragment = r, io.jsx = s, io.jsxs = s, io;
}
var Ss = {}, nS;
function qM() {
  return nS || (nS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Ss.Fragment = i, Ss.jsx = zn, Ss.jsxs = Wn;
  })()), Ss;
}
var tS;
function HM() {
  return tS || (tS = 1, process.env.NODE_ENV === "production" ? Rm.exports = BM() : Rm.exports = qM()), Rm.exports;
}
var ae = HM();
const WM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createIssue" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "projectId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "statusId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "priority" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issueCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "title" }, value: { kind: "Variable", name: { kind: "Name", value: "issueTitle" } } }, { kind: "ObjectField", name: { kind: "Name", value: "description" }, value: { kind: "Variable", name: { kind: "Name", value: "issueDescription" } } }, { kind: "ObjectField", name: { kind: "Name", value: "teamId" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "projectId" }, value: { kind: "Variable", name: { kind: "Name", value: "projectId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "stateId" }, value: { kind: "Variable", name: { kind: "Name", value: "statusId" } } }, { kind: "ObjectField", name: { kind: "Name", value: "priority" }, value: { kind: "Variable", name: { kind: "Name", value: "priority" } } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "success" } }, { kind: "Field", name: { kind: "Name", value: "issue" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] }, KM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "staticData" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "teams" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "issuePriorityValues" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "label" } }] } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }] } }] }, GM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "teamData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "teamId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "team" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "teamId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "projects" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "states" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "templates" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "templateData" } }] } }] } }] } }] } }] } }] } }] }, YM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "searchIssues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }, { kind: "Argument", name: { kind: "Name", value: "term" }, value: { kind: "Variable", name: { kind: "Name", value: "issueQuery" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }] } }] } }] } }] }, JM = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchLinkedIssues" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Linear" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "issues" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filter" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "id" }, value: { kind: "ObjectValue", fields: [{ kind: "ObjectField", name: { kind: "Name", value: "in" }, value: { kind: "Variable", name: { kind: "Name", value: "linkedIssues" } } }] } }] } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "priority" } }, { kind: "Field", name: { kind: "Name", value: "priorityLabel" } }, { kind: "Field", name: { kind: "Name", value: "url" } }, { kind: "Field", name: { kind: "Name", value: "state" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }, { kind: "Field", name: { kind: "Name", value: "assignee" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "avatarUrl" } }, { kind: "Field", name: { kind: "Name", value: "email" } }] } }, { kind: "Field", name: { kind: "Name", value: "labels" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "color" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "team" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "organization" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "urlKey" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "project" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] } }] }, QM = {
  "\n  mutation createIssue(\n    $issueTitle: String!\n    $issueDescription: String\n    $teamId: String!\n    $projectId: String\n    $statusId: String\n    $priority: Int\n  ) {\n    Linear {\n      issueCreate(\n        input: {\n          title: $issueTitle\n          description: $issueDescription\n          teamId: $teamId\n          projectId: $projectId\n          stateId: $statusId\n          priority: $priority\n        }\n      ) {\n        success\n        issue {\n          id\n          title\n          identifier\n          url\n        }\n      }\n    }\n  }\n": WM,
  "\n  query staticData {\n    Linear {\n      teams {\n        edges {\n          node {\n            id\n            name\n            organization {\n              urlKey\n            }\n          }\n        }\n      }\n      issuePriorityValues {\n        priority\n        label\n      }\n      organization {\n        urlKey\n      }\n    }\n  }\n": KM,
  "\n  query teamData($teamId: String!) {\n    Linear {\n      team(id: $teamId) {\n        projects {\n          edges {\n            node {\n              id\n              name\n            }\n          }\n        }\n        states {\n          edges {\n            node {\n              id\n              name\n              type\n              color\n            }\n          }\n        }\n        templates {\n          edges {\n            node {\n              id\n              name\n              type\n              templateData\n            }\n          }\n        }\n      }\n    }\n  }\n": GM,
  "\n  query searchIssues($issueQuery: String! $after: String, $first: Int ) {\n    Linear {\n      searchIssues(\n        first:$first\n        after:$after\n        term: $issueQuery\n      ) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n      }\n    }\n  }\n": YM,
  "\n  query searchLinkedIssues($linkedIssues: [ID!]) {\n    Linear {\n      issues(filter: { id: { in: $linkedIssues } }) {\n        edges {\n          node {\n            id\n            title\n            description\n            identifier\n            priority\n            priorityLabel\n            url\n            state {\n              id\n              type\n              name\n              color\n            }\n            assignee {\n              name\n              displayName\n              avatarUrl\n              email\n            }\n            labels {\n              edges {\n                node {\n                  id\n                  name\n                  color\n                }\n              }\n            }\n            team {\n              name\n              organization {\n                urlKey\n              }\n            }\n            project {\n              id\n              name\n            }\n          }\n        }\n      }\n    }\n  }\n": JM
};
function ts(e) {
  return QM[e] ?? {};
}
const XM = ts(
  /* GraphQL */
  `
  query searchIssues($issueQuery: String! $after: String, $first: Int ) {
    Linear {
      searchIssues(
        first:$first
        after:$after
        term: $issueQuery
      ) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`
), ZM = ts(
  /* GraphQL */
  `
  query searchLinkedIssues($linkedIssues: [ID!]) {
    Linear {
      issues(filter: { id: { in: $linkedIssues } }) {
        edges {
          node {
            id
            title
            description
            identifier
            priority
            priorityLabel
            url
            state {
              id
              type
              name
              color
            }
            assignee {
              name
              displayName
              avatarUrl
              email
            }
            labels {
              edges {
                node {
                  id
                  name
                  color
                }
              }
            }
            team {
              name
              organization {
                urlKey
              }
            }
            project {
              id
              name
            }
          }
        }
      }
    }
  }
`
), Ns = ({
  title: e,
  children: n
}) => /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
  /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "5", color: "neutral.500", children: e }),
  n
] }), e4 = "_issueAvatar_kc0sw_1", n4 = "_issueField_kc0sw_9", t4 = "_issueDescription_kc0sw_12", js = {
  issueAvatar: e4,
  issueField: n4,
  issueDescription: t4
}, V1 = ({ issue: e }) => /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
  /* @__PURE__ */ ae.jsx(Ns, { title: "Assignee", children: /* @__PURE__ */ ae.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "row",
      alignContent: "center",
      className: js.issueAvatar,
      children: [
        /* @__PURE__ */ ae.jsx(
          Fy,
          {
            size: "24",
            user: e.assignee ? {
              name: e.assignee.name || null,
              // eslint-disable-next-line camelcase
              avatar_url: e.assignee.avatarUrl || null,
              email: e.assignee.email
            } : void 0
          }
        ),
        /* @__PURE__ */ ae.jsx($.Heading, { variant: "heading-4", children: e.assignee ? e.assignee.name : "Unassigned" })
      ]
    }
  ) }),
  e.team?.name && /* @__PURE__ */ ae.jsx(Ns, { title: "Team", children: /* @__PURE__ */ ae.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: js.issueField,
      children: e.team.name
    }
  ) }),
  e.project?.name && /* @__PURE__ */ ae.jsx(Ns, { title: "Project", children: /* @__PURE__ */ ae.jsx(
    $.Paragraph,
    {
      variant: "3",
      color: "neutral.800",
      className: js.issueField,
      children: e.project.name
    }
  ) }),
  /* @__PURE__ */ ae.jsx(Ns, { title: "Description", children: /* @__PURE__ */ ae.jsx(UM, { className: js.issueDescription, children: e.description }) })
] }), r4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "No Priority",
    "data-testid": "noPriorityIcon",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 5 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 8 7)" }),
      /* @__PURE__ */ ae.jsx("rect", { width: "2", height: "2", rx: "1", transform: "matrix(-1 0 0 1 11 7)" })
    ]
  }
), i4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Low Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1", fillOpacity: "0.4" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), a4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "Medium Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1", fillOpacity: "0.4" })
    ]
  }
), o4 = /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--dixa-color-neutral-500)",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "aria-label": "High Priority",
    children: [
      /* @__PURE__ */ ae.jsx("rect", { x: "1", y: "8", width: "3", height: "6", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "6", y: "5", width: "3", height: "9", rx: "1" }),
      /* @__PURE__ */ ae.jsx("rect", { x: "11", y: "2", width: "3", height: "12", rx: "1" })
    ]
  }
), s4 = /* @__PURE__ */ ae.jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "-1 -1 15 15",
    "aria-label": "Urgent Priority",
    fill: "var(--dixa-color-orange-400)",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 0a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V2a2 2 0 00-2-2H2zm3.914 3h1.738L7.5 8.602H6.07L5.914 3zm1.809 7.164a.95.95 0 01-.938.938.934.934 0 110-1.867c.5 0 .934.417.938.93z"
      }
    )
  }
), z1 = {
  0: r4,
  1: s4,
  2: o4,
  3: a4,
  4: i4
}, l4 = (e) => e in z1, wl = ({ priority: e }) => l4(e) ? z1[e] : /* @__PURE__ */ ae.jsx(Jn, { "data-testid": "defaultPriorityTag", children: e }), c4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    "data-testid": "defaultStatusIcon",
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        d: "M13.9408 7.91426L11.9576 7.65557C11.9855 7.4419 12 7.22314 12 7C12 6.77686 11.9855 6.5581 11.9576 6.34443L13.9408 6.08573C13.9799 6.38496 14 6.69013 14 7C14 7.30987 13.9799 7.61504 13.9408 7.91426ZM13.4688 4.32049C13.2328 3.7514 12.9239 3.22019 12.5538 2.73851L10.968 3.95716C11.2328 4.30185 11.4533 4.68119 11.6214 5.08659L13.4688 4.32049ZM11.2615 1.4462L10.0428 3.03204C9.69815 2.76716 9.31881 2.54673 8.91341 2.37862L9.67951 0.531163C10.2486 0.767153 10.7798 1.07605 11.2615 1.4462ZM7.91426 0.0591659L7.65557 2.04237C7.4419 2.01449 7.22314 2 7 2C6.77686 2 6.5581 2.01449 6.34443 2.04237L6.08574 0.059166C6.38496 0.0201343 6.69013 0 7 0C7.30987 0 7.61504 0.0201343 7.91426 0.0591659ZM4.32049 0.531164L5.08659 2.37862C4.68119 2.54673 4.30185 2.76716 3.95716 3.03204L2.73851 1.4462C3.22019 1.07605 3.7514 0.767153 4.32049 0.531164ZM1.4462 2.73851L3.03204 3.95716C2.76716 4.30185 2.54673 4.68119 2.37862 5.08659L0.531164 4.32049C0.767153 3.7514 1.07605 3.22019 1.4462 2.73851ZM0.0591659 6.08574C0.0201343 6.38496 0 6.69013 0 7C0 7.30987 0.0201343 7.61504 0.059166 7.91426L2.04237 7.65557C2.01449 7.4419 2 7.22314 2 7C2 6.77686 2.01449 6.5581 2.04237 6.34443L0.0591659 6.08574ZM0.531164 9.67951L2.37862 8.91341C2.54673 9.31881 2.76716 9.69815 3.03204 10.0428L1.4462 11.2615C1.07605 10.7798 0.767153 10.2486 0.531164 9.67951ZM2.73851 12.5538L3.95716 10.968C4.30185 11.2328 4.68119 11.4533 5.08659 11.6214L4.32049 13.4688C3.7514 13.2328 3.22019 12.9239 2.73851 12.5538ZM6.08574 13.9408L6.34443 11.9576C6.5581 11.9855 6.77686 12 7 12C7.22314 12 7.4419 11.9855 7.65557 11.9576L7.91427 13.9408C7.61504 13.9799 7.30987 14 7 14C6.69013 14 6.38496 13.9799 6.08574 13.9408ZM9.67951 13.4688L8.91341 11.6214C9.31881 11.4533 9.69815 11.2328 10.0428 10.968L11.2615 12.5538C10.7798 12.9239 10.2486 13.2328 9.67951 13.4688ZM12.5538 11.2615L10.968 10.0428C11.2328 9.69815 11.4533 9.31881 11.6214 8.91341L13.4688 9.67951C13.2328 10.2486 12.924 10.7798 12.5538 11.2615Z",
        stroke: "none"
      }
    )
  }
), d4 = (e, n) => /* @__PURE__ */ ae.jsxs(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    "aria-label": n,
    "data-testid": "unstartedStatusIcon",
    children: [
      /* @__PURE__ */ ae.jsx(
        "rect",
        {
          x: "1",
          y: "1",
          width: "12",
          height: "12",
          rx: "6",
          stroke: e,
          strokeWidth: "2",
          fill: "none"
        }
      ),
      /* @__PURE__ */ ae.jsx(
        "path",
        {
          fill: e,
          stroke: "none",
          d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 0 z",
          transform: "translate(3.5,3.5)"
        }
      )
    ]
  }
), u4 = (e, n) => /* @__PURE__ */ ae.jsxs("svg", { width: "14", height: "14", viewBox: "0 0 14 14", fill: "none", "aria-label": n, children: [
  /* @__PURE__ */ ae.jsx(
    "rect",
    {
      x: "1",
      y: "1",
      width: "12",
      height: "12",
      rx: "6",
      stroke: e,
      strokeWidth: "2",
      fill: "none"
    }
  ),
  /* @__PURE__ */ ae.jsx(
    "path",
    {
      fill: e,
      stroke: "none",
      d: "M 3.5,3.5 L3.5,0 A3.5,3.5 0 0,1 3.5, 7 z",
      transform: "translate(3.5,3.5)"
    }
  )
] }), m4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), p4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z",
        stroke: "none"
      }
    )
  }
), f4 = (e, n) => /* @__PURE__ */ ae.jsx(
  "svg",
  {
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    "aria-label": n,
    fill: e,
    children: /* @__PURE__ */ ae.jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0ZM11.101 5.10104C11.433 4.76909 11.433 4.23091 11.101 3.89896C10.7691 3.56701 10.2309 3.56701 9.89896 3.89896L5.5 8.29792L4.10104 6.89896C3.7691 6.56701 3.2309 6.56701 2.89896 6.89896C2.56701 7.2309 2.56701 7.7691 2.89896 8.10104L4.89896 10.101C5.2309 10.433 5.7691 10.433 6.10104 10.101L11.101 5.10104Z"
      }
    )
  }
), py = {
  backlog: (e, n) => c4(e, n),
  unstarted: (e, n) => d4(e, n),
  started: (e, n) => u4(e, n),
  done: (e, n) => m4(e, n),
  canceled: (e, n) => p4(e, n),
  completed: (e, n) => f4(e, n)
}, h4 = (e) => e in py, Cl = ({
  type: e = "backlog",
  color: n = "var(--dixa-color-neutral-400)",
  name: r = "linear-backlog-icon"
}) => h4(e) ? py[e](n, r) : py.backlog(
  "var(--dixa-color-neutral-400)",
  "linear-backlog-icon"
), y4 = "_wrapper_e0qj3_1", g4 = "_resultTitle_e0qj3_21", v4 = "_resultTooltipTitle_e0qj3_28", k4 = "_resultLinkIcon_e0qj3_31", ao = {
  wrapper: y4,
  resultTitle: g4,
  resultTooltipTitle: v4,
  resultLinkIcon: k4
}, b4 = ({
  issue: e
}) => {
  const [n, r] = me(!1), {
    list: { isDisabled: i },
    item: { onSelect: a }
  } = Bl(jI()), o = _t(
    (s) => {
      i || a({
        value: e,
        meta: {
          target: s?.target,
          event: s || void 0
        }
      });
    },
    [i, a, e]
  );
  return /* @__PURE__ */ ae.jsx(
    Xe,
    {
      wrap: "none",
      side: "left",
      content: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", className: ao.wrapper, children: [
        /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", gap: "300", children: [
          /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ ae.jsx(
              Cl,
              {
                type: e.state.type,
                name: e.state.name,
                color: e.state.color
              }
            ),
            /* @__PURE__ */ ae.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
            /* @__PURE__ */ ae.jsx(wl, { priority: e.priority })
          ] }),
          /* @__PURE__ */ ae.jsx(Jn, { children: e.state.name })
        ] }),
        /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ ae.jsx(
            $.Heading,
            {
              variant: "heading-3",
              className: ao.resultTooltipTitle,
              children: e.title
            }
          ),
          /* @__PURE__ */ ae.jsx(V1, { issue: e })
        ] })
      ] }),
      light: !0,
      children: /* @__PURE__ */ ae.jsx(
        mt.Item,
        {
          value: e,
          noFixedSelectionStateSpace: !0,
          className: ao.result,
          onMouseEnter: () => r(!0),
          onMouseLeave: () => r(!1),
          "data-testid": "selectionListItemWrapper",
          onClick: o,
          children: /* @__PURE__ */ ae.jsxs(
            b,
            {
              flexDirection: "column",
              style: {
                width: n ? "calc(100% - 32px)" : "100%"
              },
              children: [
                /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
                  /* @__PURE__ */ ae.jsx(
                    Cl,
                    {
                      type: e.state.type,
                      color: e.state.color,
                      name: e.state.name
                    }
                  ),
                  /* @__PURE__ */ ae.jsx($.Heading, { variant: "heading-3", children: e.identifier }),
                  /* @__PURE__ */ ae.jsx(wl, { priority: e.priority })
                ] }),
                /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "4", className: ao.resultTitle, children: e.title }),
                n && /* @__PURE__ */ ae.jsx(
                  ve,
                  {
                    className: ao.resultLinkIcon,
                    name: "plus",
                    size: 32
                  }
                )
              ]
            }
          )
        },
        e.id
      )
    }
  );
}, _4 = "_loader_13xpk_1", x4 = "_dropdown_13xpk_8", S4 = "_loadMore_13xpk_13", Dm = {
  loader: _4,
  dropdown: x4,
  loadMore: S4
}, N4 = ({
  handleSelect: e,
  linkedIssues: n
}) => {
  const [r, i] = me(), [a, o] = me([]), [s, l] = me(""), [d, m] = me(!1), { useLazyQuery: u } = hn(), [f, { data: h, loading: k, networkStatus: C }] = u(
    XM,
    {
      fetchPolicy: "no-cache",
      notifyOnNetworkStatusChange: !0
    }
  );
  ki(
    () => {
      !k && s !== "" && C === tr.ready ? f({
        variables: {
          issueQuery: s,
          first: 8
        }
      }) : o([]);
    },
    500,
    [s]
  ), Qe(() => {
    k || o([]);
  }, [s]), Qe(() => {
    if (h && Object.keys(h).length > 0) {
      const j = h.Linear.searchIssues.edges.map(
        ({ node: O }) => O
      ), _ = a.filter(
        (O) => !n.find((I) => I.id === O.id)
      ), g = _.filter(
        (O) => !j.find(
          (I) => I.id === O.id
        )
      ), D = j.filter(
        (O) => !n.find((I) => I.id === O.id)
      );
      n.length > 0 ? o(
        d ? [...g, ...D] : D
      ) : h?.Linear?.searchIssues?.edges && o(
        d ? [..._, ...j] : j
      ), h.Linear.searchIssues.pageInfo.hasNextPage && m(!1), i(h.Linear.searchIssues?.pageInfo);
    }
  }, [h, n]);
  const N = () => {
    !k && s !== "" && C === tr.ready ? (m(!0), f({
      variables: {
        issueQuery: s,
        first: 8,
        after: r?.endCursor
      }
    })) : o([]);
  };
  return /* @__PURE__ */ ae.jsx(b, { flexDirection: "column", gap: "200", "data-testid": "searchBarWrapper", children: /* @__PURE__ */ ae.jsxs(
    mi,
    {
      "data-testid": "searchBarComponent",
      clearable: !0,
      getItemTitleByValue: (j) => j?.title,
      onChange: (j) => e(j.selectedValues[0]),
      dropdownProps: { className: Dm.dropdown },
      filter: {
        value: s,
        onChange: (j) => {
          const _ = j.target.value;
          l(_);
        }
      },
      placeholder: "Search Linear issues",
      children: [
        a?.map((j) => /* @__PURE__ */ ae.jsx(b4, { issue: j }, j.id)),
        r?.hasNextPage && !k && s !== "" && a.length && /* @__PURE__ */ ae.jsx(
          b,
          {
            gap: "100",
            justifyContent: "center",
            padding: "200",
            alignItems: "center",
            onClick: () => N(),
            className: Dm.loadMore,
            children: /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "3", children: "Load more ..." })
          }
        ),
        k && s !== "" && /* @__PURE__ */ ae.jsx(b, { justifyContent: "center", className: Dm.loader, children: /* @__PURE__ */ ae.jsx(fn, { size: 24 }) }),
        s === "" && a.length === 0 && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "Enter issue title or description" })
          }
        ),
        a.length === 0 && s !== "" && !k && /* @__PURE__ */ ae.jsx(
          b,
          {
            justifyContent: "center",
            style: { margin: "var(--dixa-size-spacer-250)" },
            children: /* @__PURE__ */ ae.jsx($.Paragraph, { variant: "3", color: "neutral.400", children: "No Linear issues found" })
          }
        )
      ]
    }
  ) });
}, j4 = "_collapse_su0f9_1", w4 = "_collapseHeader_su0f9_8", C4 = "_collapseContent_su0f9_31", F4 = "_url_su0f9_35", I4 = "_externalLink_su0f9_51", E4 = "_emptyState_su0f9_55", di = {
  collapse: j4,
  collapseHeader: w4,
  collapseContent: C4,
  url: F4,
  externalLink: I4,
  emptyState: E4
}, $4 = ({
  linkedIssues: e,
  isLoading: n,
  handleUnlinkIssue: r,
  showUnlinkAllModal: i,
  showUnlinkAllButton: a,
  organizationUrl: o
}) => {
  const s = e.reduce(
    (u, f) => ({ ...u, [f.id]: !1 }),
    {}
  ), [l, d] = me(s), { track: m } = Cn();
  return n ? /* @__PURE__ */ ae.jsx(
    b,
    {
      flexDirection: "column",
      margin: "0 0 400 0",
      justifyContent: "center",
      alignItems: "center",
      children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
    }
  ) : e.length === 0 ? /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      justifyContent: "center",
      margin: "0 0 300 0",
      gap: "300",
      children: [
        /* @__PURE__ */ ae.jsx(
          $.Paragraph,
          {
            align: "center",
            variant: "3",
            color: "neutral.400",
            className: di.emptyState,
            children: "No linked issues found"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(ve, { name: "external-link" }),
            variant: "tertiary",
            className: di.externalLink,
            navigate: () => window.open(
              `https://linear.app/${e[0]?.team?.organization.urlKey ?? ""}`,
              "_blank"
            )?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  ) : /* @__PURE__ */ ae.jsxs(
    b,
    {
      flexDirection: "column",
      gap: "250",
      margin: "0 0 400 0",
      "data-testid": "linkedIssueWrapper",
      children: [
        e.map((u) => {
          const f = l[u.id];
          return /* @__PURE__ */ ae.jsxs(
            _r,
            {
              "data-testid": "collapseCard",
              onToggle: () => d({ ...l, [u.id]: !l[u.id] }),
              isOpen: f,
              className: di.collapse,
              children: [
                /* @__PURE__ */ ae.jsx(_r.Header, { className: di.collapseHeader, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  /* @__PURE__ */ ae.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
                    /* @__PURE__ */ ae.jsxs(b, { gap: "100", alignItems: "center", children: [
                      /* @__PURE__ */ ae.jsx(Xe, { content: /* @__PURE__ */ ae.jsx(b, { children: u.state.name }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(
                        Cl,
                        {
                          type: u.state.type,
                          color: u.state.color,
                          name: u.state.name
                        }
                      ) }) }),
                      /* @__PURE__ */ ae.jsxs(
                        $.ExternalLink,
                        {
                          className: di.url,
                          href: u.url,
                          target: "_blank",
                          rel: "noreferrer",
                          children: [
                            u.identifier,
                            /* @__PURE__ */ ae.jsx(ve, { name: "external-link" })
                          ]
                        }
                      ),
                      /* @__PURE__ */ ae.jsx(Xe, { content: /* @__PURE__ */ ae.jsx(b, { children: u.priorityLabel }), children: /* @__PURE__ */ ae.jsx(b, { alignSelf: "center", children: /* @__PURE__ */ ae.jsx(wl, { priority: u.priority }) }) })
                    ] }),
                    /* @__PURE__ */ ae.jsx(Jn, { children: u.state.name })
                  ] }),
                  u.title
                ] }) }),
                /* @__PURE__ */ ae.jsx(_r.Content, { className: di.collapseContent, children: /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
                  u?.labels && u?.labels?.edges?.length > 0 && /* @__PURE__ */ ae.jsx(
                    b,
                    {
                      flexDirection: "row",
                      gap: "200",
                      alignItems: "center",
                      flexWrap: "wrap",
                      children: u.labels?.edges.map((h) => /* @__PURE__ */ ae.jsx(Jn, { color: h.node.color, children: h.node.name }, h.node.id))
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(V1, { issue: u }),
                  /* @__PURE__ */ ae.jsx(
                    ct,
                    {
                      slotStart: /* @__PURE__ */ ae.jsx(ve, { name: "link-slash" }),
                      variant: "secondary",
                      onClick: () => r(u.id),
                      style: { marginTop: "var(--dixa-size-spacer-200)" },
                      children: "Unlink issue from Linear"
                    }
                  ),
                  /* @__PURE__ */ ae.jsxs(
                    Lt,
                    {
                      slotEnd: /* @__PURE__ */ ae.jsx(ve, { name: "external-link" }),
                      variant: "tertiary",
                      className: di.externalLink,
                      onClick: () => {
                        m("linear:open:issue:clicked", {
                          linearInstanceUrl: o,
                          linearIssueKey: u.id
                        });
                      },
                      navigate: () => window.open(u.url, "_blank")?.focus(),
                      children: [
                        "View ",
                        u.identifier,
                        " in Linear"
                      ]
                    }
                  )
                ] }) })
              ]
            },
            u.id
          );
        }),
        e.length > 1 && a && /* @__PURE__ */ ae.jsx(
          ct,
          {
            slotStart: /* @__PURE__ */ ae.jsx(ve, { name: "link-slash" }),
            variant: "secondary",
            onClick: () => i(!0),
            children: "Unlink all issues"
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Lt,
          {
            slotEnd: /* @__PURE__ */ ae.jsx(ve, { name: "external-link" }),
            variant: "tertiary",
            className: di.externalLink,
            onClick: () => {
              m("linear:open:linear:clicked", {
                // we check against empty linkedIssues earlier in the code.
                // function is using item at index 0 since all teams belong in the same organization/workspace,
                linearInstanceUrl: o,
                linearIssueKey: e[0].id
              });
            },
            disabled: !o,
            navigate: () => window.open(o, "_blank")?.focus(),
            children: "Open Linear"
          }
        )
      ]
    }
  );
}, T4 = {
  default: (e, n) => (n() ?? []).join(""),
  nodes: {
    doc: (e, n) => (n() ?? []).join(""),
    heading: (e, n) => `
${"#".repeat(
      parseInt(e.attrs?.level) || 1
    )} ${n()}

`,
    bullet_list: (e, n) => `
` + n().map((r) => `- ${r}`).join(""),
    ordered_list: (e, n) => `
` + n().map((r) => `1. ${r}`).join(""),
    // We're not emitting list items from the listItem formatter but from the
    // ordered/bullet list nodes above, as markdown does not encapsulate list items
    //listItem: (_node, children) => '- ' + children(),
    paragraph: (e, n) => n().join("") + `
`,
    text: (e) => e.text ?? "",
    hard_break: () => `
`,
    blockquote: (e, n) => `> ${n().join("")}
`,
    code_block: (e, n) => "\n```" + (e.attrs?.language || "") + `
` + n() + "\n```\n"
  },
  marks: {
    text: {
      strong: (e, n) => `**${n()}**`,
      strike: (e, n) => `~~${n()}~~`,
      subsup: (e, n) => {
        switch (e.attrs?.type) {
          case "sub":
            return `<sub>${n()}</sub>`;
          case "sup":
            return `<sup>${n()}</sup>`;
          default:
            return n();
        }
      },
      underline: (e, n) => `<u>${n()}</u>`,
      em: (e, n) => `*${n()}*`,
      link: (e, n) => `[${n()}](${e.attrs?.href})`,
      code: (e, n) => `\`${n()}\``
    }
  }
}, U1 = (e, n) => {
  const r = (o) => (e.marks || []).map((s) => ({
    formatterFunction: n.marks[e.type]?.[s.type],
    mark: s
  })).reduce(
    (s, l) => () => l.formatterFunction?.(l.mark, s) || o,
    () => o
  )(), i = (o, s) => () => o.content ? o.content.map((l) => U1(l, s)) : [], a = n.nodes[e.type] || n.default;
  return r(
    a(e, i(e, n))
  );
}, O4 = "_modalBody_iv3ua_1", R4 = "_error_iv3ua_5", D4 = "_dropdown_iv3ua_16", ia = {
  modalBody: O4,
  error: R4,
  dropdown: D4
}, P4 = ts(
  /* GraphQL */
  `
  mutation createIssue(
    $issueTitle: String!
    $issueDescription: String
    $teamId: String!
    $projectId: String
    $statusId: String
    $priority: Int
  ) {
    Linear {
      issueCreate(
        input: {
          title: $issueTitle
          description: $issueDescription
          teamId: $teamId
          projectId: $projectId
          stateId: $statusId
          priority: $priority
        }
      ) {
        success
        issue {
          id
          title
          identifier
          url
        }
      }
    }
  }
`
), A4 = ts(
  /* GraphQL */
  `
  query staticData {
    Linear {
      teams {
        edges {
          node {
            id
            name
            organization {
              urlKey
            }
          }
        }
      }
      issuePriorityValues {
        priority
        label
      }
      organization {
        urlKey
      }
    }
  }
`
), L4 = ts(
  /* GraphQL */
  `
  query teamData($teamId: String!) {
    Linear {
      team(id: $teamId) {
        projects {
          edges {
            node {
              id
              name
            }
          }
        }
        states {
          edges {
            node {
              id
              name
              type
              color
            }
          }
        }
        templates {
          edges {
            node {
              id
              name
              type
              templateData
            }
          }
        }
      }
    }
  }
`
), V4 = ({
  setCreatedIssue: e,
  isCreateIssueModalOpen: n,
  setIsCreateIssueModalOpen: r,
  setIsCreationSuccessfulModalOpen: i,
  addToLinkedIssueIds: a,
  organizationUrl: o,
  setOrganizationUrl: s
}) => {
  const { useLazyQuery: l, showNotification: d } = hn(), { control: m, handleSubmit: u, reset: f } = ut(), [h, k] = me([]), [C, N] = me(), [j, _] = me([]), [g, D] = me(), [O, I] = me([]), [F, L] = me(), [K, J] = me([]), [te, W] = me(), [Y, P] = me([]), [B, re] = me(), [je, ue] = me(!1), { useMutation: se } = hn(), { track: he } = Cn(), [V, { loading: ke }] = se(
    P4,
    {
      onError: () => {
        ue(!1), d({
          title: "Creation was not successful",
          text: "Please try again later or contact your admin.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      },
      onCompleted: ($e) => {
        const Me = {
          identifier: $e.Linear?.issueCreate?.issue?.identifier,
          url: $e.Linear?.issueCreate?.issue?.url
        };
        $e.Linear && $e.Linear?.issueCreate?.issue?.id && (a($e.Linear?.issueCreate?.issue?.id), Be(Me), ue(!1), d({
          title: "Issue was created and linked to the conversation",
          text: `Issue ${$e.Linear.issueCreate.issue.identifier} was created and added to the active conversation`,
          icon: "exclamation-triangle-filled",
          severity: "success"
        }), he("linear:create:new:issue:confirmed", {
          linearInstanceUrl: o
        }));
      }
    }
  ), [
    De,
    { data: q, loading: Ge, error: sn }
  ] = l(A4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team ID",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: ($e) => {
      const Me = $e.Linear.teams.edges.map(
        ({ node: en }) => en
      );
      k(Me), J($e.Linear.issuePriorityValues), s(`${G4}${$e.Linear.organization.urlKey}`);
    }
  }), [Ie, { data: Ue, loading: Re }] = l(L4, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onError: () => d({
      title: "Error while fetching team projects",
      text: "Please try again later or contact your admin.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }),
    onCompleted: ($e) => {
      const Me = $e?.Linear?.team?.projects?.edges?.map(
        ({ node: le }) => le
      );
      _(Me);
      const en = $e?.Linear?.team?.states?.edges?.map(
        ({ node: le }) => le
      );
      I(en);
      const oe = $e?.Linear?.team?.templates?.edges?.map(
        ({ node: le }) => le
      );
      P(
        oe.filter(
          (le) => le.type === "issue"
        )
      );
    }
  }), Be = ($e) => {
    r(!1), D(void 0), N(void 0), L(void 0), W(void 0), re(void 0), $e && (e($e), i(!0)), f({
      title: "",
      description: "",
      projectId: "",
      teamId: "",
      statusId: "",
      priority: void 0
    });
  }, Ae = ($e) => {
    q && !Ge && (V({
      variables: {
        issueTitle: $e.title,
        issueDescription: $e?.description,
        teamId: $e.team.id,
        projectId: $e?.project?.id,
        statusId: $e?.status?.id,
        priority: $e?.priority?.priority
      }
    }), ue(!0));
  };
  Qe(() => {
    n && De();
  }, [n]);
  const Je = () => {
    he("linear:create:new:issue:cancelled", {
      linearInstanceUrl: o
    });
  };
  return /* @__PURE__ */ ae.jsxs(
    wt,
    {
      isOpen: n,
      onClose: () => {
        Je(), Be();
      },
      children: [
        /* @__PURE__ */ ae.jsx(
          Ct,
          {
            title: "Create new Linear issue",
            onClose: () => {
              Je(), Be();
            }
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Ft,
          {
            className: ia.modalBody,
            "data-testid": "createIssueModalBody",
            children: sn ? /* @__PURE__ */ ae.jsx(En, { error: sn }) : /* @__PURE__ */ ae.jsx("form", { onSubmit: u(Ae), id: "issueCreationForm", children: /* @__PURE__ */ ae.jsxs(nt, { children: [
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: m,
                  name: "team",
                  rules: {
                    required: "Team is required"
                  },
                  render: ({
                    field: { value: $e, onChange: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ ae.jsx(
                    We,
                    {
                      required: !0,
                      label: "Team",
                      meta: {
                        error: en?.message ?? null
                      },
                      children: /* @__PURE__ */ ae.jsx(
                        mi,
                        {
                          dropdownProps: { className: ia.dropdown },
                          placeholder: "Select Linear team",
                          className: dt({ [ia.error]: en }),
                          getItemTitleByValue: (oe) => oe?.name,
                          onChange: (oe) => {
                            D(void 0), L(void 0), W(void 0), re(void 0), N(oe.selectedValues[0]), Ie({
                              variables: { teamId: oe.selectedValues[0].id }
                            }), Me(oe.selectedValues[0]);
                          },
                          value: C ? [$e] : void 0,
                          children: h?.map((oe) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx($.Paragraph, { children: oe.name })
                            },
                            oe.id
                          ))
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: m,
                  name: "project",
                  render: ({ field: { value: $e, onChange: Me } }) => {
                    const en = Re ? [{ name: "Loading projects...", id: "" }] : void 0;
                    return /* @__PURE__ */ ae.jsx(We, { label: "Project", children: /* @__PURE__ */ ae.jsx(
                      mi,
                      {
                        dropdownProps: { className: ia.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (oe) => oe?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Linear project" : "Select a Team first",
                        onChange: (oe) => {
                          D(oe.selectedValues[0]), Me(oe.selectedValues[0]);
                        },
                        value: g ? [$e] : en,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          Re && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Ue && !Re && j.map((oe) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsx($.Paragraph, { children: oe.name })
                            },
                            oe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 6, children: /* @__PURE__ */ ae.jsx(We, { label: "Template", children: /* @__PURE__ */ ae.jsx(
                mi,
                {
                  clearable: !0,
                  dropdownProps: { className: ia.dropdown },
                  disabled: !C || Re,
                  placeholder: C ? "Select template" : "Select a Team first",
                  getItemTitleByValue: ($e) => $e?.name,
                  onChange: ($e) => {
                    if ($e.selectedValues.length > 0) {
                      re($e.selectedValues[0]);
                      const Me = JSON.parse(
                        $e.selectedValues[0].templateData
                      ), en = K.filter(
                        (Ve) => Ve.priority === Me.priority
                      );
                      W(
                        en ? en[0] : void 0
                      );
                      const oe = O.filter(
                        (Ve) => Ve.id === Me.stateId
                      );
                      L(
                        oe ? oe[0] : void 0
                      );
                      const le = j.filter(
                        (Ve) => Ve.id === Me.projectId
                      );
                      D(
                        le ? le[0] : void 0
                      );
                      const xe = Me.description;
                      f({
                        title: Me?.title,
                        priority: en[0],
                        status: oe[0],
                        project: le[0],
                        description: xe ? U1(xe, T4) : "",
                        team: C
                      });
                    } else
                      f({
                        title: "",
                        description: "",
                        team: C
                      }), D(void 0), W(void 0), L(void 0), re(void 0);
                  },
                  value: B ? [B] : void 0,
                  children: Y?.map(($e) => /* @__PURE__ */ ae.jsx(
                    mt.Item,
                    {
                      value: $e,
                      noFixedSelectionStateSpace: !0,
                      children: /* @__PURE__ */ ae.jsx($.Paragraph, { children: $e.name })
                    },
                    $e.id
                  ))
                }
              ) }) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 6, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: m,
                  name: "title",
                  rules: {
                    required: "Title field is required",
                    minLength: 2
                  },
                  render: ({
                    field: { onChange: $e, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ ae.jsx(
                    Wr,
                    {
                      required: !0,
                      label: "Title",
                      placeholder: "Insert issue title here",
                      input: {
                        name: "issueTitle",
                        value: Me || "",
                        onChange: $e
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: m,
                  name: "status",
                  render: ({ field: { value: $e, onChange: Me } }) => {
                    const en = Re ? [
                      {
                        name: "Loading statuses...",
                        id: "",
                        type: "",
                        color: ""
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(We, { label: "Status", children: /* @__PURE__ */ ae.jsx(
                      mi,
                      {
                        dropdownProps: { className: ia.dropdown },
                        clearable: !0,
                        getItemTitleByValue: (oe) => oe?.name,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue status" : "Select a Team first",
                        onChange: (oe) => {
                          L(oe.selectedValues[0]), Me(oe.selectedValues[0]);
                        },
                        value: F ? [$e] : en,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          Re && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          Ue && !Re && O.map((oe) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      Cl,
                                      {
                                        type: oe.type,
                                        color: oe.color,
                                        name: oe.name
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx($.Paragraph, { children: oe.name })
                                  ]
                                }
                              )
                            },
                            oe.id
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: m,
                  name: "priority",
                  render: ({ field: { value: $e, onChange: Me } }) => {
                    const en = Ge ? [
                      {
                        label: "Loading Priorities...",
                        priority: 0
                      }
                    ] : void 0;
                    return /* @__PURE__ */ ae.jsx(We, { label: "Priority", children: /* @__PURE__ */ ae.jsx(
                      mi,
                      {
                        clearable: !0,
                        getItemTitleByValue: (oe) => oe?.label,
                        disabled: C === void 0,
                        placeholder: C ? "Select Issue priority" : "Select a Team first",
                        onChange: (oe) => {
                          W(oe.selectedValues[0]), Me(oe.selectedValues[0]);
                        },
                        value: te ? [$e] : en,
                        children: /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
                          Re && /* @__PURE__ */ ae.jsx(
                            b,
                            {
                              justifyContent: "center",
                              style: {
                                padding: "var(--dixa-size-spacer-200)"
                              },
                              children: /* @__PURE__ */ ae.jsx(fn, { size: 24 })
                            }
                          ),
                          q && !Ge && K.map((oe) => /* @__PURE__ */ ae.jsx(
                            mt.Item,
                            {
                              value: oe,
                              noFixedSelectionStateSpace: !0,
                              children: /* @__PURE__ */ ae.jsxs(
                                b,
                                {
                                  flexDirection: "row",
                                  gap: "300",
                                  alignItems: "center",
                                  children: [
                                    /* @__PURE__ */ ae.jsx(
                                      wl,
                                      {
                                        priority: oe.priority
                                      }
                                    ),
                                    /* @__PURE__ */ ae.jsx($.Paragraph, { children: oe.label })
                                  ]
                                }
                              )
                            },
                            oe.priority
                          ))
                        ] })
                      }
                    ) });
                  }
                }
              ) }),
              /* @__PURE__ */ ae.jsx(Z, { children: /* @__PURE__ */ ae.jsx(
                bt,
                {
                  control: m,
                  name: "description",
                  render: ({
                    field: { onChange: $e, value: Me },
                    fieldState: { error: en }
                  }) => /* @__PURE__ */ ae.jsx(
                    SI,
                    {
                      label: "Description",
                      placeholder: "Insert Issue description here",
                      input: {
                        name: "description",
                        value: Me || "",
                        onChange: $e
                      },
                      meta: {
                        error: en?.message ?? null
                      }
                    }
                  )
                }
              ) })
            ] }) })
          }
        ),
        /* @__PURE__ */ ae.jsx(
          Et,
          {
            confirmOnClick: u(Ae),
            confirmProps: {
              disabled: ke || !q,
              isLoading: je || Ge || Re,
              loadingIndicator: /* @__PURE__ */ ae.jsx(fn, { size: 16 })
            },
            confirmName: "Save",
            cancelOnClick: () => {
              Je(), Be();
            }
          }
        )
      ]
    }
  );
}, z4 = "_modalWrapper_4kh9u_1", U4 = "_copyButton_4kh9u_6", M4 = "_copyWrapper_4kh9u_15", B4 = "_copyField_4kh9u_24", q4 = "_externalLink_4kh9u_47", H4 = "_externalLinkIcon_4kh9u_52", W4 = "_textWrapper_4kh9u_56", ji = {
  modalWrapper: z4,
  copyButton: U4,
  copyWrapper: M4,
  copyField: B4,
  externalLink: q4,
  externalLinkIcon: H4,
  textWrapper: W4
}, K4 = ({
  isCreationSuccessfulModalOpen: e,
  createdIssueData: n,
  setIsCreationSuccessfulModalOpen: r
}) => /* @__PURE__ */ ae.jsxs(
  wt,
  {
    isOpen: !!n && e,
    className: ji.modalWrapper,
    onClose: () => r(!1),
    children: [
      /* @__PURE__ */ ae.jsx(
        Ct,
        {
          title: "Issue creation successful",
          onClose: () => r(!1)
        }
      ),
      /* @__PURE__ */ ae.jsx(Ft, { children: /* @__PURE__ */ ae.jsxs(
        b,
        {
          gap: "300",
          flexDirection: "column",
          "data-testid": "creationSuccessfulModal",
          children: [
            /* @__PURE__ */ ae.jsxs($.Paragraph, { className: ji.textWrapper, children: [
              `You can visit issue ${n?.identifier} by following `,
              " ",
              /* @__PURE__ */ ae.jsxs(
                $.ExternalLink,
                {
                  href: n?.url,
                  target: "_blank",
                  className: ji.externalLink,
                  children: [
                    "this link",
                    " ",
                    /* @__PURE__ */ ae.jsx(ve, { name: "external-link", className: ji.externalLinkIcon })
                  ]
                }
              ),
              "or copy it from the field below."
            ] }),
            /* @__PURE__ */ ae.jsx(We, { label: "Linear issue link", children: /* @__PURE__ */ ae.jsxs(
              b,
              {
                flexDirection: "row",
                alignItems: "center",
                "data-testid": "copyInputField",
                className: ji.copyWrapper,
                children: [
                  /* @__PURE__ */ ae.jsx(
                    dr,
                    {
                      readOnly: !0,
                      value: n?.url,
                      className: ji.copyField
                    }
                  ),
                  /* @__PURE__ */ ae.jsx(
                    NI,
                    {
                      className: ji.copyButton,
                      textToCopy: n?.url || "",
                      clickedProps: {
                        icon: "check-circle-filled"
                      }
                    }
                  )
                ]
              }
            ) })
          ]
        }
      ) }),
      /* @__PURE__ */ ae.jsx(
        Et,
        {
          cancelOnClick: () => r(!1),
          cancelProps: { variant: "primary" },
          cancelName: "Close"
        }
      )
    ]
  }
), G4 = "https://linear.app/", Y4 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), [a, o] = me([]), [s, l] = me(!1), [d, m] = me(!1), [u, f] = me(!1), [h, k] = me(), { useLazyQuery: C } = hn(), [N, j] = me(""), _ = n?.enableCreateIssue, g = !!n?.enableUnlinkAll, { track: D } = Cn(), {
    loading: O,
    data: I,
    error: F,
    store: L
  } = jy(e?.conversationId ?? null), [
    K,
    {
      data: J,
      loading: te,
      networkStatus: W,
      error: Y
    }
  ] = C(ZM, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  Qe(() => {
    !O && !F && I && I?.linear?.issues?.length > 0 ? (o(I.linear.issues), K({
      variables: {
        linkedIssues: I.linear.issues
      }
    })) : !O && !F && (i([]), o([]));
  }, [I, O, F]), Qe(() => {
    J && J?.Linear && !te && W === tr.ready && Object.keys(J).length > 0 && i(J.Linear.issues?.edges?.map(({ node: ue }) => ue));
  }, [J, te, W]);
  const P = (ue) => {
    ue && ue?.team?.organization?.urlKey && D("linear:link:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: ue.id
    });
    const se = (he) => he.id === ue?.id;
    r.some((he) => he && se(he)) || (I && a.length === 0 && o([]), L({
      linear: {
        issues: [...a, ue.id]
      }
    }));
  }, B = (ue) => {
    const se = I?.linear.issues.filter((he) => he !== ue) || [];
    D("linear:unlink:issue:clicked", {
      linearInstanceUrl: N,
      linearIssueKey: ue
    }), i(r.filter(({ id: he }) => he !== ue)), o(se), L({
      linear: {
        issues: se
      }
    });
  }, re = () => {
    l(!1), i([]), o([]), L({
      linear: {
        issues: []
      }
    });
  }, je = O || te || !I && !F || (I?.linear?.issues?.length ?? 0) > 0 && r.length === 0;
  return !O && !te && (Y || F) ? /* @__PURE__ */ ae.jsx(En, { error: Y || F }) : /* @__PURE__ */ ae.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ ae.jsxs(
      wt,
      {
        isOpen: s,
        onClose: () => l(!1),
        children: [
          /* @__PURE__ */ ae.jsx(
            Ct,
            {
              title: "Unlink all Linear issues?",
              onClose: () => l(!1)
            }
          ),
          /* @__PURE__ */ ae.jsx(Ft, { "data-testid": "unlinkAllIssuesModalBody", children: "You are about to unlink all Linear issues from the conversation. Do you want to proceed?" }),
          /* @__PURE__ */ ae.jsx(
            Et,
            {
              confirmOnClick: () => re(),
              confirmName: "Unlink all",
              cancelOnClick: () => l(!1)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      V4,
      {
        isCreateIssueModalOpen: d,
        setIsCreateIssueModalOpen: (ue) => m(ue),
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        addToLinkedIssueIds: (ue) => {
          L({
            linear: {
              issues: [...a, ue]
            }
          });
        },
        setCreatedIssue: (ue) => k(ue),
        organizationUrl: N,
        setOrganizationUrl: (ue) => j(ue)
      }
    ),
    /* @__PURE__ */ ae.jsx(
      K4,
      {
        isCreationSuccessfulModalOpen: u,
        setIsCreationSuccessfulModalOpen: (ue) => f(ue),
        createdIssueData: h
      }
    ),
    /* @__PURE__ */ ae.jsxs(
      b,
      {
        flexDirection: "column",
        background: "neutral.100",
        padding: "300",
        borderRadius: "100",
        gap: "250",
        children: [
          _ && /* @__PURE__ */ ae.jsxs(ae.Fragment, { children: [
            /* @__PURE__ */ ae.jsx(
              ct,
              {
                variant: "primary",
                onClick: () => {
                  D("linear:create:new:issue:clicked", {
                    linearInstanceUrl: N
                  }), m(!0);
                },
                style: { minHeight: "38px" },
                children: "Create new issue"
              }
            ),
            /* @__PURE__ */ ae.jsx($.Paragraph, { color: "neutral.600", align: "center", children: "or" })
          ] }),
          /* @__PURE__ */ ae.jsx(N4, { handleSelect: P, linkedIssues: r })
        ]
      }
    ),
    /* @__PURE__ */ ae.jsx(
      $4,
      {
        linkedIssues: r,
        isLoading: je,
        handleUnlinkIssue: B,
        showUnlinkAllModal: (ue) => l(ue),
        showUnlinkAllButton: g,
        organizationUrl: N
      }
    )
  ] });
}, Fl = [
  {
    key: "enableCreateIssue",
    label: 'Enable the "Create issue" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableUnlinkAll",
    label: 'Enable the "Unlink all" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], rS = rr(Fl), wi = "LINEAR", J4 = {
  enabled: !1,
  name: "",
  enableCreateIssue: !0,
  enableUnlinkAll: !0
}, Q4 = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: J4
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = ur({
    integrationId: e,
    integrationType: wi,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: Fl,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => hr(J, {
    fieldDefinitions: Fl,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ ae.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ ae.jsx(yr, { cause: k }),
        /* @__PURE__ */ ae.jsxs(nt, { children: [
          /* @__PURE__ */ ae.jsx(Z, { children: /* @__PURE__ */ ae.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ ae.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(We, { label: rS.enableCreateIssue, children: /* @__PURE__ */ ae.jsx(
            bn,
            {
              name: "enableCreateIssue",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3 }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3, children: /* @__PURE__ */ ae.jsx(We, { label: rS.enableUnlinkAll, children: /* @__PURE__ */ ae.jsx(
            bn,
            {
              name: "enableUnlinkAll",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ ae.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ ae.jsx(
            gi,
            {
              configuration: n,
              integrationId: e,
              integrationType: wi,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ ae.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ ae.jsx(
          gr,
          {
            integrationType: wi,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ ae.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ ae.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ ae.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ ae.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  wi,
                  " integration, all links between Dixa and ",
                  wi,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ ae.jsxs($.Paragraph, { children: [
                  "All data in ",
                  wi,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ ae.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  wi,
                  " ",
                  'integration "',
                  K,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._wrapper_27vny_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_27vny_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._copyIcon_27vny_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._labelText_1q5b5_1{color:var(--dixa-typography-color-secondary)}._list_1q5b5_5{padding:0}._listItem_1q5b5_8{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_1q5b5_8:last-child{border-bottom:none}._listItemEdit_1q5b5_15{cursor:pointer}._notificationText_1q5b5_19{color:var(--dixa-color-neutral-500)}._modalBody_1clhs_1{width:400px}._reward_1wxia_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1wxia_1:hover{border-color:var(--dixa-color-neutral-400)}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Pm = { exports: {} }, oo = {}, iS;
function X4() {
  if (iS) return oo;
  iS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return oo.Fragment = r, oo.jsx = s, oo.jsxs = s, oo;
}
var ws = {}, aS;
function Z4() {
  return aS || (aS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    ws.Fragment = i, ws.jsx = zn, ws.jsxs = Wn;
  })()), ws;
}
var oS;
function e5() {
  return oS || (oS = 1, process.env.NODE_ENV === "production" ? Pm.exports = X4() : Pm.exports = Z4()), Pm.exports;
}
var Fe = e5();
const n5 = { kind: "Document", definitions: [{ kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, t5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "addPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "updateCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "UpdateCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UpdateCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_updateCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, r5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "removePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_request_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "removeCustomersPoints" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "RemoveCustomersPointsResponse" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "UnprocessableEntity" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_UnprocessableEntity" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "RemoveCustomersPointsResponse" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_removeCustomersPoints_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "UnprocessableEntity" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] }, i5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomers" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "points_approved" } }, { kind: "Field", name: { kind: "Name", value: "points_pending" } }, { kind: "Field", name: { kind: "Name", value: "points_spent" } }, { kind: "Field", name: { kind: "Name", value: "rewards_claimed" } }, { kind: "Field", name: { kind: "Name", value: "birthday" } }, { kind: "Field", name: { kind: "Name", value: "guest" } }, { kind: "Field", name: { kind: "Name", value: "blocked" } }, { kind: "Field", name: { kind: "Name", value: "enrolled" } }, { kind: "Field", name: { kind: "Name", value: "enrolled_at" } }, { kind: "Field", name: { kind: "Name", value: "referral_id" } }, { kind: "Field", name: { kind: "Name", value: "referred_by" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "merchant_id" } }] } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier_membership" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "started_at" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "manual" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "position" } }, { kind: "Field", name: { kind: "Name", value: "default" } }, { kind: "Field", name: { kind: "Name", value: "hidden" } }, { kind: "Field", name: { kind: "Name", value: "lower_bound" } }, { kind: "Field", name: { kind: "Name", value: "upper_bound" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "insights_segment" } }, { kind: "Field", name: { kind: "Name", value: "referral_url" } }, { kind: "Field", name: { kind: "Name", value: "metadata" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopify_source_url" } }] } }, { kind: "Field", name: { kind: "Name", value: "properties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }] } }] } }] } }] } }] } }] } }] } }] }, a5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getRewards" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "merchantId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "LoyaltyLion" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAvailableRewards" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "merchant_id" }, value: { kind: "Variable", name: { kind: "Name", value: "merchantId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_getAvailableRewards_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Rewards" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "rewards" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "site_id" } }, { kind: "Field", name: { kind: "Name", value: "target_site" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "content" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "point_cost" } }] } }] } }, { kind: "FragmentSpread", name: { kind: "Name", value: "BadRequest" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Unauthorized" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "Forbidden" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "NotFound" } }, { kind: "FragmentSpread", name: { kind: "Name", value: "ServerError" } }] } }] } }] } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "BadRequest" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_BadRequest" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Unauthorized" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Unauthorized" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "Forbidden" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_Forbidden" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "NotFound" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_NotFound" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "FragmentDefinition", name: { kind: "Name", value: "ServerError" }, typeCondition: { kind: "NamedType", name: { kind: "Name", value: "LoyaltyLion_ServerError" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "message" } }] } }] }, o5 = {
  "\n  fragment BadRequest on LoyaltyLion_BadRequest {\n    message\n  }\n  fragment Unauthorized on LoyaltyLion_Unauthorized {\n    message\n  }\n  fragment Forbidden on LoyaltyLion_Forbidden {\n    message\n  }\n  fragment NotFound on LoyaltyLion_NotFound {\n    message\n  }\n  fragment UnprocessableEntity on LoyaltyLion_UnprocessableEntity {\n    message\n  }\n  fragment ServerError on LoyaltyLion_ServerError {\n    message\n  }\n\n  fragment UpdateCustomersPointsResponse on LoyaltyLion_updateCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n\n  fragment RemoveCustomersPointsResponse on LoyaltyLion_removeCustomersPoints_response {\n    ...BadRequest\n    ...Unauthorized\n    ...Forbidden\n    ...NotFound\n    ...UnprocessableEntity\n    ...ServerError\n  }\n": n5,
  "\n  mutation addPoints(\n    $merchantId: String!\n    $input: LoyaltyLion_updateCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      updateCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_updateCustomersPoints_response {\n          ...UpdateCustomersPointsResponse\n        }\n      }\n    }\n  }\n": t5,
  "\n  mutation removePoints(\n    $merchantId: String!\n    $input: LoyaltyLion_removeCustomersPoints_request_Input!\n  ) {\n    LoyaltyLion {\n      removeCustomersPoints(merchant_id: $merchantId, input: $input) {\n        ... on LoyaltyLion_removeCustomersPoints_response {\n          ...RemoveCustomersPointsResponse\n        }\n      }\n    }\n  }\n": r5,
  "\n  query getCustomers($email: String!) {\n    LoyaltyLion {\n      getCustomers(email: $email) {\n        ... on LoyaltyLion_getCustomers_response {\n          ... on LoyaltyLion_Customers {\n            customers {\n              id\n              merchant_id\n              email\n              points_approved\n              points_pending\n              points_spent\n              rewards_claimed\n              birthday\n              guest\n              blocked\n              enrolled\n              enrolled_at\n              referral_id\n              referred_by {\n                id\n                merchant_id\n              }\n              loyalty_tier_membership {\n                started_at\n                expires_at\n                manual\n                loyalty_tier {\n                  id\n                  name\n                  position\n                  default\n                  hidden\n                  lower_bound\n                  upper_bound\n                }\n              }\n              insights_segment\n              referral_url\n              metadata {\n                shopify_source_url\n              }\n              properties {\n                name\n                first_name\n                last_name\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": i5,
  "\n  query getRewards($merchantId: String!) {\n    LoyaltyLion {\n      getAvailableRewards(merchant_id: $merchantId) {\n        ... on LoyaltyLion_getAvailableRewards_response {\n          ... on LoyaltyLion_Rewards {\n            rewards {\n              id\n              title\n              description\n              site_id\n              target_site {\n                id\n                name\n                url\n              }\n              content\n              kind\n              point_cost\n            }\n          }\n          ...BadRequest\n          ...Unauthorized\n          ...Forbidden\n          ...NotFound\n          ...ServerError\n        }\n      }\n    }\n  }\n": a5
};
function sc(e) {
  return o5[e] ?? {};
}
const s5 = sc(
  /* GraphQL */
  `
  query getCustomers($email: String!) {
    LoyaltyLion {
      getCustomers(email: $email) {
        ... on LoyaltyLion_getCustomers_response {
          ... on LoyaltyLion_Customers {
            customers {
              id
              merchant_id
              email
              points_approved
              points_pending
              points_spent
              rewards_claimed
              birthday
              guest
              blocked
              enrolled
              enrolled_at
              referral_id
              referred_by {
                id
                merchant_id
              }
              loyalty_tier_membership {
                started_at
                expires_at
                manual
                loyalty_tier {
                  id
                  name
                  position
                  default
                  hidden
                  lower_bound
                  upper_bound
                }
              }
              insights_segment
              referral_url
              metadata {
                shopify_source_url
              }
              properties {
                name
                first_name
                last_name
              }
            }
          }
        }
      }
    }
  }
`
), l5 = sc(
  /* GraphQL */
  `
  query getRewards($merchantId: String!) {
    LoyaltyLion {
      getAvailableRewards(merchant_id: $merchantId) {
        ... on LoyaltyLion_getAvailableRewards_response {
          ... on LoyaltyLion_Rewards {
            rewards {
              id
              title
              description
              site_id
              target_site {
                id
                name
                url
              }
              content
              kind
              point_cost
            }
          }
          ...BadRequest
          ...Unauthorized
          ...Forbidden
          ...NotFound
          ...ServerError
        }
      }
    }
  }
`
), c5 = sc(
  /* GraphQL */
  `
  mutation addPoints(
    $merchantId: String!
    $input: LoyaltyLion_updateCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      updateCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_updateCustomersPoints_response {
          ...UpdateCustomersPointsResponse
        }
      }
    }
  }
`
), d5 = sc(
  /* GraphQL */
  `
  mutation removePoints(
    $merchantId: String!
    $input: LoyaltyLion_removeCustomersPoints_request_Input!
  ) {
    LoyaltyLion {
      removeCustomersPoints(merchant_id: $merchantId, input: $input) {
        ... on LoyaltyLion_removeCustomersPoints_response {
          ...RemoveCustomersPointsResponse
        }
      }
    }
  }
`
);
function Am(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const u5 = "_wrapper_27vny_1", m5 = "_copyIcon_27vny_12", so = {
  wrapper: u5,
  copyIcon: m5
}, p5 = ({
  customer: e
}) => {
  const { isCopied: n, copy: r } = Am(), { isCopied: i, copy: a } = Am(), { isCopied: o, copy: s } = Am();
  if (!e)
    return null;
  const l = 14, {
    email: d,
    properties: m,
    metadata: u,
    birthday: f,
    created_at: h,
    enrolled: k,
    enrolled_at: C,
    referral_url: N
  } = e, j = f ? Gn(f).isSame(Date.now(), "day") : !1, { name: _, first_name: g, last_name: D } = m ?? {}, O = _ ?? (`${g} ${D}`.trim() || "A customer has no name"), I = u?.shopify_source_url ? u.shopify_source_url.startsWith("https://") ? u.shopify_source_url : `https://${u.shopify_source_url}` : "";
  return /* @__PURE__ */ Fe.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Fe.jsxs(b, { className: so.wrapper, gap: "250", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: so.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-2", children: O }),
          j && /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "primary", children: "... has birthday today 🥳" })
        ]
      }
    ),
    h && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Member since" }),
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", color: "secondary", children: Gn(h).format("DD MMM YYYY @ HH:mm") })
    ] }),
    k && /* @__PURE__ */ Fe.jsx(b, { gap: "200", children: /* @__PURE__ */ Fe.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
      "Enrolled since ",
      Gn(C).format("DD MMM YYYY @ HH:mm")
    ] }) }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(ve, { size: l, name: "mail" }),
        /* @__PURE__ */ Fe.jsx($.ExternalLink, { href: `mailto:${d}`, children: d })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: n ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: l,
          name: n ? "done" : "copy",
          onClick: () => r(d),
          className: so.copyIcon
        }
      ) })
    ] }),
    I && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(ve, { size: l, name: "link" }),
        /* @__PURE__ */ Fe.jsx(Xe, { content: "Shopify shop", children: /* @__PURE__ */ Fe.jsx(
          $.ExternalLink,
          {
            href: I,
            target: "_blank",
            rel: "noreferrer",
            children: I.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: i ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: l,
          name: i ? "done" : "copy",
          onClick: () => a(I),
          className: so.copyIcon
        }
      ) })
    ] }),
    N && /* @__PURE__ */ Fe.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ Fe.jsx(ve, { size: l, name: "external-link" }),
        /* @__PURE__ */ Fe.jsx(Xe, { content: "Referral link", children: /* @__PURE__ */ Fe.jsx(
          $.ExternalLink,
          {
            href: N,
            target: "_blank",
            rel: "noreferrer",
            children: N.replace("https://", "")
          }
        ) })
      ] }),
      /* @__PURE__ */ Fe.jsx(Xe, { content: o ? "Copied" : "Copy", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(N),
          className: so.copyIcon
        }
      ) })
    ] })
  ] }) });
}, f5 = "_list_1q5b5_5", h5 = "_listItem_1q5b5_8", y5 = "_listItemEdit_1q5b5_15", g5 = "_notificationText_1q5b5_19", Na = {
  list: f5,
  listItem: h5,
  listItemEdit: y5,
  notificationText: g5
}, v5 = "_modalBody_1clhs_1", k5 = {
  modalBody: v5
}, b5 = ({
  isOpen: e,
  points: n,
  merchantId: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), [d, m] = me(n), [u, f] = me(""), [h, k] = me(), [C, { loading: N }] = o(
    c5,
    {
      onCompleted: () => {
        s({
          title: "Success",
          text: "Added points successfully",
          icon: "check-circle-filled",
          severity: "success"
        }), l("loyaltylion:add:points:succeeded"), W();
      }
    }
  ), [j, { loading: _ }] = o(d5), g = N || _, D = !!h, O = n === d ? "Change the value to update the points" : "", I = isNaN(d), F = I ? "Points can not be empty" : "", L = d > n && d - n > 1e6, K = L ? "Points can not exceed 1,000,000" : "", J = () => {
    if (!r) {
      k(["Merchant information is missing."]), d > n ? l("loyaltylion:add:points:failed") : d < n && l("loyaltylion:remove:points:failed");
      return;
    }
    d > n && C({
      variables: {
        input: {
          points: d - n,
          reason: u
        },
        merchantId: r
      }
    }).catch((Y) => {
      const P = Y?.networkError;
      (P ? P?.statusCode : NaN) === 201 ? (l("loyaltylion:add:points:succeeded"), s({
        title: "Success",
        text: "Added points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), W()) : (l("loyaltylion:add:points:failed"), k(["Failed to add points, try again later."]));
    }), d < n && j({
      variables: {
        input: {
          points: n - d,
          reason: u
        },
        merchantId: r
      }
    }).then((Y) => {
      Y.data?.LoyaltyLion?.removeCustomersPoints?.__typename === "LoyaltyLion_Void_container" ? (l("loyaltylion:remove:points:succeeded"), s({
        title: "Success",
        text: "Removed points successfully",
        icon: "check-circle-filled",
        severity: "success"
      }), W()) : "errors" in Y && (l("loyaltylion:remove:points:failed"), k(
        Y.errors?.map((P) => P.message) ?? [
          "Failed to remove points, try again later."
        ]
      ));
    }).catch(() => {
      l("loyaltylion:remove:points:failed"), k(["Failed to remove points, try again later."]);
    });
  }, te = () => {
    I && m(n), f(""), i();
  }, W = () => {
    a(), te();
  };
  return /* @__PURE__ */ Fe.jsxs(
    wt,
    {
      isOpen: e,
      onClose: te,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ Fe.jsx(Ct, { title: "Change points", onClose: te }),
        /* @__PURE__ */ Fe.jsxs(Ft, { className: k5.modalBody, children: [
          /* @__PURE__ */ Fe.jsxs(nt, { children: [
            /* @__PURE__ */ Fe.jsx(Z, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              Wr,
              {
                required: !0,
                label: "New points",
                type: "number",
                placeholder: "Insert new points",
                min: 0,
                max: 1e5,
                meta: {
                  error: K || F,
                  warning: O
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (Y) => m(Y?.target.valueAsNumber ?? 0)
                },
                "data-testid": "points-input"
              }
            ) }),
            /* @__PURE__ */ Fe.jsx(Z, { span: 6, children: /* @__PURE__ */ Fe.jsx(
              Wr,
              {
                label: "Reason",
                placeholder: "Insert an optional reason",
                input: {
                  name: "reason",
                  value: u,
                  onChange: (Y) => f(Y?.target.value ?? "")
                }
              }
            ) })
          ] }),
          !g && D && /* @__PURE__ */ Fe.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ Fe.jsx(Ye, { children: h?.map((Y, P) => /* @__PURE__ */ Fe.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: Y,
              contentLeft: /* @__PURE__ */ Fe.jsx(
                ve,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            P
          )) }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => J(),
            confirmProps: {
              isLoading: g,
              disabled: I || L || n === d,
              loadingIndicator: /* @__PURE__ */ Fe.jsx(fn, { size: 16 })
            },
            cancelOnClick: te
          }
        )
      ]
    }
  );
}, _5 = ({
  label: e,
  points: n,
  setIsModalOpen: r
}) => {
  const i = n > 0 ? "green.500" : "neutral.400", a = n > 0 ? "warning" : "secondary", o = 10;
  return /* @__PURE__ */ Fe.jsx(Ye.Text, { variant: "dense", className: Na.listItem, children: /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { color: i, size: o, name: "star-full" }),
      /* @__PURE__ */ Fe.jsx($.Paragraph, { variant: "4", children: e })
    ] }),
    /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      r && /* @__PURE__ */ Fe.jsx(Xe, { content: "Edit points", children: /* @__PURE__ */ Fe.jsx(
        ve,
        {
          name: "pen",
          size: o,
          "aria-label": "Edit points",
          className: Na.listItemEdit,
          onClick: () => r(!0)
        }
      ) }),
      /* @__PURE__ */ Fe.jsx(Mn, { size: "small", variant: a, children: n })
    ] })
  ] }) });
}, x5 = ({
  customer: e,
  refetchCustomerData: n
}) => {
  const [r, i] = me(!1);
  if (!e)
    return null;
  const {
    merchant_id: a,
    points_approved: o,
    points_pending: s,
    points_spent: l,
    rewards_claimed: d
  } = e, m = [
    {
      id: "pointsApproved",
      label: "Points approved",
      points: o ?? 0,
      setIsModalOpen: i
    },
    {
      id: "pointsPending",
      label: "Points pending",
      points: s ?? 0
    },
    {
      id: "pointsSpent",
      label: "Points spent",
      points: l ?? 0
    },
    {
      id: "rewardClaimed",
      label: "Rewards claimed",
      points: d ?? 0
    }
  ];
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-3", children: "Points balance" }),
    /* @__PURE__ */ Fe.jsx(Ye, { className: Na.list, children: m.map(({ id: u, points: f, label: h, setIsModalOpen: k }) => /* @__PURE__ */ Fe.jsx(
      _5,
      {
        points: f,
        label: h,
        setIsModalOpen: k
      },
      u
    )) }),
    /* @__PURE__ */ Fe.jsx(
      b5,
      {
        isOpen: r,
        points: o,
        merchantId: a,
        onClose: () => i(!1),
        refetchCustomerData: n
      }
    )
  ] });
}, S5 = "_reward_1wxia_1", N5 = {
  reward: S5
}, j5 = ({ reward: e }) => {
  const {
    title: n,
    point_cost: r,
    target_site: i,
    description: a
  } = e, o = i?.name, s = i?.url;
  return /* @__PURE__ */ Fe.jsx(b, { gap: "100", flexDirection: "column", className: N5.reward, children: /* @__PURE__ */ Fe.jsx(Xe, { content: a ?? "No description", children: /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ Fe.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ Fe.jsx(ve, { name: "star", size: 12, color: "neutral.500" }),
        n
      ] }),
      /* @__PURE__ */ Fe.jsxs(Mn, { size: "small", variant: "info", children: [
        r ?? 0,
        " points"
      ] })
    ] }),
    o && s && /* @__PURE__ */ Fe.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { size: 14, name: "external-link" }),
      /* @__PURE__ */ Fe.jsx(
        $.ExternalLink,
        {
          href: s,
          target: "_blank",
          rel: "noreferrer",
          children: o
        }
      )
    ] })
  ] }) }) });
}, w5 = ({ customer: e }) => {
  const { useQuery: n } = hn(), [r, i] = me(), { merchant_id: a } = e, {
    loading: o,
    error: s,
    data: l
  } = n(l5, {
    skip: !a,
    variables: {
      merchantId: a
    }
  });
  if (Qe(() => {
    if (l?.LoyaltyLion) {
      const d = l.LoyaltyLion?.getAvailableRewards?.rewards;
      d && i(d);
    }
  }, [l]), s) {
    const d = s.graphQLErrors;
    return wa({ errors: d }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Na.notificationText,
        children: "No rewards found"
      }
    ) : bw({ errors: d }) ? /* @__PURE__ */ Fe.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        className: Na.notificationText,
        children: "You don't have permissions to view rewards"
      }
    ) : /* @__PURE__ */ Fe.jsx(En, { error: s });
  }
  return /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Fe.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    o ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : /* @__PURE__ */ Fe.jsx(b, { gap: "200", flexDirection: "column", children: r?.map((d) => /* @__PURE__ */ Fe.jsx(j5, { reward: d }, d.id)) })
  ] });
}, C5 = ({ customer: e }) => {
  const { blocked: n, guest: r, insights_segment: i } = e ?? {}, a = n || r || i, o = 14;
  return a ? /* @__PURE__ */ Fe.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
    n && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(
        ve,
        {
          size: o,
          color: "red.500",
          name: "exclamation-triangle-filled"
        }
      ),
      "Blocked"
    ] }) }) }),
    r && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { size: o, color: "green.500", name: "user" }),
      "Guest"
    ] }) }) }),
    i && /* @__PURE__ */ Fe.jsx(b, { alignItems: "start", children: /* @__PURE__ */ Fe.jsx(Xe, { content: "Insights segment", children: /* @__PURE__ */ Fe.jsx(Jn, { children: /* @__PURE__ */ Fe.jsxs(b, { gap: "200", alignItems: "center", children: [
      /* @__PURE__ */ Fe.jsx(ve, { size: o, color: "green.500", name: "team" }),
      i
    ] }) }) }) })
  ] }) : null;
}, F5 = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = Cn(), [a, o] = me(null), { customer: s } = e, {
    showCustomerSummary: l,
    showTags: d,
    showPointsBalance: m,
    showAvailableRewards: u
  } = n, f = !l && !d && !m && !u, {
    loading: h,
    error: k,
    data: C,
    refetch: N
  } = r(s5, {
    skip: !s?.email,
    variables: {
      email: s?.email ?? ""
    }
  });
  return Qe(() => {
    if (C && !h) {
      const j = (C?.LoyaltyLion?.getCustomers).customers;
      j && j.length > 0 && (o(j[0]), i("loyaltylion:customer:received"));
    }
  }, [C, h]), s?.email ? k ? wa({
    errors: k.graphQLErrors
  }) ? /* @__PURE__ */ Fe.jsxs(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      className: Na.notificationText,
      children: [
        "No user found for email: ",
        s?.email
      ]
    }
  ) : /* @__PURE__ */ Fe.jsx(En, { error: k }) : h ? /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Fe.jsx(fn, {}) }) : f ? /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-feature-enabled-message",
      children: "All features toggles in the integration settings are disabled"
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "0 0 300 0",
      "data-testid": "widget-wrapper",
      children: a ? /* @__PURE__ */ Fe.jsxs(Fe.Fragment, { children: [
        l && /* @__PURE__ */ Fe.jsx(p5, { customer: a }),
        d && /* @__PURE__ */ Fe.jsx(C5, { customer: a }),
        m && /* @__PURE__ */ Fe.jsx(
          x5,
          {
            customer: a,
            refetchCustomerData: N
          }
        ),
        u && /* @__PURE__ */ Fe.jsx(w5, { customer: a })
      ] }) : /* @__PURE__ */ Fe.jsx(b, { justifyContent: "center", padding: "200", children: "Nothing found" })
    }
  ) : /* @__PURE__ */ Fe.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "no-email-message",
      children: "We can only search LoyaltyLion with an email and there seems to be no email in this conversation"
    }
  );
}, Il = [
  {
    key: "basicAuthorization",
    label: "LoyaltyLion authorization",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerSummary",
    label: "Show customer summary",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showTags",
    label: "Show tags",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPointsBalance",
    label: "Show points balance",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAvailableRewards",
    label: "Show available rewards",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], lo = rr(Il), sS = "LOYALTYLION", I5 = {
  enabled: !1,
  name: "",
  basicAuthorization: "",
  showCustomerSummary: !0,
  showTags: !0,
  showPointsBalance: !0,
  showAvailableRewards: !0
}, E5 = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: I5
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: sS,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Il,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => hr(K, {
    fieldDefinitions: Il,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ Fe.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Fe.jsx(yr, { cause: h }),
        /* @__PURE__ */ Fe.jsxs(nt, { children: [
          /* @__PURE__ */ Fe.jsx(Z, { children: /* @__PURE__ */ Fe.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(
            hI,
            {
              name: "basicAuthorization",
              label: lo.basicAuthorization,
              control: s.control,
              isCreationMode: o,
              rules: { required: "Please insert a value for both fields" },
              usernameLabel: "Token",
              passwordLabel: "Secret",
              usernamePlaceholder: "Insert your token",
              passwordPlaceholder: "Insert your secret"
            }
          ) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: lo.showCustomerSummary, children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showCustomerSummary",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: lo.showTags, children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showTags",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: lo.showPointsBalance, children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showPointsBalance",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3, children: /* @__PURE__ */ Fe.jsx(We, { label: lo.showAvailableRewards, children: /* @__PURE__ */ Fe.jsx(
            bn,
            {
              name: "showAvailableRewards",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Fe.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ Fe.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Fe.jsx(
          gr,
          {
            integrationType: sS,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._messageContainer_1rxr4_1{padding:var(--dixa-size-spacer-250);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid}._chip_1rxr4_7{color:var(--dixa-typography-color-secondary)}._chipLabel_1rxr4_10{font-weight:var(--dixa-typography-weight-semibold)}._chipValue_1rxr4_13{font-weight:var(--dixa-typography-weight-normal)}._conversation_1draa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._conversation_1draa_1:hover{border-color:var(--dixa-color-neutral-400)}._conversationSubLine_1draa_9{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._modal_1draa_14{width:800px}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Lm = { exports: {} }, co = {}, lS;
function $5() {
  if (lS) return co;
  lS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return co.Fragment = r, co.jsx = s, co.jsxs = s, co;
}
var Cs = {}, cS;
function T5() {
  return cS || (cS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Cs.Fragment = i, Cs.jsx = zn, Cs.jsxs = Wn;
  })()), Cs;
}
var dS;
function O5() {
  return dS || (dS = 1, process.env.NODE_ENV === "production" ? Lm.exports = $5() : Lm.exports = T5()), Lm.exports;
}
var mn = O5();
const R5 = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "conversationsQuery" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Miuros" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "findTickets" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "page_size" }, value: { kind: "IntValue", value: "10" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "labels" } }, { kind: "Field", name: { kind: "Name", value: "subject" } }, { kind: "Field", name: { kind: "Name", value: "messages" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "direction" } }, { kind: "Field", name: { kind: "Name", value: "body" } }, { kind: "Field", name: { kind: "Name", value: "agent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }, { kind: "Field", name: { kind: "Name", value: "custom_fields" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "additionalProperties" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "key" } }, { kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }] } }] } }] } }] } }] }, D5 = {
  "\n  query conversationsQuery($query: String) {\n    Miuros {\n      findTickets(query: $query, page_size: 10) {\n        data {\n          id\n          labels\n          subject\n          messages {\n            direction\n            body\n            agent {\n              email\n              name\n            }\n            created_at\n          }\n          custom_fields {\n            additionalProperties {\n              key\n              value {\n                value\n              }\n            }\n          }\n          created_at\n        }\n      }\n    }\n  }\n": R5
};
function P5(e) {
  return D5[e] ?? {};
}
function uS(e, n) {
  (n == null || n > e.length) && (n = e.length);
  for (var r = 0, i = Array(n); r < n; r++) i[r] = e[r];
  return i;
}
function A5(e) {
  if (Array.isArray(e)) return e;
}
function L5(e, n) {
  var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (r != null) {
    var i, a, o, s, l = [], d = !0, m = !1;
    try {
      if (o = (r = r.call(e)).next, n !== 0) for (; !(d = (i = o.call(r)).done) && (l.push(i.value), l.length !== n); d = !0) ;
    } catch (u) {
      m = !0, a = u;
    } finally {
      try {
        if (!d && r.return != null && (s = r.return(), Object(s) !== s)) return;
      } finally {
        if (m) throw a;
      }
    }
    return l;
  }
}
function V5() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function z5(e, n) {
  return A5(e) || L5(e, n) || U5(e, n) || V5();
}
function U5(e, n) {
  if (e) {
    if (typeof e == "string") return uS(e, n);
    var r = {}.toString.call(e).slice(8, -1);
    return r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set" ? Array.from(e) : r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? uS(e, n) : void 0;
  }
}
const M1 = Object.entries, mS = Object.setPrototypeOf, M5 = Object.isFrozen, B5 = Object.getPrototypeOf, q5 = Object.getOwnPropertyDescriptor;
let At = Object.freeze, Vt = Object.seal, da = Object.create, B1 = typeof Reflect < "u" && Reflect, fy = B1.apply, hy = B1.construct;
At || (At = function(e) {
  return e;
});
Vt || (Vt = function(e) {
  return e;
});
fy || (fy = function(e, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++)
    i[a - 2] = arguments[a];
  return e.apply(n, i);
});
hy || (hy = function(e) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
    r[i - 1] = arguments[i];
  return new e(...r);
});
const uo = xt(Array.prototype.forEach), H5 = xt(Array.prototype.lastIndexOf), pS = xt(Array.prototype.pop), aa = xt(Array.prototype.push), W5 = xt(Array.prototype.splice), fi = Array.isArray, Co = xt(String.prototype.toLowerCase), Vm = xt(String.prototype.toString), fS = xt(String.prototype.match), mo = xt(String.prototype.replace), hS = xt(String.prototype.indexOf), K5 = xt(String.prototype.trim), G5 = xt(Number.prototype.toString), Y5 = xt(Boolean.prototype.toString), yS = typeof BigInt > "u" ? null : xt(BigInt.prototype.toString), gS = typeof Symbol > "u" ? null : xt(Symbol.prototype.toString), It = xt(Object.prototype.hasOwnProperty), po = xt(Object.prototype.toString), Tt = xt(RegExp.prototype.test), Ci = J5(TypeError);
function xt(e) {
  return function(n) {
    n instanceof RegExp && (n.lastIndex = 0);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), a = 1; a < r; a++)
      i[a - 1] = arguments[a];
    return fy(e, n, i);
  };
}
function J5(e) {
  return function() {
    for (var n = arguments.length, r = new Array(n), i = 0; i < n; i++)
      r[i] = arguments[i];
    return hy(e, r);
  };
}
function Hn(e, n) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Co;
  if (mS && mS(e, null), !fi(n))
    return e;
  let i = n.length;
  for (; i--; ) {
    let a = n[i];
    if (typeof a == "string") {
      const o = r(a);
      o !== a && (M5(n) || (n[i] = o), a = o);
    }
    e[a] = !0;
  }
  return e;
}
function Q5(e) {
  for (let n = 0; n < e.length; n++)
    It(e, n) || (e[n] = null);
  return e;
}
function Ht(e) {
  const n = da(null);
  for (const i of M1(e)) {
    var r = z5(i, 2);
    const a = r[0], o = r[1];
    It(e, a) && (fi(o) ? n[a] = Q5(o) : o && typeof o == "object" && o.constructor === Object ? n[a] = Ht(o) : n[a] = o);
  }
  return n;
}
function X5(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return G5(e);
    case "boolean":
      return Y5(e);
    case "bigint":
      return yS ? yS(e) : "0";
    case "symbol":
      return gS ? gS(e) : "Symbol()";
    case "undefined":
      return po(e);
    case "function":
    case "object": {
      if (e === null)
        return po(e);
      const n = e, r = Lr(n, "toString");
      if (typeof r == "function") {
        const i = r(n);
        return typeof i == "string" ? i : po(i);
      }
      return po(e);
    }
    default:
      return po(e);
  }
}
function Lr(e, n) {
  for (; e !== null; ) {
    const i = q5(e, n);
    if (i) {
      if (i.get)
        return xt(i.get);
      if (typeof i.value == "function")
        return xt(i.value);
    }
    e = B5(e);
  }
  function r() {
    return null;
  }
  return r;
}
function Z5(e) {
  try {
    return Tt(e, ""), !0;
  } catch {
    return !1;
  }
}
const vS = At(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "search", "section", "select", "shadow", "slot", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), zm = At(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "enterkeyhint", "exportparts", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "inputmode", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "part", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), Um = At(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), eB = At(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), Mm = At(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), nB = At(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), kS = At(["#text"]), bS = At(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "command", "commandfor", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "exportparts", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inert", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "part", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "slot", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns"]), Bm = At(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "mask-type", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), _S = At(["accent", "accentunder", "align", "bevelled", "close", "columnalign", "columnlines", "columnspacing", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lquote", "lspace", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), Fs = At(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), tB = Vt(/{{[\w\W]*|^[\w\W]*}}/g), rB = Vt(/<%[\w\W]*|^[\w\W]*%>/g), iB = Vt(/\${[\w\W]*/g), aB = Vt(/^data-[\-\w.\u00B7-\uFFFF]+$/), oB = Vt(/^aria-[\-\w]+$/), xS = Vt(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), sB = Vt(/^(?:\w+script|data):/i), lB = Vt(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), cB = Vt(/^html$/i), dB = Vt(/^[a-z][.\w]*(-[.\w]+)+$/i), SS = Vt(/<[/\w!]/g), uB = Vt(/<[/\w]/g), mB = Vt(/<\/no(script|embed|frames)/i), pB = Vt(/\/>/i), Pr = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, fB = function() {
  return typeof window > "u" ? null : window;
}, hB = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(a, {
      createHTML(o) {
        return o;
      },
      createScriptURL(o) {
        return o;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, NS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, ui = function(e, n, r, i) {
  return It(e, n) && fi(e[n]) ? Hn(i.base ? Ht(i.base) : {}, e[n], i.transform) : r;
};
function q1() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fB();
  const n = (H) => q1(H);
  if (n.version = "3.4.11", n.removed = [], !e || !e.document || e.document.nodeType !== Pr.document || !e.Element)
    return n.isSupported = !1, n;
  let r = e.document;
  const i = r, a = i.currentScript;
  e.DocumentFragment;
  const o = e.HTMLTemplateElement, s = e.Node, l = e.Element, d = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const u = e.DOMParser, f = e.trustedTypes, h = l.prototype, k = Lr(h, "cloneNode"), C = Lr(h, "remove"), N = Lr(h, "nextSibling"), j = Lr(h, "childNodes"), _ = Lr(h, "parentNode"), g = Lr(h, "shadowRoot"), D = Lr(h, "attributes"), O = s && s.prototype ? Lr(s.prototype, "nodeType") : null, I = s && s.prototype ? Lr(s.prototype, "nodeName") : null;
  if (typeof o == "function") {
    const H = r.createElement("template");
    H.content && H.content.ownerDocument && (r = H.content.ownerDocument);
  }
  let F, L = "", K, J = !1, te = 0;
  const W = function() {
    if (te > 0)
      throw Ci('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, Y = function(H) {
    W(), te++;
    try {
      return F.createHTML(H);
    } finally {
      te--;
    }
  }, P = function(H) {
    W(), te++;
    try {
      return F.createScriptURL(H);
    } finally {
      te--;
    }
  }, B = function() {
    return J || (K = hB(f, a), J = !0), K;
  }, re = r, je = re.implementation, ue = re.createNodeIterator, se = re.createDocumentFragment, he = re.getElementsByTagName, V = i.importNode;
  let ke = NS();
  n.isSupported = typeof M1 == "function" && typeof _ == "function" && je && je.createHTMLDocument !== void 0;
  const De = tB, q = rB, Ge = iB, sn = aB, Ie = oB, Ue = sB, Re = lB, Be = dB;
  let Ae = xS, Je = null;
  const $e = Hn({}, [...vS, ...zm, ...Um, ...Mm, ...kS]);
  let Me = null;
  const en = Hn({}, [...bS, ...Bm, ..._S, ...Fs]);
  let oe = Object.seal(da(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, xe = null;
  const Ve = Object.seal(da(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Pe = !0, vn = !0, Q = !1, E = !0, z = !1, ie = !0, ce = !1, U = !1, G = null, ye = null, Ne = !1, Oe = !1, rn = !1, kn = !1, an = !0, pn = !1;
  const $n = "user-content-";
  let _n = !0, Fn = !1, Ze = {}, yn = null;
  const Le = Hn({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    // <selectedcontent> mirrors the selected <option>'s subtree, cloned by
    // the UA (customizable <select>) — including any on* handlers — and the
    // engine re-mirrors synchronously whenever a removal changes which
    // option/selectedcontent is current, even inside DOMPurify's inert
    // DOMParser document. Hoisting its children on removal re-inserts a fresh
    // mirror target ahead of the walk, which the engine refills, looping
    // forever (DoS) and amplifying output. Dropping its content on removal
    // (rather than hoisting) breaks that cascade; the content is a duplicate
    // of the option, which is sanitized on its own. See campaign-3 F1/F6.
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let cn = null;
  const dn = Hn({}, ["audio", "video", "img", "source", "image", "track"]);
  let Nn = null;
  const Bn = Hn({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), Sn = "http://www.w3.org/1998/Math/MathML", Dn = "http://www.w3.org/2000/svg", gn = "http://www.w3.org/1999/xhtml";
  let xn = gn, An = !1, Ln = null;
  const wn = Hn({}, [Sn, Dn, gn], Vm), jn = At(["mi", "mo", "mn", "ms", "mtext"]);
  let Vn = Hn({}, jn);
  const qn = At(["annotation-xml"]);
  let zn = Hn({}, qn);
  const Wn = Hn({}, ["title", "style", "font", "a", "script"]);
  let t = null;
  const c = ["application/xhtml+xml", "text/html"], p = "text/html";
  let y = null, w = null;
  const T = r.createElement("form"), S = function(H) {
    return H instanceof RegExp || H instanceof Function;
  }, x = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (w && w === H)
      return;
    (!H || typeof H != "object") && (H = {}), H = Ht(H), t = // eslint-disable-next-line unicorn/prefer-includes
    c.indexOf(H.PARSER_MEDIA_TYPE) === -1 ? p : H.PARSER_MEDIA_TYPE, y = t === "application/xhtml+xml" ? Vm : Co, Je = ui(H, "ALLOWED_TAGS", $e, {
      transform: y
    }), Me = ui(H, "ALLOWED_ATTR", en, {
      transform: y
    }), Ln = ui(H, "ALLOWED_NAMESPACES", wn, {
      transform: Vm
    }), Nn = ui(H, "ADD_URI_SAFE_ATTR", Bn, {
      transform: y,
      base: Bn
    }), cn = ui(H, "ADD_DATA_URI_TAGS", dn, {
      transform: y,
      base: dn
    }), yn = ui(H, "FORBID_CONTENTS", Le, {
      transform: y
    }), le = ui(H, "FORBID_TAGS", Ht({}), {
      transform: y
    }), xe = ui(H, "FORBID_ATTR", Ht({}), {
      transform: y
    }), Ze = It(H, "USE_PROFILES") ? H.USE_PROFILES && typeof H.USE_PROFILES == "object" ? Ht(H.USE_PROFILES) : H.USE_PROFILES : !1, Pe = H.ALLOW_ARIA_ATTR !== !1, vn = H.ALLOW_DATA_ATTR !== !1, Q = H.ALLOW_UNKNOWN_PROTOCOLS || !1, E = H.ALLOW_SELF_CLOSE_IN_ATTR !== !1, z = H.SAFE_FOR_TEMPLATES || !1, ie = H.SAFE_FOR_XML !== !1, ce = H.WHOLE_DOCUMENT || !1, Oe = H.RETURN_DOM || !1, rn = H.RETURN_DOM_FRAGMENT || !1, kn = H.RETURN_TRUSTED_TYPE || !1, Ne = H.FORCE_BODY || !1, an = H.SANITIZE_DOM !== !1, pn = H.SANITIZE_NAMED_PROPS || !1, _n = H.KEEP_CONTENT !== !1, Fn = H.IN_PLACE || !1, Ae = Z5(H.ALLOWED_URI_REGEXP) ? H.ALLOWED_URI_REGEXP : xS, xn = typeof H.NAMESPACE == "string" ? H.NAMESPACE : gn, Vn = It(H, "MATHML_TEXT_INTEGRATION_POINTS") && H.MATHML_TEXT_INTEGRATION_POINTS && typeof H.MATHML_TEXT_INTEGRATION_POINTS == "object" ? Ht(H.MATHML_TEXT_INTEGRATION_POINTS) : Hn({}, jn), zn = It(H, "HTML_INTEGRATION_POINTS") && H.HTML_INTEGRATION_POINTS && typeof H.HTML_INTEGRATION_POINTS == "object" ? Ht(H.HTML_INTEGRATION_POINTS) : Hn({}, qn);
    const Ee = It(H, "CUSTOM_ELEMENT_HANDLING") && H.CUSTOM_ELEMENT_HANDLING && typeof H.CUSTOM_ELEMENT_HANDLING == "object" ? Ht(H.CUSTOM_ELEMENT_HANDLING) : da(null);
    if (oe = da(null), It(Ee, "tagNameCheck") && S(Ee.tagNameCheck) && (oe.tagNameCheck = Ee.tagNameCheck), It(Ee, "attributeNameCheck") && S(Ee.attributeNameCheck) && (oe.attributeNameCheck = Ee.attributeNameCheck), It(Ee, "allowCustomizedBuiltInElements") && typeof Ee.allowCustomizedBuiltInElements == "boolean" && (oe.allowCustomizedBuiltInElements = Ee.allowCustomizedBuiltInElements), Vt(oe), z && (vn = !1), rn && (Oe = !0), Ze && (Je = Hn({}, kS), Me = da(null), Ze.html === !0 && (Hn(Je, vS), Hn(Me, bS)), Ze.svg === !0 && (Hn(Je, zm), Hn(Me, Bm), Hn(Me, Fs)), Ze.svgFilters === !0 && (Hn(Je, Um), Hn(Me, Bm), Hn(Me, Fs)), Ze.mathMl === !0 && (Hn(Je, Mm), Hn(Me, _S), Hn(Me, Fs))), Ve.tagCheck = null, Ve.attributeCheck = null, It(H, "ADD_TAGS") && (typeof H.ADD_TAGS == "function" ? Ve.tagCheck = H.ADD_TAGS : fi(H.ADD_TAGS) && (Je === $e && (Je = Ht(Je)), Hn(Je, H.ADD_TAGS, y))), It(H, "ADD_ATTR") && (typeof H.ADD_ATTR == "function" ? Ve.attributeCheck = H.ADD_ATTR : fi(H.ADD_ATTR) && (Me === en && (Me = Ht(Me)), Hn(Me, H.ADD_ATTR, y))), It(H, "ADD_URI_SAFE_ATTR") && fi(H.ADD_URI_SAFE_ATTR) && Hn(Nn, H.ADD_URI_SAFE_ATTR, y), It(H, "FORBID_CONTENTS") && fi(H.FORBID_CONTENTS) && (yn === Le && (yn = Ht(yn)), Hn(yn, H.FORBID_CONTENTS, y)), It(H, "ADD_FORBID_CONTENTS") && fi(H.ADD_FORBID_CONTENTS) && (yn === Le && (yn = Ht(yn)), Hn(yn, H.ADD_FORBID_CONTENTS, y)), _n && (Je["#text"] = !0), ce && Hn(Je, ["html", "head", "body"]), Je.table && (Hn(Je, ["tbody"]), delete le.tbody), H.TRUSTED_TYPES_POLICY) {
      if (typeof H.TRUSTED_TYPES_POLICY.createHTML != "function")
        throw Ci('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof H.TRUSTED_TYPES_POLICY.createScriptURL != "function")
        throw Ci('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const He = F;
      F = H.TRUSTED_TYPES_POLICY;
      try {
        L = Y("");
      } catch (ln) {
        throw F = He, ln;
      }
    } else H.TRUSTED_TYPES_POLICY === null ? (F = void 0, L = "") : (F === void 0 && (F = B()), F && typeof L == "string" && (L = Y("")));
    At && At(H), w = H;
  }, X = Hn({}, [...zm, ...Um, ...eB]), A = Hn({}, [...Mm, ...nB]), M = function(H, Ee, He) {
    return Ee.namespaceURI === gn ? H === "svg" : Ee.namespaceURI === Sn ? H === "svg" && (He === "annotation-xml" || Vn[He]) : !!X[H];
  }, de = function(H, Ee, He) {
    return Ee.namespaceURI === gn ? H === "math" : Ee.namespaceURI === Dn ? H === "math" && zn[He] : !!A[H];
  }, ze = function(H, Ee, He) {
    return Ee.namespaceURI === Dn && !zn[He] || Ee.namespaceURI === Sn && !Vn[He] ? !1 : !A[H] && (Wn[H] || !X[H]);
  }, Te = function(H) {
    let Ee = _(H);
    (!Ee || !Ee.tagName) && (Ee = {
      namespaceURI: xn,
      tagName: "template"
    });
    const He = Co(H.tagName), ln = Co(Ee.tagName);
    return Ln[H.namespaceURI] ? H.namespaceURI === Dn ? M(He, Ee, ln) : H.namespaceURI === Sn ? de(He, Ee, ln) : H.namespaceURI === gn ? ze(He, Ee, ln) : !!(t === "application/xhtml+xml" && Ln[H.namespaceURI]) : !1;
  }, ne = function(H) {
    aa(n.removed, {
      element: H
    });
    try {
      _(H).removeChild(H);
    } catch {
      if (C(H), !_(H))
        throw Ci("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, un = function(H) {
    const Ee = j(H);
    if (Ee) {
      const ln = [];
      uo(Ee, (Rn) => {
        aa(ln, Rn);
      }), uo(ln, (Rn) => {
        try {
          C(Rn);
        } catch {
        }
      });
    }
    const He = D(H);
    if (He)
      for (let ln = He.length - 1; ln >= 0; --ln) {
        const Rn = He[ln], et = Rn && Rn.name;
        if (typeof et == "string")
          try {
            H.removeAttribute(et);
          } catch {
          }
      }
  }, On = function(H, Ee) {
    try {
      aa(n.removed, {
        attribute: Ee.getAttributeNode(H),
        from: Ee
      });
    } catch {
      aa(n.removed, {
        attribute: null,
        from: Ee
      });
    }
    if (Ee.removeAttribute(H), H === "is")
      if (Oe || rn)
        try {
          ne(Ee);
        } catch {
        }
      else
        try {
          Ee.setAttribute(H, "");
        } catch {
        }
  }, Kn = function(H) {
    const Ee = D(H);
    if (Ee)
      for (let He = Ee.length - 1; He >= 0; --He) {
        const ln = Ee[He], Rn = ln && ln.name;
        if (!(typeof Rn != "string" || Me[y(Rn)]))
          try {
            H.removeAttribute(Rn);
          } catch {
          }
      }
  }, QF = function(H) {
    const Ee = [H];
    for (; Ee.length > 0; ) {
      const He = Ee.pop();
      (O ? O(He) : He.nodeType) === Pr.element && Kn(He);
      const ln = j(He);
      if (ln)
        for (let Rn = ln.length - 1; Rn >= 0; --Rn)
          Ee.push(ln[Rn]);
    }
  }, nv = function(H) {
    let Ee = null, He = null;
    if (Ne)
      H = "<remove></remove>" + H;
    else {
      const et = fS(H, /^[\r\n\t ]+/);
      He = et && et[0];
    }
    t === "application/xhtml+xml" && xn === gn && (H = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + H + "</body></html>");
    const ln = F ? Y(H) : H;
    if (xn === gn)
      try {
        Ee = new u().parseFromString(ln, t);
      } catch {
      }
    if (!Ee || !Ee.documentElement) {
      Ee = je.createDocument(xn, "template", null);
      try {
        Ee.documentElement.innerHTML = An ? L : ln;
      } catch {
      }
    }
    const Rn = Ee.body || Ee.documentElement;
    return H && He && Rn.insertBefore(r.createTextNode(He), Rn.childNodes[0] || null), xn === gn ? he.call(Ee, ce ? "html" : "body")[0] : ce ? Ee.documentElement : Rn;
  }, tv = function(H) {
    return ue.call(
      H.ownerDocument || H,
      H,
      // eslint-disable-next-line no-bitwise
      d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT | d.SHOW_PROCESSING_INSTRUCTION | d.SHOW_CDATA_SECTION,
      null
    );
  }, os = function(H) {
    return H = mo(H, De, " "), H = mo(H, q, " "), H = mo(H, Ge, " "), H;
  }, gc = function(H) {
    var Ee;
    H.normalize();
    const He = ue.call(
      H.ownerDocument || H,
      H,
      // eslint-disable-next-line no-bitwise
      d.SHOW_TEXT | d.SHOW_COMMENT | d.SHOW_CDATA_SECTION | d.SHOW_PROCESSING_INSTRUCTION,
      null
    );
    let ln = He.nextNode();
    for (; ln; )
      ln.data = os(ln.data), ln = He.nextNode();
    const Rn = (Ee = H.querySelectorAll) === null || Ee === void 0 ? void 0 : Ee.call(H, "template");
    Rn && uo(Rn, (et) => {
      Qi(et.content) && gc(et.content);
    });
  }, ss = function(H) {
    const Ee = I ? I(H) : null;
    return typeof Ee != "string" || y(Ee) !== "form" ? !1 : typeof H.nodeName != "string" || typeof H.textContent != "string" || typeof H.removeChild != "function" || // Realm-safe NamedNodeMap detection: equality against the cached
    // prototype getter. Clobbered .attributes (e.g. <input name="attributes">)
    // makes the direct read diverge from the cached read; a clean form
    // (same-realm OR foreign-realm) has both reads pointing at the same
    // canonical NamedNodeMap.
    H.attributes !== D(H) || typeof H.removeAttribute != "function" || typeof H.setAttribute != "function" || typeof H.namespaceURI != "string" || typeof H.insertBefore != "function" || typeof H.hasChildNodes != "function" || // NodeType clobbering probe. Cached Node.prototype.nodeType getter
    // returns the integer 1 for any Element regardless of realm; direct
    // read on a clobbered form (e.g. <input name="nodeType">) returns
    // the named child element. Cheap addition — nodeType is read from
    // an internal slot, no serialization cost — and removes a residual
    // clobbering surface used by several mXSS / PI / comment branches
    // in _sanitizeElements that compare currentNode.nodeType directly.
    H.nodeType !== O(H) || // HTMLFormElement has [LegacyOverrideBuiltIns]: a descendant named
    // "childNodes" shadows the prototype getter. Direct reads of
    // form.childNodes from a clobbered form return the named child
    // instead of the real NodeList, so any walk that reads it directly
    // skips the form's real children. Compare the direct read to the
    // cached Node.prototype getter — when the form's named-property
    // getter intercepts the read, the two values differ and we flag
    // the form. This catches every clobbering child type (input,
    // select, etc.) regardless of whether the named child happens to
    // carry a numeric .length, which a typeof-based probe would miss
    // (e.g. HTMLSelectElement.length is a defined unsigned-long).
    H.childNodes !== j(H);
  }, Qi = function(H) {
    if (!O || typeof H != "object" || H === null)
      return !1;
    try {
      return O(H) === Pr.documentFragment;
    } catch {
      return !1;
    }
  }, Va = function(H) {
    if (!O || typeof H != "object" || H === null)
      return !1;
    try {
      return typeof O(H) == "number";
    } catch {
      return !1;
    }
  };
  function Qr(H, Ee, He) {
    H.length !== 0 && uo(H, (ln) => {
      ln.call(n, Ee, He, w);
    });
  }
  const XF = function(H, Ee) {
    return !!(ie && H.hasChildNodes() && !Va(H.firstElementChild) && Tt(SS, H.textContent) && Tt(SS, H.innerHTML) || ie && H.namespaceURI === gn && Ee === "style" && Va(H.firstElementChild) || H.nodeType === Pr.processingInstruction || ie && H.nodeType === Pr.comment && Tt(uB, H.data));
  }, ZF = function(H, Ee) {
    if (!le[Ee] && av(Ee) && (oe.tagNameCheck instanceof RegExp && Tt(oe.tagNameCheck, Ee) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(Ee)))
      return !1;
    if (_n && !yn[Ee]) {
      const He = _(H), ln = j(H);
      if (ln && He) {
        const Rn = ln.length;
        for (let et = Rn - 1; et >= 0; --et) {
          const tt = Fn ? ln[et] : k(ln[et], !0);
          He.insertBefore(tt, N(H));
        }
      }
    }
    return ne(H), !0;
  }, rv = function(H) {
    if (Qr(ke.beforeSanitizeElements, H, null), ss(H))
      return ne(H), !0;
    const Ee = y(I ? I(H) : H.nodeName);
    if (Qr(ke.uponSanitizeElement, H, {
      tagName: Ee,
      allowedTags: Je
    }), XF(H, Ee))
      return ne(H), !0;
    if (le[Ee] || !(Ve.tagCheck instanceof Function && Ve.tagCheck(Ee)) && !Je[Ee])
      return ZF(H, Ee);
    if ((O ? O(H) : H.nodeType) === Pr.element && !Te(H) || (Ee === "noscript" || Ee === "noembed" || Ee === "noframes") && Tt(mB, H.innerHTML))
      return ne(H), !0;
    if (z && H.nodeType === Pr.text) {
      const He = os(H.textContent);
      H.textContent !== He && (aa(n.removed, {
        element: H.cloneNode()
      }), H.textContent = He);
    }
    return Qr(ke.afterSanitizeElements, H, null), !1;
  }, iv = function(H, Ee, He) {
    if (xe[Ee] || an && (Ee === "id" || Ee === "name") && (He in r || He in T))
      return !1;
    const ln = Me[Ee] || Ve.attributeCheck instanceof Function && Ve.attributeCheck(Ee, H);
    if (!(vn && Tt(sn, Ee)) && !(Pe && Tt(Ie, Ee))) {
      if (ln) {
        if (!Nn[Ee] && !Tt(Ae, mo(He, Re, "")) && !((Ee === "src" || Ee === "xlink:href" || Ee === "href") && H !== "script" && hS(He, "data:") === 0 && cn[H]) && !(Q && !Tt(Ue, mo(He, Re, ""))) && He)
          return !1;
      } else if (
        // First condition does a very basic check if a) it's basically a valid custom element tagname AND
        // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
        !(av(H) && (oe.tagNameCheck instanceof RegExp && Tt(oe.tagNameCheck, H) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(H)) && (oe.attributeNameCheck instanceof RegExp && Tt(oe.attributeNameCheck, Ee) || oe.attributeNameCheck instanceof Function && oe.attributeNameCheck(Ee, H)) || // Alternative, second condition checks if it's an `is`-attribute, AND
        // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
        Ee === "is" && oe.allowCustomizedBuiltInElements && (oe.tagNameCheck instanceof RegExp && Tt(oe.tagNameCheck, He) || oe.tagNameCheck instanceof Function && oe.tagNameCheck(He)))
      ) return !1;
    }
    return !0;
  }, eI = Hn({}, ["annotation-xml", "color-profile", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "missing-glyph"]), av = function(H) {
    return !eI[Co(H)] && Tt(Be, H);
  }, nI = function(H, Ee, He, ln) {
    if (F && typeof f == "object" && typeof f.getAttributeType == "function" && !He)
      switch (f.getAttributeType(H, Ee)) {
        case "TrustedHTML":
          return Y(ln);
        case "TrustedScriptURL":
          return P(ln);
      }
    return ln;
  }, tI = function(H, Ee, He, ln) {
    try {
      He ? H.setAttributeNS(He, Ee, ln) : H.setAttribute(Ee, ln), ss(H) ? ne(H) : pS(n.removed);
    } catch {
      On(Ee, H);
    }
  }, ov = function(H) {
    Qr(ke.beforeSanitizeAttributes, H, null);
    const Ee = H.attributes;
    if (!Ee || ss(H))
      return;
    const He = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: Me,
      forceKeepAttr: void 0
    };
    let ln = Ee.length;
    const Rn = y(H.nodeName);
    for (; ln--; ) {
      const et = Ee[ln], tt = et.name, xi = et.namespaceURI, si = et.value, Qt = y(tt), li = si;
      let qt = tt === "value" ? li : K5(li);
      if (He.attrName = Qt, He.attrValue = qt, He.keepAttr = !0, He.forceKeepAttr = void 0, Qr(ke.uponSanitizeAttribute, H, He), qt = He.attrValue, pn && (Qt === "id" || Qt === "name") && hS(qt, $n) !== 0 && (On(tt, H), qt = $n + qt), ie && Tt(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, qt)) {
        On(tt, H);
        continue;
      }
      if (Qt === "attributename" && fS(qt, "href")) {
        On(tt, H);
        continue;
      }
      if (!He.forceKeepAttr) {
        if (!He.keepAttr) {
          On(tt, H);
          continue;
        }
        if (!E && Tt(pB, qt)) {
          On(tt, H);
          continue;
        }
        if (z && (qt = os(qt)), !iv(Rn, Qt, qt)) {
          On(tt, H);
          continue;
        }
        qt = nI(Rn, Qt, xi, qt), qt !== li && tI(H, tt, xi, qt);
      }
    }
    Qr(ke.afterSanitizeAttributes, H, null);
  }, ls = function(H) {
    let Ee = null;
    const He = tv(H);
    for (Qr(ke.beforeSanitizeShadowDOM, H, null); Ee = He.nextNode(); )
      if (Qr(ke.uponSanitizeShadowNode, Ee, null), rv(Ee), ov(Ee), Qi(Ee.content) && ls(Ee.content), (O ? O(Ee) : Ee.nodeType) === Pr.element) {
        const ln = g(Ee);
        Qi(ln) && (vc(ln), ls(ln));
      }
    Qr(ke.afterSanitizeShadowDOM, H, null);
  }, vc = function(H) {
    const Ee = [{
      node: H,
      shadow: null
    }];
    for (; Ee.length > 0; ) {
      const He = Ee.pop();
      if (He.shadow) {
        ls(He.shadow);
        continue;
      }
      const ln = He.node, Rn = (O ? O(ln) : ln.nodeType) === Pr.element, et = j(ln);
      if (et)
        for (let tt = et.length - 1; tt >= 0; --tt)
          Ee.push({
            node: et[tt],
            shadow: null
          });
      if (Rn) {
        const tt = I ? I(ln) : null;
        if (typeof tt == "string" && y(tt) === "template") {
          const xi = ln.content;
          Qi(xi) && Ee.push({
            node: xi,
            shadow: null
          });
        }
      }
      if (Rn) {
        const tt = g(ln);
        Qi(tt) && Ee.push({
          node: null,
          shadow: tt
        }, {
          node: tt,
          shadow: null
        });
      }
    }
  };
  return n.sanitize = function(H) {
    let Ee = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, He = null, ln = null, Rn = null, et = null;
    if (An = !H, An && (H = "<!-->"), typeof H != "string" && !Va(H) && (H = X5(H), typeof H != "string"))
      throw Ci("dirty is not a string, aborting");
    if (!n.isSupported)
      return H;
    U ? (Je = G, Me = ye) : x(Ee), (ke.uponSanitizeElement.length > 0 || ke.uponSanitizeAttribute.length > 0) && (Je = Ht(Je)), ke.uponSanitizeAttribute.length > 0 && (Me = Ht(Me)), n.removed = [];
    const tt = Fn && typeof H != "string" && Va(H);
    if (tt) {
      const Qt = I ? I(H) : H.nodeName;
      if (typeof Qt == "string") {
        const li = y(Qt);
        if (!Je[li] || le[li])
          throw Ci("root node is forbidden and cannot be sanitized in-place");
      }
      if (ss(H))
        throw Ci("root node is clobbered and cannot be sanitized in-place");
      try {
        vc(H);
      } catch (li) {
        throw un(H), li;
      }
    } else if (Va(H))
      He = nv("<!---->"), ln = He.ownerDocument.importNode(H, !0), ln.nodeType === Pr.element && ln.nodeName === "BODY" || ln.nodeName === "HTML" ? He = ln : He.appendChild(ln), vc(ln);
    else {
      if (!Oe && !z && !ce && // eslint-disable-next-line unicorn/prefer-includes
      H.indexOf("<") === -1)
        return F && kn ? Y(H) : H;
      if (He = nv(H), !He)
        return Oe ? null : kn ? L : "";
    }
    He && Ne && ne(He.firstChild);
    const xi = tv(tt ? H : He);
    try {
      for (; Rn = xi.nextNode(); )
        rv(Rn), ov(Rn), Qi(Rn.content) && ls(Rn.content);
    } catch (Qt) {
      throw tt && un(H), Qt;
    }
    if (tt)
      return uo(n.removed, (Qt) => {
        Qt.element && QF(Qt.element);
      }), z && gc(H), H;
    if (Oe) {
      if (z && gc(He), rn)
        for (et = se.call(He.ownerDocument); He.firstChild; )
          et.appendChild(He.firstChild);
      else
        et = He;
      return (Me.shadowroot || Me.shadowrootmode) && (et = V.call(i, et, !0)), et;
    }
    let si = ce ? He.outerHTML : He.innerHTML;
    return ce && Je["!doctype"] && He.ownerDocument && He.ownerDocument.doctype && He.ownerDocument.doctype.name && Tt(cB, He.ownerDocument.doctype.name) && (si = "<!DOCTYPE " + He.ownerDocument.doctype.name + `>
` + si), z && (si = os(si)), F && kn ? Y(si) : si;
  }, n.setConfig = function() {
    let H = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    x(H), U = !0, G = Je, ye = Me;
  }, n.clearConfig = function() {
    w = null, U = !1, G = null, ye = null, F = K, L = "";
  }, n.isValidAttribute = function(H, Ee, He) {
    w || x({});
    const ln = y(H), Rn = y(Ee);
    return iv(ln, Rn, He);
  }, n.addHook = function(H, Ee) {
    typeof Ee == "function" && It(ke, H) && aa(ke[H], Ee);
  }, n.removeHook = function(H, Ee) {
    if (It(ke, H)) {
      if (Ee !== void 0) {
        const He = H5(ke[H], Ee);
        return He === -1 ? void 0 : W5(ke[H], He, 1)[0];
      }
      return pS(ke[H]);
    }
  }, n.removeHooks = function(H) {
    It(ke, H) && (ke[H] = []);
  }, n.removeAllHooks = function() {
    ke = NS();
  }, n;
}
var yB = q1();
const gB = "_messageContainer_1rxr4_1", vB = "_chip_1rxr4_7", kB = "_chipLabel_1rxr4_10", bB = "_chipValue_1rxr4_13", Is = {
  messageContainer: gB,
  chip: vB,
  chipLabel: kB,
  chipValue: bB
}, jS = {
  INBOUND: {
    background: "var(--dixa-color-neutral-000)",
    borderColor: "var(--dixa-color-neutral-100)"
  },
  OUTBOUND: {
    background: "var(--dixa-color-neutral-100)",
    borderColor: "var(--dixa-color-neutral-200)"
  },
  INTERNAL: {
    background: "var(--dixa-color-orange-100)",
    borderColor: "var(--dixa-color-orange-200)"
  }
}, _B = ({
  messages: e,
  customFields: n,
  attachments: r,
  conversationContext: i
}) => {
  Qe(() => {
    document.getElementById("endOfConversationAnchor") && document.getElementById("endOfConversationAnchor")?.scrollIntoView({ behavior: "smooth" });
  }, [e]);
  const a = () => {
    const o = "Contact";
    if (!i?.customer)
      return o;
    const {
      name: s,
      given_name: l,
      family_name: d,
      email: m,
      phone_number: u
    } = i.customer;
    return s ?? l ?? d ?? m ?? u ?? o;
  };
  return /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "200", children: [
    /* @__PURE__ */ mn.jsx(b, { flexDirection: "row", flexWrap: "wrap", margin: "0 0 300", children: !!n?.length && /* @__PURE__ */ mn.jsxs(b, { gap: "100", children: [
      /* @__PURE__ */ mn.jsx(Xe, { content: "Conversation Attributes", children: /* @__PURE__ */ mn.jsx(
        Fy,
        {
          icon: "input",
          color: {
            contentColor: "var(--dixa-color-neutral-700)",
            backgroundColor: "var(--dixa-color-neutral-200)"
          }
        }
      ) }),
      n.map((o, s) => /* @__PURE__ */ mn.jsx(b, { alignItems: "center", children: /* @__PURE__ */ mn.jsx(Jn, { className: Is.chip, children: /* @__PURE__ */ mn.jsxs(b, { gap: "100", children: [
        /* @__PURE__ */ mn.jsxs(st, { className: Is.chipLabel, children: [
          o.name,
          ":"
        ] }),
        /* @__PURE__ */ mn.jsx(st, { className: Is.chipValue, children: o.value })
      ] }) }) }, `${s}-${o.name}`))
    ] }) }),
    e?.map((o) => /* @__PURE__ */ mn.jsx(
      b,
      {
        className: Is.messageContainer,
        gap: "200",
        style: {
          backgroundColor: o?.direction ? jS[o.direction].background : "var(--dixa-color-neutral-000)",
          borderColor: o?.direction ? jS[o.direction].borderColor : "var(--dixa-color-neutral-100)"
        },
        children: /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
          /* @__PURE__ */ mn.jsxs(b, { flexDirection: "row", justifyContent: "space-between", children: [
            /* @__PURE__ */ mn.jsx($.Heading, { variant: "heading-3", children: o?.direction == "INBOUND" ? a() : o?.agent?.name }),
            /* @__PURE__ */ mn.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ mn.jsx(wI, { relative: !0, time: o?.created_at }) })
          ] }),
          /* @__PURE__ */ mn.jsx(
            "div",
            {
              dangerouslySetInnerHTML: {
                __html: yB.sanitize(
                  o?.body?.replaceAll(/\r\n?|\n/g, "<br />") || ""
                )
              }
            }
          )
        ] })
      },
      o?.created_at
    )),
    r && /* @__PURE__ */ mn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", margin: "300 0 0", children: r.map((o, s) => /* @__PURE__ */ mn.jsx(
      CI,
      {
        fileName: o.url,
        label: o.label,
        onDownload: () => {
          window.open(o.url, "_blank")?.focus();
        }
      },
      `${s}-${o.url}`
    )) }),
    /* @__PURE__ */ mn.jsx("div", { id: "endOfConversationAnchor", children: " " })
  ] });
}, xB = "_conversation_1draa_1", SB = "_conversationSubLine_1draa_9", NB = "_modal_1draa_14", qm = {
  conversation: xB,
  conversationSubLine: SB,
  modal: NB
}, jB = (e) => (e && JSON.parse(e) || []).map((n) => ({
  url: n.URL__c,
  label: n.Name,
  type: n.File_Type__c
})), wB = (e) => Object.entries(e || {}).filter(([n]) => n.endsWith("__c")).map(([n, r]) => ({
  name: n.replace("__c", "").replaceAll("_", " "),
  // transform key into readable name
  value: r?.value ? r.value.toString() : ""
})), CB = ({
  conversation: e,
  conversationContext: n
}) => {
  const [r, i] = me(!1), a = e?.created_at, o = e?.custom_fields, s = o && "attachments" in o;
  return /* @__PURE__ */ mn.jsxs(b, { className: qm.conversation, gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ mn.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ mn.jsxs(b, { flexDirection: "row", gap: "100", children: [
          /* @__PURE__ */ mn.jsx($.Heading, { variant: "heading-4", children: e?.id }),
          a && /* @__PURE__ */ mn.jsx(Mn, { size: "small", variant: "info", children: Gn(e?.created_at).format("DD MMM YYYY @ HH:mm") })
        ] }),
        /* @__PURE__ */ mn.jsx(
          $.Heading,
          {
            variant: "heading-4",
            className: qm.conversationSubLine,
            children: e?.subject
          }
        ),
        !!e?.labels?.length && /* @__PURE__ */ mn.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [...new Set(e.labels)].map((l) => /* @__PURE__ */ mn.jsx(Jn, { children: l }, `${e.id}-${l}`)) })
      ] }),
      /* @__PURE__ */ mn.jsx(Xe, { content: "Show conversation preview", children: /* @__PURE__ */ mn.jsx(
        ir,
        {
          variant: "secondary",
          icon: "eye",
          onClick: () => i(!0),
          "data-testid": "open-messages-preview"
        }
      ) })
    ] }),
    /* @__PURE__ */ mn.jsxs(
      wt,
      {
        isOpen: r,
        allowEscClose: !0,
        onClose: () => i(!1),
        className: qm.modal,
        children: [
          /* @__PURE__ */ mn.jsx(
            Ct,
            {
              title: "Conversation preview",
              onClose: () => i(!1)
            }
          ),
          /* @__PURE__ */ mn.jsx(Ft, { children: /* @__PURE__ */ mn.jsx(
            _B,
            {
              messages: e?.messages || [],
              ...s && {
                attachments: jB(
                  o?.attachments?.value
                )
              },
              conversationContext: n,
              customFields: wB(
                e?.custom_fields
              )
            }
          ) })
        ]
      }
    )
  ] });
}, FB = ({
  conversations: e,
  conversationContext: n,
  conversationsToShow: r
}) => {
  const [i, a] = me(!1), o = r > 0 ? r : 1, s = e?.length > o, l = Xn(
    () => e?.sort((d, m) => m?.created_at.localeCompare(d?.created_at)).slice(
      0,
      i ? e.length : o
    ),
    [e, i, o]
  );
  return /* @__PURE__ */ mn.jsxs(b, { flexDirection: "column", gap: "200", margin: "200 0 300 0", children: [
    l.map((d, m) => /* @__PURE__ */ mn.jsx(
      CB,
      {
        conversation: d,
        conversationContext: n
      },
      `${m}-${d?.id}`
    )),
    s && /* @__PURE__ */ mn.jsxs(
      ct,
      {
        variant: "secondary",
        onClick: () => a(!i),
        children: [
          "Show ",
          i ? "less" : "all"
        ]
      }
    )
  ] });
}, IB = P5(
  /* GraphQL*/
  `
  query conversationsQuery($query: String) {
    Miuros {
      findTickets(query: $query, page_size: 10) {
        data {
          id
          labels
          subject
          messages {
            direction
            body
            agent {
              email
              name
            }
            created_at
          }
          custom_fields {
            additionalProperties {
              key
              value {
                value
              }
            }
          }
          created_at
        }
      }
    }
  }
`
), EB = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me([]), a = Number.parseInt(n?.amountOfConversationsToShow) || 1, o = [
    e.customer?.email,
    e.customer?.phone_number
  ].filter((u) => !!u).map((u) => `'${u}'`).join(","), { useQuery: s } = hn(), { data: l, loading: d, error: m } = s(IB, {
    skip: o.length === 0,
    variables: {
      query: `requester_id=in=(${o})`
    }
  });
  return Qe(() => {
    if (l?.Miuros) {
      const u = l?.Miuros?.findTickets?.data;
      u && i(u);
    }
  }, [l]), m ? /* @__PURE__ */ mn.jsx(En, { error: m }) : d ? /* @__PURE__ */ mn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ mn.jsx(fn, {}) }) : r?.length === 0 ? /* @__PURE__ */ mn.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: "No conversations found for this customer" }) : /* @__PURE__ */ mn.jsx(
    FB,
    {
      "data-testid": "conversation-list",
      conversationsToShow: a,
      conversations: r,
      conversationContext: e
    }
  );
}, El = [
  {
    key: "miurosClientId",
    label: "Authorization: Client ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "miurosClientSecret",
    label: "Authorization: Client secret",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "amountOfConversationsToShow",
    label: "Number of conversation to show before the fold",
    type: "string",
    secret: !1,
    defaultValue: "1"
  }
], Hm = rr(El), Wm = "MIUROS", $B = {
  enabled: !1,
  name: "",
  miurosClientId: "",
  miurosClientSecret: "",
  amountOfConversationsToShow: "1"
}, TB = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: $B
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = ur({
    integrationId: e,
    integrationType: Wm,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: El,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = (J) => hr(J, {
    fieldDefinitions: El,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), K = l.watch("name");
  return /* @__PURE__ */ mn.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: L,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ mn.jsx(yr, { cause: k }),
        /* @__PURE__ */ mn.jsxs(nt, { children: [
          /* @__PURE__ */ mn.jsx(Z, { children: /* @__PURE__ */ mn.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ mn.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Pn,
            {
              name: "miurosClientId",
              label: Hm.miurosClientId,
              control: l.control,
              rules: { required: "Client ID is required" },
              componentProps: {
                placeholder: "Insert client ID",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Er,
            {
              name: "miurosClientSecret",
              label: Hm.miurosClientSecret,
              control: l.control,
              isCreationMode: s,
              rules: { required: "Client secret is required" },
              componentProps: {
                placeholder: "Insert client secret",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3, children: /* @__PURE__ */ mn.jsx(
            Pn,
            {
              name: "amountOfConversationsToShow",
              label: Hm.amountOfConversationsToShow,
              control: l.control,
              rules: {
                required: "Please enter a number",
                validate: (J) => !Number.isNaN(Number.parseInt(J, 10)) || "Please enter a number"
              },
              componentProps: {
                placeholder: "Enter number",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ mn.jsx(Z, { span: 3 }),
          !s && e && /* @__PURE__ */ mn.jsx(
            gi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Wm,
              label: "Authorize"
            }
          ),
          o && O !== null && /* @__PURE__ */ mn.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ mn.jsx(
          gr,
          {
            integrationType: Wm,
            integrationId: e,
            widgetName: K,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._list_2c4dq_1{padding:0}._listItem_2c4dq_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_2c4dq_4:last-child{border-bottom:none}._copyIcon_2c4dq_12{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1nher_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._order_1dlaa_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_1dlaa_1:hover,._orderIsOpen_1dlaa_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_1dlaa_12{cursor:pointer}._note_1dlaa_16{border:var(--dixa-size-border-100) dashed var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-200);max-height:100px;overflow-y:auto}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Km = { exports: {} }, fo = {}, wS;
function OB() {
  if (wS) return fo;
  wS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return fo.Fragment = r, fo.jsx = s, fo.jsxs = s, fo;
}
var Es = {}, CS;
function RB() {
  return CS || (CS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Es.Fragment = i, Es.jsx = zn, Es.jsxs = Wn;
  })()), Es;
}
var FS;
function DB() {
  return FS || (FS = 1, process.env.NODE_ENV === "production" ? Km.exports = OB() : Km.exports = RB()), Km.exports;
}
var Ce = DB();
const PB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getAddresses" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getAddresses" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Addresses" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "addresses" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "payment_method_id" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "customer_id" } }, { kind: "Field", name: { kind: "Name", value: "discounts" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "value_type" } }] } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "order_attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "value" } }] } }, { kind: "Field", name: { kind: "Name", value: "order_note" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "presentment_currency" } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_conserved" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_lines_override" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "price" } }] } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] }, AB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getStore" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Store" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "store" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }, { kind: "Field", name: { kind: "Name", value: "customer_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "merchant_portal_base_url" } }, { kind: "Field", name: { kind: "Name", value: "identifier" } }, { kind: "Field", name: { kind: "Name", value: "checkout_platform" } }, { kind: "Field", name: { kind: "Name", value: "external_platform" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "updated_at" } }, { kind: "Field", name: { kind: "Name", value: "external_customer_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ecommerce" } }] } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_active_count" } }, { kind: "Field", name: { kind: "Name", value: "subscriptions_total_count" } }, { kind: "Field", name: { kind: "Name", value: "has_valid_payment_method" } }, { kind: "Field", name: { kind: "Name", value: "hash" } }] } }] } }] } }] } }] } }] }, LB = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "addressId" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Recharge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getOrders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "address_id" }, value: { kind: "Variable", name: { kind: "Name", value: "addressId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Recharge_Orders" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "created_at" } }, { kind: "Field", name: { kind: "Name", value: "currency" } }, { kind: "Field", name: { kind: "Name", value: "is_prepaid" } }, { kind: "Field", name: { kind: "Name", value: "note" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "subtotal_price" } }, { kind: "Field", name: { kind: "Name", value: "total_discounts" } }, { kind: "Field", name: { kind: "Name", value: "total_duties" } }, { kind: "Field", name: { kind: "Name", value: "total_line_items_price" } }, { kind: "Field", name: { kind: "Name", value: "total_price" } }, { kind: "Field", name: { kind: "Name", value: "total_refunds" } }, { kind: "Field", name: { kind: "Name", value: "total_tax" } }, { kind: "Field", name: { kind: "Name", value: "total_weight_grams" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "charge" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_transaction_id" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "payment_processor" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billing_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping_address" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "country_code" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }] } }] } }] } }] } }] }, VB = {
  "\n  query getAddresses($customerId: String) {\n    Recharge {\n      getAddresses(customer_id: $customerId) {\n        ... on Recharge_Addresses {\n          addresses {\n            id\n            payment_method_id\n            address1\n            address2\n            city\n            company\n            country_code\n            created_at\n            customer_id\n            discounts {\n              id\n              code\n              value\n              value_type\n            }\n            first_name\n            last_name\n            order_attributes {\n              name\n              value\n            }\n            order_note\n            phone\n            presentment_currency\n            shipping_lines_conserved {\n              code\n              title\n              price\n            }\n            shipping_lines_override {\n              code\n              title\n              price\n            }\n            updated_at\n            zip\n          }\n        }\n      }\n    }\n  }\n": PB,
  "\n  query getCustomerDetails($email: String) {\n    Recharge {\n      getStore {\n        ... on Recharge_Store {\n          store {\n            id\n            name\n            external_platform\n            customer_portal_base_url\n            merchant_portal_base_url\n            identifier\n            checkout_platform\n            external_platform\n          }\n        }\n      }\n      getCustomers(email: $email) {\n        ... on Recharge_Customers {\n          customers {\n            id\n            email\n            phone\n            first_name\n            last_name\n            created_at\n            updated_at\n            external_customer_id {\n              ecommerce\n            }\n            subscriptions_active_count\n            subscriptions_total_count\n            has_valid_payment_method\n            hash\n          }\n        }\n      }\n    }\n  }\n": AB,
  "\n  query getOrders($customerId: String, $limit: String, $addressId: String) {\n    Recharge {\n      getOrders(\n        customer_id: $customerId\n        limit: $limit\n        address_id: $addressId\n      ) {\n        ... on Recharge_Orders {\n          orders {\n            id\n            created_at\n            currency\n            is_prepaid\n            note\n            status\n            subtotal_price\n            total_discounts\n            total_duties\n            total_line_items_price\n            total_price\n            total_refunds\n            total_tax\n            total_weight_grams\n            type\n            charge {\n              external_transaction_id {\n                payment_processor\n              }\n            }\n            billing_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n            shipping_address {\n              address1\n              address2\n              city\n              company\n              country_code\n              first_name\n              last_name\n              phone\n              province\n              zip\n            }\n          }\n        }\n      }\n    }\n  }\n": LB
};
function Ig(e) {
  return VB[e] ?? {};
}
const zB = Ig(
  /* GraphQL */
  `
  query getCustomerDetails($email: String) {
    Recharge {
      getStore {
        ... on Recharge_Store {
          store {
            id
            name
            external_platform
            customer_portal_base_url
            merchant_portal_base_url
            identifier
            checkout_platform
            external_platform
          }
        }
      }
      getCustomers(email: $email) {
        ... on Recharge_Customers {
          customers {
            id
            email
            phone
            first_name
            last_name
            created_at
            updated_at
            external_customer_id {
              ecommerce
            }
            subscriptions_active_count
            subscriptions_total_count
            has_valid_payment_method
            hash
          }
        }
      }
    }
  }
`
), UB = Ig(
  /* GraphQL */
  `
  query getAddresses($customerId: String) {
    Recharge {
      getAddresses(customer_id: $customerId) {
        ... on Recharge_Addresses {
          addresses {
            id
            payment_method_id
            address1
            address2
            city
            company
            country_code
            created_at
            customer_id
            discounts {
              id
              code
              value
              value_type
            }
            first_name
            last_name
            order_attributes {
              name
              value
            }
            order_note
            phone
            presentment_currency
            shipping_lines_conserved {
              code
              title
              price
            }
            shipping_lines_override {
              code
              title
              price
            }
            updated_at
            zip
          }
        }
      }
    }
  }
`
), MB = Ig(
  /* GraphQL */
  `
  query getOrders($customerId: String, $limit: String, $addressId: String) {
    Recharge {
      getOrders(
        customer_id: $customerId
        limit: $limit
        address_id: $addressId
      ) {
        ... on Recharge_Orders {
          orders {
            id
            created_at
            currency
            is_prepaid
            note
            status
            subtotal_price
            total_discounts
            total_duties
            total_line_items_price
            total_price
            total_refunds
            total_tax
            total_weight_grams
            type
            charge {
              external_transaction_id {
                payment_processor
              }
            }
            billing_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
            shipping_address {
              address1
              address2
              city
              company
              country_code
              first_name
              last_name
              phone
              province
              zip
            }
          }
        }
      }
    }
  }
`
);
function yy(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const BB = (e) => `${e.charAt(0).toUpperCase()}${e.slice(1).toLowerCase()}`, H1 = "DD MMM YYYY @ HH:mm", qB = "_list_2c4dq_1", HB = "_listItem_2c4dq_4", WB = "_copyIcon_2c4dq_12", Vi = {
  list: qB,
  listItem: HB,
  copyIcon: WB
}, gy = ({
  address: e,
  icon: n,
  title: r,
  isLoading: i = !1,
  hasMultipleAddresses: a = !1
}) => {
  const { isCopied: o, copy: s } = yy(), l = 14, {
    first_name: d,
    last_name: m,
    address1: u,
    address2: f,
    city: h,
    zip: k,
    country_code: C
  } = e ?? {}, N = `${d} ${m}`.trim() || void 0, j = `${h} ${k}`.trim() || void 0, _ = [N, u, f, j, C].filter(
    Boolean
  );
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(ve, { size: l, name: n }),
      i ? /* @__PURE__ */ Ce.jsx(fn, { size: l }) : /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
        r && /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: r }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: _.map((g, D) => /* @__PURE__ */ Ce.jsx(st, { children: g }, D)) })
      ] })
    ] }),
    !i && /* @__PURE__ */ Ce.jsxs(b, { gap: "100", children: [
      a && /* @__PURE__ */ Ce.jsx(Xe, { content: "The customer has multiple addresses, showing only the first here.", children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: l,
          name: "exclamation",
          className: Vi.copyIcon
        }
      ) }),
      /* @__PURE__ */ Ce.jsx(Xe, { content: `Copy ${r ? r.toLowerCase() : "address"}`, children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: l,
          name: o ? "done" : "copy",
          onClick: () => s(_.join(", ")),
          className: Vi.copyIcon
        }
      ) })
    ] })
  ] });
}, KB = "_wrapper_1nher_1", GB = {
  wrapper: KB
}, YB = ({
  customer: e,
  store: n
}) => {
  const { track: r } = Cn(), { isCopied: i, copy: a } = yy(), { isCopied: o, copy: s } = yy(), { useQuery: l } = hn(), d = e?.id, {
    loading: m,
    error: u,
    data: f
  } = l(UB, {
    skip: !d,
    variables: {
      customerId: d?.toString()
    }
  }), h = f?.Recharge?.getAddresses, k = !m && h?.addresses?.[0] ? h.addresses[0] : void 0, C = (h?.addresses?.length ?? 0) > 1;
  if (Qe(() => {
    k && r("recharge:profile:received");
  }, [k, r]), u)
    return /* @__PURE__ */ Ce.jsx(En, { error: u });
  if (!e)
    return null;
  const {
    id: N,
    phone: j,
    email: _,
    first_name: g,
    last_name: D,
    created_at: O,
    has_valid_payment_method: I
  } = e, F = 14, L = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/customers/${N}` : null, K = `${g || ""} ${D || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Ce.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Ce.jsxs(b, { className: GB.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-2", children: K }),
    O && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: Gn(O).format(H1) })
    ] }),
    _ && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "mail" }),
        /* @__PURE__ */ Ce.jsx($.ExternalLink, { href: `mailto:${_}`, children: _ })
      ] }),
      /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: F,
          name: i ? "done" : "copy",
          onClick: () => a(_),
          className: Vi.copyIcon
        }
      ) })
    ] }),
    j && /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "phone" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: j })
      ] }),
      /* @__PURE__ */ Ce.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: F,
          name: o ? "done" : "copy",
          onClick: () => s(j),
          className: Vi.copyIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ Ce.jsx(
      gy,
      {
        address: k,
        icon: "home",
        isLoading: m,
        hasMultipleAddresses: C
      }
    ),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Ce.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "credit-card" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Has valid payment method" })
      ] }),
      /* @__PURE__ */ Ce.jsx(
        ve,
        {
          size: F,
          name: I ? "check-circle" : "close-circle-filled",
          color: I ? "green.500" : "red.500"
        }
      )
    ] }),
    L && /* @__PURE__ */ Ce.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ Ce.jsx(ve, { size: F, name: "external-link" }),
      /* @__PURE__ */ Ce.jsx(
        $.ExternalLink,
        {
          href: L,
          target: "_blank",
          rel: "noreferrer",
          onClick: () => r("recharge:external:customer:overview:opened"),
          children: "View customer in Recharge"
        }
      )
    ] })
  ] }) });
}, JB = "_order_1dlaa_1", QB = "_orderIsOpen_1dlaa_9", XB = "_orderHeader_1dlaa_12", ZB = "_note_1dlaa_16", $s = {
  order: JB,
  orderIsOpen: QB,
  orderHeader: XB,
  note: ZB
}, eq = ({
  order: e,
  isOpenByDefault: n,
  store: r
}) => {
  const { track: i } = Cn(), [a, o] = me(n), {
    id: s,
    status: l,
    charge: d,
    currency: m,
    note: u,
    created_at: f,
    billing_address: h,
    shipping_address: k,
    total_price: C,
    is_prepaid: N
  } = e, j = 14, _ = r ? `https://${r.identifier}.admin.rechargeapps.com/merchant/orders/${s}` : null, g = d?.external_transaction_id?.payment_processor || void 0;
  return /* @__PURE__ */ Ce.jsxs(
    b,
    {
      className: dt($s.order, {
        [$s.orderIsOpen]: a
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ Ce.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: $s.orderHeader,
            onClick: () => o(!a),
            children: [
              /* @__PURE__ */ Ce.jsxs(b, { gap: "100", flexDirection: "column", children: [
                f && /* @__PURE__ */ Ce.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: Gn(f).format(H1) }) }),
                /* @__PURE__ */ Ce.jsxs($.Paragraph, { variant: "1", children: [
                  "Order #",
                  s
                ] })
              ] }),
              /* @__PURE__ */ Ce.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: a ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        a && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          u && /* @__PURE__ */ Ce.jsx(Xe, { content: "Note", children: /* @__PURE__ */ Ce.jsx(
            $.Paragraph,
            {
              variant: "4",
              color: "secondary",
              className: $s.note,
              children: u
            }
          ) }),
          l && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "activity" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Status" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: BB(l) })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "credit-card" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Prepaid" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: N ? "Yes" : "No" })
            ] })
          ] }),
          g && /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "cog" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Payment processor" }),
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: g })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsxs(b, { gap: "250", flexDirection: "row", children: [
            /* @__PURE__ */ Ce.jsx(ve, { size: j, name: "chart-bar" }),
            /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
              /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ Ce.jsxs($.Paragraph, { variant: "4", children: [
                C,
                " ",
                m
              ] })
            ] })
          ] }),
          /* @__PURE__ */ Ce.jsx(
            gy,
            {
              address: h,
              icon: "home",
              title: "Billing address"
            }
          ),
          /* @__PURE__ */ Ce.jsx(
            gy,
            {
              address: k,
              icon: "map-pin",
              title: "Shipping address"
            }
          ),
          _ && /* @__PURE__ */ Ce.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(_, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ Ce.jsx(ve, { name: "external-link" }),
              onClick: () => i("recharge:external:order:opened"),
              children: "View order in Recharge"
            }
          )
        ] })
      ]
    }
  );
}, nq = ({
  customerId: e,
  store: n
}) => {
  const { track: r } = Cn(), { useQuery: i } = hn(), {
    loading: a,
    error: o,
    data: s
  } = i(MB, {
    skip: !e,
    variables: {
      customerId: e?.toString(),
      limit: "5"
    }
  }), l = s?.Recharge?.getOrders, d = !a && l?.orders && l.orders.length > 0 ? l.orders : [];
  if (!e)
    return null;
  if (o)
    return /* @__PURE__ */ Ce.jsx(En, { error: o });
  const m = n ? `https://${n.identifier}.admin.rechargeapps.com/merchant/orders/processed?limit=25` : null;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !a && /* @__PURE__ */ Ce.jsx(Mn, { variant: "success", size: "small", children: d.length })
    ] }),
    /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
      a && /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(fn, {}) }),
      !a && d.length === 0 && /* @__PURE__ */ Ce.jsx(
        b,
        {
          justifyContent: "center",
          margin: "200 0 300 0",
          "data-testid": "widget-no-orders",
          children: /* @__PURE__ */ Ce.jsx($.Paragraph, { color: "tertiary", children: "No orders found" })
        }
      ),
      !a && d.length > 0 && /* @__PURE__ */ Ce.jsx(b, { gap: "200", flexDirection: "column", children: d.map((u, f) => /* @__PURE__ */ Ce.jsx(
        eq,
        {
          order: u,
          isOpenByDefault: f === 0,
          store: n
        },
        `${f}-${u.id}`
      )) }),
      m && /* @__PURE__ */ Ce.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(m, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ Ce.jsx(ve, { name: "external-link" }),
          onClick: () => r("recharge:external:orders:list:opened"),
          children: "View all orders in Recharge"
        }
      )
    ] })
  ] });
}, tq = ({
  customer: e
}) => {
  if (!e)
    return null;
  const {
    subscriptions_active_count: n,
    subscriptions_total_count: r
  } = e, i = r ?? 0, a = n ?? 0;
  return /* @__PURE__ */ Ce.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Ce.jsx($.Heading, { variant: "heading-3", children: "Subscriptions overview" }),
    /* @__PURE__ */ Ce.jsxs(Ye, { className: Vi.list, children: [
      /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Vi.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Total subscriptions" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: i })
      ] }) }),
      /* @__PURE__ */ Ce.jsx(Ye.Text, { variant: "dense", className: Vi.listItem, children: /* @__PURE__ */ Ce.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: "Active subscriptions" }),
        /* @__PURE__ */ Ce.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] });
}, rq = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), i = e?.customer?.email, a = n.displayCustomerDetails ?? !1, o = n.displaysubscriptionOverview ?? !1, s = n.displayOrders ?? !1, l = !a && !o && !s, {
    loading: d,
    error: m,
    data: u
  } = r(zB, {
    skip: !i,
    variables: {
      email: i
    }
  }), f = !d && u ? u?.Recharge?.getCustomers?.customers?.[0] : void 0, h = !d && u ? u?.Recharge?.getStore?.store ?? void 0 : void 0;
  if (m) {
    const k = m.graphQLErrors;
    return zl({ errors: k }) ? /* @__PURE__ */ Ce.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: k }) ? /* @__PURE__ */ Ce.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Recharge. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Ce.jsx(En, { error: m });
  }
  return d ? /* @__PURE__ */ Ce.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Ce.jsx(fn, {}) }) : f ? l ? /* @__PURE__ */ Ce.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-no-features",
      children: "All features toggles in the settings are disabled."
    }
  ) : /* @__PURE__ */ Ce.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        a && /* @__PURE__ */ Ce.jsx(YB, { customer: f, store: h }),
        o && /* @__PURE__ */ Ce.jsx(tq, { customer: f }),
        s && /* @__PURE__ */ Ce.jsx(nq, { customerId: f.id, store: h })
      ]
    }
  ) : /* @__PURE__ */ Ce.jsx(
    $.Paragraph,
    {
      margin: "200 0 300 0",
      color: "secondary",
      align: "center",
      "data-testid": "widget-customer-not-found",
      children: "No data found for this customer in Recharge."
    }
  );
}, $l = [
  {
    key: "rechargeAccessToken",
    label: "API token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "displayCustomerDetails",
    label: "Displays details of a customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaysubscriptionOverview",
    label: "Displays the subscription overview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrders",
    label: "Displays the last 5 orders",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ts = rr($l), iq = {
  enabled: !1,
  name: "",
  rechargeAccessToken: "",
  displayCustomerDetails: !0,
  displaysubscriptionOverview: !0,
  displayOrders: !0
}, aq = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: iq
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "RECHARGE",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: $l,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => hr(K, {
    fieldDefinitions: $l,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ Ce.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ Ce.jsx(yr, { cause: h }),
        /* @__PURE__ */ Ce.jsxs(nt, { children: [
          /* @__PURE__ */ Ce.jsx(Z, { children: /* @__PURE__ */ Ce.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(
            Er,
            {
              name: "rechargeAccessToken",
              label: Ts.rechargeAccessToken,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API token is required" },
              componentProps: {
                placeholder: "Insert the Admin API token for Recharge",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: Ts.displayCustomerDetails, children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "displayCustomerDetails",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: Ts.displaysubscriptionOverview, children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "displaysubscriptionOverview",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3, children: /* @__PURE__ */ Ce.jsx(We, { label: Ts.displayOrders, children: /* @__PURE__ */ Ce.jsx(
            bn,
            {
              name: "displayOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ Ce.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ Ce.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ Ce.jsx(
          gr,
          {
            integrationType: "RECHARGE",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._wrapper_l5y5y_54{gap:var(--dixa-size-spacer-250);margin-bottom:var(--dixa-size-spacer-300)}._inputWrapper_l5y5y_59{background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);margin:var(--dixa-size-spacer-300) 0;gap:var(--dixa-size-spacer-250);padding:var(--dixa-size-spacer-300)}._inputField_l5y5y_67{text-align:center}._inputSeparator_l5y5y_71{color:var(--dixa-color-neutral-600);text-align:center}._buttonLink_l5y5y_76{color:var(--dixa-typography-color-link)}._noIssuesFound_l5y5y_80{color:var(--dixa-color-neutral-400);font-size:var(--dixa-typography-size-200)}._list_l5y5y_85{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_l5y5y_95{background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_l5y5y_95:last-child{box-shadow:none}._listItemHighlighted_l5y5y_103{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._listItemEdit_l5y5y_106{cursor:pointer}._fullWidth_l5y5y_110{width:100%}._boxWrapper_l5y5y_114{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._clickableIcon_l5y5y_120{cursor:pointer;color:var(--dixa-typography-color-secondary)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._list_rxh85_1{padding:0;overflow-y:auto;max-height:230px}._listItem_rxh85_6{cursor:pointer;font-size:var(--dixa-typography-size-100);background-color:transparent;padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_rxh85_6:last-child{box-shadow:none}._listItemHighlighted_rxh85_16{border-left:var(--dixa-size-spacer-200) solid var(--dixa-color-orange-300)}._modalBody_1clhs_1{width:400px}._reward_1gmba_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._reward_1gmba_1:hover{border-color:var(--dixa-color-neutral-400)}._clickable_1gmba_10{cursor:pointer}._voucherCode_1gmba_14{font-family:monospace}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Gm = { exports: {} }, ho = {}, IS;
function oq() {
  if (IS) return ho;
  IS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ho.Fragment = r, ho.jsx = s, ho.jsxs = s, ho;
}
var Os = {}, ES;
function sq() {
  return ES || (ES = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Os.Fragment = i, Os.jsx = zn, Os.jsxs = Wn;
  })()), Os;
}
var $S;
function lq() {
  return $S || ($S = 1, process.env.NODE_ENV === "production" ? Gm.exports = oq() : Gm.exports = sq()), Gm.exports;
}
var be = lq(), W1 = /* @__PURE__ */ ((e) => (e.CustomAction = "custom_action", e.FacebookLike = "facebook_like", e.FacebookShare = "facebook_share", e.InstagramFollow = "instagram_follow", e.Manual = "manual", e.ReferralComplete = "referral_complete", e.TiktokFollow = "tiktok_follow", e.TwitterFollow = "twitter_follow", e.TwitterShare = "twitter_share", e.VisitUrl = "visit_url", e))(W1 || {}), va = /* @__PURE__ */ ((e) => (e.Excluded = "excluded", e.Guest = "guest", e.Member = "member", e))(va || {});
const cq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "adjustCustomerPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NamedType", name: { kind: "Name", value: "RivoLoyalty_adjust_customer_points_request_Input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "adjust_customer_points" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, dq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "return_customer" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_identifier" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "fields" }, value: { kind: "StringValue", value: "lifetime_earnings_tally,next_vip_tier", block: !1 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "accepts_marketing" } }, { kind: "Field", name: { kind: "Name", value: "orders_count" } }, { kind: "Field", name: { kind: "Name", value: "verified_email" } }, { kind: "Field", name: { kind: "Name", value: "total_spent" } }, { kind: "Field", name: { kind: "Name", value: "loyalty_status" } }, { kind: "Field", name: { kind: "Name", value: "points_tally" } }, { kind: "Field", name: { kind: "Name", value: "credits_tally" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }] } }, { kind: "Field", name: { kind: "Name", value: "points_expire_at" } }, { kind: "Field", name: { kind: "Name", value: "next_vip_tier" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "threshold" } }, { kind: "Field", name: { kind: "Name", value: "to_spend_or_earn" } }] } }, { kind: "Field", name: { kind: "Name", value: "lifetime_earnings_tally" } }] } }] } }] } }] } }] } }] }, uq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getFavoriteProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_customer_favorite_products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customer_id" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "data_source" }, value: { kind: "EnumValue", value: "shopify" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "product_id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "handle" } }] } }] } }] } }] } }] }, mq = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPointsRedemptions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "RivoLoyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "list_points_redemptions" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "data" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_amount" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "expires_at" } }, { kind: "Field", name: { kind: "Name", value: "used_at" } }, { kind: "Field", name: { kind: "Name", value: "refunded_at" } }, { kind: "Field", name: { kind: "Name", value: "revoked_at" } }] } }] } }] } }] } }] } }] }, pq = {
  "\n  mutation adjustCustomerPoints(\n    $input: RivoLoyalty_adjust_customer_points_request_Input\n  ) {\n    RivoLoyalty {\n      adjust_customer_points(input: $input)\n    }\n  }\n": cq,
  '\n  query getCustomer($email: String!) {\n    RivoLoyalty {\n      return_customer(\n        customer_identifier: $email\n        fields: "lifetime_earnings_tally,next_vip_tier"\n      ) {\n        data {\n          attributes {\n            id\n            email\n            first_name\n            last_name\n            accepts_marketing\n            orders_count\n            verified_email\n            total_spent\n            loyalty_status\n            points_tally\n            credits_tally\n            vip_tier {\n              name\n              threshold\n            }\n            points_expire_at\n            next_vip_tier {\n              name\n              threshold\n              to_spend_or_earn\n            }\n            lifetime_earnings_tally\n          }\n        }\n      }\n    }\n  }\n': dq,
  "\n  query getFavoriteProducts($customerId: String!) {\n    RivoLoyalty {\n      list_customer_favorite_products(\n        customer_id: $customerId\n        data_source: shopify\n      ) {\n        data {\n          product_id\n          title\n          handle\n        }\n      }\n    }\n  }\n": uq,
  "\n  query getPointsRedemptions($customerId: String!) {\n    RivoLoyalty {\n      list_points_redemptions(\n        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId\n      ) {\n        data {\n          id\n          attributes {\n            points_amount\n            name\n            code\n            expires_at\n            used_at\n            refunded_at\n            revoked_at\n          }\n        }\n      }\n    }\n  }\n": mq
};
function lc(e) {
  return pq[e] ?? {};
}
const fq = lc(
  /* GraphQL */
  `
  query getCustomer($email: String!) {
    RivoLoyalty {
      return_customer(
        customer_identifier: $email
        fields: "lifetime_earnings_tally,next_vip_tier"
      ) {
        data {
          attributes {
            id
            email
            first_name
            last_name
            accepts_marketing
            orders_count
            verified_email
            total_spent
            loyalty_status
            points_tally
            credits_tally
            vip_tier {
              name
              threshold
            }
            points_expire_at
            next_vip_tier {
              name
              threshold
              to_spend_or_earn
            }
            lifetime_earnings_tally
          }
        }
      }
    }
  }
`
), hq = lc(
  /* GraphQL */
  `
  query getFavoriteProducts($customerId: String!) {
    RivoLoyalty {
      list_customer_favorite_products(
        customer_id: $customerId
        data_source: shopify
      ) {
        data {
          product_id
          title
          handle
        }
      }
    }
  }
`
), yq = lc(
  /* GraphQL */
  `
  query getPointsRedemptions($customerId: String!) {
    RivoLoyalty {
      list_points_redemptions(
        filters_LEFT_SQUARE_BRACE_customer_identifier_RIGHT_SQUARE_BRACE_: $customerId
      ) {
        data {
          id
          attributes {
            points_amount
            name
            code
            expires_at
            used_at
            refunded_at
            revoked_at
          }
        }
      }
    }
  }
`
), gq = lc(
  /* GraphQL */
  `
  mutation adjustCustomerPoints(
    $input: RivoLoyalty_adjust_customer_points_request_Input
  ) {
    RivoLoyalty {
      adjust_customer_points(input: $input)
    }
  }
`
), vq = "_list_l5y5y_85", kq = "_listItem_l5y5y_95", bq = "_listItemHighlighted_l5y5y_103", _q = "_listItemEdit_l5y5y_106", xq = "_clickableIcon_l5y5y_120", Cr = {
  list: vq,
  listItem: kq,
  listItemHighlighted: bq,
  listItemEdit: _q,
  clickableIcon: xq
}, cc = "rivoLoyaltyShopifyApiHostName", K1 = "https://admin.shopify.com";
function G1(e) {
  return e.split(".")[0];
}
const Sq = "_wrapper_1xucg_1", TS = {
  wrapper: Sq
}, Nq = ({
  customerDetails: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { track: r } = Cn(), { isCopied: i, copy: a } = Jt(), { attributes: o } = e, {
    first_name: s,
    last_name: l,
    email: d,
    verified_email: m
  } = o, u = 14, f = `${s || ""} ${l || ""}`.trim() || "No name found for customer";
  return /* @__PURE__ */ be.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { className: TS.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx(
      b,
      {
        justifyContent: "space-between",
        className: TS.block,
        alignItems: "center",
        children: /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    d && /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ be.jsx(ve, { size: u, name: "mail" }),
        /* @__PURE__ */ be.jsx($.ExternalLink, { href: `mailto:${d}`, children: d }),
        /* @__PURE__ */ be.jsx(
          Xe,
          {
            content: m ? "Verified email" : "Email is not verified",
            children: /* @__PURE__ */ be.jsx(b, { alignItems: "center", children: /* @__PURE__ */ be.jsx(
              ve,
              {
                size: u,
                color: m ? "green.500" : "red.500",
                name: m ? "check-circle" : "exclamation"
              }
            ) })
          }
        )
      ] }),
      /* @__PURE__ */ be.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ be.jsx(
        ve,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: Cr.clickableIcon
        }
      ) })
    ] }),
    /* @__PURE__ */ be.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(ve, { size: u, name: "sign-in" }),
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "2", children: "Marketing consent" })
      ] }),
      /* @__PURE__ */ be.jsx(
        ve,
        {
          name: o.accepts_marketing ? "check-circle-filled" : "close-circle-filled",
          color: o.accepts_marketing ? "green.500" : "neutral.500"
        }
      )
    ] }),
    /* @__PURE__ */ be.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ be.jsx(ve, { size: u, name: "external-link" }),
      /* @__PURE__ */ be.jsx(
        $.ExternalLink,
        {
          href: jq(n, o.id),
          target: "_blank",
          rel: "noreferrer",
          onClick: () => {
            r("rivoloyalty:customer:clicked", {});
          },
          children: "View customer in Rivo Loyalty"
        }
      )
    ] })
  ] }) });
};
function jq(e, n) {
  const r = G1(e);
  return `${K1}/store/${r}/apps/rivo-loyalty/customers/${n}`;
}
const wq = "_list_rxh85_1", Cq = "_listItem_rxh85_6", OS = {
  list: wq,
  listItem: Cq
}, Fq = ({
  customerId: e,
  rivoLoyaltyShopifyApiHostName: n
}) => {
  const { useQuery: r } = hn(), {
    loading: i,
    error: a,
    data: o
  } = r(hq, {
    skip: !e,
    variables: {
      customerId: e?.toString()
    }
  }), s = !i && o ? o.RivoLoyalty?.list_customer_favorite_products?.data ?? [] : [], l = 14, d = () => a ? /* @__PURE__ */ be.jsx(En, { error: a }) : i ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(fn, {}) }) : s.length === 0 ? /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No favorite products found." }) : /* @__PURE__ */ be.jsx(Ye, { className: OS.list, children: s.map((m) => /* @__PURE__ */ be.jsxs(
    b,
    {
      alignItems: "center",
      gap: "200",
      className: OS.listItem,
      children: [
        /* @__PURE__ */ be.jsx(ve, { size: l, name: "external-link" }),
        /* @__PURE__ */ be.jsx(
          $.ExternalLink,
          {
            href: Iq(
              n,
              m.product_id
            ),
            target: "_blank",
            rel: "noreferrer",
            children: m.title
          }
        )
      ]
    },
    m.product_id
  )) });
  return /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Favorite products" }),
    d()
  ] }) });
};
function Iq(e, n) {
  const r = G1(e);
  return `${K1}/store/${r}/products/${n}`;
}
const Eq = "_modalBody_1clhs_1", $q = {
  modalBody: Eq
};
function Tq(e, n) {
  if (isNaN(e))
    return "Points can not be empty";
  if (e < n.min)
    return `Points cannot be below ${n.min}`;
  if (e > n.max)
    return `Points can not exceed ${n.max}`;
}
function Oq(e, n) {
  if (e === n)
    return "Change the value to update the points";
}
const Rq = W1, Rs = {
  addPoints: {
    successEventName: "rivoloyalty:points:add:succeeded",
    successEventText: "Added points successfully",
    failEventName: "rivoloyalty:points:add:failed",
    failEventText: "Failed to add points, try again later."
  },
  removePoints: {
    successEventName: "rivoloyalty:points:remove:succeeded",
    successEventText: "Removed points successfully",
    failEventName: "rivoloyalty:points:remove:failed",
    failEventText: "Failed to remove points, try again later."
  }
}, Dq = ({
  customerIdentifier: e,
  isOpen: n,
  points: r,
  onClose: i,
  refetchCustomerData: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), [d, m] = me(r), [u, f] = me(""), [h, k] = me(!0), [C, N] = me(), j = {
    min: 0,
    max: 1e5
  }, [_, { loading: g }] = o(
    gq,
    {
      onCompleted: () => {
        const te = d > r ? Rs.addPoints : Rs.removePoints;
        s({
          title: "Success",
          text: te.successEventText,
          icon: "check-circle-filled",
          severity: "success"
        }), l(te.successEventName), J();
      }
    }
  ), D = () => {
    m(r), f(""), k(!0), N(void 0);
  };
  Qe(() => {
    n && D();
  }, [n]);
  const O = !!C, I = Tq(d, j), F = Oq(r, d), L = () => {
    if (d !== r) {
      const te = d > r ? Rs.addPoints : Rs.removePoints, W = !h;
      _({
        variables: {
          input: {
            // eslint-disable-next-line camelcase
            points_amount: d - r,
            // eslint-disable-next-line camelcase
            ...u && { internal_note: u },
            // eslint-disable-next-line camelcase
            customer_identifier: e?.toString(),
            source: Rq.Manual,
            // eslint-disable-next-line camelcase
            skip_email: W
          }
        }
      }).catch(() => {
        l(te.failEventName), N([te.failEventText]);
      });
    }
  }, K = () => {
    D(), i();
  }, J = () => {
    a(), K();
  };
  return /* @__PURE__ */ be.jsxs(
    wt,
    {
      isOpen: n,
      onClose: K,
      "data-testid": "rivo-loyalty-change-points-modal",
      children: [
        /* @__PURE__ */ be.jsx(Ct, { title: "Change points", onClose: K }),
        /* @__PURE__ */ be.jsxs(Ft, { className: $q.modalBody, children: [
          /* @__PURE__ */ be.jsxs(nt, { children: [
            /* @__PURE__ */ be.jsx(Z, { span: 6, "data-testid": "rivo-loyalty-points-input", children: /* @__PURE__ */ be.jsx(
              Wr,
              {
                label: "New points balance",
                type: "number",
                placeholder: "Insert points balance",
                min: j.min,
                max: j.max,
                meta: {
                  error: I,
                  warning: F
                },
                input: {
                  name: "points",
                  value: d.toString(),
                  onChange: (te) => m(te?.target.valueAsNumber ?? 0)
                }
              }
            ) }),
            /* @__PURE__ */ be.jsx(Z, { span: 6, children: /* @__PURE__ */ be.jsx(
              Wr,
              {
                label: "Internal note",
                placeholder: "Insert an internal note (optional)",
                input: {
                  name: "internalNote",
                  value: u,
                  onChange: (te) => f(te?.target.value ?? "")
                }
              }
            ) }),
            /* @__PURE__ */ be.jsx(Z, { span: 6, children: /* @__PURE__ */ be.jsx(We, { label: "Notify the customer by email", children: /* @__PURE__ */ be.jsx(
              Sw,
              {
                input: {
                  name: "sendEmail",
                  value: "sendEmail",
                  checked: h,
                  onChange: () => k(!h)
                }
              }
            ) }) })
          ] }),
          !g && O && /* @__PURE__ */ be.jsx(b, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ be.jsx(Ye, { children: C?.map((te, W) => /* @__PURE__ */ be.jsx(
            Ye.Item,
            {
              variant: "dense",
              title: te,
              contentLeft: /* @__PURE__ */ be.jsx(
                ve,
                {
                  color: "red.500",
                  size: 16,
                  name: "exclamation-triangle-filled"
                }
              )
            },
            W
          )) }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => L(),
            confirmProps: {
              isLoading: g,
              loadingIndicator: /* @__PURE__ */ be.jsx(fn, { size: 16 }),
              disabled: !!(I || F)
            },
            cancelOnClick: K
          }
        )
      ]
    }
  );
}, oa = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = _w(n);
  return /* @__PURE__ */ be.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(Cr.listItem, {
        [Cr.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ be.jsx(Xe, { content: r, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Mi(n)
      ] }) })
    }
  );
}, RS = {
  [va.Guest]: {
    name: "Guest",
    tooltip: "Customers who can participate in your loyalty program without creating a full account. They can earn and redeem points through email verification or one-time codes.",
    badgeColor: "info"
  },
  [va.Member]: {
    name: "Member",
    tooltip: "Customers who have activated their loyalty membership and have full access to all program features, including account dashboards and advanced features.",
    badgeColor: "success"
  },
  [va.Excluded]: {
    name: "Excluded",
    tooltip: "Customers who have been excluded from the loyalty program (typically through the “Rivo Excluded” tag or manual exclusion).",
    badgeColor: "warning"
  }
}, Pq = ({
  customer: e,
  allowAdjustLoyaltyPoints: n,
  refetchCustomerData: r
}) => {
  const { attributes: i } = e, a = i.loyalty_status ? RS[i.loyalty_status] : RS[va.Guest], o = a?.name === va.Excluded, s = i.lifetime_earnings_tally ?? 0, l = i.total_spent ?? 0, d = Math.trunc(i.points_tally ?? 0), m = i.next_vip_tier, u = i.next_vip_tier?.to_spend_or_earn ?? 0, f = m?.name ?? "None", [h, k] = me(!1), C = 10, N = () => /* @__PURE__ */ be.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(Cr.listItem),
      children: /* @__PURE__ */ be.jsx(Xe, { content: a.tooltip, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Loyalty status" }),
        /* @__PURE__ */ be.jsx(Mn, { variant: a.badgeColor, size: "small", children: a.name })
      ] }) })
    }
  ), j = () => o ? N() : /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsx(
      Ye.Text,
      {
        variant: "dense",
        className: dt(
          Cr.listItem,
          Cr.listItemHighlighted,
          {
            [Cr.listItemEdit]: n
          }
        ),
        onClick: () => n ? k(!0) : void 0,
        children: /* @__PURE__ */ be.jsx(Xe, { content: "The current balance of loyalty points for the customer.", children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Points balance" }),
          /* @__PURE__ */ be.jsxs(
            b,
            {
              alignItems: "center",
              justifyContent: "space-between",
              gap: "100",
              children: [
                n && /* @__PURE__ */ be.jsx(
                  ve,
                  {
                    name: "pen",
                    size: C,
                    "aria-label": "Edit points"
                  }
                ),
                /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: Mi(d) })
              ]
            }
          )
        ] }) })
      }
    ),
    u != null && f && /* @__PURE__ */ be.jsx(
      oa,
      {
        description: `Points until ${f} tier`,
        tooltip: `Loyalty points until the customer advances to ${f} tier`,
        content: u.toFixed(2)
      }
    ),
    /* @__PURE__ */ be.jsx(
      oa,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: i.points_expire_at ?? "No expiry"
      }
    ),
    /* @__PURE__ */ be.jsx(
      oa,
      {
        description: "Total points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: s?.toFixed(2)
      }
    ),
    /* @__PURE__ */ be.jsx(
      oa,
      {
        description: "Total points spent",
        tooltip: "The total number of loyalty points spent by the customer.",
        content: l.toFixed(2)
      }
    ),
    N(),
    /* @__PURE__ */ be.jsx(
      oa,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: i.vip_tier?.name ?? "None"
      }
    ),
    /* @__PURE__ */ be.jsx(
      oa,
      {
        description: "Next VIP tier",
        tooltip: "The name of the customer's next VIP tier status.",
        content: f
      }
    )
  ] });
  return /* @__PURE__ */ be.jsxs(be.Fragment, { children: [
    /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
      /* @__PURE__ */ be.jsx(Ye, { className: Cr.list, children: j() })
    ] }),
    /* @__PURE__ */ be.jsx(
      Dq,
      {
        customerIdentifier: i.id,
        isOpen: h,
        points: d,
        onClose: () => k(!1),
        refetchCustomerData: r
      }
    )
  ] });
}, Aq = ({
  ordersCount: e
}) => /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
  /* @__PURE__ */ be.jsx(Ye, { className: Cr.list, children: /* @__PURE__ */ be.jsx(Ye.Text, { variant: "dense", className: Cr.listItem, children: /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
    /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", children: e ?? 0 })
  ] }) }) })
] }) }), Lq = "_reward_1gmba_1", Vq = "_voucherCode_1gmba_14", DS = {
  reward: Lq,
  voucherCode: Vq
}, zq = ({
  pointsRedemption: e
}) => {
  const { isCopied: n, copy: r } = Jt(), {
    name: i,
    code: a,
    points_amount: o
  } = e.attributes;
  return /* @__PURE__ */ be.jsx(b, { gap: "100", flexDirection: "column", children: /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "column", className: DS.reward, children: [
    /* @__PURE__ */ be.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ be.jsxs(b, { gap: "100", alignItems: "center", children: [
        /* @__PURE__ */ be.jsx(ve, { name: "star", size: 12, color: "neutral.500" }),
        i
      ] }),
      /* @__PURE__ */ be.jsxs(Mn, { size: "small", variant: "info", children: [
        o ?? 0,
        " points"
      ] })
    ] }),
    /* @__PURE__ */ be.jsxs(
      b,
      {
        gap: "100",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        children: [
          /* @__PURE__ */ be.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ be.jsx(ve, { size: 14, name: "tag" }),
            /* @__PURE__ */ be.jsx(b, { children: /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", className: DS.voucherCode, children: a }) })
          ] }),
          /* @__PURE__ */ be.jsx(Xe, { content: "Copy reward code", children: /* @__PURE__ */ be.jsx(
            ve,
            {
              size: 14,
              name: n ? "done" : "copy",
              className: Cr.clickableIcon,
              onClick: () => r(a)
            }
          ) })
        ]
      }
    )
  ] }) });
}, Uq = ({
  customer: e
}) => {
  const { useQuery: n } = hn(), {
    loading: r,
    error: i,
    data: a
  } = n(yq, {
    skip: !e,
    variables: {
      customerId: e.attributes.id.toString()
    }
  }), o = (!r && e && a ? a?.RivoLoyalty?.list_points_redemptions?.data ?? [] : []).filter(
    ({ attributes: l }) => Mq({
      usedAt: l.used_at,
      revokedAt: l.revoked_at,
      refundedAt: l.refunded_at
    }) === "Issued"
  ), s = () => i ? /* @__PURE__ */ be.jsx(En, { error: i }) : r ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(fn, {}) }) : o.length > 0 ? /* @__PURE__ */ be.jsx(b, { gap: "200", flexDirection: "column", children: o.map((l) => /* @__PURE__ */ be.jsx(
    zq,
    {
      pointsRedemption: l
    },
    l.id
  )) }) : /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty rewards found." });
  return /* @__PURE__ */ be.jsx(be.Fragment, { children: /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ be.jsx($.Heading, { variant: "heading-3", children: "Available rewards" }),
    s()
  ] }) });
};
function Mq(e) {
  return e.usedAt ? "Used" : e.revokedAt ? "Revoked" : e.refundedAt ? "Refunded" : "Issued";
}
const Bq = (e) => {
  const { conversationContext: n, settings: r } = e, {
    rivoLoyaltyShowOrders: i,
    rivoLoyaltyShowLoyalty: a,
    rivoLoyaltyAdjustLoyaltyPoints: o,
    rivoLoyaltyShowFavoriteProducts: s,
    rivoLoyaltyShowPointsRedemptions: l
  } = r, d = r[cc].toString(), { useQuery: m } = hn(), { track: u } = Cn(), [f, h] = me(!1), k = n?.customer?.email, {
    loading: C,
    error: N,
    data: j,
    refetch: _
  } = m(fq, {
    skip: !k,
    variables: {
      email: k
    }
  }), g = !C && j ? j.RivoLoyalty?.return_customer?.data : void 0;
  Qe(() => {
    !C && g && !f && (u("rivoloyalty:customer:received"), h(!0));
  }, [C, g]);
  const D = () => /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ be.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (N) {
    const O = N.graphQLErrors;
    return wa({ errors: O }) ? D() : zl({ errors: O }) ? /* @__PURE__ */ be.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: O }) ? /* @__PURE__ */ be.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Rivo Loyalty. Please contact your administrator."
      }
    ) : /* @__PURE__ */ be.jsx(En, { error: N });
  }
  return C ? /* @__PURE__ */ be.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ be.jsx(fn, {}) }) : !k || !g ? D() : /* @__PURE__ */ be.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ be.jsx(
          Nq,
          {
            customerDetails: g,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        i && /* @__PURE__ */ be.jsx(
          Aq,
          {
            ordersCount: g.attributes?.orders_count ?? 0
          }
        ),
        a && /* @__PURE__ */ be.jsx(
          Pq,
          {
            customer: g,
            refetchCustomerData: _,
            allowAdjustLoyaltyPoints: !!o
          }
        ),
        s && /* @__PURE__ */ be.jsx(
          Fq,
          {
            customerId: g.attributes.id,
            rivoLoyaltyShopifyApiHostName: d
          }
        ),
        l && /* @__PURE__ */ be.jsx(Uq, { customer: g })
      ]
    }
  );
};
var rs = (e) => e.type === "checkbox", Pi = (e) => e instanceof Date, Yt = (e) => e == null;
const Y1 = (e) => typeof e == "object";
var gt = (e) => !Yt(e) && !Array.isArray(e) && Y1(e) && !Pi(e), J1 = (e) => gt(e) && e.target ? rs(e.target) ? e.target.checked : e.target.value : e, qq = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Q1 = (e, n) => e.has(qq(n)), Hq = (e) => {
  const n = e.constructor && e.constructor.prototype;
  return gt(n) && n.hasOwnProperty("isPrototypeOf");
}, Eg = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function Dt(e) {
  let n;
  const r = Array.isArray(e), i = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    n = new Date(e);
  else if (e instanceof Set)
    n = new Set(e);
  else if (!(Eg && (e instanceof Blob || i)) && (r || gt(e)))
    if (n = r ? [] : {}, !r && !Hq(e))
      n = e;
    else
      for (const a in e)
        e.hasOwnProperty(a) && (n[a] = Dt(e[a]));
  else
    return e;
  return n;
}
var dc = (e) => Array.isArray(e) ? e.filter(Boolean) : [], ht = (e) => e === void 0, tn = (e, n, r) => {
  if (!n || !gt(e))
    return r;
  const i = dc(n.split(/[,[\].]+?/)).reduce((a, o) => Yt(a) ? a : a[o], e);
  return ht(i) || i === e ? ht(e[n]) ? r : e[n] : i;
}, lr = (e) => typeof e == "boolean", $g = (e) => /^\w*$/.test(e), X1 = (e) => dc(e.replace(/["|']|\]/g, "").split(/\.|\[/)), it = (e, n, r) => {
  let i = -1;
  const a = $g(n) ? [n] : X1(n), o = a.length, s = o - 1;
  for (; ++i < o; ) {
    const l = a[i];
    let d = r;
    if (i !== s) {
      const m = e[l];
      d = gt(m) || Array.isArray(m) ? m : isNaN(+a[i + 1]) ? {} : [];
    }
    if (l === "__proto__" || l === "constructor" || l === "prototype")
      return;
    e[l] = d, e = e[l];
  }
};
const Tl = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Fr = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, ri = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, Wq = qe.createContext(null), Tg = () => qe.useContext(Wq);
var Z1 = (e, n, r, i = !0) => {
  const a = {
    defaultValues: n._defaultValues
  };
  for (const o in e)
    Object.defineProperty(a, o, {
      get: () => {
        const s = o;
        return n._proxyFormState[s] !== Fr.all && (n._proxyFormState[s] = !i || Fr.all), r && (r[s] = !0), e[s];
      }
    });
  return a;
};
function Kq(e) {
  const n = Tg(), { control: r = n.control, disabled: i, name: a, exact: o } = e || {}, [s, l] = qe.useState(r._formState), d = qe.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), m = qe.useRef(a);
  return m.current = a, qe.useEffect(() => r._subscribe({
    name: m.current,
    formState: d.current,
    exact: o,
    callback: (u) => {
      !i && l({
        ...r._formState,
        ...u
      });
    }
  }), [r, i, o]), qe.useEffect(() => {
    d.current.isValid && r._setValid(!0);
  }, [r]), qe.useMemo(() => Z1(s, r, d.current, !1), [s, r]);
}
var qr = (e) => typeof e == "string", eF = (e, n, r, i, a) => qr(e) ? (i && n.watch.add(e), tn(r, e, a)) : Array.isArray(e) ? e.map((o) => (i && n.watch.add(o), tn(r, o))) : (i && (n.watchAll = !0), r);
function Gq(e) {
  const n = Tg(), { control: r = n.control, name: i, defaultValue: a, disabled: o, exact: s } = e || {}, l = qe.useRef(i), d = qe.useRef(a);
  l.current = i, qe.useEffect(() => r._subscribe({
    name: l.current,
    formState: {
      values: !0
    },
    exact: s,
    callback: (f) => !o && u(eF(l.current, r._names, f.values || r._formValues, !1, d.current))
  }), [r, o, s]);
  const [m, u] = qe.useState(r._getWatch(i, a));
  return qe.useEffect(() => r._removeUnmounted()), m;
}
function Yq(e) {
  const n = Tg(), { name: r, disabled: i, control: a = n.control, shouldUnregister: o } = e, s = Q1(a._names.array, r), l = Gq({
    control: a,
    name: r,
    defaultValue: tn(a._formValues, r, tn(a._defaultValues, r, e.defaultValue)),
    exact: !0
  }), d = Kq({
    control: a,
    name: r,
    exact: !0
  }), m = qe.useRef(e), u = qe.useRef(a.register(r, {
    ...e.rules,
    value: l,
    ...lr(e.disabled) ? { disabled: e.disabled } : {}
  })), f = qe.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!tn(d.errors, r)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!tn(d.dirtyFields, r)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!tn(d.touchedFields, r)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!tn(d.validatingFields, r)
    },
    error: {
      enumerable: !0,
      get: () => tn(d.errors, r)
    }
  }), [d, r]), h = qe.useCallback((j) => u.current.onChange({
    target: {
      value: J1(j),
      name: r
    },
    type: Tl.CHANGE
  }), [r]), k = qe.useCallback(() => u.current.onBlur({
    target: {
      value: tn(a._formValues, r),
      name: r
    },
    type: Tl.BLUR
  }), [r, a._formValues]), C = qe.useCallback((j) => {
    const _ = tn(a._fields, r);
    _ && j && (_._f.ref = {
      focus: () => j.focus(),
      select: () => j.select(),
      setCustomValidity: (g) => j.setCustomValidity(g),
      reportValidity: () => j.reportValidity()
    });
  }, [a._fields, r]), N = qe.useMemo(() => ({
    name: r,
    value: l,
    ...lr(i) || d.disabled ? { disabled: d.disabled || i } : {},
    onChange: h,
    onBlur: k,
    ref: C
  }), [r, i, d.disabled, h, k, C, l]);
  return qe.useEffect(() => {
    const j = a._options.shouldUnregister || o;
    a.register(r, {
      ...m.current.rules,
      ...lr(m.current.disabled) ? { disabled: m.current.disabled } : {}
    });
    const _ = (g, D) => {
      const O = tn(a._fields, g);
      O && O._f && (O._f.mount = D);
    };
    if (_(r, !0), j) {
      const g = Dt(tn(a._options.defaultValues, r));
      it(a._defaultValues, r, g), ht(tn(a._formValues, r)) && it(a._formValues, r, g);
    }
    return !s && a.register(r), () => {
      (s ? j && !a._state.action : j) ? a.unregister(r) : _(r, !1);
    };
  }, [r, a, s, o]), qe.useEffect(() => {
    a._setDisabledField({
      disabled: i,
      name: r
    });
  }, [i, r, a]), qe.useMemo(() => ({
    field: N,
    formState: d,
    fieldState: f
  }), [N, d, f]);
}
var Jq = (e, n, r, i, a) => n ? {
  ...r[e],
  types: {
    ...r[e] && r[e].types ? r[e].types : {},
    [i]: a || !0
  }
} : {}, Oo = (e) => Array.isArray(e) ? e : [e], PS = () => {
  let e = [];
  return {
    get observers() {
      return e;
    },
    next: (n) => {
      for (const r of e)
        r.next && r.next(n);
    },
    subscribe: (n) => (e.push(n), {
      unsubscribe: () => {
        e = e.filter((r) => r !== n);
      }
    }),
    unsubscribe: () => {
      e = [];
    }
  };
}, vy = (e) => Yt(e) || !Y1(e);
function hi(e, n) {
  if (vy(e) || vy(n))
    return e === n;
  if (Pi(e) && Pi(n))
    return e.getTime() === n.getTime();
  const r = Object.keys(e), i = Object.keys(n);
  if (r.length !== i.length)
    return !1;
  for (const a of r) {
    const o = e[a];
    if (!i.includes(a))
      return !1;
    if (a !== "ref") {
      const s = n[a];
      if (Pi(o) && Pi(s) || gt(o) && gt(s) || Array.isArray(o) && Array.isArray(s) ? !hi(o, s) : o !== s)
        return !1;
    }
  }
  return !0;
}
var Kt = (e) => gt(e) && !Object.keys(e).length, Og = (e) => e.type === "file", Ir = (e) => typeof e == "function", Ol = (e) => {
  if (!Eg)
    return !1;
  const n = e ? e.ownerDocument : 0;
  return e instanceof (n && n.defaultView ? n.defaultView.HTMLElement : HTMLElement);
}, nF = (e) => e.type === "select-multiple", Rg = (e) => e.type === "radio", Qq = (e) => Rg(e) || rs(e), Ym = (e) => Ol(e) && e.isConnected;
function Xq(e, n) {
  const r = n.slice(0, -1).length;
  let i = 0;
  for (; i < r; )
    e = ht(e) ? i++ : e[n[i++]];
  return e;
}
function Zq(e) {
  for (const n in e)
    if (e.hasOwnProperty(n) && !ht(e[n]))
      return !1;
  return !0;
}
function Nt(e, n) {
  const r = Array.isArray(n) ? n : $g(n) ? [n] : X1(n), i = r.length === 1 ? e : Xq(e, r), a = r.length - 1, o = r[a];
  return i && delete i[o], a !== 0 && (gt(i) && Kt(i) || Array.isArray(i) && Zq(i)) && Nt(e, r.slice(0, -1)), e;
}
var tF = (e) => {
  for (const n in e)
    if (Ir(e[n]))
      return !0;
  return !1;
};
function Rl(e, n = {}) {
  const r = Array.isArray(e);
  if (gt(e) || r)
    for (const i in e)
      Array.isArray(e[i]) || gt(e[i]) && !tF(e[i]) ? (n[i] = Array.isArray(e[i]) ? [] : {}, Rl(e[i], n[i])) : Yt(e[i]) || (n[i] = !0);
  return n;
}
function rF(e, n, r) {
  const i = Array.isArray(e);
  if (gt(e) || i)
    for (const a in e)
      Array.isArray(e[a]) || gt(e[a]) && !tF(e[a]) ? ht(n) || vy(r[a]) ? r[a] = Array.isArray(e[a]) ? Rl(e[a], []) : { ...Rl(e[a]) } : rF(e[a], Yt(n) ? {} : n[a], r[a]) : r[a] = !hi(e[a], n[a]);
  return r;
}
var yo = (e, n) => rF(e, n, Rl(n));
const AS = {
  value: !1,
  isValid: !1
}, LS = { value: !0, isValid: !0 };
var iF = (e) => {
  if (Array.isArray(e)) {
    if (e.length > 1) {
      const n = e.filter((r) => r && r.checked && !r.disabled).map((r) => r.value);
      return { value: n, isValid: !!n.length };
    }
    return e[0].checked && !e[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      e[0].attributes && !ht(e[0].attributes.value) ? ht(e[0].value) || e[0].value === "" ? LS : { value: e[0].value, isValid: !0 } : LS
    ) : AS;
  }
  return AS;
}, aF = (e, { valueAsNumber: n, valueAsDate: r, setValueAs: i }) => ht(e) ? e : n ? e === "" ? NaN : e && +e : r && qr(e) ? new Date(e) : i ? i(e) : e;
const VS = {
  isValid: !1,
  value: null
};
var oF = (e) => Array.isArray(e) ? e.reduce((n, r) => r && r.checked && !r.disabled ? {
  isValid: !0,
  value: r.value
} : n, VS) : VS;
function zS(e) {
  const n = e.ref;
  return Og(n) ? n.files : Rg(n) ? oF(e.refs).value : nF(n) ? [...n.selectedOptions].map(({ value: r }) => r) : rs(n) ? iF(e.refs).value : aF(ht(n.value) ? e.ref.value : n.value, e);
}
var e6 = (e, n, r, i) => {
  const a = {};
  for (const o of e) {
    const s = tn(n, o);
    s && it(a, o, s._f);
  }
  return {
    criteriaMode: r,
    names: [...e],
    fields: a,
    shouldUseNativeValidation: i
  };
}, Dl = (e) => e instanceof RegExp, go = (e) => ht(e) ? e : Dl(e) ? e.source : gt(e) ? Dl(e.value) ? e.value.source : e.value : e, US = (e) => ({
  isOnSubmit: !e || e === Fr.onSubmit,
  isOnBlur: e === Fr.onBlur,
  isOnChange: e === Fr.onChange,
  isOnAll: e === Fr.all,
  isOnTouch: e === Fr.onTouched
});
const MS = "AsyncFunction";
var n6 = (e) => !!e && !!e.validate && !!(Ir(e.validate) && e.validate.constructor.name === MS || gt(e.validate) && Object.values(e.validate).find((n) => n.constructor.name === MS)), t6 = (e) => e.mount && (e.required || e.min || e.max || e.maxLength || e.minLength || e.pattern || e.validate), BS = (e, n, r) => !r && (n.watchAll || n.watch.has(e) || [...n.watch].some((i) => e.startsWith(i) && /^\.\w+/.test(e.slice(i.length))));
const Ro = (e, n, r, i) => {
  for (const a of r || Object.keys(e)) {
    const o = tn(e, a);
    if (o) {
      const { _f: s, ...l } = o;
      if (s) {
        if (s.refs && s.refs[0] && n(s.refs[0], a) && !i || s.ref && n(s.ref, s.name) && !i)
          return !0;
        if (Ro(l, n))
          break;
      } else if (gt(l) && Ro(l, n))
        break;
    }
  }
};
function qS(e, n, r) {
  const i = tn(e, r);
  if (i || $g(r))
    return {
      error: i,
      name: r
    };
  const a = r.split(".");
  for (; a.length; ) {
    const o = a.join("."), s = tn(n, o), l = tn(e, o);
    if (s && !Array.isArray(s) && r !== o)
      return { name: r };
    if (l && l.type)
      return {
        name: o,
        error: l
      };
    a.pop();
  }
  return {
    name: r
  };
}
var r6 = (e, n, r, i) => {
  r(e);
  const { name: a, ...o } = e;
  return Kt(o) || Object.keys(o).length >= Object.keys(n).length || Object.keys(o).find((s) => n[s] === (!i || Fr.all));
}, i6 = (e, n, r) => !e || !n || e === n || Oo(e).some((i) => i && (r ? i === n : i.startsWith(n) || n.startsWith(i))), a6 = (e, n, r, i, a) => a.isOnAll ? !1 : !r && a.isOnTouch ? !(n || e) : (r ? i.isOnBlur : a.isOnBlur) ? !e : (r ? i.isOnChange : a.isOnChange) ? e : !0, o6 = (e, n) => !dc(tn(e, n)).length && Nt(e, n), s6 = (e, n, r) => {
  const i = Oo(tn(e, r));
  return it(i, "root", n[r]), it(e, r, i), e;
}, il = (e) => qr(e);
function HS(e, n, r = "validate") {
  if (il(e) || Array.isArray(e) && e.every(il) || lr(e) && !e)
    return {
      type: r,
      message: il(e) ? e : "",
      ref: n
    };
}
var sa = (e) => gt(e) && !Dl(e) ? e : {
  value: e,
  message: ""
}, WS = async (e, n, r, i, a, o) => {
  const { ref: s, refs: l, required: d, maxLength: m, minLength: u, min: f, max: h, pattern: k, validate: C, name: N, valueAsNumber: j, mount: _ } = e._f, g = tn(r, N);
  if (!_ || n.has(N))
    return {};
  const D = l ? l[0] : s, O = (Y) => {
    a && D.reportValidity && (D.setCustomValidity(lr(Y) ? "" : Y || ""), D.reportValidity());
  }, I = {}, F = Rg(s), L = rs(s), K = F || L, J = (j || Og(s)) && ht(s.value) && ht(g) || Ol(s) && s.value === "" || g === "" || Array.isArray(g) && !g.length, te = Jq.bind(null, N, i, I), W = (Y, P, B, re = ri.maxLength, je = ri.minLength) => {
    const ue = Y ? P : B;
    I[N] = {
      type: Y ? re : je,
      message: ue,
      ref: s,
      ...te(Y ? re : je, ue)
    };
  };
  if (o ? !Array.isArray(g) || !g.length : d && (!K && (J || Yt(g)) || lr(g) && !g || L && !iF(l).isValid || F && !oF(l).isValid)) {
    const { value: Y, message: P } = il(d) ? { value: !!d, message: d } : sa(d);
    if (Y && (I[N] = {
      type: ri.required,
      message: P,
      ref: D,
      ...te(ri.required, P)
    }, !i))
      return O(P), I;
  }
  if (!J && (!Yt(f) || !Yt(h))) {
    let Y, P;
    const B = sa(h), re = sa(f);
    if (!Yt(g) && !isNaN(g)) {
      const je = s.valueAsNumber || g && +g;
      Yt(B.value) || (Y = je > B.value), Yt(re.value) || (P = je < re.value);
    } else {
      const je = s.valueAsDate || new Date(g), ue = (V) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + V), se = s.type == "time", he = s.type == "week";
      qr(B.value) && g && (Y = se ? ue(g) > ue(B.value) : he ? g > B.value : je > new Date(B.value)), qr(re.value) && g && (P = se ? ue(g) < ue(re.value) : he ? g < re.value : je < new Date(re.value));
    }
    if ((Y || P) && (W(!!Y, B.message, re.message, ri.max, ri.min), !i))
      return O(I[N].message), I;
  }
  if ((m || u) && !J && (qr(g) || o && Array.isArray(g))) {
    const Y = sa(m), P = sa(u), B = !Yt(Y.value) && g.length > +Y.value, re = !Yt(P.value) && g.length < +P.value;
    if ((B || re) && (W(B, Y.message, P.message), !i))
      return O(I[N].message), I;
  }
  if (k && !J && qr(g)) {
    const { value: Y, message: P } = sa(k);
    if (Dl(Y) && !g.match(Y) && (I[N] = {
      type: ri.pattern,
      message: P,
      ref: s,
      ...te(ri.pattern, P)
    }, !i))
      return O(P), I;
  }
  if (C) {
    if (Ir(C)) {
      const Y = await C(g, r), P = HS(Y, D);
      if (P && (I[N] = {
        ...P,
        ...te(ri.validate, P.message)
      }, !i))
        return O(P.message), I;
    } else if (gt(C)) {
      let Y = {};
      for (const P in C) {
        if (!Kt(Y) && !i)
          break;
        const B = HS(await C[P](g, r), D, P);
        B && (Y = {
          ...B,
          ...te(P, B.message)
        }, O(B.message), i && (I[N] = Y));
      }
      if (!Kt(Y) && (I[N] = {
        ref: D,
        ...Y
      }, !i))
        return I;
    }
  }
  return O(!0), I;
};
const l6 = {
  mode: Fr.onSubmit,
  reValidateMode: Fr.onChange,
  shouldFocusError: !0
};
function c6(e = {}) {
  let n = {
    ...l6,
    ...e
  }, r = {
    submitCount: 0,
    isDirty: !1,
    isLoading: Ir(n.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1
  };
  const i = {};
  let a = gt(n.defaultValues) || gt(n.values) ? Dt(n.values || n.defaultValues) || {} : {}, o = n.shouldUnregister ? {} : Dt(a), s = {
    action: !1,
    mount: !1,
    watch: !1
  }, l = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, d, m = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let f = {
    ...u
  };
  const h = {
    array: PS(),
    state: PS()
  }, k = US(n.mode), C = US(n.reValidateMode), N = n.criteriaMode === Fr.all, j = (Q) => (E) => {
    clearTimeout(m), m = setTimeout(Q, E);
  }, _ = async (Q) => {
    if (!n.disabled && (u.isValid || f.isValid || Q)) {
      const E = n.resolver ? Kt((await J()).errors) : await W(i, !0);
      E !== r.isValid && h.state.next({
        isValid: E
      });
    }
  }, g = (Q, E) => {
    !n.disabled && (u.isValidating || u.validatingFields || f.isValidating || f.validatingFields) && ((Q || Array.from(l.mount)).forEach((z) => {
      z && (E ? it(r.validatingFields, z, E) : Nt(r.validatingFields, z));
    }), h.state.next({
      validatingFields: r.validatingFields,
      isValidating: !Kt(r.validatingFields)
    }));
  }, D = (Q, E = [], z, ie, ce = !0, U = !0) => {
    if (ie && z && !n.disabled) {
      if (s.action = !0, U && Array.isArray(tn(i, Q))) {
        const G = z(tn(i, Q), ie.argA, ie.argB);
        ce && it(i, Q, G);
      }
      if (U && Array.isArray(tn(r.errors, Q))) {
        const G = z(tn(r.errors, Q), ie.argA, ie.argB);
        ce && it(r.errors, Q, G), o6(r.errors, Q);
      }
      if ((u.touchedFields || f.touchedFields) && U && Array.isArray(tn(r.touchedFields, Q))) {
        const G = z(tn(r.touchedFields, Q), ie.argA, ie.argB);
        ce && it(r.touchedFields, Q, G);
      }
      (u.dirtyFields || f.dirtyFields) && (r.dirtyFields = yo(a, o)), h.state.next({
        name: Q,
        isDirty: P(Q, E),
        dirtyFields: r.dirtyFields,
        errors: r.errors,
        isValid: r.isValid
      });
    } else
      it(o, Q, E);
  }, O = (Q, E) => {
    it(r.errors, Q, E), h.state.next({
      errors: r.errors
    });
  }, I = (Q) => {
    r.errors = Q, h.state.next({
      errors: r.errors,
      isValid: !1
    });
  }, F = (Q, E, z, ie) => {
    const ce = tn(i, Q);
    if (ce) {
      const U = tn(o, Q, ht(z) ? tn(a, Q) : z);
      ht(U) || ie && ie.defaultChecked || E ? it(o, Q, E ? U : zS(ce._f)) : je(Q, U), s.mount && _();
    }
  }, L = (Q, E, z, ie, ce) => {
    let U = !1, G = !1;
    const ye = {
      name: Q
    };
    if (!n.disabled) {
      if (!z || ie) {
        (u.isDirty || f.isDirty) && (G = r.isDirty, r.isDirty = ye.isDirty = P(), U = G !== ye.isDirty);
        const Ne = hi(tn(a, Q), E);
        G = !!tn(r.dirtyFields, Q), Ne ? Nt(r.dirtyFields, Q) : it(r.dirtyFields, Q, !0), ye.dirtyFields = r.dirtyFields, U = U || (u.dirtyFields || f.dirtyFields) && G !== !Ne;
      }
      if (z) {
        const Ne = tn(r.touchedFields, Q);
        Ne || (it(r.touchedFields, Q, z), ye.touchedFields = r.touchedFields, U = U || (u.touchedFields || f.touchedFields) && Ne !== z);
      }
      U && ce && h.state.next(ye);
    }
    return U ? ye : {};
  }, K = (Q, E, z, ie) => {
    const ce = tn(r.errors, Q), U = (u.isValid || f.isValid) && lr(E) && r.isValid !== E;
    if (n.delayError && z ? (d = j(() => O(Q, z)), d(n.delayError)) : (clearTimeout(m), d = null, z ? it(r.errors, Q, z) : Nt(r.errors, Q)), (z ? !hi(ce, z) : ce) || !Kt(ie) || U) {
      const G = {
        ...ie,
        ...U && lr(E) ? { isValid: E } : {},
        errors: r.errors,
        name: Q
      };
      r = {
        ...r,
        ...G
      }, h.state.next(G);
    }
  }, J = async (Q) => {
    g(Q, !0);
    const E = await n.resolver(o, n.context, e6(Q || l.mount, i, n.criteriaMode, n.shouldUseNativeValidation));
    return g(Q), E;
  }, te = async (Q) => {
    const { errors: E } = await J(Q);
    if (Q)
      for (const z of Q) {
        const ie = tn(E, z);
        ie ? it(r.errors, z, ie) : Nt(r.errors, z);
      }
    else
      r.errors = E;
    return E;
  }, W = async (Q, E, z = {
    valid: !0
  }) => {
    for (const ie in Q) {
      const ce = Q[ie];
      if (ce) {
        const { _f: U, ...G } = ce;
        if (U) {
          const ye = l.array.has(U.name), Ne = ce._f && n6(ce._f);
          Ne && u.validatingFields && g([ie], !0);
          const Oe = await WS(ce, l.disabled, o, N, n.shouldUseNativeValidation && !E, ye);
          if (Ne && u.validatingFields && g([ie]), Oe[U.name] && (z.valid = !1, E))
            break;
          !E && (tn(Oe, U.name) ? ye ? s6(r.errors, Oe, U.name) : it(r.errors, U.name, Oe[U.name]) : Nt(r.errors, U.name));
        }
        !Kt(G) && await W(G, E, z);
      }
    }
    return z.valid;
  }, Y = () => {
    for (const Q of l.unMount) {
      const E = tn(i, Q);
      E && (E._f.refs ? E._f.refs.every((z) => !Ym(z)) : !Ym(E._f.ref)) && Be(Q);
    }
    l.unMount = /* @__PURE__ */ new Set();
  }, P = (Q, E) => !n.disabled && (Q && E && it(o, Q, E), !hi(De(), a)), B = (Q, E, z) => eF(Q, l, {
    ...s.mount ? o : ht(E) ? a : qr(Q) ? { [Q]: E } : E
  }, z, E), re = (Q) => dc(tn(s.mount ? o : a, Q, n.shouldUnregister ? tn(a, Q, []) : [])), je = (Q, E, z = {}) => {
    const ie = tn(i, Q);
    let ce = E;
    if (ie) {
      const U = ie._f;
      U && (!U.disabled && it(o, Q, aF(E, U)), ce = Ol(U.ref) && Yt(E) ? "" : E, nF(U.ref) ? [...U.ref.options].forEach((G) => G.selected = ce.includes(G.value)) : U.refs ? rs(U.ref) ? U.refs.length > 1 ? U.refs.forEach((G) => (!G.defaultChecked || !G.disabled) && (G.checked = Array.isArray(ce) ? !!ce.find((ye) => ye === G.value) : ce === G.value)) : U.refs[0] && (U.refs[0].checked = !!ce) : U.refs.forEach((G) => G.checked = G.value === ce) : Og(U.ref) ? U.ref.value = "" : (U.ref.value = ce, U.ref.type || h.state.next({
        name: Q,
        values: Dt(o)
      })));
    }
    (z.shouldDirty || z.shouldTouch) && L(Q, ce, z.shouldTouch, z.shouldDirty, !0), z.shouldValidate && ke(Q);
  }, ue = (Q, E, z) => {
    for (const ie in E) {
      const ce = E[ie], U = `${Q}.${ie}`, G = tn(i, U);
      (l.array.has(Q) || gt(ce) || G && !G._f) && !Pi(ce) ? ue(U, ce, z) : je(U, ce, z);
    }
  }, se = (Q, E, z = {}) => {
    const ie = tn(i, Q), ce = l.array.has(Q), U = Dt(E);
    it(o, Q, U), ce ? (h.array.next({
      name: Q,
      values: Dt(o)
    }), (u.isDirty || u.dirtyFields || f.isDirty || f.dirtyFields) && z.shouldDirty && h.state.next({
      name: Q,
      dirtyFields: yo(a, o),
      isDirty: P(Q, U)
    })) : ie && !ie._f && !Yt(U) ? ue(Q, U, z) : je(Q, U, z), BS(Q, l) && h.state.next({ ...r }), h.state.next({
      name: s.mount ? Q : void 0,
      values: Dt(o)
    });
  }, he = async (Q) => {
    s.mount = !0;
    const E = Q.target;
    let z = E.name, ie = !0;
    const ce = tn(i, z), U = (G) => {
      ie = Number.isNaN(G) || Pi(G) && isNaN(G.getTime()) || hi(G, tn(o, z, G));
    };
    if (ce) {
      let G, ye;
      const Ne = E.type ? zS(ce._f) : J1(Q), Oe = Q.type === Tl.BLUR || Q.type === Tl.FOCUS_OUT, rn = !t6(ce._f) && !n.resolver && !tn(r.errors, z) && !ce._f.deps || a6(Oe, tn(r.touchedFields, z), r.isSubmitted, C, k), kn = BS(z, l, Oe);
      it(o, z, Ne), Oe ? (ce._f.onBlur && ce._f.onBlur(Q), d && d(0)) : ce._f.onChange && ce._f.onChange(Q);
      const an = L(z, Ne, Oe), pn = !Kt(an) || kn;
      if (!Oe && h.state.next({
        name: z,
        type: Q.type,
        values: Dt(o)
      }), rn)
        return (u.isValid || f.isValid) && (n.mode === "onBlur" ? Oe && _() : Oe || _()), pn && h.state.next({ name: z, ...kn ? {} : an });
      if (!Oe && kn && h.state.next({ ...r }), n.resolver) {
        const { errors: $n } = await J([z]);
        if (U(Ne), ie) {
          const _n = qS(r.errors, i, z), Fn = qS($n, i, _n.name || z);
          G = Fn.error, z = Fn.name, ye = Kt($n);
        }
      } else
        g([z], !0), G = (await WS(ce, l.disabled, o, N, n.shouldUseNativeValidation))[z], g([z]), U(Ne), ie && (G ? ye = !1 : (u.isValid || f.isValid) && (ye = await W(i, !0)));
      ie && (ce._f.deps && ke(ce._f.deps), K(z, ye, G, an));
    }
  }, V = (Q, E) => {
    if (tn(r.errors, E) && Q.focus)
      return Q.focus(), 1;
  }, ke = async (Q, E = {}) => {
    let z, ie;
    const ce = Oo(Q);
    if (n.resolver) {
      const U = await te(ht(Q) ? Q : ce);
      z = Kt(U), ie = Q ? !ce.some((G) => tn(U, G)) : z;
    } else Q ? (ie = (await Promise.all(ce.map(async (U) => {
      const G = tn(i, U);
      return await W(G && G._f ? { [U]: G } : G);
    }))).every(Boolean), !(!ie && !r.isValid) && _()) : ie = z = await W(i);
    return h.state.next({
      ...!qr(Q) || (u.isValid || f.isValid) && z !== r.isValid ? {} : { name: Q },
      ...n.resolver || !Q ? { isValid: z } : {},
      errors: r.errors
    }), E.shouldFocus && !ie && Ro(i, V, Q ? ce : l.mount), ie;
  }, De = (Q) => {
    const E = {
      ...s.mount ? o : a
    };
    return ht(Q) ? E : qr(Q) ? tn(E, Q) : Q.map((z) => tn(E, z));
  }, q = (Q, E) => ({
    invalid: !!tn((E || r).errors, Q),
    isDirty: !!tn((E || r).dirtyFields, Q),
    error: tn((E || r).errors, Q),
    isValidating: !!tn(r.validatingFields, Q),
    isTouched: !!tn((E || r).touchedFields, Q)
  }), Ge = (Q) => {
    Q && Oo(Q).forEach((E) => Nt(r.errors, E)), h.state.next({
      errors: Q ? r.errors : {}
    });
  }, sn = (Q, E, z) => {
    const ie = (tn(i, Q, { _f: {} })._f || {}).ref, ce = tn(r.errors, Q) || {}, { ref: U, message: G, type: ye, ...Ne } = ce;
    it(r.errors, Q, {
      ...Ne,
      ...E,
      ref: ie
    }), h.state.next({
      name: Q,
      errors: r.errors,
      isValid: !1
    }), z && z.shouldFocus && ie && ie.focus && ie.focus();
  }, Ie = (Q, E) => Ir(Q) ? h.state.subscribe({
    next: (z) => Q(B(void 0, E), z)
  }) : B(Q, E, !0), Ue = (Q) => h.state.subscribe({
    next: (E) => {
      i6(Q.name, E.name, Q.exact) && r6(E, Q.formState || u, Pe, Q.reRenderRoot) && Q.callback({
        values: { ...o },
        ...r,
        ...E
      });
    }
  }).unsubscribe, Re = (Q) => (s.mount = !0, f = {
    ...f,
    ...Q.formState
  }, Ue({
    ...Q,
    formState: f
  })), Be = (Q, E = {}) => {
    for (const z of Q ? Oo(Q) : l.mount)
      l.mount.delete(z), l.array.delete(z), E.keepValue || (Nt(i, z), Nt(o, z)), !E.keepError && Nt(r.errors, z), !E.keepDirty && Nt(r.dirtyFields, z), !E.keepTouched && Nt(r.touchedFields, z), !E.keepIsValidating && Nt(r.validatingFields, z), !n.shouldUnregister && !E.keepDefaultValue && Nt(a, z);
    h.state.next({
      values: Dt(o)
    }), h.state.next({
      ...r,
      ...E.keepDirty ? { isDirty: P() } : {}
    }), !E.keepIsValid && _();
  }, Ae = ({ disabled: Q, name: E }) => {
    (lr(Q) && s.mount || Q || l.disabled.has(E)) && (Q ? l.disabled.add(E) : l.disabled.delete(E));
  }, Je = (Q, E = {}) => {
    let z = tn(i, Q);
    const ie = lr(E.disabled) || lr(n.disabled);
    return it(i, Q, {
      ...z || {},
      _f: {
        ...z && z._f ? z._f : { ref: { name: Q } },
        name: Q,
        mount: !0,
        ...E
      }
    }), l.mount.add(Q), z ? Ae({
      disabled: lr(E.disabled) ? E.disabled : n.disabled,
      name: Q
    }) : F(Q, !0, E.value), {
      ...ie ? { disabled: E.disabled || n.disabled } : {},
      ...n.progressive ? {
        required: !!E.required,
        min: go(E.min),
        max: go(E.max),
        minLength: go(E.minLength),
        maxLength: go(E.maxLength),
        pattern: go(E.pattern)
      } : {},
      name: Q,
      onChange: he,
      onBlur: he,
      ref: (ce) => {
        if (ce) {
          Je(Q, E), z = tn(i, Q);
          const U = ht(ce.value) && ce.querySelectorAll && ce.querySelectorAll("input,select,textarea")[0] || ce, G = Qq(U), ye = z._f.refs || [];
          if (G ? ye.find((Ne) => Ne === U) : U === z._f.ref)
            return;
          it(i, Q, {
            _f: {
              ...z._f,
              ...G ? {
                refs: [
                  ...ye.filter(Ym),
                  U,
                  ...Array.isArray(tn(a, Q)) ? [{}] : []
                ],
                ref: { type: U.type, name: Q }
              } : { ref: U }
            }
          }), F(Q, !1, void 0, U);
        } else
          z = tn(i, Q, {}), z._f && (z._f.mount = !1), (n.shouldUnregister || E.shouldUnregister) && !(Q1(l.array, Q) && s.action) && l.unMount.add(Q);
      }
    };
  }, $e = () => n.shouldFocusError && Ro(i, V, l.mount), Me = (Q) => {
    lr(Q) && (h.state.next({ disabled: Q }), Ro(i, (E, z) => {
      const ie = tn(i, z);
      ie && (E.disabled = ie._f.disabled || Q, Array.isArray(ie._f.refs) && ie._f.refs.forEach((ce) => {
        ce.disabled = ie._f.disabled || Q;
      }));
    }, 0, !1));
  }, en = (Q, E) => async (z) => {
    let ie;
    z && (z.preventDefault && z.preventDefault(), z.persist && z.persist());
    let ce = Dt(o);
    if (h.state.next({
      isSubmitting: !0
    }), n.resolver) {
      const { errors: U, values: G } = await J();
      r.errors = U, ce = G;
    } else
      await W(i);
    if (l.disabled.size)
      for (const U of l.disabled)
        it(ce, U, void 0);
    if (Nt(r.errors, "root"), Kt(r.errors)) {
      h.state.next({
        errors: {}
      });
      try {
        await Q(ce, z);
      } catch (U) {
        ie = U;
      }
    } else
      E && await E({ ...r.errors }, z), $e(), setTimeout($e);
    if (h.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Kt(r.errors) && !ie,
      submitCount: r.submitCount + 1,
      errors: r.errors
    }), ie)
      throw ie;
  }, oe = (Q, E = {}) => {
    tn(i, Q) && (ht(E.defaultValue) ? se(Q, Dt(tn(a, Q))) : (se(Q, E.defaultValue), it(a, Q, Dt(E.defaultValue))), E.keepTouched || Nt(r.touchedFields, Q), E.keepDirty || (Nt(r.dirtyFields, Q), r.isDirty = E.defaultValue ? P(Q, Dt(tn(a, Q))) : P()), E.keepError || (Nt(r.errors, Q), u.isValid && _()), h.state.next({ ...r }));
  }, le = (Q, E = {}) => {
    const z = Q ? Dt(Q) : a, ie = Dt(z), ce = Kt(Q), U = ce ? a : ie;
    if (E.keepDefaultValues || (a = z), !E.keepValues) {
      if (E.keepDirtyValues) {
        const G = /* @__PURE__ */ new Set([
          ...l.mount,
          ...Object.keys(yo(a, o))
        ]);
        for (const ye of Array.from(G))
          tn(r.dirtyFields, ye) ? it(U, ye, tn(o, ye)) : se(ye, tn(U, ye));
      } else {
        if (Eg && ht(Q))
          for (const G of l.mount) {
            const ye = tn(i, G);
            if (ye && ye._f) {
              const Ne = Array.isArray(ye._f.refs) ? ye._f.refs[0] : ye._f.ref;
              if (Ol(Ne)) {
                const Oe = Ne.closest("form");
                if (Oe) {
                  Oe.reset();
                  break;
                }
              }
            }
          }
        for (const G of l.mount)
          se(G, tn(U, G));
      }
      o = Dt(U), h.array.next({
        values: { ...U }
      }), h.state.next({
        values: { ...U }
      });
    }
    l = {
      mount: E.keepDirtyValues ? l.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, s.mount = !u.isValid || !!E.keepIsValid || !!E.keepDirtyValues, s.watch = !!n.shouldUnregister, h.state.next({
      submitCount: E.keepSubmitCount ? r.submitCount : 0,
      isDirty: ce ? !1 : E.keepDirty ? r.isDirty : !!(E.keepDefaultValues && !hi(Q, a)),
      isSubmitted: E.keepIsSubmitted ? r.isSubmitted : !1,
      dirtyFields: ce ? {} : E.keepDirtyValues ? E.keepDefaultValues && o ? yo(a, o) : r.dirtyFields : E.keepDefaultValues && Q ? yo(a, Q) : E.keepDirty ? r.dirtyFields : {},
      touchedFields: E.keepTouched ? r.touchedFields : {},
      errors: E.keepErrors ? r.errors : {},
      isSubmitSuccessful: E.keepIsSubmitSuccessful ? r.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, xe = (Q, E) => le(Ir(Q) ? Q(o) : Q, E), Ve = (Q, E = {}) => {
    const z = tn(i, Q), ie = z && z._f;
    if (ie) {
      const ce = ie.refs ? ie.refs[0] : ie.ref;
      ce.focus && (ce.focus(), E.shouldSelect && Ir(ce.select) && ce.select());
    }
  }, Pe = (Q) => {
    r = {
      ...r,
      ...Q
    };
  }, vn = {
    control: {
      register: Je,
      unregister: Be,
      getFieldState: q,
      handleSubmit: en,
      setError: sn,
      _subscribe: Ue,
      _runSchema: J,
      _getWatch: B,
      _getDirty: P,
      _setValid: _,
      _setFieldArray: D,
      _setDisabledField: Ae,
      _setErrors: I,
      _getFieldArray: re,
      _reset: le,
      _resetDefaultValues: () => Ir(n.defaultValues) && n.defaultValues().then((Q) => {
        xe(Q, n.resetOptions), h.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: Y,
      _disableForm: Me,
      _subjects: h,
      _proxyFormState: u,
      get _fields() {
        return i;
      },
      get _formValues() {
        return o;
      },
      get _state() {
        return s;
      },
      set _state(Q) {
        s = Q;
      },
      get _defaultValues() {
        return a;
      },
      get _names() {
        return l;
      },
      set _names(Q) {
        l = Q;
      },
      get _formState() {
        return r;
      },
      get _options() {
        return n;
      },
      set _options(Q) {
        n = {
          ...n,
          ...Q
        };
      }
    },
    subscribe: Re,
    trigger: ke,
    register: Je,
    handleSubmit: en,
    watch: Ie,
    setValue: se,
    getValues: De,
    reset: xe,
    resetField: oe,
    clearErrors: Ge,
    unregister: Be,
    setError: sn,
    setFocus: Ve,
    getFieldState: q
  };
  return {
    ...vn,
    formControl: vn
  };
}
function d6(e = {}) {
  const n = qe.useRef(void 0), r = qe.useRef(void 0), [i, a] = qe.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: Ir(e.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1,
    defaultValues: Ir(e.defaultValues) ? void 0 : e.defaultValues
  });
  n.current || (n.current = {
    ...e.formControl ? e.formControl : c6(e),
    formState: i
  }, e.formControl && e.defaultValues && !Ir(e.defaultValues) && e.formControl.reset(e.defaultValues, e.resetOptions));
  const o = n.current.control;
  return o._options = e, qe.useLayoutEffect(() => o._subscribe({
    formState: o._proxyFormState,
    callback: () => a({ ...o._formState }),
    reRenderRoot: !0
  }), [o]), qe.useEffect(() => o._disableForm(e.disabled), [o, e.disabled]), qe.useEffect(() => {
    if (o._proxyFormState.isDirty) {
      const s = o._getDirty();
      s !== i.isDirty && o._subjects.state.next({
        isDirty: s
      });
    }
  }, [o, i.isDirty]), qe.useEffect(() => {
    e.values && !hi(e.values, r.current) ? (o._reset(e.values, o._options.resetOptions), r.current = e.values, a((s) => ({ ...s }))) : o._resetDefaultValues();
  }, [e.values, o]), qe.useEffect(() => {
    e.errors && !Kt(e.errors) && o._setErrors(e.errors);
  }, [e.errors, o]), qe.useEffect(() => {
    o._state.mount || (o._setValid(), o._state.mount = !0), o._state.watch && (o._state.watch = !1, o._subjects.state.next({ ...o._formState })), o._removeUnmounted();
  }), qe.useEffect(() => {
    e.shouldUnregister && o._subjects.state.next({
      values: o._getWatch()
    });
  }, [e.shouldUnregister, o]), n.current.formState = Z1(i, o), n.current;
}
var Ds = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function sF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Jm = { exports: {} }, vo = {}, KS;
function u6() {
  if (KS) return vo;
  KS = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return vo.Fragment = r, vo.jsx = s, vo.jsxs = s, vo;
}
var Ps = {}, GS;
function m6() {
  return GS || (GS = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Ps.Fragment = i, Ps.jsx = zn, Ps.jsxs = Wn;
  })()), Ps;
}
var YS;
function p6() {
  return YS || (YS = 1, process.env.NODE_ENV === "production" ? Jm.exports = u6() : Jm.exports = m6()), Jm.exports;
}
var Do = p6();
function f6(e) {
  return !e || typeof e == "boolean" || typeof e == "string" ? !!e : e.value;
}
var Qm, JS;
function _i() {
  if (JS) return Qm;
  JS = 1;
  var e = Array.isArray;
  return Qm = e, Qm;
}
var Xm, QS;
function lF() {
  if (QS) return Xm;
  QS = 1;
  var e = typeof Ds == "object" && Ds && Ds.Object === Object && Ds;
  return Xm = e, Xm;
}
var Zm, XS;
function Jr() {
  if (XS) return Zm;
  XS = 1;
  var e = lF(), n = typeof self == "object" && self && self.Object === Object && self, r = e || n || Function("return this")();
  return Zm = r, Zm;
}
var ep, ZS;
function is() {
  if (ZS) return ep;
  ZS = 1;
  var e = Jr(), n = e.Symbol;
  return ep = n, ep;
}
var np, e0;
function h6() {
  if (e0) return np;
  e0 = 1;
  var e = is(), n = Object.prototype, r = n.hasOwnProperty, i = n.toString, a = e ? e.toStringTag : void 0;
  function o(s) {
    var l = r.call(s, a), d = s[a];
    try {
      s[a] = void 0;
      var m = !0;
    } catch {
    }
    var u = i.call(s);
    return m && (l ? s[a] = d : delete s[a]), u;
  }
  return np = o, np;
}
var tp, n0;
function y6() {
  if (n0) return tp;
  n0 = 1;
  var e = Object.prototype, n = e.toString;
  function r(i) {
    return n.call(i);
  }
  return tp = r, tp;
}
var rp, t0;
function Pa() {
  if (t0) return rp;
  t0 = 1;
  var e = is(), n = h6(), r = y6(), i = "[object Null]", a = "[object Undefined]", o = e ? e.toStringTag : void 0;
  function s(l) {
    return l == null ? l === void 0 ? a : i : o && o in Object(l) ? n(l) : r(l);
  }
  return rp = s, rp;
}
var ip, r0;
function Yi() {
  if (r0) return ip;
  r0 = 1;
  function e(n) {
    return n != null && typeof n == "object";
  }
  return ip = e, ip;
}
var ap, i0;
function Dg() {
  if (i0) return ap;
  i0 = 1;
  var e = Pa(), n = Yi(), r = "[object Symbol]";
  function i(a) {
    return typeof a == "symbol" || n(a) && e(a) == r;
  }
  return ap = i, ap;
}
var op, a0;
function g6() {
  if (a0) return op;
  a0 = 1;
  var e = _i(), n = Dg(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, i = /^\w*$/;
  function a(o, s) {
    if (e(o))
      return !1;
    var l = typeof o;
    return l == "number" || l == "symbol" || l == "boolean" || o == null || n(o) ? !0 : i.test(o) || !r.test(o) || s != null && o in Object(s);
  }
  return op = a, op;
}
var sp, o0;
function Aa() {
  if (o0) return sp;
  o0 = 1;
  function e(n) {
    var r = typeof n;
    return n != null && (r == "object" || r == "function");
  }
  return sp = e, sp;
}
var lp, s0;
function cF() {
  if (s0) return lp;
  s0 = 1;
  var e = Pa(), n = Aa(), r = "[object AsyncFunction]", i = "[object Function]", a = "[object GeneratorFunction]", o = "[object Proxy]";
  function s(l) {
    if (!n(l))
      return !1;
    var d = e(l);
    return d == i || d == a || d == r || d == o;
  }
  return lp = s, lp;
}
var cp, l0;
function v6() {
  if (l0) return cp;
  l0 = 1;
  var e = Jr(), n = e["__core-js_shared__"];
  return cp = n, cp;
}
var dp, c0;
function k6() {
  if (c0) return dp;
  c0 = 1;
  var e = v6(), n = (function() {
    var i = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return i ? "Symbol(src)_1." + i : "";
  })();
  function r(i) {
    return !!n && n in i;
  }
  return dp = r, dp;
}
var up, d0;
function dF() {
  if (d0) return up;
  d0 = 1;
  var e = Function.prototype, n = e.toString;
  function r(i) {
    if (i != null) {
      try {
        return n.call(i);
      } catch {
      }
      try {
        return i + "";
      } catch {
      }
    }
    return "";
  }
  return up = r, up;
}
var mp, u0;
function b6() {
  if (u0) return mp;
  u0 = 1;
  var e = cF(), n = k6(), r = Aa(), i = dF(), a = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, s = Function.prototype, l = Object.prototype, d = s.toString, m = l.hasOwnProperty, u = RegExp(
    "^" + d.call(m).replace(a, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function f(h) {
    if (!r(h) || n(h))
      return !1;
    var k = e(h) ? u : o;
    return k.test(i(h));
  }
  return mp = f, mp;
}
var pp, m0;
function _6() {
  if (m0) return pp;
  m0 = 1;
  function e(n, r) {
    return n?.[r];
  }
  return pp = e, pp;
}
var fp, p0;
function Ji() {
  if (p0) return fp;
  p0 = 1;
  var e = b6(), n = _6();
  function r(i, a) {
    var o = n(i, a);
    return e(o) ? o : void 0;
  }
  return fp = r, fp;
}
var hp, f0;
function uc() {
  if (f0) return hp;
  f0 = 1;
  var e = Ji(), n = e(Object, "create");
  return hp = n, hp;
}
var yp, h0;
function x6() {
  if (h0) return yp;
  h0 = 1;
  var e = uc();
  function n() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return yp = n, yp;
}
var gp, y0;
function S6() {
  if (y0) return gp;
  y0 = 1;
  function e(n) {
    var r = this.has(n) && delete this.__data__[n];
    return this.size -= r ? 1 : 0, r;
  }
  return gp = e, gp;
}
var vp, g0;
function N6() {
  if (g0) return vp;
  g0 = 1;
  var e = uc(), n = "__lodash_hash_undefined__", r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    var s = this.__data__;
    if (e) {
      var l = s[o];
      return l === n ? void 0 : l;
    }
    return i.call(s, o) ? s[o] : void 0;
  }
  return vp = a, vp;
}
var kp, v0;
function j6() {
  if (v0) return kp;
  v0 = 1;
  var e = uc(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var o = this.__data__;
    return e ? o[a] !== void 0 : r.call(o, a);
  }
  return kp = i, kp;
}
var bp, k0;
function w6() {
  if (k0) return bp;
  k0 = 1;
  var e = uc(), n = "__lodash_hash_undefined__";
  function r(i, a) {
    var o = this.__data__;
    return this.size += this.has(i) ? 0 : 1, o[i] = e && a === void 0 ? n : a, this;
  }
  return bp = r, bp;
}
var _p, b0;
function C6() {
  if (b0) return _p;
  b0 = 1;
  var e = x6(), n = S6(), r = N6(), i = j6(), a = w6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, _p = o, _p;
}
var xp, _0;
function F6() {
  if (_0) return xp;
  _0 = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return xp = e, xp;
}
var Sp, x0;
function uF() {
  if (x0) return Sp;
  x0 = 1;
  function e(n, r) {
    return n === r || n !== n && r !== r;
  }
  return Sp = e, Sp;
}
var Np, S0;
function mc() {
  if (S0) return Np;
  S0 = 1;
  var e = uF();
  function n(r, i) {
    for (var a = r.length; a--; )
      if (e(r[a][0], i))
        return a;
    return -1;
  }
  return Np = n, Np;
}
var jp, N0;
function I6() {
  if (N0) return jp;
  N0 = 1;
  var e = mc(), n = Array.prototype, r = n.splice;
  function i(a) {
    var o = this.__data__, s = e(o, a);
    if (s < 0)
      return !1;
    var l = o.length - 1;
    return s == l ? o.pop() : r.call(o, s, 1), --this.size, !0;
  }
  return jp = i, jp;
}
var wp, j0;
function E6() {
  if (j0) return wp;
  j0 = 1;
  var e = mc();
  function n(r) {
    var i = this.__data__, a = e(i, r);
    return a < 0 ? void 0 : i[a][1];
  }
  return wp = n, wp;
}
var Cp, w0;
function $6() {
  if (w0) return Cp;
  w0 = 1;
  var e = mc();
  function n(r) {
    return e(this.__data__, r) > -1;
  }
  return Cp = n, Cp;
}
var Fp, C0;
function T6() {
  if (C0) return Fp;
  C0 = 1;
  var e = mc();
  function n(r, i) {
    var a = this.__data__, o = e(a, r);
    return o < 0 ? (++this.size, a.push([r, i])) : a[o][1] = i, this;
  }
  return Fp = n, Fp;
}
var Ip, F0;
function pc() {
  if (F0) return Ip;
  F0 = 1;
  var e = F6(), n = I6(), r = E6(), i = $6(), a = T6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Ip = o, Ip;
}
var Ep, I0;
function Pg() {
  if (I0) return Ep;
  I0 = 1;
  var e = Ji(), n = Jr(), r = e(n, "Map");
  return Ep = r, Ep;
}
var $p, E0;
function O6() {
  if (E0) return $p;
  E0 = 1;
  var e = C6(), n = pc(), r = Pg();
  function i() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (r || n)(),
      string: new e()
    };
  }
  return $p = i, $p;
}
var Tp, $0;
function R6() {
  if ($0) return Tp;
  $0 = 1;
  function e(n) {
    var r = typeof n;
    return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? n !== "__proto__" : n === null;
  }
  return Tp = e, Tp;
}
var Op, T0;
function fc() {
  if (T0) return Op;
  T0 = 1;
  var e = R6();
  function n(r, i) {
    var a = r.__data__;
    return e(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
  }
  return Op = n, Op;
}
var Rp, O0;
function D6() {
  if (O0) return Rp;
  O0 = 1;
  var e = fc();
  function n(r) {
    var i = e(this, r).delete(r);
    return this.size -= i ? 1 : 0, i;
  }
  return Rp = n, Rp;
}
var Dp, R0;
function P6() {
  if (R0) return Dp;
  R0 = 1;
  var e = fc();
  function n(r) {
    return e(this, r).get(r);
  }
  return Dp = n, Dp;
}
var Pp, D0;
function A6() {
  if (D0) return Pp;
  D0 = 1;
  var e = fc();
  function n(r) {
    return e(this, r).has(r);
  }
  return Pp = n, Pp;
}
var Ap, P0;
function L6() {
  if (P0) return Ap;
  P0 = 1;
  var e = fc();
  function n(r, i) {
    var a = e(this, r), o = a.size;
    return a.set(r, i), this.size += a.size == o ? 0 : 1, this;
  }
  return Ap = n, Ap;
}
var Lp, A0;
function mF() {
  if (A0) return Lp;
  A0 = 1;
  var e = O6(), n = D6(), r = P6(), i = A6(), a = L6();
  function o(s) {
    var l = -1, d = s == null ? 0 : s.length;
    for (this.clear(); ++l < d; ) {
      var m = s[l];
      this.set(m[0], m[1]);
    }
  }
  return o.prototype.clear = e, o.prototype.delete = n, o.prototype.get = r, o.prototype.has = i, o.prototype.set = a, Lp = o, Lp;
}
var Vp, L0;
function V6() {
  if (L0) return Vp;
  L0 = 1;
  var e = mF(), n = "Expected a function";
  function r(i, a) {
    if (typeof i != "function" || a != null && typeof a != "function")
      throw new TypeError(n);
    var o = function() {
      var s = arguments, l = a ? a.apply(this, s) : s[0], d = o.cache;
      if (d.has(l))
        return d.get(l);
      var m = i.apply(this, s);
      return o.cache = d.set(l, m) || d, m;
    };
    return o.cache = new (r.Cache || e)(), o;
  }
  return r.Cache = e, Vp = r, Vp;
}
var zp, V0;
function z6() {
  if (V0) return zp;
  V0 = 1;
  var e = V6(), n = 500;
  function r(i) {
    var a = e(i, function(s) {
      return o.size === n && o.clear(), s;
    }), o = a.cache;
    return a;
  }
  return zp = r, zp;
}
var Up, z0;
function U6() {
  if (z0) return Up;
  z0 = 1;
  var e = z6(), n = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, i = e(function(a) {
    var o = [];
    return a.charCodeAt(0) === 46 && o.push(""), a.replace(n, function(s, l, d, m) {
      o.push(d ? m.replace(r, "$1") : l || s);
    }), o;
  });
  return Up = i, Up;
}
var Mp, U0;
function pF() {
  if (U0) return Mp;
  U0 = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = Array(a); ++i < a; )
      o[i] = r(n[i], i, n);
    return o;
  }
  return Mp = e, Mp;
}
var Bp, M0;
function M6() {
  if (M0) return Bp;
  M0 = 1;
  var e = is(), n = pF(), r = _i(), i = Dg(), a = e ? e.prototype : void 0, o = a ? a.toString : void 0;
  function s(l) {
    if (typeof l == "string")
      return l;
    if (r(l))
      return n(l, s) + "";
    if (i(l))
      return o ? o.call(l) : "";
    var d = l + "";
    return d == "0" && 1 / l == -1 / 0 ? "-0" : d;
  }
  return Bp = s, Bp;
}
var qp, B0;
function B6() {
  if (B0) return qp;
  B0 = 1;
  var e = M6();
  function n(r) {
    return r == null ? "" : e(r);
  }
  return qp = n, qp;
}
var Hp, q0;
function La() {
  if (q0) return Hp;
  q0 = 1;
  var e = _i(), n = g6(), r = U6(), i = B6();
  function a(o, s) {
    return e(o) ? o : n(o, s) ? [o] : r(i(o));
  }
  return Hp = a, Hp;
}
var Wp, H0;
function hc() {
  if (H0) return Wp;
  H0 = 1;
  var e = Dg();
  function n(r) {
    if (typeof r == "string" || e(r))
      return r;
    var i = r + "";
    return i == "0" && 1 / r == -1 / 0 ? "-0" : i;
  }
  return Wp = n, Wp;
}
var Kp, W0;
function fF() {
  if (W0) return Kp;
  W0 = 1;
  var e = La(), n = hc();
  function r(i, a) {
    a = e(a, i);
    for (var o = 0, s = a.length; i != null && o < s; )
      i = i[n(a[o++])];
    return o && o == s ? i : void 0;
  }
  return Kp = r, Kp;
}
var Gp, K0;
function hF() {
  if (K0) return Gp;
  K0 = 1;
  var e = Ji(), n = (function() {
    try {
      var r = e(Object, "defineProperty");
      return r({}, "", {}), r;
    } catch {
    }
  })();
  return Gp = n, Gp;
}
var Yp, G0;
function yF() {
  if (G0) return Yp;
  G0 = 1;
  var e = hF();
  function n(r, i, a) {
    i == "__proto__" && e ? e(r, i, {
      configurable: !0,
      enumerable: !0,
      value: a,
      writable: !0
    }) : r[i] = a;
  }
  return Yp = n, Yp;
}
var Jp, Y0;
function Ag() {
  if (Y0) return Jp;
  Y0 = 1;
  var e = yF(), n = uF(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o, s, l) {
    var d = o[s];
    (!(i.call(o, s) && n(d, l)) || l === void 0 && !(s in o)) && e(o, s, l);
  }
  return Jp = a, Jp;
}
var Qp, J0;
function Lg() {
  if (J0) return Qp;
  J0 = 1;
  var e = 9007199254740991, n = /^(?:0|[1-9]\d*)$/;
  function r(i, a) {
    var o = typeof i;
    return a = a ?? e, !!a && (o == "number" || o != "symbol" && n.test(i)) && i > -1 && i % 1 == 0 && i < a;
  }
  return Qp = r, Qp;
}
var Xp, Q0;
function q6() {
  if (Q0) return Xp;
  Q0 = 1;
  var e = Ag(), n = La(), r = Lg(), i = Aa(), a = hc();
  function o(s, l, d, m) {
    if (!i(s))
      return s;
    l = n(l, s);
    for (var u = -1, f = l.length, h = f - 1, k = s; k != null && ++u < f; ) {
      var C = a(l[u]), N = d;
      if (C === "__proto__" || C === "constructor" || C === "prototype")
        return s;
      if (u != h) {
        var j = k[C];
        N = m ? m(j, C, k) : void 0, N === void 0 && (N = i(j) ? j : r(l[u + 1]) ? [] : {});
      }
      e(k, C, N), k = k[C];
    }
    return s;
  }
  return Xp = o, Xp;
}
var Zp, X0;
function H6() {
  if (X0) return Zp;
  X0 = 1;
  var e = fF(), n = q6(), r = La();
  function i(a, o, s) {
    for (var l = -1, d = o.length, m = {}; ++l < d; ) {
      var u = o[l], f = e(a, u);
      s(f, u) && n(m, r(u, a), f);
    }
    return m;
  }
  return Zp = i, Zp;
}
var ef, Z0;
function W6() {
  if (Z0) return ef;
  Z0 = 1;
  function e(n, r) {
    return n != null && r in Object(n);
  }
  return ef = e, ef;
}
var nf, eN;
function K6() {
  if (eN) return nf;
  eN = 1;
  var e = Pa(), n = Yi(), r = "[object Arguments]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return nf = i, nf;
}
var tf, nN;
function Vg() {
  if (nN) return tf;
  nN = 1;
  var e = K6(), n = Yi(), r = Object.prototype, i = r.hasOwnProperty, a = r.propertyIsEnumerable, o = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return n(s) && i.call(s, "callee") && !a.call(s, "callee");
  };
  return tf = o, tf;
}
var rf, tN;
function zg() {
  if (tN) return rf;
  tN = 1;
  var e = 9007199254740991;
  function n(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
  }
  return rf = n, rf;
}
var af, rN;
function G6() {
  if (rN) return af;
  rN = 1;
  var e = La(), n = Vg(), r = _i(), i = Lg(), a = zg(), o = hc();
  function s(l, d, m) {
    d = e(d, l);
    for (var u = -1, f = d.length, h = !1; ++u < f; ) {
      var k = o(d[u]);
      if (!(h = l != null && m(l, k)))
        break;
      l = l[k];
    }
    return h || ++u != f ? h : (f = l == null ? 0 : l.length, !!f && a(f) && i(k, f) && (r(l) || n(l)));
  }
  return af = s, af;
}
var of, iN;
function Y6() {
  if (iN) return of;
  iN = 1;
  var e = W6(), n = G6();
  function r(i, a) {
    return i != null && n(i, a, e);
  }
  return of = r, of;
}
var sf, aN;
function J6() {
  if (aN) return sf;
  aN = 1;
  var e = H6(), n = Y6();
  function r(i, a) {
    return e(i, a, function(o, s) {
      return n(i, s);
    });
  }
  return sf = r, sf;
}
var lf, oN;
function Ug() {
  if (oN) return lf;
  oN = 1;
  function e(n, r) {
    for (var i = -1, a = r.length, o = n.length; ++i < a; )
      n[o + i] = r[i];
    return n;
  }
  return lf = e, lf;
}
var cf, sN;
function Q6() {
  if (sN) return cf;
  sN = 1;
  var e = is(), n = Vg(), r = _i(), i = e ? e.isConcatSpreadable : void 0;
  function a(o) {
    return r(o) || n(o) || !!(i && o && o[i]);
  }
  return cf = a, cf;
}
var df, lN;
function X6() {
  if (lN) return df;
  lN = 1;
  var e = Ug(), n = Q6();
  function r(i, a, o, s, l) {
    var d = -1, m = i.length;
    for (o || (o = n), l || (l = []); ++d < m; ) {
      var u = i[d];
      a > 0 && o(u) ? a > 1 ? r(u, a - 1, o, s, l) : e(l, u) : s || (l[l.length] = u);
    }
    return l;
  }
  return df = r, df;
}
var uf, cN;
function Z6() {
  if (cN) return uf;
  cN = 1;
  var e = X6();
  function n(r) {
    var i = r == null ? 0 : r.length;
    return i ? e(r, 1) : [];
  }
  return uf = n, uf;
}
var mf, dN;
function eH() {
  if (dN) return mf;
  dN = 1;
  function e(n, r, i) {
    switch (i.length) {
      case 0:
        return n.call(r);
      case 1:
        return n.call(r, i[0]);
      case 2:
        return n.call(r, i[0], i[1]);
      case 3:
        return n.call(r, i[0], i[1], i[2]);
    }
    return n.apply(r, i);
  }
  return mf = e, mf;
}
var pf, uN;
function nH() {
  if (uN) return pf;
  uN = 1;
  var e = eH(), n = Math.max;
  function r(i, a, o) {
    return a = n(a === void 0 ? i.length - 1 : a, 0), function() {
      for (var s = arguments, l = -1, d = n(s.length - a, 0), m = Array(d); ++l < d; )
        m[l] = s[a + l];
      l = -1;
      for (var u = Array(a + 1); ++l < a; )
        u[l] = s[l];
      return u[a] = o(m), e(i, this, u);
    };
  }
  return pf = r, pf;
}
var ff, mN;
function tH() {
  if (mN) return ff;
  mN = 1;
  function e(n) {
    return function() {
      return n;
    };
  }
  return ff = e, ff;
}
var hf, pN;
function gF() {
  if (pN) return hf;
  pN = 1;
  function e(n) {
    return n;
  }
  return hf = e, hf;
}
var yf, fN;
function rH() {
  if (fN) return yf;
  fN = 1;
  var e = tH(), n = hF(), r = gF(), i = n ? function(a, o) {
    return n(a, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(o),
      writable: !0
    });
  } : r;
  return yf = i, yf;
}
var gf, hN;
function iH() {
  if (hN) return gf;
  hN = 1;
  var e = 800, n = 16, r = Date.now;
  function i(a) {
    var o = 0, s = 0;
    return function() {
      var l = r(), d = n - (l - s);
      if (s = l, d > 0) {
        if (++o >= e)
          return arguments[0];
      } else
        o = 0;
      return a.apply(void 0, arguments);
    };
  }
  return gf = i, gf;
}
var vf, yN;
function aH() {
  if (yN) return vf;
  yN = 1;
  var e = rH(), n = iH(), r = n(e);
  return vf = r, vf;
}
var kf, gN;
function vF() {
  if (gN) return kf;
  gN = 1;
  var e = Z6(), n = nH(), r = aH();
  function i(a) {
    return r(n(a, void 0, e), a + "");
  }
  return kf = i, kf;
}
var bf, vN;
function oH() {
  if (vN) return bf;
  vN = 1;
  var e = J6(), n = vF(), r = n(function(i, a) {
    return i == null ? {} : e(i, a);
  });
  return bf = r, bf;
}
var sH = oH();
const kF = /* @__PURE__ */ sF(sH), lH = [
  "control",
  "defaultValue",
  "name",
  "rules",
  "shouldUnregister"
];
function bF(e) {
  const n = kF(e, lH);
  return {
    controller: Yq(n),
    controllerProps: n
  };
}
const cH = [
  "className",
  "description",
  "disabled",
  "helpIcon",
  "label",
  "noAlert",
  "noLabel",
  "style"
];
function dH(e) {
  const { controller: n, controllerProps: r } = bF(e), i = {
    ...kF(e, cH),
    required: f6(r.rules?.required),
    meta: {
      touched: n.fieldState.isTouched,
      error: n.fieldState.error?.message,
      success: e.meta?.success,
      warning: e.meta?.warning
    },
    labelFor: r.name,
    noLabel: e.noLabel,
    noAlert: e.noAlert
  };
  return {
    controller: n,
    controllerProps: r,
    fieldWrapperProps: i
  };
}
var _f, kN;
function uH() {
  if (kN) return _f;
  kN = 1;
  var e = pc();
  function n() {
    this.__data__ = new e(), this.size = 0;
  }
  return _f = n, _f;
}
var xf, bN;
function mH() {
  if (bN) return xf;
  bN = 1;
  function e(n) {
    var r = this.__data__, i = r.delete(n);
    return this.size = r.size, i;
  }
  return xf = e, xf;
}
var Sf, _N;
function pH() {
  if (_N) return Sf;
  _N = 1;
  function e(n) {
    return this.__data__.get(n);
  }
  return Sf = e, Sf;
}
var Nf, xN;
function fH() {
  if (xN) return Nf;
  xN = 1;
  function e(n) {
    return this.__data__.has(n);
  }
  return Nf = e, Nf;
}
var jf, SN;
function hH() {
  if (SN) return jf;
  SN = 1;
  var e = pc(), n = Pg(), r = mF(), i = 200;
  function a(o, s) {
    var l = this.__data__;
    if (l instanceof e) {
      var d = l.__data__;
      if (!n || d.length < i - 1)
        return d.push([o, s]), this.size = ++l.size, this;
      l = this.__data__ = new r(d);
    }
    return l.set(o, s), this.size = l.size, this;
  }
  return jf = a, jf;
}
var wf, NN;
function yH() {
  if (NN) return wf;
  NN = 1;
  var e = pc(), n = uH(), r = mH(), i = pH(), a = fH(), o = hH();
  function s(l) {
    var d = this.__data__ = new e(l);
    this.size = d.size;
  }
  return s.prototype.clear = n, s.prototype.delete = r, s.prototype.get = i, s.prototype.has = a, s.prototype.set = o, wf = s, wf;
}
var Cf, jN;
function gH() {
  if (jN) return Cf;
  jN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length; ++i < a && r(n[i], i, n) !== !1; )
      ;
    return n;
  }
  return Cf = e, Cf;
}
var Ff, wN;
function as() {
  if (wN) return Ff;
  wN = 1;
  var e = Ag(), n = yF();
  function r(i, a, o, s) {
    var l = !o;
    o || (o = {});
    for (var d = -1, m = a.length; ++d < m; ) {
      var u = a[d], f = s ? s(o[u], i[u], u, o, i) : void 0;
      f === void 0 && (f = i[u]), l ? n(o, u, f) : e(o, u, f);
    }
    return o;
  }
  return Ff = r, Ff;
}
var If, CN;
function vH() {
  if (CN) return If;
  CN = 1;
  function e(n, r) {
    for (var i = -1, a = Array(n); ++i < n; )
      a[i] = r(i);
    return a;
  }
  return If = e, If;
}
var al = { exports: {} }, Ef, FN;
function kH() {
  if (FN) return Ef;
  FN = 1;
  function e() {
    return !1;
  }
  return Ef = e, Ef;
}
al.exports;
var IN;
function _F() {
  return IN || (IN = 1, (function(e, n) {
    var r = Jr(), i = kH(), a = n && !n.nodeType && n, o = a && !0 && e && !e.nodeType && e, s = o && o.exports === a, l = s ? r.Buffer : void 0, d = l ? l.isBuffer : void 0, m = d || i;
    e.exports = m;
  })(al, al.exports)), al.exports;
}
var $f, EN;
function bH() {
  if (EN) return $f;
  EN = 1;
  var e = Pa(), n = zg(), r = Yi(), i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", l = "[object Error]", d = "[object Function]", m = "[object Map]", u = "[object Number]", f = "[object Object]", h = "[object RegExp]", k = "[object Set]", C = "[object String]", N = "[object WeakMap]", j = "[object ArrayBuffer]", _ = "[object DataView]", g = "[object Float32Array]", D = "[object Float64Array]", O = "[object Int8Array]", I = "[object Int16Array]", F = "[object Int32Array]", L = "[object Uint8Array]", K = "[object Uint8ClampedArray]", J = "[object Uint16Array]", te = "[object Uint32Array]", W = {};
  W[g] = W[D] = W[O] = W[I] = W[F] = W[L] = W[K] = W[J] = W[te] = !0, W[i] = W[a] = W[j] = W[o] = W[_] = W[s] = W[l] = W[d] = W[m] = W[u] = W[f] = W[h] = W[k] = W[C] = W[N] = !1;
  function Y(P) {
    return r(P) && n(P.length) && !!W[e(P)];
  }
  return $f = Y, $f;
}
var Tf, $N;
function Mg() {
  if ($N) return Tf;
  $N = 1;
  function e(n) {
    return function(r) {
      return n(r);
    };
  }
  return Tf = e, Tf;
}
var ol = { exports: {} };
ol.exports;
var TN;
function Bg() {
  return TN || (TN = 1, (function(e, n) {
    var r = lF(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o && r.process, l = (function() {
      try {
        var d = a && a.require && a.require("util").types;
        return d || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = l;
  })(ol, ol.exports)), ol.exports;
}
var Of, ON;
function _H() {
  if (ON) return Of;
  ON = 1;
  var e = bH(), n = Mg(), r = Bg(), i = r && r.isTypedArray, a = i ? n(i) : e;
  return Of = a, Of;
}
var Rf, RN;
function xF() {
  if (RN) return Rf;
  RN = 1;
  var e = vH(), n = Vg(), r = _i(), i = _F(), a = Lg(), o = _H(), s = Object.prototype, l = s.hasOwnProperty;
  function d(m, u) {
    var f = r(m), h = !f && n(m), k = !f && !h && i(m), C = !f && !h && !k && o(m), N = f || h || k || C, j = N ? e(m.length, String) : [], _ = j.length;
    for (var g in m)
      (u || l.call(m, g)) && !(N && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      k && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      C && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      a(g, _))) && j.push(g);
    return j;
  }
  return Rf = d, Rf;
}
var Df, DN;
function qg() {
  if (DN) return Df;
  DN = 1;
  var e = Object.prototype;
  function n(r) {
    var i = r && r.constructor, a = typeof i == "function" && i.prototype || e;
    return r === a;
  }
  return Df = n, Df;
}
var Pf, PN;
function SF() {
  if (PN) return Pf;
  PN = 1;
  function e(n, r) {
    return function(i) {
      return n(r(i));
    };
  }
  return Pf = e, Pf;
}
var Af, AN;
function xH() {
  if (AN) return Af;
  AN = 1;
  var e = SF(), n = e(Object.keys, Object);
  return Af = n, Af;
}
var Lf, LN;
function SH() {
  if (LN) return Lf;
  LN = 1;
  var e = qg(), n = xH(), r = Object.prototype, i = r.hasOwnProperty;
  function a(o) {
    if (!e(o))
      return n(o);
    var s = [];
    for (var l in Object(o))
      i.call(o, l) && l != "constructor" && s.push(l);
    return s;
  }
  return Lf = a, Lf;
}
var Vf, VN;
function NF() {
  if (VN) return Vf;
  VN = 1;
  var e = cF(), n = zg();
  function r(i) {
    return i != null && n(i.length) && !e(i);
  }
  return Vf = r, Vf;
}
var zf, zN;
function Hg() {
  if (zN) return zf;
  zN = 1;
  var e = xF(), n = SH(), r = NF();
  function i(a) {
    return r(a) ? e(a) : n(a);
  }
  return zf = i, zf;
}
var Uf, UN;
function NH() {
  if (UN) return Uf;
  UN = 1;
  var e = as(), n = Hg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Uf = r, Uf;
}
var Mf, MN;
function jH() {
  if (MN) return Mf;
  MN = 1;
  function e(n) {
    var r = [];
    if (n != null)
      for (var i in Object(n))
        r.push(i);
    return r;
  }
  return Mf = e, Mf;
}
var Bf, BN;
function wH() {
  if (BN) return Bf;
  BN = 1;
  var e = Aa(), n = qg(), r = jH(), i = Object.prototype, a = i.hasOwnProperty;
  function o(s) {
    if (!e(s))
      return r(s);
    var l = n(s), d = [];
    for (var m in s)
      m == "constructor" && (l || !a.call(s, m)) || d.push(m);
    return d;
  }
  return Bf = o, Bf;
}
var qf, qN;
function Wg() {
  if (qN) return qf;
  qN = 1;
  var e = xF(), n = wH(), r = NF();
  function i(a) {
    return r(a) ? e(a, !0) : n(a);
  }
  return qf = i, qf;
}
var Hf, HN;
function CH() {
  if (HN) return Hf;
  HN = 1;
  var e = as(), n = Wg();
  function r(i, a) {
    return i && e(a, n(a), i);
  }
  return Hf = r, Hf;
}
var sl = { exports: {} };
sl.exports;
var WN;
function FH() {
  return WN || (WN = 1, (function(e, n) {
    var r = Jr(), i = n && !n.nodeType && n, a = i && !0 && e && !e.nodeType && e, o = a && a.exports === i, s = o ? r.Buffer : void 0, l = s ? s.allocUnsafe : void 0;
    function d(m, u) {
      if (u)
        return m.slice();
      var f = m.length, h = l ? l(f) : new m.constructor(f);
      return m.copy(h), h;
    }
    e.exports = d;
  })(sl, sl.exports)), sl.exports;
}
var Wf, KN;
function IH() {
  if (KN) return Wf;
  KN = 1;
  function e(n, r) {
    var i = -1, a = n.length;
    for (r || (r = Array(a)); ++i < a; )
      r[i] = n[i];
    return r;
  }
  return Wf = e, Wf;
}
var Kf, GN;
function EH() {
  if (GN) return Kf;
  GN = 1;
  function e(n, r) {
    for (var i = -1, a = n == null ? 0 : n.length, o = 0, s = []; ++i < a; ) {
      var l = n[i];
      r(l, i, n) && (s[o++] = l);
    }
    return s;
  }
  return Kf = e, Kf;
}
var Gf, YN;
function jF() {
  if (YN) return Gf;
  YN = 1;
  function e() {
    return [];
  }
  return Gf = e, Gf;
}
var Yf, JN;
function Kg() {
  if (JN) return Yf;
  JN = 1;
  var e = EH(), n = jF(), r = Object.prototype, i = r.propertyIsEnumerable, a = Object.getOwnPropertySymbols, o = a ? function(s) {
    return s == null ? [] : (s = Object(s), e(a(s), function(l) {
      return i.call(s, l);
    }));
  } : n;
  return Yf = o, Yf;
}
var Jf, QN;
function $H() {
  if (QN) return Jf;
  QN = 1;
  var e = as(), n = Kg();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Jf = r, Jf;
}
var Qf, XN;
function Gg() {
  if (XN) return Qf;
  XN = 1;
  var e = SF(), n = e(Object.getPrototypeOf, Object);
  return Qf = n, Qf;
}
var Xf, ZN;
function wF() {
  if (ZN) return Xf;
  ZN = 1;
  var e = Ug(), n = Gg(), r = Kg(), i = jF(), a = Object.getOwnPropertySymbols, o = a ? function(s) {
    for (var l = []; s; )
      e(l, r(s)), s = n(s);
    return l;
  } : i;
  return Xf = o, Xf;
}
var Zf, ej;
function TH() {
  if (ej) return Zf;
  ej = 1;
  var e = as(), n = wF();
  function r(i, a) {
    return e(i, n(i), a);
  }
  return Zf = r, Zf;
}
var eh, nj;
function CF() {
  if (nj) return eh;
  nj = 1;
  var e = Ug(), n = _i();
  function r(i, a, o) {
    var s = a(i);
    return n(i) ? s : e(s, o(i));
  }
  return eh = r, eh;
}
var nh, tj;
function OH() {
  if (tj) return nh;
  tj = 1;
  var e = CF(), n = Kg(), r = Hg();
  function i(a) {
    return e(a, r, n);
  }
  return nh = i, nh;
}
var th, rj;
function FF() {
  if (rj) return th;
  rj = 1;
  var e = CF(), n = wF(), r = Wg();
  function i(a) {
    return e(a, r, n);
  }
  return th = i, th;
}
var rh, ij;
function RH() {
  if (ij) return rh;
  ij = 1;
  var e = Ji(), n = Jr(), r = e(n, "DataView");
  return rh = r, rh;
}
var ih, aj;
function DH() {
  if (aj) return ih;
  aj = 1;
  var e = Ji(), n = Jr(), r = e(n, "Promise");
  return ih = r, ih;
}
var ah, oj;
function PH() {
  if (oj) return ah;
  oj = 1;
  var e = Ji(), n = Jr(), r = e(n, "Set");
  return ah = r, ah;
}
var oh, sj;
function AH() {
  if (sj) return oh;
  sj = 1;
  var e = Ji(), n = Jr(), r = e(n, "WeakMap");
  return oh = r, oh;
}
var sh, lj;
function Yg() {
  if (lj) return sh;
  lj = 1;
  var e = RH(), n = Pg(), r = DH(), i = PH(), a = AH(), o = Pa(), s = dF(), l = "[object Map]", d = "[object Object]", m = "[object Promise]", u = "[object Set]", f = "[object WeakMap]", h = "[object DataView]", k = s(e), C = s(n), N = s(r), j = s(i), _ = s(a), g = o;
  return (e && g(new e(new ArrayBuffer(1))) != h || n && g(new n()) != l || r && g(r.resolve()) != m || i && g(new i()) != u || a && g(new a()) != f) && (g = function(D) {
    var O = o(D), I = O == d ? D.constructor : void 0, F = I ? s(I) : "";
    if (F)
      switch (F) {
        case k:
          return h;
        case C:
          return l;
        case N:
          return m;
        case j:
          return u;
        case _:
          return f;
      }
    return O;
  }), sh = g, sh;
}
var lh, cj;
function LH() {
  if (cj) return lh;
  cj = 1;
  var e = Object.prototype, n = e.hasOwnProperty;
  function r(i) {
    var a = i.length, o = new i.constructor(a);
    return a && typeof i[0] == "string" && n.call(i, "index") && (o.index = i.index, o.input = i.input), o;
  }
  return lh = r, lh;
}
var ch, dj;
function VH() {
  if (dj) return ch;
  dj = 1;
  var e = Jr(), n = e.Uint8Array;
  return ch = n, ch;
}
var dh, uj;
function Jg() {
  if (uj) return dh;
  uj = 1;
  var e = VH();
  function n(r) {
    var i = new r.constructor(r.byteLength);
    return new e(i).set(new e(r)), i;
  }
  return dh = n, dh;
}
var uh, mj;
function zH() {
  if (mj) return uh;
  mj = 1;
  var e = Jg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.byteLength);
  }
  return uh = n, uh;
}
var mh, pj;
function UH() {
  if (pj) return mh;
  pj = 1;
  var e = /\w*$/;
  function n(r) {
    var i = new r.constructor(r.source, e.exec(r));
    return i.lastIndex = r.lastIndex, i;
  }
  return mh = n, mh;
}
var ph, fj;
function MH() {
  if (fj) return ph;
  fj = 1;
  var e = is(), n = e ? e.prototype : void 0, r = n ? n.valueOf : void 0;
  function i(a) {
    return r ? Object(r.call(a)) : {};
  }
  return ph = i, ph;
}
var fh, hj;
function BH() {
  if (hj) return fh;
  hj = 1;
  var e = Jg();
  function n(r, i) {
    var a = i ? e(r.buffer) : r.buffer;
    return new r.constructor(a, r.byteOffset, r.length);
  }
  return fh = n, fh;
}
var hh, yj;
function qH() {
  if (yj) return hh;
  yj = 1;
  var e = Jg(), n = zH(), r = UH(), i = MH(), a = BH(), o = "[object Boolean]", s = "[object Date]", l = "[object Map]", d = "[object Number]", m = "[object RegExp]", u = "[object Set]", f = "[object String]", h = "[object Symbol]", k = "[object ArrayBuffer]", C = "[object DataView]", N = "[object Float32Array]", j = "[object Float64Array]", _ = "[object Int8Array]", g = "[object Int16Array]", D = "[object Int32Array]", O = "[object Uint8Array]", I = "[object Uint8ClampedArray]", F = "[object Uint16Array]", L = "[object Uint32Array]";
  function K(J, te, W) {
    var Y = J.constructor;
    switch (te) {
      case k:
        return e(J);
      case o:
      case s:
        return new Y(+J);
      case C:
        return n(J, W);
      case N:
      case j:
      case _:
      case g:
      case D:
      case O:
      case I:
      case F:
      case L:
        return a(J, W);
      case l:
        return new Y();
      case d:
      case f:
        return new Y(J);
      case m:
        return r(J);
      case u:
        return new Y();
      case h:
        return i(J);
    }
  }
  return hh = K, hh;
}
var yh, gj;
function HH() {
  if (gj) return yh;
  gj = 1;
  var e = Aa(), n = Object.create, r = /* @__PURE__ */ (function() {
    function i() {
    }
    return function(a) {
      if (!e(a))
        return {};
      if (n)
        return n(a);
      i.prototype = a;
      var o = new i();
      return i.prototype = void 0, o;
    };
  })();
  return yh = r, yh;
}
var gh, vj;
function WH() {
  if (vj) return gh;
  vj = 1;
  var e = HH(), n = Gg(), r = qg();
  function i(a) {
    return typeof a.constructor == "function" && !r(a) ? e(n(a)) : {};
  }
  return gh = i, gh;
}
var vh, kj;
function KH() {
  if (kj) return vh;
  kj = 1;
  var e = Yg(), n = Yi(), r = "[object Map]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return vh = i, vh;
}
var kh, bj;
function GH() {
  if (bj) return kh;
  bj = 1;
  var e = KH(), n = Mg(), r = Bg(), i = r && r.isMap, a = i ? n(i) : e;
  return kh = a, kh;
}
var bh, _j;
function YH() {
  if (_j) return bh;
  _j = 1;
  var e = Yg(), n = Yi(), r = "[object Set]";
  function i(a) {
    return n(a) && e(a) == r;
  }
  return bh = i, bh;
}
var _h, xj;
function JH() {
  if (xj) return _h;
  xj = 1;
  var e = YH(), n = Mg(), r = Bg(), i = r && r.isSet, a = i ? n(i) : e;
  return _h = a, _h;
}
var xh, Sj;
function QH() {
  if (Sj) return xh;
  Sj = 1;
  var e = yH(), n = gH(), r = Ag(), i = NH(), a = CH(), o = FH(), s = IH(), l = $H(), d = TH(), m = OH(), u = FF(), f = Yg(), h = LH(), k = qH(), C = WH(), N = _i(), j = _F(), _ = GH(), g = Aa(), D = JH(), O = Hg(), I = Wg(), F = 1, L = 2, K = 4, J = "[object Arguments]", te = "[object Array]", W = "[object Boolean]", Y = "[object Date]", P = "[object Error]", B = "[object Function]", re = "[object GeneratorFunction]", je = "[object Map]", ue = "[object Number]", se = "[object Object]", he = "[object RegExp]", V = "[object Set]", ke = "[object String]", De = "[object Symbol]", q = "[object WeakMap]", Ge = "[object ArrayBuffer]", sn = "[object DataView]", Ie = "[object Float32Array]", Ue = "[object Float64Array]", Re = "[object Int8Array]", Be = "[object Int16Array]", Ae = "[object Int32Array]", Je = "[object Uint8Array]", $e = "[object Uint8ClampedArray]", Me = "[object Uint16Array]", en = "[object Uint32Array]", oe = {};
  oe[J] = oe[te] = oe[Ge] = oe[sn] = oe[W] = oe[Y] = oe[Ie] = oe[Ue] = oe[Re] = oe[Be] = oe[Ae] = oe[je] = oe[ue] = oe[se] = oe[he] = oe[V] = oe[ke] = oe[De] = oe[Je] = oe[$e] = oe[Me] = oe[en] = !0, oe[P] = oe[B] = oe[q] = !1;
  function le(xe, Ve, Pe, vn, Q, E) {
    var z, ie = Ve & F, ce = Ve & L, U = Ve & K;
    if (Pe && (z = Q ? Pe(xe, vn, Q, E) : Pe(xe)), z !== void 0)
      return z;
    if (!g(xe))
      return xe;
    var G = N(xe);
    if (G) {
      if (z = h(xe), !ie)
        return s(xe, z);
    } else {
      var ye = f(xe), Ne = ye == B || ye == re;
      if (j(xe))
        return o(xe, ie);
      if (ye == se || ye == J || Ne && !Q) {
        if (z = ce || Ne ? {} : C(xe), !ie)
          return ce ? d(xe, a(z, xe)) : l(xe, i(z, xe));
      } else {
        if (!oe[ye])
          return Q ? xe : {};
        z = k(xe, ye, ie);
      }
    }
    E || (E = new e());
    var Oe = E.get(xe);
    if (Oe)
      return Oe;
    E.set(xe, z), D(xe) ? xe.forEach(function(an) {
      z.add(le(an, Ve, Pe, an, xe, E));
    }) : _(xe) && xe.forEach(function(an, pn) {
      z.set(pn, le(an, Ve, Pe, pn, xe, E));
    });
    var rn = U ? ce ? u : m : ce ? I : O, kn = G ? void 0 : rn(xe);
    return n(kn || xe, function(an, pn) {
      kn && (pn = an, an = xe[pn]), r(z, pn, le(an, Ve, Pe, pn, xe, E));
    }), z;
  }
  return xh = le, xh;
}
var Sh, Nj;
function XH() {
  if (Nj) return Sh;
  Nj = 1;
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? n[r - 1] : void 0;
  }
  return Sh = e, Sh;
}
var Nh, jj;
function ZH() {
  if (jj) return Nh;
  jj = 1;
  function e(n, r, i) {
    var a = -1, o = n.length;
    r < 0 && (r = -r > o ? 0 : o + r), i = i > o ? o : i, i < 0 && (i += o), o = r > i ? 0 : i - r >>> 0, r >>>= 0;
    for (var s = Array(o); ++a < o; )
      s[a] = n[a + r];
    return s;
  }
  return Nh = e, Nh;
}
var jh, wj;
function eW() {
  if (wj) return jh;
  wj = 1;
  var e = fF(), n = ZH();
  function r(i, a) {
    return a.length < 2 ? i : e(i, n(a, 0, -1));
  }
  return jh = r, jh;
}
var wh, Cj;
function nW() {
  if (Cj) return wh;
  Cj = 1;
  var e = La(), n = XH(), r = eW(), i = hc(), a = Object.prototype, o = a.hasOwnProperty;
  function s(l, d) {
    d = e(d, l);
    var m = -1, u = d.length;
    if (!u)
      return !0;
    for (; ++m < u; ) {
      var f = i(d[m]);
      if (f === "__proto__" && !o.call(l, "__proto__") || (f === "constructor" || f === "prototype") && m < u - 1)
        return !1;
    }
    var h = r(l, d);
    return h == null || delete h[i(n(d))];
  }
  return wh = s, wh;
}
var Ch, Fj;
function tW() {
  if (Fj) return Ch;
  Fj = 1;
  var e = Pa(), n = Gg(), r = Yi(), i = "[object Object]", a = Function.prototype, o = Object.prototype, s = a.toString, l = o.hasOwnProperty, d = s.call(Object);
  function m(u) {
    if (!r(u) || e(u) != i)
      return !1;
    var f = n(u);
    if (f === null)
      return !0;
    var h = l.call(f, "constructor") && f.constructor;
    return typeof h == "function" && h instanceof h && s.call(h) == d;
  }
  return Ch = m, Ch;
}
var Fh, Ij;
function rW() {
  if (Ij) return Fh;
  Ij = 1;
  var e = tW();
  function n(r) {
    return e(r) ? void 0 : r;
  }
  return Fh = n, Fh;
}
var Ih, Ej;
function iW() {
  if (Ej) return Ih;
  Ej = 1;
  var e = pF(), n = QH(), r = nW(), i = La(), a = as(), o = rW(), s = vF(), l = FF(), d = 1, m = 2, u = 4, f = s(function(h, k) {
    var C = {};
    if (h == null)
      return C;
    var N = !1;
    k = e(k, function(_) {
      return _ = i(_, h), N || (N = _.length > 1), _;
    }), a(h, l(h), C), N && (C = n(C, d | m | u, o));
    for (var j = k.length; j--; )
      r(C, k[j]);
    return C;
  });
  return Ih = f, Ih;
}
iW();
var aW = gF();
const oW = /* @__PURE__ */ sF(aW), la = ({
  transformValue: e = oW,
  label: n,
  helpIcon: r,
  className: i,
  ...a
}) => {
  const {
    controller: { field: o },
    controllerProps: { name: s }
  } = bF(a);
  return /* @__PURE__ */ Do.jsxs(b, { gap: "200", alignItems: "center", className: i, children: [
    /* @__PURE__ */ Do.jsx(
      Ao,
      {
        ...o,
        id: s,
        checked: e(o.value),
        disabled: a.componentProps?.disabled,
        onChange: (l) => {
          a.componentProps?.onChange?.(l), o.onChange(e(l.target.checked));
        }
      }
    ),
    n && /* @__PURE__ */ Do.jsx(xw, { htmlFor: s, helpIcon: r, children: n })
  ] });
}, $j = (e) => {
  const { controller: n, controllerProps: r, fieldWrapperProps: i } = dH(e);
  return /* @__PURE__ */ Do.jsx(We, { ...i, children: /* @__PURE__ */ Do.jsx(
    dr,
    {
      ...e.componentProps,
      ...n.field,
      value: e.componentProps?.type === "number" && isNaN(n.field.value) ? "" : n.field.value ?? "",
      onBlur: (a) => {
        e.componentProps?.onBlur?.(a), n.field.onBlur();
      },
      onChange: (a) => {
        e.componentProps?.onChange?.(a), n.field.onChange(
          e.componentProps?.type === "number" ? a.target.valueAsNumber : a
        );
      },
      id: r.name,
      "aria-disabled": i.disabled,
      disabled: i.disabled,
      "aria-required": i.required,
      required: i.required,
      status: We.getStatus(i.meta)
    }
  ) });
}, Pl = [
  {
    key: "rivoLoyaltyApiKey",
    label: "API key",
    defaultValue: "",
    secret: !0,
    type: "string"
  },
  {
    key: cc,
    label: "Shopify API host name",
    defaultValue: "",
    secret: !1,
    type: "string"
  },
  {
    key: "rivoLoyaltyShowOrders",
    label: "Show orders overview",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowLoyalty",
    label: "Show loyalty",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyAdjustLoyaltyPoints",
    label: "Allow adjusting loyalty points",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowFavoriteProducts",
    label: "Show favorite products",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  },
  {
    key: "rivoLoyaltyShowPointsRedemptions",
    label: "Show available rewards",
    defaultValue: !0,
    secret: !1,
    type: "boolean"
  }
], Fi = rr(Pl), Tj = "RIVOLOYALTY", As = "Rivo Loyalty", sW = {
  enabled: !1,
  name: "",
  rivoLoyaltyApiKey: "",
  [cc]: "",
  rivoLoyaltyShowOrders: !0,
  rivoLoyaltyShowLoyalty: !0,
  rivoLoyaltyAdjustLoyaltyPoints: !0,
  rivoLoyaltyShowFavoriteProducts: !0,
  rivoLoyaltyShowPointsRedemptions: !0
}, lW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = d6({
    mode: "onChange",
    defaultValues: sW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: Tj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Pl,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => hr(K, {
    fieldDefinitions: Pl,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ be.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ be.jsx(yr, { cause: h }),
        /* @__PURE__ */ be.jsxs(nt, { children: [
          /* @__PURE__ */ be.jsx(Z, { children: /* @__PURE__ */ be.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ be.jsx(
            la,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            $j,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            $j,
            {
              name: "rivoLoyaltyShopifyApiHostName",
              label: Fi[cc],
              control: s.control,
              rules: {
                required: "Shopify API host name is required",
                validate: (K) => Vl(K) ?? void 0
              },
              componentProps: {
                placeholder: 'Host name of your Shopify shop, e.g. "my-webshop.myshopify.com"',
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(
            Er,
            {
              name: "rivoLoyaltyApiKey",
              label: Fi.rivoLoyaltyApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "Insert your Rivo API key",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: Fi.rivoLoyaltyShowOrders, children: /* @__PURE__ */ be.jsx(
            la,
            {
              name: "rivoLoyaltyShowOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: Fi.rivoLoyaltyShowLoyalty, children: /* @__PURE__ */ be.jsx(
            la,
            {
              name: "rivoLoyaltyShowLoyalty",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: Fi.rivoLoyaltyAdjustLoyaltyPoints, children: /* @__PURE__ */ be.jsx(
            la,
            {
              name: "rivoLoyaltyAdjustLoyaltyPoints",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: Fi.rivoLoyaltyShowFavoriteProducts, children: /* @__PURE__ */ be.jsx(
            la,
            {
              name: "rivoLoyaltyShowFavoriteProducts",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ be.jsx(Z, { span: 3 }),
          /* @__PURE__ */ be.jsx(Z, { span: 3, children: /* @__PURE__ */ be.jsx(We, { label: Fi.rivoLoyaltyShowPointsRedemptions, children: /* @__PURE__ */ be.jsx(
            la,
            {
              name: "rivoLoyaltyShowPointsRedemptions",
              control: s.control
            }
          ) }) }),
          a && D !== null && /* @__PURE__ */ be.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ be.jsx(
          gr,
          {
            integrationType: Tj,
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m(),
            confirmDeleteVariant: "danger",
            deleteConfirmationBody: /* @__PURE__ */ be.jsxs(b, { gap: "400", children: [
              /* @__PURE__ */ be.jsx(
                ve,
                {
                  size: 24,
                  name: "exclamation-triangle-filled",
                  color: "red.500"
                }
              ),
              /* @__PURE__ */ be.jsxs(b, { gap: "200", flexDirection: "column", children: [
                /* @__PURE__ */ be.jsxs($.Heading, { withMarginBottom: !0, children: [
                  "By deleting the ",
                  As,
                  " integration, all links between Dixa and ",
                  As,
                  " are also deleted."
                ] }),
                /* @__PURE__ */ be.jsxs($.Paragraph, { children: [
                  "All data in ",
                  As,
                  " stays untouched."
                ] }),
                /* @__PURE__ */ be.jsxs($.Paragraph, { children: [
                  "Are you sure you want to delete the ",
                  As,
                  " ",
                  'integration "',
                  L,
                  '"?'
                ] })
              ] })
            ] })
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._banner_d9pot_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-400)}._list_d9pot_8{margin:var(--dixa-size-spacer-200) 0;padding-left:var(--dixa-size-spacer-500)}._list_d9pot_8 li{margin-bottom:var(--dixa-size-spacer-200)}._list_d9pot_8 li:last-child{margin-bottom:0}._list_alvh6_1{padding:0}._listItem_alvh6_4{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_alvh6_4:last-child{border-bottom:none}._listItemEdit_alvh6_11{cursor:pointer}._fullWidth_alvh6_15{width:100%}._boxWrapper_alvh6_19{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._modal_1vkwz_1{width:800px}._disabled_1vkwz_5 input{color:var(--dixa-typography-color-tertiary);background-color:var(--dixa-color-neutral-100);pointer-events:none}._wrapper_10fld_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300) var(--dixa-size-spacer-300) var(--dixa-size-spacer-250);background-color:var(--dixa-color-neutral-100)}._copyIcon_10fld_7{cursor:pointer;color:var(--dixa-typography-color-secondary)}._creationModal_pbe64_1{width:800px}._detailsModal_pbe64_5{width:600px}._percentageSuffix_pbe64_9{background-color:var(--dixa-color-neutral-100);padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-250)}._modal_11d6e_1{width:600px}._modalBody_11d6e_4{max-height:500px;overflow-y:auto}._codeContainer_11d6e_9{margin:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100) 0 0;padding:var(--dixa-size-spacer-200);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100)}._modal_1wlra_1{width:800px}._clickableIcon_33mqm_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._productTableHeader_6h6pl_1>tr>th{height:var(--dixa-size-spacer-300)}._productImage_6h6pl_5{width:50px;height:50px}._copyIcon_1dlzg_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._modal_1mprq_1{width:900px}._modal_al73g_1{width:600px}._editIcon_1yp2k_1,._copyIcon_1yp2k_2,._icon_cddi1_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._link_cddi1_6{font-size:var(--dixa-typography-size-200)}._copyIcon_u5m0p_1{cursor:pointer;color:var(--dixa-typography-color-secondary)}._strikethrough_u5m0p_6{text-decoration:line-through}._order_u5m0p_10{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_u5m0p_10:hover,._orderIsOpen_u5m0p_18{border-color:var(--dixa-color-neutral-400)}._orderHeader_u5m0p_21{cursor:pointer}._segmentName_1dkhk_1{overflow:hidden;white-space:nowrap}")), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Eh = { exports: {} }, ko = {}, Oj;
function cW() {
  if (Oj) return ko;
  Oj = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return ko.Fragment = r, ko.jsx = s, ko.jsxs = s, ko;
}
var Ls = {}, Rj;
function dW() {
  return Rj || (Rj = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Ls.Fragment = i, Ls.jsx = zn, Ls.jsxs = Wn;
  })()), Ls;
}
var Dj;
function uW() {
  return Dj || (Dj = 1, process.env.NODE_ENV === "production" ? Eh.exports = cW() : Eh.exports = dW()), Eh.exports;
}
var v = uW();
const Pj = "__PairingContext__", mW = () => globalThis[Pj] ?? (() => {
  const e = wy({});
  return globalThis[Pj] = e, e;
})(), pW = mW(), fW = () => Bl(pW), hW = "_banner_d9pot_1", yW = "_list_d9pot_8", Aj = {
  banner: hW,
  list: yW
}, Lj = "https://apps.shopify.com/dixa-dashboard", gW = {
  install: {
    description: "Connect your Shopify store to Dixa with just a few clicks.",
    listHeading: "How it works:",
    listType: "ol",
    listItems: [
      'Click "Install Dixa app in Shopify" below to start the connection',
      "You'll be redirected to the Shopify App Store to install the Dixa app",
      "After installing, the connection is set up automatically",
      "Return to the Settings > Integrations overview to see your newly connected Shopify integration"
    ],
    buttonText: "Install Dixa app in Shopify",
    buttonVariant: "primary"
  },
  migration: {
    description: "This integration uses a legacy connection method. We recommend upgrading to the Dixa Shopify app for a simpler, more reliable connection that doesn't require manual credential management.",
    listHeading: "Benefits of upgrading:",
    listType: "ul",
    listItems: [
      "No need to manage Client ID and Client Secret",
      "Automatic token refresh handled by the app",
      "Easier setup for new stores"
    ],
    buttonText: "Upgrade via Shopify App Store",
    buttonVariant: "primary"
  }
}, Al = ({
  label: e,
  bannerVariant: n = "install"
}) => {
  const { initiateFromDixa: r } = fW(), [i, a] = me(!1), [o, s] = me(null), l = gW[n], d = async () => {
    if (n === "install" && r) {
      a(!0), s(null);
      try {
        const u = await r();
        window.open(
          u ?? Lj,
          "_blank",
          "noopener,noreferrer"
        );
      } catch {
        s("Failed to start the connection. Please try again.");
      } finally {
        a(!1);
      }
      return;
    }
    window.open(Lj, "_blank", "noopener,noreferrer");
  }, m = l.listType === "ol" ? "ol" : "ul";
  return /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", className: Aj.banner, children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-2", children: e }),
    /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
      /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(ve, { size: 30, name: "shopify", color: "green.500" }) }),
      /* @__PURE__ */ v.jsx($.Paragraph, { children: l.description })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: l.listHeading }),
      /* @__PURE__ */ v.jsx($.Paragraph, { as: "div", children: /* @__PURE__ */ v.jsx(m, { className: Aj.list, children: l.listItems.map((u, f) => /* @__PURE__ */ v.jsx("li", { children: u }, f)) }) })
    ] }),
    o && /* @__PURE__ */ v.jsx($.Paragraph, { color: "danger", children: o }),
    /* @__PURE__ */ v.jsx(b, { margin: "200 0 0 0", children: /* @__PURE__ */ v.jsx(
      ct,
      {
        onClick: d,
        icon: "external-link",
        variant: l.buttonVariant,
        disabled: i,
        children: i ? /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(fn, { size: 16 }),
          "Connecting…"
        ] }) : l.buttonText
      }
    ) })
  ] }) });
}, Ho = [
  {
    key: "apiHostName",
    label: "API host name",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    type: "boolean",
    secret: !1,
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "apiAccessToken",
    label: "API Access Token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientId",
    label: "Client ID",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    type: "string",
    secret: !0,
    defaultValue: ""
  }
], Vj = "SHOPIFY", Vs = rr(Ho), vW = [
  "displayRefundOrder",
  "displayPartialRefundOrder",
  "displayCancelOrder",
  "enableEditShippingAddress",
  "displayOrdersOverview",
  "displayEmailMarketingConsent",
  "displaySegmentMembership",
  "displayDiscountCodes",
  "displayDiscountCodeCreation",
  "displayCreateOrder",
  "displayCreateDraftOrder",
  "displayDuplicateOrder"
], kW = {
  enabled: !1,
  name: "",
  ...Ml(
    [],
    Ho
  )
}, bW = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: kW
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: Vj,
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Ho,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = g?.additionalProperties, L = F?.tokenSource === "marketplace_app", K = !!F?.isUsingOAuth, J = !L, te = (Y) => hr(Y, {
    fieldDefinitions: Ho,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), W = s.watch("name");
  return /* @__PURE__ */ v.jsx(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: te,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: o ? /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(
        Al,
        {
          label: "Connect your Shopify store",
          bannerVariant: "install"
        }
      ) }) : /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(yr, { cause: h }),
        /* @__PURE__ */ v.jsxs(nt, { children: [
          J && /* @__PURE__ */ v.jsx(
            Al,
            {
              label: "Upgrade to simplified connection",
              bannerVariant: "migration"
            }
          ),
          /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ v.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          J && K && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "shopifyClientId",
                label: Vs.shopifyClientId,
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client ID is required" },
                componentProps: {
                  placeholder: "Client ID from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "shopifyClientSecret",
                label: Vs.shopifyClientSecret,
                control: s.control,
                isCreationMode: o,
                rules: { required: "Client Secret is required" },
                componentProps: {
                  placeholder: "Client Secret from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          J && !K && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Er,
              {
                name: "apiAccessToken",
                label: Vs.apiAccessToken,
                control: s.control,
                isCreationMode: o,
                rules: { required: "API access token is required" },
                componentProps: {
                  placeholder: "API access token from Shopify",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }),
          L ? /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            Pn,
            {
              name: "apiHostName",
              label: "Connected Shopify store",
              control: s.control,
              componentProps: {
                readOnly: !0,
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }) : /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
            Pn,
            {
              name: "apiHostName",
              label: "API host name",
              control: s.control,
              rules: {
                required: "API host name is required",
                validate: (Y) => Vl(Y) || !0
              },
              componentProps: {
                placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ v.jsx(Z, { span: 3 }),
          vW.map((Y) => /* @__PURE__ */ v.jsxs(_I, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(We, { label: Vs[Y], children: /* @__PURE__ */ v.jsx(
              bn,
              {
                name: Y,
                control: s.control
              }
            ) }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3 })
          ] }, Y)),
          a && D !== null && /* @__PURE__ */ v.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ v.jsx(
          gr,
          {
            integrationType: Vj,
            integrationId: e,
            widgetName: W,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ] })
    }
  );
}, _W = (e) => /* @__PURE__ */ v.jsx(Al, { ...e, bannerVariant: "install" }), xW = (e) => /* @__PURE__ */ v.jsx(Al, { ...e, bannerVariant: "migration" }), SW = [
  {
    key: "shopifyClientId",
    label: "Client ID",
    placeholder: "Client ID from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  },
  {
    key: "shopifyClientSecret",
    label: "Client Secret",
    placeholder: "Client Secret from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], NW = [
  {
    key: "apiAccessToken",
    label: "API Access Token",
    placeholder: "API access token from Shopify",
    required: !0,
    secret: !0,
    type: "input"
  }
], jW = [
  {
    key: "marketplaceInstallBanner",
    label: "Connect your Shopify store",
    secret: !1,
    type: "custom",
    component: _W
  }
], wW = [
  {
    key: "apiHostName",
    label: "Connected Shopify store",
    placeholder: "",
    required: !1,
    secret: !1,
    type: "input",
    prefix: "https://",
    readOnly: !0
  }
], zj = [
  {
    key: "migrationBanner",
    label: "Upgrade to simplified connection",
    secret: !1,
    type: "custom",
    component: xW,
    additionalProperties: { renderAboveForm: !0 }
  }
], IF = [
  {
    key: "displayRefundOrder",
    label: "Display the refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !1
  },
  {
    key: "displayPartialRefundOrder",
    label: "Displays the partial refund order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCancelOrder",
    label: "Displays the cancel order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "enableEditShippingAddress",
    label: 'Enable the "edit shipping address" button',
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayOrdersOverview",
    label: "Displays short orders overview",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    // We keep the key name to the first version which only showed marketing
    // consent for email in order to not change the existing integration setting
    // for customers. The current version shows both email and phone marketing consent.
    key: "displayEmailMarketingConsent",
    label: "Displays the email and phone marketing consent status of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displaySegmentMembership",
    label: "Displays the segment memberships of the customer",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodes",
    label: "Displays available discount codes",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDiscountCodeCreation",
    label: "Displays the discount code creation button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateOrder",
    label: "Displays the create order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayCreateDraftOrder",
    label: "Displays the create draft order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  },
  {
    key: "displayDuplicateOrder",
    label: "Displays the duplicate order button",
    secret: !1,
    type: "switch",
    defaultValue: !0
  }
], Uj = [
  {
    key: "apiHostName",
    label: "API host name",
    placeholder: 'Host name of your shop, e.g. "my-webshop.myshopify.com"',
    required: !0,
    secret: !1,
    type: "input",
    prefix: "https://",
    customValidation: (e) => Vl(e)
  },
  ...IF
];
var ua = /* @__PURE__ */ ((e) => (e.Invalid = "INVALID", e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(ua || {}), zi = /* @__PURE__ */ ((e) => (e.ConfirmedOptIn = "CONFIRMED_OPT_IN", e.SingleOptIn = "SINGLE_OPT_IN", e.Unknown = "UNKNOWN", e))(zi || {}), Mr = /* @__PURE__ */ ((e) => (e.NotSubscribed = "NOT_SUBSCRIBED", e.Pending = "PENDING", e.Redacted = "REDACTED", e.Subscribed = "SUBSCRIBED", e.Unsubscribed = "UNSUBSCRIBED", e))(Mr || {}), EF = /* @__PURE__ */ ((e) => (e.All = "ALL", e))(EF || {}), ky = /* @__PURE__ */ ((e) => (e.Active = "ACTIVE", e.Expired = "EXPIRED", e.Scheduled = "SCHEDULED", e))(ky || {}), Oi = /* @__PURE__ */ ((e) => (e.Customer = "CUSTOMER", e.Declined = "DECLINED", e.Fraud = "FRAUD", e.Inventory = "INVENTORY", e.Other = "OTHER", e.Staff = "STAFF", e))(Oi || {}), Ui = /* @__PURE__ */ ((e) => (e.Authorized = "AUTHORIZED", e.Expired = "EXPIRED", e.Paid = "PAID", e.PartiallyPaid = "PARTIALLY_PAID", e.PartiallyRefunded = "PARTIALLY_REFUNDED", e.Pending = "PENDING", e.Refunded = "REFUNDED", e.Voided = "VOIDED", e))(Ui || {}), ll = /* @__PURE__ */ ((e) => (e.Fulfilled = "FULFILLED", e.Partial = "PARTIAL", e.Restocked = "RESTOCKED", e))(ll || {}), $F = /* @__PURE__ */ ((e) => (e.Authorization = "AUTHORIZATION", e.Capture = "CAPTURE", e.Change = "CHANGE", e.EmvAuthorization = "EMV_AUTHORIZATION", e.Refund = "REFUND", e.Sale = "SALE", e.SuggestedRefund = "SUGGESTED_REFUND", e.Void = "VOID", e))($F || {});
const CW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundCreate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, FW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderUpdate" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, IW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderCancel" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "reason" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelReason" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCancelRefundMethodInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "restock" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "staffNote" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCancel" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "notifyCustomer" }, value: { kind: "Variable", name: { kind: "Name", value: "notifyCustomer" } } }, { kind: "Argument", name: { kind: "Name", value: "orderId" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }, { kind: "Argument", name: { kind: "Name", value: "reason" }, value: { kind: "Variable", name: { kind: "Name", value: "reason" } } }, { kind: "Argument", name: { kind: "Name", value: "refundMethod" }, value: { kind: "Variable", name: { kind: "Name", value: "refundMethod" } } }, { kind: "Argument", name: { kind: "Name", value: "restock" }, value: { kind: "Variable", name: { kind: "Name", value: "restock" } } }, { kind: "Argument", name: { kind: "Name", value: "staffNote" }, value: { kind: "Variable", name: { kind: "Name", value: "staffNote" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "job" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "done" } }] } }, { kind: "Field", name: { kind: "Name", value: "orderCancelUserErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, EW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createCustomer" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_CustomerInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }, { kind: "Field", name: { kind: "Name", value: "customer" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }] } }, { kind: "Field", name: { kind: "Name", value: "taxExempt" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] }, $W = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "order" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOrderInput" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "options" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderCreateOptionsInput" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "order" }, value: { kind: "Variable", name: { kind: "Name", value: "order" } } }, { kind: "Argument", name: { kind: "Name", value: "options" }, value: { kind: "Variable", name: { kind: "Name", value: "options" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, TW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDraftOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DraftOrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrderCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "draftOrder" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "totalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, OW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "createDiscountCode" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasicInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountCodeBasicCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "basicCodeDiscount" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codeDiscountNode" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "codeDiscount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "startsAt" } }, { kind: "Field", name: { kind: "Name", value: "endsAt" } }, { kind: "Field", name: { kind: "Name", value: "usageLimit" } }, { kind: "Field", name: { kind: "Name", value: "appliesOncePerCustomer" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, RW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "orderMarkAsPaid" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderMarkAsPaidInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderMarkAsPaid" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, DW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "refundLineItems" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refundCreate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "refund" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "userErrors" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "field" } }, { kind: "Field", name: { kind: "Name", value: "message" } }] } }] } }] } }] } }] }, PW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updateOrder" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_OrderInput" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderUpdate" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }] } }] } }] } }] } }] }, AW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "segments" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }] } }] } }] } }] } }] } }] }, LW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "customerSegmentMembership" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "customerId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } }, type: { kind: "NonNullType", type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customerSegmentMembership" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "customerId" }, value: { kind: "Variable", name: { kind: "Name", value: "customerId" } } }, { kind: "Argument", name: { kind: "Name", value: "segmentIds" }, value: { kind: "Variable", name: { kind: "Name", value: "segmentIds" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "memberships" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "segmentId" } }, { kind: "Field", name: { kind: "Name", value: "isMember" } }] } }] } }] } }] } }] }, VW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerData" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countriesInShippingZones" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "countryCodes" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "1" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "displayName" } }, { kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "defaultEmailAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "emailAddress" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultPhoneNumber" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "phoneNumber" } }, { kind: "Field", name: { kind: "Name", value: "marketingOptInLevel" } }, { kind: "Field", name: { kind: "Name", value: "marketingState" } }, { kind: "Field", name: { kind: "Name", value: "marketingUpdatedAt" } }] } }, { kind: "Field", name: { kind: "Name", value: "numberOfOrders" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "verifiedEmail" } }, { kind: "Field", name: { kind: "Name", value: "amountSpent" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "defaultAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }] } }] } }] } }] } }] } }] } }] }, zW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifyCustomerOrders" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orders" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "sortKey" }, value: { kind: "EnumValue", value: "CREATED_AT" } }, { kind: "Argument", name: { kind: "Name", value: "reverse" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "displayFulfillmentStatus" } }, { kind: "Field", name: { kind: "Name", value: "displayFinancialStatus" } }, { kind: "Field", name: { kind: "Name", value: "cancelledAt" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "discountCodes" } }, { kind: "Field", name: { kind: "Name", value: "netPaymentSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalRefundedSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "billingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingAddress" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "firstName" } }, { kind: "Field", name: { kind: "Name", value: "lastName" } }, { kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "address1" } }, { kind: "Field", name: { kind: "Name", value: "address2" } }, { kind: "Field", name: { kind: "Name", value: "city" } }, { kind: "Field", name: { kind: "Name", value: "country" } }, { kind: "Field", name: { kind: "Name", value: "countryCodeV2" } }, { kind: "Field", name: { kind: "Name", value: "province" } }, { kind: "Field", name: { kind: "Name", value: "provinceCode" } }, { kind: "Field", name: { kind: "Name", value: "zip" } }, { kind: "Field", name: { kind: "Name", value: "phone" } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "BooleanValue", value: !0 } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "BooleanValue", value: !0 } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shippingLines" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "5" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "code" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "discountedPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "fulfillments" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "2" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "trackingInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "company" } }, { kind: "Field", name: { kind: "Name", value: "number" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "15" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "variantTitle" } }, { kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "url" } }] } }, { kind: "Field", name: { kind: "Name", value: "product" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "discountedUnitPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refunds" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalRefunded" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "250" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "edges" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "node" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }] } }] } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalPriceSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "currentTotalDiscountsSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shopMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }] } }] } }] }, UW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchDiscountCodes" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "first" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "after" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "discountNodes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }, { kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "first" } } }, { kind: "Argument", name: { kind: "Name", value: "after" }, value: { kind: "Variable", name: { kind: "Name", value: "after" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "pageInfo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "hasNextPage" } }, { kind: "Field", name: { kind: "Name", value: "endCursor" } }] } }, { kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "discount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeApp" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBasic" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "customerGets" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "value" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "__typename" } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountPercentage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "percentage" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountAmount" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeBxgy" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Shopify_DiscountCodeFreeShipping" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "codes" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "IntValue", value: "100" } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "code" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, MW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "searchProducts" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "query" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "productCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "products" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "productCount" } } }, { kind: "Argument", name: { kind: "Name", value: "query" }, value: { kind: "Variable", name: { kind: "Name", value: "query" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "onlineStoreUrl" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "tags" } }, { kind: "Field", name: { kind: "Name", value: "title" } }, { kind: "Field", name: { kind: "Name", value: "totalInventory" } }, { kind: "Field", name: { kind: "Name", value: "priceRangeV2" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "maxVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }, { kind: "Field", name: { kind: "Name", value: "minVariantPrice" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "media" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "first" }, value: { kind: "Variable", name: { kind: "Name", value: "mediaCount" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "nodes" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "alt" } }, { kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "mediaContentType" } }, { kind: "Field", name: { kind: "Name", value: "preview" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "image" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "altText" } }, { kind: "Field", name: { kind: "Name", value: "url" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, BW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "shopifySuggestedRefund" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "orderId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "ID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } }, type: { kind: "ListType", type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Shopify_RefundLineItemInput" } } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Boolean" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "order" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "id" }, value: { kind: "Variable", name: { kind: "Name", value: "orderId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "suggestedRefund" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "refundLineItems" }, value: { kind: "Variable", name: { kind: "Name", value: "refundLineItems" } } }, { kind: "Argument", name: { kind: "Name", value: "refundShipping" }, value: { kind: "Variable", name: { kind: "Name", value: "refundShipping" } } }, { kind: "Argument", name: { kind: "Name", value: "suggestFullRefund" }, value: { kind: "Variable", name: { kind: "Name", value: "suggestFullRefund" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "subtotalSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "totalTaxSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "shipping" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "maximumRefundableSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "suggestedTransactions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "accountNumber" } }, { kind: "Field", name: { kind: "Name", value: "gateway" } }, { kind: "Field", name: { kind: "Name", value: "kind" } }, { kind: "Field", name: { kind: "Name", value: "parentTransaction" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }, { kind: "Field", name: { kind: "Name", value: "amountSet" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "presentmentMoney" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "amount" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "refundLineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "lineItem" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }] } }] } }] } }] } }] } }] } }] }, qW = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "test" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Shopify" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "shop" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "description" } }] } }] } }] } }] }, HW = {
  "\n  mutation refundCreate($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": CW,
  "\n  mutation orderUpdate($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          shippingAddress {\n            firstName\n            lastName\n            company\n            address1\n            address2\n            city\n            countryCodeV2\n            provinceCode\n            zip\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": FW,
  "\n  mutation orderCancel(\n    $notifyCustomer: Boolean\n    $orderId: ID!\n    $reason: Shopify_OrderCancelReason!\n    $refundMethod: Shopify_OrderCancelRefundMethodInput!\n    $restock: Boolean!\n    $staffNote: String!\n  ) {\n    Shopify {\n      orderCancel(\n        notifyCustomer: $notifyCustomer\n        orderId: $orderId\n        reason: $reason\n        refundMethod: $refundMethod\n        restock: $restock\n        staffNote: $staffNote\n      ) {\n        job {\n          id\n          done\n        }\n        orderCancelUserErrors {\n          code\n          field\n          message\n        }\n      }\n    }\n  }\n": IW,
  "\n  mutation createCustomer($input: Shopify_CustomerInput!) {\n    Shopify {\n      customerCreate(input: $input) {\n        userErrors {\n          field\n          message\n        }\n        customer {\n          id\n          defaultEmailAddress {\n            emailAddress\n          }\n          defaultPhoneNumber {\n            phoneNumber\n            marketingState\n            marketingOptInLevel\n          }\n          taxExempt\n          firstName\n          lastName\n          amountSpent {\n            amount\n            currencyCode\n          }\n        }\n      }\n    }\n  }\n": EW,
  "\n  mutation createOrder(\n    $order: Shopify_OrderCreateOrderInput!\n    $options: Shopify_OrderCreateOptionsInput\n  ) {\n    Shopify {\n      orderCreate(order: $order, options: $options) {\n        order {\n          id\n          name\n          createdAt\n          displayFulfillmentStatus\n          displayFinancialStatus\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": $W,
  "\n  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {\n    Shopify {\n      draftOrderCreate(input: $input) {\n        draftOrder {\n          id\n          name\n          createdAt\n          tags\n          status\n          totalPriceSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n            shopMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": TW,
  "\n  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {\n    Shopify {\n      discountCodeBasicCreate(basicCodeDiscount: $input) {\n        codeDiscountNode {\n          id\n          codeDiscount {\n            ... on Shopify_DiscountCodeBasic {\n              codes(first: 1) {\n                nodes {\n                  code\n                }\n              }\n              title\n              status\n              startsAt\n              endsAt\n              usageLimit\n              appliesOncePerCustomer\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": OW,
  "\n  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {\n    Shopify {\n      orderMarkAsPaid(input: $input) {\n        order {\n          id\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": RW,
  "\n  mutation refundLineItems($input: Shopify_RefundInput!) {\n    Shopify {\n      refundCreate(input: $input) {\n        refund {\n          id\n          totalRefundedSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n        }\n        userErrors {\n          field\n          message\n        }\n      }\n    }\n  }\n": DW,
  "\n  mutation updateOrder($input: Shopify_OrderInput!) {\n    Shopify {\n      orderUpdate(input: $input) {\n        order {\n          id\n          tags\n        }\n      }\n    }\n  }\n": PW,
  "\n  query segments($first: Int!) {\n    Shopify {\n      segments(first: $first) {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n": AW,
  "\n  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {\n    Shopify {\n      customerSegmentMembership(\n        customerId: $customerId\n        segmentIds: $segmentIds\n      ) {\n        memberships {\n          segmentId\n          isMember\n        }\n      }\n    }\n  }\n": LW,
  "\n  query shopifyCustomerData($query: String!) {\n    Shopify {\n      shop {\n        countriesInShippingZones {\n          countryCodes\n        }\n      }\n\n      customers(first: 1, query: $query) {\n        edges {\n          node {\n            id\n            displayName\n            firstName\n            lastName\n            defaultEmailAddress {\n              emailAddress\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            defaultPhoneNumber {\n              phoneNumber\n              marketingOptInLevel\n              marketingState\n              marketingUpdatedAt\n            }\n            numberOfOrders\n            tags\n            verifiedEmail\n            amountSpent {\n              amount\n              currencyCode\n            }\n            defaultAddress {\n              firstName\n              lastName\n              address1\n              address2\n              city\n              country\n              zip\n              phone\n              provinceCode\n              countryCodeV2\n            }\n          }\n        }\n      }\n    }\n  }\n": VW,
  "\n  query shopifyCustomerOrders($query: String!) {\n    Shopify {\n      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {\n        edges {\n          node {\n            id\n            name\n            createdAt\n            displayFulfillmentStatus\n            displayFinancialStatus\n            cancelledAt\n            tags\n            discountCodes\n            netPaymentSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            totalRefundedSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            billingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            shippingAddress {\n              firstName\n              lastName\n              company\n              address1\n              address2\n              city\n              country\n              countryCodeV2\n              province\n              provinceCode\n              zip\n              phone\n            }\n            suggestedRefund(suggestFullRefund: true, refundShipping: true) {\n              amountSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              subtotalSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              totalTaxSet {\n                presentmentMoney {\n                  amount\n                  currencyCode\n                }\n              }\n              shipping {\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n                maximumRefundableSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              suggestedTransactions {\n                accountNumber\n                gateway\n                kind\n                parentTransaction {\n                  id\n                }\n                amountSet {\n                  presentmentMoney {\n                    amount\n                    currencyCode\n                  }\n                }\n              }\n              refundLineItems {\n                lineItem {\n                  id\n                  quantity\n                }\n              }\n            }\n            shippingLines(first: 5) {\n              edges {\n                node {\n                  title\n                  code\n                  source\n                  discountedPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            fulfillments(first: 2) {\n              trackingInfo {\n                company\n                number\n                url\n              }\n            }\n            lineItems(first: 15) {\n              edges {\n                node {\n                  id\n                  title\n                  quantity\n                  variantTitle\n                  sku\n                  image {\n                    url\n                  }\n                  product {\n                    id\n                  }\n                  discountedUnitPriceSet {\n                    shopMoney {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n            refunds {\n              totalRefunded {\n                amount\n                currencyCode\n              }\n              refundLineItems(first: 250) {\n                edges {\n                  node {\n                    id\n                    quantity\n                    lineItem {\n                      id\n                      title\n                    }\n                  }\n                }\n              }\n            }\n            currentTotalPriceSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n            currentTotalDiscountsSet {\n              shopMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": zW,
  "\n  query searchDiscountCodes($query: String, $first: Int, $after: String) {\n    Shopify {\n      discountNodes(query: $query, first: $first, after: $after) {\n        pageInfo {\n          hasNextPage\n          endCursor\n        }\n        nodes {\n          id\n          discount {\n            __typename\n\n            ... on Shopify_DiscountCodeApp {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBasic {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n              customerGets {\n                value {\n                  __typename\n\n                  ... on Shopify_DiscountPercentage {\n                    percentage\n                  }\n\n                  ... on Shopify_DiscountAmount {\n                    amount {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeBxgy {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n\n            ... on Shopify_DiscountCodeFreeShipping {\n              title\n              status\n              codes(first: 100) {\n                nodes {\n                  code\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": UW,
  "\n  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {\n    Shopify {\n      products(first: $productCount, query: $query) {\n        nodes {\n          id\n          title\n          description\n          onlineStoreUrl\n          status\n          tags\n          title\n          totalInventory\n          priceRangeV2 {\n            maxVariantPrice {\n              amount\n              currencyCode\n            }\n            minVariantPrice {\n              amount\n              currencyCode\n            }\n          }\n          media(first: $mediaCount) {\n            nodes {\n              alt\n              id\n              status\n              mediaContentType\n              preview {\n                image {\n                  id\n                  altText\n                  url\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": MW,
  "\n  query shopifySuggestedRefund(\n    $orderId: ID!\n    $refundLineItems: [Shopify_RefundLineItemInput!]\n    $refundShipping: Boolean\n    $suggestFullRefund: Boolean\n  ) {\n    Shopify {\n      order(id: $orderId) {\n        id\n        suggestedRefund(\n          refundLineItems: $refundLineItems\n          refundShipping: $refundShipping\n          suggestFullRefund: $suggestFullRefund\n        ) {\n          amountSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          subtotalSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          totalTaxSet {\n            presentmentMoney {\n              amount\n              currencyCode\n            }\n          }\n          shipping {\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n            maximumRefundableSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          suggestedTransactions {\n            accountNumber\n            gateway\n            kind\n            parentTransaction {\n              id\n            }\n            amountSet {\n              presentmentMoney {\n                amount\n                currencyCode\n              }\n            }\n          }\n          refundLineItems {\n            lineItem {\n              id\n              quantity\n            }\n          }\n        }\n      }\n    }\n  }\n": BW,
  "\n  query test {\n    Shopify {\n      shop {\n        name\n        email\n        description\n      }\n    }\n  }\n": qW
};
function ar(e) {
  return HW[e] ?? {};
}
const WW = ar(
  /* GraphQL */
  `
  query shopifyCustomerData($query: String!) {
    Shopify {
      shop {
        countriesInShippingZones {
          countryCodes
        }
      }

      customers(first: 1, query: $query) {
        edges {
          node {
            id
            displayName
            firstName
            lastName
            defaultEmailAddress {
              emailAddress
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            defaultPhoneNumber {
              phoneNumber
              marketingOptInLevel
              marketingState
              marketingUpdatedAt
            }
            numberOfOrders
            tags
            verifiedEmail
            amountSpent {
              amount
              currencyCode
            }
            defaultAddress {
              firstName
              lastName
              address1
              address2
              city
              country
              zip
              phone
              provinceCode
              countryCodeV2
            }
          }
        }
      }
    }
  }
`
), KW = ar(
  /* GraphQL */
  `
  query shopifyCustomerOrders($query: String!) {
    Shopify {
      orders(first: 5, query: $query, sortKey: CREATED_AT, reverse: true) {
        edges {
          node {
            id
            name
            createdAt
            displayFulfillmentStatus
            displayFinancialStatus
            cancelledAt
            tags
            discountCodes
            netPaymentSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            totalRefundedSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            billingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            shippingAddress {
              firstName
              lastName
              company
              address1
              address2
              city
              country
              countryCodeV2
              province
              provinceCode
              zip
              phone
            }
            suggestedRefund(suggestFullRefund: true, refundShipping: true) {
              amountSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              subtotalSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              totalTaxSet {
                presentmentMoney {
                  amount
                  currencyCode
                }
              }
              shipping {
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
                maximumRefundableSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              suggestedTransactions {
                accountNumber
                gateway
                kind
                parentTransaction {
                  id
                }
                amountSet {
                  presentmentMoney {
                    amount
                    currencyCode
                  }
                }
              }
              refundLineItems {
                lineItem {
                  id
                  quantity
                }
              }
            }
            shippingLines(first: 5) {
              edges {
                node {
                  title
                  code
                  source
                  discountedPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            fulfillments(first: 2) {
              trackingInfo {
                company
                number
                url
              }
            }
            lineItems(first: 15) {
              edges {
                node {
                  id
                  title
                  quantity
                  variantTitle
                  sku
                  image {
                    url
                  }
                  product {
                    id
                  }
                  discountedUnitPriceSet {
                    shopMoney {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
            refunds {
              totalRefunded {
                amount
                currencyCode
              }
              refundLineItems(first: 250) {
                edges {
                  node {
                    id
                    quantity
                    lineItem {
                      id
                      title
                    }
                  }
                }
              }
            }
            currentTotalPriceSet {
              presentmentMoney {
                amount
                currencyCode
              }
              shopMoney {
                amount
                currencyCode
              }
            }
            currentTotalDiscountsSet {
              shopMoney {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
  }
`
), GW = ar(
  /* GraphQL */
  `
  query shopifySuggestedRefund(
    $orderId: ID!
    $refundLineItems: [Shopify_RefundLineItemInput!]
    $refundShipping: Boolean
    $suggestFullRefund: Boolean
  ) {
    Shopify {
      order(id: $orderId) {
        id
        suggestedRefund(
          refundLineItems: $refundLineItems
          refundShipping: $refundShipping
          suggestFullRefund: $suggestFullRefund
        ) {
          amountSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          subtotalSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          totalTaxSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
          shipping {
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
            maximumRefundableSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          suggestedTransactions {
            accountNumber
            gateway
            kind
            parentTransaction {
              id
            }
            amountSet {
              presentmentMoney {
                amount
                currencyCode
              }
            }
          }
          refundLineItems {
            lineItem {
              id
              quantity
            }
          }
        }
      }
    }
  }
`
), YW = ar(
  /* GraphQL */
  `
  query segments($first: Int!) {
    Shopify {
      segments(first: $first) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`
), JW = ar(
  /* GraphQL */
  `
  query customerSegmentMembership($customerId: ID!, $segmentIds: [ID!]!) {
    Shopify {
      customerSegmentMembership(
        customerId: $customerId
        segmentIds: $segmentIds
      ) {
        memberships {
          segmentId
          isMember
        }
      }
    }
  }
`
), Qg = ar(
  /* GraphQL */
  `
  query searchProducts($query: String!, $productCount: Int, $mediaCount: Int) {
    Shopify {
      products(first: $productCount, query: $query) {
        nodes {
          id
          title
          description
          onlineStoreUrl
          status
          tags
          title
          totalInventory
          priceRangeV2 {
            maxVariantPrice {
              amount
              currencyCode
            }
            minVariantPrice {
              amount
              currencyCode
            }
          }
          media(first: $mediaCount) {
            nodes {
              alt
              id
              status
              mediaContentType
              preview {
                image {
                  id
                  altText
                  url
                }
              }
            }
          }
        }
      }
    }
  }
`
), QW = ar(
  /* GraphQL */
  `
  query searchDiscountCodes($query: String, $first: Int, $after: String) {
    Shopify {
      discountNodes(query: $query, first: $first, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        nodes {
          id
          discount {
            __typename

            ... on Shopify_DiscountCodeApp {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeBasic {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
              customerGets {
                value {
                  __typename

                  ... on Shopify_DiscountPercentage {
                    percentage
                  }

                  ... on Shopify_DiscountAmount {
                    amount {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }

            ... on Shopify_DiscountCodeBxgy {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }

            ... on Shopify_DiscountCodeFreeShipping {
              title
              status
              codes(first: 100) {
                nodes {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
`
), XW = ar(
  /* GraphQL */
  `
  mutation orderUpdate($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          shippingAddress {
            firstName
            lastName
            company
            address1
            address2
            city
            countryCodeV2
            provinceCode
            zip
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), ZW = ar(
  /* GraphQL */
  `
  mutation refundCreate($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        userErrors {
          field
          message
        }
      }
    }
  }
`
), e9 = ar(
  /* GraphQL */
  `
  mutation orderCancel(
    $notifyCustomer: Boolean
    $orderId: ID!
    $reason: Shopify_OrderCancelReason!
    $refundMethod: Shopify_OrderCancelRefundMethodInput!
    $restock: Boolean!
    $staffNote: String!
  ) {
    Shopify {
      orderCancel(
        notifyCustomer: $notifyCustomer
        orderId: $orderId
        reason: $reason
        refundMethod: $refundMethod
        restock: $restock
        staffNote: $staffNote
      ) {
        job {
          id
          done
        }
        orderCancelUserErrors {
          code
          field
          message
        }
      }
    }
  }
`
), n9 = ar(
  /* GraphQL */
  `
  mutation updateOrder($input: Shopify_OrderInput!) {
    Shopify {
      orderUpdate(input: $input) {
        order {
          id
          tags
        }
      }
    }
  }
`
), t9 = ar(
  /* GraphQL */
  `
  mutation createCustomer($input: Shopify_CustomerInput!) {
    Shopify {
      customerCreate(input: $input) {
        userErrors {
          field
          message
        }
        customer {
          id
          defaultEmailAddress {
            emailAddress
          }
          defaultPhoneNumber {
            phoneNumber
            marketingState
            marketingOptInLevel
          }
          taxExempt
          firstName
          lastName
          amountSpent {
            amount
            currencyCode
          }
        }
      }
    }
  }
`
), r9 = ar(
  /* GraphQL */
  `
  mutation createDiscountCode($input: Shopify_DiscountCodeBasicInput!) {
    Shopify {
      discountCodeBasicCreate(basicCodeDiscount: $input) {
        codeDiscountNode {
          id
          codeDiscount {
            ... on Shopify_DiscountCodeBasic {
              codes(first: 1) {
                nodes {
                  code
                }
              }
              title
              status
              startsAt
              endsAt
              usageLimit
              appliesOncePerCustomer
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), TF = Wl`
  mutation createOrder(
    $order: Shopify_OrderCreateOrderInput!
    $options: Shopify_OrderCreateOptionsInput
  ) {
    Shopify {
      orderCreate(order: $order, options: $options) {
        order {
          id
          name
          createdAt
          displayFulfillmentStatus
          displayFinancialStatus
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, i9 = Wl`
  mutation createDraftOrder($input: Shopify_DraftOrderInput!) {
    Shopify {
      draftOrderCreate(input: $input) {
        draftOrder {
          id
          name
          createdAt
          tags
          status
          totalPriceSet {
            presentmentMoney {
              amount
              currencyCode
            }
            shopMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, OF = ar(
  /* GraphQL */
  `
  mutation orderMarkAsPaid($input: Shopify_OrderMarkAsPaidInput!) {
    Shopify {
      orderMarkAsPaid(input: $input) {
        order {
          id
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`
), a9 = ({
  conversationContext: e,
  forcePhoneLookup: n
}) => {
  const { useQuery: r } = hn(), i = e.customer?.email, a = e.customer?.phone_number, o = i ? `email:"${i}"` : null, s = a ? `phone:"${a}"` : null, l = n ? s : o ?? s, {
    loading: d,
    error: m,
    data: u,
    refetch: f,
    networkStatus: h
  } = r(WW, {
    skip: !l,
    variables: {
      query: l
    },
    notifyOnNetworkStatusChange: !0
  });
  return {
    isCustomerLoading: d,
    customerError: m,
    customerData: u,
    refetchCustomer: f,
    customerNetworkStatus: h
  };
}, o9 = () => {
  const { useLazyQuery: e } = hn(), [
    n,
    {
      loading: r,
      error: i,
      data: a,
      refetch: o
    }
  ] = e(KW);
  return {
    getCustomerOrders: n,
    isCustomerOrdersLoading: r,
    customerOrdersError: i,
    customerOrders: a,
    refetchCustomerOrders: o
  };
};
function Hr(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const RF = (e, n) => (n ?? []).map(({ amountSet: r, gateway: i, parentTransaction: a }) => ({
  amount: String(r?.presentmentMoney?.amount ?? "0.00"),
  gateway: i ?? "",
  kind: $F.Refund,
  orderId: e,
  parentId: a?.id
})), DF = ({
  orderId: e,
  transactions: n,
  refundLineItems: r,
  refundShipping: i,
  note: a,
  notify: o = !0
}) => ({
  orderId: e,
  notify: o,
  note: a,
  refundLineItems: r,
  transactions: n,
  shipping: {
    fullRefund: i
  }
}), s9 = ({
  ordersData: e
}) => {
  const n = (r) => r?.fulfillments?.length > 0 ? r.fulfillments[0].trackingInfo : [];
  return e.map(({ node: r }) => ({
    id: r.id,
    name: r.name,
    createdAt: new Date(r.createdAt),
    cancelledAt: r.cancelledAt ? new Date(r.cancelledAt) : void 0,
    status: `${r.displayFulfillmentStatus?.toLowerCase()}, ${r.displayFinancialStatus?.toLowerCase()}${r.cancelledAt ? ", cancelled" : ""}`,
    displayFinancialStatus: r.displayFinancialStatus,
    currentTotalPriceSet: r.currentTotalPriceSet,
    currentTotalDiscountsSet: r.currentTotalDiscountsSet,
    value: r.netPaymentSet?.presentmentMoney?.amount,
    currencyCode: r.netPaymentSet?.presentmentMoney?.currencyCode,
    shippingAddress: r.shippingAddress,
    billingAddress: r.billingAddress,
    lineItems: r.lineItems?.edges?.map(({ node: i }) => i),
    suggestedRefund: {
      orderId: r.id,
      amount: r.suggestedRefund?.amountSet?.presentmentMoney?.amount,
      subtotal: r.suggestedRefund?.subtotalSet?.presentmentMoney?.amount,
      tax: r.suggestedRefund?.totalTaxSet?.presentmentMoney?.amount,
      currency: r.suggestedRefund?.amountSet?.presentmentMoney?.currencyCode,
      notify: !0,
      refundLineItems: r.suggestedRefund?.refundLineItems.map(
        ({ lineItem: i }) => ({
          lineItemId: i.id,
          quantity: i.quantity
        })
      ),
      transactions: RF(
        r.id,
        r.suggestedRefund?.suggestedTransactions
      ),
      shipping: {
        fullRefund: !0,
        amount: r.suggestedRefund?.shipping?.amountSet?.presentmentMoney?.amount,
        maximumRefundable: r.suggestedRefund?.shipping?.maximumRefundableSet?.presentmentMoney?.amount
      }
    },
    trackingInfos: n(r),
    shippingLines: r.shippingLines?.edges?.map(({ node: i }) => i),
    tags: r.tags,
    discountCodes: r.discountCodes,
    refunds: r.refunds
  }));
}, Mj = [
  {
    value: Ui.Pending,
    label: "Pending",
    description: "The payment is pending"
  },
  {
    value: Ui.Authorized,
    label: "Authorized",
    description: "The payment has been authorized but not captured"
  },
  {
    value: Ui.Paid,
    label: "Paid",
    description: "The payment has been completed"
  }
], Bj = [
  {
    value: ll.Fulfilled,
    label: "Fulfilled",
    description: "Every line item in the order has been fulfilled"
  },
  {
    value: ll.Partial,
    label: "Partial",
    description: "At least one line item in the order has been fulfilled"
  },
  {
    value: ll.Restocked,
    label: "Restocked",
    description: "Every line item in the order has been restocked and the order canceled"
  }
], PF = (e) => e.length === 0 ? "" : e.map((n) => `id:${n.split("/").pop()}`).join(" OR "), ma = (e) => l9(c9(e)), l9 = (e) => Object.fromEntries(
  Object.entries(e ?? {}).filter(([, n]) => n != null)
), c9 = (e) => {
  const n = e;
  if (typeof n == "object" && "countryCodeV2" in n) {
    const { countryCodeV2: r, ...i } = n;
    return {
      ...i,
      ...r && { countryCode: r }
    };
  }
  return e;
}, AF = ({
  orderId: e,
  refundShipping: n,
  refundLineItems: r,
  suggestFullRefund: i,
  skip: a
}) => {
  const { useQuery: o } = hn(), {
    data: s,
    previousData: l,
    loading: d,
    error: m
  } = o(GW, {
    skip: a,
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: !0,
    variables: {
      orderId: e,
      refundShipping: n,
      refundLineItems: r,
      suggestFullRefund: i
    }
  }), u = a ? void 0 : s?.Shopify?.order?.suggestedRefund ?? l?.Shopify?.order?.suggestedRefund;
  return { suggestedRefund: Xn(() => {
    if (u)
      return {
        amount: String(u.amountSet.presentmentMoney.amount),
        subtotal: String(u.subtotalSet.presentmentMoney.amount),
        tax: String(u.totalTaxSet.presentmentMoney.amount),
        currency: u.amountSet.presentmentMoney.currencyCode,
        shipping: {
          amount: String(
            u.shipping.amountSet.presentmentMoney.amount
          ),
          maximumRefundable: String(
            u.shipping.maximumRefundableSet.presentmentMoney.amount
          )
        },
        transactions: RF(
          e,
          u.suggestedTransactions
        ),
        refundLineItems: u.refundLineItems.map(
          ({ lineItem: f }) => ({
            lineItemId: f.id,
            quantity: f.quantity
          })
        )
      };
  }, [u, e]), isLoading: d, error: m };
}, d9 = {
  nodes: [],
  hasMoreResults: !1
}, qj = (e) => "codes" in e.discount ? e.discount.codes.nodes[0]?.code ?? "" : "", u9 = (e) => [...e].sort(
  (n, r) => qj(n).localeCompare(qj(r))
), m9 = (e) => {
  const n = e?.Shopify?.discountNodes;
  return {
    nodes: u9(n?.nodes ?? []),
    hasMoreResults: !!n?.pageInfo?.hasNextPage
  };
}, p9 = 300, Hj = 2, f9 = 250, LF = ({
  enabled: e = !0
} = {}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = me(""), [o, s] = me([]), [l, d] = me(!1), [m, u] = me(!1), f = $r(null), h = $r(0), [k] = n(QW, {
    fetchPolicy: "no-cache"
  }), C = (j) => {
    s(j.nodes), d(j.hasMoreResults);
  }, N = async (j, _) => {
    const g = h.current + 1;
    h.current = g, u(!0);
    try {
      const D = await k({
        variables: { query: j, first: f9 }
      });
      if (g !== h.current)
        return;
      if (D.error)
        throw D.error;
      const O = m9(D.data);
      _ && (f.current = O), C(O);
    } catch {
      if (g !== h.current)
        return;
      C(d9), r({
        title: "Something went wrong",
        text: "Could not search for discount codes. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    } finally {
      g === h.current && u(!1);
    }
  };
  return ki(
    () => {
      if (!e)
        return;
      const j = i.trim(), _ = j.length === 0;
      if (!(!_ && j.length < Hj)) {
        if (_ && f.current) {
          C(f.current);
          return;
        }
        N(
          _ ? void 0 : j,
          _
        );
      }
    },
    p9,
    [i, e]
  ), {
    discountNodes: o,
    isLoading: m,
    hasMoreResults: l,
    filter: i,
    setFilter: a,
    minSearchCharacters: Hj
  };
}, h9 = "_list_alvh6_1", y9 = "_listItem_alvh6_4", g9 = "_fullWidth_alvh6_15", v9 = "_boxWrapper_alvh6_19", Mt = {
  list: h9,
  listItem: y9,
  fullWidth: g9,
  boxWrapper: v9
}, k9 = "_modal_1vkwz_1", b9 = "_disabled_1vkwz_5", $h = {
  modal: k9,
  disabled: b9
}, Wj = [
  {
    label: "Single Opt-In",
    description: "After providing their information, the customer receives marketing information without any intermediate steps.",
    value: zi.SingleOptIn
  },
  {
    label: "Confirmed Opt-In",
    description: "After providing their information, the customer receives a confirmation and is required to perform a intermediate step before receiving marketing information.",
    value: zi.ConfirmedOptIn
  },
  {
    label: "Unknown",
    description: "The customer receives marketing information but how they were opted in is unknown.",
    value: zi.Unknown
  }
], Kj = [
  {
    label: "Not Subscribed",
    description: "The customer hasn’t subscribed to SMS marketing.",
    value: Mr.NotSubscribed
  },
  {
    label: "Pending",
    description: "The customer is in the process of subscribing to SMS marketing.",
    value: Mr.Pending
  },
  {
    label: "Redacted",
    description: "The customer’s personal data is erased. This value is internally-set and read-only.",
    value: Mr.Redacted
  },
  {
    label: "Subscribed",
    description: "The customer is subscribed to SMS marketing.",
    value: Mr.Subscribed
  },
  {
    label: "Unsubscribed",
    description: "The customer isn’t currently subscribed to SMS marketing but was previously subscribed.",
    value: Mr.Unsubscribed
  }
], _9 = ({
  conversationContext: e,
  isOpen: n,
  setIsOpen: r,
  isMutationLoading: i,
  setIsMutationLoading: a,
  refetchCustomer: o
}) => {
  const { track: s } = Cn(), { useMutation: l, showNotification: d } = hn(), [m, u] = me(), [f, h] = me(), [k, C] = P_(!0), [N, j] = P_(!0), _ = !!m, g = e.customer?.email, D = e.customer?.phone_number, O = e.customer?.given_name, I = e.customer?.family_name, F = {
    email: g ?? "",
    phone: D ?? "",
    firstName: O ?? "",
    lastName: I ?? "",
    smsMarketingState: null,
    smsMarketingOptInLevel: null
  }, L = ut({
    defaultValues: F
  });
  Qe(() => {
    f?.forEach((P) => {
      const B = P?.field?.[0];
      B && (L.setError(B, {
        type: "server",
        message: P.message
      }), L.setFocus(B));
    });
  }, [f, L]);
  const [K, { error: J, reset: te }] = l(t9, {
    onError: (P) => {
      u(P.message), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: async (P) => {
      const B = P?.Shopify?.customerCreate?.userErrors || [];
      B.length > 0 ? (h(B), a(!1), d({
        title: "Something went wrong",
        text: "The customer creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      })) : (setTimeout(async () => {
        await o(), a(!1);
      }, 3e3), d({
        title: "Success",
        text: "The customer creation was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), s("shopify:profile:created"), r(!1));
    }
  }), W = _t(
    (P) => {
      a(!0), u(void 0), K({
        variables: {
          input: {
            firstName: P.firstName,
            lastName: P.lastName,
            ...k && { email: P.email },
            ...N && { phone: P.phone },
            ...P.smsMarketingState && {
              smsMarketingConsent: {
                marketingState: P.smsMarketingState,
                marketingOptInLevel: P.smsMarketingOptInLevel
              }
            }
          }
        }
      });
    },
    [K, a, N, k]
  ), Y = () => {
    r(!1), te(), u(void 0), L.reset(F);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: Y, className: $h.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Create new customer", onClose: Y }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "First name",
          name: "firstName",
          control: L.control,
          rules: {
            required: "First name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "Last name",
          name: "lastName",
          control: L.control,
          rules: {
            required: "Last name is required"
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "Email",
          name: "email",
          control: L.control,
          rules: {
            required: k ? "Email is required" : void 0
          },
          componentProps: {
            className: dt({
              [$h.disabled]: !k
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Ao,
                {
                  disabled: !N,
                  name: "hasEmail",
                  value: "email",
                  checked: k,
                  onChange: () => C()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          label: "Phone",
          name: "phone",
          control: L.control,
          rules: {
            required: N ? "Phone is required" : void 0
          },
          componentProps: {
            className: dt({
              [$h.disabled]: !N
            }),
            prefix: {
              type: "custom",
              value: /* @__PURE__ */ v.jsx(
                Ao,
                {
                  disabled: !k,
                  name: "hasPhone",
                  value: "phone",
                  checked: N,
                  onChange: () => j()
                }
              )
            }
          }
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        xr,
        {
          control: L.control,
          label: "SMS marketing state",
          name: "smsMarketingState",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing state"
            }
          },
          componentProps: {
            placeholder: "Select a marketing state",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Kj.find(
                (re) => re.value === P
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Kj.map((P) => /* @__PURE__ */ v.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        xr,
        {
          control: L.control,
          label: "SMS marketing opt-in level",
          name: "smsMarketingOptInLevel",
          rules: {
            required: {
              value: !0,
              message: "Please select a marketing opt-in level"
            }
          },
          componentProps: {
            placeholder: "Select a marketing opt-in level",
            equalityFn: (P, B) => P === B,
            getItemTitleByValue: (P) => {
              const B = Wj.find(
                (re) => re.value === P
              );
              return /* @__PURE__ */ v.jsxs(
                b,
                {
                  flexDirection: "column",
                  gap: "100",
                  margin: "100 0 200",
                  children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: B.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: B.description })
                  ]
                }
              );
            }
          },
          children: Wj.map((P) => /* @__PURE__ */ v.jsx(mt.Item, { value: P.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: P.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: P.description })
          ] }) }, P.value))
        }
      ) }),
      _ && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "close-circle-filled", color: "red.500" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { children: m })
      ] }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(L.formState.isValid && L.formState.isDirty),
          isLoading: i,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
        },
        confirmOnClick: L.handleSubmit(W),
        cancelOnClick: Y,
        confirmName: J ? "Close" : "Save",
        cancelName: J ? void 0 : "Cancel"
      }
    )
  ] });
}, x9 = ({
  conversationContext: e,
  refetchCustomer: n
}) => {
  const [r, i] = me(!1), [a, o] = me(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        onClick: () => i(!0),
        isLoading: a,
        loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
        slotStart: /* @__PURE__ */ v.jsx(ve, { size: 14, name: "user-plus", color: "green.500" }),
        className: Mt.fullWidth,
        children: "Create new Shopify profile"
      }
    ),
    /* @__PURE__ */ v.jsx(
      _9,
      {
        isOpen: r,
        setIsOpen: i,
        isMutationLoading: a,
        setIsMutationLoading: o,
        conversationContext: e,
        refetchCustomer: n
      }
    )
  ] });
}, Xg = (e) => {
  const n = e?.match(/shopify\/\w+\/(\d+)/);
  return n ? n[1] : null;
}, by = "DD MMM YYYY @ HH:mm", S9 = "_wrapper_10fld_1", N9 = "_copyIcon_10fld_7", zs = {
  wrapper: S9,
  copyIcon: N9
}, j9 = ({
  customer: e,
  shopifyDomain: n,
  refresh: r,
  loading: i,
  networkStatus: a
}) => {
  const { isCopied: o, copy: s } = Hr(), { isCopied: l, copy: d } = Hr(), { track: m } = Cn();
  if (!e)
    return null;
  const {
    id: u,
    displayName: f,
    defaultEmailAddress: h,
    defaultPhoneNumber: k,
    tags: C = [],
    verifiedEmail: N
  } = e, j = h?.emailAddress, _ = k?.phoneNumber, g = Xg(u), D = `https://${n}/admin/customers/${g ?? ""}`, O = i && a === tr.refetch, I = 14;
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { className: zs.wrapper, gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: f }),
        O ? /* @__PURE__ */ v.jsx(fn, { size: I }) : /* @__PURE__ */ v.jsx(Xe, { content: "Reload customer", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: I,
            name: "sync",
            onClick: () => {
              m("shopify:refreshed", { shopifyId: u }), r();
            },
            className: zs.copyIcon
          }
        ) })
      ] }),
      j && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ve, { size: I, name: "mail" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `mailto:${j}`, children: j }),
          /* @__PURE__ */ v.jsx(
            Xe,
            {
              content: N ? "Verified email" : "Email is not verified",
              children: /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx(
                ve,
                {
                  size: I,
                  color: N ? "green.500" : "red.500",
                  name: N ? "check-circle" : "exclamation"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Copy Email", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: I,
            name: o ? "done" : "copy",
            onClick: () => s(j),
            className: zs.copyIcon
          }
        ) })
      ] }),
      _ && /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
          /* @__PURE__ */ v.jsx(ve, { size: I, name: "phone" }),
          /* @__PURE__ */ v.jsx($.ExternalLink, { href: `tel:${_}`, children: _ })
        ] }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: I,
            name: l ? "done" : "copy",
            onClick: () => d(_),
            className: zs.copyIcon
          }
        ) })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(ve, { size: I, name: "external-link" }),
        /* @__PURE__ */ v.jsx(
          $.ExternalLink,
          {
            href: D,
            target: "_blank",
            rel: "noreferrer",
            children: "View customer in Shopify"
          }
        )
      ] })
    ] }),
    C.length > 0 && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Tags" }),
      /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: C.map((F) => /* @__PURE__ */ v.jsx(Jn, { children: F }, `${u}-${F}`)) })
    ] })
  ] });
}, w9 = "_creationModal_pbe64_1", C9 = "_detailsModal_pbe64_5", F9 = "_percentageSuffix_pbe64_9", Th = {
  creationModal: w9,
  detailsModal: C9,
  percentageSuffix: F9
}, I9 = () => {
  const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  return Array.from(
    { length: 12 },
    () => e.charAt(Math.floor(Math.random() * e.length))
  ).join("");
}, E9 = (e) => {
  const n = e.customerGetsOption === "percentage" ? e.customerGets / 100 : e.customerGets, r = (() => {
    switch (e.minimumRequirementOption) {
      case "quantity":
        return "greaterThanOrEqualToQuantity";
      case "subtotal":
        return "greaterThanOrEqualToSubtotal";
      default:
        return null;
    }
  })(), i = e.maximumUsage;
  return {
    code: e.code,
    title: e.title,
    usageLimit: i === "only-once" ? 1 : null,
    appliesOncePerCustomer: i === "once-per-customer",
    customerGets: {
      value: {
        [e.customerGetsOption]: e.customerGetsOption === "discountAmount" ? { amount: n } : n
      },
      items: {
        all: !0
      }
    },
    context: {
      all: EF.All
    },
    ...r && {
      minimumRequirement: {
        [e.minimumRequirementOption]: {
          [r]: e.minimumRequirementOption === "quantity" ? e.minimumRequirementValue?.toString() : e.minimumRequirementValue
        }
      }
    },
    startsAt: (/* @__PURE__ */ new Date()).toISOString()
  };
}, Gj = [
  {
    label: "Percentage",
    description: "The percentage value of the discount.",
    value: "percentage"
  },
  {
    label: "Amount",
    description: "The value of the discount.",
    value: "discountAmount"
  }
], Yj = [
  {
    label: "None",
    description: "No minimum requirements.",
    value: "none"
  },
  {
    label: "Quantity",
    description: "Minimum required quantity of items.",
    value: "quantity"
  },
  {
    label: "Subtotal",
    description: "Minimum required order subtotal.",
    value: "subtotal"
  }
], Jj = [
  {
    label: "No limit",
    value: "no-limit",
    description: "The discount code can be used unlimited times."
  },
  {
    label: "Only once",
    value: "only-once",
    description: "The discount code can only be used once."
  },
  {
    label: "Once per customer",
    value: "once-per-customer",
    description: "The discount code can be used once per customer."
  }
], $9 = ({
  codeDiscount: e
}) => {
  const n = e?.codes?.nodes?.[0]?.code, { isCopied: r, copy: i } = Jt(), a = e?.usageLimit ? `${e?.usageLimit} uses remaining` : "No limit";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "400", children: [
    /* @__PURE__ */ v.jsxs(Ye, { children: [
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Title" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.title })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Status" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(
            ve,
            {
              name: e?.status === "ACTIVE" ? "check-circle-filled" : "circle-filled",
              color: e?.status === "ACTIVE" ? "green.500" : "neutral.500"
            }
          ),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.status })
        ] })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Usage limit" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: a })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Applies once per customer" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: e?.appliesOncePerCustomer ? "Yes" : "No" })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "1", children: "Starts at" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "2", color: "secondary", children: Gn(e?.startsAt).format(jt) })
      ] }) })
    ] }),
    /* @__PURE__ */ v.jsx(We, { label: "Discount code", children: /* @__PURE__ */ v.jsx(
      dr,
      {
        readOnly: !0,
        value: n,
        suffix: {
          type: "button",
          button: {
            icon: r ? "done" : "copy",
            onClick: () => {
              i(n);
            }
          }
        }
      }
    ) })
  ] });
}, T9 = "shopify-discount-code-form", Qj = {
  title: "",
  code: "",
  customerGets: void 0,
  customerGetsOption: "percentage",
  minimumRequirementOption: "none",
  minimumRequirementValue: void 0,
  maximumUsage: "only-once"
}, O9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const { track: r } = Cn(), { useMutation: i, showNotification: a } = hn(), [o, s] = me(
    []
  ), [l, d] = me(), m = ut({
    mode: "all",
    defaultValues: Qj
  });
  Qe(() => {
    o?.forEach((I) => {
      const F = I?.field?.[1];
      F && m.setError(F, {
        type: "server",
        message: I.message
      });
    });
  }, [o, m]);
  const u = !!l, f = m.watch("minimumRequirementOption"), h = m.watch("customerGetsOption"), k = Xn(() => {
    switch (f) {
      case "quantity":
        return "Minimum quantity";
      case "subtotal":
        return "Minimum subtotal";
      default:
        return "";
    }
  }, [f]), [
    C,
    {
      loading: N,
      error: j,
      reset: _
    }
  ] = i(r9, {
    onError: () => {
      a({
        title: "Something went wrong",
        text: "The discount code creation was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (I) => {
      const F = I?.Shopify?.discountCodeBasicCreate?.userErrors;
      if (F && F.length > 0)
        s(F);
      else {
        const L = I?.Shopify?.discountCodeBasicCreate?.codeDiscountNode?.codeDiscount;
        L && "codes" in L && d(L), a({
          title: "Success",
          text: "The discount code was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), r("shopify:discount:code:created"), s([]);
      }
    }
  }), g = () => {
    m.setValue("code", I9(), {
      shouldDirty: !0,
      shouldValidate: !0,
      shouldTouch: !0
    });
  }, D = (I) => {
    C({
      variables: {
        input: E9(I)
      }
    });
  }, O = () => {
    m.reset(Qj), s([]), _(), d(void 0), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: O,
      className: dt({
        [Th.creationModal]: !u,
        [Th.detailsModal]: u
      }),
      children: [
        /* @__PURE__ */ v.jsx(
          Ct,
          {
            title: u ? "Discount code details" : "Create new discount code",
            onClose: O
          }
        ),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          u && /* @__PURE__ */ v.jsx($9, { codeDiscount: l }),
          !u && /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: T9, onSubmit: m.handleSubmit(D), children: [
            /* @__PURE__ */ v.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ v.jsx(
              Cy,
              {
                variant: "info",
                description: /* @__PURE__ */ v.jsx($.Paragraph, { children: "This code will be eligible for all customers." })
              }
            ) }),
            /* @__PURE__ */ v.jsxs(nt, { children: [
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Title",
                  name: "title",
                  control: m.control,
                  rules: {
                    required: "Please enter a title"
                  },
                  componentProps: {
                    placeholder: "Enter a title"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                xr,
                {
                  control: m.control,
                  label: "Discount type",
                  name: "customerGetsOption",
                  rules: {
                    required: "Please select a discount type"
                  },
                  componentProps: {
                    placeholder: "Select a discount type",
                    equalityFn: (I, F) => I === F,
                    onChange: () => {
                      m.setValue("customerGets", void 0), m.clearErrors("customerGets");
                    },
                    getItemTitleByValue: (I) => {
                      const F = Gj.find(
                        (L) => L.value === I
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: Gj.map((I) => /* @__PURE__ */ v.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Discount value",
                  name: "customerGets",
                  control: m.control,
                  rules: {
                    required: "Please enter a value",
                    validate: (I) => {
                      if (I) {
                        if (h === "percentage" && (I < 0 || I > 100))
                          return "Percentage must be between 0 and 100";
                        if (h === "discountAmount" && I < 0)
                          return "Discount amount must be greater than 0";
                      }
                    }
                  },
                  componentProps: {
                    placeholder: "Enter a value",
                    type: "number",
                    ...h === "percentage" && {
                      suffix: {
                        type: "custom",
                        noWrap: !0,
                        value: /* @__PURE__ */ v.jsx(
                          b,
                          {
                            alignItems: "center",
                            className: Th.percentageSuffix,
                            children: "%"
                          }
                        )
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Code",
                  name: "code",
                  control: m.control,
                  rules: {
                    required: "Please enter a code"
                  },
                  componentProps: {
                    placeholder: "Enter a code or click to the right to generate",
                    suffix: {
                      type: "button",
                      button: {
                        icon: "sync",
                        onClick: g
                      }
                    }
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                xr,
                {
                  control: m.control,
                  label: "Minimum purchase requirements",
                  name: "minimumRequirementOption",
                  rules: {
                    required: "Please select a minimum requirement option"
                  },
                  componentProps: {
                    placeholder: "Select a minimum purchase requirement",
                    equalityFn: (I, F) => I === F,
                    onChange: () => {
                      m.setValue("minimumRequirementValue", void 0), m.clearErrors("minimumRequirementValue");
                    },
                    getItemTitleByValue: (I) => {
                      const F = Yj.find(
                        (L) => L.value === I
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: Yj.map((I) => /* @__PURE__ */ v.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
                Pn,
                {
                  name: "minimumRequirementValue",
                  label: k,
                  control: m.control,
                  disabled: f === "none",
                  rules: {
                    required: {
                      value: f !== "none",
                      message: "Please enter a value"
                    },
                    validate: (I) => {
                      if (I && f !== "none" && I < 0)
                        return `Minimum ${f} must be greater than 0`;
                    }
                  },
                  componentProps: {
                    type: "number",
                    placeholder: "Enter a value"
                  }
                }
              ) }),
              /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
                xr,
                {
                  name: "maximumUsage",
                  label: "Maximum usage",
                  control: m.control,
                  componentProps: {
                    placeholder: "Select a maximum usage",
                    equalityFn: (I, F) => I === F,
                    getItemTitleByValue: (I) => {
                      const F = Jj.find(
                        (L) => L.value === I
                      );
                      return /* @__PURE__ */ v.jsx(b, { margin: "0 0 100", children: /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: F?.label }) });
                    }
                  },
                  children: Jj.map((I) => /* @__PURE__ */ v.jsx(mt.Item, { value: I.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
                    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
                  ] }) }, I.value))
                }
              ) })
            ] })
          ] }),
          j && /* @__PURE__ */ v.jsx(En, { error: j })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !u && !(m.formState.isValid && m.formState.isDirty),
              isLoading: N,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
            },
            confirmName: u ? "Close" : "Save",
            confirmOnClick: u ? O : m.handleSubmit(D),
            cancelOnClick: u ? void 0 : O
          }
        )
      ]
    }
  );
}, R9 = ({ code: e }) => {
  const { isCopied: n, copy: r } = Hr();
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "200",
      width: "100%",
      children: [
        /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ v.jsx(ve, { size: 12, name: "shopify", color: "green.500" }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e })
        ] }),
        /* @__PURE__ */ v.jsx(
          ir,
          {
            icon: n ? "done" : "copy",
            onClick: () => r(e),
            variant: "secondary"
          }
        )
      ]
    }
  );
}, D9 = ({
  discountCode: e
}) => {
  const { discount: n } = e;
  if (!("codes" in n))
    return null;
  const r = n?.codes?.nodes ?? [];
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: n.title }),
    /* @__PURE__ */ v.jsx(Ye, { children: r.map((i) => /* @__PURE__ */ v.jsx(Ye.Item, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(R9, { code: i.code }) }, i.code)) })
  ] });
}, P9 = "_modal_11d6e_1", A9 = "_modalBody_11d6e_4", L9 = "_codeContainer_11d6e_9", Oh = {
  modal: P9,
  modalBody: A9,
  codeContainer: L9
}, V9 = ({
  isOpen: e,
  setIsOpen: n
}) => {
  const {
    discountNodes: r,
    isLoading: i,
    filter: a,
    setFilter: o,
    minSearchCharacters: s
  } = LF({ enabled: e }), l = r.length === 0, d = () => {
    o(""), n(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: e, onClose: d, className: Oh.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Discount codes", onClose: d }),
    /* @__PURE__ */ v.jsxs(Ft, { className: Oh.modalBody, children: [
      /* @__PURE__ */ v.jsx(
        dr,
        {
          type: "search",
          icon: "search",
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (m) => {
            o(m.target.value);
          }
        }
      ),
      i && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }),
      !i && l && /* @__PURE__ */ v.jsx(
        Lo,
        {
          title: "No discount codes found.",
          description: "There are no discount codes to display. You can create a new discount code with the 'Create new' button in our integration."
        }
      ),
      !i && !l && r.map((m) => /* @__PURE__ */ v.jsx("div", { className: Oh.codeContainer, children: /* @__PURE__ */ v.jsx(D9, { discountCode: m }) }, m.id))
    ] }),
    /* @__PURE__ */ v.jsx(Et, { confirmName: "Close", confirmOnClick: d })
  ] });
}, z9 = ({
  displayDiscountCodeCreation: e
}) => {
  const [n, r] = me(!1), [i, a] = me(!1);
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Discount codes" }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", alignItems: "center", width: "100%", children: [
        /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          ct,
          {
            variant: "secondary",
            icon: "gift",
            onClick: () => a(!0),
            style: { width: "100%" },
            children: "View discount codes"
          }
        ) }),
        e && /* @__PURE__ */ v.jsx(b, { flex: "1", children: /* @__PURE__ */ v.jsx(
          ct,
          {
            variant: "secondary",
            icon: "plus",
            onClick: () => r(!0),
            style: { width: "100%" },
            children: "Create new"
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      V9,
      {
        isOpen: i,
        setIsOpen: a
      }
    ),
    /* @__PURE__ */ v.jsx(
      O9,
      {
        isOpen: n,
        setIsOpen: r
      }
    )
  ] });
}, U9 = ({
  customer: e
}) => {
  if (!e)
    return null;
  const { defaultEmailAddress: n, defaultPhoneNumber: r } = e, i = (h) => h ? kw(h.replaceAll("_", " ")) : "No state available", a = (h) => {
    switch (h) {
      case ua.Invalid:
      case ua.NotSubscribed:
      case Mr.NotSubscribed:
        return "red.500";
      case ua.Pending:
      case Mr.Pending:
      case ua.Unsubscribed:
      case Mr.Unsubscribed:
        return "orange.500";
      case ua.Subscribed:
      case Mr.Subscribed:
        return "green.500";
      default:
        return "neutral.500";
    }
  }, o = (h) => {
    switch (h) {
      case zi.SingleOptIn:
      case zi.ConfirmedOptIn:
        return "green.500";
      case zi.Unknown:
      default:
        return "neutral.200";
    }
  }, {
    marketingState: s,
    marketingUpdatedAt: l,
    marketingOptInLevel: d
  } = n ?? {}, {
    marketingState: m,
    marketingUpdatedAt: u,
    marketingOptInLevel: f
  } = r ?? {};
  return /* @__PURE__ */ v.jsxs(b, { gap: "300", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Marketing consent" }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "mail", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Email" })
      ] }),
      l && /* @__PURE__ */ v.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Mn, { size: "small", variant: "info", children: Gn(l).format(by) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(d), children: i(d) }) }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(s), children: i(s) }) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ v.jsx(ve, { name: "phone", color: "neutral.500" }),
        /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-4", children: "Phone" })
      ] }),
      u && /* @__PURE__ */ v.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ v.jsx(Mn, { size: "small", variant: "info", children: Gn(u).format(by) }) }),
      /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Opt-In state", children: /* @__PURE__ */ v.jsx(Jn, { color: o(f), children: i(f) }) }),
        /* @__PURE__ */ v.jsx(Xe, { content: "Marketing state", children: /* @__PURE__ */ v.jsx(Jn, { color: a(m), children: i(m) }) })
      ] })
    ] })
  ] });
}, M9 = (e) => {
  const { discount: n } = e;
  switch (n.__typename) {
    case "Shopify_DiscountCodeBasic": {
      if (n.status !== ky.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      if (!r)
        return null;
      const { value: i } = n.customerGets;
      return i.__typename === "Shopify_DiscountPercentage" ? {
        code: r,
        kind: "percentage",
        percentage: Number((i.percentage * 100).toFixed(2))
      } : i.__typename === "Shopify_DiscountAmount" ? {
        code: r,
        kind: "fixedAmount",
        amount: String(i.amount.amount),
        currencyCode: i.amount.currencyCode
      } : null;
    }
    case "Shopify_DiscountCodeFreeShipping": {
      if (n.status !== ky.Active)
        return null;
      const r = n.codes.nodes[0]?.code;
      return r ? { code: r, kind: "freeShipping" } : null;
    }
    default:
      return null;
  }
}, B9 = (e) => {
  const n = e.map(M9).filter(
    (i) => !!i
  ), r = /* @__PURE__ */ new Map();
  return n.forEach((i) => {
    r.has(i.code) || r.set(i.code, i);
  }), Array.from(r.values());
}, VF = (e) => {
  if (e)
    switch (e.kind) {
      case "percentage":
        return {
          itemPercentageDiscountCode: {
            code: e.code,
            percentage: e.percentage
          }
        };
      case "fixedAmount":
        return {
          itemFixedDiscountCode: {
            code: e.code,
            amountSet: {
              shopMoney: {
                amount: e.amount,
                currencyCode: e.currencyCode
              }
            }
          }
        };
      case "freeShipping":
        return { freeShippingDiscountCode: { code: e.code } };
      default:
        return;
    }
}, q9 = (e) => e ? [e.code] : void 0, _y = (e) => {
  switch (e.kind) {
    case "percentage":
      return `${e.percentage}% off`;
    case "fixedAmount":
      return `${e.amount} ${e.currencyCode} off`;
    case "freeShipping":
      return "Free shipping";
    default:
      return "";
  }
}, zF = ({
  enabled: e
}) => {
  const n = Rr(), { discountNodes: r, isLoading: i, filter: a, setFilter: o, minSearchCharacters: s } = LF({ enabled: e }), l = Xn(
    () => B9(r),
    [r]
  ), d = a.trim().length > 0;
  if (!i && !d && l.length === 0)
    return null;
  const m = !i && l.length === 0;
  return /* @__PURE__ */ v.jsx(
    xr,
    {
      label: "Discount code",
      control: n.control,
      name: "discountCode",
      componentProps: {
        clearable: !0,
        placeholder: "Search discount codes",
        tabIndex: 0,
        equalityFn: (u, f) => u?.code === f?.code,
        getItemTitleByValue: (u) => u ? /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
          u.code,
          " · ",
          _y(u)
        ] }) : null,
        filter: {
          value: a,
          placeholder: `Search discount codes (min. ${s} characters)`,
          onChange: (u) => {
            o(u.target.value);
          }
        },
        onToggleDropdown: (u) => {
          !u && a !== "" && o("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        i && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }) }),
        !i && l.map((u) => /* @__PURE__ */ v.jsx(mt.Item, { value: u, children: /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            gap: "200",
            children: [
              d ? /* @__PURE__ */ v.jsx(
                Nw,
                {
                  text: u.code,
                  highlight: a
                }
              ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: u.code }),
              /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "tertiary", children: _y(u) })
            ]
          }
        ) }, u.code)),
        m && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Lo,
          {
            title: "No discount codes found",
            description: "Try changing your search criteria."
          }
        ) })
      ] })
    }
  );
}, Ii = ({
  control: e,
  name: n,
  label: r,
  placeholder: i,
  required: a = !1,
  apiUserError: o
}) => /* @__PURE__ */ v.jsx(
  bt,
  {
    name: n,
    control: e,
    rules: {
      required: a ? {
        value: !0,
        message: "This field is required"
      } : !1
    },
    render: ({ field: s, fieldState: l }) => /* @__PURE__ */ v.jsx(
      Wr,
      {
        required: a,
        label: r,
        input: s,
        placeholder: i,
        meta: {
          warning: l?.error?.message,
          error: l?.error?.message || o?.[s.name]
        }
      }
    )
  }
), H9 = "_modal_1wlra_1", W9 = {
  modal: H9
};
function Xj(e) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      e.toUpperCase()
    ) ?? e;
  } catch {
    return e;
  }
}
const Zj = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], ew = "shopify-shiping-address-form", K9 = ({
  title: e,
  address: n,
  isOpen: r,
  setIsOpen: i,
  orderId: a,
  shopifyId: o,
  shippingCountryCodes: s,
  onChange: l,
  refetchOrders: d
}) => {
  const { useMutation: m, showNotification: u } = hn(), { track: f } = Cn(), [h, k] = me(!1), [C, N] = me({}), j = !l, [
    _,
    { error: g, reset: D }
  ] = m(XW, {
    onError: () => {
      k(!1), u({
        title: "Something went wrong",
        text: "The address change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    },
    onCompleted: (W) => {
      k(!1);
      const Y = W?.Shopify?.orderUpdate?.userErrors;
      if (Y != null && Y.length > 0) {
        const P = Y.reduce(
          (B, re) => {
            const je = re.field;
            if (je == null || je.length === 0)
              return B;
            const ue = je[je.length - 1];
            return ue != null && (B[ue] = re.message), B;
          },
          {}
        );
        N(P);
      } else
        u({
          title: "Success",
          text: "The address change was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), d(), te();
    }
  }), O = _t(
    () => ({
      firstName: n?.firstName || "",
      lastName: n?.lastName || "",
      company: n?.company || "",
      address1: n?.address1 || "",
      address2: n?.address2 || "",
      city: n?.city || "",
      countryCodeV2: Zj.find(
        (W) => W === n?.countryCodeV2
      ),
      provinceCode: n?.province || "",
      zip: n?.zip || ""
    }),
    [n]
  ), { control: I, handleSubmit: F, formState: L, reset: K } = ut({
    mode: "all",
    defaultValues: O()
  }), J = F((W) => {
    if (j) {
      if (k(!0), !o || !a) {
        k(!1);
        return;
      }
      f("shopify:order:edit:shipping:address:modal:submitted", {
        shopifyId: o,
        orderId: a
      });
      const { countryCodeV2: Y, ...P } = W, B = {
        ...P,
        countryCode: Y
      };
      _({
        variables: {
          input: {
            id: a,
            shippingAddress: B
          }
        }
      });
    } else
      l(W), te();
  });
  Qe(() => {
    r && K(O());
  }, [r, n, K, O]);
  const te = () => {
    K(O()), N({}), D(), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: te,
      className: W9.modal,
      "data-testid": "edit-shipping-address-modal",
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: e, onClose: () => te() }),
        /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs("form", { noValidate: !0, id: ew, onSubmit: J, children: [
          g && /* @__PURE__ */ v.jsx(En, { error: g }),
          /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                required: !0,
                control: I,
                name: "firstName",
                label: "First name",
                placeholder: "Insert your first name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                required: !0,
                control: I,
                name: "lastName",
                label: "Last name",
                placeholder: "Insert your last name",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                control: I,
                name: "company",
                label: "Company",
                placeholder: "Insert your company name"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                required: !0,
                control: I,
                name: "address1",
                label: "Address",
                placeholder: "Insert your address",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                control: I,
                name: "address2",
                label: "Additional address details",
                placeholder: "Insert more address details"
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                required: !0,
                control: I,
                name: "zip",
                label: "Zip / postal code",
                placeholder: "Insert your zip / postal code",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 3, children: /* @__PURE__ */ v.jsx(
              Ii,
              {
                required: !0,
                control: I,
                name: "city",
                label: "City",
                placeholder: "Insert your city",
                apiUserError: C
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 6, children: /* @__PURE__ */ v.jsx(
              xr,
              {
                name: "countryCodeV2",
                control: I,
                label: "Country",
                rules: {
                  required: {
                    value: !0,
                    message: "Please select a country"
                  }
                },
                componentProps: {
                  placeholder: "Select your country",
                  getItemTitleByValue: (W) => W ? Xj(W) : ""
                },
                children: Zj.filter((W) => s.includes(W)).map((W) => /* @__PURE__ */ v.jsx(mt.Item, { value: W, children: /* @__PURE__ */ v.jsx($.Paragraph, { children: Xj(W) }) }, W))
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              disabled: !(L.isValid && L.isDirty),
              type: "submit",
              form: ew,
              isLoading: h,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
            },
            confirmOnClick: () => {
              g && te();
            },
            cancelOnClick: () => {
              o && a && !g && f("shopify:order:edit:shipping:address:modal:canceled", {
                shopifyId: o,
                orderId: a
              }), te();
            },
            confirmName: g ? "Close" : "Save",
            cancelName: g ? void 0 : "Cancel"
          }
        )
      ]
    }
  );
}, G9 = "_clickableIcon_33mqm_1", Rh = {
  clickableIcon: G9
}, nw = ({
  formFieldName: e,
  ...n
}) => {
  const r = Rr(), { field: i } = Ky({
    control: r.control,
    name: e
  });
  return /* @__PURE__ */ v.jsx(
    xy,
    {
      enableEditAddress: !0,
      openByDefault: !0,
      onChange: i.onChange,
      ...n
    }
  );
}, xy = ({
  labelText: e,
  address: n,
  orderId: r,
  shopifyId: i,
  shippingCountryCodes: a,
  enableEditAddress: o,
  icon: s = "home",
  onChange: l,
  refetchOrders: d,
  openByDefault: m = !1
}) => {
  const [u, f] = me(!1), [h, k] = me(m), { isCopied: C, copy: N } = Hr(), { track: j } = Cn(), _ = 14, g = o && (!!r || !!l), D = [n?.zip || "", n?.city || ""].filter(Boolean).join(" "), O = [n?.firstName || "", n?.lastName || ""].filter(Boolean).join(" "), I = n?.countryCodeV2 && yI(n.countryCodeV2), F = _t(() => [
    O,
    n?.company,
    n?.address1,
    n?.address2,
    D,
    n?.province,
    I
  ].filter(Boolean).join(`
`), [n, O, D, I]);
  if (!n)
    return null;
  const L = () => {
    i && r && j("shopify:order:edit:shipping:address:modal:opened", {
      shopifyId: i,
      orderId: r
    }), f(!0);
  };
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { size: _, name: s, color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "row",
              onClick: () => k(!h),
              className: Rh.clickableIcon,
              alignItems: "center",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: e }),
                /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: _,
                    name: h ? "angle-down" : "angle-right"
                  }
                )
              ]
            }
          ),
          h && /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
            O && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: O }),
            n?.company && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.company }),
            n?.address1 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address1 }),
            n?.address2 && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.address2 }),
            D && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: D }),
            n?.province && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.province }),
            I && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: I })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        g && /* @__PURE__ */ v.jsx(Xe, { content: `Edit ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: _,
            name: "pen",
            onClick: () => L(),
            className: Rh.clickableIcon
          }
        ) }),
        /* @__PURE__ */ v.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: _,
            name: C ? "done" : "copy",
            onClick: () => N(F()),
            className: Rh.clickableIcon
          }
        ) })
      ] })
    ] }),
    g && /* @__PURE__ */ v.jsx(
      K9,
      {
        title: `Edit ${e}`,
        address: n,
        isOpen: u,
        setIsOpen: f,
        orderId: r,
        shopifyId: i,
        shippingCountryCodes: a,
        onChange: l,
        refetchOrders: d
      }
    )
  ] });
}, UF = ({
  withAddresses: e = !0,
  selectedProductIds: n
}) => {
  const r = Rr(), i = yi({ control: r.control, name: "lineItems" }), a = yi({
    control: r.control,
    name: "billingAddress"
  }), o = yi({
    control: r.control,
    name: "shippingAddress"
  }), s = yi({
    control: r.control,
    name: "discountCode"
  }), l = Xn(() => n ? n.length === 0 ? [] : (i || []).filter(
    (u) => n.includes(u.id)
  ) : i, [i, n]), d = Xn(() => !l || l.length === 0 ? 0 : l.reduce((u, f) => {
    const h = f.priceRangeV2?.minVariantPrice?.amount || 0, k = f.quantity || 0;
    return u + h * k;
  }, 0), [l]), m = l?.[0]?.priceRangeV2?.minVariantPrice?.currencyCode || "";
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    e && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "3", children: [
        a?.firstName,
        " ",
        a?.lastName
      ] }),
      /* @__PURE__ */ v.jsx(
        nw,
        {
          formFieldName: "billingAddress",
          address: a,
          labelText: "Billing address",
          shippingCountryCodes: [],
          refetchOrders: () => Promise.resolve({})
        }
      ),
      /* @__PURE__ */ v.jsx(
        nw,
        {
          formFieldName: "shippingAddress",
          address: o,
          labelText: "Shipping address",
          shippingCountryCodes: [],
          icon: "map-pin",
          refetchOrders: () => Promise.resolve({})
        }
      )
    ] }),
    /* @__PURE__ */ v.jsx(Hl, {}),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: `${d.toFixed(2)} ${m}` })
    ] }),
    s && /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
      /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
          "Discount (",
          s.code,
          ")"
        ] }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: _y(s) })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "The discount will be deducted after the order is created." })
    ] }),
    /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", variant: "5", children: "Tax and shipping will be calculated by Shopify based on customer address and store settings." })
  ] });
}, Y9 = "_productTableHeader_6h6pl_1", J9 = "_productImage_6h6pl_5", Po = {
  productTableHeader: Y9,
  productImage: J9
}, Zg = (e) => e.media?.nodes?.[0]?.preview?.image?.url || null, Q9 = ({
  product: e,
  index: n,
  onRemove: r
}) => {
  const i = Rr(), a = e.priceRangeV2.minVariantPrice.amount, o = e.priceRangeV2.minVariantPrice.currencyCode, s = `lineItems.${n}.quantity`, l = i.watch(s), d = Zg(e);
  return /* @__PURE__ */ v.jsxs(at.Tr, { children: [
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
      d && /* @__PURE__ */ v.jsx(
        Ca,
        {
          src: d,
          alt: e.title,
          className: Po.productImage
        }
      ),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.title })
    ] }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e.totalInventory }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a} ${o}` }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(
      Pn,
      {
        noLabel: !0,
        noAlert: !0,
        name: s,
        control: i.control,
        componentProps: {
          type: "number",
          min: 1,
          max: e.totalInventory,
          tabIndex: 0
        }
      },
      `${s}-${l}`
    ) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${a * l} ${o}` }) }),
    /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(ir, { icon: "trash", variant: "secondary", onClick: r }) }) })
  ] });
}, X9 = 300, bo = 2, Z9 = 25, e7 = ({
  onProductSelected: e
}) => {
  const { useLazyQuery: n, showNotification: r } = hn(), [i, a] = me(""), [o, s] = me([]), l = Rr(), d = l.watch("selectedProductId"), [m, { loading: u, networkStatus: f }] = n(Qg, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0,
    onCompleted: (N) => {
      const j = N?.Shopify?.products?.nodes || [];
      s(
        j.filter((_) => !!_).sort((_, g) => _.title.localeCompare(g.title))
      );
    },
    onError: () => {
      s([]), r({
        title: "Something went wrong",
        text: "Could not search for products. Please try again.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      });
    }
  });
  ki(
    () => {
      i.trim().length >= bo && !u && f === tr.ready ? m({
        variables: {
          query: i.trim(),
          productCount: Z9,
          mediaCount: 1
        }
      }) : i.trim().length < bo && s([]);
    },
    X9,
    [i]
  ), Qe(() => {
    if (!d) return;
    const N = o.find(
      (j) => j.id === d
    );
    N && e(N), l.setValue("selectedProductId", void 0);
  }, [d, o, l, e]);
  const h = u && f !== tr.ready, k = i.trim().length >= bo, C = !o.length && !h && k;
  return /* @__PURE__ */ v.jsx(
    xr,
    {
      noAlert: !0,
      label: "Product selection",
      control: l.control,
      name: "selectedProductId",
      componentProps: {
        placeholder: `Search products (min. ${bo} characters)`,
        tabIndex: 0,
        getItemTitleByValue: (N) => {
          const j = o.find(
            (_) => _.id === N
          );
          return j ? /* @__PURE__ */ v.jsx($.Paragraph, { children: j.title }) : null;
        },
        filter: {
          value: i,
          onChange: (N) => {
            a(N.target.value);
          }
        },
        onToggleDropdown: (N) => {
          !N && i !== "" && a("");
        }
      },
      children: /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
        h && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(b, { justifyContent: "center", padding: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }) }),
        !h && o.map((N) => {
          const j = N.totalInventory <= 0, _ = Zg(N);
          return /* @__PURE__ */ v.jsx(
            mt.Item,
            {
              value: N.id,
              isDisabled: j,
              children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                  _ && /* @__PURE__ */ v.jsx(
                    Ca,
                    {
                      src: _,
                      alt: N.title,
                      className: Po.productImage
                    }
                  ),
                  i ? /* @__PURE__ */ v.jsx(
                    Nw,
                    {
                      text: N.title,
                      highlight: i
                    }
                  ) : /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: N.title })
                ] }),
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: j ? "Out of stock" : `${N.totalInventory} in stock` })
              ] })
            },
            N.id
          );
        }),
        C && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Lo,
          {
            title: "No products found",
            description: "Try changing your search criteria."
          }
        ) }),
        !k && !h && /* @__PURE__ */ v.jsx(mt.Item, { noFixedSelectionStateSpace: !0, children: /* @__PURE__ */ v.jsx(
          Lo,
          {
            title: "Search for products",
            description: `Type at least ${bo} characters to search.`
          }
        ) })
      ] })
    }
  );
}, ev = ({
  loading: e = !1,
  selectionMode: n = !1,
  hideDeleteButton: r = !1,
  hideProductSelect: i = !1,
  selectedProductIds: a = [],
  disabledProductIds: o = [],
  maxQuantities: s,
  onToggleSelect: l,
  onToggleSelectAll: d
}) => {
  const m = Rr(), u = m.watch("lineItems"), f = !!u?.length, h = n && f ? u.filter(
    (j) => !o.includes(j?.id)
  ) : [], k = h.length > 0 && h.every(
    (j) => a.includes(j?.id)
  ), C = h.some(
    (j) => a.includes(j?.id)
  ) && !k, N = _t(
    (j) => {
      const _ = m.getValues("lineItems"), g = _.findIndex(
        (D) => D?.id === j.id
      );
      if (g > -1) {
        const D = m.getValues(`lineItems.${g}.quantity`) || 0, O = [..._];
        O[g] = {
          ...O[g],
          quantity: D + 1
        }, m.setValue("lineItems", O);
      } else
        m.setValue("lineItems", [
          ..._,
          { ...j, quantity: 1 }
        ]);
    },
    [m]
  );
  return /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    !i && /* @__PURE__ */ v.jsx(e7, { onProductSelected: N }),
    !f && e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        padding: "300",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(fn, {})
      }
    ),
    !f && !e && /* @__PURE__ */ v.jsx(
      b,
      {
        margin: "200 0",
        justifyContent: "center",
        className: Mt.boxWrapper,
        children: /* @__PURE__ */ v.jsx(
          Lo,
          {
            title: "No products selected",
            description: "Select a product above for your new order"
          }
        )
      }
    ),
    f && /* @__PURE__ */ v.jsx(b, { margin: "300 0", children: /* @__PURE__ */ v.jsxs(
      at,
      {
        hoverable: !0,
        framed: !1,
        headerWithBackground: !1,
        className: Po.productTable,
        children: [
          /* @__PURE__ */ v.jsx(at.Thead, { className: Po.productTableHeader, children: /* @__PURE__ */ v.jsxs(at.Tr, { children: [
            n && /* @__PURE__ */ v.jsx(at.Th, { children: /* @__PURE__ */ v.jsx(
              sv,
              {
                checked: k,
                indeterminate: C,
                onChange: () => d?.(!k)
              }
            ) }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Product" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "In stock" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Price" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Quantity" }),
            /* @__PURE__ */ v.jsx(at.Th, { children: "Total" }),
            !r && /* @__PURE__ */ v.jsx(at.Th, {})
          ] }) }),
          /* @__PURE__ */ v.jsx(at.Tbody, { children: u?.map((j, _) => {
            if (!n)
              return /* @__PURE__ */ v.jsx(
                Q9,
                {
                  product: j,
                  index: _,
                  onRemove: () => {
                    const Y = u.filter(
                      (P, B) => B !== _
                    );
                    m.setValue("lineItems", Y);
                  }
                },
                `${j?.id}-${_}`
              );
            const g = j, D = g.priceRangeV2.minVariantPrice.amount, O = g.priceRangeV2.minVariantPrice.currencyCode, I = `lineItems.${_}.quantity`, F = m.watch(I) || 0, L = D * F, K = Zg(g), J = a.includes(g.id), te = o.includes(g.id), W = s?.[g.id] ?? g.totalInventory;
            return /* @__PURE__ */ v.jsxs(
              at.Tr,
              {
                style: te ? { opacity: 0.5 } : void 0,
                children: [
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(
                    sv,
                    {
                      checked: J,
                      disabled: te,
                      onChange: () => l?.(g.id, !J)
                    }
                  ) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", children: [
                    K && /* @__PURE__ */ v.jsx(
                      Ca,
                      {
                        src: K,
                        alt: g.title,
                        className: Po.productImage
                      }
                    ),
                    /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.title }),
                      te && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", children: "Already refunded" })
                    ] })
                  ] }) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: g.totalInventory }) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${D} ${O}` }) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(
                    Pn,
                    {
                      noLabel: !0,
                      noAlert: !0,
                      disabled: te || W <= 1,
                      name: I,
                      control: m.control,
                      componentProps: {
                        type: "number",
                        min: 1,
                        max: W,
                        tabIndex: 0
                      }
                    },
                    `${I}-${m.watch(I)}`
                  ) }),
                  /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: `${L} ${O}` }) }),
                  !r && /* @__PURE__ */ v.jsx(at.Td, { children: /* @__PURE__ */ v.jsx(b, { justifyContent: "flex-end", children: /* @__PURE__ */ v.jsx(
                    ir,
                    {
                      icon: "trash",
                      variant: "secondary",
                      onClick: () => {
                        const Y = u.filter(
                          (P, B) => B !== _
                        );
                        m.setValue("lineItems", Y), J && l?.(g.id, !1);
                      }
                    }
                  ) }) })
                ]
              },
              `${g.id}-${_}`
            );
          }) })
        ]
      }
    ) })
  ] });
}, MF = ({
  previousOrderStatus: e
} = {}) => {
  const n = Rr();
  return /* @__PURE__ */ v.jsx(
    xr,
    {
      label: "Payment Status",
      name: "financialStatus",
      control: n.control,
      rules: {
        required: {
          value: !0,
          message: "Please select a payment status"
        }
      },
      componentProps: {
        placeholder: "Select payment status",
        tabIndex: 0,
        getItemTitleByValue: (r) => {
          const i = Mj.find(
            (a) => a.value === r
          );
          return i ? /* @__PURE__ */ v.jsxs(
            b,
            {
              flexDirection: "row",
              gap: "200",
              alignItems: "center",
              margin: "0 0 100 0",
              children: [
                /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: i.label }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
                  "(",
                  i.description,
                  ")"
                ] })
              ]
            }
          ) : null;
        }
      },
      children: Mj.map((r) => {
        const i = e && r.value === e;
        return /* @__PURE__ */ v.jsx(mt.Item, { value: r.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
          /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            i && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: "(previous order status)" })
          ] }),
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: r.description })
        ] }) }, r.value);
      })
    }
  );
}, BF = () => {
  const e = Rr();
  return /* @__PURE__ */ v.jsx(
    xr,
    {
      label: "Fulfillment Status",
      helpIcon: {
        text: "Defaults to 'unfulfilled' if nothing is selected"
      },
      name: "fulfillmentStatus",
      control: e.control,
      componentProps: {
        clearable: !0,
        placeholder: "Select fulfillment status",
        tabIndex: 0,
        getItemTitleByValue: (n) => {
          const r = Bj.find(
            (i) => i.value === n
          );
          return r ? /* @__PURE__ */ v.jsxs(b, { gap: "200", alignItems: "center", margin: "0 0 100 0", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: r.label }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "5", color: "secondary", children: [
              "(",
              r.description,
              ")"
            ] })
          ] }) : null;
        }
      },
      children: Bj.map((n) => /* @__PURE__ */ v.jsx(mt.Item, { value: n.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "100", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: n.label }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "5", color: "secondary", children: n.description })
      ] }) }, n.value))
    }
  );
}, n7 = "_modal_1mprq_1", t7 = {
  modal: n7
}, Dh = "create-shopify-order-form", r7 = ({
  isOpen: e,
  shopifyCustomer: n,
  displayCreateDraftOrder: r,
  setIsOpen: i,
  refetchCustomerOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), [d, m] = me(!1), [
    u,
    f
  ] = me(!1), h = {
    firstName: n.defaultAddress?.firstName,
    lastName: n.defaultAddress?.lastName,
    address1: n.defaultAddress?.address1,
    address2: n.defaultAddress?.address2,
    city: n.defaultAddress?.city,
    zip: n.defaultAddress?.zip,
    countryCodeV2: n.defaultAddress?.countryCodeV2,
    phone: n.defaultAddress?.phone
  }, k = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: [],
    billingAddress: h,
    shippingAddress: h,
    financialStatus: Ui.Pending,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, [C, N] = me([]), j = ut({
    mode: "all",
    defaultValues: k
  }), _ = j.watch("lineItems").length > 0, g = () => {
    j.reset(k), N([]), i(!1);
  };
  Qe(() => {
    C.length > 0 && j.setValue("tags", C, { shouldDirty: !0 });
  }, [C, j]);
  const D = $r(!1), O = () => {
    a(), m(!1), s({
      title: "Success",
      text: "The order was created successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), l("shopify:order:create:succeeded"), g();
  }, I = () => {
    a(), m(!1), s({
      title: "Order created but not marked as paid",
      text: "The order was created but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), g();
  }, F = () => {
    m(!1), s({
      title: "Something went wrong",
      text: "The order creation was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), l("shopify:order:create:failed"), g();
  }, [L] = o(OF, {
    onError: I,
    onCompleted: (B) => {
      const re = B.Shopify?.orderMarkAsPaid?.userErrors;
      if (re && re.length > 0) {
        I();
        return;
      }
      O();
    }
  }), [K, { error: J }] = o(TF, {
    onError: F,
    onCompleted: (B) => {
      const re = B.Shopify?.orderCreate, je = re?.order?.id;
      if (re?.userErrors?.length || !je) {
        F();
        return;
      }
      if (D.current) {
        L({ variables: { input: { id: je } } });
        return;
      }
      O();
    }
  }), [te, { error: W }] = o(
    i9,
    {
      onError: () => {
        f(!1), s({
          title: "Something went wrong",
          text: "The draft order creation was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:create:draft:failed"), g();
      },
      onCompleted: () => {
        a(), f(!1), s({
          title: "Success",
          text: "The draft order creation was successful.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:create:draft:succeeded"), g();
      }
    }
  ), Y = (B) => {
    const re = B.lineItems.map((he) => ({
      productId: he.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: he.priceRangeV2.maxVariantPrice.amount,
          currencyCode: he.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: he.quantity
    }));
    m(!0);
    const je = ma(B?.billingAddress), ue = ma(
      B?.shippingAddress
    ), se = B.financialStatus === Ui.Paid;
    D.current = se, K({
      variables: {
        order: {
          lineItems: re,
          customer: {
            toAssociate: {
              id: n?.id
            }
          },
          note: B.customNote,
          tags: B.tags,
          financialStatus: se ? void 0 : B.financialStatus,
          fulfillmentStatus: B.fulfillmentStatus,
          discountCode: VF(B.discountCode),
          shippingAddress: ue,
          billingAddress: je
        }
      }
    });
  }, P = (B) => {
    const re = B.lineItems.map((se) => ({
      title: se.title,
      requiresShipping: !0,
      originalUnitPriceWithCurrency: {
        amount: se.priceRangeV2.maxVariantPrice.amount,
        currencyCode: se.priceRangeV2.maxVariantPrice.currencyCode
      },
      quantity: se.quantity
    }));
    f(!0);
    const je = ma(B?.billingAddress), ue = ma(
      B?.shippingAddress
    );
    te({
      variables: {
        input: {
          email: n.defaultEmailAddress?.emailAddress,
          note: B.customNote,
          tags: B.tags,
          lineItems: re,
          discountCodes: q9(B.discountCode),
          shippingAddress: ue,
          billingAddress: je
        }
      }
    });
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: e,
      onClose: g,
      className: t7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: "Create new order", onClose: g }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx(Wy, { ...j, children: /* @__PURE__ */ v.jsx("form", { id: Dh, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(ev, {}) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              bt,
              {
                name: "tags",
                render: ({ fieldState: { error: B } }) => /* @__PURE__ */ v.jsx(
                  We,
                  {
                    label: "Tags",
                    meta: {
                      error: B?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (re) => {
                          re.key === "Enter" && (re.preventDefault(), re.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          ql,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: C,
                            onChange: (re) => {
                              N(re);
                            }
                          },
                          `tags-input-${e}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(MF, {}),
              /* @__PURE__ */ v.jsx(BF, {}),
              /* @__PURE__ */ v.jsx(zF, { enabled: e }),
              /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(UF, {})
              }
            ) }) })
          ] }) }) }),
          (J || W) && /* @__PURE__ */ v.jsx(En, { error: J || W })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: Dh,
              disabled: !_ || d,
              isLoading: d,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: j.handleSubmit(Y),
            ...r && {
              confirmSecondaryName: "Create draft order",
              confirmSecondaryOnClick: () => {
                j.handleSubmit(P)();
              },
              confirmSecondaryProps: {
                type: "submit",
                form: Dh,
                disabled: !_ || u,
                isLoading: u,
                loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
                tabIndex: 0
              }
            }
          }
        )
      ]
    }
  );
}, i7 = "_modal_al73g_1", a7 = {
  modal: i7
}, tw = [
  {
    label: "Customer",
    value: Oi.Customer,
    description: "The customer wanted to cancel the order."
  },
  {
    label: "Declined",
    value: Oi.Declined,
    description: "Payment was declined."
  },
  {
    label: "Fraud",
    value: Oi.Fraud,
    description: "The order was fraudulent."
  },
  {
    label: "Inventory",
    value: Oi.Inventory,
    description: "There was insufficient inventory."
  },
  {
    label: "Other",
    value: Oi.Other,
    description: "The order was canceled for an unlisted reason."
  },
  {
    label: "Staff",
    value: Oi.Staff,
    description: "Staff made an error."
  }
], o7 = ({
  orderId: e,
  isOpen: n,
  orderName: r,
  setIsOpen: i,
  isMutationLoading: a,
  setIsMutationLoading: o,
  refetchOrders: s
}) => {
  const { track: l } = Cn(), { useMutation: d, showNotification: m } = hn(), [u, f] = me([]), h = u.length > 0, k = {
    orderId: e,
    reason: null,
    refundMethod: {
      originalPaymentMethodsRefund: !0
    },
    restock: !0,
    notifyCustomer: !1,
    staffNote: ""
  }, C = ut({
    defaultValues: k
  }), [N, { error: j, reset: _ }] = d(e9, {
    onError: () => {
      o(!1), m({
        title: "Something went wrong",
        text: "Could not cancel the order.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async (O) => {
      const I = O.Shopify?.orderCancel?.orderCancelUserErrors || [];
      if (I.length > 0)
        o(!1), f(I), m({
          title: "Something went wrong",
          text: "Could not cancel the order.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        });
      else {
        const F = O.Shopify?.orderCancel?.job?.done;
        setTimeout(async () => {
          await s().finally(() => o(!1));
        }, F ? 0 : 4e3), m({
          title: "Success",
          text: `${F ? "The order got cancelled" : "The order is being cancelled. It might take some time until it is reflected in the order details."}`,
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:cancelled"), i(!1);
      }
    }
  }), g = _t(
    (O) => {
      O.reason != null && (o(!0), N({
        variables: {
          orderId: O.orderId,
          reason: O.reason,
          refundMethod: O.refundMethod,
          restock: O.restock,
          notifyCustomer: O.notifyCustomer,
          staffNote: O.staffNote ?? ""
        }
      }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e]
  ), D = () => {
    i(!1), _(), f([]), C.reset(k);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: n, onClose: D, className: a7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Cancel order ${r}`, onClose: D }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(nt, { children: [
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        xr,
        {
          control: C.control,
          label: "Reason",
          name: "reason",
          rules: {
            required: {
              value: !0,
              message: "Please select a reason"
            }
          },
          componentProps: {
            placeholder: "Select a reason",
            equalityFn: (O, I) => O === I,
            getItemTitleByValue: (O) => {
              if (!O)
                return "";
              const I = tw.find(
                (F) => F.value === O
              );
              return /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
                /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: I.label }),
                /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: I.description })
              ] });
            }
          },
          children: tw.map((O) => /* @__PURE__ */ v.jsx(mt.Item, { value: O.value, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: O.label }),
            /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: O.description })
          ] }) }, O.value))
        }
      ) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Refund order", children: /* @__PURE__ */ v.jsx(
        bn,
        {
          control: C.control,
          name: "refundMethod.originalPaymentMethodsRefund"
        }
      ) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Restock items", children: /* @__PURE__ */ v.jsx(bn, { control: C.control, name: "restock" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(We, { label: "Notify the customer", children: /* @__PURE__ */ v.jsx(bn, { control: C.control, name: "notifyCustomer" }) }) }),
      /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        Pn,
        {
          name: "staffNote",
          label: "Staff note",
          control: C.control
        }
      ) }),
      h && /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: u.map((O) => /* @__PURE__ */ v.jsxs(
        b,
        {
          flexDirection: "row",
          gap: "200",
          alignItems: "center",
          children: [
            /* @__PURE__ */ v.jsx(ve, { name: "close-circle-filled", color: "red.500" }),
            /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: O.code }),
            /* @__PURE__ */ v.jsxs($.Paragraph, { children: [
              "(",
              O.field?.join(","),
              ") ",
              O.message
            ] })
          ]
        },
        O.code
      )) }) })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(C.formState.isValid && C.formState.isDirty),
          isLoading: a,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
        },
        confirmOnClick: C.handleSubmit(g),
        cancelOnClick: D,
        confirmName: j ? "Close" : "Cancel order",
        cancelName: j ? void 0 : "Cancel"
      }
    )
  ] });
}, s7 = ({
  orderId: e,
  orderName: n,
  refetchOrders: r,
  disabled: i
}) => {
  const [a, o] = me(!1), [s, l] = me(!1);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        onClick: () => o(!0),
        isLoading: s,
        loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
        disabled: i,
        slotStart: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: 14,
            name: "close-circle-filled",
            color: "red.500"
          }
        ),
        className: Mt.fullWidth,
        children: "Cancel"
      }
    ),
    /* @__PURE__ */ v.jsx(
      o7,
      {
        orderId: e,
        orderName: n,
        isOpen: a,
        setIsOpen: o,
        isMutationLoading: s,
        setIsMutationLoading: l,
        refetchOrders: r
      }
    )
  ] });
}, l7 = "_modal_1mprq_1", c7 = {
  modal: l7
}, d7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  shopifyId: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l, useQuery: d } = hn(), { track: m } = Cn(), [u, f] = me(!1), [h, k] = me(e?.tags || []), C = "duplicate-shopify-order-form", N = (ue) => ({
    firstName: ue?.firstName,
    lastName: ue?.lastName,
    company: ue?.company,
    address1: ue?.address1,
    address2: ue?.address2,
    city: ue?.city,
    provinceCode: ue?.provinceCode,
    zip: ue?.zip,
    countryCode: ue?.countryCodeV2,
    phone: ue?.phone
  }), j = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: "",
    tags: e?.tags || [],
    billingAddress: N(
      e?.billingAddress ?? e?.shippingAddress
    ),
    shippingAddress: N(e?.shippingAddress),
    financialStatus: void 0,
    fulfillmentStatus: void 0,
    discountCode: void 0
  }, _ = ut({
    mode: "all",
    defaultValues: j
  }), g = _.watch("lineItems").length > 0, D = Xn(
    () => (e?.lineItems || []).map((ue) => ue.product?.id).filter((ue) => !!ue),
    [e]
  ), O = Xn(
    () => PF(D),
    [D]
  ), {
    data: I,
    loading: F,
    error: L
  } = d(Qg, {
    skip: !O,
    variables: {
      query: O,
      productCount: D.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    L && l({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [L, l]), Qe(() => {
    if (!r || F || !I || _.getValues("lineItems")?.length)
      return;
    const ue = I?.Shopify?.products?.nodes || [], se = [];
    e?.lineItems?.forEach((he) => {
      const V = ue.find(
        (ke) => ke.id === he.product?.id
      );
      V && se.push({
        ...V,
        quantity: he.quantity || 1,
        sku: he.sku,
        discountedUnitPrice: he.discountedUnitPriceSet?.shopMoney
      });
    }), se.length > 0 && _.setValue("lineItems", se, { shouldDirty: !0 });
  }, [r, I, F, e, _]), Qe(() => {
    (h.length > 0 || (_.getValues("tags") || []).length > 0) && _.setValue("tags", h, { shouldDirty: !0 });
  }, [h, _]);
  const K = $r(!1), J = () => {
    o(), f(!1), l({
      title: "Success",
      text: "The order was duplicated successfully.",
      icon: "check-circle-filled",
      severity: "success"
    }), m("shopify:order:duplicate:succeeded"), je();
  }, te = () => {
    o(), f(!1), l({
      title: "Order duplicated but not marked as paid",
      text: "The order was duplicated but recording the payment failed. You can mark it as paid in Shopify.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), je();
  }, W = () => {
    f(!1), l({
      title: "Something went wrong",
      text: "The order duplication was not successful.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    }), m("shopify:order:duplicate:failed"), je();
  }, [Y] = s(OF, {
    onError: te,
    onCompleted: (ue) => {
      const se = ue.Shopify?.orderMarkAsPaid?.userErrors;
      if (se && se.length > 0) {
        te();
        return;
      }
      J();
    }
  }), [P, { error: B }] = s(TF, {
    onError: W,
    onCompleted: (ue) => {
      const se = ue.Shopify?.orderCreate, he = se?.order?.id;
      if (se?.userErrors?.length || !he) {
        W();
        return;
      }
      if (K.current) {
        Y({ variables: { input: { id: he } } });
        return;
      }
      J();
    }
  }), re = (ue) => {
    const se = ue.lineItems.map((ke) => ({
      productId: ke.id,
      requiresShipping: !0,
      priceSet: {
        shopMoney: {
          amount: ke.discountedUnitPrice?.amount ?? ke.priceRangeV2.maxVariantPrice.amount,
          currencyCode: ke.discountedUnitPrice?.currencyCode ?? ke.priceRangeV2.maxVariantPrice.currencyCode
        }
      },
      quantity: ke.quantity,
      sku: ke.sku
    })), he = (e?.shippingLines ?? []).map(
      (ke) => ({
        title: ke.title,
        code: ke.code,
        source: ke.source,
        priceSet: {
          shopMoney: {
            amount: ke.discountedPriceSet?.shopMoney?.amount ?? "0.00",
            currencyCode: ke.discountedPriceSet?.shopMoney?.currencyCode ?? "USD"
          }
        }
      })
    );
    f(!0);
    const V = ue.financialStatus === Ui.Paid;
    K.current = V, P({
      variables: {
        order: {
          customer: {
            toAssociate: {
              id: i
            }
          },
          lineItems: se,
          shippingLines: he,
          note: ue.customNote,
          tags: ue.tags,
          financialStatus: V ? void 0 : ue.financialStatus,
          fulfillmentStatus: ue.fulfillmentStatus,
          discountCode: VF(ue.discountCode),
          shippingAddress: ma(ue?.shippingAddress),
          billingAddress: ma(ue?.billingAddress)
        }
      }
    });
  }, je = () => {
    _.reset(j), k(e?.tags || []), a(!1);
  };
  return /* @__PURE__ */ v.jsxs(
    wt,
    {
      isOpen: r,
      onClose: je,
      className: c7.modal,
      allowEscClose: !1,
      children: [
        /* @__PURE__ */ v.jsx(Ct, { title: `Duplicate order ${n}`, onClose: je }),
        /* @__PURE__ */ v.jsxs(Ft, { children: [
          /* @__PURE__ */ v.jsx(Wy, { ..._, children: /* @__PURE__ */ v.jsx("form", { id: C, children: /* @__PURE__ */ v.jsxs(nt, { children: [
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(ev, { loading: F }) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
              bt,
              {
                name: "tags",
                render: ({ fieldState: { error: ue } }) => /* @__PURE__ */ v.jsx(
                  We,
                  {
                    label: "Tags",
                    meta: {
                      error: ue?.message
                    },
                    children: /* @__PURE__ */ v.jsx(
                      "div",
                      {
                        tabIndex: 0,
                        onKeyDown: (se) => {
                          se.key === "Enter" && (se.preventDefault(), se.stopPropagation());
                        },
                        children: /* @__PURE__ */ v.jsx(
                          ql,
                          {
                            placeholder: "Type and hit enter to add tags",
                            selectedTags: h,
                            onChange: (se) => {
                              k(se);
                            }
                          },
                          `tags-input-${r}`
                        )
                      }
                    )
                  }
                )
              }
            ) }),
            /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(zF, { enabled: r }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
              /* @__PURE__ */ v.jsx(
                MF,
                {
                  previousOrderStatus: e?.displayFinancialStatus
                }
              ),
              /* @__PURE__ */ v.jsx(BF, {}),
              /* @__PURE__ */ v.jsx(
                Pn,
                {
                  label: "Custom note",
                  name: "customNote",
                  componentProps: {
                    placeholder: "Enter custom note",
                    tabIndex: 0
                  }
                }
              )
            ] }) }),
            /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
              b,
              {
                flexDirection: "column",
                gap: "200",
                justifyContent: "end",
                className: Mt.boxWrapper,
                children: /* @__PURE__ */ v.jsx(UF, {})
              }
            ) }) })
          ] }) }) }),
          B && /* @__PURE__ */ v.jsx(En, { error: B })
        ] }),
        /* @__PURE__ */ v.jsx(
          Et,
          {
            confirmProps: {
              type: "submit",
              form: C,
              disabled: !g || u || F,
              isLoading: u || F,
              loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
              tabIndex: 0
            },
            confirmName: "Create order",
            confirmOnClick: _.handleSubmit(re)
          }
        )
      ]
    }
  );
}, u7 = "_copyIcon_1dlzg_1", m7 = {
  copyIcon: u7
}, p7 = ({
  orderId: e,
  lineItems: n,
  refundedQuantities: r = {}
}) => {
  const { isCopied: i, copy: a } = Hr();
  if (!n || n?.length === 0)
    return null;
  const o = Object.values(r).some(
    (d) => d > 0
  ), s = n.every(
    ({ id: d, quantity: m }) => (r[d] || 0) >= m
  ), l = n.map(
    ({ title: d, quantity: m, variantTitle: u }) => u ? `${m}x ${d} (${u})` : `${m}x ${d}`
  ).join(`
`);
  return /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(
      b,
      {
        gap: "250",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        children: [
          /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "center", children: [
            /* @__PURE__ */ v.jsx(ve, { size: 14, name: "shopify", color: "green.500" }),
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Line items" })
          ] }),
          /* @__PURE__ */ v.jsx(Xe, { content: "Copy line items", children: /* @__PURE__ */ v.jsx(
            ve,
            {
              size: 14,
              name: i ? "done" : "copy",
              onClick: () => a(l),
              className: m7.copyIcon
            }
          ) })
        ]
      }
    ),
    o && /* @__PURE__ */ v.jsx(
      b,
      {
        gap: "100",
        flexDirection: "row",
        margin: "200 0 0",
        justifyContent: "center",
        children: /* @__PURE__ */ v.jsx(Jn, { color: "red.500", children: s ? "The order has been refunded" : "Order has refunded items" })
      }
    ),
    /* @__PURE__ */ v.jsx(Ye, { children: n.map(({ id: d, title: m, quantity: u, variantTitle: f, image: h }) => {
      const k = r[d], C = k > 0, N = k > 1 ? `Refunded (${k} items)` : "Refunded";
      return /* @__PURE__ */ v.jsx(
        Ye.Item,
        {
          contentLeft: /* @__PURE__ */ v.jsxs(b, { gap: "200", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { children: u }),
            /* @__PURE__ */ v.jsx($.Paragraph, { children: "×" })
          ] }),
          title: /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", children: [
            m,
            " ",
            f && `(${f})`,
            C && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", color: "red.500", children: N })
          ] }),
          contentRight: h?.url && /* @__PURE__ */ v.jsx(Ca, { src: `${h?.url}&height=48`, alt: m })
        },
        `list-${e}-${d}`
      );
    }) })
  ] });
}, f7 = Wl`
  mutation refundLineItems($input: Shopify_RefundInput!) {
    Shopify {
      refundCreate(input: $input) {
        refund {
          id
          totalRefundedSet {
            presentmentMoney {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  }
`, h7 = (e) => {
  const n = [];
  return e.refunds.forEach((r) => {
    const i = r.refundLineItems.edges.filter(
      (a) => a.node.id !== null
    );
    i.length > 0 && n.push({
      ...r,
      refundLineItems: {
        ...r.refundLineItems,
        edges: i
      }
    });
  }), n;
}, qF = (e) => {
  const n = {}, r = h7(e);
  return e.lineItems?.forEach((i) => {
    n[i.id] = 0;
  }), r.forEach((i) => {
    i.refundLineItems.edges.forEach((a) => {
      const o = a.node;
      if (o.id !== null) {
        const s = o.lineItem.id;
        n[s] += o.quantity;
      }
    });
  }), n;
}, Us = (e, n) => `${Number(e || 0).toFixed(2)} ${n}`, HF = ({
  refund: e,
  currencyCode: n,
  refundShipping: r,
  onToggleShipping: i,
  isLoading: a = !1
}) => {
  const o = e?.currency || n, s = Number(e?.shipping.maximumRefundable || 0) > 0, l = s && r;
  return /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Subtotal" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Us(e?.subtotal || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Tax" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Us(e?.tax || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ v.jsxs(b, { alignItems: "center", gap: "200", children: [
        /* @__PURE__ */ v.jsx(
          Ao,
          {
            name: "refundShipping",
            value: "shipping",
            checked: l,
            disabled: !s || a,
            onChange: () => i(!r)
          }
        ),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: "Refund shipping" })
      ] }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", subdued: !l, children: Us(e?.shipping.amount || "0", o) })
    ] }),
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Total refund" }),
      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: Us(e?.amount || "0", o) })
    ] })
  ] });
}, y7 = "_modal_1mprq_1", g7 = {
  modal: y7
}, rw = "partial-refund-shopify-order-form", v7 = ({
  order: e,
  orderName: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), { useQuery: d } = hn(), [m, u] = me(!1), [f, h] = me([]), [k, C] = me(!1), N = Xn(
    () => e?.refunds ? qF(e) : {},
    [e]
  ), j = Xn(
    () => (e?.lineItems || []).filter((se) => (N[se.id] || 0) >= (se.quantity || 0)).map((se) => se.product?.id).filter((se) => !!se),
    [e, N]
  ), _ = Xn(() => {
    const se = {};
    return (e?.lineItems || []).forEach((he) => {
      if (he.product?.id) {
        const V = N[he.id] || 0, ke = Math.max(
          0,
          (he.quantity || 0) - V
        );
        se[he.product.id] = ke;
      }
    }), se;
  }, [e, N]), g = Xn(
    () => (e?.lineItems || []).map((se) => se.product?.id).filter((se) => !!se),
    [e]
  ), D = Xn(
    () => PF(g),
    [g]
  ), {
    data: O,
    loading: I,
    error: F
  } = d(Qg, {
    skip: !D,
    variables: {
      query: D,
      productCount: g.length,
      mediaCount: 1
    }
  });
  Qe(() => {
    F && s({
      title: "Something went wrong",
      text: "Could not load products for this order.",
      icon: "exclamation-triangle-filled",
      severity: "warning"
    });
  }, [F, s]);
  const L = {
    selectedProductId: void 0,
    lineItems: [],
    customNote: ""
  }, K = ut({
    mode: "all",
    defaultValues: L
  }), J = f.length > 0;
  Qe(() => {
    !J && k && C(!1);
  }, [J, k]);
  const te = yi({
    control: K.control,
    name: "lineItems"
  }), W = Xn(
    () => (te || []).filter(
      (se) => f.includes(se.id)
    ).map((se) => {
      const he = e?.lineItems?.find(
        (q) => q.product?.id === se.id
      ), V = N[he?.id || ""] || 0, ke = (he?.quantity || 0) - V, De = Math.max(
        0,
        Math.min(ke, se.quantity || 0)
      );
      return he && De > 0 ? { lineItemId: he.id, quantity: De } : void 0;
    }).filter(
      (se) => !!se
    ),
    [te, f, e, N]
  ), { suggestedRefund: Y, isLoading: P } = AF({
    orderId: e.id,
    refundShipping: k,
    refundLineItems: W,
    skip: !J
  }), [B, { error: re }] = o(
    f7,
    {
      onError: () => {
        s({
          title: "Something went wrong",
          text: "The partial refund was not successful.",
          icon: "exclamation-triangle-filled",
          severity: "warning"
        }), l("shopify:order:partial:refund:failed"), ue();
      },
      onCompleted: () => {
        a(), s({
          title: "Success",
          text: "The partial refund was created successfully.",
          icon: "check-circle-filled",
          severity: "success"
        }), l("shopify:order:partial:refund:succeeded"), ue();
      }
    }
  );
  Qe(() => {
    if (!r || I || !O || K.getValues("lineItems")?.length)
      return;
    const se = O?.Shopify?.products?.nodes || [], he = [];
    e?.lineItems?.forEach((V) => {
      const ke = se.find(
        (De) => De.id === V.product?.id
      );
      if (ke) {
        const De = N[V.id] || 0, q = (V.quantity || 1) - De;
        he.push({
          ...ke,
          quantity: q > 0 ? q : V.quantity || 1
        });
      }
    }), he.length > 0 && (K.setValue("lineItems", he, { shouldDirty: !0 }), h([]));
  }, [
    r,
    O,
    I,
    e,
    K,
    N
  ]);
  const je = (se) => {
    u(!0), B({
      variables: {
        input: DF({
          orderId: e.id,
          transactions: Y?.transactions,
          refundLineItems: W,
          refundShipping: k,
          note: se.customNote || void 0,
          notify: !0
        })
      }
    });
  }, ue = () => {
    K.reset(L), u(!1), i(!1);
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: ue, className: g7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${n}`, onClose: ue }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(Wy, { ...K, children: /* @__PURE__ */ v.jsx("form", { id: rw, children: /* @__PURE__ */ v.jsxs(nt, { children: [
        /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
          ev,
          {
            loading: I,
            selectionMode: !0,
            hideDeleteButton: !0,
            hideProductSelect: !0,
            selectedProductIds: f,
            disabledProductIds: j,
            maxQuantities: _,
            onToggleSelect: (se, he) => {
              h((V) => he ? Array.from(/* @__PURE__ */ new Set([...V, se])) : V.filter((ke) => ke !== se));
            },
            onToggleSelectAll: (se) => {
              const he = (K.getValues("lineItems") || []).map((V) => V.id).filter((V) => !j.includes(V));
              h(se ? he : []);
            }
          }
        ) }),
        /* @__PURE__ */ v.jsx(Z, { span: 4, children: /* @__PURE__ */ v.jsx(b, { flexDirection: "column", gap: "300", children: /* @__PURE__ */ v.jsx(
          Pn,
          {
            label: "Custom note",
            name: "customNote",
            componentProps: {
              placeholder: "Enter custom note (optional)",
              tabIndex: 0
            }
          }
        ) }) }),
        /* @__PURE__ */ v.jsx(Z, { span: 2, children: /* @__PURE__ */ v.jsx(We, { label: "Details", noAlert: !0, children: /* @__PURE__ */ v.jsx(
          b,
          {
            flexDirection: "column",
            gap: "200",
            justifyContent: "end",
            className: Mt.boxWrapper,
            children: /* @__PURE__ */ v.jsx(
              HF,
              {
                refund: Y,
                currencyCode: e.currencyCode,
                refundShipping: k,
                onToggleShipping: C,
                isLoading: P
              }
            )
          }
        ) }) })
      ] }) }) }),
      re && /* @__PURE__ */ v.jsx(En, { error: re })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          type: "submit",
          form: rw,
          disabled: !J || m || I || P || !Y,
          isLoading: m || I,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Refund selected",
        confirmOnClick: K.handleSubmit(je)
      }
    )
  ] });
}, k7 = "_modal_al73g_1", b7 = {
  modal: k7
}, _7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  isOpen: i,
  setIsOpen: a,
  refetchOrders: o
}) => {
  const { useMutation: s, showNotification: l } = hn(), { track: d } = Cn(), { id: m, name: u, currencyCode: f } = e, [h, k] = me(!0), [C, N] = me(), { suggestedRefund: j, isLoading: _ } = AF({
    orderId: m,
    suggestFullRefund: !0,
    refundShipping: h,
    skip: !i
  }), [g, { loading: D }] = s(
    ZW,
    {
      onError: (F) => N(F),
      onCompleted: (F) => {
        const L = F.Shopify?.refundCreate?.userErrors;
        if (L && L.length > 0) {
          N(
            new Fw({
              graphQLErrors: L.map((K) => ({
                message: K.message
              }))
            })
          );
          return;
        }
        l({
          title: "Order refunded",
          text: `You refunded order ${u}`,
          icon: "check-circle-filled",
          severity: "success"
        }), o(), O();
      }
    }
  ), O = () => {
    k(!0), N(void 0), a(!1);
  }, I = () => {
    j && (d("shopify:order:refund:confirmed", { shopifyId: n, orderId: m }), g({
      variables: {
        input: DF({
          orderId: m,
          transactions: j.transactions,
          refundLineItems: j.refundLineItems,
          refundShipping: h,
          notify: e.suggestedRefund.notify
        })
      }
    }));
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: i, onClose: O, className: b7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: `Refund order ${u}`, onClose: O }),
    /* @__PURE__ */ v.jsx(Ft, { children: /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", gap: "300", children: [
      /* @__PURE__ */ v.jsx(
        HF,
        {
          refund: j,
          currencyCode: f,
          refundShipping: h,
          onToggleShipping: k,
          isLoading: _
        }
      ),
      C && /* @__PURE__ */ v.jsxs(b, { flexDirection: "column", children: [
        /* @__PURE__ */ v.jsx(En, { error: C }),
        /* @__PURE__ */ v.jsx(
          Lt,
          {
            variant: "secondary",
            style: {
              color: "var(--dixa-typography-color-link)",
              padding: "var(--dixa-size-spacer-100)"
            },
            navigate: () => window.open(r, "_blank")?.focus(),
            slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
            children: "View order in Shopify"
          }
        )
      ] })
    ] }) }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !j || _ || D,
          isLoading: D || _,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 }),
          tabIndex: 0
        },
        confirmName: "Confirm order refund",
        confirmOnClick: I
      }
    )
  ] });
}, x7 = ({
  order: e,
  shopifyId: n,
  orderLink: r,
  refetchOrders: i
}) => {
  const { showModal: a } = hn(), { track: o } = Cn(), { suggestedRefund: s, id: l } = e, [d, m] = me(!1), u = parseFloat(String(s?.amount)), f = !isNaN(u) && u > 0, h = _t(() => {
    o("shopify:order:refund:requested", { shopifyId: n, orderId: l }), f ? m(!0) : a({
      headline: `Refund Order ${e.name}`,
      children: /* @__PURE__ */ v.jsx($.Paragraph, { children: "No refund can be issued because no payment has been captured for this order. The order's financial status is currently pending." }),
      confirmLabel: "Close",
      confirmVariant: "secondary",
      onConfirm: () => {
      }
    });
  }, [n, l, e.name, f, a, o]);
  return /* @__PURE__ */ v.jsxs(b, { width: "100%", children: [
    /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        onClick: h,
        disabled: s?.refundLineItems?.length === 0 || !f,
        slotStart: /* @__PURE__ */ v.jsx(ve, { size: 14, name: "undo" }),
        className: Mt.fullWidth,
        children: "Full refund"
      }
    ),
    /* @__PURE__ */ v.jsx(
      _7,
      {
        order: e,
        shopifyId: n,
        orderLink: r,
        isOpen: d,
        setIsOpen: m,
        refetchOrders: i
      }
    )
  ] });
}, S7 = "_modal_al73g_1", N7 = {
  modal: S7
}, j7 = ({
  orderId: e,
  tags: n,
  isOpen: r,
  setIsOpen: i,
  refetchOrders: a
}) => {
  const { track: o } = Cn(), { useMutation: s, showNotification: l } = hn(), [d, m] = me(n), [u, f] = me(!1), h = ut({
    defaultValues: {
      tags: n
    }
  });
  Qe(() => {
    d && h.setValue("tags", d, { shouldDirty: !0 });
  }, [d]);
  const [k, { error: C, reset: N }] = s(n9, {
    onError: () => {
      f(!1), l({
        title: "Something went wrong",
        text: "The tags change was not successful.",
        icon: "exclamation-triangle-filled",
        severity: "warning"
      }), i(!1);
    },
    onCompleted: async () => {
      await a(), f(!1), l({
        title: "Success",
        text: "The tags change was successful.",
        icon: "check-circle-filled",
        severity: "success"
      }), o("shopify:order:tags:updated"), i(!1);
    }
  }), j = _t(
    (g) => {
      f(!0), k({
        variables: {
          input: {
            id: e,
            tags: g.tags
          }
        }
      }).then((D) => {
        const O = D.data?.Shopify?.orderUpdate?.order?.tags ?? g.tags;
        h.reset({ tags: O });
      });
    },
    [e, h, k]
  ), _ = () => {
    i(!1), N();
  };
  return /* @__PURE__ */ v.jsxs(wt, { isOpen: r, onClose: _, className: N7.modal, children: [
    /* @__PURE__ */ v.jsx(Ct, { title: "Manage tags for order", onClose: _ }),
    /* @__PURE__ */ v.jsxs(Ft, { children: [
      /* @__PURE__ */ v.jsx(nt, { children: /* @__PURE__ */ v.jsx(Z, { children: /* @__PURE__ */ v.jsx(
        bt,
        {
          control: h.control,
          name: "tags",
          render: ({ fieldState: { error: g } }) => /* @__PURE__ */ v.jsx(
            We,
            {
              label: "Tags",
              meta: {
                error: g?.message
              },
              children: /* @__PURE__ */ v.jsx(
                ql,
                {
                  placeholder: "Add tags here",
                  selectedTags: n,
                  onChange: (D) => m(D)
                }
              )
            }
          )
        }
      ) }) }),
      C && /* @__PURE__ */ v.jsx(En, { error: C })
    ] }),
    /* @__PURE__ */ v.jsx(
      Et,
      {
        confirmProps: {
          disabled: !(h.formState.isValid && h.formState.isDirty),
          isLoading: u,
          loadingIndicator: /* @__PURE__ */ v.jsx(fn, { size: 16 })
        },
        confirmOnClick: h.handleSubmit(j),
        cancelOnClick: _,
        confirmName: C ? "Close" : "Save",
        cancelName: C ? void 0 : "Cancel"
      }
    )
  ] });
}, w7 = "_editIcon_1yp2k_1", C7 = "_copyIcon_1yp2k_2", iw = {
  editIcon: w7,
  copyIcon: C7
}, F7 = ({
  orderId: e,
  tags: n,
  refetchOrders: r
}) => {
  const [i, a] = me(!1), { isCopied: o, copy: s } = Hr(), l = 14, d = n.length > 0;
  return /* @__PURE__ */ v.jsxs(v.Fragment, { children: [
    /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(ve, { size: l, name: "tag", color: "green.500" }),
        /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tags" }),
          /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "row", flexWrap: "wrap", children: [
            !d && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", color: "tertiary", children: "No tags here yet" }),
            d && n.map((m, u) => /* @__PURE__ */ v.jsx(Mn, { size: "small", variant: "primary", children: m }, u))
          ] })
        ] })
      ] }),
      /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
        /* @__PURE__ */ v.jsx(Xe, { content: "Edit tags", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: l,
            name: "pen",
            className: iw.editIcon,
            onClick: () => a(!0)
          }
        ) }),
        d && /* @__PURE__ */ v.jsx(Xe, { content: "Copy tags", children: /* @__PURE__ */ v.jsx(
          ve,
          {
            size: l,
            name: o ? "done" : "copy",
            className: iw.copyIcon,
            onClick: () => s(n.join(", "))
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ v.jsx(
      j7,
      {
        orderId: e,
        tags: n,
        isOpen: i,
        setIsOpen: a,
        refetchOrders: r
      }
    )
  ] });
}, I7 = "_icon_cddi1_1", E7 = "_link_cddi1_6", aw = {
  icon: I7,
  link: E7
}, $7 = ({ trackingInfo: e }) => {
  const { isCopied: n, copy: r } = Hr(), { company: i, number: a, url: o } = e;
  return /* @__PURE__ */ v.jsx(
    Ye.Item,
    {
      contentLeft: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: a }),
      title: /* @__PURE__ */ v.jsx(
        $.ExternalLink,
        {
          href: o,
          target: "_blank",
          rel: "noreferrer",
          className: aw.link,
          children: i
        }
      ),
      contentRight: a && /* @__PURE__ */ v.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ v.jsx(
        ve,
        {
          size: 14,
          name: n ? "done" : "copy",
          onClick: () => r(a.toString()),
          className: aw.icon
        }
      ) })
    }
  );
}, T7 = ({
  trackingInfos: e
}) => !e || e?.length === 0 ? null : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ v.jsx(ve, { size: 14, name: "eye", color: "green.500" }),
    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Tracking" })
  ] }),
  /* @__PURE__ */ v.jsx(Ye, { children: e.map((n) => /* @__PURE__ */ v.jsx($7, { trackingInfo: n }, n.number)) })
] }), O7 = "_copyIcon_u5m0p_1", R7 = "_strikethrough_u5m0p_6", D7 = "_order_u5m0p_10", P7 = "_orderIsOpen_u5m0p_18", A7 = "_orderHeader_u5m0p_21", Ei = {
  copyIcon: O7,
  strikethrough: R7,
  order: D7,
  orderIsOpen: P7,
  orderHeader: A7
}, L7 = ({
  order: e,
  shopifyId: n,
  openByDefault: r,
  customerCountryCodes: i,
  enableEditShippingAddress: a,
  displayRefund: o,
  displayCancel: s,
  shopifyDomain: l,
  displayDuplicateOrder: d,
  displayPartialRefundOrder: m,
  refetchOrders: u
}) => {
  const { track: f } = Cn(), { isCopied: h, copy: k } = Hr(), { isCopied: C, copy: N } = Hr(), { isCopied: j, copy: _ } = Hr(), [g, D] = me(!1), [O, I] = me(!1), [F, L] = me(r), {
    id: K,
    name: J,
    createdAt: te,
    status: W,
    currentTotalPriceSet: Y,
    currencyCode: P,
    lineItems: B,
    billingAddress: re,
    shippingAddress: je,
    trackingInfos: ue,
    tags: se,
    discountCodes: he,
    currentTotalDiscountsSet: V
  } = e, ke = !!je, De = Xg(K), q = `https://${l}/admin/orders/${De ?? ""}`, Ge = Y?.shopMoney?.amount ?? 0, sn = W.includes("cancelled"), Ie = (en) => new Intl.NumberFormat(void 0, {
    style: "currency",
    currency: P
  }).format(en), Ue = Number(
    V?.shopMoney?.amount ?? 0
  ), Re = Ue > 0, Be = he?.join(", ") ?? "", Ae = Ie(Number(Ge)), Je = Ie(
    Number(Ge) + Ue
  ), $e = e?.refunds ? qF(e) : {}, Me = !!B?.length && B.every((en) => ($e[en.id] || 0) >= (en.quantity || 0));
  return /* @__PURE__ */ v.jsxs(
    b,
    {
      className: dt(Ei.order, {
        [Ei.orderIsOpen]: F
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ v.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: Ei.orderHeader,
            onClick: () => L(!F),
            children: [
              /* @__PURE__ */ v.jsxs(b, { gap: "100", flexDirection: "column", children: [
                te && /* @__PURE__ */ v.jsx(b, { alignItems: "center", children: /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Gn(te).format(by) }) }),
                /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "1", children: [
                  "Order ",
                  J
                ] })
              ] }),
              /* @__PURE__ */ v.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: F ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        F && /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "info", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order number" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: J.replace("#", "") })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order number", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: h ? "done" : "copy",
                    onClick: () => k(J.replace("#", "")),
                    className: Ei.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "activity", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order status" }),
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: W })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order status", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: j ? "done" : "copy",
                    onClick: () => _(W),
                    className: Ei.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsxs(
            b,
            {
              gap: "250",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              children: [
                /* @__PURE__ */ v.jsxs(b, { gap: "250", flexDirection: "row", alignItems: "flex-start", children: [
                  /* @__PURE__ */ v.jsx(ve, { size: 14, name: "chart-bar", color: "green.500" }),
                  /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
                    /* @__PURE__ */ v.jsx($.Paragraph, { variant: "3", children: "Order value" }),
                    Re && /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: Ei.strikethrough, children: Je }),
                    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
                      /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: Ae }),
                      Be && /* @__PURE__ */ v.jsxs($.Paragraph, { variant: "4", color: "tertiary", children: [
                        "(",
                        Be,
                        ")"
                      ] })
                    ] })
                  ] })
                ] }),
                /* @__PURE__ */ v.jsx(Xe, { content: "Copy order value", children: /* @__PURE__ */ v.jsx(
                  ve,
                  {
                    size: 14,
                    name: C ? "done" : "copy",
                    onClick: () => N(Ge),
                    className: Ei.copyIcon
                  }
                ) })
              ]
            }
          ),
          /* @__PURE__ */ v.jsx(
            F7,
            {
              orderId: K,
              tags: se,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            xy,
            {
              openByDefault: !ke,
              labelText: "Billing address",
              address: re,
              shippingCountryCodes: i,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            xy,
            {
              openByDefault: ke,
              shopifyId: n,
              orderId: K,
              icon: "map-pin",
              labelText: "Shipping address",
              address: je,
              shippingCountryCodes: i,
              enableEditAddress: a,
              refetchOrders: u
            }
          ),
          /* @__PURE__ */ v.jsx(
            p7,
            {
              orderId: K,
              lineItems: B,
              refundedQuantities: $e
            }
          ),
          /* @__PURE__ */ v.jsx(T7, { trackingInfos: ue }),
          (o || m) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            o && /* @__PURE__ */ v.jsx(
              x7,
              {
                order: e,
                shopifyId: n,
                refetchOrders: u,
                orderLink: q
              }
            ),
            m && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              ct,
              {
                variant: "secondary",
                icon: "undo",
                onClick: () => I(!0),
                className: Mt.fullWidth,
                disabled: sn || Me,
                children: "Partial refund"
              }
            ) })
          ] }),
          (d || s) && /* @__PURE__ */ v.jsxs(b, { flexDirection: "row", gap: "200", children: [
            d && /* @__PURE__ */ v.jsx(b, { width: "100%", children: /* @__PURE__ */ v.jsx(
              ct,
              {
                variant: "secondary",
                icon: "plus",
                onClick: () => D(!0),
                className: Mt.fullWidth,
                children: "Duplicate"
              }
            ) }),
            s && /* @__PURE__ */ v.jsx(
              s7,
              {
                orderId: K,
                orderName: J,
                disabled: sn,
                refetchOrders: u
              }
            )
          ] }),
          /* @__PURE__ */ v.jsx(
            Lt,
            {
              variant: "secondary",
              style: {
                color: "var(--dixa-typography-color-link)",
                padding: "var(--dixa-size-spacer-100)"
              },
              navigate: () => window.open(q, "_blank")?.focus(),
              slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
              onClick: () => f("shopify:view:order:clicked", {
                shopifyId: n,
                orderId: K
              }),
              children: "View order in Shopify"
            }
          )
        ] }),
        g && /* @__PURE__ */ v.jsx(
          d7,
          {
            order: e,
            shopifyId: n,
            orderName: J,
            isOpen: g,
            setIsOpen: D,
            refetchOrders: u
          }
        ),
        O && /* @__PURE__ */ v.jsx(
          v7,
          {
            order: e,
            orderName: J,
            isOpen: O,
            setIsOpen: I,
            refetchOrders: () => {
              u();
            }
          }
        )
      ]
    }
  );
}, V7 = ({
  customerCountryCodes: e,
  shopifyDomain: n,
  displayRefund: r,
  displayCancel: i,
  displayCreateOrder: a,
  displayCreateDraftOrder: o,
  displayDuplicateOrder: s,
  displayPartialRefundOrder: l,
  enableEditShippingAddress: d,
  shopifyCustomer: m
}) => {
  const { track: u } = Cn(), [f, h] = me([]), [k, C] = me(!1), N = Xg(m?.id), j = `https://${n}/admin/orders?customer_id=${N ?? ""}`, {
    getCustomerOrders: _,
    isCustomerOrdersLoading: g,
    customerOrdersError: D,
    customerOrders: O,
    refetchCustomerOrders: I
  } = o9();
  return Qe(() => {
    !g && N && _({
      variables: {
        query: `customer_id:${N}`
      }
    });
  }, [N]), Qe(() => {
    const F = O?.Shopify?.orders?.edges;
    F && h(s9({ ordersData: F }));
  }, [O]), m ? D ? /* @__PURE__ */ v.jsx(En, { error: D }) : /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Customer orders" }),
      !g && /* @__PURE__ */ v.jsx(Mn, { variant: "success", size: "small", children: f.length })
    ] }),
    a && /* @__PURE__ */ v.jsx(
      ct,
      {
        variant: "secondary",
        icon: "plus",
        onClick: () => C(!0),
        children: "Create new order"
      }
    ),
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
      g && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }),
      !g && f.length === 0 && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", children: "No orders found" }) }),
      !g && f.length > 0 && /* @__PURE__ */ v.jsx(b, { gap: "200", flexDirection: "column", children: f.map((F, L) => /* @__PURE__ */ v.jsx(
        L7,
        {
          order: F,
          openByDefault: L === 0,
          shopifyId: m?.id,
          displayRefund: r,
          displayCancel: i,
          enableEditShippingAddress: d,
          customerCountryCodes: e,
          refetchOrders: I,
          shopifyDomain: n,
          displayDuplicateOrder: s,
          displayPartialRefundOrder: l
        },
        `${L}-${F.id}`
      )) }),
      /* @__PURE__ */ v.jsx(
        Lt,
        {
          variant: "secondary",
          style: {
            color: "var(--dixa-typography-color-link)",
            padding: "var(--dixa-size-spacer-100)"
          },
          navigate: () => window.open(j, "_blank")?.focus(),
          slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
          onClick: () => u("shopify:view:all:orders:clicked", {
            shopifyId: m?.id
          }),
          children: "View all orders in Shopify"
        }
      )
    ] }),
    a && /* @__PURE__ */ v.jsx(
      r7,
      {
        isOpen: k,
        setIsOpen: C,
        shopifyCustomer: m,
        refetchCustomerOrders: I,
        displayCreateDraftOrder: o
      }
    )
  ] }) : null;
}, z7 = ({
  totalOrders: e,
  amountSpent: n
}) => {
  const r = n?.amount ?? 0, i = n?.currencyCode ?? "", a = `${Number.parseFloat(r).toFixed(
    2
  )} ${i}`;
  return /* @__PURE__ */ v.jsx(v.Fragment, { children: /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Orders overview" }),
    /* @__PURE__ */ v.jsxs(Ye, { className: Mt.list, children: [
      /* @__PURE__ */ v.jsx(Ye.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total orders" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: e })
      ] }) }),
      /* @__PURE__ */ v.jsx(Ye.Text, { variant: "dense", className: Mt.listItem, children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: "Total revenue" }),
        /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", children: a })
      ] }) })
    ] })
  ] }) });
}, U7 = "_segmentName_1dkhk_1", M7 = {
  segmentName: U7
}, B7 = 100, Ms = 10, q7 = ({
  shopifyId: e
}) => {
  const { useQuery: n, useLazyQuery: r } = hn(), [i, a] = me([]), [o, s] = me(Ms), [l, d] = me(!1), m = Xn(
    () => i.filter((N) => N.isMember).length,
    [i]
  ), { loading: u, error: f } = n(
    YW,
    {
      skip: !e,
      variables: {
        first: B7
      },
      onCompleted: (N) => {
        const j = N?.Shopify?.segments?.edges;
        if (j && j.length > 0) {
          const _ = j.map(({ node: g }) => ({
            ...g,
            isMember: !1
          })).sort((g, D) => g.name.localeCompare(D.name));
          a(_), h({
            variables: {
              customerId: e,
              segmentIds: _.map((g) => g.id)
            }
          });
        }
      }
    }
  ), [
    h,
    { loading: k, error: C }
  ] = r(JW, {
    onCompleted: (N) => {
      const j = N?.Shopify?.customerSegmentMembership?.memberships;
      if (j && j.length > 0) {
        const _ = i.map((g) => {
          const D = j.find(
            (O) => O.segmentId === g.id
          );
          return {
            ...g,
            ...D?.isMember && { isMember: D.isMember }
          };
        }).sort(
          (g, D) => g.isMember === D.isMember ? 0 : g.isMember ? -1 : 1
        );
        a(_);
      }
    }
  });
  return Qe(() => {
    s(l ? i.length : Ms);
  }, [l]), e ? /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ v.jsx($.Heading, { variant: "heading-3", children: "Segment membership" }),
      !u && /* @__PURE__ */ v.jsx(Mn, { variant: "success", size: "small", children: m })
    ] }),
    u && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ v.jsx(fn, {}) }),
    !u && i.length === 0 && /* @__PURE__ */ v.jsx($.Paragraph, { color: "tertiary", margin: "200 0 300 0", align: "center", children: "No segments found" }),
    f && /* @__PURE__ */ v.jsx(En, { error: f }),
    C && /* @__PURE__ */ v.jsx(En, { error: C }),
    !u && i.length > 0 && /* @__PURE__ */ v.jsxs(Ye, { className: Mt.list, children: [
      i.slice(0, o).map(({ id: N, name: j, isMember: _ }) => /* @__PURE__ */ v.jsx(Ye.Text, { className: Mt.listItem, children: /* @__PURE__ */ v.jsx(
        Xe,
        {
          content: `${_ ? "Member of" : "Not a member of"} ${j}`,
          children: /* @__PURE__ */ v.jsxs(b, { justifyContent: "space-between", children: [
            /* @__PURE__ */ v.jsx($.Paragraph, { variant: "4", className: M7.segmentName, children: j }),
            k && /* @__PURE__ */ v.jsx(fn, { size: 12 }),
            !k && /* @__PURE__ */ v.jsx(b, { children: /* @__PURE__ */ v.jsx(
              ve,
              {
                color: _ ? "green.500" : "neutral.300",
                name: "shopify"
              }
            ) })
          ] })
        }
      ) }, N)),
      i.length > Ms && /* @__PURE__ */ v.jsx(b, { justifyContent: "center", margin: "200 0 0", children: /* @__PURE__ */ v.jsx(
        ct,
        {
          variant: "secondary",
          onClick: () => d(!l),
          icon: l ? "angle-up" : "angle-down",
          children: l ? "Show less" : `Show ${i.length - Ms} more`
        }
      ) })
    ] })
  ] }) : null;
}, H7 = ({
  conversationContext: e,
  settings: n
}) => {
  const [r, i] = me(!1);
  Qe(() => {
    i(!1);
  }, [
    e.customer?.phone_number,
    e.customer?.email
  ]);
  const {
    isCustomerLoading: a,
    customerError: o,
    customerData: s,
    refetchCustomer: l,
    customerNetworkStatus: d
  } = a9({ conversationContext: e, forcePhoneLookup: r }), [m, u] = me(), [f, h] = me(
    []
  ), k = n.apiHostName, C = n.displayRefundOrder ?? !1, N = n.displayCancelOrder ?? !1, j = n.enableEditShippingAddress ?? !1, _ = n.displayEmailMarketingConsent ?? !1, g = n.displayOrdersOverview ?? !1, D = n.displaySegmentMembership ?? !1, O = n.displayDiscountCodeCreation ?? !1, I = n.displayDiscountCodes ?? !1, F = n.displayCreateOrder ?? !1, L = n.displayDuplicateOrder ?? !1, K = n.displayCreateDraftOrder ?? !1, J = n.displayPartialRefundOrder ?? !1;
  if (Qe(() => {
    const te = s?.Shopify?.customers?.edges[0]?.node, W = !!e.customer?.phone_number && !!e.customer?.email;
    te && !a ? (h(
      s?.Shopify?.shop?.countriesInShippingZones?.countryCodes || []
    ), u(te)) : !te && !a && W && !r ? i(!0) : u(void 0);
  }, [s, e]), !a && o)
    return /* @__PURE__ */ v.jsx(En, { error: o, retry: l });
  if (!a && !o && !m) {
    const te = `https://${k}/admin/customers?search=${e.customer?.name || ""}`;
    return /* @__PURE__ */ v.jsxs(
      b,
      {
        margin: "200 0 300",
        gap: "300",
        flexDirection: "column",
        "data-testid": "widget-customer-not-found",
        children: [
          /* @__PURE__ */ v.jsx($.Paragraph, { color: "secondary", children: "We cannot find the customer in Shopify." }),
          /* @__PURE__ */ v.jsxs(b, { gap: "200", flexDirection: "column", children: [
            /* @__PURE__ */ v.jsx(
              x9,
              {
                refetchCustomer: l,
                conversationContext: e
              }
            ),
            /* @__PURE__ */ v.jsx(
              Lt,
              {
                variant: "secondary",
                style: {
                  color: "var(--dixa-typography-color-link)",
                  padding: "var(--dixa-size-spacer-100)"
                },
                navigate: () => window.open(te, "_blank")?.focus(),
                slotStart: /* @__PURE__ */ v.jsx(ve, { name: "external-link" }),
                children: "Search customers in Shopify"
              }
            )
          ] })
        ]
      }
    );
  }
  return a && d !== tr.refetch ? /* @__PURE__ */ v.jsx(b, { margin: "200 0 300", justifyContent: "center", children: /* @__PURE__ */ v.jsx(fn, {}) }) : /* @__PURE__ */ v.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ v.jsx(
          j9,
          {
            customer: m,
            shopifyDomain: k,
            refresh: l,
            loading: a,
            networkStatus: d
          }
        ),
        g && /* @__PURE__ */ v.jsx(
          z7,
          {
            totalOrders: m?.numberOfOrders,
            amountSpent: m?.amountSpent
          }
        ),
        D && /* @__PURE__ */ v.jsx(q7, { shopifyId: m?.id }),
        _ && /* @__PURE__ */ v.jsx(U9, { customer: m }),
        I && /* @__PURE__ */ v.jsx(
          z9,
          {
            displayDiscountCodeCreation: O
          }
        ),
        /* @__PURE__ */ v.jsx(
          V7,
          {
            shopifyCustomer: m,
            shopifyDomain: k,
            displayRefund: C,
            displayCancel: N,
            displayCreateOrder: F,
            displayCreateDraftOrder: K,
            enableEditShippingAddress: j,
            customerCountryCodes: f,
            displayDuplicateOrder: L,
            displayPartialRefundOrder: J
          }
        )
      ]
    }
  );
}, Ot = [];
for (let e = 0; e < 256; ++e)
  Ot.push((e + 256).toString(16).slice(1));
function W7(e, n = 0) {
  return (Ot[e[n + 0]] + Ot[e[n + 1]] + Ot[e[n + 2]] + Ot[e[n + 3]] + "-" + Ot[e[n + 4]] + Ot[e[n + 5]] + "-" + Ot[e[n + 6]] + Ot[e[n + 7]] + "-" + Ot[e[n + 8]] + Ot[e[n + 9]] + "-" + Ot[e[n + 10]] + Ot[e[n + 11]] + Ot[e[n + 12]] + Ot[e[n + 13]] + Ot[e[n + 14]] + Ot[e[n + 15]]).toLowerCase();
}
const K7 = new Uint8Array(16);
function G7() {
  return crypto.getRandomValues(K7);
}
function Y7(e, n, r) {
  return crypto.randomUUID ? crypto.randomUUID() : J7(e);
}
function J7(e, n, r) {
  e = e || {};
  const i = e.random ?? e.rng?.() ?? G7();
  if (i.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return i[6] = i[6] & 15 | 64, i[8] = i[8] & 63 | 128, W7(i);
}
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._pointer_pn2q5_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_pn2q5_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_pn2q5_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItem_pn2q5_69:last-child{border-bottom:none}._modalBody_1clhs_1{width:400px}._wrapper_1ge6c_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._textVariant_1ge6c_7{color:var(--dixa-typography-color-secondary);font-size:var(--dixa-typography-size-300)}._block_1ge6c_12{margin-bottom:var(--dixa-size-spacer-250)}._wrapper_yud4a_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300)}._list_yud4a_7{padding:0}._listItem_yud4a_11{padding:var(--dixa-size-spacer-100);border-bottom:var(--dixa-size-border-100) solid var(--dixa-color-neutral-200)}._listItemTooltip_yud4a_15{cursor:pointer}._listItemTimestamp_yud4a_18{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._listItem_yud4a_11:last-child{border-bottom:none}._tagHover_kzbzk_1:hover{cursor:pointer;border-color:var(--dixa-color-neutral-400)}._channelUnsubscribed_kzbzk_6{color:var(--dixa-color-neutral-500)}._list_zu4s7_1{padding:var(--dixa-size-spacer-100)}._listItem_zu4s7_4{padding:var(--dixa-size-spacer-200) var(--dixa-size-spacer-100)}._listSum_zu4s7_7{margin-top:var(--dixa-size-spacer-200);border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-400)}._transaction_1kr8d_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._transaction_1kr8d_1:hover,._transactionIsOpen_1kr8d_9{border-color:var(--dixa-color-neutral-400)}._transactionHeader_1kr8d_12{cursor:pointer}._transactionHeaderSubLine_1kr8d_15{font-size:var(--dixa-typography-size-200);color:var(--dixa-typography-color-tertiary)}._transactionHeaderAlignItemRight_1kr8d_19{margin-left:auto;margin-right:var(--dixa-size-spacer-200)}._message_4z55u_54{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._message_4z55u_54:hover,._messageIsOpen_4z55u_62{border-color:var(--dixa-color-neutral-400)}._messageHeader_4z55u_66{cursor:pointer}._messageText_4z55u_70{max-height:150px;overflow:scroll;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-200);border:1px solid var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);overflow:auto}._messageText_4z55u_70::-webkit-scrollbar{width:7px;height:7px}._messageText_4z55u_70::-webkit-scrollbar-track{background-color:var(--dixa-color-neutral-000)}._messageText_4z55u_70::-webkit-scrollbar-thumb{background-color:var(--dixa-color-neutral-400);border-radius:4px}._messageText_4z55u_70::-webkit-scrollbar-thumb:hover{background-color:var(--dixa-color-neutral-500)}._buttonLink_4z55u_93{color:var(--dixa-typography-color-link)}._order_19t4p_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-250)}._order_19t4p_1:hover,._orderIsOpen_19t4p_9{border-color:var(--dixa-color-neutral-400)}._orderHeader_19t4p_12{cursor:pointer}._orderIconColor_19t4p_15{color:var(--dixa-color-green-500)}._delivery_1m9nb_1{word-break:break-all}._deliveryCode_1m9nb_4{font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-tertiary)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Ph = { exports: {} }, _o = {}, ow;
function Q7() {
  if (ow) return _o;
  ow = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return _o.Fragment = r, _o.jsx = s, _o.jsxs = s, _o;
}
var Bs = {}, sw;
function X7() {
  return sw || (sw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Bs.Fragment = i, Bs.jsx = zn, Bs.jsxs = Wn;
  })()), Bs;
}
var lw;
function Z7() {
  return lw || (lw = 1, process.env.NODE_ENV === "production" ? Ph.exports = Q7() : Ph.exports = X7()), Ph.exports;
}
var R = Z7(), WF = /* @__PURE__ */ ((e) => (e.Adjustment = "Adjustment", e.Automation = "Automation", e.BonusBalanceAdjustment = "BonusBalanceAdjustment", e.BonusPromotion = "BonusPromotion", e.BonusPromotionReturn = "BonusPromotionReturn", e.Manual = "Manual", e.PointTransactionCancellation = "PointTransactionCancellation", e.Purchase = "Purchase", e.ReceiptAdjustment = "ReceiptAdjustment", e.Return = "Return", e.RewardVoucher = "RewardVoucher", e.UpdateBalance = "UpdateBalance", e))(WF || {}), Sy = /* @__PURE__ */ ((e) => (e.Addition = "Addition", e.Cancellation = "Cancellation", e.Deduction = "Deduction", e.Expiry = "Expiry", e))(Sy || {});
const eK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePreferences" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_contactAttributes_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_ContactPatch" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }] } }] } }] } }] }, nK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "mutation", name: { kind: "Name", value: "updatePoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "input" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_AddPointTransactionRequestModel_Input" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointTransaction_AddPointTransacion" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "input" }, value: { kind: "Variable", name: { kind: "Name", value: "input" } } }] }] } }] } }] }, tK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactsV_GetContactById" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "attributes" } }, { kind: "Field", name: { kind: "Name", value: "meta" } }, { kind: "Field", name: { kind: "Name", value: "preferences" } }, { kind: "Field", name: { kind: "Name", value: "consents" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "date" } }, { kind: "Field", name: { kind: "Name", value: "value" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "comment" } }] } }] } }] } }] } }] }, rK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactOverviewById" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactOverviewAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }] }] } }] } }] }, iK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactOverview_GetContactIdAsync" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "mobilePhone" }, value: { kind: "Variable", name: { kind: "Name", value: "mobilePhone" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ContactOverview_GetContactIdAsync_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_String_container" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "String" } }] } }, { kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ApiExceptionMultipleMatchesResponse" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "errorCode" } }, { kind: "Field", name: { kind: "Name", value: "message" } }, { kind: "Field", name: { kind: "Name", value: "requestId" } }, { kind: "Field", name: { kind: "Name", value: "messageDetails" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "multipleMatchesFound" } }] } }] } }] } }] } }] } }] } }] }, aK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getLatestMessagesByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "ContactMessage_GetSmsMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetPostalMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }, { kind: "Field", name: { kind: "Name", value: "ContactMessage_GetEmailMessagesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_ListResultOfApiMessage" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "messageId" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "sendDateTime" } }, { kind: "Field", name: { kind: "Name", value: "type" } }, { kind: "Field", name: { kind: "Name", value: "source" } }, { kind: "Field", name: { kind: "Name", value: "isTransactional" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "messageLink" } }, { kind: "Field", name: { kind: "Name", value: "messageText" } }] } }] } }] } }] } }] } }] }, oK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerTransactions" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Transactions_GetTransactionsWithArticlesByContactId" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "count" } }, { kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "createdDate" } }, { kind: "Field", name: { kind: "Name", value: "transactionNumber" } }, { kind: "Field", name: { kind: "Name", value: "storeName" } }, { kind: "Field", name: { kind: "Name", value: "numberOfItems" } }, { kind: "Field", name: { kind: "Name", value: "netPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localNetPriceSum" } }, { kind: "Field", name: { kind: "Name", value: "localCurrency" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "name" } }] } }, { kind: "Field", name: { kind: "Name", value: "localPrice" } }, { kind: "Field", name: { kind: "Name", value: "type" } }] } }] } }] } }] } }] } }] }, sK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getOrdersByContactId" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "offset" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "count" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Orders_GetAllByContact" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }, { kind: "Argument", name: { kind: "Name", value: "offset" }, value: { kind: "Variable", name: { kind: "Name", value: "offset" } } }, { kind: "Argument", name: { kind: "Name", value: "count" }, value: { kind: "Variable", name: { kind: "Name", value: "count" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "totalCount" } }, { kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "orderId" } }, { kind: "Field", name: { kind: "Name", value: "createdAt" } }, { kind: "Field", name: { kind: "Name", value: "lastChangedAt" } }, { kind: "Field", name: { kind: "Name", value: "channel" } }, { kind: "Field", name: { kind: "Name", value: "status" } }, { kind: "Field", name: { kind: "Name", value: "externalStatus" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "currencyCode" } }, { kind: "Field", name: { kind: "Name", value: "lineItems" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "items" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "quantity" } }, { kind: "Field", name: { kind: "Name", value: "totalPrice" } }, { kind: "Field", name: { kind: "Name", value: "article" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "sku" } }, { kind: "Field", name: { kind: "Name", value: "name" } }, { kind: "Field", name: { kind: "Name", value: "description" } }, { kind: "Field", name: { kind: "Name", value: "imageUri" } }, { kind: "Field", name: { kind: "Name", value: "targetUri" } }] } }] } }] } }] } }] } }] } }] } }] }, lK = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getPoints" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "contactId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "Voyado_UUID" } } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Voyado" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "PointAccountV_GetPointAccounts" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "contactId" }, value: { kind: "Variable", name: { kind: "Name", value: "contactId" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Voyado_PointAccountModelV3" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "balance" } }] } }] } }] } }] } }] }, cK = {
  "\n  mutation updatePreferences(\n    $contactId: Voyado_UUID!\n    $input: Voyado_contactAttributes_Input!\n  ) {\n    Voyado {\n      ContactsV_ContactPatch(contactId: $contactId, input: $input) {\n        id\n      }\n    }\n  }\n": eK,
  "\n  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {\n    Voyado {\n      PointTransaction_AddPointTransacion(input: $input)\n    }\n  }\n": nK,
  "\n  query getContactById($contactId: Voyado_UUID!) {\n    Voyado {\n      ContactsV_GetContactById(contactId: $contactId) {\n        id\n        attributes\n        meta\n        preferences\n        consents {\n          id\n          date\n          value\n          source\n          comment\n        }\n      }\n    }\n  }\n": tK,
  "\n  query getContactOverviewById($contactId: String!) {\n    Voyado {\n      ContactOverview_GetContactOverviewAsync(contactId: $contactId)\n    }\n  }\n": rK,
  "\n  query getContactId($email: String!, $mobilePhone: String!) {\n    Voyado {\n      ContactOverview_GetContactIdAsync(\n        email: $email\n        mobilePhone: $mobilePhone\n      ) {\n        ... on Voyado_ContactOverview_GetContactIdAsync_response {\n          ... on Voyado_String_container {\n            String\n          }\n          ... on Voyado_ApiExceptionMultipleMatchesResponse {\n            errorCode\n            message\n            requestId\n            messageDetails {\n              multipleMatchesFound\n            }\n          }\n        }\n      }\n    }\n  }\n": iK,
  "\n  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {\n    Voyado {\n      ContactMessage_GetSmsMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetPostalMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n      ContactMessage_GetEmailMessagesByContactId(\n        contactId: $contactId\n        count: $count\n      ) {\n        ... on Voyado_ListResultOfApiMessage {\n          count\n          items {\n            messageId\n            name\n            sendDateTime\n            type\n            source\n            isTransactional\n            status\n            messageLink\n            messageText\n          }\n        }\n      }\n    }\n  }\n": aK,
  "\n  query getCustomerTransactions(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Transactions_GetTransactionsWithArticlesByContactId(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        count\n        totalCount\n        items {\n          id\n          createdDate\n          transactionNumber\n          storeName\n          numberOfItems\n          netPriceSum\n          localNetPriceSum\n          localCurrency\n          lineItems {\n            quantity\n            article {\n              name\n            }\n            localPrice\n            type\n          }\n        }\n      }\n    }\n  }\n": oK,
  "\n  query getOrdersByContactId(\n    $contactId: Voyado_UUID!\n    $offset: Int\n    $count: Int\n  ) {\n    Voyado {\n      Orders_GetAllByContact(\n        contactId: $contactId\n        offset: $offset\n        count: $count\n      ) {\n        totalCount\n        items {\n          orderId\n          createdAt\n          lastChangedAt\n          channel\n          status\n          externalStatus\n          totalPrice\n          currencyCode\n          lineItems {\n            items {\n              id\n              quantity\n              totalPrice\n              article {\n                sku\n                name\n                description\n                imageUri\n                targetUri\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": sK,
  "\n  query getPoints($contactId: Voyado_UUID!) {\n    Voyado {\n      PointAccountV_GetPointAccounts(contactId: $contactId) {\n        ... on Voyado_PointAccountModelV3 {\n          id\n          balance\n        }\n      }\n    }\n  }\n": lK
};
function oi(e) {
  return cK[e] ?? {};
}
const dK = oi(
  /* GraphQL */
  `
  query getContactById($contactId: Voyado_UUID!) {
    Voyado {
      ContactsV_GetContactById(contactId: $contactId) {
        id
        attributes
        meta
        preferences
        consents {
          id
          date
          value
          source
          comment
        }
      }
    }
  }
`
), uK = oi(
  /* GraphQL */
  `
  query getContactOverviewById($contactId: String!) {
    Voyado {
      ContactOverview_GetContactOverviewAsync(contactId: $contactId)
    }
  }
`
), mK = oi(
  /* GraphQL */
  `
  query getContactId($email: String!, $mobilePhone: String!) {
    Voyado {
      ContactOverview_GetContactIdAsync(
        email: $email
        mobilePhone: $mobilePhone
      ) {
        ... on Voyado_ContactOverview_GetContactIdAsync_response {
          ... on Voyado_String_container {
            String
          }
          ... on Voyado_ApiExceptionMultipleMatchesResponse {
            errorCode
            message
            requestId
            messageDetails {
              multipleMatchesFound
            }
          }
        }
      }
    }
  }
`
), pK = oi(
  /* GraphQL */
  `
  query getLatestMessagesByContactId($contactId: Voyado_UUID!, $count: Int) {
    Voyado {
      ContactMessage_GetSmsMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetPostalMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
      ContactMessage_GetEmailMessagesByContactId(
        contactId: $contactId
        count: $count
      ) {
        ... on Voyado_ListResultOfApiMessage {
          count
          items {
            messageId
            name
            sendDateTime
            type
            source
            isTransactional
            status
            messageLink
            messageText
          }
        }
      }
    }
  }
`
), fK = oi(
  /* GraphQL */
  `
  query getCustomerTransactions(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Transactions_GetTransactionsWithArticlesByContactId(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        count
        totalCount
        items {
          id
          createdDate
          transactionNumber
          storeName
          numberOfItems
          netPriceSum
          localNetPriceSum
          localCurrency
          lineItems {
            quantity
            article {
              name
            }
            localPrice
            type
          }
        }
      }
    }
  }
`
), hK = oi(
  /* GraphQL */
  `
  query getOrdersByContactId(
    $contactId: Voyado_UUID!
    $offset: Int
    $count: Int
  ) {
    Voyado {
      Orders_GetAllByContact(
        contactId: $contactId
        offset: $offset
        count: $count
      ) {
        totalCount
        items {
          orderId
          createdAt
          lastChangedAt
          channel
          status
          externalStatus
          totalPrice
          currencyCode
          lineItems {
            items {
              id
              quantity
              totalPrice
              article {
                sku
                name
                description
                imageUri
                targetUri
              }
            }
          }
        }
      }
    }
  }
`
), yK = oi(
  /* GraphQL */
  `
  query getPoints($contactId: Voyado_UUID!) {
    Voyado {
      PointAccountV_GetPointAccounts(contactId: $contactId) {
        ... on Voyado_PointAccountModelV3 {
          id
          balance
        }
      }
    }
  }
`
), gK = oi(
  /* GraphQL */
  `
  mutation updatePreferences(
    $contactId: Voyado_UUID!
    $input: Voyado_contactAttributes_Input!
  ) {
    Voyado {
      ContactsV_ContactPatch(contactId: $contactId, input: $input) {
        id
      }
    }
  }
`
), vK = oi(
  /* GraphQL */
  `
  mutation updatePoints($input: Voyado_AddPointTransactionRequestModel_Input!) {
    Voyado {
      PointTransaction_AddPointTransacion(input: $input)
    }
  }
`
), kK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = Cn(), [i, a] = me(), [o, s] = me(), [l, d] = me(), {
    loading: m,
    error: u,
    data: f,
    refetch: h
  } = n(dK, {
    skip: !e,
    variables: { contactId: e }
  });
  return Qe(() => {
    const k = f?.Voyado?.ContactsV_GetContactById;
    !m && k && typeof k == "object" && ("id" in k && r("voyado:profile:received", { hasProfile: !0 }), "attributes" in k && a(k.attributes), "preferences" in k && s(k.preferences), "consents" in k && d(
      k?.consents?.filter(
        (C) => C !== null
      ) || void 0
    )), !m && (!k || typeof k != "object") && r("voyado:profile:received", { hasProfile: !1 });
  }, [f?.Voyado, m]), Xn(
    () => ({
      isLoading: m,
      error: u,
      refetch: h,
      attributes: i,
      preferences: o,
      consents: l
    }),
    [u, i, o, l]
  );
};
function cl(e = !1, n) {
  const [r, i] = me(e);
  return Qe(() => {
    const a = r ? window.setTimeout(() => i(!1), 2e3) : void 0;
    return () => window.clearTimeout(a);
  }, [n, r]), { isCopied: r, copy: (a) => {
    navigator.clipboard.writeText(a), i(!0);
  } };
}
const bK = {
  count: 0,
  items: []
}, _K = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = Cn(), [i, a] = me(bK), {
    loading: o,
    error: s,
    data: l
  } = n(pK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    if (!o && (l?.Voyado?.ContactMessage_GetSmsMessagesByContactId || l?.Voyado?.ContactMessage_GetPostalMessagesByContactId || l?.Voyado?.ContactMessage_GetEmailMessagesByContactId)) {
      const d = l?.Voyado?.ContactMessage_GetEmailMessagesByContactId, m = l?.Voyado?.ContactMessage_GetSmsMessagesByContactId, u = l?.Voyado?.ContactMessage_GetPostalMessagesByContactId, f = {
        count: (m?.count ?? 0) + (u?.count ?? 0) + (d?.count ?? 0),
        items: [
          ...m.items ?? [],
          ...d.items ?? [],
          ...u.items ?? []
        ]
      };
      a(f), r("voyado:messages:received", {
        emailsReceived: d.count ?? 0,
        smsReceived: m.count ?? 0,
        postalReceived: u.count ?? 0,
        total: f.count ?? 0
      });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    lastMessages: i
  };
}, xK = {
  count: 0,
  totalCount: 0,
  items: []
}, SK = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), { track: r } = Cn(), [i, a] = me(
    xK
  ), {
    loading: o,
    error: s,
    data: l
  } = n(fK, {
    skip: !e,
    variables: { contactId: e, count: 5 }
  });
  return Qe(() => {
    const d = l?.Voyado?.Transactions_GetTransactionsWithArticlesByContactId;
    if (!o && d) {
      a(
        d
      );
      const { count: m } = d;
      m && r("voyado:transactions:received", { count: m });
    }
  }, [l?.Voyado, o]), {
    isLoading: o,
    error: s,
    transactions: i
  };
}, NK = ({
  conversationContext: e
}) => {
  const { useQuery: n } = hn(), [r, i] = me(void 0), [a, o] = me(!1), { customer: s } = e, l = !!s?.email || !!s?.phone_number, {
    loading: d,
    error: m,
    data: u,
    refetch: f
  } = n(mK, {
    skip: !l,
    variables: {
      email: s?.email ?? "",
      mobilePhone: s?.phone_number ?? ""
    }
  });
  return Qe(() => {
    const h = u?.Voyado?.ContactOverview_GetContactIdAsync;
    h?.__typename === "Voyado_ApiExceptionMultipleMatchesResponse" && h?.messageDetails?.multipleMatchesFound && h?.messageDetails?.multipleMatchesFound.length > 0 && (o(!0), i(void 0)), h?.__typename === "Voyado_String_container" && h?.String && (o(!1), i(h.String));
  }, [u?.Voyado, d]), {
    isLoading: d,
    contactId: r,
    hasMultipleContacts: a,
    error: m,
    refetch: f
  };
}, jK = ({
  contactId: e,
  skip: n
}) => {
  const { useQuery: r } = hn(), [i, a] = me(
    void 0
  ), {
    loading: o,
    error: s,
    data: l,
    refetch: d
  } = r(uK, {
    skip: !e || n,
    variables: { contactId: e }
  });
  return Qe(() => {
    const m = l?.Voyado?.ContactOverview_GetContactOverviewAsync;
    if (!o && m && Object.hasOwn(m, "memberlevel")) {
      const u = m?.memberlevel;
      a({
        levelName: u?.levelName,
        remainingToUpgrade: u?.remainingToUpgrade,
        basedOnRewardPoints: u?.basedOnRewardPoints,
        levelId: u?.levelId,
        latestChange: u?.latestChange,
        expires: u?.expires
      });
    } else
      a(void 0);
  }, [l?.Voyado, o]), Xn(
    () => ({
      isLoading: o,
      error: s,
      memberLevel: i,
      refetch: d
    }),
    [o, s, i, d]
  );
}, wK = "_pointer_pn2q5_54", CK = "_list_pn2q5_59", FK = "_listItem_pn2q5_69", pt = {
  pointer: wK,
  list: CK,
  listItem: FK
}, IK = "_modalBody_1clhs_1", EK = {
  modalBody: IK
}, $K = ({
  isOpen: e,
  onClose: n,
  pointsAccount: r,
  setHasPointsBeenUpdated: i,
  refetchPointsQuery: a
}) => {
  const { useMutation: o, showNotification: s } = hn(), { track: l } = Cn(), d = r?.id, m = r?.balance ?? 0, u = {
    balance: m?.toString() ?? "0",
    description: "",
    transactionType: null
  }, { control: f, setValue: h, reset: k } = ut({
    defaultValues: u,
    mode: "onChange"
  }), C = yi({ control: f }), N = parseInt(C?.balance ?? "0", 10), j = m === N, _ = j ? "Change the value to update the points" : "", g = N < 0, D = g ? "Points can not be negative" : "", O = C.description === "", I = O ? "Description can not be empty" : "";
  Qe(() => {
    N > m ? h(
      "transactionType",
      Sy.Addition
    ) : N < m && h(
      "transactionType",
      Sy.Deduction
    );
  }, [m, N, h]);
  const [F, { loading: L, error: K, reset: J }] = o(vK, {
    onCompleted: () => {
      s({
        title: "Success",
        text: "Points updated successfully",
        icon: "check-circle-filled",
        severity: "success"
      });
    }
  }), te = () => {
    if (d) {
      const Y = Y7();
      F({
        variables: {
          input: {
            accountId: d,
            transactionId: Y,
            amount: Math.abs(N - m),
            transactionType: C.transactionType,
            description: C.description,
            source: WF.UpdateBalance
          }
        }
      }).then(async (P) => {
        P?.errors ? l("voyado:update:points:failed") : (l("voyado:update:points:succeeded"), i(!0), await a(), W());
      }).catch(() => {
        l("voyado:update:points:failed");
      });
    }
  }, W = () => {
    k(u), J(), n();
  };
  return /* @__PURE__ */ R.jsxs(
    wt,
    {
      isOpen: e,
      onClose: W,
      "data-testid": "change-points-modal",
      children: [
        /* @__PURE__ */ R.jsx(Ct, { title: "Update points balance", onClose: W }),
        /* @__PURE__ */ R.jsxs(Ft, { className: EK.modalBody, children: [
          /* @__PURE__ */ R.jsxs(nt, { children: [
            /* @__PURE__ */ R.jsx(Z, { span: 6, children: /* @__PURE__ */ R.jsx(
              bt,
              {
                name: "balance",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ R.jsx(
                  Wr,
                  {
                    label: "New points balance",
                    type: "number",
                    placeholder: "Insert new points",
                    min: 0,
                    max: 1e5,
                    meta: {
                      warning: _ || D
                    },
                    input: {
                      ...Y,
                      value: Y.value.toString(),
                      onChange: (P) => Y.onChange(P)
                    }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ R.jsx(Z, { span: 6, children: /* @__PURE__ */ R.jsx(
              bt,
              {
                name: "description",
                control: f,
                render: ({ field: Y }) => /* @__PURE__ */ R.jsx(
                  Wr,
                  {
                    required: !0,
                    label: "Description",
                    placeholder: "Insert a description",
                    input: Y,
                    meta: {
                      warning: I
                    }
                  }
                )
              }
            ) })
          ] }),
          K && /* @__PURE__ */ R.jsx(En, { error: K })
        ] }),
        /* @__PURE__ */ R.jsx(
          Et,
          {
            confirmName: "Save",
            confirmOnClick: () => te(),
            confirmProps: {
              isLoading: L,
              disabled: j || g || O,
              loadingIndicator: /* @__PURE__ */ R.jsx(fn, { size: 16 })
            },
            cancelOnClick: W
          }
        )
      ]
    }
  );
}, TK = "_wrapper_1ge6c_1", OK = "_block_1ge6c_12", cw = {
  wrapper: TK,
  block: OK
}, RK = ({
  contactAttributes: e,
  contactId: n
}) => {
  const { useQuery: r } = hn(), { isCopied: i, copy: a } = cl(), { isCopied: o, copy: s } = cl(), { isCopied: l, copy: d } = cl(), [m, u] = me(!1), [f, h] = me(), [k, C] = me(!1), {
    loading: N,
    data: j,
    refetch: _
  } = r(yK, {
    variables: {
      contactId: n
    },
    skip: !n
  });
  Qe(() => {
    if (j) {
      const re = j?.Voyado?.PointAccountV_GetPointAccounts;
      re && re?.length > 0 && h(re[0]);
    }
  }, [j]);
  const g = !!f?.id, D = f?.balance ?? 0;
  if (!e)
    return null;
  const {
    firstName: O,
    lastName: I,
    street: F,
    zipCode: L,
    city: K,
    country: J,
    isRegistrationCompleted: te,
    email: W,
    mobilePhone: Y
  } = e, P = 14, B = `${O || ""} ${I || ""}`.trim() || "Anonymous";
  return /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", className: cw.wrapper, children: [
    /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        className: cw.block,
        alignItems: "center",
        children: [
          /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-2", children: B }),
          N && /* @__PURE__ */ R.jsx(fn, { size: 12 }),
          g && !N && /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", children: [
            /* @__PURE__ */ R.jsxs(Mn, { size: "small", variant: "warning", children: [
              D,
              " points"
            ] }),
            /* @__PURE__ */ R.jsx(Xe, { content: "Update points balance", children: /* @__PURE__ */ R.jsx(
              ve,
              {
                name: "pen",
                size: 12,
                onClick: () => u(!0),
                className: pt.pointer
              }
            ) }),
            k && /* @__PURE__ */ R.jsx(Xe, { content: "It might take a while until the updated points are available. Please refresh the integration by collapsing and expanding the widget in the sidebar.", children: /* @__PURE__ */ R.jsx(
              ve,
              {
                name: "info",
                size: 12,
                className: pt.pointer
              }
            ) })
          ] })
        ]
      }
    ),
    (F || K || L || J || Y || W) && /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
      Y && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "phone" }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Y })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            size: P,
            name: o ? "done" : "copy",
            onClick: () => s(Y),
            className: pt.pointer
          }
        )
      ] }),
      W && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "mail" }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: W })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            size: P,
            name: i ? "done" : "copy",
            onClick: () => a(W),
            className: pt.pointer
          }
        )
      ] }),
      (F || K || L || J) && /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "home" }),
          /* @__PURE__ */ R.jsxs($.Paragraph, { variant: "4", color: "secondary", children: [
            /* @__PURE__ */ R.jsx(st, { children: F }),
            /* @__PURE__ */ R.jsxs(st, { children: [
              L,
              " ",
              K
            ] }),
            /* @__PURE__ */ R.jsx(st, { children: J })
          ] })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            size: P,
            name: l ? "done" : "copy",
            onClick: () => d(`${F}, ${L} ${K}, ${J}`),
            className: pt.pointer
          }
        )
      ] }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx(ve, { size: P, name: "sign-in" }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Is registration completed" })
        ] }),
        /* @__PURE__ */ R.jsx(
          ve,
          {
            name: te ? "check-circle-filled" : "close-circle-filled",
            color: te ? "green.500" : "neutral.500"
          }
        )
      ] })
    ] }),
    g && /* @__PURE__ */ R.jsx(
      $K,
      {
        isOpen: m,
        pointsAccount: f,
        onClose: () => u(!1),
        setHasPointsBeenUpdated: C,
        refetchPointsQuery: _
      }
    )
  ] });
}, DK = "_list_yud4a_7", PK = "_listItem_yud4a_11", AK = "_listItemTooltip_yud4a_15", LK = "_listItemTimestamp_yud4a_18", qs = {
  list: DK,
  listItem: PK,
  listItemTooltip: AK,
  listItemTimestamp: LK
}, VK = ({
  contactConsents: e
}) => !e || e.length === 0 ? null : /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Consents" }),
  /* @__PURE__ */ R.jsx(Ye, { className: qs.list, children: e.map((n, r) => /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: qs.listItem, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ R.jsx(Xe, { content: n?.comment, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: dt({
          [qs.listItemTooltip]: n?.comment
        }),
        children: [
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.id }),
          /* @__PURE__ */ R.jsx($.Paragraph, { className: qs.listItemTimestamp, children: Gn(n.date).format(jt) }),
          n?.comment && /* @__PURE__ */ R.jsx(ve, { name: "info", color: "neutral.400" })
        ]
      }
    ) }),
    /* @__PURE__ */ R.jsx(
      ve,
      {
        name: n.value ? "check-circle-filled" : "close-circle-filled",
        color: n.value ? "green.500" : "red.500"
      }
    )
  ] }) }, r)) })
] }), zK = ({
  memberLevel: e
}) => {
  const n = e?.levelName ?? null, r = e?.remainingToUpgrade ?? null, i = e?.basedOnRewardPoints ?? null, a = e?.latestChange ? Gn(e.latestChange).format(jt) : null, o = e?.expires ? `${Gn(e.expires).fromNow()} (${Gn(e.expires).format(jt)})` : null, s = !n && !a && !r && !i && !o;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "100", children: [
      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Member level" }),
      /* @__PURE__ */ R.jsx(Xe, { content: "Voyado updates the member level data in a nightly batch process", children: /* @__PURE__ */ R.jsx(
        ve,
        {
          name: "question",
          size: 14,
          className: pt.pointer
        }
      ) })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsxs(Ye, { className: pt.list, children: [
      s && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No member level properties found" }) }),
      n && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Level" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "info", size: "small", children: e?.levelName ?? "" })
      ] }) }) }),
      i && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "Voyado updates the member level data once a day in a nightly job", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Based on reward points" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: i })
      ] }) }) }),
      r && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Remaining to upgrade" }),
        /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: r })
      ] }) }) }),
      a && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Latest change" }),
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", color: "secondary", children: a })
      ] }) }) }),
      o && /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: pt.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: "", children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "Expires" }),
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", color: "secondary", children: o })
      ] }) }) })
    ] }) })
  ] }) });
}, UK = "_tagHover_kzbzk_1", MK = "_channelUnsubscribed_kzbzk_6", dw = {
  tagHover: UK,
  channelUnsubscribed: MK
}, Ah = ({
  isSubscribed: e,
  channelName: n,
  channelIcon: r,
  contactId: i,
  contactPreferences: a,
  refetchContact: o
}) => {
  const { track: s } = Cn(), { useMutation: l } = hn(), [d, m] = me(!1), [u, { loading: f }] = l(gK), h = async ({
    newPreference: C,
    isSubscribed: N,
    channelType: j
  }) => {
    m(!0), (await u({
      variables: {
        contactId: i,
        input: {
          preferences: {
            ...a,
            ...C
          }
        }
      }
    }))?.data?.Voyado.ContactsV_ContactPatch?.id ? N ? s("voyado:channel:unsubscribe:succeeded", { channel: j }) : s("voyado:channel:subscribe:succeeded", { channel: j }) : N ? s("voyado:channel:unsubscribe:failed", { channel: j }) : s("voyado:channel:subscribe:failed", { channel: j }), setTimeout(async () => {
      await o().finally(() => m(!1));
    }, 1e3);
  }, k = d || f;
  return /* @__PURE__ */ R.jsx(Xe, { content: e ? "Unsubscribe" : "Subscribe", children: /* @__PURE__ */ R.jsx(
    Jn,
    {
      className: dw.tagHover,
      color: e ? "green.500" : "neutral.200",
      children: /* @__PURE__ */ R.jsxs(
        b,
        {
          "data-testid": `widget-preference-${e ? "subscribed" : "unsubscribed"}`,
          gap: "200",
          alignItems: "center",
          className: dt({
            [dw.channelUnsubscribed]: !e
          }),
          onClick: () => {
            e ? s("voyado:channel:unsubscribe:clicked", {
              channel: n.toUpperCase()
            }) : s("voyado:channel:subscribe:clicked", {
              channel: n.toUpperCase()
            }), h({
              newPreference: { [`accepts${n}`]: !e },
              isSubscribed: e,
              channelType: n.toUpperCase()
            });
          },
          children: [
            k ? /* @__PURE__ */ R.jsx(fn, { size: 16 }) : /* @__PURE__ */ R.jsx(ve, { size: 16, name: r }),
            n
          ]
        }
      )
    }
  ) });
}, BK = ({
  contactPreferences: e,
  contactId: n,
  refetchContact: r
}) => {
  if (!e || !n)
    return null;
  const { acceptsEmail: i, acceptsPostal: a, acceptsSms: o } = e;
  return /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Subscriptions" }),
    /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        Ah,
        {
          channelName: "Email",
          channelIcon: "mail",
          isSubscribed: i,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        Ah,
        {
          channelName: "Sms",
          channelIcon: "sms",
          isSubscribed: o,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      ),
      /* @__PURE__ */ R.jsx(
        Ah,
        {
          channelName: "Postal",
          channelIcon: "paper-plane",
          isSubscribed: a,
          contactId: n,
          contactPreferences: e,
          refetchContact: r
        }
      )
    ] })
  ] }) });
}, qK = ({
  contactId: e,
  settings: n
}) => {
  const {
    showCustomerAttributes: r,
    showPreferences: i,
    showAudiences: a,
    showConsents: o,
    showMemberLevel: s
  } = n, {
    isLoading: l,
    error: d,
    refetch: m,
    attributes: u,
    preferences: f,
    consents: h
  } = kK({ contactId: e }), {
    isLoading: k,
    error: C,
    memberLevel: N
  } = jK({ contactId: e, skip: !s }), j = k || l, _ = Xn(
    () => h?.filter(
      (g) => g !== null
    ),
    [h]
  );
  return d || C ? wa({
    errors: d?.graphQLErrors || C?.graphQLErrors || []
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { color: "secondary", children: "No contact informations found" }) }) : /* @__PURE__ */ R.jsx(En, { error: d || C }) : !r && !i && !a && !o && !s ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { color: "secondary", children: "All contact related features in the settings are disabled." }) }) : j ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
    r && /* @__PURE__ */ R.jsx(
      RK,
      {
        contactAttributes: u,
        contactId: e
      }
    ),
    s && /* @__PURE__ */ R.jsx(zK, { memberLevel: N }),
    i && /* @__PURE__ */ R.jsx(
      BK,
      {
        refetchContact: m,
        contactPreferences: f,
        contactId: e
      }
    ),
    o && /* @__PURE__ */ R.jsx(VK, { contactConsents: _ })
  ] });
}, Ny = (e, n) => `${e ? e.toFixed(2) : "0.00"} ${n}`, HK = "_list_zu4s7_1", WK = "_listItem_zu4s7_4", KK = "_listSum_zu4s7_7", Hs = {
  list: HK,
  listItem: WK,
  listSum: KK
}, GK = ({
  lineItems: e,
  localCurrency: n,
  localNetPriceSum: r
}) => /* @__PURE__ */ R.jsxs(Ye, { className: Hs.list, children: [
  e?.map(({ quantity: i, article: a, localPrice: o, type: s }, l) => /* @__PURE__ */ R.jsx(Ye.Text, { variant: "dense", className: Hs.listItem, children: /* @__PURE__ */ R.jsx(Xe, { content: s, children: /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", gap: "200", children: [
    /* @__PURE__ */ R.jsxs(b, { flex: "0 0 auto", gap: "200", children: [
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i }),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "×" })
    ] }),
    /* @__PURE__ */ R.jsx(b, { flex: "auto", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: a?.name }) }),
    o && n && /* @__PURE__ */ R.jsx(b, { flex: "0 0 auto", gap: "100", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Ny(o, n) }) })
  ] }) }) }, l)),
  /* @__PURE__ */ R.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(Hs.listItem, Hs.listSum),
      children: /* @__PURE__ */ R.jsxs(b, { gap: "100", justifyContent: "space-between", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Sum" }),
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: Ny(r, n) })
      ] })
    },
    "theSumOfItAll"
  )
] }), YK = "_transaction_1kr8d_1", JK = "_transactionIsOpen_1kr8d_9", QK = "_transactionHeader_1kr8d_12", XK = "_transactionHeaderSubLine_1kr8d_15", ZK = "_transactionHeaderAlignItemRight_1kr8d_19", ca = {
  transaction: YK,
  transactionIsOpen: JK,
  transactionHeader: QK,
  transactionHeaderSubLine: XK,
  transactionHeaderAlignItemRight: ZK
}, eG = ({
  transaction: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), {
    transactionNumber: a,
    createdDate: o,
    storeName: s,
    numberOfItems: l,
    storeType: d,
    lineItems: m,
    localCurrency: u,
    localNetPriceSum: f
  } = e, h = u ?? "", k = f ?? 0, C = m?.length ? m : [];
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: dt(ca.transaction, {
        [ca.transactionIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: ca.transactionHeader,
            onClick: () => i(!r),
            "data-testid": "contact-transaction-header",
            children: [
              /* @__PURE__ */ R.jsxs(b, { style: { flexGrow: 1 }, children: [
                /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                  o && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Gn(o).format(jt) }),
                  /* @__PURE__ */ R.jsxs(
                    $.Heading,
                    {
                      variant: "heading-4",
                      className: ca.transactionHeaderSubLine,
                      children: [
                        "ID: ",
                        a
                      ]
                    }
                  )
                ] }),
                /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    flexDirection: "column",
                    gap: "100",
                    className: ca.transactionHeaderAlignItemRight,
                    children: [
                      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-4", children: Ny(k, h) }),
                      /* @__PURE__ */ R.jsxs(
                        $.Heading,
                        {
                          variant: "heading-4",
                          className: ca.transactionHeaderSubLine,
                          children: [
                            l,
                            " line ",
                            `${l === 1 ? "item" : "items"}`
                          ]
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ R.jsx(b, { flexDirection: "column", children: /* @__PURE__ */ R.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              ) })
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(
          b,
          {
            gap: "300",
            flexDirection: "column",
            "data-testid": "contact-transaction-content",
            children: [
              /* @__PURE__ */ R.jsx(Hl, {}),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                s && /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-2", children: s }),
                d && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: d }) }),
                /* @__PURE__ */ R.jsx(
                  GK,
                  {
                    lineItems: C,
                    localCurrency: h,
                    localNetPriceSum: k
                  }
                )
              ] })
            ]
          }
        )
      ]
    }
  );
}, nG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    transactions: i
  } = SK({ contactId: e });
  if (!e)
    return null;
  const { items: a, totalCount: o } = i, s = o ?? 0;
  return r ? /* @__PURE__ */ R.jsx(En, { error: r }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "200",
      flexDirection: "column",
      "data-testid": "contact-transactions-wrapper",
      children: [
        /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
          /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Transactions" }),
          !n && s > 0 && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "success", children: s })
        ] }),
        n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
          s === 0 && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no transactions for this contact" }) }),
          s > 0 && a?.map((l, d) => /* @__PURE__ */ R.jsx(
            eG,
            {
              transaction: l,
              openByDefault: d === 0
            },
            d
          ))
        ] })
      ]
    }
  );
}, tG = "_message_4z55u_54", rG = "_messageIsOpen_4z55u_62", iG = "_messageHeader_4z55u_66", aG = "_messageText_4z55u_70", oG = "_buttonLink_4z55u_93", xo = {
  message: tG,
  messageIsOpen: rG,
  messageHeader: iG,
  messageText: aG,
  buttonLink: oG
}, Lh = {
  status: {
    Delivered: "check-circle",
    Waiting: "clock",
    Hardbounce: "close-circle-filled",
    Softbounce: "close"
  },
  type: {
    EmailMessage: "mail",
    SmsMessage: "sms",
    PostalMessage: "paper-plane"
  },
  source: {
    Automation: "chat-bot",
    Manual: "user",
    System: "eye"
  }
}, Vh = (e, n) => n && e in Lh && n in Lh[e] ? Lh[e][n] : null, sG = ({
  message: e,
  openByDefault: n
}) => {
  const [r, i] = me(n), { track: a } = Cn();
  if (!e)
    return null;
  const {
    name: o,
    sendDateTime: s,
    type: l,
    source: d,
    isTransactional: m,
    status: u,
    messageLink: f,
    messageText: h
  } = e, k = l ? Vh("type", l) : null, C = d ? Vh("source", d) : null, N = u ? Vh("status", u) : null, j = l?.replace("Message", "");
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: dt(xo.message, {
        [xo.messageIsOpen]: r
      }),
      gap: "300",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: xo.messageHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                /* @__PURE__ */ R.jsxs(b, { gap: "200", alignItems: "center", children: [
                  k && /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
                    /* @__PURE__ */ R.jsx(ve, { name: k, size: 16 }),
                    " ",
                    j
                  ] }),
                  s && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: Gn(s).format(jt) })
                ] }),
                o
              ] }),
              /* @__PURE__ */ R.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-up" : "angle-down"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "300", flexDirection: "column", children: [
          /* @__PURE__ */ R.jsx(Hl, {}),
          /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", flexWrap: "wrap", children: [
            N && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(ve, { name: N }),
              " ",
              u
            ] }) }),
            C && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(ve, { name: C }),
              " ",
              d
            ] }) }),
            m && /* @__PURE__ */ R.jsx(Jn, { children: /* @__PURE__ */ R.jsxs(b, { alignItems: "center", gap: "200", children: [
              /* @__PURE__ */ R.jsx(ve, { name: "exchange" }),
              " Transactional"
            ] }) })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "Message text" }),
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", className: xo.messageText, children: h })
          ] }),
          f && /* @__PURE__ */ R.jsx(
            Lt,
            {
              slotEnd: /* @__PURE__ */ R.jsx(ve, { name: "external-link" }),
              variant: "tertiary",
              className: xo.buttonLink,
              navigate: () => {
                j && a("voyado:message:external-link:opened", {
                  channel: j.toUpperCase()
                }), window.open(f, "_blank")?.focus();
              },
              children: "Open message in new tab"
            }
          )
        ] })
      ]
    }
  );
}, lG = ({
  contactId: e
}) => {
  const {
    isLoading: n,
    error: r,
    lastMessages: i
  } = _K({ contactId: e });
  if (!e)
    return null;
  if (r)
    return /* @__PURE__ */ R.jsx(En, { error: r });
  const { count: a, items: o } = i, s = (a && a) ?? 0, l = s > 0;
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Last Messages" }),
      !n && l && /* @__PURE__ */ R.jsx(Mn, { variant: "success", size: "small", children: s })
    ] }),
    /* @__PURE__ */ R.jsx(b, { gap: "200", flexDirection: "column", children: n ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(R.Fragment, { children: [
      l && o?.map((d, m) => /* @__PURE__ */ R.jsx(
        sG,
        {
          message: d || void 0,
          openByDefault: m === 0
        },
        m
      )),
      !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No messages available" }) })
    ] }) })
  ] });
}, yc = ({
  value: e,
  currencyCode: n
}) => `${Number.parseFloat((e ?? 0).toString()).toFixed(2)} ${n ?? ""}`, uw = ({
  labelText: e,
  address: n,
  icon: r = "home"
}) => {
  const { isCopied: i, copy: a } = cl(), o = [n?.title, n?.firstname, n?.lastname].filter(Boolean).join(" "), s = _t(() => [
    o,
    n?.streetAddress,
    n?.streetAddress2,
    n?.postalCode,
    n?.region,
    n?.city,
    n?.country
  ].filter(Boolean).join(`
`), [n, o]);
  if (!n)
    return null;
  const l = 14;
  return /* @__PURE__ */ R.jsxs(b, { justifyContent: "space-between", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(ve, { size: l, name: r, color: "green.500" }),
      /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
        /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: e }),
        /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
          o && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: o }),
          n?.streetAddress && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.streetAddress }),
          n?.streetAddress2 && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.streetAddress2 }),
          n?.postalCode && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n?.postalCode }),
          n?.region && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.region }),
          n?.city && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.city }),
          n?.country && /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: n.country })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ R.jsx(Xe, { content: `Copy ${e.toLowerCase()}`, children: /* @__PURE__ */ R.jsx(
      ve,
      {
        size: l,
        name: i ? "done" : "copy",
        onClick: () => a(s()),
        className: pt.pointer
      }
    ) })
  ] });
}, cG = "_order_19t4p_1", dG = "_orderIsOpen_19t4p_9", uG = "_orderHeader_19t4p_12", mG = "_orderIconColor_19t4p_15", zr = {
  order: cG,
  orderIsOpen: dG,
  orderHeader: uG,
  orderIconColor: mG
}, pG = "_delivery_1m9nb_1", fG = "_deliveryCode_1m9nb_4", zh = {
  delivery: pG,
  deliveryCode: fG
}, hG = ({
  delivery: e
}) => {
  const { isCopied: n, copy: r } = Jt();
  if (!e)
    return null;
  const { method: i, trackingNumber: a, trackingUri: o, deliveryDate: s } = e, l = 14;
  return /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
    /* @__PURE__ */ R.jsx(
      ve,
      {
        size: l,
        name: "eye",
        className: zr.orderIconColor
      }
    ),
    /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", width: "100%", children: [
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Delivery" }),
      /* @__PURE__ */ R.jsx(
        Xe,
        {
          content: /* @__PURE__ */ R.jsxs($.Paragraph, { variant: "4", color: "inherit", children: [
            "Arrives: ",
            Gn(s).format(jt)
          ] }),
          children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
            o ? /* @__PURE__ */ R.jsx(
              $.ExternalLink,
              {
                href: o,
                target: "_blank",
                rel: "noreferrer",
                children: /* @__PURE__ */ R.jsxs(
                  b,
                  {
                    gap: "100",
                    alignItems: "center",
                    className: zh.delivery,
                    children: [
                      /* @__PURE__ */ R.jsx(ve, { name: "external-link", size: l }),
                      i
                    ]
                  }
                )
              }
            ) : i,
            /* @__PURE__ */ R.jsx(
              $.Paragraph,
              {
                variant: "4",
                className: dt(zh.delivery, zh.deliveryCode),
                children: a
              }
            )
          ] })
        }
      )
    ] }),
    a && /* @__PURE__ */ R.jsx(Xe, { content: "Copy tracking code", children: /* @__PURE__ */ R.jsx(
      ve,
      {
        size: l,
        name: n ? "done" : "copy",
        onClick: () => r(a.toString()),
        className: pt.pointer
      }
    ) })
  ] });
}, yG = ({
  fees: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ve,
        {
          size: 14,
          name: "file-text",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Fees" })
    ] }),
    /* @__PURE__ */ R.jsx(Ye, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(Ye.Item, { className: pt.listItem, children: /* @__PURE__ */ R.jsxs(
      b,
      {
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        children: [
          /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: i?.type }),
            /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.description })
          ] }),
          /* @__PURE__ */ R.jsx(b, { flexDirection: "column", gap: "100", children: i?.taxes?.items?.map((o, s) => /* @__PURE__ */ R.jsxs(
            b,
            {
              gap: "100",
              flexDirection: "column",
              className: pt.listItemAlignRight,
              children: [
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: `${o?.description} ${o?.percent}%` }),
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: yc({ value: o?.amount, currencyCode: n }) })
              ]
            },
            `tax-${s}`
          )) })
        ]
      }
    ) }, `fees-${a}`)) })
  ] });
}, gG = ({
  lineItems: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ve,
        {
          size: 14,
          name: "tag",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Line items" })
    ] }),
    /* @__PURE__ */ R.jsx(Ye, { className: pt.list, children: r?.map((i) => /* @__PURE__ */ R.jsx(
      Ye.Item,
      {
        className: pt.listItem,
        contentLeft: /* @__PURE__ */ R.jsxs(b, { gap: "200", children: [
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.quantity }),
          /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: "×" })
        ] }),
        title: /* @__PURE__ */ R.jsx(
          Xe,
          {
            content: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", color: "inherit", children: i?.article?.sku }),
            children: /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.article?.name }),
              /* @__PURE__ */ R.jsx(b, { children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: yc({
                value: i?.totalPrice,
                currencyCode: n
              }) }) })
            ] })
          }
        ),
        contentRight: i?.article?.imageUri && /* @__PURE__ */ R.jsx(
          Ca,
          {
            src: i?.article?.imageUri,
            alt: i?.article?.name,
            style: { height: "48px" }
          }
        )
      },
      `list-${i?.id}`
    )) })
  ] });
}, vG = ({
  payments: e,
  currencyCode: n
}) => {
  if (!e)
    return null;
  const r = e?.items ?? [];
  return /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "row", children: [
      /* @__PURE__ */ R.jsx(
        ve,
        {
          size: 14,
          name: "credit-card",
          className: zr.orderIconColor
        }
      ),
      /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Payment methods" })
    ] }),
    /* @__PURE__ */ R.jsx(Ye, { className: pt.list, children: r?.map((i, a) => /* @__PURE__ */ R.jsx(
      Ye.Item,
      {
        className: pt.listItem,
        children: /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            children: [
              /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "100", children: [
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: i?.description }),
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: i?.method })
              ] }),
              /* @__PURE__ */ R.jsxs(
                b,
                {
                  gap: "100",
                  flexDirection: "column",
                  className: pt.listItemAlignRight,
                  children: [
                    /* @__PURE__ */ R.jsx($.Paragraph, { variant: "5", children: Gn(i?.paidAt).format(jt) }),
                    /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: yc({ value: i?.amount, currencyCode: n }) })
                  ]
                }
              )
            ]
          }
        )
      },
      `payments-${a}`
    )) })
  ] });
}, kG = ({
  order: e,
  openByDefault: n
}) => {
  const [r, i] = me(n);
  if (!e)
    return null;
  const {
    orderId: a,
    status: o,
    externalStatus: s,
    currencyCode: l,
    channel: d,
    createdAt: m,
    lastChangedAt: u,
    lineItems: f,
    billingAddress: h,
    deliveryAddress: k,
    totalPrice: C
  } = e, N = 14;
  return /* @__PURE__ */ R.jsxs(
    b,
    {
      className: dt(zr.order, {
        [zr.orderIsOpen]: r
      }),
      gap: "200",
      flexDirection: "column",
      children: [
        /* @__PURE__ */ R.jsxs(
          b,
          {
            justifyContent: "space-between",
            alignItems: "center",
            className: zr.orderHeader,
            onClick: () => i(!r),
            children: [
              /* @__PURE__ */ R.jsxs(b, { gap: "100", flexDirection: "column", children: [
                m && /* @__PURE__ */ R.jsx(b, { alignItems: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: Gn(m).format(jt) }) }),
                /* @__PURE__ */ R.jsx($.Paragraph, { variant: "1", children: a })
              ] }),
              /* @__PURE__ */ R.jsx(
                ir,
                {
                  variant: "tertiary",
                  icon: r ? "angle-down" : "angle-right"
                }
              )
            ]
          }
        ),
        r && /* @__PURE__ */ R.jsxs(b, { gap: "250", flexDirection: "column", margin: "200 0 0", children: [
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              ve,
              {
                size: N,
                name: "activity",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Order status" }),
              /* @__PURE__ */ R.jsxs(b, { gap: "100", alignItems: "center", flexWrap: "wrap", children: [
                o && /* @__PURE__ */ R.jsx(Xe, { content: "Internal status", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: o }) }) }),
                s && /* @__PURE__ */ R.jsx(Xe, { content: "External status", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: s }) }) }),
                /* @__PURE__ */ R.jsx(Xe, { content: "Last updated at", children: /* @__PURE__ */ R.jsx($.Paragraph, { as: "span", variant: "5", children: Gn(u).format(jt) }) })
              ] })
            ] })
          ] }),
          /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              ve,
              {
                size: N,
                name: "chart-bar",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Order value" }),
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: yc({
                value: C,
                currencyCode: l
              }) })
            ] })
          ] }),
          d && /* @__PURE__ */ R.jsxs(b, { gap: "250", children: [
            /* @__PURE__ */ R.jsx(
              ve,
              {
                size: N,
                name: "channels",
                className: zr.orderIconColor
              }
            ),
            /* @__PURE__ */ R.jsxs(b, { flexDirection: "column", gap: "200", children: [
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "3", children: "Channel" }),
              /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", children: /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "info", children: /* @__PURE__ */ R.jsx(R.Fragment, { children: d }) }) })
            ] })
          ] }),
          /* @__PURE__ */ R.jsx(uw, { labelText: "Billing address", address: h }),
          /* @__PURE__ */ R.jsx(
            uw,
            {
              icon: "map-pin",
              labelText: "Delivery address",
              address: k
            }
          ),
          /* @__PURE__ */ R.jsx(hG, { delivery: e.delivery }),
          /* @__PURE__ */ R.jsx(gG, { lineItems: f, currencyCode: l }),
          /* @__PURE__ */ R.jsx(yG, { fees: e.fees, currencyCode: l }),
          /* @__PURE__ */ R.jsx(
            vG,
            {
              payments: e.payments,
              currencyCode: l
            }
          )
        ] })
      ]
    }
  );
}, bG = ({
  error: e,
  itemCount: n,
  children: r
}) => e ? n === 0 || wa({
  errors: e.graphQLErrors
}) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "There are no orders for this contact" }) }) : /* @__PURE__ */ R.jsx(En, { error: e }) : /* @__PURE__ */ R.jsx(R.Fragment, { children: r }), _G = ({
  contactId: e
}) => {
  const { useQuery: n } = hn(), [r, i] = me([]), { track: a } = Cn(), {
    loading: o,
    error: s,
    data: l
  } = n(hK, {
    skip: !e,
    variables: {
      contactId: e
    }
  });
  return Qe(() => {
    if (l?.Voyado) {
      const d = l?.Voyado.Orders_GetAllByContact;
      if (!o && d?.items) {
        i(d.items);
        const { totalCount: m } = d;
        m && a("voyado:orders:received", { count: m });
      }
    }
  }, [l?.Voyado]), e ? /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "column", margin: "200 0 300 0", children: [
    /* @__PURE__ */ R.jsxs(b, { gap: "200", flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ R.jsx($.Heading, { variant: "heading-3", children: "Orders" }),
      r.length > 0 && /* @__PURE__ */ R.jsx(Mn, { size: "small", variant: "success", children: r.length })
    ] }),
    o ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsx(bG, { error: s, itemCount: r.length, children: r.map((d, m) => /* @__PURE__ */ R.jsx(
      kG,
      {
        order: d,
        openByDefault: m === 0
      },
      m
    )) })
  ] }) : null;
}, xG = ({
  conversationContext: e,
  settings: n
}) => {
  const { isLoading: r, contactId: i, hasMultipleContacts: a, error: o } = NK({
    conversationContext: e
  }), s = !e?.customer?.email && !e?.customer?.phone_number, l = !!i, {
    showCustomerAttributes: d,
    showPreferences: m,
    showAudiences: u,
    showConsents: f,
    showLastMessages: h,
    showCustomerTransactions: k,
    showOrders: C
  } = n;
  return s ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "widget-no-contact-message",
      children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
    }
  ) : a ? /* @__PURE__ */ R.jsx(
    b,
    {
      justifyContent: "center",
      margin: "200 0 300 0",
      "data-testid": "multiple-contacts-found-message",
      children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "We found multiple profile IDs that match your email or phone number. To display customer informations, we need a unique profile id. Please make sure that the customers data is normalized." })
    }
  ) : o ? wa({
    errors: o.graphQLErrors
  }) ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No profile found" }) }) : /* @__PURE__ */ R.jsx(En, { error: o }) : !d && !m && !u && !f && !h && !k ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." }) }) : r ? /* @__PURE__ */ R.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ R.jsx(fn, {}) }) : /* @__PURE__ */ R.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        /* @__PURE__ */ R.jsx(qK, { contactId: i, settings: n }),
        h && /* @__PURE__ */ R.jsx(lG, { contactId: i }),
        k && /* @__PURE__ */ R.jsx(nG, { contactId: i }),
        C && /* @__PURE__ */ R.jsx(_G, { contactId: i }),
        !l && /* @__PURE__ */ R.jsx(b, { justifyContent: "center", padding: "200", children: /* @__PURE__ */ R.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No contact found." }) })
      ]
    }
  );
}, Ll = [
  {
    key: "voyadoApiKey",
    label: "API key",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "apiHostName",
    label: "API URL",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  {
    key: "showCustomerAttributes",
    label: "Show the customer attributes",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showPreferences",
    label: "Show preferences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showAudiences",
    label: "Show audiences",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showConsents",
    label: "Show consents",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showLastMessages",
    label: "Show the last 5 messages",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showCustomerTransactions",
    label: "Show customer transactions",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showOrders",
    label: "Show orders by contact",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showMemberLevel",
    label: "Show member level",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], Ar = rr(Ll), SG = {
  enabled: !1,
  name: "",
  voyadoApiKey: "",
  apiHostName: "",
  showCustomerAttributes: !0,
  showPreferences: !0,
  showAudiences: !0,
  showConsents: !0,
  showLastMessages: !0,
  showCustomerTransactions: !0,
  showOrders: !0,
  showMemberLevel: !0
}, NG = ({
  integrationId: e,
  handleRedirect: n,
  showNotification: r,
  automationCouplingState: i,
  renderConditionsEditor: a
}) => {
  const o = !e, s = ut({
    mode: "onChange",
    defaultValues: SG
  }), {
    create: l,
    update: d,
    remove: m,
    isLoading: u,
    error: f,
    misconfigurationCause: h,
    setMisconfigurationCause: k
  } = ur({
    integrationId: e,
    integrationType: "VOYADO",
    handleRedirect: n,
    showNotification: r
  }), {
    isLoading: C,
    error: N,
    isWidgetUnknown: j,
    refetch: _,
    widgetConfiguration: g
  } = mr({
    integrationId: e,
    fieldDefinitions: Ll,
    form: s,
    onMisconfigured: k
  }), { renderConditions: D, setRenderConditions: O, renderConditionsForSubmit: I } = pr({
    integrationId: e,
    widgetConfiguration: g,
    renderConditionsEditor: a
  }), F = (K) => hr(K, {
    fieldDefinitions: Ll,
    isCreationMode: o,
    create: l,
    update: d,
    renderConditions: I
  }), L = s.watch("name");
  return /* @__PURE__ */ R.jsxs(
    fr,
    {
      form: s,
      integrationId: e,
      onValidSubmit: F,
      error: N ?? f,
      onRetry: N ? _ : void 0,
      isLoading: u || C,
      isWidgetUnknown: j,
      children: [
        h && /* @__PURE__ */ R.jsx(yr, { cause: h }),
        /* @__PURE__ */ R.jsxs(nt, { children: [
          /* @__PURE__ */ R.jsx(Z, { children: /* @__PURE__ */ R.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "enabled",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: s.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(
            Er,
            {
              name: "voyadoApiKey",
              label: Ar.voyadoApiKey,
              control: s.control,
              isCreationMode: o,
              rules: { required: "API key is required" },
              componentProps: {
                placeholder: "API key from Voyado",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(
            Pn,
            {
              name: "apiHostName",
              label: Ar.apiHostName,
              control: s.control,
              rules: { required: "API URL is required" },
              componentProps: {
                placeholder: "The URL of the Voyado API",
                autoComplete: "off",
                prefix: "https://"
              }
            }
          ) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showCustomerAttributes, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showCustomerAttributes",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showPreferences, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showPreferences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showAudiences, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showAudiences",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showConsents, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showConsents",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showLastMessages, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showLastMessages",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showCustomerTransactions, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showCustomerTransactions",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showOrders, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showOrders",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          /* @__PURE__ */ R.jsx(Z, { span: 3, children: /* @__PURE__ */ R.jsx(We, { label: Ar.showMemberLevel, children: /* @__PURE__ */ R.jsx(
            bn,
            {
              name: "showMemberLevel",
              control: s.control
            }
          ) }) }),
          /* @__PURE__ */ R.jsx(Z, { span: 3 }),
          a && D !== null && /* @__PURE__ */ R.jsx(Z, { children: a({
            value: D,
            onChange: O,
            configurationKey: g?.id
          }) })
        ] }),
        /* @__PURE__ */ R.jsx(
          gr,
          {
            integrationType: "VOYADO",
            integrationId: e,
            widgetName: L,
            isCreationMode: o,
            isSubmitting: s.formState.isSubmitting,
            automationCouplingState: i,
            onConfirmDelete: () => m()
          }
        )
      ]
    }
  );
};
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode('@charset "UTF-8";._copyIcon_1pfts_54{cursor:pointer;color:var(--dixa-typography-color-secondary)}._list_1pfts_59{padding:0;overflow-y:auto;max-height:230px;background:linear-gradient(var(--dixa-color-neutral-000) 33%,rgba(255,255,255,0)),linear-gradient(rgba(255,255,255,0),var(--dixa-color-neutral-000) 66%) 0 100%,radial-gradient(farthest-side at 50% 0,var(--dixa-color-neutral-200),rgba(0,0,0,0)),radial-gradient(farthest-side at 50% 100%,var(--dixa-color-neutral-200),rgba(0,0,0,0)) 0 100%;background-color:var(--dixa-color-neutral-000);background-repeat:no-repeat;background-attachment:local,local,scroll,scroll;background-size:100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-400),100% var(--dixa-size-spacer-200),100% var(--dixa-size-spacer-200)}._listItem_1pfts_69{cursor:pointer;background-color:transparent;padding:var(--dixa-size-spacer-100);box-shadow:inset 0 calc(-1 * var(--dixa-size-border-100)) 0 var(--dixa-color-neutral-200)}._listItem_1pfts_69:last-child{box-shadow:none}._listItemHighlighted_1pfts_78{border-left:8px solid var(--dixa-color-orange-300)}._wrapper_1xucg_1{border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);background-color:var(--dixa-color-neutral-100)}._externalLink_1xucg_7{color:var(--dixa-typography-color-primary);font-size:var(--dixa-typography-size-200)}._settingsWrapper_1ycvy_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);margin-bottom:var(--dixa-size-spacer-300)}._settingsWrapperHeader_1ycvy_6{cursor:pointer;padding:var(--dixa-size-spacer-300)}._settingsWrapperContent_1ycvy_10{border-top:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);padding:var(--dixa-size-spacer-300);line-height:var(--dixa-typography-line-height-400)}._settingsWrapperContent_1ycvy_10 ol{margin-bottom:0}._settingsWrapperContentCode_1ycvy_18{background-color:var(--dixa-color-neutral-200);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);font-family:var(--dixa-typography-family-code);font-size:var(--dixa-typography-size-200)}._settingsWrapperContentCURL_1ycvy_26{overflow:auto;padding:var(--dixa-size-spacer-100) var(--dixa-size-spacer-300);font-family:var(--dixa-typography-family-code);color:var(--dixa-typography-color-secondary);background-color:var(--dixa-color-neutral-100);border-radius:var(--dixa-size-border-radius-100);border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300)}')), document.head.appendChild(e);
    }
  } catch (n) {
    console.error("vite-plugin-css-injected-by-js", n);
  }
})();
var Uh = { exports: {} }, So = {}, mw;
function jG() {
  if (mw) return So;
  mw = 1;
  var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, a = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(l, d, m) {
    var u, f = {}, h = null, k = null;
    m !== void 0 && (h = "" + m), d.key !== void 0 && (h = "" + d.key), d.ref !== void 0 && (k = d.ref);
    for (u in d) i.call(d, u) && !o.hasOwnProperty(u) && (f[u] = d[u]);
    if (l && l.defaultProps) for (u in d = l.defaultProps, d) f[u] === void 0 && (f[u] = d[u]);
    return { $$typeof: n, type: l, key: h, ref: k, props: f, _owner: a.current };
  }
  return So.Fragment = r, So.jsx = s, So.jsxs = s, So;
}
var Ws = {}, pw;
function wG() {
  return pw || (pw = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = qe, n = /* @__PURE__ */ Symbol.for("react.element"), r = /* @__PURE__ */ Symbol.for("react.portal"), i = /* @__PURE__ */ Symbol.for("react.fragment"), a = /* @__PURE__ */ Symbol.for("react.strict_mode"), o = /* @__PURE__ */ Symbol.for("react.profiler"), s = /* @__PURE__ */ Symbol.for("react.provider"), l = /* @__PURE__ */ Symbol.for("react.context"), d = /* @__PURE__ */ Symbol.for("react.forward_ref"), m = /* @__PURE__ */ Symbol.for("react.suspense"), u = /* @__PURE__ */ Symbol.for("react.suspense_list"), f = /* @__PURE__ */ Symbol.for("react.memo"), h = /* @__PURE__ */ Symbol.for("react.lazy"), k = /* @__PURE__ */ Symbol.for("react.offscreen"), C = Symbol.iterator, N = "@@iterator";
    function j(t) {
      if (t === null || typeof t != "object")
        return null;
      var c = C && t[C] || t[N];
      return typeof c == "function" ? c : null;
    }
    var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function g(t) {
      {
        for (var c = arguments.length, p = new Array(c > 1 ? c - 1 : 0), y = 1; y < c; y++)
          p[y - 1] = arguments[y];
        D("error", t, p);
      }
    }
    function D(t, c, p) {
      {
        var y = _.ReactDebugCurrentFrame, w = y.getStackAddendum();
        w !== "" && (c += "%s", p = p.concat([w]));
        var T = p.map(function(S) {
          return String(S);
        });
        T.unshift("Warning: " + c), Function.prototype.apply.call(console[t], console, T);
      }
    }
    var O = !1, I = !1, F = !1, L = !1, K = !1, J;
    J = /* @__PURE__ */ Symbol.for("react.module.reference");
    function te(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === i || t === o || K || t === a || t === m || t === u || L || t === k || O || I || F || typeof t == "object" && t !== null && (t.$$typeof === h || t.$$typeof === f || t.$$typeof === s || t.$$typeof === l || t.$$typeof === d || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === J || t.getModuleId !== void 0));
    }
    function W(t, c, p) {
      var y = t.displayName;
      if (y)
        return y;
      var w = c.displayName || c.name || "";
      return w !== "" ? p + "(" + w + ")" : p;
    }
    function Y(t) {
      return t.displayName || "Context";
    }
    function P(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && g("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case m:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case l:
            var c = t;
            return Y(c) + ".Consumer";
          case s:
            var p = t;
            return Y(p._context) + ".Provider";
          case d:
            return W(t, t.render, "ForwardRef");
          case f:
            var y = t.displayName || null;
            return y !== null ? y : P(t.type) || "Memo";
          case h: {
            var w = t, T = w._payload, S = w._init;
            try {
              return P(S(T));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, re = 0, je, ue, se, he, V, ke, De;
    function q() {
    }
    q.__reactDisabledLog = !0;
    function Ge() {
      {
        if (re === 0) {
          je = console.log, ue = console.info, se = console.warn, he = console.error, V = console.group, ke = console.groupCollapsed, De = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: q,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        re++;
      }
    }
    function sn() {
      {
        if (re--, re === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, t, {
              value: je
            }),
            info: B({}, t, {
              value: ue
            }),
            warn: B({}, t, {
              value: se
            }),
            error: B({}, t, {
              value: he
            }),
            group: B({}, t, {
              value: V
            }),
            groupCollapsed: B({}, t, {
              value: ke
            }),
            groupEnd: B({}, t, {
              value: De
            })
          });
        }
        re < 0 && g("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Ie = _.ReactCurrentDispatcher, Ue;
    function Re(t, c, p) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (w) {
            var y = w.stack.trim().match(/\n( *(at )?)/);
            Ue = y && y[1] || "";
          }
        return `
` + Ue + t;
      }
    }
    var Be = !1, Ae;
    {
      var Je = typeof WeakMap == "function" ? WeakMap : Map;
      Ae = new Je();
    }
    function $e(t, c) {
      if (!t || Be)
        return "";
      {
        var p = Ae.get(t);
        if (p !== void 0)
          return p;
      }
      var y;
      Be = !0;
      var w = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var T;
      T = Ie.current, Ie.current = null, Ge();
      try {
        if (c) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (ne) {
              y = ne;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (ne) {
              y = ne;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ne) {
            y = ne;
          }
          t();
        }
      } catch (ne) {
        if (ne && y && typeof ne.stack == "string") {
          for (var x = ne.stack.split(`
`), X = y.stack.split(`
`), A = x.length - 1, M = X.length - 1; A >= 1 && M >= 0 && x[A] !== X[M]; )
            M--;
          for (; A >= 1 && M >= 0; A--, M--)
            if (x[A] !== X[M]) {
              if (A !== 1 || M !== 1)
                do
                  if (A--, M--, M < 0 || x[A] !== X[M]) {
                    var de = `
` + x[A].replace(" at new ", " at ");
                    return t.displayName && de.includes("<anonymous>") && (de = de.replace("<anonymous>", t.displayName)), typeof t == "function" && Ae.set(t, de), de;
                  }
                while (A >= 1 && M >= 0);
              break;
            }
        }
      } finally {
        Be = !1, Ie.current = T, sn(), Error.prepareStackTrace = w;
      }
      var ze = t ? t.displayName || t.name : "", Te = ze ? Re(ze) : "";
      return typeof t == "function" && Ae.set(t, Te), Te;
    }
    function Me(t, c, p) {
      return $e(t, !1);
    }
    function en(t) {
      var c = t.prototype;
      return !!(c && c.isReactComponent);
    }
    function oe(t, c, p) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return $e(t, en(t));
      if (typeof t == "string")
        return Re(t);
      switch (t) {
        case m:
          return Re("Suspense");
        case u:
          return Re("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case d:
            return Me(t.render);
          case f:
            return oe(t.type, c, p);
          case h: {
            var y = t, w = y._payload, T = y._init;
            try {
              return oe(T(w), c, p);
            } catch {
            }
          }
        }
      return "";
    }
    var le = Object.prototype.hasOwnProperty, xe = {}, Ve = _.ReactDebugCurrentFrame;
    function Pe(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        Ve.setExtraStackFrame(p);
      } else
        Ve.setExtraStackFrame(null);
    }
    function vn(t, c, p, y, w) {
      {
        var T = Function.call.bind(le);
        for (var S in t)
          if (T(t, S)) {
            var x = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + p + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              x = t[S](c, S, y, p, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (A) {
              x = A;
            }
            x && !(x instanceof Error) && (Pe(w), g("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", p, S, typeof x), Pe(null)), x instanceof Error && !(x.message in xe) && (xe[x.message] = !0, Pe(w), g("Failed %s type: %s", p, x.message), Pe(null));
          }
      }
    }
    var Q = Array.isArray;
    function E(t) {
      return Q(t);
    }
    function z(t) {
      {
        var c = typeof Symbol == "function" && Symbol.toStringTag, p = c && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return p;
      }
    }
    function ie(t) {
      try {
        return ce(t), !1;
      } catch {
        return !0;
      }
    }
    function ce(t) {
      return "" + t;
    }
    function U(t) {
      if (ie(t))
        return g("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", z(t)), ce(t);
    }
    var G = _.ReactCurrentOwner, ye = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ne, Oe;
    function rn(t) {
      if (le.call(t, "ref")) {
        var c = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function kn(t) {
      if (le.call(t, "key")) {
        var c = Object.getOwnPropertyDescriptor(t, "key").get;
        if (c && c.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function an(t, c) {
      typeof t.ref == "string" && G.current;
    }
    function pn(t, c) {
      {
        var p = function() {
          Ne || (Ne = !0, g("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: p,
          configurable: !0
        });
      }
    }
    function $n(t, c) {
      {
        var p = function() {
          Oe || (Oe = !0, g("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", c));
        };
        p.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: p,
          configurable: !0
        });
      }
    }
    var _n = function(t, c, p, y, w, T, S) {
      var x = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: t,
        key: c,
        ref: p,
        props: S,
        // Record the component responsible for creating this element.
        _owner: T
      };
      return x._store = {}, Object.defineProperty(x._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(x, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(x, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: w
      }), Object.freeze && (Object.freeze(x.props), Object.freeze(x)), x;
    };
    function Fn(t, c, p, y, w) {
      {
        var T, S = {}, x = null, X = null;
        p !== void 0 && (U(p), x = "" + p), kn(c) && (U(c.key), x = "" + c.key), rn(c) && (X = c.ref, an(c));
        for (T in c)
          le.call(c, T) && !ye.hasOwnProperty(T) && (S[T] = c[T]);
        if (t && t.defaultProps) {
          var A = t.defaultProps;
          for (T in A)
            S[T] === void 0 && (S[T] = A[T]);
        }
        if (x || X) {
          var M = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          x && pn(S, M), X && $n(S, M);
        }
        return _n(t, x, X, w, y, G.current, S);
      }
    }
    var Ze = _.ReactCurrentOwner, yn = _.ReactDebugCurrentFrame;
    function Le(t) {
      if (t) {
        var c = t._owner, p = oe(t.type, t._source, c ? c.type : null);
        yn.setExtraStackFrame(p);
      } else
        yn.setExtraStackFrame(null);
    }
    var cn;
    cn = !1;
    function dn(t) {
      return typeof t == "object" && t !== null && t.$$typeof === n;
    }
    function Nn() {
      {
        if (Ze.current) {
          var t = P(Ze.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function Bn(t) {
      return "";
    }
    var Sn = {};
    function Dn(t) {
      {
        var c = Nn();
        if (!c) {
          var p = typeof t == "string" ? t : t.displayName || t.name;
          p && (c = `

Check the top-level render call using <` + p + ">.");
        }
        return c;
      }
    }
    function gn(t, c) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var p = Dn(c);
        if (Sn[p])
          return;
        Sn[p] = !0;
        var y = "";
        t && t._owner && t._owner !== Ze.current && (y = " It was passed a child from " + P(t._owner.type) + "."), Le(t), g('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', p, y), Le(null);
      }
    }
    function xn(t, c) {
      {
        if (typeof t != "object")
          return;
        if (E(t))
          for (var p = 0; p < t.length; p++) {
            var y = t[p];
            dn(y) && gn(y, c);
          }
        else if (dn(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var w = j(t);
          if (typeof w == "function" && w !== t.entries)
            for (var T = w.call(t), S; !(S = T.next()).done; )
              dn(S.value) && gn(S.value, c);
        }
      }
    }
    function An(t) {
      {
        var c = t.type;
        if (c == null || typeof c == "string")
          return;
        var p;
        if (typeof c == "function")
          p = c.propTypes;
        else if (typeof c == "object" && (c.$$typeof === d || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        c.$$typeof === f))
          p = c.propTypes;
        else
          return;
        if (p) {
          var y = P(c);
          vn(p, t.props, "prop", y, t);
        } else if (c.PropTypes !== void 0 && !cn) {
          cn = !0;
          var w = P(c);
          g("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", w || "Unknown");
        }
        typeof c.getDefaultProps == "function" && !c.getDefaultProps.isReactClassApproved && g("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ln(t) {
      {
        for (var c = Object.keys(t.props), p = 0; p < c.length; p++) {
          var y = c[p];
          if (y !== "children" && y !== "key") {
            Le(t), g("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Le(null);
            break;
          }
        }
        t.ref !== null && (Le(t), g("Invalid attribute `ref` supplied to `React.Fragment`."), Le(null));
      }
    }
    var wn = {};
    function jn(t, c, p, y, w, T) {
      {
        var S = te(t);
        if (!S) {
          var x = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (x += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = Bn();
          X ? x += X : x += Nn();
          var A;
          t === null ? A = "null" : E(t) ? A = "array" : t !== void 0 && t.$$typeof === n ? (A = "<" + (P(t.type) || "Unknown") + " />", x = " Did you accidentally export a JSX literal instead of a component?") : A = typeof t, g("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", A, x);
        }
        var M = Fn(t, c, p, w, T);
        if (M == null)
          return M;
        if (S) {
          var de = c.children;
          if (de !== void 0)
            if (y)
              if (E(de)) {
                for (var ze = 0; ze < de.length; ze++)
                  xn(de[ze], t);
                Object.freeze && Object.freeze(de);
              } else
                g("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              xn(de, t);
        }
        if (le.call(c, "key")) {
          var Te = P(t), ne = Object.keys(c).filter(function(Kn) {
            return Kn !== "key";
          }), un = ne.length > 0 ? "{key: someKey, " + ne.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!wn[Te + un]) {
            var On = ne.length > 0 ? "{" + ne.join(": ..., ") + ": ...}" : "{}";
            g(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, un, Te, On, Te), wn[Te + un] = !0;
          }
        }
        return t === i ? Ln(M) : An(M), M;
      }
    }
    function Vn(t, c, p) {
      return jn(t, c, p, !0);
    }
    function qn(t, c, p) {
      return jn(t, c, p, !1);
    }
    var zn = qn, Wn = Vn;
    Ws.Fragment = i, Ws.jsx = zn, Ws.jsxs = Wn;
  })()), Ws;
}
var fw;
function CG() {
  return fw || (fw = 1, process.env.NODE_ENV === "production" ? Uh.exports = jG() : Uh.exports = wG()), Uh.exports;
}
var Se = CG();
const FG = { kind: "Document", definitions: [{ kind: "OperationDefinition", operation: "query", name: { kind: "Name", value: "getCustomerDetails" }, variableDefinitions: [{ kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "email" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "phone" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "limit" } }, type: { kind: "NamedType", name: { kind: "Name", value: "Int" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "externalIds" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "storeId" } }, type: { kind: "NonNullType", type: { kind: "NamedType", name: { kind: "Name", value: "String" } } } }, { kind: "VariableDefinition", variable: { kind: "Variable", name: { kind: "Name", value: "expand" } }, type: { kind: "NamedType", name: { kind: "Name", value: "String" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "Yotpo" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "getCustomers" }, arguments: [{ kind: "Argument", name: { kind: "Name", value: "email" }, value: { kind: "Variable", name: { kind: "Name", value: "email" } } }, { kind: "Argument", name: { kind: "Name", value: "phone_number" }, value: { kind: "Variable", name: { kind: "Name", value: "phone" } } }, { kind: "Argument", name: { kind: "Name", value: "limit" }, value: { kind: "Variable", name: { kind: "Name", value: "limit" } } }, { kind: "Argument", name: { kind: "Name", value: "external_ids" }, value: { kind: "Variable", name: { kind: "Name", value: "externalIds" } } }, { kind: "Argument", name: { kind: "Name", value: "store_id" }, value: { kind: "Variable", name: { kind: "Name", value: "storeId" } } }, { kind: "Argument", name: { kind: "Name", value: "expand" }, value: { kind: "Variable", name: { kind: "Name", value: "expand" } } }], selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_getCustomers_response" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "InlineFragment", typeCondition: { kind: "NamedType", name: { kind: "Name", value: "Yotpo_Customers" } }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "customers" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "external_id" } }, { kind: "Field", name: { kind: "Name", value: "email" } }, { kind: "Field", name: { kind: "Name", value: "phone_number" } }, { kind: "Field", name: { kind: "Name", value: "first_name" } }, { kind: "Field", name: { kind: "Name", value: "last_name" } }, { kind: "Field", name: { kind: "Name", value: "gender" } }, { kind: "Field", name: { kind: "Name", value: "account_created_at" } }, { kind: "Field", name: { kind: "Name", value: "account_updated_at" } }, { kind: "Field", name: { kind: "Name", value: "default_language" } }, { kind: "Field", name: { kind: "Name", value: "dafault_currency" } }, { kind: "Field", name: { kind: "Name", value: "lists" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "id" } }, { kind: "Field", name: { kind: "Name", value: "since" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_ugc" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "total_reviews" } }, { kind: "Field", name: { kind: "Name", value: "avg_product_rating" } }, { kind: "Field", name: { kind: "Name", value: "avg_site_rating" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_rating" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_product" } }, { kind: "Field", name: { kind: "Name", value: "sentiment_avg_site" } }, { kind: "Field", name: { kind: "Name", value: "total_avg_sentiment" } }, { kind: "Field", name: { kind: "Name", value: "top_topics" } }, { kind: "Field", name: { kind: "Name", value: "last_star_rating" } }, { kind: "Field", name: { kind: "Name", value: "last_review_date" } }, { kind: "Field", name: { kind: "Name", value: "last_sentiment" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_loyalty" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "points_earned" } }, { kind: "Field", name: { kind: "Name", value: "points_balance" } }, { kind: "Field", name: { kind: "Name", value: "last_seen_at" } }, { kind: "Field", name: { kind: "Name", value: "total_redemptions" } }, { kind: "Field", name: { kind: "Name", value: "total_points_redeemed" } }, { kind: "Field", name: { kind: "Name", value: "vip_tier_name" } }, { kind: "Field", name: { kind: "Name", value: "successful_referrals" } }, { kind: "Field", name: { kind: "Name", value: "referrals_made_and_clicked" } }, { kind: "Field", name: { kind: "Name", value: "is_referred_by_other_customer" } }, { kind: "Field", name: { kind: "Name", value: "points_expire_date" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_amount" } }, { kind: "Field", name: { kind: "Name", value: "credit_balance_customer_currency" } }, { kind: "Field", name: { kind: "Name", value: "is_opt_in" } }, { kind: "Field", name: { kind: "Name", value: "opt_in_date" } }, { kind: "Field", name: { kind: "Name", value: "opt_out_date" } }, { kind: "Field", name: { kind: "Name", value: "has_store_account" } }, { kind: "Field", name: { kind: "Name", value: "referred_by_customer" } }, { kind: "Field", name: { kind: "Name", value: "vip_entry_date" } }, { kind: "Field", name: { kind: "Name", value: "vip_expiration_date" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_on" } }, { kind: "Field", name: { kind: "Name", value: "next_points_expire_amount" } }] } }, { kind: "Field", name: { kind: "Name", value: "yotpo_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "active_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "paused_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "failed_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "expired_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }, { kind: "Field", name: { kind: "Name", value: "canceled_subscriptions" }, selectionSet: { kind: "SelectionSet", selections: [{ kind: "Field", name: { kind: "Name", value: "externalProductId" } }, { kind: "Field", name: { kind: "Name", value: "externalVariantId" } }] } }] } }] } }] } }] } }] } }] } }] } }] }, IG = {
  "\n  query getCustomerDetails(\n    $email: String\n    $phone: String\n    $limit: Int\n    $externalIds: String\n    $storeId: String!\n    $expand: String\n  ) {\n    Yotpo {\n      getCustomers(\n        email: $email\n        phone_number: $phone\n        limit: $limit\n        external_ids: $externalIds\n        store_id: $storeId\n        expand: $expand\n      ) {\n        ... on Yotpo_getCustomers_response {\n          ... on Yotpo_Customers {\n            customers {\n              external_id\n              email\n              phone_number\n              first_name\n              last_name\n              gender\n              account_created_at\n              account_updated_at\n              default_language\n              dafault_currency\n              lists {\n                id\n                since\n              }\n              yotpo_ugc {\n                total_reviews\n                avg_product_rating\n                avg_site_rating\n                total_avg_rating\n                sentiment_avg_product\n                sentiment_avg_site\n                total_avg_sentiment\n                top_topics\n                last_star_rating\n                last_review_date\n                last_sentiment\n              }\n              yotpo_loyalty {\n                points_earned\n                points_balance\n                last_seen_at\n                total_redemptions\n                total_points_redeemed\n                vip_tier_name\n                successful_referrals\n                referrals_made_and_clicked\n                is_referred_by_other_customer\n                points_expire_date\n                credit_balance_amount\n                credit_balance_customer_currency\n                is_opt_in\n                opt_in_date\n                opt_out_date\n                has_store_account\n                referred_by_customer\n                vip_entry_date\n                vip_expiration_date\n                next_points_expire_on\n                next_points_expire_amount\n              }\n              yotpo_subscriptions {\n                active_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                paused_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                failed_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                expired_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n                canceled_subscriptions {\n                  externalProductId\n                  externalVariantId\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n": FG
};
function EG(e) {
  return IG[e] ?? {};
}
const $G = EG(
  /* GraphQL */
  `
  query getCustomerDetails(
    $email: String
    $phone: String
    $limit: Int
    $externalIds: String
    $storeId: String!
    $expand: String
  ) {
    Yotpo {
      getCustomers(
        email: $email
        phone_number: $phone
        limit: $limit
        external_ids: $externalIds
        store_id: $storeId
        expand: $expand
      ) {
        ... on Yotpo_getCustomers_response {
          ... on Yotpo_Customers {
            customers {
              external_id
              email
              phone_number
              first_name
              last_name
              gender
              account_created_at
              account_updated_at
              default_language
              dafault_currency
              lists {
                id
                since
              }
              yotpo_ugc {
                total_reviews
                avg_product_rating
                avg_site_rating
                total_avg_rating
                sentiment_avg_product
                sentiment_avg_site
                total_avg_sentiment
                top_topics
                last_star_rating
                last_review_date
                last_sentiment
              }
              yotpo_loyalty {
                points_earned
                points_balance
                last_seen_at
                total_redemptions
                total_points_redeemed
                vip_tier_name
                successful_referrals
                referrals_made_and_clicked
                is_referred_by_other_customer
                points_expire_date
                credit_balance_amount
                credit_balance_customer_currency
                is_opt_in
                opt_in_date
                opt_out_date
                has_store_account
                referred_by_customer
                vip_entry_date
                vip_expiration_date
                next_points_expire_on
                next_points_expire_amount
              }
              yotpo_subscriptions {
                active_subscriptions {
                  externalProductId
                  externalVariantId
                }
                paused_subscriptions {
                  externalProductId
                  externalVariantId
                }
                failed_subscriptions {
                  externalProductId
                  externalVariantId
                }
                expired_subscriptions {
                  externalProductId
                  externalVariantId
                }
                canceled_subscriptions {
                  externalProductId
                  externalVariantId
                }
              }
            }
          }
        }
      }
    }
  }
`
), TG = "_copyIcon_1pfts_54", OG = "_list_1pfts_59", RG = "_listItem_1pfts_69", DG = "_listItemHighlighted_1pfts_78", ja = {
  copyIcon: TG,
  list: OG,
  listItem: RG,
  listItemHighlighted: DG
}, PG = "_wrapper_1xucg_1", AG = "_externalLink_1xucg_7", Mh = {
  wrapper: PG,
  externalLink: AG
}, LG = ({
  customerDetails: e
}) => {
  const { isCopied: n, copy: r } = Jt(), { isCopied: i, copy: a } = Jt();
  if (!e)
    return null;
  const {
    first_name: o,
    last_name: s,
    email: l,
    phone_number: d,
    account_created_at: m
  } = e, u = 14, f = `${o || ""} ${s || ""}`.trim() || "A customer has no name";
  return /* @__PURE__ */ Se.jsx(b, { gap: "300", flexDirection: "column", children: /* @__PURE__ */ Se.jsxs(b, { className: Mh.wrapper, gap: "200", flexDirection: "column", children: [
    /* @__PURE__ */ Se.jsx(
      b,
      {
        justifyContent: "space-between",
        className: Mh.block,
        alignItems: "center",
        children: /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-2", children: f })
      }
    ),
    m && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", margin: "0 0 200", children: [
      /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: "Member since" }),
      /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: Gn(m).format(jt) })
    ] }),
    l && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(ve, { size: u, name: "mail" }),
        /* @__PURE__ */ Se.jsx("span", { className: Mh.externalLink, children: l })
      ] }),
      /* @__PURE__ */ Se.jsx(Xe, { content: "Copy email", children: /* @__PURE__ */ Se.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Se.jsx(
        ve,
        {
          size: u,
          name: n ? "done" : "copy",
          onClick: () => r(l),
          className: ja.copyIcon
        }
      ) }) })
    ] }),
    d && /* @__PURE__ */ Se.jsxs(b, { gap: "200", justifyContent: "space-between", children: [
      /* @__PURE__ */ Se.jsxs(b, { gap: "200", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx(ve, { size: u, name: "phone" }),
        /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: d })
      ] }),
      /* @__PURE__ */ Se.jsx(Xe, { content: "Copy phone number", children: /* @__PURE__ */ Se.jsx(b, { alignItems: "center", children: /* @__PURE__ */ Se.jsx(
        ve,
        {
          size: u,
          name: i ? "done" : "copy",
          onClick: () => a(d),
          className: ja.copyIcon
        }
      ) }) })
    ] })
  ] }) });
}, Zn = ({
  description: e,
  content: n,
  tooltip: r,
  isHighlighted: i = !1
}) => {
  if (n == null)
    return null;
  const a = _w(n);
  return /* @__PURE__ */ Se.jsx(
    Ye.Text,
    {
      variant: "dense",
      className: dt(ja.listItem, {
        [ja.listItemHighlighted]: i
      }),
      children: /* @__PURE__ */ Se.jsx(Xe, { content: r, children: /* @__PURE__ */ Se.jsxs(b, { justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", children: e }),
        a ? n : Mi(n)
      ] }) })
    }
  );
}, VG = ({
  loyalty: e
}) => /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-3", children: "Loyalty" }),
  !e && /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No loyalty data available" }) }),
  e && /* @__PURE__ */ Se.jsxs(Ye, { className: ja.list, children: [
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Successful referrals",
        tooltip: "The total number of successful referrals made by the customer.",
        content: e.successful_referrals
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Referrals made and clicked",
        tooltip: "The total number of referrals made by the customer and clicked on by others.",
        content: e.referrals_made_and_clicked
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Points earned",
        tooltip: "The total number of loyalty points earned by the customer.",
        content: e.points_earned
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Points balance",
        tooltip: "The current balance of loyalty points for the customer.",
        content: e.points_balance
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Last seen",
        tooltip: "The timestamp when the customer was last seen or engaged with the loyalty program.",
        content: e.last_seen_at
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Total redemptions",
        tooltip: "The total number of times the customer has redeemed loyalty points.",
        content: e.total_redemptions
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Total points redeemed",
        tooltip: "The total number of loyalty points redeemed by the customer.",
        content: e.total_points_redeemed
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "VIP tier",
        tooltip: "The name of the customer's current VIP tier status.",
        content: e.vip_tier_name
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Referred by other customer",
        tooltip: "Indicates whether the customer was referred by another customer.",
        content: e.is_referred_by_other_customer
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Points expiry date",
        tooltip: "The timestamp when the customer's loyalty points are set to expire.",
        content: e.next_points_expire_on || e.points_expire_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Points expiry amount",
        tooltip: "The number of points that are about to expire",
        content: e.next_points_expire_amount
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Credit balance amount",
        tooltip: "The amount of store credit available to the customer in the default currency of the store.",
        content: e.credit_balance_amount
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Credit balance customer currency",
        tooltip: "The store credit amount in the customer's preferred currency.",
        content: e.credit_balance_customer_currency
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Opt in",
        tooltip: "Indicates whether the customer has opted into the loyalty program.",
        content: e.is_opt_in
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Opt in date",
        tooltip: "The timestamp for when the customer opted into the loyalty program.",
        content: e.opt_in_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Opt out date",
        tooltip: "The timestamp for when the customer opted out of the loyalty program.",
        content: e.opt_out_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Has store account",
        tooltip: "Indicates whether the customer has a store account.",
        content: e.has_store_account
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Referred by customer",
        tooltip: "The email address of the customer who referred this customer to the loyalty program.",
        content: e.referred_by_customer
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "VIP entry date",
        tooltip: "The timestamp for when the customer entered the VIP tier.",
        content: e.vip_entry_date
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "VIP expiration date",
        tooltip: "The timestamp for when the customer's VIP tier membership is set to expire.",
        content: e.vip_expiration_date
      }
    )
  ] })
] }), zG = 0.8, UG = 0.4, hw = (e) => {
  if (e != null)
    return e >= zG ? /* @__PURE__ */ Se.jsx(Mn, { variant: "success", size: "small", children: "Positive" }) : e <= UG ? /* @__PURE__ */ Se.jsx(Mn, { variant: "error", size: "small", children: "Negative" }) : /* @__PURE__ */ Se.jsx(Mn, { variant: "warning", size: "small", children: "Neutral" });
}, MG = ({
  userGeneratedContent: e
}) => /* @__PURE__ */ Se.jsxs(b, { gap: "200", flexDirection: "column", children: [
  /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-3", children: "User generated content" }),
  !e && /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No user generated content available" }) }),
  e && /* @__PURE__ */ Se.jsxs(Ye, { className: ja.list, children: [
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total reviews",
        tooltip: "The total number of reviews submitted by the customer.",
        content: e.total_reviews
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average rating",
        tooltip: "The total average rating given by the customer (combining products and site/store ratings).",
        content: e.total_avg_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        isHighlighted: !0,
        description: "Total average sentiment score",
        tooltip: "The total average sentiment score given by the customer (combining products and site/store scores).",
        content: hw(e.total_avg_sentiment)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Average product rating",
        tooltip: "The average product rating given by the customer.",
        content: e.avg_product_rating
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Average site rating",
        tooltip: "The average rating of the site/store given by the customer.",
        content: e.avg_site_rating?.toFixed(2)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Last sentiment",
        tooltip: "The sentiment score of the customer's last review.",
        content: hw(e.last_sentiment)
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Last star rating",
        tooltip: "The star rating of the customer's last review.",
        content: e.last_star_rating
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Last review date",
        tooltip: "The timestamp for when the customer last submitted a review.",
        content: Gn(e.last_review_date).format(
          jt
        )
      }
    ),
    /* @__PURE__ */ Se.jsx(
      Zn,
      {
        description: "Topics",
        tooltip: "An list of top topics (themes) mentioned in all of the customer's reviews.",
        content: /* @__PURE__ */ Se.jsx(
          b,
          {
            gap: "100",
            width: "80%",
            flexWrap: "wrap",
            justifyContent: "flex-end",
            children: e.top_topics?.map((n, r) => /* @__PURE__ */ Se.jsx(Mn, { variant: "info", size: "small", children: /* @__PURE__ */ Se.jsx(Se.Fragment, { children: n }) }, r))
          }
        )
      }
    )
  ] })
] }), BG = ({
  conversationContext: e,
  settings: n
}) => {
  const { useQuery: r } = hn(), { track: i } = Cn(), [a, o] = me(), [s, l] = me(!1), d = e?.customer?.email, m = e?.customer?.phone_number, u = !d && !m, f = n?.yotpoStoreId, h = n?.showCustomerDetails ?? !1, k = n?.showUserGeneratedContent ?? !1, C = n?.displayLoyalty ?? !1, N = n?.displaySubscriptions ?? !1, j = !f, _ = !h && !k && !C && !N, {
    loading: g,
    error: D,
    data: O
  } = r($G, {
    skip: u || j,
    variables: {
      ...d && { email: d },
      ...!d && m && { phone: m },
      storeId: f,
      expand: "all"
    }
  });
  if (Qe(() => {
    const I = O?.Yotpo?.getCustomers?.customers?.[0];
    I ? (o(I), l(!1), i("yotpo:customer:received")) : l(!0);
  }, [O?.Yotpo, g]), j)
    return /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Se.jsx(
      En,
      {
        error: new Fw({
          graphQLErrors: [
            {
              message: "Integration needs to be re-/authorized in the settings."
            }
          ]
        }),
        hideCopyButton: !0
      }
    ) });
  if (u)
    return /* @__PURE__ */ Se.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-contact-message",
        children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No email nor phone number are available in this conversation to look up a profile." })
      }
    );
  if (_)
    return /* @__PURE__ */ Se.jsx(
      b,
      {
        justifyContent: "center",
        margin: "200 0 300 0",
        "data-testid": "widget-no-features",
        children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "All features toggles in the widget settings are disabled." })
      }
    );
  if (g)
    return /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "300", children: /* @__PURE__ */ Se.jsx(fn, {}) });
  if (s)
    return /* @__PURE__ */ Se.jsx(b, { justifyContent: "center", margin: "200 0 300 0", children: /* @__PURE__ */ Se.jsx($.Paragraph, { variant: "4", color: "secondary", children: "No customer profile found." }) });
  if (D) {
    const I = D.graphQLErrors;
    return zl({ errors: I }) ? /* @__PURE__ */ Se.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-forbidden-error",
        children: "The API token used for the integration does not have the necessary access rights. Please contact your administrator."
      }
    ) : Ul({ errors: I }) ? /* @__PURE__ */ Se.jsx(
      $.Paragraph,
      {
        margin: "200 0 300 0",
        color: "secondary",
        variant: "4",
        "data-testid": "widget-downstream-api-authorization-error",
        children: "The integration could not authorize against Yotpo. Please contact your administrator."
      }
    ) : /* @__PURE__ */ Se.jsx(En, { error: D });
  }
  return /* @__PURE__ */ Se.jsxs(
    b,
    {
      gap: "300",
      flexDirection: "column",
      margin: "200 0 300 0",
      "data-testid": "widget-wrapper",
      children: [
        h && /* @__PURE__ */ Se.jsx(LG, { customerDetails: a }),
        k && /* @__PURE__ */ Se.jsx(
          MG,
          {
            userGeneratedContent: a?.yotpo_ugc
          }
        ),
        C && /* @__PURE__ */ Se.jsx(VG, { loyalty: a?.yotpo_loyalty })
      ]
    }
  );
}, qG = "_settingsWrapper_1ycvy_1", HG = "_settingsWrapperHeader_1ycvy_6", WG = "_settingsWrapperContent_1ycvy_10", KG = "_settingsWrapperContentCode_1ycvy_18", GG = "_settingsWrapperContentCURL_1ycvy_26", No = {
  settingsWrapper: qG,
  settingsWrapperHeader: HG,
  settingsWrapperContent: WG,
  settingsWrapperContentCode: KG,
  settingsWrapperContentCURL: GG
}, KF = ({
  handleChangeText: e
}) => {
  const [n, r] = me(!1), { isCopied: i, copy: a } = Jt(), { control: o } = ut({
    defaultValues: {
      storeId: "",
      secret: ""
    },
    mode: "onChange"
  }), s = yi({
    control: o
  }), l = s.storeId !== "" && s.secret !== "", d = _t(() => {
    const m = s.storeId, u = s.secret;
    return `curl --request POST \\
  --url https://api.yotpo.com/core/v3/stores/${m || "store_id"}/access_tokens \\
  --header 'Content-Type: application/json' \\
  --header 'accept: application/json'${u ? ` \\
  --data '{"secret":"${u}"}'` : ""}`;
  }, [s.storeId, s.secret]);
  return /* @__PURE__ */ Se.jsx(Se.Fragment, { children: /* @__PURE__ */ Se.jsx(Z, { span: 6, children: /* @__PURE__ */ Se.jsxs(b, { flexDirection: "column", className: No.settingsWrapper, children: [
    /* @__PURE__ */ Se.jsxs(
      b,
      {
        gap: "200",
        alignItems: "center",
        className: No.settingsWrapperHeader,
        onClick: () => r(!n),
        children: [
          /* @__PURE__ */ Se.jsx($.Heading, { variant: "heading-3", children: "How to get the Yotpo access token" }),
          /* @__PURE__ */ Se.jsx(ve, { name: n ? "angle-down" : "angle-right" })
        ]
      }
    ),
    n && /* @__PURE__ */ Se.jsxs(
      b,
      {
        flexDirection: "column",
        className: No.settingsWrapperContent,
        children: [
          /* @__PURE__ */ Se.jsx(b, { margin: "0 0 400", children: /* @__PURE__ */ Se.jsx(
            Cy,
            {
              variant: "announcement",
              headline: "In order to get the Yotpo access token, you have to follow the steps below",
              description: /* @__PURE__ */ Se.jsxs("ol", { children: [
                /* @__PURE__ */ Se.jsx("li", { children: "Insert the Yotpo store ID and secret below in the input fields" }),
                /* @__PURE__ */ Se.jsx("li", { children: "Once the fields are filled in, the CURL command will appear below and you can copy and run it in your terminal" }),
                /* @__PURE__ */ Se.jsxs("li", { children: [
                  "The response should look like this",
                  " ",
                  /* @__PURE__ */ Se.jsx("span", { className: No.settingsWrapperContentCode, children: '{ "access_token": "this-is-your-token" }' })
                ] }),
                /* @__PURE__ */ Se.jsxs("li", { children: [
                  "Copy the token without quotes and paste it in the",
                  " ",
                  /* @__PURE__ */ Se.jsx("i", { children: "Yotpo access token" }),
                  " input field below"
                ] }),
                /* @__PURE__ */ Se.jsx("li", { children: "Click the save button" })
              ] })
            }
          ) }),
          /* @__PURE__ */ Se.jsx(
            bt,
            {
              name: "storeId",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Se.jsx(
                Wr,
                {
                  label: "Yotpo store ID",
                  placeholder: "Please insert the store ID",
                  input: {
                    ...m,
                    onChange: (u) => {
                      m.onChange(u), e({
                        target: {
                          name: "yotpoStoreId",
                          value: u?.target.value ?? ""
                        }
                      });
                    }
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ Se.jsx(
            bt,
            {
              name: "secret",
              control: o,
              render: ({ field: m }) => /* @__PURE__ */ Se.jsx(
                Wr,
                {
                  label: "Yotpo secret",
                  placeholder: "Please insert the secret",
                  input: m
                }
              )
            }
          ),
          l && /* @__PURE__ */ Se.jsxs(Se.Fragment, { children: [
            /* @__PURE__ */ Se.jsx(We, { label: "Generated CURL command", noAlert: !0, children: /* @__PURE__ */ Se.jsx(
              b,
              {
                as: "pre",
                gap: "200",
                margin: "100 0 250",
                className: No.settingsWrapperContentCURL,
                children: d()
              }
            ) }),
            /* @__PURE__ */ Se.jsx(b, { alignContent: "start", children: /* @__PURE__ */ Se.jsx(
              Xe,
              {
                content: i ? "Copied!" : "Copy CURL command",
                children: /* @__PURE__ */ Se.jsx(
                  ct,
                  {
                    variant: "secondary",
                    icon: i ? "check-circle" : "copy",
                    onClick: () => a(d()),
                    children: "Copy CURL"
                  }
                )
              }
            ) })
          ] })
        ]
      }
    )
  ] }) }) });
}, Wo = [
  // The store id is populated by the OAuth flow, not edited in the form. It is
  // kept here so the runtime widget render can resolve it and so it round-trips
  // on update.
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    type: "string",
    secret: !1,
    defaultValue: ""
  },
  // Secret, only written when editing a legacy token-authenticated widget.
  // Excluded from the read path; omitted from the update payload unless the
  // user re-enters it (preserving the stored value).
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    type: "string",
    secret: !0,
    defaultValue: ""
  },
  {
    key: "showCustomerDetails",
    label: "Show customer details",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "showUserGeneratedContent",
    label: "Show user generated content",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  },
  {
    key: "displayLoyalty",
    label: "Show loyalty data",
    type: "boolean",
    secret: !1,
    defaultValue: !0
  }
], YG = [
  /**
   * The store ID will be fetched through the OAuth flow, so there's no real
   * reason to show it
   */
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: "",
    readOnly: !0,
    required: !1,
    secret: !1,
    type: "hidden",
    hideOnCreate: !0
  },
  {
    key: "authorizeWithOauth",
    label: "Authorize with OAuth",
    secret: !1,
    type: "custom",
    hideOnCreate: !0,
    component: gi
  }
], JG = [
  {
    key: "accessTokenComponent",
    label: "Retrieve Yotpo access token",
    secret: !1,
    type: "custom",
    component: KF
  },
  {
    key: "yotpoStoreId",
    label: "Yotpo store ID",
    placeholder: 'See "How to get the Yotpo access token" above.',
    readOnly: !0,
    required: !0,
    secret: !1,
    type: "input"
  },
  {
    key: "yotpoAccessToken",
    label: "Yotpo access token",
    placeholder: "Insert the Yotpo access token",
    required: !0,
    secret: !0,
    type: "input"
  }
], jo = rr(Wo), Bh = "YOTPO", QG = {
  enabled: !1,
  name: "",
  ...Ml(
    [],
    Wo
  )
}, XG = ({
  integrationId: e,
  configuration: n,
  handleRedirect: r,
  showNotification: i,
  automationCouplingState: a,
  renderConditionsEditor: o
}) => {
  const s = !e, l = ut({
    mode: "onChange",
    defaultValues: QG
  }), {
    create: d,
    update: m,
    remove: u,
    isLoading: f,
    error: h,
    misconfigurationCause: k,
    setMisconfigurationCause: C
  } = ur({
    integrationId: e,
    integrationType: Bh,
    handleRedirect: r,
    showNotification: i
  }), {
    isLoading: N,
    error: j,
    isWidgetUnknown: _,
    refetch: g,
    widgetConfiguration: D
  } = mr({
    integrationId: e,
    fieldDefinitions: Wo,
    form: l,
    onMisconfigured: C
  }), { renderConditions: O, setRenderConditions: I, renderConditionsForSubmit: F } = pr({
    integrationId: e,
    widgetConfiguration: D,
    renderConditionsEditor: o
  }), L = s || !!D?.additionalProperties?.isUsingOAuth, K = (te) => hr(te, {
    fieldDefinitions: Wo,
    isCreationMode: s,
    create: d,
    update: m,
    renderConditions: F
  }), J = l.watch("name");
  return /* @__PURE__ */ Se.jsxs(
    fr,
    {
      form: l,
      integrationId: e,
      onValidSubmit: K,
      error: j ?? h,
      onRetry: j ? g : void 0,
      isLoading: f || N,
      isWidgetUnknown: _,
      children: [
        k && /* @__PURE__ */ Se.jsx(yr, { cause: k }),
        /* @__PURE__ */ Se.jsxs(nt, { children: [
          /* @__PURE__ */ Se.jsx(Z, { children: /* @__PURE__ */ Se.jsx(We, { label: "Show the widget in the conversation sidebar", children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "enabled",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(
            Pn,
            {
              name: "name",
              label: "Widget name",
              control: l.control,
              rules: { required: "Name is required" },
              componentProps: {
                placeholder: "Insert the name of the widget",
                autoComplete: "off"
              }
            }
          ) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          !L && /* @__PURE__ */ Se.jsxs(Se.Fragment, { children: [
            /* @__PURE__ */ Se.jsx(
              KF,
              {
                handleChangeText: (te) => l.setValue("yotpoStoreId", te?.target.value ?? "")
              }
            ),
            /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(
              Pn,
              {
                name: "yotpoStoreId",
                label: jo.yotpoStoreId,
                control: l.control,
                rules: { required: "Yotpo store ID is required" },
                componentProps: {
                  placeholder: 'See "How to get the Yotpo access token" above.',
                  readOnly: !0,
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
            /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(
              Er,
              {
                name: "yotpoAccessToken",
                label: jo.yotpoAccessToken,
                control: l.control,
                isCreationMode: s,
                rules: { required: "Yotpo access token is required" },
                componentProps: {
                  placeholder: "Insert the Yotpo access token",
                  autoComplete: "off"
                }
              }
            ) }),
            /* @__PURE__ */ Se.jsx(Z, { span: 3 })
          ] }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(We, { label: jo.showCustomerDetails, children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "showCustomerDetails",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(We, { label: jo.showUserGeneratedContent, children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "showUserGeneratedContent",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3, children: /* @__PURE__ */ Se.jsx(We, { label: jo.displayLoyalty, children: /* @__PURE__ */ Se.jsx(
            bn,
            {
              name: "displayLoyalty",
              control: l.control
            }
          ) }) }),
          /* @__PURE__ */ Se.jsx(Z, { span: 3 }),
          L && !s && e && /* @__PURE__ */ Se.jsx(
            gi,
            {
              configuration: n,
              integrationId: e,
              integrationType: Bh,
              label: "Authorize with OAuth"
            }
          ),
          o && O !== null && /* @__PURE__ */ Se.jsx(Z, { children: o({
            value: O,
            onChange: I,
            configurationKey: D?.id
          }) })
        ] }),
        /* @__PURE__ */ Se.jsx(
          gr,
          {
            integrationType: Bh,
            integrationId: e,
            widgetName: J,
            isCreationMode: s,
            isSubmitting: l.formState.isSubmitting,
            automationCouplingState: a,
            onConfirmDelete: () => u()
          }
        )
      ]
    }
  );
}, ZG = ({
  hasShopifyOAuth: e = !1,
  isShopifyMarketplaceApp: n = !1,
  isCreationMode: r = !1
}) => r ? {
  authSettings: jW,
  featureSettings: []
} : n ? {
  authSettings: wW,
  featureSettings: [...IF]
} : e ? {
  authSettings: [
    ...zj,
    ...SW
  ],
  featureSettings: [...Uj]
} : {
  authSettings: [
    ...zj,
    ...NW
  ],
  featureSettings: [...Uj]
}, GF = (e, n) => ({
  hasOAuth: r = !1,
  isCreationMode: i = !1
}) => r || i ? e : n, e8 = GF(
  YG,
  JG
), n8 = GF(
  hV,
  yV
), YF = (e = {
  SHOPIFY: {},
  YOTPO: {},
  KLAVIYO: {}
}) => {
  const { SHOPIFY: n, YOTPO: r, KLAVIYO: i } = e, {
    authSettings: a,
    featureSettings: o
  } = ZG(n), s = e8(r), l = n8(i);
  return {
    SHOPIFY: {
      widget: H7,
      icon: "shopify",
      iconColors: {
        contentColor: "rgb(148, 190, 69)",
        backgroundColor: "rgba(148, 190, 69, 0.1)"
      },
      fieldDefinitions: Ho,
      WidgetSettings: bW,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [
        ...a,
        ...o
      ]
    },
    JIRA: {
      widget: M2,
      icon: "jira",
      iconColors: {
        contentColor: "rgb(38, 132, 255)",
        backgroundColor: "rgba(38, 132, 255, 0.075)"
      },
      fieldDefinitions: xl,
      WidgetSettings: H2
    },
    GITHUB: {
      widget: qP,
      icon: "github",
      iconColors: {
        contentColor: "rgb(87, 96, 106)",
        backgroundColor: "rgba(221, 244, 255, 0.75)"
      },
      fieldDefinitions: kl,
      WidgetSettings: WP
    },
    MIUROS: {
      widget: EB,
      icon: "miuros",
      iconColors: {
        contentColor: "rgb(246, 135, 179)",
        backgroundColor: "rgba(246, 135, 179, 0.15)"
      },
      fieldDefinitions: El,
      WidgetSettings: TB
    },
    KLAVIYO: {
      widget: fV,
      icon: "klaviyo",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Sa,
      WidgetSettings: NV,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...l]
    },
    LINEAR: {
      widget: Y4,
      icon: "linear",
      iconColors: {
        contentColor: "rgb(94, 106, 210)",
        backgroundColor: "rgba(94, 106, 210, 0.15)"
      },
      fieldDefinitions: Fl,
      WidgetSettings: Q4
    },
    VOYADO: {
      widget: xG,
      icon: "voyado",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Ll,
      WidgetSettings: NG
    },
    LOYALTYLION: {
      widget: F5,
      icon: "loyaltylion",
      iconColors: {
        contentColor: "rgb(36, 31, 79)",
        backgroundColor: "rgba(36, 31, 79, 0.075)"
      },
      fieldDefinitions: Il,
      WidgetSettings: E5
    },
    RECHARGE: {
      widget: rq,
      icon: "recharge",
      iconColors: {
        contentColor: "rgb(57, 1, 241)",
        backgroundColor: "rgba(57, 1, 241, 0.075)"
      },
      fieldDefinitions: $l,
      WidgetSettings: aq
    },
    BRAZE: {
      widget: gD,
      icon: "braze",
      iconColors: {
        contentColor: "rgb(48, 2, 102)",
        backgroundColor: "rgba(48, 2, 102, 0.075)"
      },
      fieldDefinitions: Mo,
      WidgetSettings: kD
    },
    YOTPO: {
      widget: BG,
      icon: "yotpo",
      iconColors: {
        contentColor: "rgb(0, 66, 228)",
        backgroundColor: "rgba(0, 66, 228, 0.075)"
      },
      fieldDefinitions: Wo,
      WidgetSettings: XG,
      // Kept for backwards compatibility with the older declarative
      // configuration types. The active settings UI is `WidgetSettings`.
      settingsConfiguration: [...s]
    },
    INGRID: {
      widget: kA,
      icon: "ingrid",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: bl,
      WidgetSettings: _A
    },
    RIVOLOYALTY: {
      widget: Bq,
      icon: "rivoloyalty",
      iconColors: {
        contentColor: "rgb(0, 0, 0)",
        backgroundColor: "rgba(0, 0, 0, 0.075)"
      },
      fieldDefinitions: Pl,
      WidgetSettings: lW
    }
  };
}, t8 = (e, n) => {
  const r = n.find(
    (i) => i.key === e.key
  )?.value;
  return e.type === "boolean" ? gI(r, e.defaultValue) : vI(r, e.defaultValue);
}, r8 = (e, n) => e.map((r) => ({
  key: r.key,
  value: t8(r, n)
})), i8 = ({ fieldDefinitions: e }, n) => r8(
  (e ?? []).filter(({ secret: r }) => !r),
  n
), a8 = (e) => {
  const n = YF();
  return e.map(
    ({
      id: r,
      type: i,
      name: a,
      settings: o,
      misconfigured: s,
      renderConditions: l,
      integrationKey: d
    }) => {
      const u = n[i];
      return {
        id: r,
        type: i,
        name: a,
        settings: i8(u, o),
        misconfigured: s,
        renderConditions: l,
        icon: u.icon,
        iconColors: u.iconColors,
        widget: u.widget,
        integrationKey: d
      };
    }
  );
}, o8 = ({
  widget: e,
  index: n,
  configuration: r,
  conversationContext: i,
  showNotification: a,
  onToggleFn: o,
  isOpenFn: s,
  isMinimized: l,
  isUnmatched: d,
  renderVisibilityToggleElement: m,
  renderDragElement: u,
  renderConditionMatchedIndicator: f
}) => {
  const { track: h } = Cn(), k = FT(), C = $r(null), {
    id: N,
    name: j,
    type: _,
    widget: g,
    settings: D,
    misconfigured: O,
    renderConditions: I,
    icon: F,
    iconColors: L,
    integrationKey: K
  } = Xn(
    () => a8([e])[0],
    [e]
  ), J = `partner-integration-${_}`, te = /* @__PURE__ */ Qn.jsx(Fy, { icon: F, color: L }), W = D?.reduce(
    (Y, P) => (Y[P.key] = P.value, Y),
    {}
  );
  return l ? /* @__PURE__ */ Qn.jsx("div", { className: "icon-holder", children: te }, `partner-icon-${N}`) : /* @__PURE__ */ Qn.jsxs(
    _r,
    {
      onToggle: () => {
        h(
          s(K) ? "widget:collapse:closed" : "widget:collapse:opened",
          { widgetId: N, widgetType: _.toLowerCase() }
        ), o(K);
      },
      isOpen: s(K),
      className: J,
      containerRef: C,
      children: [
        /* @__PURE__ */ Qn.jsx(
          _r.Header,
          {
            className: dt({ [$T.unmatchedHeader]: d }),
            wrap: "normal",
            avatar: te,
            slotBeforeTitle: u?.(K, n, C),
            slotAfterTitle: /* @__PURE__ */ Qn.jsx(Qn.Fragment, { children: m?.(K) }),
            children: /* @__PURE__ */ Qn.jsxs(b, { alignItems: "center", flexDirection: "row", gap: "200", children: [
              j,
              f?.(I ?? [], N)
            ] })
          }
        ),
        /* @__PURE__ */ Qn.jsx(_r.Content, { children: O ? /* @__PURE__ */ Qn.jsx(En, { isMisconfigured: !0 }) : /* @__PURE__ */ Qn.jsx(
          jw.Provider,
          {
            value: {
              onError: (Y, P) => console.warn(
                `Something went wrong with a partner widget of type '${_}' and id '${N}'`,
                Y,
                P
              )
            },
            children: /* @__PURE__ */ Qn.jsx(
              sC,
              {
                integrationId: N,
                type: _,
                configuration: r,
                showNotification: a,
                showModal: k,
                children: xI(g, {
                  conversationContext: i,
                  settings: W
                })
              }
            )
          }
        ) })
      ]
    },
    K
  );
}, V8 = ({
  widgets: e,
  configuration: n,
  conversationContext: r,
  showNotification: i,
  onToggleFn: a,
  isOpenFn: o,
  isMinimized: s,
  renderVisibilityToggleElement: l,
  renderDragElement: d,
  renderConditionMatchedIndicator: m,
  widgetAnnotations: u
}) => /* @__PURE__ */ Qn.jsx(IT, { children: e.map((f, h) => /* @__PURE__ */ Qn.jsx(
  o8,
  {
    widget: f,
    index: h,
    configuration: n,
    conversationContext: r,
    showNotification: i,
    onToggleFn: a,
    isOpenFn: o,
    isMinimized: s,
    isUnmatched: u?.get(f.id) === !1,
    renderVisibilityToggleElement: l,
    renderDragElement: d,
    renderConditionMatchedIndicator: m
  },
  f.integrationKey
)) }), z8 = ({
  configuration: e,
  integrationId: n,
  type: r,
  handleRedirect: i,
  showNotification: a,
  automationCouplingState: o,
  renderConditionsEditor: s
}) => {
  const l = YF()[r]?.WidgetSettings;
  return /* @__PURE__ */ Qn.jsx(
    jw.Provider,
    {
      value: {
        onError: (d, m) => console.warn(
          `Something went wrong with the partner widget settings of type ${r} and id ${n}`,
          d,
          m
        )
      },
      children: /* @__PURE__ */ Qn.jsx(
        sC,
        {
          integrationId: n,
          type: r,
          configuration: e,
          showNotification: a,
          children: /* @__PURE__ */ Qn.jsx(Qn.Fragment, { children: l && /* @__PURE__ */ Qn.jsx(
            l,
            {
              configuration: e,
              integrationId: n,
              handleRedirect: i,
              showNotification: a,
              automationCouplingState: o,
              renderConditionsEditor: s
            }
          ) })
        }
      )
    }
  );
}, yw = "__PairingContext__", JF = globalThis[yw] ?? (() => {
  const e = wy({});
  return globalThis[yw] = e, e;
})(), U8 = () => Bl(JF), M8 = ({
  value: e,
  children: n
}) => /* @__PURE__ */ Qn.jsx(JF.Provider, { value: e, children: n }), s8 = Wl`
  query getWidgetConfigurations {
    Management {
      widgetConfigurations {
        id
        type
        enabled
        name
        misconfigured
        renderConditions
        settings {
          key
          value
        }
      }
    }
  }
`;
function B8(e, { skip: n = !1 } = {}) {
  const [r, i] = me([]), [a, o] = me(!1);
  return Qe(() => {
    if (n) {
      o(!1);
      return;
    }
    let s = !1;
    return o(!0), oC(e).query({
      query: s8
    }).then(({ data: l }) => {
      s || (i(
        (l?.Management?.widgetConfigurations ?? []).filter(
          (d) => d != null
        ).map((d) => ({
          ...d,
          integrationKey: `partner-integration-${d.id}`
        }))
      ), o(!1));
    }).catch(() => {
      s || o(!1);
    }), () => {
      s = !0;
    };
  }, [e, n]), {
    isLoading: a,
    widgets: r
  };
}
var Ks = { exports: {} }, gw;
function l8() {
  if (gw) return Ks.exports;
  gw = 1;
  var e = typeof Reflect == "object" ? Reflect : null, n = e && typeof e.apply == "function" ? e.apply : function(I, F, L) {
    return Function.prototype.apply.call(I, F, L);
  }, r;
  e && typeof e.ownKeys == "function" ? r = e.ownKeys : Object.getOwnPropertySymbols ? r = function(I) {
    return Object.getOwnPropertyNames(I).concat(Object.getOwnPropertySymbols(I));
  } : r = function(I) {
    return Object.getOwnPropertyNames(I);
  };
  function i(O) {
    console && console.warn && console.warn(O);
  }
  var a = Number.isNaN || function(I) {
    return I !== I;
  };
  function o() {
    o.init.call(this);
  }
  Ks.exports = o, Ks.exports.once = _, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var s = 10;
  function l(O) {
    if (typeof O != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof O);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return s;
    },
    set: function(O) {
      if (typeof O != "number" || O < 0 || a(O))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + O + ".");
      s = O;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(I) {
    if (typeof I != "number" || I < 0 || a(I))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + I + ".");
    return this._maxListeners = I, this;
  };
  function d(O) {
    return O._maxListeners === void 0 ? o.defaultMaxListeners : O._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return d(this);
  }, o.prototype.emit = function(I) {
    for (var F = [], L = 1; L < arguments.length; L++) F.push(arguments[L]);
    var K = I === "error", J = this._events;
    if (J !== void 0)
      K = K && J.error === void 0;
    else if (!K)
      return !1;
    if (K) {
      var te;
      if (F.length > 0 && (te = F[0]), te instanceof Error)
        throw te;
      var W = new Error("Unhandled error." + (te ? " (" + te.message + ")" : ""));
      throw W.context = te, W;
    }
    var Y = J[I];
    if (Y === void 0)
      return !1;
    if (typeof Y == "function")
      n(Y, this, F);
    else
      for (var P = Y.length, B = C(Y, P), L = 0; L < P; ++L)
        n(B[L], this, F);
    return !0;
  };
  function m(O, I, F, L) {
    var K, J, te;
    if (l(F), J = O._events, J === void 0 ? (J = O._events = /* @__PURE__ */ Object.create(null), O._eventsCount = 0) : (J.newListener !== void 0 && (O.emit(
      "newListener",
      I,
      F.listener ? F.listener : F
    ), J = O._events), te = J[I]), te === void 0)
      te = J[I] = F, ++O._eventsCount;
    else if (typeof te == "function" ? te = J[I] = L ? [F, te] : [te, F] : L ? te.unshift(F) : te.push(F), K = d(O), K > 0 && te.length > K && !te.warned) {
      te.warned = !0;
      var W = new Error("Possible EventEmitter memory leak detected. " + te.length + " " + String(I) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      W.name = "MaxListenersExceededWarning", W.emitter = O, W.type = I, W.count = te.length, i(W);
    }
    return O;
  }
  o.prototype.addListener = function(I, F) {
    return m(this, I, F, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(I, F) {
    return m(this, I, F, !0);
  };
  function u() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function f(O, I, F) {
    var L = { fired: !1, wrapFn: void 0, target: O, type: I, listener: F }, K = u.bind(L);
    return K.listener = F, L.wrapFn = K, K;
  }
  o.prototype.once = function(I, F) {
    return l(F), this.on(I, f(this, I, F)), this;
  }, o.prototype.prependOnceListener = function(I, F) {
    return l(F), this.prependListener(I, f(this, I, F)), this;
  }, o.prototype.removeListener = function(I, F) {
    var L, K, J, te, W;
    if (l(F), K = this._events, K === void 0)
      return this;
    if (L = K[I], L === void 0)
      return this;
    if (L === F || L.listener === F)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete K[I], K.removeListener && this.emit("removeListener", I, L.listener || F));
    else if (typeof L != "function") {
      for (J = -1, te = L.length - 1; te >= 0; te--)
        if (L[te] === F || L[te].listener === F) {
          W = L[te].listener, J = te;
          break;
        }
      if (J < 0)
        return this;
      J === 0 ? L.shift() : N(L, J), L.length === 1 && (K[I] = L[0]), K.removeListener !== void 0 && this.emit("removeListener", I, W || F);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(I) {
    var F, L, K;
    if (L = this._events, L === void 0)
      return this;
    if (L.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : L[I] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete L[I]), this;
    if (arguments.length === 0) {
      var J = Object.keys(L), te;
      for (K = 0; K < J.length; ++K)
        te = J[K], te !== "removeListener" && this.removeAllListeners(te);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (F = L[I], typeof F == "function")
      this.removeListener(I, F);
    else if (F !== void 0)
      for (K = F.length - 1; K >= 0; K--)
        this.removeListener(I, F[K]);
    return this;
  };
  function h(O, I, F) {
    var L = O._events;
    if (L === void 0)
      return [];
    var K = L[I];
    return K === void 0 ? [] : typeof K == "function" ? F ? [K.listener || K] : [K] : F ? j(K) : C(K, K.length);
  }
  o.prototype.listeners = function(I) {
    return h(this, I, !0);
  }, o.prototype.rawListeners = function(I) {
    return h(this, I, !1);
  }, o.listenerCount = function(O, I) {
    return typeof O.listenerCount == "function" ? O.listenerCount(I) : k.call(O, I);
  }, o.prototype.listenerCount = k;
  function k(O) {
    var I = this._events;
    if (I !== void 0) {
      var F = I[O];
      if (typeof F == "function")
        return 1;
      if (F !== void 0)
        return F.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function C(O, I) {
    for (var F = new Array(I), L = 0; L < I; ++L)
      F[L] = O[L];
    return F;
  }
  function N(O, I) {
    for (; I + 1 < O.length; I++)
      O[I] = O[I + 1];
    O.pop();
  }
  function j(O) {
    for (var I = new Array(O.length), F = 0; F < I.length; ++F)
      I[F] = O[F].listener || O[F];
    return I;
  }
  function _(O, I) {
    return new Promise(function(F, L) {
      function K(te) {
        O.removeListener(I, J), L(te);
      }
      function J() {
        typeof O.removeListener == "function" && O.removeListener("error", K), F([].slice.call(arguments));
      }
      D(O, I, J, { once: !0 }), I !== "error" && g(O, K, { once: !0 });
    });
  }
  function g(O, I, F) {
    typeof O.on == "function" && D(O, "error", I, F);
  }
  function D(O, I, F, L) {
    if (typeof O.on == "function")
      L.once ? O.once(I, F) : O.on(I, F);
    else if (typeof O.addEventListener == "function")
      O.addEventListener(I, function K(J) {
        L.once && O.removeEventListener(I, K), F(J);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof O);
  }
  return Ks.exports;
}
var c8 = l8();
function q8() {
  const e = new c8.EventEmitter();
  return e && typeof window < "u" ? window._partner = {
    events: e
  } : console.warn(
    "Initialization of partner-integration events was not successfull."
  ), e;
}
export {
  NT as GraphQLClientProvider,
  JF as PairingContext,
  M8 as PairingProvider,
  o8 as PartnerIntegrationCard,
  IT as PartnerIntegrationModalProvider,
  V8 as PartnerIntegrations,
  z8 as PartnerIntegrationsSettings,
  YF as getWidgetDefinitions,
  q8 as initializePartnerEventEmitter,
  U8 as usePairing,
  FT as usePartnerIntegrationModal,
  B8 as usePartnerIntegrationWidgetConfigurations
};
